var configuratorRenderer = new cds.configurator.DefaultRenderer("configuratorContainer");
var configurator = new cds.configurator.AttributeManager(configuratorRenderer);
configuratorRenderer.manager = configurator;
var nestingManager = new cds.configurator.NestingManager(configurator);
var componentManager = new cds.configurator.ComponentManager(configurator);
 
var aUnit = configurator.addAttribute(new cds.configurator.SetAttribute("aUnit", "Unit", true, true,1));
var aToothStyle = configurator.addAttribute(new cds.configurator.SetAttribute("aToothStyle", "Tooth Style (Pitch)", true, true,3));
var aTeethA = configurator.addAttribute(new cds.configurator.SetAttribute("aTeethA", "Number of Teeth - Large Pulley (A)", true, true,5));
var aTeethB = configurator.addAttribute(new cds.configurator.SetAttribute("aTeethB", "Number of Teeth - Small Pulley (B)", true, true,5));
var aBeltWidthEnglish = configurator.addAttribute(new cds.configurator.SetAttribute("aBeltWidthEnglish", "Belt Width (in)", true, true,3));
var aBeltWidthMetric = configurator.addAttribute(new cds.configurator.SetAttribute("aBeltWidthMetric", "Belt Width (mm)", true, true,3));

aUnit.addValue(new cds.configurator.SetAttributeValue("ue", "English"));
aUnit.addValue(new cds.configurator.SetAttributeValue("um", "Metric"));
aToothStyle.addValue(new cds.configurator.SetAttributeValue("semxl", "MXL"));
aToothStyle.addValue(new cds.configurator.SetAttributeValue("sexll", "XL"));
aToothStyle.addValue(new cds.configurator.SetAttributeValue("selll", "L"));
aToothStyle.addValue(new cds.configurator.SetAttributeValue("sehhh", "H"));
aToothStyle.addValue(new cds.configurator.SetAttributeValue("smh03", "HTD 3mm"));
aToothStyle.addValue(new cds.configurator.SetAttributeValue("smh05", "HTD 5mm"));
aToothStyle.addValue(new cds.configurator.SetAttributeValue("smh08", "HTD 8mm"));
aToothStyle.addValue(new cds.configurator.SetAttributeValue("smt25", "T2.5mm"));
aToothStyle.addValue(new cds.configurator.SetAttributeValue("smt05", "T5mm"));
aToothStyle.addValue(new cds.configurator.SetAttributeValue("smt10", "T10mm"));
aToothStyle.addValue(new cds.configurator.SetAttributeValue("sma05", "AT5mm"));
aToothStyle.addValue(new cds.configurator.SetAttributeValue("sma10", "AT10mm"));
aBeltWidthEnglish.addValue(new cds.configurator.SetAttributeValue("be0118", "0.118"));
aBeltWidthEnglish.addValue(new cds.configurator.SetAttributeValue("be0125", "0.125"));
aBeltWidthEnglish.addValue(new cds.configurator.SetAttributeValue("be0236", "0.236"));
aBeltWidthEnglish.addValue(new cds.configurator.SetAttributeValue("be0250", "0.25"));
aBeltWidthEnglish.addValue(new cds.configurator.SetAttributeValue("be0354", "0.354"));
aBeltWidthEnglish.addValue(new cds.configurator.SetAttributeValue("be0375", "0.375"));
aBeltWidthEnglish.addValue(new cds.configurator.SetAttributeValue("be0394", "0.394"));
aBeltWidthEnglish.addValue(new cds.configurator.SetAttributeValue("be0472", "0.472"));
aBeltWidthEnglish.addValue(new cds.configurator.SetAttributeValue("be0500", "0.5"));
aBeltWidthEnglish.addValue(new cds.configurator.SetAttributeValue("be0590", "0.59"));
aBeltWidthEnglish.addValue(new cds.configurator.SetAttributeValue("be0630", "0.63"));
aBeltWidthEnglish.addValue(new cds.configurator.SetAttributeValue("be0750", "0.75"));
aBeltWidthEnglish.addValue(new cds.configurator.SetAttributeValue("be0787", "0.787"));
aBeltWidthEnglish.addValue(new cds.configurator.SetAttributeValue("be0827", "0.827"));
aBeltWidthEnglish.addValue(new cds.configurator.SetAttributeValue("be0984", "0.984"));
aBeltWidthEnglish.addValue(new cds.configurator.SetAttributeValue("be1000", "1"));
aBeltWidthEnglish.addValue(new cds.configurator.SetAttributeValue("be1181", "1.181"));
aBeltWidthEnglish.addValue(new cds.configurator.SetAttributeValue("be1260", "1.26"));
aBeltWidthEnglish.addValue(new cds.configurator.SetAttributeValue("be1417", "1.417"));
aBeltWidthEnglish.addValue(new cds.configurator.SetAttributeValue("be1457", "1.457"));
aBeltWidthEnglish.addValue(new cds.configurator.SetAttributeValue("be1500", "1.5"));
aBeltWidthEnglish.addValue(new cds.configurator.SetAttributeValue("be1575", "1.575"));
aBeltWidthEnglish.addValue(new cds.configurator.SetAttributeValue("be1969", "1.969"));
aBeltWidthEnglish.addValue(new cds.configurator.SetAttributeValue("be2000", "2"));
aBeltWidthEnglish.addValue(new cds.configurator.SetAttributeValue("be2165", "2.165"));
aBeltWidthEnglish.addValue(new cds.configurator.SetAttributeValue("be2441", "2.441"));
aBeltWidthEnglish.addValue(new cds.configurator.SetAttributeValue("be2677", "2.677"));
aBeltWidthEnglish.addValue(new cds.configurator.SetAttributeValue("be3000", "3"));
aBeltWidthEnglish.addValue(new cds.configurator.SetAttributeValue("be3346", "3.346"));
aBeltWidthEnglish.addValue(new cds.configurator.SetAttributeValue("be3543", "3.543"));
aBeltWidthEnglish.addValue(new cds.configurator.SetAttributeValue("be4528", "4.528"));
aBeltWidthEnglish.addValue(new cds.configurator.SetAttributeValue("be4921", "4.921"));
aBeltWidthEnglish.addValue(new cds.configurator.SetAttributeValue("be6693", "6.693"));
aBeltWidthMetric.addValue(new cds.configurator.SetAttributeValue("bm03000", "3"));
aBeltWidthMetric.addValue(new cds.configurator.SetAttributeValue("bm03175", "3.2"));
aBeltWidthMetric.addValue(new cds.configurator.SetAttributeValue("bm06000", "6"));
aBeltWidthMetric.addValue(new cds.configurator.SetAttributeValue("bm06350", "6.4"));
aBeltWidthMetric.addValue(new cds.configurator.SetAttributeValue("bm09000", "9"));
aBeltWidthMetric.addValue(new cds.configurator.SetAttributeValue("bm09525", "9.5"));
aBeltWidthMetric.addValue(new cds.configurator.SetAttributeValue("bm10000", "10"));
aBeltWidthMetric.addValue(new cds.configurator.SetAttributeValue("bm115000", "115"));
aBeltWidthMetric.addValue(new cds.configurator.SetAttributeValue("bm12000", "12"));
aBeltWidthMetric.addValue(new cds.configurator.SetAttributeValue("bm125000", "125"));
aBeltWidthMetric.addValue(new cds.configurator.SetAttributeValue("bm12700", "12.7"));
aBeltWidthMetric.addValue(new cds.configurator.SetAttributeValue("bm15000", "15"));
aBeltWidthMetric.addValue(new cds.configurator.SetAttributeValue("bm16000", "16"));
aBeltWidthMetric.addValue(new cds.configurator.SetAttributeValue("bm170000", "170"));
aBeltWidthMetric.addValue(new cds.configurator.SetAttributeValue("bm19050", "19.1"));
aBeltWidthMetric.addValue(new cds.configurator.SetAttributeValue("bm20000", "20"));
aBeltWidthMetric.addValue(new cds.configurator.SetAttributeValue("bm21000", "21"));
aBeltWidthMetric.addValue(new cds.configurator.SetAttributeValue("bm25000", "25"));
aBeltWidthMetric.addValue(new cds.configurator.SetAttributeValue("bm25400", "25.4"));
aBeltWidthMetric.addValue(new cds.configurator.SetAttributeValue("bm30000", "30"));
aBeltWidthMetric.addValue(new cds.configurator.SetAttributeValue("bm32000", "32"));
aBeltWidthMetric.addValue(new cds.configurator.SetAttributeValue("bm36000", "36"));
aBeltWidthMetric.addValue(new cds.configurator.SetAttributeValue("bm37000", "37"));
aBeltWidthMetric.addValue(new cds.configurator.SetAttributeValue("bm38100", "38.1"));
aBeltWidthMetric.addValue(new cds.configurator.SetAttributeValue("bm40000", "40"));
aBeltWidthMetric.addValue(new cds.configurator.SetAttributeValue("bm50000", "50"));
aBeltWidthMetric.addValue(new cds.configurator.SetAttributeValue("bm50800", "50.8"));
aBeltWidthMetric.addValue(new cds.configurator.SetAttributeValue("bm55000", "55"));
aBeltWidthMetric.addValue(new cds.configurator.SetAttributeValue("bm62000", "62"));
aBeltWidthMetric.addValue(new cds.configurator.SetAttributeValue("bm68000", "68"));
aBeltWidthMetric.addValue(new cds.configurator.SetAttributeValue("bm76200", "76.2"));
aBeltWidthMetric.addValue(new cds.configurator.SetAttributeValue("bm85000", "85"));
aBeltWidthMetric.addValue(new cds.configurator.SetAttributeValue("bm90000", "90"));
aTeethA.addValue(new cds.configurator.SetAttributeValue("tea010", "10"));
aTeethA.addValue(new cds.configurator.SetAttributeValue("tea011", "11"));
aTeethA.addValue(new cds.configurator.SetAttributeValue("tea012", "12"));
aTeethA.addValue(new cds.configurator.SetAttributeValue("tea013", "13"));
aTeethA.addValue(new cds.configurator.SetAttributeValue("tea014", "14"));
aTeethA.addValue(new cds.configurator.SetAttributeValue("tea015", "15"));
aTeethA.addValue(new cds.configurator.SetAttributeValue("tea016", "16"));
aTeethA.addValue(new cds.configurator.SetAttributeValue("tea017", "17"));
aTeethA.addValue(new cds.configurator.SetAttributeValue("tea018", "18"));
aTeethA.addValue(new cds.configurator.SetAttributeValue("tea019", "19"));
aTeethA.addValue(new cds.configurator.SetAttributeValue("tea020", "20"));
aTeethA.addValue(new cds.configurator.SetAttributeValue("tea021", "21"));
aTeethA.addValue(new cds.configurator.SetAttributeValue("tea022", "22"));
aTeethA.addValue(new cds.configurator.SetAttributeValue("tea023", "23"));
aTeethA.addValue(new cds.configurator.SetAttributeValue("tea024", "24"));
aTeethA.addValue(new cds.configurator.SetAttributeValue("tea025", "25"));
aTeethA.addValue(new cds.configurator.SetAttributeValue("tea026", "26"));
aTeethA.addValue(new cds.configurator.SetAttributeValue("tea027", "27"));
aTeethA.addValue(new cds.configurator.SetAttributeValue("tea028", "28"));
aTeethA.addValue(new cds.configurator.SetAttributeValue("tea029", "29"));
aTeethA.addValue(new cds.configurator.SetAttributeValue("tea030", "30"));
aTeethA.addValue(new cds.configurator.SetAttributeValue("tea031", "31"));
aTeethA.addValue(new cds.configurator.SetAttributeValue("tea032", "32"));
aTeethA.addValue(new cds.configurator.SetAttributeValue("tea033", "33"));
aTeethA.addValue(new cds.configurator.SetAttributeValue("tea034", "34"));
aTeethA.addValue(new cds.configurator.SetAttributeValue("tea035", "35"));
aTeethA.addValue(new cds.configurator.SetAttributeValue("tea036", "36"));
aTeethA.addValue(new cds.configurator.SetAttributeValue("tea037", "37"));
aTeethA.addValue(new cds.configurator.SetAttributeValue("tea038", "38"));
aTeethA.addValue(new cds.configurator.SetAttributeValue("tea039", "39"));
aTeethA.addValue(new cds.configurator.SetAttributeValue("tea040", "40"));
aTeethA.addValue(new cds.configurator.SetAttributeValue("tea041", "41"));
aTeethA.addValue(new cds.configurator.SetAttributeValue("tea042", "42"));
aTeethA.addValue(new cds.configurator.SetAttributeValue("tea043", "43"));
aTeethA.addValue(new cds.configurator.SetAttributeValue("tea044", "44"));
aTeethA.addValue(new cds.configurator.SetAttributeValue("tea045", "45"));
aTeethA.addValue(new cds.configurator.SetAttributeValue("tea046", "46"));
aTeethA.addValue(new cds.configurator.SetAttributeValue("tea048", "48"));
aTeethA.addValue(new cds.configurator.SetAttributeValue("tea050", "50"));
aTeethA.addValue(new cds.configurator.SetAttributeValue("tea052", "52"));
aTeethA.addValue(new cds.configurator.SetAttributeValue("tea053", "53"));
aTeethA.addValue(new cds.configurator.SetAttributeValue("tea056", "56"));
aTeethA.addValue(new cds.configurator.SetAttributeValue("tea060", "60"));
aTeethA.addValue(new cds.configurator.SetAttributeValue("tea062", "62"));
aTeethA.addValue(new cds.configurator.SetAttributeValue("tea063", "63"));
aTeethA.addValue(new cds.configurator.SetAttributeValue("tea064", "64"));
aTeethA.addValue(new cds.configurator.SetAttributeValue("tea067", "67"));
aTeethA.addValue(new cds.configurator.SetAttributeValue("tea068", "68"));
aTeethA.addValue(new cds.configurator.SetAttributeValue("tea070", "70"));
aTeethA.addValue(new cds.configurator.SetAttributeValue("tea071", "71"));
aTeethA.addValue(new cds.configurator.SetAttributeValue("tea072", "72"));
aTeethA.addValue(new cds.configurator.SetAttributeValue("tea074", "74"));
aTeethA.addValue(new cds.configurator.SetAttributeValue("tea075", "75"));
aTeethA.addValue(new cds.configurator.SetAttributeValue("tea080", "80"));
aTeethA.addValue(new cds.configurator.SetAttributeValue("tea084", "84"));
aTeethA.addValue(new cds.configurator.SetAttributeValue("tea090", "90"));
aTeethA.addValue(new cds.configurator.SetAttributeValue("tea096", "96"));
aTeethA.addValue(new cds.configurator.SetAttributeValue("tea100", "100"));
aTeethA.addValue(new cds.configurator.SetAttributeValue("tea112", "112"));
aTeethA.addValue(new cds.configurator.SetAttributeValue("tea120", "120"));
aTeethA.addValue(new cds.configurator.SetAttributeValue("tea126", "126"));
aTeethA.addValue(new cds.configurator.SetAttributeValue("tea140", "140"));
aTeethA.addValue(new cds.configurator.SetAttributeValue("tea144", "144"));
aTeethA.addValue(new cds.configurator.SetAttributeValue("tea154", "154"));
aTeethA.addValue(new cds.configurator.SetAttributeValue("tea168", "168"));
aTeethA.addValue(new cds.configurator.SetAttributeValue("tea180", "180"));
aTeethA.addValue(new cds.configurator.SetAttributeValue("tea192", "192"));
aTeethA.addValue(new cds.configurator.SetAttributeValue("tea200", "200"));
aTeethA.addValue(new cds.configurator.SetAttributeValue("tea216", "216"));
aTeethA.addValue(new cds.configurator.SetAttributeValue("tea224", "224"));
aTeethB.addValue(new cds.configurator.SetAttributeValue("teb010", "10"));
aTeethB.addValue(new cds.configurator.SetAttributeValue("teb011", "11"));
aTeethB.addValue(new cds.configurator.SetAttributeValue("teb012", "12"));
aTeethB.addValue(new cds.configurator.SetAttributeValue("teb013", "13"));
aTeethB.addValue(new cds.configurator.SetAttributeValue("teb014", "14"));
aTeethB.addValue(new cds.configurator.SetAttributeValue("teb015", "15"));
aTeethB.addValue(new cds.configurator.SetAttributeValue("teb016", "16"));
aTeethB.addValue(new cds.configurator.SetAttributeValue("teb017", "17"));
aTeethB.addValue(new cds.configurator.SetAttributeValue("teb018", "18"));
aTeethB.addValue(new cds.configurator.SetAttributeValue("teb019", "19"));
aTeethB.addValue(new cds.configurator.SetAttributeValue("teb020", "20"));
aTeethB.addValue(new cds.configurator.SetAttributeValue("teb021", "21"));
aTeethB.addValue(new cds.configurator.SetAttributeValue("teb022", "22"));
aTeethB.addValue(new cds.configurator.SetAttributeValue("teb023", "23"));
aTeethB.addValue(new cds.configurator.SetAttributeValue("teb024", "24"));
aTeethB.addValue(new cds.configurator.SetAttributeValue("teb025", "25"));
aTeethB.addValue(new cds.configurator.SetAttributeValue("teb026", "26"));
aTeethB.addValue(new cds.configurator.SetAttributeValue("teb027", "27"));
aTeethB.addValue(new cds.configurator.SetAttributeValue("teb028", "28"));
aTeethB.addValue(new cds.configurator.SetAttributeValue("teb029", "29"));
aTeethB.addValue(new cds.configurator.SetAttributeValue("teb030", "30"));
aTeethB.addValue(new cds.configurator.SetAttributeValue("teb031", "31"));
aTeethB.addValue(new cds.configurator.SetAttributeValue("teb032", "32"));
aTeethB.addValue(new cds.configurator.SetAttributeValue("teb033", "33"));
aTeethB.addValue(new cds.configurator.SetAttributeValue("teb034", "34"));
aTeethB.addValue(new cds.configurator.SetAttributeValue("teb035", "35"));
aTeethB.addValue(new cds.configurator.SetAttributeValue("teb036", "36"));
aTeethB.addValue(new cds.configurator.SetAttributeValue("teb037", "37"));
aTeethB.addValue(new cds.configurator.SetAttributeValue("teb038", "38"));
aTeethB.addValue(new cds.configurator.SetAttributeValue("teb039", "39"));
aTeethB.addValue(new cds.configurator.SetAttributeValue("teb040", "40"));
aTeethB.addValue(new cds.configurator.SetAttributeValue("teb041", "41"));
aTeethB.addValue(new cds.configurator.SetAttributeValue("teb042", "42"));
aTeethB.addValue(new cds.configurator.SetAttributeValue("teb043", "43"));
aTeethB.addValue(new cds.configurator.SetAttributeValue("teb044", "44"));
aTeethB.addValue(new cds.configurator.SetAttributeValue("teb045", "45"));
aTeethB.addValue(new cds.configurator.SetAttributeValue("teb046", "46"));
aTeethB.addValue(new cds.configurator.SetAttributeValue("teb048", "48"));
aTeethB.addValue(new cds.configurator.SetAttributeValue("teb050", "50"));
aTeethB.addValue(new cds.configurator.SetAttributeValue("teb052", "52"));
aTeethB.addValue(new cds.configurator.SetAttributeValue("teb053", "53"));
aTeethB.addValue(new cds.configurator.SetAttributeValue("teb056", "56"));
aTeethB.addValue(new cds.configurator.SetAttributeValue("teb060", "60"));
aTeethB.addValue(new cds.configurator.SetAttributeValue("teb062", "62"));
aTeethB.addValue(new cds.configurator.SetAttributeValue("teb063", "63"));
aTeethB.addValue(new cds.configurator.SetAttributeValue("teb064", "64"));
aTeethB.addValue(new cds.configurator.SetAttributeValue("teb067", "67"));
aTeethB.addValue(new cds.configurator.SetAttributeValue("teb068", "68"));
aTeethB.addValue(new cds.configurator.SetAttributeValue("teb070", "70"));
aTeethB.addValue(new cds.configurator.SetAttributeValue("teb071", "71"));
aTeethB.addValue(new cds.configurator.SetAttributeValue("teb072", "72"));
aTeethB.addValue(new cds.configurator.SetAttributeValue("teb074", "74"));
aTeethB.addValue(new cds.configurator.SetAttributeValue("teb075", "75"));
aTeethB.addValue(new cds.configurator.SetAttributeValue("teb080", "80"));
aTeethB.addValue(new cds.configurator.SetAttributeValue("teb084", "84"));
aTeethB.addValue(new cds.configurator.SetAttributeValue("teb090", "90"));
aTeethB.addValue(new cds.configurator.SetAttributeValue("teb096", "96"));
aTeethB.addValue(new cds.configurator.SetAttributeValue("teb100", "100"));
aTeethB.addValue(new cds.configurator.SetAttributeValue("teb112", "112"));
aTeethB.addValue(new cds.configurator.SetAttributeValue("teb120", "120"));
aTeethB.addValue(new cds.configurator.SetAttributeValue("teb126", "126"));
aTeethB.addValue(new cds.configurator.SetAttributeValue("teb140", "140"));
aTeethB.addValue(new cds.configurator.SetAttributeValue("teb144", "144"));
aTeethB.addValue(new cds.configurator.SetAttributeValue("teb154", "154"));
aTeethB.addValue(new cds.configurator.SetAttributeValue("teb168", "168"));
aTeethB.addValue(new cds.configurator.SetAttributeValue("teb180", "180"));
aTeethB.addValue(new cds.configurator.SetAttributeValue("teb192", "192"));
aTeethB.addValue(new cds.configurator.SetAttributeValue("teb200", "200"));
aTeethB.addValue(new cds.configurator.SetAttributeValue("teb216", "216"));
aTeethB.addValue(new cds.configurator.SetAttributeValue("teb224", "224"));


// nesting rules
nestingManager.addRule("aBeltWidthEnglish","aBeltWidthEnglish","aUnit=ue");
nestingManager.addRule("aBeltWidthMetric","aBeltWidthMetric","aUnit=um");

// mapping to catalog tooth styles
var catalogToothStyles = {
    "MXL":"MXL",
    "XL":"XL",
    "L":"L",
    "H":"H",
    "HTD 3mm":"HTD 3mm",
    "HTD 5mm":"HTD 5mm",
    "HTD 8mm":"HTD 8mm",
    "T2.5mm":"T2.5mm",
    "T5mm":"T5mm",
    "T10mm":"T10mm",
    "AT5mm":"AT5mm",
    "AT10mm":"AT10mm"
};

// pitch lengths
var pitchList = {
    "sehhh":0.5,
    "smh03":3/25.4,
    "smh05":5/25.4,
    "smh08":8/25.4,
    "selll":3/8,
    "semxl":0.08,
    "sexll":1/5,
    "sma10":10/25.4,
    "sma05":5/25.4,
    "smt10":10/25.4,
    "smt25":2.5/25.4,
    "smt05":5/25.4,
};

var availablePitchLengths = {
    "semxlbe0125":[2.4,2.64,2.8,2.88,3.12,3.2,3.28,3.36,3.52,3.6,3.68,3.76,3.84,3.92,4,4.08,4.16,4.24,4.32,4.4,4.48,4.56,4.64,4.72,4.8,4.88,4.96,5.04,5.12,5.2,5.36,5.44,5.52,5.6,5.68,5.76,5.84,5.92,6,6.08,6.16,6.24,6.32,6.4,6.48,6.56,6.64,6.72,6.8,6.88,6.96,7.04,7.12,7.2,7.28,7.36,7.44,7.52,7.6,7.76,7.84,7.92,8,8.08,8.16,8.24,8.32,8.4,8.48,8.56,8.64,8.72,8.8,8.96,9.04,9.12,9.2,9.36,9.44,9.52,9.6,9.76,9.84,9.92,10,10.08,10.16,10.24,10.32,10.4,10.48,10.56,10.72,10.8,10.88,10.96,11.04,11.12,11.2,11.36,11.52,11.6,11.68,11.76,11.84,11.92,12,12.08,12.24,12.32,12.4,12.48,12.64,12.72,12.8,12.96,13.04,13.12,13.2,13.28,13.36,13.52,13.6,13.68,14,14.16,14.4,14.72,14.8,14.88,15.04,15.2,15.36,15.52,15.6,15.68,16,16.08,16.16,16.32,16.4,16.48,16.64,16.8,16.96,17.2,17.28,17.6,17.68,17.76,17.92,18,18.08,18.24,18.32,18.4,18.56,18.64,18.72,18.8,18.88,19.12,19.2,19.44,19.6,19.84,19.92,20,20.08,20.24,20.4,20.48,20.8,20.96,21.2,21.36,21.44,21.6,21.68,21.84,22,22.24,22.4,22.8,23.04,23.2,23.6,23.76,23.84,24,24.4,24.64,24.8,24.96,25.2,25.44,25.6,25.84,25.92,26.08,26.24,26.4,26.56,26.72,26.8,26.88,26.96,27.12,27.2,27.36,27.44,27.76,28,28.32,28.4,28.48,28.56,28.64,28.72,28.8,29.12,29.2,29.6,29.68,29.76,30.4,31.04,31.2,31.76,32,32.16,32.24,32.4,32.64,32.8,32.96,33.04,33.2,33.52,33.6,33.68,33.92,34,34.16,34.24,34.48,34.72,34.8,34.88,35.2,35.36,35.76,35.84,36.24,36.32,36.64,37.04,37.12,37.28,37.76,37.84,38,38.4,38.48,38.56,38.96,39.04,39.2,39.44,39.84,40,40.4,41.2,41.28,41.76,41.92,42,42.56,42.8,43.2,43.44,43.68,43.84,44,45.68,46.32,47.28,47.36,47.92,48,48.96,51.84,53.2,55.52],
    "sma05be0236":[8.858,10.039,11.024,11.811,13.386,14.764,15.354,16.535,17.717,17.913,19.685,21.457,23.622,24.016,25.984,27.953,28.346,29.528,30.709,32.48,33.858,38.386,41.339,44.291,59.055],
    "smh03be0236":[3.425,4.016,4.134,4.252,4.37,4.606,4.724,4.843,4.96,5.079,5.197,5.551,5.669,5.787,5.906,6.024,6.142,6.26,6.496,6.614,6.732,6.85,6.969,7.087,7.205,7.323,7.44,7.559,7.677,7.795,7.913,8.031,8.15,8.268,8.386,8.504,8.622,8.74,8.858,8.976,9.213,9.331,9.449,9.685,9.803,9.92,10.039,10.157,10.276,10.394,10.512,10.63,10.866,10.984,11.102,11.22,11.339,11.457,11.575,11.693,11.811,11.929,12.047,12.165,12.283,12.4,12.52,12.756,12.874,12.992,13.11,13.228,13.346,13.465,13.583,13.819,14.055,14.173,14.291,14.409,14.528,14.646,14.764,15,15.118,15.236,15.354,15.472,15.591,15.709,15.827,15.945,16.181,16.417,16.535,16.654,16.772,17.008,17.126,17.244,17.48,17.6,18.071,18.189,18.307,18.425,18.543,18.661,18.78,18.898,19.016,19.134,19.252,19.37,19.488,19.724,19.843,20.08,20.197,20.315,20.433,20.551,20.669,20.787,20.906,21.142,21.614,21.732,21.969,22.205,22.441,22.559,22.677,22.795,22.913,23.031,23.268,23.386,23.504,23.622,23.858,23.976,24.094,24.213,24.685,24.921,25.157,25.394,25.512,25.748,25.866,26.102,26.339,26.457,26.575,26.811,26.929,27.047,27.165,27.283,27.4,27.638,27.756,27.874,27.992,28.346,28.465,28.819,28.937,29.055,29.528,29.646,30.827,31.299,31.654,32.126,32.362,32.48,32.953,33.189,33.78,33.898,34.37,34.724,34.961,35.079,35.433,36.024,36.85,37.205,37.441,37.795,38.622,39.449,40.394,40.748,40.866,40.984,41.339,41.575,41.811,42.047,42.165,42.52,43.701,44.291,45.472,46.299,46.772,46.89,48.307,49.016,49.606,49.724,52.559,59.055,59.528,60.236,61.772,62.48,70.866,73.346,75.827,77.008,78.898],
    "smt05be0236":[6.496,7.283,7.874,8.465,8.661,8.858,9.646,9.843,10.039,10.236,10.63,10.827,11.024,11.614,11.811,12.008,12.6,12.795,12.992,13.386,13.78,13.976,14.173,14.37,14.764,15.354,15.748,16.142,16.535,16.732,16.929,17.323,17.52,17.717,17.913,18.11,18.701,18.898,19.685,20.08,20.669,21.457,21.654,22.047,22.638,23.228,23.622,24.016,24.409,24.606,24.803,25.197,25.591,25.984,26.575,27.165,27.559,28.346,28.543,29.528,30.709,31.496,32.087,33.071,33.465,33.858,35.433,37.008,38.976,39.37,42.323,43.307,43.898,44.882,47.835,51.772,53.15,54.331,56.693],
    "smt25be0236":[4.724,5.709,6.299,6.988,7.874,8.268,9.055,9.646,10.433,10.925,11.22,11.417,12.008,12.5,12.992,13.484,14.961,16.535,18.898,19.685,21.26,23.622,25.591,30.709,36.024,37.402],
    "semxlbe0250":[2.4,2.64,2.8,2.88,3.12,3.2,3.28,3.36,3.52,3.6,3.68,3.76,3.84,3.92,4,4.08,4.16,4.24,4.32,4.4,4.48,4.56,4.64,4.72,4.8,4.88,4.96,5.04,5.12,5.2,5.36,5.44,5.52,5.6,5.68,5.76,5.84,5.92,6,6.08,6.16,6.24,6.32,6.4,6.48,6.56,6.64,6.72,6.8,6.88,6.96,7.04,7.12,7.2,7.28,7.36,7.44,7.52,7.6,7.76,7.84,7.92,8,8.08,8.16,8.24,8.32,8.4,8.48,8.56,8.64,8.72,8.8,8.96,9.04,9.12,9.2,9.36,9.44,9.52,9.6,9.76,9.84,9.92,10,10.08,10.16,10.24,10.32,10.4,10.48,10.56,10.72,10.8,10.88,10.96,11.04,11.12,11.2,11.36,11.52,11.6,11.68,11.76,11.84,11.92,12,12.08,12.24,12.32,12.4,12.48,12.64,12.72,12.8,12.96,13.04,13.12,13.2,13.28,13.36,13.52,13.6,13.68,14,14.16,14.4,14.72,14.8,14.88,15.04,15.2,15.36,15.52,15.6,15.68,16,16.08,16.16,16.32,16.4,16.48,16.64,16.8,16.96,17.2,17.28,17.68,17.76,17.92,18,18.08,18.24,18.32,18.4,18.56,18.64,18.72,18.8,18.88,19.12,19.2,19.44,19.6,19.84,19.92,20,20.08,20.24,20.4,20.48,20.8,20.96,21.2,21.36,21.44,21.6,21.68,21.84,22,22.24,22.4,22.8,23.04,23.2,23.6,23.76,23.84,24,24.4,24.64,24.8,24.96,25.2,25.44,25.6,25.84,25.92,26.08,26.24,26.4,26.56,26.72,26.8,26.88,26.96,27.12,27.2,27.36,27.44,27.76,28,28.32,28.4,28.48,28.56,28.64,28.72,28.8,29.12,29.2,29.6,29.68,29.76,30.4,31.04,31.2,31.76,32,32.16,32.24,32.4,32.64,32.8,32.96,33.04,33.2,33.52,33.6,33.68,33.92,34,34.16,34.24,34.48,34.72,34.8,34.88,35.2,35.36,35.76,35.84,36.24,36.32,36.64,37.04,37.12,37.28,37.76,37.84,38,38.4,38.48,38.56,38.96,39.04,39.2,39.44,39.84,40,40.4,41.2,41.28,41.76,41.92,42,42.56,42.8,43.2,43.44,43.68,43.84,44,45.68,46.32,47.28,47.36,47.92,48,48.96,51.84,53.2,55.52],
    "sexllbe0250":[4,4.2,5,5.4,5.6,5.8,6,6.2,6.4,6.6,6.8,7,7.2,7.4,7.6,7.8,8,8.2,8.4,8.6,8.8,9,9.2,9.4,9.6,9.8,10,10.2,10.4,10.6,10.8,11,11.2,11.4,11.6,11.8,12,12.2,12.4,12.6,12.8,13,13.2,13.4,13.6,13.8,14,14.2,14.4,14.6,14.8,15,15.2,15.4,15.6,15.8,16,16.2,16.4,16.6,16.8,17,17.2,17.4,17.6,17.8,18,18.2,18.4,18.6,18.8,19,19.2,19.4,19.6,19.8,20,20.2,20.4,20.6,20.8,21,21.2,21.4,21.6,21.8,22,22.2,22.4,22.6,22.8,23,23.2,23.4,23.6,24,24.4,24.6,24.8,25,25.4,25.8,26,26.2,26.4,26.6,26.8,27,27.2,27.4,27.6,27.8,28,28.2,28.4,28.6,29,29.6,30,30.2,30.6,31,31.4,31.6,32,32.2,33,33.2,33.8,34,34.4,34.8,35,35.2,35.6,36,36.2,36.4,37,37.2,37.6,38,38.2,38.4,38.6,38.8,39,39.2,39.6,40,40.4,40.8,41.2,41.4,42,42.4,43,43.2,43.4,43.8,44.4,45,45.4,45.6,46,46.8,47,48,48.6,49,49.2,49.6,49.8,50,50.6,51,51.4,52.2,52.4,53.2,54,55.4,56,56.4,57,58,59.2,60.8,61.2,63,63.8,64.8,67,67.2,68.6,69,73.6,77,81,82.8,85,86,88.8,90,90.8,91.4,92.6,101.4,102],
    "smh03be0354":[3.425,4.016,4.134,4.252,4.37,4.606,4.724,4.843,4.96,5.079,5.197,5.551,5.669,5.787,5.906,6.024,6.142,6.26,6.496,6.614,6.732,6.85,6.969,7.087,7.205,7.323,7.44,7.559,7.677,7.795,7.913,8.031,8.15,8.268,8.386,8.504,8.622,8.74,8.858,8.976,9.213,9.331,9.449,9.685,9.803,9.92,10.039,10.157,10.276,10.394,10.512,10.63,10.866,10.984,11.102,11.22,11.339,11.457,11.575,11.693,11.811,11.929,12.047,12.165,12.283,12.4,12.52,12.756,12.874,12.992,13.11,13.228,13.346,13.465,13.583,13.819,14.055,14.173,14.291,14.409,14.528,14.646,14.764,15,15.118,15.236,15.354,15.472,15.591,15.709,15.827,15.945,16.181,16.417,16.535,16.654,16.772,17.008,17.126,17.244,17.48,17.6,18.071,18.189,18.307,18.425,18.543,18.661,18.78,18.898,19.016,19.134,19.252,19.37,19.488,19.724,19.843,20.08,20.197,20.315,20.433,20.551,20.669,20.787,20.906,21.142,21.614,21.732,21.969,22.205,22.441,22.559,22.677,22.795,22.913,23.031,23.268,23.386,23.504,23.622,23.858,23.976,24.094,24.213,24.685,24.921,25.157,25.394,25.512,25.748,25.866,26.102,26.339,26.457,26.575,26.811,26.929,27.047,27.165,27.283,27.4,27.638,27.756,27.874,27.992,28.346,28.465,28.819,28.937,29.055,29.528,29.646,30.827,31.299,31.654,32.126,32.362,32.48,32.953,33.189,33.78,33.898,34.37,34.724,34.961,35.079,35.433,36.024,36.85,37.205,37.441,37.795,38.622,39.449,40.394,40.748,40.866,40.984,41.339,41.575,41.811,42.047,42.165,42.52,43.701,44.291,45.472,46.299,46.772,46.89,48.307,49.016,49.606,49.724,52.559,59.055,59.528,60.236,61.772,62.48,70.866,73.346,75.827,77.008,78.898],
    "smh05be0354":[6.89,7.087,7.874,8.465,8.858,9.055,9.449,9.646,10.039,10.236,10.433,10.63,10.827,11.024,11.22,11.614,11.811,12.008,12.205,12.6,12.795,12.992,13.189,13.386,13.583,13.78,14.173,14.37,14.567,14.764,15.157,15.748,15.945,16.142,16.339,16.535,16.732,17.717,18.11,18.307,18.701,18.898,19.488,19.685,20.472,20.669,21.063,21.654,21.85,22.047,22.244,22.638,22.835,23.031,23.228,23.622,24.016,24.213,24.606,24.803,25,25.197,25.394,25.787,26.181,26.378,26.772,26.969,27.362,27.559,27.953,28.346,29.134,29.331,29.528,29.724,30.118,30.315,30.512,31.102,31.496,31.89,32.48,32.677,32.874,33.268,33.465,33.858,34.252,35.039,35.433,36.22,36.417,36.614,36.811,37.008,37.402,37.992,38.386,38.583,38.78,39.37,40.354,40.748,41.339,43.307,43.898,44.291,44.685,45.079,46.26,47.047,47.244,48.228,48.622,49.213,50,50.984,53.15,54.134,54.331,55.906,56.102,59.055,62.008,62.795,64.37,66.339,66.535,67.717,70.472,70.866,73.622,74.606,76.575,77.953,78.74,82.68,83.071,88.583,92.52,99.409,108.661,122.835,124.803,135.039,149.606],
    "semxlbe0375":[2.4,2.64,2.8,2.88,3.12,3.2,3.28,3.36,3.52,3.6,3.68,3.76,3.84,3.92,4,4.08,4.16,4.24,4.32,4.4,4.48,4.56,4.64,4.72,4.8,4.88,4.96,5.04,5.12,5.2,5.36,5.44,5.52,5.6,5.68,5.76,5.84,5.92,6,6.08,6.16,6.24,6.32,6.4,6.48,6.56,6.64,6.72,6.8,6.88,6.96,7.04,7.12,7.2,7.28,7.36,7.44,7.52,7.6,7.76,7.84,7.92,8,8.08,8.16,8.24,8.32,8.4,8.48,8.56,8.64,8.72,8.8,8.96,9.04,9.12,9.2,9.36,9.44,9.52,9.6,9.76,9.84,9.92,10,10.08,10.16,10.24,10.32,10.4,10.48,10.56,10.72,10.8,10.88,10.96,11.04,11.12,11.2,11.36,11.52,11.6,11.68,11.76,11.84,11.92,12,12.08,12.24,12.32,12.4,12.48,12.64,12.72,12.8,12.96,13.04,13.12,13.2,13.28,13.36,13.52,13.6,13.68,14,14.16,14.4,14.72,14.8,14.88,15.04,15.2,15.36,15.52,15.6,15.68,16,16.08,16.16,16.32,16.4,16.48,16.64,16.8,16.96,17.2,17.28,17.6,17.68,17.76,17.92,18,18.08,18.24,18.32,18.4,18.56,18.64,18.72,18.8,18.88,19.12,19.2,19.44,19.6,19.84,19.92,20,20.08,20.24,20.4,20.48,20.8,20.96,21.2,21.36,21.44,21.6,21.68,21.84,22,22.24,22.4,22.8,23.04,23.2,23.6,23.76,23.84,24,24.4,24.64,24.8,24.96,25.2,25.44,25.6,25.84,25.92,26.08,26.24,26.4,26.56,26.72,26.8,26.88,26.96,27.12,27.2,27.36,27.44,27.76,28,28.32,28.4,28.48,28.56,28.64,28.72,28.8,29.12,29.2,29.6,29.68,29.76,30.4,31.04,31.2,31.76,32,32.16,32.24,32.4,32.64,32.8,32.96,33.04,33.2,33.52,33.6,33.68,33.92,34,34.16,34.24,34.48,34.72,34.8,34.88,35.2,35.36,35.76,35.84,36.24,36.32,36.64,37.04,37.12,37.28,37.76,37.84,38,38.4,38.48,38.56,38.96,39.04,39.2,39.44,39.84,40,40.4,41.2,41.28,41.76,41.92,42,42.56,42.8,43.2,43.44,43.68,43.84,44,45.68,46.32,47.28,47.36,47.92,48,48.96,51.84,53.2,55.52],
    "sexllbe0375":[4,4.2,5,5.4,5.6,5.8,6,6.2,6.4,6.6,6.8,7,7.2,7.4,7.6,7.8,8,8.2,8.4,8.6,8.8,9,9.2,9.4,9.6,9.8,10,10.2,10.4,10.6,10.8,11,11.2,11.4,11.6,11.8,12,12.2,12.4,12.6,12.8,13,13.2,13.4,13.6,13.8,14,14.2,14.4,14.6,14.8,15,15.4,15.6,15.8,16,16.2,16.4,16.6,16.8,17,17.2,17.4,17.6,17.8,18,18.2,18.4,18.6,18.8,19,19.2,19.4,19.6,19.8,20,20.2,20.4,20.6,20.8,21,21.2,21.4,21.6,21.8,22,22.2,22.4,22.6,22.8,23,23.2,23.4,23.6,24,24.4,24.6,24.8,25,25.4,25.8,26,26.2,26.4,26.6,26.8,27,27.2,27.4,27.6,27.8,28,28.2,28.4,28.6,29,29.6,30,30.2,30.6,31,31.4,31.6,32,32.2,33,33.2,33.8,34,34.4,34.8,35,35.2,35.6,36,36.2,36.4,37,37.2,37.6,38,38.2,38.4,38.6,38.8,39,39.2,39.6,40,40.4,40.8,41.2,41.4,42,42.4,43,43.2,43.4,43.8,44.4,45,45.4,45.6,46,46.8,47,48,48.6,49,49.2,49.6,49.8,50,50.6,51,51.4,52.2,52.4,53.2,54,55.4,56,56.4,57,58,59.2,60.8,61.2,63,63.8,64.8,67,67.2,68.6,69,73.6,77,81,82.8,85,86,88.8,90,90.8,91.4,92.6,101.4,102],
    "sma05be0394":[8.858,10.039,11.024,11.811,13.386,14.764,15.354,16.535,17.717,17.913,19.685,21.457,23.622,24.016,25.984,27.953,28.346,29.528,30.709,32.48,33.858,38.386,41.339,44.291,59.055],
    "sma10be0394":[19.685,22.047,23.622,24.016,25.984,27.559,28.74,30.709,31.496,33.071,35.039,36.22,37.795,38.583,39.37,39.764,41.339,42.52,43.307,45.276,47.244,47.638,49.213,50.394,51.181,51.969,53.15,53.543,55.12,55.906,58.268,59.055,62.992,66.929,67.717,70.866,73.228,76.378],
    "smt05be0394":[6.496,7.283,7.874,8.465,8.661,8.858,9.646,9.843,10.039,10.236,10.63,10.827,11.024,11.614,11.811,12.008,12.6,12.795,12.992,13.386,13.78,13.976,14.173,14.37,14.764,15.354,15.748,16.142,16.535,16.732,16.929,17.323,17.52,17.717,17.913,18.11,18.701,18.898,19.685,20.08,20.669,21.457,21.654,22.047,22.638,23.228,23.622,24.016,24.409,24.606,24.803,25.197,25.591,25.984,26.575,27.165,27.559,28.346,28.543,29.528,30.709,31.496,32.087,33.071,33.465,33.858,35.433,37.008,38.976,39.37,42.323,43.307,43.898,44.882,47.835,51.772,53.15,54.331,56.693],
    "smt10be0394":[10.236,12.6,14.567,15.748,16.142,17.323,17.717,19.685,20.866,21.654,22.047,23.622,24.016,24.803,25.591,25.984,27.165,27.559,28.346,29.528,30.709,31.496,31.89,33.071,33.465,34.646,35.039,35.433,35.827,36.22,37.402,37.795,38.189,38.583,39.37,39.764,41.339,42.52,43.307,43.701,44.882,45.276,47.244,47.638,48.819,49.213,51.181,51.969,53.15,54.724,55.12,55.906,56.693,57.087,57.48,59.055,61.417,62.992,63.39,66.929,68.898,70.079,70.866,74.016,77.165,88.583],
    "smt25be0394":[4.724,5.709,6.299,6.988,7.874,8.268,9.055,9.646,10.433,10.925,11.22,11.417,12.008,12.5,12.992,13.484,14.961,16.535,18.898,19.685,21.26,23.622,25.591,30.709,36.024,37.402],
    "sma05be0472":[8.858,10.039,11.024,11.811,13.386,14.764,15.354,16.535,17.717,17.913,19.685,21.457,23.622,24.016,25.984,27.953,28.346,29.528,30.709,32.48,33.858,38.386,41.339,44.291,59.055],
    "sma10be0472":[19.685,22.047,23.622,24.016,25.984,27.559,28.74,30.709,31.496,33.071,35.039,36.22,37.795,38.583,39.37,39.764,41.339,42.52,43.307,45.276,47.244,47.638,49.213,50.394,51.181,51.969,53.15,53.543,55.12,55.906,58.268,59.055,62.992,66.929,67.717,70.866,73.228,76.378],
    "smt05be0472":[6.496,7.283,7.874,8.465,8.661,8.858,9.646,9.843,10.039,10.236,10.63,10.827,11.024,11.614,11.811,12.008,12.6,12.795,12.992,13.386,13.78,13.976,14.173,14.37,14.764,15.354,15.748,16.142,16.535,16.732,16.929,17.323,17.52,17.717,17.913,18.11,18.701,18.898,19.685,20.08,20.669,21.457,21.654,22.047,22.638,23.228,23.622,24.016,24.409,24.606,24.803,25.197,25.591,25.984,26.575,27.165,27.559,28.346,28.543,29.528,30.709,31.496,32.087,33.071,33.465,33.858,35.433,37.008,38.976,39.37,42.323,43.307,43.898,44.882,47.835,51.772,53.15,54.331,56.693],
    "smt10be0472":[10.236,12.6,14.567,15.748,16.142,17.323,17.717,19.685,20.866,21.654,22.047,23.622,24.016,24.803,25.591,25.984,27.165,27.559,28.346,29.528,30.709,31.496,31.89,33.071,33.465,34.646,35.039,35.433,35.827,36.22,37.402,37.795,38.189,38.583,39.37,39.764,41.339,42.52,43.307,43.701,44.882,45.276,47.244,47.638,48.819,49.213,51.181,51.969,53.15,54.724,55.12,55.906,56.693,57.087,57.48,59.055,61.417,62.992,63.39,66.929,68.898,70.079,70.866,74.016,77.165,88.583],
    "smt25be0472":[4.724,5.709,6.299,6.988,7.874,8.268,9.055,9.646,10.433,10.925,11.22,11.417,12.008,12.5,12.992,13.484,14.961,16.535,18.898,19.685,21.26,23.622,25.591,30.709,36.024,37.402],
    "selllbe0500":[9.75,10.875,12.375,13.125,13.5,15,15.375,15.75,16.5,16.875,17.25,17.625,18.75,19.5,19.875,20.25,20.625,21,21.75,22.5,23.25,23.625,24,24.375,24.75,25.125,25.5,25.875,26.25,27,27.75,28.5,30,30.375,30.75,31.5,31.875,32.25,33.375,33.75,34.5,35.25,36,36.75,37.5,38.25,39,39.375,40.5,42,42.75,43.5,43.875,44.625,45,45.375,46.125,46.5,48,51,51.375,52.5,54,54.75,56.625,57,58.125,60,60.375,61.875,63,63.75,65.25,66,69.75,72,72.75,73.125,76.875,78,78.75,80.625,81.75,85.5,86.25,88.125,90,91.5,91.875,93.75,94.5,110.25,129.375],
    "smh05be0590":[6.89,7.087,7.874,8.465,8.858,9.055,9.449,9.646,10.039,10.236,10.433,10.63,10.827,11.024,11.22,11.614,11.811,12.008,12.205,12.6,12.795,12.992,13.189,13.386,13.583,13.78,14.173,14.37,14.567,14.764,15.157,15.748,15.945,16.142,16.339,16.535,16.732,17.717,18.11,18.307,18.701,18.898,19.488,19.685,20.472,20.669,21.063,21.654,21.85,22.047,22.244,22.638,22.835,23.031,23.228,23.622,24.016,24.213,24.606,24.803,25,25.197,25.394,25.787,26.181,26.378,26.772,26.969,27.362,27.559,27.953,28.346,29.134,29.331,29.528,29.724,30.118,30.315,30.512,31.102,31.496,31.89,32.48,32.677,32.874,33.268,33.465,33.858,34.252,35.039,35.433,36.22,36.417,36.614,36.811,37.008,37.402,37.992,38.386,38.583,38.78,39.37,40.354,40.748,41.339,43.307,43.898,44.291,44.685,45.079,46.26,47.047,47.244,48.228,48.622,49.213,50,50.984,53.15,54.134,54.331,55.906,56.102,59.055,62.008,62.795,64.37,66.339,66.535,67.717,70.472,70.866,73.622,74.606,76.575,77.953,78.74,82.68,83.071,88.583,92.52,99.409,108.661,122.835,124.803,135.039,149.606],
    "sma05be0630":[8.858,10.039,11.024,11.811,13.386,14.764,15.354,16.535,17.717,17.913,19.685,21.457,23.622,24.016,25.984,27.953,28.346,29.528,30.709,32.48,33.858,38.386,41.339,44.291,59.055],
    "sma10be0630":[19.685,22.047,23.622,24.016,25.984,27.559,28.74,30.709,31.496,33.071,35.039,36.22,37.795,38.583,39.37,39.764,41.339,42.52,43.307,45.276,47.244,47.638,49.213,50.394,51.181,51.969,53.15,53.543,55.12,55.906,58.268,59.055,62.992,66.929,67.717,70.866,73.228,76.378],
    "smt05be0630":[6.496,7.283,7.874,8.465,8.661,8.858,9.646,9.843,10.039,10.236,10.63,10.827,11.024,11.614,11.811,12.008,12.6,12.795,12.992,13.386,13.78,13.976,14.173,14.37,14.764,15.354,15.748,16.142,16.535,16.732,16.929,17.323,17.52,17.717,17.913,18.11,18.701,18.898,19.685,20.08,20.669,21.457,21.654,22.047,22.638,23.228,23.622,24.016,24.409,24.606,24.803,25.197,25.591,25.984,26.575,27.165,27.559,28.346,28.543,29.528,30.709,31.496,32.087,33.071,33.465,33.858,35.433,37.008,38.976,39.37,42.323,43.307,43.898,44.882,47.835,51.772,53.15,54.331,56.693],
    "smt10be0630":[10.236,12.6,14.567,15.748,16.142,17.323,17.717,19.685,20.866,21.654,22.047,23.622,24.016,24.803,25.591,25.984,27.165,27.559,28.346,29.528,30.709,31.496,31.89,33.071,33.465,34.646,35.039,35.433,35.827,36.22,37.402,37.795,38.189,38.583,39.37,39.764,41.339,42.52,43.307,43.701,44.882,45.276,47.244,47.638,48.819,49.213,51.181,51.969,53.15,54.724,55.12,55.906,56.693,57.087,57.48,59.055,61.417,62.992,63.39,66.929,68.898,70.079,70.866,74.016,77.165,88.583],
    "sehhhbe0750":[18.5,20.5,21,22,22.5,23,24,24.5,25.5,27,28,30,30.5,31,31.5,32,33,33.5,34,35,36,37,37.5,39,39.5,40,41,41.5,42,43,44,44.5,45,45.5,46.5,48,48.5,49,49.5,51,52,52.5,53,54,55.5,56,56.5,57,58,58.5,60,60.5,61.5,63,64,64.5,65,65.5,66,67,68,70,73,75,76,77,77.5,78,80,81,82,84,85,86,87,87.5,90,95,96,98.5,100,102,104,105,110,112,113,114,117,118,125,132,132.5,134.5,135,136.5,140,146,151,155,164.5,168,170],
    "selllbe0750":[9.75,10.875,12.375,13.125,13.5,15,15.375,15.75,16.5,16.875,17.25,17.625,18.75,19.5,19.875,20.25,20.625,21,21.75,22.5,23.25,23.625,24,24.375,24.75,25.125,25.5,25.875,26.25,27,27.75,28.5,30,30.375,30.75,31.5,31.875,32.25,33.375,33.75,34.5,35.25,36,36.75,37.5,38.25,39,39.375,40.5,42,42.75,43.5,43.875,44.625,45,45.375,46.125,46.5,48,51,51.375,52.5,54,54.75,56.625,57,58.125,60,60.375,61.875,63,63.75,65.25,66,69.75,72,72.75,73.125,76.875,78,78.75,80.625,81.75,85.5,86.25,88.125,90,91.5,91.875,93.75,94.5,110.25,129.375],
    "sma05be0787":[8.858,10.039,11.024,11.811,13.386,14.764,15.354,16.535,17.717,17.913,19.685,21.457,23.622,24.016,25.984,27.953,28.346,29.528,30.709,32.48,33.858,38.386,41.339,44.291,59.055],
    "sma10be0787":[19.685,22.047,23.622,24.016,25.984,27.559,28.74,30.709,31.496,33.071,35.039,36.22,37.795,38.583,39.37,39.764,41.339,42.52,43.307,45.276,47.244,47.638,49.213,50.394,51.181,51.969,53.15,53.543,55.12,55.906,58.268,59.055,62.992,66.929,67.717,70.866,73.228,76.378],
    "smh08be0787":[12.6,14.173,14.803,15.118,16.693,17.008,18.583,18.898,19.843,20.157,20.472,21.102,22.047,22.677,23.307,23.622,23.937,24.567,24.882,25.197,25.827,26.457,26.772,28.031,28.346,29.921,30.551,30.866,31.496,32.441,33.071,33.386,33.701,34.646,35.276,35.906,36.22,36.535,36.85,37.795,38.11,38.425,39.37,40.945,41.575,41.89,42.52,43.15,43.465,44.094,44.409,44.724,45.354,45.669,46.299,46.614,46.929,47.244,47.874,48.189,49.134,49.449,49.764,50.394,51.339,51.969,52.283,52.913,53.543,54.803,55.12,56.063,56.378,56.693,58.268,59.528,59.843,61.102,62.992,66.142,66.772,68.031,69.291,70.866,74.646,74.961,76.22,78.74,80.945,81.89,82.835,85.039,86.614,88.189,88.504,89.449,90.079,94.488,98.583,102.362,110.24,120,125.984,129.134,132.28,141.732,150.551,173.228,175.748,195.276],
    "smt05be0787":[6.496,7.283,7.874,8.465,8.661,8.858,9.646,9.843,10.039,10.236,10.63,10.827,11.024,11.614,11.811,12.008,12.6,12.795,12.992,13.386,13.78,13.976,14.173,14.37,14.764,15.354,15.748,16.142,16.535,16.732,16.929,17.323,17.52,17.717,17.913,18.11,18.701,18.898,19.685,20.08,20.669,21.457,21.654,22.047,22.638,23.228,23.622,24.016,24.409,24.606,24.803,25.197,25.591,25.984,26.575,27.165,27.559,28.346,28.543,29.528,30.709,31.496,32.087,33.071,33.465,33.858,35.433,37.008,38.976,39.37,42.323,43.307,43.898,44.882,47.835,51.772,53.15,54.331,56.693],
    "smt10be0787":[10.236,12.6,14.567,15.748,16.142,17.323,17.717,19.685,20.866,21.654,22.047,23.622,24.016,24.803,25.591,25.984,27.165,27.559,28.346,29.528,30.709,31.496,31.89,33.071,33.465,34.646,35.039,35.433,35.827,36.22,37.402,37.795,38.189,38.583,39.37,39.764,41.339,42.52,43.307,43.701,44.882,45.276,47.244,47.638,48.819,49.213,51.181,51.969,53.15,54.724,55.12,55.906,56.693,57.087,57.48,59.055,61.417,62.992,63.39,66.929,68.898,70.079,70.866,74.016,77.165,88.583],
    "sma05be0984":[8.858,10.039,11.024,11.811,13.386,14.764,15.354,16.535,17.717,17.913,19.685,21.457,23.622,24.016,25.984,27.953,28.346,29.528,30.709,32.48,33.858,38.386,41.339,44.291,59.055],
    "sma10be0984":[19.685,22.047,23.622,24.016,25.984,27.559,28.74,30.709,31.496,33.071,35.039,36.22,37.795,38.583,39.37,39.764,41.339,42.52,43.307,45.276,47.244,47.638,49.213,50.394,51.181,51.969,53.15,53.543,55.12,55.906,58.268,59.055,62.992,66.929,67.717,70.866,73.228,76.378],
    "smh05be0984":[6.89,7.087,7.874,8.465,8.858,9.055,9.449,9.646,10.039,10.236,10.433,10.63,10.827,11.024,11.22,11.614,11.811,12.008,12.205,12.6,12.795,12.992,13.189,13.386,13.583,13.78,14.173,14.37,14.567,14.764,15.157,15.748,15.945,16.142,16.339,16.535,16.732,17.717,18.11,18.307,18.701,18.898,19.488,19.685,20.472,20.669,21.063,21.654,21.85,22.047,22.244,22.638,22.835,23.031,23.228,23.622,24.016,24.213,24.606,24.803,25,25.197,25.394,25.787,26.181,26.378,26.772,26.969,27.362,27.559,27.953,28.346,29.134,29.331,29.528,29.724,30.118,30.315,30.512,31.102,31.496,31.89,32.48,32.677,32.874,33.268,33.465,33.858,34.252,35.039,35.433,36.22,36.417,36.614,36.811,37.008,37.402,37.992,38.386,38.583,38.78,39.37,40.354,40.748,41.339,43.307,43.898,44.291,44.685,45.079,46.26,47.047,47.244,48.228,48.622,49.213,50,50.984,53.15,54.134,54.331,55.906,56.102,59.055,62.008,62.795,64.37,66.339,66.535,67.717,70.472,70.866,73.622,74.606,76.575,77.953,78.74,82.68,83.071,88.583,92.52,99.409,108.661,122.835,124.803,135.039,149.606],
    "smt05be0984":[6.496,7.283,7.874,8.465,8.661,8.858,9.646,9.843,10.039,10.236,10.63,10.827,11.024,11.614,11.811,12.008,12.6,12.795,12.992,13.386,13.78,13.976,14.173,14.37,14.764,15.354,15.748,16.142,16.535,16.732,16.929,17.323,17.52,17.717,17.913,18.11,18.701,18.898,19.685,20.08,20.669,21.457,21.654,22.047,22.638,23.228,23.622,24.016,24.409,24.606,24.803,25.197,25.591,25.984,26.575,27.165,27.559,28.346,28.543,29.528,30.709,31.496,32.087,33.071,33.465,33.858,35.433,37.008,38.976,39.37,42.323,43.307,43.898,44.882,47.835,51.772,53.15,54.331,56.693],
    "smt10be0984":[10.236,12.6,14.567,15.748,16.142,17.323,17.717,19.685,20.866,21.654,22.047,23.622,24.016,24.803,25.591,25.984,27.165,27.559,28.346,29.528,30.709,31.496,31.89,33.071,33.465,34.646,35.039,35.433,35.827,36.22,37.402,37.795,38.189,38.583,39.37,39.764,41.339,42.52,43.307,43.701,44.882,45.276,47.244,47.638,48.819,49.213,51.181,51.969,53.15,54.724,55.12,55.906,56.693,57.087,57.48,59.055,61.417,62.992,63.39,66.929,68.898,70.079,70.866,74.016,77.165,88.583],
    "sehhhbe1000":[18.5,20.5,21,22,22.5,23,24,24.5,25.5,27,28,30,30.5,31,31.5,32,33,33.5,34,35,36,37,37.5,39,39.5,40,41,41.5,42,43,44,44.5,45,45.5,46.5,48,48.5,49,49.5,51,52,52.5,53,54,55.5,56,56.5,57,58,58.5,60,60.5,61.5,63,64,64.5,65,65.5,66,67,68,70,73,75,76,77,77.5,78,80,81,82,84,85,86,87,87.5,90,95,96,98.5,100,102,104,105,110,112,113,114,117,118,125,132,132.5,134.5,135,136.5,140,146,151,155,164.5,168,170],
    "selllbe1000":[9.75,10.875,12.375,13.125,13.5,15,15.375,15.75,16.5,16.875,17.25,17.625,18.75,19.5,19.875,20.25,20.625,21,21.75,22.5,23.25,23.625,24,24.375,24.75,25.125,25.5,25.875,26.25,27,27.75,28.5,30,30.375,30.75,31.5,31.875,32.25,33.375,33.75,34.5,35.25,36,36.75,37.5,38.25,39,39.375,40.5,42,42.75,43.5,43.875,44.625,45,45.375,46.125,46.5,48,51,51.375,52.5,54,54.75,56.625,57,58.125,60,60.375,61.875,63,63.75,65.25,66,69.75,72,72.75,73.125,76.875,78,78.75,80.625,81.75,85.5,86.25,88.125,90,91.5,91.875,93.75,94.5,110.25,129.375],
    "smh08be1181":[12.6,14.173,14.803,15.118,16.693,17.008,18.583,18.898,19.843,20.157,20.472,21.102,22.047,22.677,23.307,23.622,23.937,24.567,24.882,25.197,25.827,26.457,26.772,28.031,28.346,29.921,30.551,30.866,31.496,32.441,33.071,33.386,33.701,34.646,35.276,35.906,36.22,36.535,36.85,37.795,38.11,38.425,39.37,40.945,41.575,41.89,42.52,43.15,43.465,44.094,44.409,44.724,45.354,45.669,46.299,46.614,46.929,47.244,47.874,48.189,49.134,49.449,49.764,50.394,51.339,51.969,52.283,52.913,53.543,54.803,55.12,56.063,56.378,56.693,58.268,59.528,59.843,61.102,62.992,66.142,66.772,68.031,69.291,70.866,74.646,74.961,76.22,78.74,80.945,81.89,82.835,85.039,86.614,88.189,88.504,89.449,90.079,94.488,98.583,102.362,110.24,120,125.984,129.134,132.28,141.732,150.551,173.228,175.748,195.276],
    "sma10be1260":[19.685,22.047,23.622,24.016,25.984,27.559,28.74,30.709,31.496,33.071,35.039,36.22,37.795,38.583,39.37,39.764,41.339,42.52,43.307,45.276,47.244,47.638,49.213,50.394,51.181,51.969,53.15,53.543,55.12,55.906,58.268,59.055,62.992,66.929,67.717,70.866,73.228,76.378],
    "smt10be1260":[10.236,12.6,14.567,15.748,16.142,17.323,17.717,19.685,20.866,21.654,22.047,23.622,24.016,24.803,25.591,25.984,27.165,27.559,28.346,29.528,30.709,31.496,31.89,33.071,33.465,34.646,35.039,35.433,35.827,36.22,37.402,37.795,38.189,38.583,39.37,39.764,41.339,42.52,43.307,43.701,44.882,45.276,47.244,47.638,48.819,49.213,51.181,51.969,53.15,54.724,55.12,55.906,56.693,57.087,57.48,59.055,61.417,62.992,63.39,66.929,68.898,70.079,70.866,74.016,77.165,88.583],
    "sehhhbe1500":[18.5,20.5,21,22,22.5,23,24,24.5,25.5,27,28,30,30.5,31,31.5,32,33,33.5,34,35,36,37,37.5,39,39.5,40,41,41.5,42,43,44,44.5,45,45.5,46.5,48,48.5,49,49.5,51,52,52.5,53,54,55.5,56,56.5,57,58,58.5,60,60.5,61.5,63,64,64.5,65,65.5,66,67,68,70,73,75,76,77,77.5,78,80,81,82,84,85,86,87,87.5,90,95,96,98.5,100,102,104,105,110,112,113,114,117,118,125,132,132.5,134.5,135,136.5,140,146,151,155,164.5,168,170],
    "sma10be1969":[19.685,22.047,23.622,24.016,25.984,27.559,28.74,30.709,31.496,33.071,35.039,36.22,37.795,38.583,39.37,39.764,41.339,42.52,43.307,45.276,47.244,47.638,49.213,50.394,51.181,51.969,53.15,53.543,55.12,55.906,58.268,59.055,62.992,66.929,67.717,70.866,73.228,76.378],
    "smh08be1969":[12.6,14.173,14.803,15.118,16.693,17.008,18.583,18.898,19.843,20.157,20.472,21.102,22.047,22.677,23.307,23.622,23.937,24.567,24.882,25.197,25.827,26.457,26.772,28.031,28.346,29.921,30.551,30.866,31.496,32.441,33.071,33.386,33.701,34.646,35.276,35.906,36.22,36.535,36.85,37.795,38.11,38.425,39.37,40.945,41.575,41.89,42.52,43.15,43.465,44.094,44.409,44.724,45.354,45.669,46.299,46.614,46.929,47.244,47.874,48.189,49.134,49.449,49.764,50.394,51.339,51.969,52.283,52.913,53.543,54.803,55.12,56.063,56.378,56.693,58.268,59.528,59.843,61.102,62.992,66.142,66.772,68.031,69.291,70.866,74.646,74.961,76.22,78.74,80.945,81.89,82.835,85.039,86.614,88.189,88.504,89.449,90.079,94.488,98.583,102.362,110.24,120,125.984,129.134,132.28,141.732,150.551,173.228,175.748,195.276],
    "smt10be1969":[10.236,12.6,14.567,15.748,16.142,17.323,17.717,19.685,20.866,21.654,22.047,23.622,24.016,24.803,25.591,25.984,27.165,27.559,28.346,29.528,30.709,31.496,31.89,33.071,33.465,34.646,35.039,35.433,35.827,36.22,37.402,37.795,38.189,38.583,39.37,39.764,41.339,42.52,43.307,43.701,44.882,45.276,47.244,47.638,48.819,49.213,51.181,51.969,53.15,54.724,55.12,55.906,56.693,57.087,57.48,59.055,61.417,62.992,63.39,66.929,68.898,70.079,70.866,74.016,77.165,88.583],
    "sehhhbe2000":[18.5,20.5,21,22,22.5,23,24,24.5,25.5,27,28,30,30.5,31,31.5,32,33,33.5,34,35,36,37,37.5,39,39.5,40,41,41.5,42,43,44,44.5,45,45.5,46.5,48,48.5,49,49.5,51,52,52.5,53,54,55.5,56,56.5,57,58,58.5,60,60.5,61.5,63,64,64.5,65,65.5,66,67,68,70,73,75,76,77,77.5,78,80,81,82,84,85,86,87,87.5,90,95,96,98.5,100,102,104,105,110,112,113,114,117,118,125,132,132.5,134.5,135,136.5,140,146,151,155,164.5,168,170],
    "sehhhbe3000":[18.5,20.5,21,22,22.5,23,24,24.5,25.5,27,28,30,30.5,31,31.5,32,33,33.5,34,35,36,37,37.5,39,39.5,40,41,41.5,42,43,44,44.5,45,45.5,46.5,48,48.5,49,49.5,51,52,52.5,53,54,55.5,56,56.5,57,58,58.5,60,60.5,61.5,63,64,64.5,65,65.5,66,67,68,70,73,75,76,77,77.5,78,80,81,82,84,85,86,87,87.5,90,95,96,98.5,100,102,104,105,110,112,113,114,117,118,125,132,132.5,134.5,135,136.5,140,146,151,155,164.5,168,170],
    "smh08be3346":[12.6,14.173,14.803,15.118,16.693,17.008,18.583,18.898,19.843,20.157,20.472,21.102,22.047,22.677,23.307,23.622,23.937,24.567,24.882,25.197,25.827,26.457,26.772,28.031,28.346,29.921,30.551,30.866,31.496,32.441,33.071,33.386,33.701,34.646,35.276,35.906,36.22,36.535,36.85,37.795,38.11,38.425,39.37,40.945,41.575,41.89,42.52,43.15,43.465,44.094,44.409,44.724,45.354,45.669,46.299,46.614,46.929,47.244,47.874,48.189,49.134,49.449,49.764,50.394,51.339,51.969,52.283,52.913,53.543,54.803,55.12,56.063,56.378,56.693,58.268,59.528,59.843,61.102,62.992,66.142,66.772,68.031,69.291,70.866,74.646,74.961,76.22,78.74,80.945,81.89,82.835,85.039,86.614,88.189,88.504,89.449,90.079,94.488,98.583,102.362,110.24,120,125.984,129.134,132.28,141.732,150.551,173.228,175.748,195.276],
    "semxlbm03175":[2.4,2.64,2.8,2.88,3.12,3.2,3.28,3.36,3.52,3.6,3.68,3.76,3.84,3.92,4,4.08,4.16,4.24,4.32,4.4,4.48,4.56,4.64,4.72,4.8,4.88,4.96,5.04,5.12,5.2,5.36,5.44,5.52,5.6,5.68,5.76,5.84,5.92,6,6.08,6.16,6.24,6.32,6.4,6.48,6.56,6.64,6.72,6.8,6.88,6.96,7.04,7.12,7.2,7.28,7.36,7.44,7.52,7.6,7.76,7.84,7.92,8,8.08,8.16,8.24,8.32,8.4,8.48,8.56,8.64,8.72,8.8,8.96,9.04,9.12,9.2,9.36,9.44,9.52,9.6,9.76,9.84,9.92,10,10.08,10.16,10.24,10.32,10.4,10.48,10.56,10.72,10.8,10.88,10.96,11.04,11.12,11.2,11.36,11.52,11.6,11.68,11.76,11.84,11.92,12,12.08,12.24,12.32,12.4,12.48,12.64,12.72,12.8,12.96,13.04,13.12,13.2,13.28,13.36,13.52,13.6,13.68,14,14.16,14.4,14.72,14.8,14.88,15.04,15.2,15.36,15.52,15.6,15.68,16,16.08,16.16,16.32,16.4,16.48,16.64,16.8,16.96,17.2,17.28,17.6,17.68,17.76,17.92,18,18.08,18.24,18.32,18.4,18.56,18.64,18.72,18.8,18.88,19.12,19.2,19.44,19.6,19.84,19.92,20,20.08,20.24,20.4,20.48,20.8,20.96,21.2,21.36,21.44,21.6,21.68,21.84,22,22.24,22.4,22.8,23.04,23.2,23.6,23.76,23.84,24,24.4,24.64,24.8,24.96,25.2,25.44,25.6,25.84,25.92,26.08,26.24,26.4,26.56,26.72,26.8,26.88,26.96,27.12,27.2,27.36,27.44,27.76,28,28.32,28.4,28.48,28.56,28.64,28.72,28.8,29.12,29.2,29.6,29.68,29.76,30.4,31.04,31.2,31.76,32,32.16,32.24,32.4,32.64,32.8,32.96,33.04,33.2,33.52,33.6,33.68,33.92,34,34.16,34.24,34.48,34.72,34.8,34.88,35.2,35.36,35.76,35.84,36.24,36.32,36.64,37.04,37.12,37.28,37.76,37.84,38,38.4,38.48,38.56,38.96,39.04,39.2,39.44,39.84,40,40.4,41.2,41.28,41.76,41.92,42,42.56,42.8,43.2,43.44,43.68,43.84,44,45.68,46.32,47.28,47.36,47.92,48,48.96,51.84,53.2,55.52],
    "sma05bm06000":[8.858,10.039,11.024,11.811,13.386,14.764,15.354,16.535,17.717,17.913,19.685,21.457,23.622,24.016,25.984,27.953,28.346,29.528,30.709,32.48,33.858,38.386,41.339,44.291,59.055],
    "smh03bm06000":[3.425,4.016,4.134,4.252,4.37,4.606,4.724,4.843,4.96,5.079,5.197,5.551,5.669,5.787,5.906,6.024,6.142,6.26,6.496,6.614,6.732,6.85,6.969,7.087,7.205,7.323,7.44,7.559,7.677,7.795,7.913,8.031,8.15,8.268,8.386,8.504,8.622,8.74,8.858,8.976,9.213,9.331,9.449,9.685,9.803,9.92,10.039,10.157,10.276,10.394,10.512,10.63,10.866,10.984,11.102,11.22,11.339,11.457,11.575,11.693,11.811,11.929,12.047,12.165,12.283,12.4,12.52,12.756,12.874,12.992,13.11,13.228,13.346,13.465,13.583,13.819,14.055,14.173,14.291,14.409,14.528,14.646,14.764,15,15.118,15.236,15.354,15.472,15.591,15.709,15.827,15.945,16.181,16.417,16.535,16.654,16.772,17.008,17.126,17.244,17.48,17.6,18.071,18.189,18.307,18.425,18.543,18.661,18.78,18.898,19.016,19.134,19.252,19.37,19.488,19.724,19.843,20.08,20.197,20.315,20.433,20.551,20.669,20.787,20.906,21.142,21.614,21.732,21.969,22.205,22.441,22.559,22.677,22.795,22.913,23.031,23.268,23.386,23.504,23.622,23.858,23.976,24.094,24.213,24.685,24.921,25.157,25.394,25.512,25.748,25.866,26.102,26.339,26.457,26.575,26.811,26.929,27.047,27.165,27.283,27.4,27.638,27.756,27.874,27.992,28.346,28.465,28.819,28.937,29.055,29.528,29.646,30.827,31.299,31.654,32.126,32.362,32.48,32.953,33.189,33.78,33.898,34.37,34.724,34.961,35.079,35.433,36.024,36.85,37.205,37.441,37.795,38.622,39.449,40.394,40.748,40.866,40.984,41.339,41.575,41.811,42.047,42.165,42.52,43.701,44.291,45.472,46.299,46.772,46.89,48.307,49.016,49.606,49.724,52.559,59.055,59.528,60.236,61.772,62.48,70.866,73.346,75.827,77.008,78.898],
    "smt05bm06000":[6.496,7.283,7.874,8.465,8.661,8.858,9.646,9.843,10.039,10.236,10.63,10.827,11.024,11.614,11.811,12.008,12.6,12.795,12.992,13.386,13.78,13.976,14.173,14.37,14.764,15.354,15.748,16.142,16.535,16.732,16.929,17.323,17.52,17.717,17.913,18.11,18.701,18.898,19.685,20.08,20.669,21.457,21.654,22.047,22.638,23.228,23.622,24.016,24.409,24.606,24.803,25.197,25.591,25.984,26.575,27.165,27.559,28.346,28.543,29.528,30.709,31.496,32.087,33.071,33.465,33.858,35.433,37.008,38.976,39.37,42.323,43.307,43.898,44.882,47.835,51.772,53.15,54.331,56.693],
    "smt25bm06000":[4.724,5.709,6.299,6.988,7.874,8.268,9.055,9.646,10.433,10.925,11.22,11.417,12.008,12.5,12.992,13.484,14.961,16.535,18.898,19.685,21.26,23.622,25.591,30.709,36.024,37.402],
    "semxlbm06350":[2.4,2.64,2.8,2.88,3.12,3.2,3.28,3.36,3.52,3.6,3.68,3.76,3.84,3.92,4,4.08,4.16,4.24,4.32,4.4,4.48,4.56,4.64,4.72,4.8,4.88,4.96,5.04,5.12,5.2,5.36,5.44,5.52,5.6,5.68,5.76,5.84,5.92,6,6.08,6.16,6.24,6.32,6.4,6.48,6.56,6.64,6.72,6.8,6.88,6.96,7.04,7.12,7.2,7.28,7.36,7.44,7.52,7.6,7.76,7.84,7.92,8,8.08,8.16,8.24,8.32,8.4,8.48,8.56,8.64,8.72,8.8,8.96,9.04,9.12,9.2,9.36,9.44,9.52,9.6,9.76,9.84,9.92,10,10.08,10.16,10.24,10.32,10.4,10.48,10.56,10.72,10.8,10.88,10.96,11.04,11.12,11.2,11.36,11.52,11.6,11.68,11.76,11.84,11.92,12,12.08,12.24,12.32,12.4,12.48,12.64,12.72,12.8,12.96,13.04,13.12,13.2,13.28,13.36,13.52,13.6,13.68,14,14.16,14.4,14.72,14.8,14.88,15.04,15.2,15.36,15.52,15.6,15.68,16,16.08,16.16,16.32,16.4,16.48,16.64,16.8,16.96,17.2,17.28,17.68,17.76,17.92,18,18.08,18.24,18.32,18.4,18.56,18.64,18.72,18.8,18.88,19.12,19.2,19.44,19.6,19.84,19.92,20,20.08,20.24,20.4,20.48,20.8,20.96,21.2,21.36,21.44,21.6,21.68,21.84,22,22.24,22.4,22.8,23.04,23.2,23.6,23.76,23.84,24,24.4,24.64,24.8,24.96,25.2,25.44,25.6,25.84,25.92,26.08,26.24,26.4,26.56,26.72,26.8,26.88,26.96,27.12,27.2,27.36,27.44,27.76,28,28.32,28.4,28.48,28.56,28.64,28.72,28.8,29.12,29.2,29.6,29.68,29.76,30.4,31.04,31.2,31.76,32,32.16,32.24,32.4,32.64,32.8,32.96,33.04,33.2,33.52,33.6,33.68,33.92,34,34.16,34.24,34.48,34.72,34.8,34.88,35.2,35.36,35.76,35.84,36.24,36.32,36.64,37.04,37.12,37.28,37.76,37.84,38,38.4,38.48,38.56,38.96,39.04,39.2,39.44,39.84,40,40.4,41.2,41.28,41.76,41.92,42,42.56,42.8,43.2,43.44,43.68,43.84,44,45.68,46.32,47.28,47.36,47.92,48,48.96,51.84,53.2,55.52],
    "sexllbm06350":[4,4.2,5,5.4,5.6,5.8,6,6.2,6.4,6.6,6.8,7,7.2,7.4,7.6,7.8,8,8.2,8.4,8.6,8.8,9,9.2,9.4,9.6,9.8,10,10.2,10.4,10.6,10.8,11,11.2,11.4,11.6,11.8,12,12.2,12.4,12.6,12.8,13,13.2,13.4,13.6,13.8,14,14.2,14.4,14.6,14.8,15,15.2,15.4,15.6,15.8,16,16.2,16.4,16.6,16.8,17,17.2,17.4,17.6,17.8,18,18.2,18.4,18.6,18.8,19,19.2,19.4,19.6,19.8,20,20.2,20.4,20.6,20.8,21,21.2,21.4,21.6,21.8,22,22.2,22.4,22.6,22.8,23,23.2,23.4,23.6,24,24.4,24.6,24.8,25,25.4,25.8,26,26.2,26.4,26.6,26.8,27,27.2,27.4,27.6,27.8,28,28.2,28.4,28.6,29,29.6,30,30.2,30.6,31,31.4,31.6,32,32.2,33,33.2,33.8,34,34.4,34.8,35,35.2,35.6,36,36.2,36.4,37,37.2,37.6,38,38.2,38.4,38.6,38.8,39,39.2,39.6,40,40.4,40.8,41.2,41.4,42,42.4,43,43.2,43.4,43.8,44.4,45,45.4,45.6,46,46.8,47,48,48.6,49,49.2,49.6,49.8,50,50.6,51,51.4,52.2,52.4,53.2,54,55.4,56,56.4,57,58,59.2,60.8,61.2,63,63.8,64.8,67,67.2,68.6,69,73.6,77,81,82.8,85,86,88.8,90,90.8,91.4,92.6,101.4,102],
    "smh03bm09000":[3.425,4.016,4.134,4.252,4.37,4.606,4.724,4.843,4.96,5.079,5.197,5.551,5.669,5.787,5.906,6.024,6.142,6.26,6.496,6.614,6.732,6.85,6.969,7.087,7.205,7.323,7.44,7.559,7.677,7.795,7.913,8.031,8.15,8.268,8.386,8.504,8.622,8.74,8.858,8.976,9.213,9.331,9.449,9.685,9.803,9.92,10.039,10.157,10.276,10.394,10.512,10.63,10.866,10.984,11.102,11.22,11.339,11.457,11.575,11.693,11.811,11.929,12.047,12.165,12.283,12.4,12.52,12.756,12.874,12.992,13.11,13.228,13.346,13.465,13.583,13.819,14.055,14.173,14.291,14.409,14.528,14.646,14.764,15,15.118,15.236,15.354,15.472,15.591,15.709,15.827,15.945,16.181,16.417,16.535,16.654,16.772,17.008,17.126,17.244,17.48,17.6,18.071,18.189,18.307,18.425,18.543,18.661,18.78,18.898,19.016,19.134,19.252,19.37,19.488,19.724,19.843,20.08,20.197,20.315,20.433,20.551,20.669,20.787,20.906,21.142,21.614,21.732,21.969,22.205,22.441,22.559,22.677,22.795,22.913,23.031,23.268,23.386,23.504,23.622,23.858,23.976,24.094,24.213,24.685,24.921,25.157,25.394,25.512,25.748,25.866,26.102,26.339,26.457,26.575,26.811,26.929,27.047,27.165,27.283,27.4,27.638,27.756,27.874,27.992,28.346,28.465,28.819,28.937,29.055,29.528,29.646,30.827,31.299,31.654,32.126,32.362,32.48,32.953,33.189,33.78,33.898,34.37,34.724,34.961,35.079,35.433,36.024,36.85,37.205,37.441,37.795,38.622,39.449,40.394,40.748,40.866,40.984,41.339,41.575,41.811,42.047,42.165,42.52,43.701,44.291,45.472,46.299,46.772,46.89,48.307,49.016,49.606,49.724,52.559,59.055,59.528,60.236,61.772,62.48,70.866,73.346,75.827,77.008,78.898],
    "smh05bm09000":[6.89,7.087,7.874,8.465,8.858,9.055,9.449,9.646,10.039,10.236,10.433,10.63,10.827,11.024,11.22,11.614,11.811,12.008,12.205,12.6,12.795,12.992,13.189,13.386,13.583,13.78,14.173,14.37,14.567,14.764,15.157,15.748,15.945,16.142,16.339,16.535,16.732,17.717,18.11,18.307,18.701,18.898,19.488,19.685,20.472,20.669,21.063,21.654,21.85,22.047,22.244,22.638,22.835,23.031,23.228,23.622,24.016,24.213,24.606,24.803,25,25.197,25.394,25.787,26.181,26.378,26.772,26.969,27.362,27.559,27.953,28.346,29.134,29.331,29.528,29.724,30.118,30.315,30.512,31.102,31.496,31.89,32.48,32.677,32.874,33.268,33.465,33.858,34.252,35.039,35.433,36.22,36.417,36.614,36.811,37.008,37.402,37.992,38.386,38.583,38.78,39.37,40.354,40.748,41.339,43.307,43.898,44.291,44.685,45.079,46.26,47.047,47.244,48.228,48.622,49.213,50,50.984,53.15,54.134,54.331,55.906,56.102,59.055,62.008,62.795,64.37,66.339,66.535,67.717,70.472,70.866,73.622,74.606,76.575,77.953,78.74,82.68,83.071,88.583,92.52,99.409,108.661,122.835,124.803,135.039,149.606],
    "semxlbm09525":[2.4,2.64,2.8,2.88,3.12,3.2,3.28,3.36,3.52,3.6,3.68,3.76,3.84,3.92,4,4.08,4.16,4.24,4.32,4.4,4.48,4.56,4.64,4.72,4.8,4.88,4.96,5.04,5.12,5.2,5.36,5.44,5.52,5.6,5.68,5.76,5.84,5.92,6,6.08,6.16,6.24,6.32,6.4,6.48,6.56,6.64,6.72,6.8,6.88,6.96,7.04,7.12,7.2,7.28,7.36,7.44,7.52,7.6,7.76,7.84,7.92,8,8.08,8.16,8.24,8.32,8.4,8.48,8.56,8.64,8.72,8.8,8.96,9.04,9.12,9.2,9.36,9.44,9.52,9.6,9.76,9.84,9.92,10,10.08,10.16,10.24,10.32,10.4,10.48,10.56,10.72,10.8,10.88,10.96,11.04,11.12,11.2,11.36,11.52,11.6,11.68,11.76,11.84,11.92,12,12.08,12.24,12.32,12.4,12.48,12.64,12.72,12.8,12.96,13.04,13.12,13.2,13.28,13.36,13.52,13.6,13.68,14,14.16,14.4,14.72,14.8,14.88,15.04,15.2,15.36,15.52,15.6,15.68,16,16.08,16.16,16.32,16.4,16.48,16.64,16.8,16.96,17.2,17.28,17.6,17.68,17.76,17.92,18,18.08,18.24,18.32,18.4,18.56,18.64,18.72,18.8,18.88,19.12,19.2,19.44,19.6,19.84,19.92,20,20.08,20.24,20.4,20.48,20.8,20.96,21.2,21.36,21.44,21.6,21.68,21.84,22,22.24,22.4,22.8,23.04,23.2,23.6,23.76,23.84,24,24.4,24.64,24.8,24.96,25.2,25.44,25.6,25.84,25.92,26.08,26.24,26.4,26.56,26.72,26.8,26.88,26.96,27.12,27.2,27.36,27.44,27.76,28,28.32,28.4,28.48,28.56,28.64,28.72,28.8,29.12,29.2,29.6,29.68,29.76,30.4,31.04,31.2,31.76,32,32.16,32.24,32.4,32.64,32.8,32.96,33.04,33.2,33.52,33.6,33.68,33.92,34,34.16,34.24,34.48,34.72,34.8,34.88,35.2,35.36,35.76,35.84,36.24,36.32,36.64,37.04,37.12,37.28,37.76,37.84,38,38.4,38.48,38.56,38.96,39.04,39.2,39.44,39.84,40,40.4,41.2,41.28,41.76,41.92,42,42.56,42.8,43.2,43.44,43.68,43.84,44,45.68,46.32,47.28,47.36,47.92,48,48.96,51.84,53.2,55.52],
    "sexllbm09525":[4,4.2,5,5.4,5.6,5.8,6,6.2,6.4,6.6,6.8,7,7.2,7.4,7.6,7.8,8,8.2,8.4,8.6,8.8,9,9.2,9.4,9.6,9.8,10,10.2,10.4,10.6,10.8,11,11.2,11.4,11.6,11.8,12,12.2,12.4,12.6,12.8,13,13.2,13.4,13.6,13.8,14,14.2,14.4,14.6,14.8,15,15.4,15.6,15.8,16,16.2,16.4,16.6,16.8,17,17.2,17.4,17.6,17.8,18,18.2,18.4,18.6,18.8,19,19.2,19.4,19.6,19.8,20,20.2,20.4,20.6,20.8,21,21.2,21.4,21.6,21.8,22,22.2,22.4,22.6,22.8,23,23.2,23.4,23.6,24,24.4,24.6,24.8,25,25.4,25.8,26,26.2,26.4,26.6,26.8,27,27.2,27.4,27.6,27.8,28,28.2,28.4,28.6,29,29.6,30,30.2,30.6,31,31.4,31.6,32,32.2,33,33.2,33.8,34,34.4,34.8,35,35.2,35.6,36,36.2,36.4,37,37.2,37.6,38,38.2,38.4,38.6,38.8,39,39.2,39.6,40,40.4,40.8,41.2,41.4,42,42.4,43,43.2,43.4,43.8,44.4,45,45.4,45.6,46,46.8,47,48,48.6,49,49.2,49.6,49.8,50,50.6,51,51.4,52.2,52.4,53.2,54,55.4,56,56.4,57,58,59.2,60.8,61.2,63,63.8,64.8,67,67.2,68.6,69,73.6,77,81,82.8,85,86,88.8,90,90.8,91.4,92.6,101.4,102],
    "sma05bm10000":[8.858,10.039,11.024,11.811,13.386,14.764,15.354,16.535,17.717,17.913,19.685,21.457,23.622,24.016,25.984,27.953,28.346,29.528,30.709,32.48,33.858,38.386,41.339,44.291,59.055],
    "sma10bm10000":[19.685,22.047,23.622,24.016,25.984,27.559,28.74,30.709,31.496,33.071,35.039,36.22,37.795,38.583,39.37,39.764,41.339,42.52,43.307,45.276,47.244,47.638,49.213,50.394,51.181,51.969,53.15,53.543,55.12,55.906,58.268,59.055,62.992,66.929,67.717,70.866,73.228,76.378],
    "smt05bm10000":[6.496,7.283,7.874,8.465,8.661,8.858,9.646,9.843,10.039,10.236,10.63,10.827,11.024,11.614,11.811,12.008,12.6,12.795,12.992,13.386,13.78,13.976,14.173,14.37,14.764,15.354,15.748,16.142,16.535,16.732,16.929,17.323,17.52,17.717,17.913,18.11,18.701,18.898,19.685,20.08,20.669,21.457,21.654,22.047,22.638,23.228,23.622,24.016,24.409,24.606,24.803,25.197,25.591,25.984,26.575,27.165,27.559,28.346,28.543,29.528,30.709,31.496,32.087,33.071,33.465,33.858,35.433,37.008,38.976,39.37,42.323,43.307,43.898,44.882,47.835,51.772,53.15,54.331,56.693],
    "smt10bm10000":[10.236,12.6,14.567,15.748,16.142,17.323,17.717,19.685,20.866,21.654,22.047,23.622,24.016,24.803,25.591,25.984,27.165,27.559,28.346,29.528,30.709,31.496,31.89,33.071,33.465,34.646,35.039,35.433,35.827,36.22,37.402,37.795,38.189,38.583,39.37,39.764,41.339,42.52,43.307,43.701,44.882,45.276,47.244,47.638,48.819,49.213,51.181,51.969,53.15,54.724,55.12,55.906,56.693,57.087,57.48,59.055,61.417,62.992,63.39,66.929,68.898,70.079,70.866,74.016,77.165,88.583],
    "smt25bm10000":[4.724,5.709,6.299,6.988,7.874,8.268,9.055,9.646,10.433,10.925,11.22,11.417,12.008,12.5,12.992,13.484,14.961,16.535,18.898,19.685,21.26,23.622,25.591,30.709,36.024,37.402],
    "sma05bm12000":[8.858,10.039,11.024,11.811,13.386,14.764,15.354,16.535,17.717,17.913,19.685,21.457,23.622,24.016,25.984,27.953,28.346,29.528,30.709,32.48,33.858,38.386,41.339,44.291,59.055],
    "sma10bm12000":[19.685,22.047,23.622,24.016,25.984,27.559,28.74,30.709,31.496,33.071,35.039,36.22,37.795,38.583,39.37,39.764,41.339,42.52,43.307,45.276,47.244,47.638,49.213,50.394,51.181,51.969,53.15,53.543,55.12,55.906,58.268,59.055,62.992,66.929,67.717,70.866,73.228,76.378],
    "smt05bm12000":[6.496,7.283,7.874,8.465,8.661,8.858,9.646,9.843,10.039,10.236,10.63,10.827,11.024,11.614,11.811,12.008,12.6,12.795,12.992,13.386,13.78,13.976,14.173,14.37,14.764,15.354,15.748,16.142,16.535,16.732,16.929,17.323,17.52,17.717,17.913,18.11,18.701,18.898,19.685,20.08,20.669,21.457,21.654,22.047,22.638,23.228,23.622,24.016,24.409,24.606,24.803,25.197,25.591,25.984,26.575,27.165,27.559,28.346,28.543,29.528,30.709,31.496,32.087,33.071,33.465,33.858,35.433,37.008,38.976,39.37,42.323,43.307,43.898,44.882,47.835,51.772,53.15,54.331,56.693],
    "smt10bm12000":[10.236,12.6,14.567,15.748,16.142,17.323,17.717,19.685,20.866,21.654,22.047,23.622,24.016,24.803,25.591,25.984,27.165,27.559,28.346,29.528,30.709,31.496,31.89,33.071,33.465,34.646,35.039,35.433,35.827,36.22,37.402,37.795,38.189,38.583,39.37,39.764,41.339,42.52,43.307,43.701,44.882,45.276,47.244,47.638,48.819,49.213,51.181,51.969,53.15,54.724,55.12,55.906,56.693,57.087,57.48,59.055,61.417,62.992,63.39,66.929,68.898,70.079,70.866,74.016,77.165,88.583],
    "smt25bm12000":[4.724,5.709,6.299,6.988,7.874,8.268,9.055,9.646,10.433,10.925,11.22,11.417,12.008,12.5,12.992,13.484,14.961,16.535,18.898,19.685,21.26,23.622,25.591,30.709,36.024,37.402],
    "selllbm12700":[9.75,10.875,12.375,13.125,13.5,15,15.375,15.75,16.5,16.875,17.25,17.625,18.75,19.5,19.875,20.25,20.625,21,21.75,22.5,23.25,23.625,24,24.375,24.75,25.125,25.5,25.875,26.25,27,27.75,28.5,30,30.375,30.75,31.5,31.875,32.25,33.375,33.75,34.5,35.25,36,36.75,37.5,38.25,39,39.375,40.5,42,42.75,43.5,43.875,44.625,45,45.375,46.125,46.5,48,51,51.375,52.5,54,54.75,56.625,57,58.125,60,60.375,61.875,63,63.75,65.25,66,69.75,72,72.75,73.125,76.875,78,78.75,80.625,81.75,85.5,86.25,88.125,90,91.5,91.875,93.75,94.5,110.25,129.375],
    "smh05bm15000":[6.89,7.087,7.874,8.465,8.858,9.055,9.449,9.646,10.039,10.236,10.433,10.63,10.827,11.024,11.22,11.614,11.811,12.008,12.205,12.6,12.795,12.992,13.189,13.386,13.583,13.78,14.173,14.37,14.567,14.764,15.157,15.748,15.945,16.142,16.339,16.535,16.732,17.717,18.11,18.307,18.701,18.898,19.488,19.685,20.472,20.669,21.063,21.654,21.85,22.047,22.244,22.638,22.835,23.031,23.228,23.622,24.016,24.213,24.606,24.803,25,25.197,25.394,25.787,26.181,26.378,26.772,26.969,27.362,27.559,27.953,28.346,29.134,29.331,29.528,29.724,30.118,30.315,30.512,31.102,31.496,31.89,32.48,32.677,32.874,33.268,33.465,33.858,34.252,35.039,35.433,36.22,36.417,36.614,36.811,37.008,37.402,37.992,38.386,38.583,38.78,39.37,40.354,40.748,41.339,43.307,43.898,44.291,44.685,45.079,46.26,47.047,47.244,48.228,48.622,49.213,50,50.984,53.15,54.134,54.331,55.906,56.102,59.055,62.008,62.795,64.37,66.339,66.535,67.717,70.472,70.866,73.622,74.606,76.575,77.953,78.74,82.68,83.071,88.583,92.52,99.409,108.661,122.835,124.803,135.039,149.606],
    "sma05bm16000":[8.858,10.039,11.024,11.811,13.386,14.764,15.354,16.535,17.717,17.913,19.685,21.457,23.622,24.016,25.984,27.953,28.346,29.528,30.709,32.48,33.858,38.386,41.339,44.291,59.055],
    "sma10bm16000":[19.685,22.047,23.622,24.016,25.984,27.559,28.74,30.709,31.496,33.071,35.039,36.22,37.795,38.583,39.37,39.764,41.339,42.52,43.307,45.276,47.244,47.638,49.213,50.394,51.181,51.969,53.15,53.543,55.12,55.906,58.268,59.055,62.992,66.929,67.717,70.866,73.228,76.378],
    "smt05bm16000":[6.496,7.283,7.874,8.465,8.661,8.858,9.646,9.843,10.039,10.236,10.63,10.827,11.024,11.614,11.811,12.008,12.6,12.795,12.992,13.386,13.78,13.976,14.173,14.37,14.764,15.354,15.748,16.142,16.535,16.732,16.929,17.323,17.52,17.717,17.913,18.11,18.701,18.898,19.685,20.08,20.669,21.457,21.654,22.047,22.638,23.228,23.622,24.016,24.409,24.606,24.803,25.197,25.591,25.984,26.575,27.165,27.559,28.346,28.543,29.528,30.709,31.496,32.087,33.071,33.465,33.858,35.433,37.008,38.976,39.37,42.323,43.307,43.898,44.882,47.835,51.772,53.15,54.331,56.693],
    "smt10bm16000":[10.236,12.6,14.567,15.748,16.142,17.323,17.717,19.685,20.866,21.654,22.047,23.622,24.016,24.803,25.591,25.984,27.165,27.559,28.346,29.528,30.709,31.496,31.89,33.071,33.465,34.646,35.039,35.433,35.827,36.22,37.402,37.795,38.189,38.583,39.37,39.764,41.339,42.52,43.307,43.701,44.882,45.276,47.244,47.638,48.819,49.213,51.181,51.969,53.15,54.724,55.12,55.906,56.693,57.087,57.48,59.055,61.417,62.992,63.39,66.929,68.898,70.079,70.866,74.016,77.165,88.583],
    "sehhhbm19050":[18.5,20.5,21,22,22.5,23,24,24.5,25.5,27,28,30,30.5,31,31.5,32,33,33.5,34,35,36,37,37.5,39,39.5,40,41,41.5,42,43,44,44.5,45,45.5,46.5,48,48.5,49,49.5,51,52,52.5,53,54,55.5,56,56.5,57,58,58.5,60,60.5,61.5,63,64,64.5,65,65.5,66,67,68,70,73,75,76,77,77.5,78,80,81,82,84,85,86,87,87.5,90,95,96,98.5,100,102,104,105,110,112,113,114,117,118,125,132,132.5,134.5,135,136.5,140,146,151,155,164.5,168,170],
    "selllbm19050":[9.75,10.875,12.375,13.125,13.5,15,15.375,15.75,16.5,16.875,17.25,17.625,18.75,19.5,19.875,20.25,20.625,21,21.75,22.5,23.25,23.625,24,24.375,24.75,25.125,25.5,25.875,26.25,27,27.75,28.5,30,30.375,30.75,31.5,31.875,32.25,33.375,33.75,34.5,35.25,36,36.75,37.5,38.25,39,39.375,40.5,42,42.75,43.5,43.875,44.625,45,45.375,46.125,46.5,48,51,51.375,52.5,54,54.75,56.625,57,58.125,60,60.375,61.875,63,63.75,65.25,66,69.75,72,72.75,73.125,76.875,78,78.75,80.625,81.75,85.5,86.25,88.125,90,91.5,91.875,93.75,94.5,110.25,129.375],
    "sma05bm20000":[8.858,10.039,11.024,11.811,13.386,14.764,15.354,16.535,17.717,17.913,19.685,21.457,23.622,24.016,25.984,27.953,28.346,29.528,30.709,32.48,33.858,38.386,41.339,44.291,59.055],
    "sma10bm20000":[19.685,22.047,23.622,24.016,25.984,27.559,28.74,30.709,31.496,33.071,35.039,36.22,37.795,38.583,39.37,39.764,41.339,42.52,43.307,45.276,47.244,47.638,49.213,50.394,51.181,51.969,53.15,53.543,55.12,55.906,58.268,59.055,62.992,66.929,67.717,70.866,73.228,76.378],
    "smh08bm20000":[12.6,14.173,14.803,15.118,16.693,17.008,18.583,18.898,19.843,20.157,20.472,21.102,22.047,22.677,23.307,23.622,23.937,24.567,24.882,25.197,25.827,26.457,26.772,28.031,28.346,29.921,30.551,30.866,31.496,32.441,33.071,33.386,33.701,34.646,35.276,35.906,36.22,36.535,36.85,37.795,38.11,38.425,39.37,40.945,41.575,41.89,42.52,43.15,43.465,44.094,44.409,44.724,45.354,45.669,46.299,46.614,46.929,47.244,47.874,48.189,49.134,49.449,49.764,50.394,51.339,51.969,52.283,52.913,53.543,54.803,55.12,56.063,56.378,56.693,58.268,59.528,59.843,61.102,62.992,66.142,66.772,68.031,69.291,70.866,74.646,74.961,76.22,78.74,80.945,81.89,82.835,85.039,86.614,88.189,88.504,89.449,90.079,94.488,98.583,102.362,110.24,120,125.984,129.134,132.28,141.732,150.551,173.228,175.748,195.276],
    "smt05bm20000":[6.496,7.283,7.874,8.465,8.661,8.858,9.646,9.843,10.039,10.236,10.63,10.827,11.024,11.614,11.811,12.008,12.6,12.795,12.992,13.386,13.78,13.976,14.173,14.37,14.764,15.354,15.748,16.142,16.535,16.732,16.929,17.323,17.52,17.717,17.913,18.11,18.701,18.898,19.685,20.08,20.669,21.457,21.654,22.047,22.638,23.228,23.622,24.016,24.409,24.606,24.803,25.197,25.591,25.984,26.575,27.165,27.559,28.346,28.543,29.528,30.709,31.496,32.087,33.071,33.465,33.858,35.433,37.008,38.976,39.37,42.323,43.307,43.898,44.882,47.835,51.772,53.15,54.331,56.693],
    "smt10bm20000":[10.236,12.6,14.567,15.748,16.142,17.323,17.717,19.685,20.866,21.654,22.047,23.622,24.016,24.803,25.591,25.984,27.165,27.559,28.346,29.528,30.709,31.496,31.89,33.071,33.465,34.646,35.039,35.433,35.827,36.22,37.402,37.795,38.189,38.583,39.37,39.764,41.339,42.52,43.307,43.701,44.882,45.276,47.244,47.638,48.819,49.213,51.181,51.969,53.15,54.724,55.12,55.906,56.693,57.087,57.48,59.055,61.417,62.992,63.39,66.929,68.898,70.079,70.866,74.016,77.165,88.583],
    "sma05bm25000":[8.858,10.039,11.024,11.811,13.386,14.764,15.354,16.535,17.717,17.913,19.685,21.457,23.622,24.016,25.984,27.953,28.346,29.528,30.709,32.48,33.858,38.386,41.339,44.291,59.055],
    "sma10bm25000":[19.685,22.047,23.622,24.016,25.984,27.559,28.74,30.709,31.496,33.071,35.039,36.22,37.795,38.583,39.37,39.764,41.339,42.52,43.307,45.276,47.244,47.638,49.213,50.394,51.181,51.969,53.15,53.543,55.12,55.906,58.268,59.055,62.992,66.929,67.717,70.866,73.228,76.378],
    "smh05bm25000":[6.89,7.087,7.874,8.465,8.858,9.055,9.449,9.646,10.039,10.236,10.433,10.63,10.827,11.024,11.22,11.614,11.811,12.008,12.205,12.6,12.795,12.992,13.189,13.386,13.583,13.78,14.173,14.37,14.567,14.764,15.157,15.748,15.945,16.142,16.339,16.535,16.732,17.717,18.11,18.307,18.701,18.898,19.488,19.685,20.472,20.669,21.063,21.654,21.85,22.047,22.244,22.638,22.835,23.031,23.228,23.622,24.016,24.213,24.606,24.803,25,25.197,25.394,25.787,26.181,26.378,26.772,26.969,27.362,27.559,27.953,28.346,29.134,29.331,29.528,29.724,30.118,30.315,30.512,31.102,31.496,31.89,32.48,32.677,32.874,33.268,33.465,33.858,34.252,35.039,35.433,36.22,36.417,36.614,36.811,37.008,37.402,37.992,38.386,38.583,38.78,39.37,40.354,40.748,41.339,43.307,43.898,44.291,44.685,45.079,46.26,47.047,47.244,48.228,48.622,49.213,50,50.984,53.15,54.134,54.331,55.906,56.102,59.055,62.008,62.795,64.37,66.339,66.535,67.717,70.472,70.866,73.622,74.606,76.575,77.953,78.74,82.68,83.071,88.583,92.52,99.409,108.661,122.835,124.803,135.039,149.606],
    "smt05bm25000":[6.496,7.283,7.874,8.465,8.661,8.858,9.646,9.843,10.039,10.236,10.63,10.827,11.024,11.614,11.811,12.008,12.6,12.795,12.992,13.386,13.78,13.976,14.173,14.37,14.764,15.354,15.748,16.142,16.535,16.732,16.929,17.323,17.52,17.717,17.913,18.11,18.701,18.898,19.685,20.08,20.669,21.457,21.654,22.047,22.638,23.228,23.622,24.016,24.409,24.606,24.803,25.197,25.591,25.984,26.575,27.165,27.559,28.346,28.543,29.528,30.709,31.496,32.087,33.071,33.465,33.858,35.433,37.008,38.976,39.37,42.323,43.307,43.898,44.882,47.835,51.772,53.15,54.331,56.693],
    "smt10bm25000":[10.236,12.6,14.567,15.748,16.142,17.323,17.717,19.685,20.866,21.654,22.047,23.622,24.016,24.803,25.591,25.984,27.165,27.559,28.346,29.528,30.709,31.496,31.89,33.071,33.465,34.646,35.039,35.433,35.827,36.22,37.402,37.795,38.189,38.583,39.37,39.764,41.339,42.52,43.307,43.701,44.882,45.276,47.244,47.638,48.819,49.213,51.181,51.969,53.15,54.724,55.12,55.906,56.693,57.087,57.48,59.055,61.417,62.992,63.39,66.929,68.898,70.079,70.866,74.016,77.165,88.583],
    "sehhhbm25400":[18.5,20.5,21,22,22.5,23,24,24.5,25.5,27,28,30,30.5,31,31.5,32,33,33.5,34,35,36,37,37.5,39,39.5,40,41,41.5,42,43,44,44.5,45,45.5,46.5,48,48.5,49,49.5,51,52,52.5,53,54,55.5,56,56.5,57,58,58.5,60,60.5,61.5,63,64,64.5,65,65.5,66,67,68,70,73,75,76,77,77.5,78,80,81,82,84,85,86,87,87.5,90,95,96,98.5,100,102,104,105,110,112,113,114,117,118,125,132,132.5,134.5,135,136.5,140,146,151,155,164.5,168,170],
    "selllbm25400":[9.75,10.875,12.375,13.125,13.5,15,15.375,15.75,16.5,16.875,17.25,17.625,18.75,19.5,19.875,20.25,20.625,21,21.75,22.5,23.25,23.625,24,24.375,24.75,25.125,25.5,25.875,26.25,27,27.75,28.5,30,30.375,30.75,31.5,31.875,32.25,33.375,33.75,34.5,35.25,36,36.75,37.5,38.25,39,39.375,40.5,42,42.75,43.5,43.875,44.625,45,45.375,46.125,46.5,48,51,51.375,52.5,54,54.75,56.625,57,58.125,60,60.375,61.875,63,63.75,65.25,66,69.75,72,72.75,73.125,76.875,78,78.75,80.625,81.75,85.5,86.25,88.125,90,91.5,91.875,93.75,94.5,110.25,129.375],
    "smh08bm30000":[12.6,14.173,14.803,15.118,16.693,17.008,18.583,18.898,19.843,20.157,20.472,21.102,22.047,22.677,23.307,23.622,23.937,24.567,24.882,25.197,25.827,26.457,26.772,28.031,28.346,29.921,30.551,30.866,31.496,32.441,33.071,33.386,33.701,34.646,35.276,35.906,36.22,36.535,36.85,37.795,38.11,38.425,39.37,40.945,41.575,41.89,42.52,43.15,43.465,44.094,44.409,44.724,45.354,45.669,46.299,46.614,46.929,47.244,47.874,48.189,49.134,49.449,49.764,50.394,51.339,51.969,52.283,52.913,53.543,54.803,55.12,56.063,56.378,56.693,58.268,59.528,59.843,61.102,62.992,66.142,66.772,68.031,69.291,70.866,74.646,74.961,76.22,78.74,80.945,81.89,82.835,85.039,86.614,88.189,88.504,89.449,90.079,94.488,98.583,102.362,110.24,120,125.984,129.134,132.28,141.732,150.551,173.228,175.748,195.276],
    "sma10bm32000":[19.685,22.047,23.622,24.016,25.984,27.559,28.74,30.709,31.496,33.071,35.039,36.22,37.795,38.583,39.37,39.764,41.339,42.52,43.307,45.276,47.244,47.638,49.213,50.394,51.181,51.969,53.15,53.543,55.12,55.906,58.268,59.055,62.992,66.929,67.717,70.866,73.228,76.378],
    "smt10bm32000":[10.236,12.6,14.567,15.748,16.142,17.323,17.717,19.685,20.866,21.654,22.047,23.622,24.016,24.803,25.591,25.984,27.165,27.559,28.346,29.528,30.709,31.496,31.89,33.071,33.465,34.646,35.039,35.433,35.827,36.22,37.402,37.795,38.189,38.583,39.37,39.764,41.339,42.52,43.307,43.701,44.882,45.276,47.244,47.638,48.819,49.213,51.181,51.969,53.15,54.724,55.12,55.906,56.693,57.087,57.48,59.055,61.417,62.992,63.39,66.929,68.898,70.079,70.866,74.016,77.165,88.583],
    "sehhhbm38100":[18.5,20.5,21,22,22.5,23,24,24.5,25.5,27,28,30,30.5,31,31.5,32,33,33.5,34,35,36,37,37.5,39,39.5,40,41,41.5,42,43,44,44.5,45,45.5,46.5,48,48.5,49,49.5,51,52,52.5,53,54,55.5,56,56.5,57,58,58.5,60,60.5,61.5,63,64,64.5,65,65.5,66,67,68,70,73,75,76,77,77.5,78,80,81,82,84,85,86,87,87.5,90,95,96,98.5,100,102,104,105,110,112,113,114,117,118,125,132,132.5,134.5,135,136.5,140,146,151,155,164.5,168,170],
    "sma10bm50000":[19.685,22.047,23.622,24.016,25.984,27.559,28.74,30.709,31.496,33.071,35.039,36.22,37.795,38.583,39.37,39.764,41.339,42.52,43.307,45.276,47.244,47.638,49.213,50.394,51.181,51.969,53.15,53.543,55.12,55.906,58.268,59.055,62.992,66.929,67.717,70.866,73.228,76.378],
    "smh08bm50000":[12.6,14.173,14.803,15.118,16.693,17.008,18.583,18.898,19.843,20.157,20.472,21.102,22.047,22.677,23.307,23.622,23.937,24.567,24.882,25.197,25.827,26.457,26.772,28.031,28.346,29.921,30.551,30.866,31.496,32.441,33.071,33.386,33.701,34.646,35.276,35.906,36.22,36.535,36.85,37.795,38.11,38.425,39.37,40.945,41.575,41.89,42.52,43.15,43.465,44.094,44.409,44.724,45.354,45.669,46.299,46.614,46.929,47.244,47.874,48.189,49.134,49.449,49.764,50.394,51.339,51.969,52.283,52.913,53.543,54.803,55.12,56.063,56.378,56.693,58.268,59.528,59.843,61.102,62.992,66.142,66.772,68.031,69.291,70.866,74.646,74.961,76.22,78.74,80.945,81.89,82.835,85.039,86.614,88.189,88.504,89.449,90.079,94.488,98.583,102.362,110.24,120,125.984,129.134,132.28,141.732,150.551,173.228,175.748,195.276],
    "smt10bm50000":[10.236,12.6,14.567,15.748,16.142,17.323,17.717,19.685,20.866,21.654,22.047,23.622,24.016,24.803,25.591,25.984,27.165,27.559,28.346,29.528,30.709,31.496,31.89,33.071,33.465,34.646,35.039,35.433,35.827,36.22,37.402,37.795,38.189,38.583,39.37,39.764,41.339,42.52,43.307,43.701,44.882,45.276,47.244,47.638,48.819,49.213,51.181,51.969,53.15,54.724,55.12,55.906,56.693,57.087,57.48,59.055,61.417,62.992,63.39,66.929,68.898,70.079,70.866,74.016,77.165,88.583],
    "sehhhbm50800":[18.5,20.5,21,22,22.5,23,24,24.5,25.5,27,28,30,30.5,31,31.5,32,33,33.5,34,35,36,37,37.5,39,39.5,40,41,41.5,42,43,44,44.5,45,45.5,46.5,48,48.5,49,49.5,51,52,52.5,53,54,55.5,56,56.5,57,58,58.5,60,60.5,61.5,63,64,64.5,65,65.5,66,67,68,70,73,75,76,77,77.5,78,80,81,82,84,85,86,87,87.5,90,95,96,98.5,100,102,104,105,110,112,113,114,117,118,125,132,132.5,134.5,135,136.5,140,146,151,155,164.5,168,170],
    "sehhhbm76200":[18.5,20.5,21,22,22.5,23,24,24.5,25.5,27,28,30,30.5,31,31.5,32,33,33.5,34,35,36,37,37.5,39,39.5,40,41,41.5,42,43,44,44.5,45,45.5,46.5,48,48.5,49,49.5,51,52,52.5,53,54,55.5,56,56.5,57,58,58.5,60,60.5,61.5,63,64,64.5,65,65.5,66,67,68,70,73,75,76,77,77.5,78,80,81,82,84,85,86,87,87.5,90,95,96,98.5,100,102,104,105,110,112,113,114,117,118,125,132,132.5,134.5,135,136.5,140,146,151,155,164.5,168,170],
    "smh08bm85000":[12.6,14.173,14.803,15.118,16.693,17.008,18.583,18.898,19.843,20.157,20.472,21.102,22.047,22.677,23.307,23.622,23.937,24.567,24.882,25.197,25.827,26.457,26.772,28.031,28.346,29.921,30.551,30.866,31.496,32.441,33.071,33.386,33.701,34.646,35.276,35.906,36.22,36.535,36.85,37.795,38.11,38.425,39.37,40.945,41.575,41.89,42.52,43.15,43.465,44.094,44.409,44.724,45.354,45.669,46.299,46.614,46.929,47.244,47.874,48.189,49.134,49.449,49.764,50.394,51.339,51.969,52.283,52.913,53.543,54.803,55.12,56.063,56.378,56.693,58.268,59.528,59.843,61.102,62.992,66.142,66.772,68.031,69.291,70.866,74.646,74.961,76.22,78.74,80.945,81.89,82.835,85.039,86.614,88.189,88.504,89.449,90.079,94.488,98.583,102.362,110.24,120,125.984,129.134,132.28,141.732,150.551,173.228,175.748,195.276],
};

var availablePitchLengthsMetric = {
    "semxlbe0125":[61,67.1,71.1,73.2,79.2,81.3,83.3,85.3,89.4,91.4,93.5,95.5,97.5,99.6,101.6,103.6,105.7,107.7,109.7,111.8,113.8,115.8,117.9,119.9,121.9,124,126,128,130,132.1,136.1,138.2,140.2,142.2,144.3,146.3,148.3,150.4,152.4,154.4,156.5,158.5,160.5,162.6,164.6,166.6,168.7,170.7,172.7,174.8,176.8,178.8,180.8,182.9,184.9,186.9,189,191,193,197.1,199.1,201.2,203.2,205.2,207.3,209.3,211.3,213.4,215.4,217.4,219.5,221.5,223.5,227.6,229.6,231.6,233.7,237.7,239.8,241.8,243.8,247.9,249.9,252,254,256,258.1,260.1,262.1,264.2,266.2,268.2,272.3,274.3,276.4,278.4,280.4,282.4,284.5,288.5,292.6,294.6,296.7,298.7,300.7,302.8,304.8,306.8,310.9,312.9,315,317,321.1,323.1,325.1,329.2,331.2,333.2,335.3,337.3,339.3,343.4,345.4,347.5,355.6,359.7,365.8,373.9,375.9,378,382,386.1,390.1,394.2,396.2,398.3,406.4,408.4,410.5,414.5,416.6,418.6,422.7,426.7,430.8,436.9,438.9,447,449.1,451.1,455.2,457.2,459.2,463.3,465.3,467.4,471.4,473.5,475.5,477.5,479.6,485.6,487.7,493.8,497.8,503.9,506,508,510,514.1,518.2,520.2,528.3,532.4,538.5,542.5,544.6,548.6,550.7,554.7,558.8,564.9,569,579.1,585.2,589.3,599.4,603.5,605.5,609.6,619.8,625.9,629.9,634,640.1,646.2,650.2,656.3,658.4,662.4,666.5,670.6,674.6,678.7,680.7,682.8,684.8,688.8,690.9,694.9,697,705.1,711.2,719.3,721.4,723.4,725.4,727.5,729.5,731.5,739.6,741.7,751.8,753.9,755.9,772.2,788.4,792.5,806.7,812.8,816.9,818.9,823,829.1,833.1,837.2,839.2,843.3,851.4,853.4,855.5,861.6,863.6,867.7,869.7,875.8,881.9,883.9,886,894.1,898.1,908.3,910.3,920.5,922.5,930.7,940.8,942.8,946.9,959.1,961.1,965.2,975.4,977.4,979.4,989.6,991.6,995.7,1001.8,1011.9,1016,1026.2,1046.5,1048.5,1060.7,1064.8,1066.8,1081,1087.1,1097.3,1103.4,1109.5,1113.5,1117.6,1160.3,1176.5,1200.9,1202.9,1217.2,1219.2,1243.6,1316.7,1351.3,1410.2],
    "sma05be0236":[225,255,280,300,340,375,390,420,450,455,500,545,600,610,660,710,720,750,780,825,860,975,1050,1125,1500],
    "smh03be0236":[87,102,105,108,111,117,120,123,126,129,132,141,144,147,150,153,156,159,165,168,171,174,177,180,183,186,189,192,195,198,201,204,207,210,213,216,219,222,225,228,234,237,240,246,249,252,255,258,261,264,267,270,276,279,282,285,288,291,294,297,300,303,306,309,312,315,318,324,327,330,333,336,339,342,345,351,357,360,363,366,369,372,375,381,384,387,390,393,396,399,402,405,411,417,420,423,426,432,435,438,444,447,459,462,465,468,471,474,477,480,483,486,489,492,495,501,504,510,513,516,519,522,525,528,531,537,549,552,558,564,570,573,576,579,582,585,591,594,597,600,606,609,612,615,627,633,639,645,648,654,657,663,669,672,675,681,684,687,690,693,696,702,705,708,711,720,723,732,735,738,750,753,783,795,804,816,822,825,837,843,858,861,873,882,888,891,900,915,936,945,951,960,981,1002,1026,1035,1038,1041,1050,1056,1062,1068,1071,1080,1110,1125,1155,1176,1188,1191,1227,1245,1260,1263,1335,1500,1512,1530,1569,1587,1800,1863,1926,1956,2004],
    "smt05be0236":[165,185,200,215,220,225,245,250,255,260,270,275,280,295,300,305,320,325,330,340,350,355,360,365,375,390,400,410,420,425,430,440,445,450,455,460,475,480,500,510,525,545,550,560,575,590,600,610,620,625,630,640,650,660,675,690,700,720,725,750,780,800,815,840,850,860,900,940,990,1000,1075,1100,1115,1140,1215,1315,1350,1380,1440],
    "smt25be0236":[120,145,160,177.5,200,210,230,245,265,277.5,285,290,305,317.5,330,342.5,380,420,480,500,540,600,650,780,915,950],
    "semxlbe0250":[61,67.1,71.1,73.2,79.2,81.3,83.3,85.3,89.4,91.4,93.5,95.5,97.5,99.6,101.6,103.6,105.7,107.7,109.7,111.8,113.8,115.8,117.9,119.9,121.9,124,126,128,130,132.1,136.1,138.2,140.2,142.2,144.3,146.3,148.3,150.4,152.4,154.4,156.5,158.5,160.5,162.6,164.6,166.6,168.7,170.7,172.7,174.8,176.8,178.8,180.8,182.9,184.9,186.9,189,191,193,197.1,199.1,201.2,203.2,205.2,207.3,209.3,211.3,213.4,215.4,217.4,219.5,221.5,223.5,227.6,229.6,231.6,233.7,237.7,239.8,241.8,243.8,247.9,249.9,252,254,256,258.1,260.1,262.1,264.2,266.2,268.2,272.3,274.3,276.4,278.4,280.4,282.4,284.5,288.5,292.6,294.6,296.7,298.7,300.7,302.8,304.8,306.8,310.9,312.9,315,317,321.1,323.1,325.1,329.2,331.2,333.2,335.3,337.3,339.3,343.4,345.4,347.5,355.6,359.7,365.8,373.9,375.9,378,382,386.1,390.1,394.2,396.2,398.3,406.4,408.4,410.5,414.5,416.6,418.6,422.7,426.7,430.8,436.9,438.9,449.1,451.1,455.2,457.2,459.2,463.3,465.3,467.4,471.4,473.5,475.5,477.5,479.6,485.6,487.7,493.8,497.8,503.9,506,508,510,514.1,518.2,520.2,528.3,532.4,538.5,542.5,544.6,548.6,550.7,554.7,558.8,564.9,569,579.1,585.2,589.3,599.4,603.5,605.5,609.6,619.8,625.9,629.9,634,640.1,646.2,650.2,656.3,658.4,662.4,666.5,670.6,674.6,678.7,680.7,682.8,684.8,688.8,690.9,694.9,697,705.1,711.2,719.3,721.4,723.4,725.4,727.5,729.5,731.5,739.6,741.7,751.8,753.9,755.9,772.2,788.4,792.5,806.7,812.8,816.9,818.9,823,829.1,833.1,837.2,839.2,843.3,851.4,853.4,855.5,861.6,863.6,867.7,869.7,875.8,881.9,883.9,886,894.1,898.1,908.3,910.3,920.5,922.5,930.7,940.8,942.8,946.9,959.1,961.1,965.2,975.4,977.4,979.4,989.6,991.6,995.7,1001.8,1011.9,1016,1026.2,1046.5,1048.5,1060.7,1064.8,1066.8,1081,1087.1,1097.3,1103.4,1109.5,1113.5,1117.6,1160.3,1176.5,1200.9,1202.9,1217.2,1219.2,1243.6,1316.7,1351.3,1410.2],
    "sexllbe0250":[101.6,106.7,127,137.2,142.2,147.3,152.4,157.5,162.6,167.6,172.7,177.8,182.9,188,193,198.1,203.2,208.3,213.4,218.4,223.5,228.6,233.7,238.8,243.8,248.9,254,259.1,264.2,269.2,274.3,279.4,284.5,289.6,294.6,299.7,304.8,309.9,315,320,325.1,330.2,335.3,340.4,345.4,350.5,355.6,360.7,365.8,370.8,375.9,381,386.1,391.2,396.2,401.3,406.4,411.5,416.6,421.6,426.7,431.8,436.9,442,447,452.1,457.2,462.3,467.4,472.4,477.5,482.6,487.7,492.8,497.8,502.9,508,513.1,518.2,523.2,528.3,533.4,538.5,543.6,548.6,553.7,558.8,563.9,569,574,579.1,584.2,589.3,594.4,599.4,609.6,619.8,624.8,629.9,635,645.2,655.3,660.4,665.5,670.6,675.6,680.7,685.8,690.9,696,701,706.1,711.2,716.3,721.4,726.4,736.6,751.8,762,767.1,777.2,787.4,797.6,802.6,812.8,817.9,838.2,843.3,858.5,863.6,873.8,883.9,889,894.1,904.2,914.4,919.5,924.6,939.8,944.9,955,965.2,970.3,975.4,980.4,985.5,990.6,995.7,1005.8,1016,1026.2,1036.3,1046.5,1051.6,1066.8,1077,1092.2,1097.3,1102.4,1112.5,1127.8,1143,1153.2,1158.2,1168.4,1188.7,1193.8,1219.2,1234.4,1244.6,1249.7,1259.8,1264.9,1270,1285.2,1295.4,1305.6,1325.9,1331,1351.3,1371.6,1407.2,1422.4,1432.6,1447.8,1473.2,1503.7,1544.3,1554.5,1600.2,1620.5,1645.9,1701.8,1706.9,1742.4,1752.6,1869.4,1955.8,2057.4,2103.1,2159,2184.4,2255.5,2286,2306.3,2321.6,2352,2575.6,2590.8],
    "smh03be0354":[87,102,105,108,111,117,120,123,126,129,132,141,144,147,150,153,156,159,165,168,171,174,177,180,183,186,189,192,195,198,201,204,207,210,213,216,219,222,225,228,234,237,240,246,249,252,255,258,261,264,267,270,276,279,282,285,288,291,294,297,300,303,306,309,312,315,318,324,327,330,333,336,339,342,345,351,357,360,363,366,369,372,375,381,384,387,390,393,396,399,402,405,411,417,420,423,426,432,435,438,444,447,459,462,465,468,471,474,477,480,483,486,489,492,495,501,504,510,513,516,519,522,525,528,531,537,549,552,558,564,570,573,576,579,582,585,591,594,597,600,606,609,612,615,627,633,639,645,648,654,657,663,669,672,675,681,684,687,690,693,696,702,705,708,711,720,723,732,735,738,750,753,783,795,804,816,822,825,837,843,858,861,873,882,888,891,900,915,936,945,951,960,981,1002,1026,1035,1038,1041,1050,1056,1062,1068,1071,1080,1110,1125,1155,1176,1188,1191,1227,1245,1260,1263,1335,1500,1512,1530,1569,1587,1800,1863,1926,1956,2004],
    "smh05be0354":[175,180,200,215,225,230,240,245,255,260,265,270,275,280,285,295,300,305,310,320,325,330,335,340,345,350,360,365,370,375,385,400,405,410,415,420,425,450,460,465,475,480,495,500,520,525,535,550,555,560,565,575,580,585,590,600,610,615,625,630,635,640,645,655,665,670,680,685,695,700,710,720,740,745,750,755,765,770,775,790,800,810,825,830,835,845,850,860,870,890,900,920,925,930,935,940,950,965,975,980,985,1000,1025,1035,1050,1100,1115,1125,1135,1145,1175,1195,1200,1225,1235,1250,1270,1295,1350,1375,1380,1420,1425,1500,1575,1595,1635,1685,1690,1720,1790,1800,1870,1895,1945,1980,2000,2100,2110,2250,2350,2525,2760,3120,3170,3430,3800],
    "semxlbe0375":[61,67.1,71.1,73.2,79.2,81.3,83.3,85.3,89.4,91.4,93.5,95.5,97.5,99.6,101.6,103.6,105.7,107.7,109.7,111.8,113.8,115.8,117.9,119.9,121.9,124,126,128,130,132.1,136.1,138.2,140.2,142.2,144.3,146.3,148.3,150.4,152.4,154.4,156.5,158.5,160.5,162.6,164.6,166.6,168.7,170.7,172.7,174.8,176.8,178.8,180.8,182.9,184.9,186.9,189,191,193,197.1,199.1,201.2,203.2,205.2,207.3,209.3,211.3,213.4,215.4,217.4,219.5,221.5,223.5,227.6,229.6,231.6,233.7,237.7,239.8,241.8,243.8,247.9,249.9,252,254,256,258.1,260.1,262.1,264.2,266.2,268.2,272.3,274.3,276.4,278.4,280.4,282.4,284.5,288.5,292.6,294.6,296.7,298.7,300.7,302.8,304.8,306.8,310.9,312.9,315,317,321.1,323.1,325.1,329.2,331.2,333.2,335.3,337.3,339.3,343.4,345.4,347.5,355.6,359.7,365.8,373.9,375.9,378,382,386.1,390.1,394.2,396.2,398.3,406.4,408.4,410.5,414.5,416.6,418.6,422.7,426.7,430.8,436.9,438.9,447,449.1,451.1,455.2,457.2,459.2,463.3,465.3,467.4,471.4,473.5,475.5,477.5,479.6,485.6,487.7,493.8,497.8,503.9,506,508,510,514.1,518.2,520.2,528.3,532.4,538.5,542.5,544.6,548.6,550.7,554.7,558.8,564.9,569,579.1,585.2,589.3,599.4,603.5,605.5,609.6,619.8,625.9,629.9,634,640.1,646.2,650.2,656.3,658.4,662.4,666.5,670.6,674.6,678.7,680.7,682.8,684.8,688.8,690.9,694.9,697,705.1,711.2,719.3,721.4,723.4,725.4,727.5,729.5,731.5,739.6,741.7,751.8,753.9,755.9,772.2,788.4,792.5,806.7,812.8,816.9,818.9,823,829.1,833.1,837.2,839.2,843.3,851.4,853.4,855.5,861.6,863.6,867.7,869.7,875.8,881.9,883.9,886,894.1,898.1,908.3,910.3,920.5,922.5,930.7,940.8,942.8,946.9,959.1,961.1,965.2,975.4,977.4,979.4,989.6,991.6,995.7,1001.8,1011.9,1016,1026.2,1046.5,1048.5,1060.7,1064.8,1066.8,1081,1087.1,1097.3,1103.4,1109.5,1113.5,1117.6,1160.3,1176.5,1200.9,1202.9,1217.2,1219.2,1243.6,1316.7,1351.3,1410.2],
    "sexllbe0375":[101.6,106.7,127,137.2,142.2,147.3,152.4,157.5,162.6,167.6,172.7,177.8,182.9,188,193,198.1,203.2,208.3,213.4,218.4,223.5,228.6,233.7,238.8,243.8,248.9,254,259.1,264.2,269.2,274.3,279.4,284.5,289.6,294.6,299.7,304.8,309.9,315,320,325.1,330.2,335.3,340.4,345.4,350.5,355.6,360.7,365.8,370.8,375.9,381,391.2,396.2,401.3,406.4,411.5,416.6,421.6,426.7,431.8,436.9,442,447,452.1,457.2,462.3,467.4,472.4,477.5,482.6,487.7,492.8,497.8,502.9,508,513.1,518.2,523.2,528.3,533.4,538.5,543.6,548.6,553.7,558.8,563.9,569,574,579.1,584.2,589.3,594.4,599.4,609.6,619.8,624.8,629.9,635,645.2,655.3,660.4,665.5,670.6,675.6,680.7,685.8,690.9,696,701,706.1,711.2,716.3,721.4,726.4,736.6,751.8,762,767.1,777.2,787.4,797.6,802.6,812.8,817.9,838.2,843.3,858.5,863.6,873.8,883.9,889,894.1,904.2,914.4,919.5,924.6,939.8,944.9,955,965.2,970.3,975.4,980.4,985.5,990.6,995.7,1005.8,1016,1026.2,1036.3,1046.5,1051.6,1066.8,1077,1092.2,1097.3,1102.4,1112.5,1127.8,1143,1153.2,1158.2,1168.4,1188.7,1193.8,1219.2,1234.4,1244.6,1249.7,1259.8,1264.9,1270,1285.2,1295.4,1305.6,1325.9,1331,1351.3,1371.6,1407.2,1422.4,1432.6,1447.8,1473.2,1503.7,1544.3,1554.5,1600.2,1620.5,1645.9,1701.8,1706.9,1742.4,1752.6,1869.4,1955.8,2057.4,2103.1,2159,2184.4,2255.5,2286,2306.3,2321.6,2352,2575.6,2590.8],
    "sma05be0394":[225,255,280,300,340,375,390,420,450,455,500,545,600,610,660,710,720,750,780,825,860,975,1050,1125,1500],
    "sma10be0394":[500,560,600,610,660,700,730,780,800,840,890,920,960,980,1000,1010,1050,1080,1100,1150,1200,1210,1250,1280,1300,1320,1350,1360,1400,1420,1480,1500,1600,1700,1720,1800,1860,1940],
    "smt05be0394":[165,185,200,215,220,225,245,250,255,260,270,275,280,295,300,305,320,325,330,340,350,355,360,365,375,390,400,410,420,425,430,440,445,450,455,460,475,480,500,510,525,545,550,560,575,590,600,610,620,625,630,640,650,660,675,690,700,720,725,750,780,800,815,840,850,860,900,940,990,1000,1075,1100,1115,1140,1215,1315,1350,1380,1440],
    "smt10be0394":[260,320,370,400,410,440,450,500,530,550,560,600,610,630,650,660,690,700,720,750,780,800,810,840,850,880,890,900,910,920,950,960,970,980,1000,1010,1050,1080,1100,1110,1140,1150,1200,1210,1240,1250,1300,1320,1350,1390,1400,1420,1440,1450,1460,1500,1560,1600,1610,1700,1750,1780,1800,1880,1960,2250],
    "smt25be0394":[120,145,160,177.5,200,210,230,245,265,277.5,285,290,305,317.5,330,342.5,380,420,480,500,540,600,650,780,915,950],
    "sma05be0472":[225,255,280,300,340,375,390,420,450,455,500,545,600,610,660,710,720,750,780,825,860,975,1050,1125,1500],
    "sma10be0472":[500,560,600,610,660,700,730,780,800,840,890,920,960,980,1000,1010,1050,1080,1100,1150,1200,1210,1250,1280,1300,1320,1350,1360,1400,1420,1480,1500,1600,1700,1720,1800,1860,1940],
    "smt05be0472":[165,185,200,215,220,225,245,250,255,260,270,275,280,295,300,305,320,325,330,340,350,355,360,365,375,390,400,410,420,425,430,440,445,450,455,460,475,480,500,510,525,545,550,560,575,590,600,610,620,625,630,640,650,660,675,690,700,720,725,750,780,800,815,840,850,860,900,940,990,1000,1075,1100,1115,1140,1215,1315,1350,1380,1440],
    "smt10be0472":[260,320,370,400,410,440,450,500,530,550,560,600,610,630,650,660,690,700,720,750,780,800,810,840,850,880,890,900,910,920,950,960,970,980,1000,1010,1050,1080,1100,1110,1140,1150,1200,1210,1240,1250,1300,1320,1350,1390,1400,1420,1440,1450,1460,1500,1560,1600,1610,1700,1750,1780,1800,1880,1960,2250],
    "smt25be0472":[120,145,160,177.5,200,210,230,245,265,277.5,285,290,305,317.5,330,342.5,380,420,480,500,540,600,650,780,915,950],
    "selllbe0500":[247.7,276.2,314.3,333.4,342.9,381,390.5,400.1,419.1,428.6,438.2,447.7,476.3,495.3,504.8,514.4,523.9,533.4,552.5,571.5,590.6,600.1,609.6,619.1,628.7,638.2,647.7,657.2,666.8,685.8,704.9,723.9,762,771.5,781.1,800.1,809.6,819.2,847.7,857.3,876.3,895.4,914.4,933.5,952.5,971.6,990.6,1000.1,1028.7,1066.8,1085.9,1104.9,1114.4,1133.5,1143,1152.5,1171.6,1181.1,1219.2,1295.4,1304.9,1333.5,1371.6,1390.7,1438.3,1447.8,1476.4,1524,1533.5,1571.6,1600.2,1619.3,1657.4,1676.4,1771.7,1828.8,1847.9,1857.4,1952.6,1981.2,2000.3,2047.9,2076.5,2171.7,2190.8,2238.4,2286,2324.1,2333.6,2381.3,2400.3,2800.4,3286.1],
    "smh05be0590":[175,180,200,215,225,230,240,245,255,260,265,270,275,280,285,295,300,305,310,320,325,330,335,340,345,350,360,365,370,375,385,400,405,410,415,420,425,450,460,465,475,480,495,500,520,525,535,550,555,560,565,575,580,585,590,600,610,615,625,630,635,640,645,655,665,670,680,685,695,700,710,720,740,745,750,755,765,770,775,790,800,810,825,830,835,845,850,860,870,890,900,920,925,930,935,940,950,965,975,980,985,1000,1025,1035,1050,1100,1115,1125,1135,1145,1175,1195,1200,1225,1235,1250,1270,1295,1350,1375,1380,1420,1425,1500,1575,1595,1635,1685,1690,1720,1790,1800,1870,1895,1945,1980,2000,2100,2110,2250,2350,2525,2760,3120,3170,3430,3800],
    "sma05be0630":[225,255,280,300,340,375,390,420,450,455,500,545,600,610,660,710,720,750,780,825,860,975,1050,1125,1500],
    "sma10be0630":[500,560,600,610,660,700,730,780,800,840,890,920,960,980,1000,1010,1050,1080,1100,1150,1200,1210,1250,1280,1300,1320,1350,1360,1400,1420,1480,1500,1600,1700,1720,1800,1860,1940],
    "smt05be0630":[165,185,200,215,220,225,245,250,255,260,270,275,280,295,300,305,320,325,330,340,350,355,360,365,375,390,400,410,420,425,430,440,445,450,455,460,475,480,500,510,525,545,550,560,575,590,600,610,620,625,630,640,650,660,675,690,700,720,725,750,780,800,815,840,850,860,900,940,990,1000,1075,1100,1115,1140,1215,1315,1350,1380,1440],
    "smt10be0630":[260,320,370,400,410,440,450,500,530,550,560,600,610,630,650,660,690,700,720,750,780,800,810,840,850,880,890,900,910,920,950,960,970,980,1000,1010,1050,1080,1100,1110,1140,1150,1200,1210,1240,1250,1300,1320,1350,1390,1400,1420,1440,1450,1460,1500,1560,1600,1610,1700,1750,1780,1800,1880,1960,2250],
    "sehhhbe0750":[469.9,520.7,533.4,558.8,571.5,584.2,609.6,622.3,647.7,685.8,711.2,762,774.7,787.4,800.1,812.8,838.2,850.9,863.6,889,914.4,939.8,952.5,990.6,1003.3,1016,1041.4,1054.1,1066.8,1092.2,1117.6,1130.3,1143,1155.7,1181.1,1219.2,1231.9,1244.6,1257.3,1295.4,1320.8,1333.5,1346.2,1371.6,1409.7,1422.4,1435.1,1447.8,1473.2,1485.9,1524,1536.7,1562.1,1600.2,1625.6,1638.3,1651,1663.7,1676.4,1701.8,1727.2,1778,1854.2,1905,1930.4,1955.8,1968.5,1981.2,2032,2057.4,2082.8,2133.6,2159,2184.4,2209.8,2222.5,2286,2413,2438.4,2501.9,2540,2590.8,2641.6,2667,2794,2844.8,2870.2,2895.6,2971.8,2997.2,3175,3352.8,3365.5,3416.3,3429,3467.1,3556,3708.4,3835.4,3937,4178.3,4267.2,4318],
    "selllbe0750":[247.7,276.2,314.3,333.4,342.9,381,390.5,400.1,419.1,428.6,438.2,447.7,476.3,495.3,504.8,514.4,523.9,533.4,552.5,571.5,590.6,600.1,609.6,619.1,628.7,638.2,647.7,657.2,666.8,685.8,704.9,723.9,762,771.5,781.1,800.1,809.6,819.2,847.7,857.3,876.3,895.4,914.4,933.5,952.5,971.6,990.6,1000.1,1028.7,1066.8,1085.9,1104.9,1114.4,1133.5,1143,1152.5,1171.6,1181.1,1219.2,1295.4,1304.9,1333.5,1371.6,1390.7,1438.3,1447.8,1476.4,1524,1533.5,1571.6,1600.2,1619.3,1657.4,1676.4,1771.7,1828.8,1847.9,1857.4,1952.6,1981.2,2000.3,2047.9,2076.5,2171.7,2190.8,2238.4,2286,2324.1,2333.6,2381.3,2400.3,2800.4,3286.1],
    "sma05be0787":[225,255,280,300,340,375,390,420,450,455,500,545,600,610,660,710,720,750,780,825,860,975,1050,1125,1500],
    "sma10be0787":[500,560,600,610,660,700,730,780,800,840,890,920,960,980,1000,1010,1050,1080,1100,1150,1200,1210,1250,1280,1300,1320,1350,1360,1400,1420,1480,1500,1600,1700,1720,1800,1860,1940],
    "smh08be0787":[320,360,376,384,424,432,472,480,504,512,520,536,560,576,592,600,608,624,632,640,656,672,680,712,720,760,776,784,800,824,840,848,856,880,896,912,920,928,936,960,968,976,1000,1040,1056,1064,1080,1096,1104,1120,1128,1136,1152,1160,1176,1184,1192,1200,1216,1224,1248,1256,1264,1280,1304,1320,1328,1344,1360,1392,1400,1424,1432,1440,1480,1512,1520,1552,1600,1680,1696,1728,1760,1800,1896,1904,1936,2000,2056,2080,2104,2160,2200,2240,2248,2272,2288,2400,2504,2600,2800,3048,3200,3280,3360,3600,3824,4400,4464,4960],
    "smt05be0787":[165,185,200,215,220,225,245,250,255,260,270,275,280,295,300,305,320,325,330,340,350,355,360,365,375,390,400,410,420,425,430,440,445,450,455,460,475,480,500,510,525,545,550,560,575,590,600,610,620,625,630,640,650,660,675,690,700,720,725,750,780,800,815,840,850,860,900,940,990,1000,1075,1100,1115,1140,1215,1315,1350,1380,1440],
    "smt10be0787":[260,320,370,400,410,440,450,500,530,550,560,600,610,630,650,660,690,700,720,750,780,800,810,840,850,880,890,900,910,920,950,960,970,980,1000,1010,1050,1080,1100,1110,1140,1150,1200,1210,1240,1250,1300,1320,1350,1390,1400,1420,1440,1450,1460,1500,1560,1600,1610,1700,1750,1780,1800,1880,1960,2250],
    "sma05be0984":[225,255,280,300,340,375,390,420,450,455,500,545,600,610,660,710,720,750,780,825,860,975,1050,1125,1500],
    "sma10be0984":[500,560,600,610,660,700,730,780,800,840,890,920,960,980,1000,1010,1050,1080,1100,1150,1200,1210,1250,1280,1300,1320,1350,1360,1400,1420,1480,1500,1600,1700,1720,1800,1860,1940],
    "smh05be0984":[175,180,200,215,225,230,240,245,255,260,265,270,275,280,285,295,300,305,310,320,325,330,335,340,345,350,360,365,370,375,385,400,405,410,415,420,425,450,460,465,475,480,495,500,520,525,535,550,555,560,565,575,580,585,590,600,610,615,625,630,635,640,645,655,665,670,680,685,695,700,710,720,740,745,750,755,765,770,775,790,800,810,825,830,835,845,850,860,870,890,900,920,925,930,935,940,950,965,975,980,985,1000,1025,1035,1050,1100,1115,1125,1135,1145,1175,1195,1200,1225,1235,1250,1270,1295,1350,1375,1380,1420,1425,1500,1575,1595,1635,1685,1690,1720,1790,1800,1870,1895,1945,1980,2000,2100,2110,2250,2350,2525,2760,3120,3170,3430,3800],
    "smt05be0984":[165,185,200,215,220,225,245,250,255,260,270,275,280,295,300,305,320,325,330,340,350,355,360,365,375,390,400,410,420,425,430,440,445,450,455,460,475,480,500,510,525,545,550,560,575,590,600,610,620,625,630,640,650,660,675,690,700,720,725,750,780,800,815,840,850,860,900,940,990,1000,1075,1100,1115,1140,1215,1315,1350,1380,1440],
    "smt10be0984":[260,320,370,400,410,440,450,500,530,550,560,600,610,630,650,660,690,700,720,750,780,800,810,840,850,880,890,900,910,920,950,960,970,980,1000,1010,1050,1080,1100,1110,1140,1150,1200,1210,1240,1250,1300,1320,1350,1390,1400,1420,1440,1450,1460,1500,1560,1600,1610,1700,1750,1780,1800,1880,1960,2250],
    "sehhhbe1000":[469.9,520.7,533.4,558.8,571.5,584.2,609.6,622.3,647.7,685.8,711.2,762,774.7,787.4,800.1,812.8,838.2,850.9,863.6,889,914.4,939.8,952.5,990.6,1003.3,1016,1041.4,1054.1,1066.8,1092.2,1117.6,1130.3,1143,1155.7,1181.1,1219.2,1231.9,1244.6,1257.3,1295.4,1320.8,1333.5,1346.2,1371.6,1409.7,1422.4,1435.1,1447.8,1473.2,1485.9,1524,1536.7,1562.1,1600.2,1625.6,1638.3,1651,1663.7,1676.4,1701.8,1727.2,1778,1854.2,1905,1930.4,1955.8,1968.5,1981.2,2032,2057.4,2082.8,2133.6,2159,2184.4,2209.8,2222.5,2286,2413,2438.4,2501.9,2540,2590.8,2641.6,2667,2794,2844.8,2870.2,2895.6,2971.8,2997.2,3175,3352.8,3365.5,3416.3,3429,3467.1,3556,3708.4,3835.4,3937,4178.3,4267.2,4318],
    "selllbe1000":[247.7,276.2,314.3,333.4,342.9,381,390.5,400.1,419.1,428.6,438.2,447.7,476.3,495.3,504.8,514.4,523.9,533.4,552.5,571.5,590.6,600.1,609.6,619.1,628.7,638.2,647.7,657.2,666.8,685.8,704.9,723.9,762,771.5,781.1,800.1,809.6,819.2,847.7,857.3,876.3,895.4,914.4,933.5,952.5,971.6,990.6,1000.1,1028.7,1066.8,1085.9,1104.9,1114.4,1133.5,1143,1152.5,1171.6,1181.1,1219.2,1295.4,1304.9,1333.5,1371.6,1390.7,1438.3,1447.8,1476.4,1524,1533.5,1571.6,1600.2,1619.3,1657.4,1676.4,1771.7,1828.8,1847.9,1857.4,1952.6,1981.2,2000.3,2047.9,2076.5,2171.7,2190.8,2238.4,2286,2324.1,2333.6,2381.3,2400.3,2800.4,3286.1],
    "smh08be1181":[320,360,376,384,424,432,472,480,504,512,520,536,560,576,592,600,608,624,632,640,656,672,680,712,720,760,776,784,800,824,840,848,856,880,896,912,920,928,936,960,968,976,1000,1040,1056,1064,1080,1096,1104,1120,1128,1136,1152,1160,1176,1184,1192,1200,1216,1224,1248,1256,1264,1280,1304,1320,1328,1344,1360,1392,1400,1424,1432,1440,1480,1512,1520,1552,1600,1680,1696,1728,1760,1800,1896,1904,1936,2000,2056,2080,2104,2160,2200,2240,2248,2272,2288,2400,2504,2600,2800,3048,3200,3280,3360,3600,3824,4400,4464,4960],
    "sma10be1260":[500,560,600,610,660,700,730,780,800,840,890,920,960,980,1000,1010,1050,1080,1100,1150,1200,1210,1250,1280,1300,1320,1350,1360,1400,1420,1480,1500,1600,1700,1720,1800,1860,1940],
    "smt10be1260":[260,320,370,400,410,440,450,500,530,550,560,600,610,630,650,660,690,700,720,750,780,800,810,840,850,880,890,900,910,920,950,960,970,980,1000,1010,1050,1080,1100,1110,1140,1150,1200,1210,1240,1250,1300,1320,1350,1390,1400,1420,1440,1450,1460,1500,1560,1600,1610,1700,1750,1780,1800,1880,1960,2250],
    "sehhhbe1500":[469.9,520.7,533.4,558.8,571.5,584.2,609.6,622.3,647.7,685.8,711.2,762,774.7,787.4,800.1,812.8,838.2,850.9,863.6,889,914.4,939.8,952.5,990.6,1003.3,1016,1041.4,1054.1,1066.8,1092.2,1117.6,1130.3,1143,1155.7,1181.1,1219.2,1231.9,1244.6,1257.3,1295.4,1320.8,1333.5,1346.2,1371.6,1409.7,1422.4,1435.1,1447.8,1473.2,1485.9,1524,1536.7,1562.1,1600.2,1625.6,1638.3,1651,1663.7,1676.4,1701.8,1727.2,1778,1854.2,1905,1930.4,1955.8,1968.5,1981.2,2032,2057.4,2082.8,2133.6,2159,2184.4,2209.8,2222.5,2286,2413,2438.4,2501.9,2540,2590.8,2641.6,2667,2794,2844.8,2870.2,2895.6,2971.8,2997.2,3175,3352.8,3365.5,3416.3,3429,3467.1,3556,3708.4,3835.4,3937,4178.3,4267.2,4318],
    "sma10be1969":[500,560,600,610,660,700,730,780,800,840,890,920,960,980,1000,1010,1050,1080,1100,1150,1200,1210,1250,1280,1300,1320,1350,1360,1400,1420,1480,1500,1600,1700,1720,1800,1860,1940],
    "smh08be1969":[320,360,376,384,424,432,472,480,504,512,520,536,560,576,592,600,608,624,632,640,656,672,680,712,720,760,776,784,800,824,840,848,856,880,896,912,920,928,936,960,968,976,1000,1040,1056,1064,1080,1096,1104,1120,1128,1136,1152,1160,1176,1184,1192,1200,1216,1224,1248,1256,1264,1280,1304,1320,1328,1344,1360,1392,1400,1424,1432,1440,1480,1512,1520,1552,1600,1680,1696,1728,1760,1800,1896,1904,1936,2000,2056,2080,2104,2160,2200,2240,2248,2272,2288,2400,2504,2600,2800,3048,3200,3280,3360,3600,3824,4400,4464,4960],
    "smt10be1969":[260,320,370,400,410,440,450,500,530,550,560,600,610,630,650,660,690,700,720,750,780,800,810,840,850,880,890,900,910,920,950,960,970,980,1000,1010,1050,1080,1100,1110,1140,1150,1200,1210,1240,1250,1300,1320,1350,1390,1400,1420,1440,1450,1460,1500,1560,1600,1610,1700,1750,1780,1800,1880,1960,2250],
    "sehhhbe2000":[469.9,520.7,533.4,558.8,571.5,584.2,609.6,622.3,647.7,685.8,711.2,762,774.7,787.4,800.1,812.8,838.2,850.9,863.6,889,914.4,939.8,952.5,990.6,1003.3,1016,1041.4,1054.1,1066.8,1092.2,1117.6,1130.3,1143,1155.7,1181.1,1219.2,1231.9,1244.6,1257.3,1295.4,1320.8,1333.5,1346.2,1371.6,1409.7,1422.4,1435.1,1447.8,1473.2,1485.9,1524,1536.7,1562.1,1600.2,1625.6,1638.3,1651,1663.7,1676.4,1701.8,1727.2,1778,1854.2,1905,1930.4,1955.8,1968.5,1981.2,2032,2057.4,2082.8,2133.6,2159,2184.4,2209.8,2222.5,2286,2413,2438.4,2501.9,2540,2590.8,2641.6,2667,2794,2844.8,2870.2,2895.6,2971.8,2997.2,3175,3352.8,3365.5,3416.3,3429,3467.1,3556,3708.4,3835.4,3937,4178.3,4267.2,4318],
    "sehhhbe3000":[469.9,520.7,533.4,558.8,571.5,584.2,609.6,622.3,647.7,685.8,711.2,762,774.7,787.4,800.1,812.8,838.2,850.9,863.6,889,914.4,939.8,952.5,990.6,1003.3,1016,1041.4,1054.1,1066.8,1092.2,1117.6,1130.3,1143,1155.7,1181.1,1219.2,1231.9,1244.6,1257.3,1295.4,1320.8,1333.5,1346.2,1371.6,1409.7,1422.4,1435.1,1447.8,1473.2,1485.9,1524,1536.7,1562.1,1600.2,1625.6,1638.3,1651,1663.7,1676.4,1701.8,1727.2,1778,1854.2,1905,1930.4,1955.8,1968.5,1981.2,2032,2057.4,2082.8,2133.6,2159,2184.4,2209.8,2222.5,2286,2413,2438.4,2501.9,2540,2590.8,2641.6,2667,2794,2844.8,2870.2,2895.6,2971.8,2997.2,3175,3352.8,3365.5,3416.3,3429,3467.1,3556,3708.4,3835.4,3937,4178.3,4267.2,4318],
    "smh08be3346":[320,360,376,384,424,432,472,480,504,512,520,536,560,576,592,600,608,624,632,640,656,672,680,712,720,760,776,784,800,824,840,848,856,880,896,912,920,928,936,960,968,976,1000,1040,1056,1064,1080,1096,1104,1120,1128,1136,1152,1160,1176,1184,1192,1200,1216,1224,1248,1256,1264,1280,1304,1320,1328,1344,1360,1392,1400,1424,1432,1440,1480,1512,1520,1552,1600,1680,1696,1728,1760,1800,1896,1904,1936,2000,2056,2080,2104,2160,2200,2240,2248,2272,2288,2400,2504,2600,2800,3048,3200,3280,3360,3600,3824,4400,4464,4960],
    "semxlbm03175":[61,67.1,71.1,73.2,79.2,81.3,83.3,85.3,89.4,91.4,93.5,95.5,97.5,99.6,101.6,103.6,105.7,107.7,109.7,111.8,113.8,115.8,117.9,119.9,121.9,124,126,128,130,132.1,136.1,138.2,140.2,142.2,144.3,146.3,148.3,150.4,152.4,154.4,156.5,158.5,160.5,162.6,164.6,166.6,168.7,170.7,172.7,174.8,176.8,178.8,180.8,182.9,184.9,186.9,189,191,193,197.1,199.1,201.2,203.2,205.2,207.3,209.3,211.3,213.4,215.4,217.4,219.5,221.5,223.5,227.6,229.6,231.6,233.7,237.7,239.8,241.8,243.8,247.9,249.9,252,254,256,258.1,260.1,262.1,264.2,266.2,268.2,272.3,274.3,276.4,278.4,280.4,282.4,284.5,288.5,292.6,294.6,296.7,298.7,300.7,302.8,304.8,306.8,310.9,312.9,315,317,321.1,323.1,325.1,329.2,331.2,333.2,335.3,337.3,339.3,343.4,345.4,347.5,355.6,359.7,365.8,373.9,375.9,378,382,386.1,390.1,394.2,396.2,398.3,406.4,408.4,410.5,414.5,416.6,418.6,422.7,426.7,430.8,436.9,438.9,447,449.1,451.1,455.2,457.2,459.2,463.3,465.3,467.4,471.4,473.5,475.5,477.5,479.6,485.6,487.7,493.8,497.8,503.9,506,508,510,514.1,518.2,520.2,528.3,532.4,538.5,542.5,544.6,548.6,550.7,554.7,558.8,564.9,569,579.1,585.2,589.3,599.4,603.5,605.5,609.6,619.8,625.9,629.9,634,640.1,646.2,650.2,656.3,658.4,662.4,666.5,670.6,674.6,678.7,680.7,682.8,684.8,688.8,690.9,694.9,697,705.1,711.2,719.3,721.4,723.4,725.4,727.5,729.5,731.5,739.6,741.7,751.8,753.9,755.9,772.2,788.4,792.5,806.7,812.8,816.9,818.9,823,829.1,833.1,837.2,839.2,843.3,851.4,853.4,855.5,861.6,863.6,867.7,869.7,875.8,881.9,883.9,886,894.1,898.1,908.3,910.3,920.5,922.5,930.7,940.8,942.8,946.9,959.1,961.1,965.2,975.4,977.4,979.4,989.6,991.6,995.7,1001.8,1011.9,1016,1026.2,1046.5,1048.5,1060.7,1064.8,1066.8,1081,1087.1,1097.3,1103.4,1109.5,1113.5,1117.6,1160.3,1176.5,1200.9,1202.9,1217.2,1219.2,1243.6,1316.7,1351.3,1410.2],
    "sma05bm06000":[225,255,280,300,340,375,390,420,450,455,500,545,600,610,660,710,720,750,780,825,860,975,1050,1125,1500],
    "smh03bm06000":[87,102,105,108,111,117,120,123,126,129,132,141,144,147,150,153,156,159,165,168,171,174,177,180,183,186,189,192,195,198,201,204,207,210,213,216,219,222,225,228,234,237,240,246,249,252,255,258,261,264,267,270,276,279,282,285,288,291,294,297,300,303,306,309,312,315,318,324,327,330,333,336,339,342,345,351,357,360,363,366,369,372,375,381,384,387,390,393,396,399,402,405,411,417,420,423,426,432,435,438,444,447,459,462,465,468,471,474,477,480,483,486,489,492,495,501,504,510,513,516,519,522,525,528,531,537,549,552,558,564,570,573,576,579,582,585,591,594,597,600,606,609,612,615,627,633,639,645,648,654,657,663,669,672,675,681,684,687,690,693,696,702,705,708,711,720,723,732,735,738,750,753,783,795,804,816,822,825,837,843,858,861,873,882,888,891,900,915,936,945,951,960,981,1002,1026,1035,1038,1041,1050,1056,1062,1068,1071,1080,1110,1125,1155,1176,1188,1191,1227,1245,1260,1263,1335,1500,1512,1530,1569,1587,1800,1863,1926,1956,2004],
    "smt05bm06000":[165,185,200,215,220,225,245,250,255,260,270,275,280,295,300,305,320,325,330,340,350,355,360,365,375,390,400,410,420,425,430,440,445,450,455,460,475,480,500,510,525,545,550,560,575,590,600,610,620,625,630,640,650,660,675,690,700,720,725,750,780,800,815,840,850,860,900,940,990,1000,1075,1100,1115,1140,1215,1315,1350,1380,1440],
    "smt25bm06000":[120,145,160,177.5,200,210,230,245,265,277.5,285,290,305,317.5,330,342.5,380,420,480,500,540,600,650,780,915,950],
    "semxlbm06350":[61,67.1,71.1,73.2,79.2,81.3,83.3,85.3,89.4,91.4,93.5,95.5,97.5,99.6,101.6,103.6,105.7,107.7,109.7,111.8,113.8,115.8,117.9,119.9,121.9,124,126,128,130,132.1,136.1,138.2,140.2,142.2,144.3,146.3,148.3,150.4,152.4,154.4,156.5,158.5,160.5,162.6,164.6,166.6,168.7,170.7,172.7,174.8,176.8,178.8,180.8,182.9,184.9,186.9,189,191,193,197.1,199.1,201.2,203.2,205.2,207.3,209.3,211.3,213.4,215.4,217.4,219.5,221.5,223.5,227.6,229.6,231.6,233.7,237.7,239.8,241.8,243.8,247.9,249.9,252,254,256,258.1,260.1,262.1,264.2,266.2,268.2,272.3,274.3,276.4,278.4,280.4,282.4,284.5,288.5,292.6,294.6,296.7,298.7,300.7,302.8,304.8,306.8,310.9,312.9,315,317,321.1,323.1,325.1,329.2,331.2,333.2,335.3,337.3,339.3,343.4,345.4,347.5,355.6,359.7,365.8,373.9,375.9,378,382,386.1,390.1,394.2,396.2,398.3,406.4,408.4,410.5,414.5,416.6,418.6,422.7,426.7,430.8,436.9,438.9,449.1,451.1,455.2,457.2,459.2,463.3,465.3,467.4,471.4,473.5,475.5,477.5,479.6,485.6,487.7,493.8,497.8,503.9,506,508,510,514.1,518.2,520.2,528.3,532.4,538.5,542.5,544.6,548.6,550.7,554.7,558.8,564.9,569,579.1,585.2,589.3,599.4,603.5,605.5,609.6,619.8,625.9,629.9,634,640.1,646.2,650.2,656.3,658.4,662.4,666.5,670.6,674.6,678.7,680.7,682.8,684.8,688.8,690.9,694.9,697,705.1,711.2,719.3,721.4,723.4,725.4,727.5,729.5,731.5,739.6,741.7,751.8,753.9,755.9,772.2,788.4,792.5,806.7,812.8,816.9,818.9,823,829.1,833.1,837.2,839.2,843.3,851.4,853.4,855.5,861.6,863.6,867.7,869.7,875.8,881.9,883.9,886,894.1,898.1,908.3,910.3,920.5,922.5,930.7,940.8,942.8,946.9,959.1,961.1,965.2,975.4,977.4,979.4,989.6,991.6,995.7,1001.8,1011.9,1016,1026.2,1046.5,1048.5,1060.7,1064.8,1066.8,1081,1087.1,1097.3,1103.4,1109.5,1113.5,1117.6,1160.3,1176.5,1200.9,1202.9,1217.2,1219.2,1243.6,1316.7,1351.3,1410.2],
    "sexllbm06350":[101.6,106.7,127,137.2,142.2,147.3,152.4,157.5,162.6,167.6,172.7,177.8,182.9,188,193,198.1,203.2,208.3,213.4,218.4,223.5,228.6,233.7,238.8,243.8,248.9,254,259.1,264.2,269.2,274.3,279.4,284.5,289.6,294.6,299.7,304.8,309.9,315,320,325.1,330.2,335.3,340.4,345.4,350.5,355.6,360.7,365.8,370.8,375.9,381,386.1,391.2,396.2,401.3,406.4,411.5,416.6,421.6,426.7,431.8,436.9,442,447,452.1,457.2,462.3,467.4,472.4,477.5,482.6,487.7,492.8,497.8,502.9,508,513.1,518.2,523.2,528.3,533.4,538.5,543.6,548.6,553.7,558.8,563.9,569,574,579.1,584.2,589.3,594.4,599.4,609.6,619.8,624.8,629.9,635,645.2,655.3,660.4,665.5,670.6,675.6,680.7,685.8,690.9,696,701,706.1,711.2,716.3,721.4,726.4,736.6,751.8,762,767.1,777.2,787.4,797.6,802.6,812.8,817.9,838.2,843.3,858.5,863.6,873.8,883.9,889,894.1,904.2,914.4,919.5,924.6,939.8,944.9,955,965.2,970.3,975.4,980.4,985.5,990.6,995.7,1005.8,1016,1026.2,1036.3,1046.5,1051.6,1066.8,1077,1092.2,1097.3,1102.4,1112.5,1127.8,1143,1153.2,1158.2,1168.4,1188.7,1193.8,1219.2,1234.4,1244.6,1249.7,1259.8,1264.9,1270,1285.2,1295.4,1305.6,1325.9,1331,1351.3,1371.6,1407.2,1422.4,1432.6,1447.8,1473.2,1503.7,1544.3,1554.5,1600.2,1620.5,1645.9,1701.8,1706.9,1742.4,1752.6,1869.4,1955.8,2057.4,2103.1,2159,2184.4,2255.5,2286,2306.3,2321.6,2352,2575.6,2590.8],
    "smh03bm09000":[87,102,105,108,111,117,120,123,126,129,132,141,144,147,150,153,156,159,165,168,171,174,177,180,183,186,189,192,195,198,201,204,207,210,213,216,219,222,225,228,234,237,240,246,249,252,255,258,261,264,267,270,276,279,282,285,288,291,294,297,300,303,306,309,312,315,318,324,327,330,333,336,339,342,345,351,357,360,363,366,369,372,375,381,384,387,390,393,396,399,402,405,411,417,420,423,426,432,435,438,444,447,459,462,465,468,471,474,477,480,483,486,489,492,495,501,504,510,513,516,519,522,525,528,531,537,549,552,558,564,570,573,576,579,582,585,591,594,597,600,606,609,612,615,627,633,639,645,648,654,657,663,669,672,675,681,684,687,690,693,696,702,705,708,711,720,723,732,735,738,750,753,783,795,804,816,822,825,837,843,858,861,873,882,888,891,900,915,936,945,951,960,981,1002,1026,1035,1038,1041,1050,1056,1062,1068,1071,1080,1110,1125,1155,1176,1188,1191,1227,1245,1260,1263,1335,1500,1512,1530,1569,1587,1800,1863,1926,1956,2004],
    "smh05bm09000":[175,180,200,215,225,230,240,245,255,260,265,270,275,280,285,295,300,305,310,320,325,330,335,340,345,350,360,365,370,375,385,400,405,410,415,420,425,450,460,465,475,480,495,500,520,525,535,550,555,560,565,575,580,585,590,600,610,615,625,630,635,640,645,655,665,670,680,685,695,700,710,720,740,745,750,755,765,770,775,790,800,810,825,830,835,845,850,860,870,890,900,920,925,930,935,940,950,965,975,980,985,1000,1025,1035,1050,1100,1115,1125,1135,1145,1175,1195,1200,1225,1235,1250,1270,1295,1350,1375,1380,1420,1425,1500,1575,1595,1635,1685,1690,1720,1790,1800,1870,1895,1945,1980,2000,2100,2110,2250,2350,2525,2760,3120,3170,3430,3800],
    "semxlbm09525":[61,67.1,71.1,73.2,79.2,81.3,83.3,85.3,89.4,91.4,93.5,95.5,97.5,99.6,101.6,103.6,105.7,107.7,109.7,111.8,113.8,115.8,117.9,119.9,121.9,124,126,128,130,132.1,136.1,138.2,140.2,142.2,144.3,146.3,148.3,150.4,152.4,154.4,156.5,158.5,160.5,162.6,164.6,166.6,168.7,170.7,172.7,174.8,176.8,178.8,180.8,182.9,184.9,186.9,189,191,193,197.1,199.1,201.2,203.2,205.2,207.3,209.3,211.3,213.4,215.4,217.4,219.5,221.5,223.5,227.6,229.6,231.6,233.7,237.7,239.8,241.8,243.8,247.9,249.9,252,254,256,258.1,260.1,262.1,264.2,266.2,268.2,272.3,274.3,276.4,278.4,280.4,282.4,284.5,288.5,292.6,294.6,296.7,298.7,300.7,302.8,304.8,306.8,310.9,312.9,315,317,321.1,323.1,325.1,329.2,331.2,333.2,335.3,337.3,339.3,343.4,345.4,347.5,355.6,359.7,365.8,373.9,375.9,378,382,386.1,390.1,394.2,396.2,398.3,406.4,408.4,410.5,414.5,416.6,418.6,422.7,426.7,430.8,436.9,438.9,447,449.1,451.1,455.2,457.2,459.2,463.3,465.3,467.4,471.4,473.5,475.5,477.5,479.6,485.6,487.7,493.8,497.8,503.9,506,508,510,514.1,518.2,520.2,528.3,532.4,538.5,542.5,544.6,548.6,550.7,554.7,558.8,564.9,569,579.1,585.2,589.3,599.4,603.5,605.5,609.6,619.8,625.9,629.9,634,640.1,646.2,650.2,656.3,658.4,662.4,666.5,670.6,674.6,678.7,680.7,682.8,684.8,688.8,690.9,694.9,697,705.1,711.2,719.3,721.4,723.4,725.4,727.5,729.5,731.5,739.6,741.7,751.8,753.9,755.9,772.2,788.4,792.5,806.7,812.8,816.9,818.9,823,829.1,833.1,837.2,839.2,843.3,851.4,853.4,855.5,861.6,863.6,867.7,869.7,875.8,881.9,883.9,886,894.1,898.1,908.3,910.3,920.5,922.5,930.7,940.8,942.8,946.9,959.1,961.1,965.2,975.4,977.4,979.4,989.6,991.6,995.7,1001.8,1011.9,1016,1026.2,1046.5,1048.5,1060.7,1064.8,1066.8,1081,1087.1,1097.3,1103.4,1109.5,1113.5,1117.6,1160.3,1176.5,1200.9,1202.9,1217.2,1219.2,1243.6,1316.7,1351.3,1410.2],
    "sexllbm09525":[101.6,106.7,127,137.2,142.2,147.3,152.4,157.5,162.6,167.6,172.7,177.8,182.9,188,193,198.1,203.2,208.3,213.4,218.4,223.5,228.6,233.7,238.8,243.8,248.9,254,259.1,264.2,269.2,274.3,279.4,284.5,289.6,294.6,299.7,304.8,309.9,315,320,325.1,330.2,335.3,340.4,345.4,350.5,355.6,360.7,365.8,370.8,375.9,381,391.2,396.2,401.3,406.4,411.5,416.6,421.6,426.7,431.8,436.9,442,447,452.1,457.2,462.3,467.4,472.4,477.5,482.6,487.7,492.8,497.8,502.9,508,513.1,518.2,523.2,528.3,533.4,538.5,543.6,548.6,553.7,558.8,563.9,569,574,579.1,584.2,589.3,594.4,599.4,609.6,619.8,624.8,629.9,635,645.2,655.3,660.4,665.5,670.6,675.6,680.7,685.8,690.9,696,701,706.1,711.2,716.3,721.4,726.4,736.6,751.8,762,767.1,777.2,787.4,797.6,802.6,812.8,817.9,838.2,843.3,858.5,863.6,873.8,883.9,889,894.1,904.2,914.4,919.5,924.6,939.8,944.9,955,965.2,970.3,975.4,980.4,985.5,990.6,995.7,1005.8,1016,1026.2,1036.3,1046.5,1051.6,1066.8,1077,1092.2,1097.3,1102.4,1112.5,1127.8,1143,1153.2,1158.2,1168.4,1188.7,1193.8,1219.2,1234.4,1244.6,1249.7,1259.8,1264.9,1270,1285.2,1295.4,1305.6,1325.9,1331,1351.3,1371.6,1407.2,1422.4,1432.6,1447.8,1473.2,1503.7,1544.3,1554.5,1600.2,1620.5,1645.9,1701.8,1706.9,1742.4,1752.6,1869.4,1955.8,2057.4,2103.1,2159,2184.4,2255.5,2286,2306.3,2321.6,2352,2575.6,2590.8],
    "sma05bm10000":[225,255,280,300,340,375,390,420,450,455,500,545,600,610,660,710,720,750,780,825,860,975,1050,1125,1500],
    "sma10bm10000":[500,560,600,610,660,700,730,780,800,840,890,920,960,980,1000,1010,1050,1080,1100,1150,1200,1210,1250,1280,1300,1320,1350,1360,1400,1420,1480,1500,1600,1700,1720,1800,1860,1940],
    "smt05bm10000":[165,185,200,215,220,225,245,250,255,260,270,275,280,295,300,305,320,325,330,340,350,355,360,365,375,390,400,410,420,425,430,440,445,450,455,460,475,480,500,510,525,545,550,560,575,590,600,610,620,625,630,640,650,660,675,690,700,720,725,750,780,800,815,840,850,860,900,940,990,1000,1075,1100,1115,1140,1215,1315,1350,1380,1440],
    "smt10bm10000":[260,320,370,400,410,440,450,500,530,550,560,600,610,630,650,660,690,700,720,750,780,800,810,840,850,880,890,900,910,920,950,960,970,980,1000,1010,1050,1080,1100,1110,1140,1150,1200,1210,1240,1250,1300,1320,1350,1390,1400,1420,1440,1450,1460,1500,1560,1600,1610,1700,1750,1780,1800,1880,1960,2250],
    "smt25bm10000":[120,145,160,177.5,200,210,230,245,265,277.5,285,290,305,317.5,330,342.5,380,420,480,500,540,600,650,780,915,950],
    "sma05bm12000":[225,255,280,300,340,375,390,420,450,455,500,545,600,610,660,710,720,750,780,825,860,975,1050,1125,1500],
    "sma10bm12000":[500,560,600,610,660,700,730,780,800,840,890,920,960,980,1000,1010,1050,1080,1100,1150,1200,1210,1250,1280,1300,1320,1350,1360,1400,1420,1480,1500,1600,1700,1720,1800,1860,1940],
    "smt05bm12000":[165,185,200,215,220,225,245,250,255,260,270,275,280,295,300,305,320,325,330,340,350,355,360,365,375,390,400,410,420,425,430,440,445,450,455,460,475,480,500,510,525,545,550,560,575,590,600,610,620,625,630,640,650,660,675,690,700,720,725,750,780,800,815,840,850,860,900,940,990,1000,1075,1100,1115,1140,1215,1315,1350,1380,1440],
    "smt10bm12000":[260,320,370,400,410,440,450,500,530,550,560,600,610,630,650,660,690,700,720,750,780,800,810,840,850,880,890,900,910,920,950,960,970,980,1000,1010,1050,1080,1100,1110,1140,1150,1200,1210,1240,1250,1300,1320,1350,1390,1400,1420,1440,1450,1460,1500,1560,1600,1610,1700,1750,1780,1800,1880,1960,2250],
    "smt25bm12000":[120,145,160,177.5,200,210,230,245,265,277.5,285,290,305,317.5,330,342.5,380,420,480,500,540,600,650,780,915,950],
    "selllbm12700":[247.7,276.2,314.3,333.4,342.9,381,390.5,400.1,419.1,428.6,438.2,447.7,476.3,495.3,504.8,514.4,523.9,533.4,552.5,571.5,590.6,600.1,609.6,619.1,628.7,638.2,647.7,657.2,666.8,685.8,704.9,723.9,762,771.5,781.1,800.1,809.6,819.2,847.7,857.3,876.3,895.4,914.4,933.5,952.5,971.6,990.6,1000.1,1028.7,1066.8,1085.9,1104.9,1114.4,1133.5,1143,1152.5,1171.6,1181.1,1219.2,1295.4,1304.9,1333.5,1371.6,1390.7,1438.3,1447.8,1476.4,1524,1533.5,1571.6,1600.2,1619.3,1657.4,1676.4,1771.7,1828.8,1847.9,1857.4,1952.6,1981.2,2000.3,2047.9,2076.5,2171.7,2190.8,2238.4,2286,2324.1,2333.6,2381.3,2400.3,2800.4,3286.1],
    "smh05bm15000":[175,180,200,215,225,230,240,245,255,260,265,270,275,280,285,295,300,305,310,320,325,330,335,340,345,350,360,365,370,375,385,400,405,410,415,420,425,450,460,465,475,480,495,500,520,525,535,550,555,560,565,575,580,585,590,600,610,615,625,630,635,640,645,655,665,670,680,685,695,700,710,720,740,745,750,755,765,770,775,790,800,810,825,830,835,845,850,860,870,890,900,920,925,930,935,940,950,965,975,980,985,1000,1025,1035,1050,1100,1115,1125,1135,1145,1175,1195,1200,1225,1235,1250,1270,1295,1350,1375,1380,1420,1425,1500,1575,1595,1635,1685,1690,1720,1790,1800,1870,1895,1945,1980,2000,2100,2110,2250,2350,2525,2760,3120,3170,3430,3800],
    "sma05bm16000":[225,255,280,300,340,375,390,420,450,455,500,545,600,610,660,710,720,750,780,825,860,975,1050,1125,1500],
    "sma10bm16000":[500,560,600,610,660,700,730,780,800,840,890,920,960,980,1000,1010,1050,1080,1100,1150,1200,1210,1250,1280,1300,1320,1350,1360,1400,1420,1480,1500,1600,1700,1720,1800,1860,1940],
    "smt05bm16000":[165,185,200,215,220,225,245,250,255,260,270,275,280,295,300,305,320,325,330,340,350,355,360,365,375,390,400,410,420,425,430,440,445,450,455,460,475,480,500,510,525,545,550,560,575,590,600,610,620,625,630,640,650,660,675,690,700,720,725,750,780,800,815,840,850,860,900,940,990,1000,1075,1100,1115,1140,1215,1315,1350,1380,1440],
    "smt10bm16000":[260,320,370,400,410,440,450,500,530,550,560,600,610,630,650,660,690,700,720,750,780,800,810,840,850,880,890,900,910,920,950,960,970,980,1000,1010,1050,1080,1100,1110,1140,1150,1200,1210,1240,1250,1300,1320,1350,1390,1400,1420,1440,1450,1460,1500,1560,1600,1610,1700,1750,1780,1800,1880,1960,2250],
    "sehhhbm19050":[469.9,520.7,533.4,558.8,571.5,584.2,609.6,622.3,647.7,685.8,711.2,762,774.7,787.4,800.1,812.8,838.2,850.9,863.6,889,914.4,939.8,952.5,990.6,1003.3,1016,1041.4,1054.1,1066.8,1092.2,1117.6,1130.3,1143,1155.7,1181.1,1219.2,1231.9,1244.6,1257.3,1295.4,1320.8,1333.5,1346.2,1371.6,1409.7,1422.4,1435.1,1447.8,1473.2,1485.9,1524,1536.7,1562.1,1600.2,1625.6,1638.3,1651,1663.7,1676.4,1701.8,1727.2,1778,1854.2,1905,1930.4,1955.8,1968.5,1981.2,2032,2057.4,2082.8,2133.6,2159,2184.4,2209.8,2222.5,2286,2413,2438.4,2501.9,2540,2590.8,2641.6,2667,2794,2844.8,2870.2,2895.6,2971.8,2997.2,3175,3352.8,3365.5,3416.3,3429,3467.1,3556,3708.4,3835.4,3937,4178.3,4267.2,4318],
    "selllbm19050":[247.7,276.2,314.3,333.4,342.9,381,390.5,400.1,419.1,428.6,438.2,447.7,476.3,495.3,504.8,514.4,523.9,533.4,552.5,571.5,590.6,600.1,609.6,619.1,628.7,638.2,647.7,657.2,666.8,685.8,704.9,723.9,762,771.5,781.1,800.1,809.6,819.2,847.7,857.3,876.3,895.4,914.4,933.5,952.5,971.6,990.6,1000.1,1028.7,1066.8,1085.9,1104.9,1114.4,1133.5,1143,1152.5,1171.6,1181.1,1219.2,1295.4,1304.9,1333.5,1371.6,1390.7,1438.3,1447.8,1476.4,1524,1533.5,1571.6,1600.2,1619.3,1657.4,1676.4,1771.7,1828.8,1847.9,1857.4,1952.6,1981.2,2000.3,2047.9,2076.5,2171.7,2190.8,2238.4,2286,2324.1,2333.6,2381.3,2400.3,2800.4,3286.1],
    "sma05bm20000":[225,255,280,300,340,375,390,420,450,455,500,545,600,610,660,710,720,750,780,825,860,975,1050,1125,1500],
    "sma10bm20000":[500,560,600,610,660,700,730,780,800,840,890,920,960,980,1000,1010,1050,1080,1100,1150,1200,1210,1250,1280,1300,1320,1350,1360,1400,1420,1480,1500,1600,1700,1720,1800,1860,1940],
    "smh08bm20000":[320,360,376,384,424,432,472,480,504,512,520,536,560,576,592,600,608,624,632,640,656,672,680,712,720,760,776,784,800,824,840,848,856,880,896,912,920,928,936,960,968,976,1000,1040,1056,1064,1080,1096,1104,1120,1128,1136,1152,1160,1176,1184,1192,1200,1216,1224,1248,1256,1264,1280,1304,1320,1328,1344,1360,1392,1400,1424,1432,1440,1480,1512,1520,1552,1600,1680,1696,1728,1760,1800,1896,1904,1936,2000,2056,2080,2104,2160,2200,2240,2248,2272,2288,2400,2504,2600,2800,3048,3200,3280,3360,3600,3824,4400,4464,4960],
    "smt05bm20000":[165,185,200,215,220,225,245,250,255,260,270,275,280,295,300,305,320,325,330,340,350,355,360,365,375,390,400,410,420,425,430,440,445,450,455,460,475,480,500,510,525,545,550,560,575,590,600,610,620,625,630,640,650,660,675,690,700,720,725,750,780,800,815,840,850,860,900,940,990,1000,1075,1100,1115,1140,1215,1315,1350,1380,1440],
    "smt10bm20000":[260,320,370,400,410,440,450,500,530,550,560,600,610,630,650,660,690,700,720,750,780,800,810,840,850,880,890,900,910,920,950,960,970,980,1000,1010,1050,1080,1100,1110,1140,1150,1200,1210,1240,1250,1300,1320,1350,1390,1400,1420,1440,1450,1460,1500,1560,1600,1610,1700,1750,1780,1800,1880,1960,2250],
    "sma05bm25000":[225,255,280,300,340,375,390,420,450,455,500,545,600,610,660,710,720,750,780,825,860,975,1050,1125,1500],
    "sma10bm25000":[500,560,600,610,660,700,730,780,800,840,890,920,960,980,1000,1010,1050,1080,1100,1150,1200,1210,1250,1280,1300,1320,1350,1360,1400,1420,1480,1500,1600,1700,1720,1800,1860,1940],
    "smh05bm25000":[175,180,200,215,225,230,240,245,255,260,265,270,275,280,285,295,300,305,310,320,325,330,335,340,345,350,360,365,370,375,385,400,405,410,415,420,425,450,460,465,475,480,495,500,520,525,535,550,555,560,565,575,580,585,590,600,610,615,625,630,635,640,645,655,665,670,680,685,695,700,710,720,740,745,750,755,765,770,775,790,800,810,825,830,835,845,850,860,870,890,900,920,925,930,935,940,950,965,975,980,985,1000,1025,1035,1050,1100,1115,1125,1135,1145,1175,1195,1200,1225,1235,1250,1270,1295,1350,1375,1380,1420,1425,1500,1575,1595,1635,1685,1690,1720,1790,1800,1870,1895,1945,1980,2000,2100,2110,2250,2350,2525,2760,3120,3170,3430,3800],
    "smt05bm25000":[165,185,200,215,220,225,245,250,255,260,270,275,280,295,300,305,320,325,330,340,350,355,360,365,375,390,400,410,420,425,430,440,445,450,455,460,475,480,500,510,525,545,550,560,575,590,600,610,620,625,630,640,650,660,675,690,700,720,725,750,780,800,815,840,850,860,900,940,990,1000,1075,1100,1115,1140,1215,1315,1350,1380,1440],
    "smt10bm25000":[260,320,370,400,410,440,450,500,530,550,560,600,610,630,650,660,690,700,720,750,780,800,810,840,850,880,890,900,910,920,950,960,970,980,1000,1010,1050,1080,1100,1110,1140,1150,1200,1210,1240,1250,1300,1320,1350,1390,1400,1420,1440,1450,1460,1500,1560,1600,1610,1700,1750,1780,1800,1880,1960,2250],
    "sehhhbm25400":[469.9,520.7,533.4,558.8,571.5,584.2,609.6,622.3,647.7,685.8,711.2,762,774.7,787.4,800.1,812.8,838.2,850.9,863.6,889,914.4,939.8,952.5,990.6,1003.3,1016,1041.4,1054.1,1066.8,1092.2,1117.6,1130.3,1143,1155.7,1181.1,1219.2,1231.9,1244.6,1257.3,1295.4,1320.8,1333.5,1346.2,1371.6,1409.7,1422.4,1435.1,1447.8,1473.2,1485.9,1524,1536.7,1562.1,1600.2,1625.6,1638.3,1651,1663.7,1676.4,1701.8,1727.2,1778,1854.2,1905,1930.4,1955.8,1968.5,1981.2,2032,2057.4,2082.8,2133.6,2159,2184.4,2209.8,2222.5,2286,2413,2438.4,2501.9,2540,2590.8,2641.6,2667,2794,2844.8,2870.2,2895.6,2971.8,2997.2,3175,3352.8,3365.5,3416.3,3429,3467.1,3556,3708.4,3835.4,3937,4178.3,4267.2,4318],
    "selllbm25400":[247.7,276.2,314.3,333.4,342.9,381,390.5,400.1,419.1,428.6,438.2,447.7,476.3,495.3,504.8,514.4,523.9,533.4,552.5,571.5,590.6,600.1,609.6,619.1,628.7,638.2,647.7,657.2,666.8,685.8,704.9,723.9,762,771.5,781.1,800.1,809.6,819.2,847.7,857.3,876.3,895.4,914.4,933.5,952.5,971.6,990.6,1000.1,1028.7,1066.8,1085.9,1104.9,1114.4,1133.5,1143,1152.5,1171.6,1181.1,1219.2,1295.4,1304.9,1333.5,1371.6,1390.7,1438.3,1447.8,1476.4,1524,1533.5,1571.6,1600.2,1619.3,1657.4,1676.4,1771.7,1828.8,1847.9,1857.4,1952.6,1981.2,2000.3,2047.9,2076.5,2171.7,2190.8,2238.4,2286,2324.1,2333.6,2381.3,2400.3,2800.4,3286.1],
    "smh08bm30000":[320,360,376,384,424,432,472,480,504,512,520,536,560,576,592,600,608,624,632,640,656,672,680,712,720,760,776,784,800,824,840,848,856,880,896,912,920,928,936,960,968,976,1000,1040,1056,1064,1080,1096,1104,1120,1128,1136,1152,1160,1176,1184,1192,1200,1216,1224,1248,1256,1264,1280,1304,1320,1328,1344,1360,1392,1400,1424,1432,1440,1480,1512,1520,1552,1600,1680,1696,1728,1760,1800,1896,1904,1936,2000,2056,2080,2104,2160,2200,2240,2248,2272,2288,2400,2504,2600,2800,3048,3200,3280,3360,3600,3824,4400,4464,4960],
    "sma10bm32000":[500,560,600,610,660,700,730,780,800,840,890,920,960,980,1000,1010,1050,1080,1100,1150,1200,1210,1250,1280,1300,1320,1350,1360,1400,1420,1480,1500,1600,1700,1720,1800,1860,1940],
    "smt10bm32000":[260,320,370,400,410,440,450,500,530,550,560,600,610,630,650,660,690,700,720,750,780,800,810,840,850,880,890,900,910,920,950,960,970,980,1000,1010,1050,1080,1100,1110,1140,1150,1200,1210,1240,1250,1300,1320,1350,1390,1400,1420,1440,1450,1460,1500,1560,1600,1610,1700,1750,1780,1800,1880,1960,2250],
    "sehhhbm38100":[469.9,520.7,533.4,558.8,571.5,584.2,609.6,622.3,647.7,685.8,711.2,762,774.7,787.4,800.1,812.8,838.2,850.9,863.6,889,914.4,939.8,952.5,990.6,1003.3,1016,1041.4,1054.1,1066.8,1092.2,1117.6,1130.3,1143,1155.7,1181.1,1219.2,1231.9,1244.6,1257.3,1295.4,1320.8,1333.5,1346.2,1371.6,1409.7,1422.4,1435.1,1447.8,1473.2,1485.9,1524,1536.7,1562.1,1600.2,1625.6,1638.3,1651,1663.7,1676.4,1701.8,1727.2,1778,1854.2,1905,1930.4,1955.8,1968.5,1981.2,2032,2057.4,2082.8,2133.6,2159,2184.4,2209.8,2222.5,2286,2413,2438.4,2501.9,2540,2590.8,2641.6,2667,2794,2844.8,2870.2,2895.6,2971.8,2997.2,3175,3352.8,3365.5,3416.3,3429,3467.1,3556,3708.4,3835.4,3937,4178.3,4267.2,4318],
    "sma10bm50000":[500,560,600,610,660,700,730,780,800,840,890,920,960,980,1000,1010,1050,1080,1100,1150,1200,1210,1250,1280,1300,1320,1350,1360,1400,1420,1480,1500,1600,1700,1720,1800,1860,1940],
    "smh08bm50000":[320,360,376,384,424,432,472,480,504,512,520,536,560,576,592,600,608,624,632,640,656,672,680,712,720,760,776,784,800,824,840,848,856,880,896,912,920,928,936,960,968,976,1000,1040,1056,1064,1080,1096,1104,1120,1128,1136,1152,1160,1176,1184,1192,1200,1216,1224,1248,1256,1264,1280,1304,1320,1328,1344,1360,1392,1400,1424,1432,1440,1480,1512,1520,1552,1600,1680,1696,1728,1760,1800,1896,1904,1936,2000,2056,2080,2104,2160,2200,2240,2248,2272,2288,2400,2504,2600,2800,3048,3200,3280,3360,3600,3824,4400,4464,4960],
    "smt10bm50000":[260,320,370,400,410,440,450,500,530,550,560,600,610,630,650,660,690,700,720,750,780,800,810,840,850,880,890,900,910,920,950,960,970,980,1000,1010,1050,1080,1100,1110,1140,1150,1200,1210,1240,1250,1300,1320,1350,1390,1400,1420,1440,1450,1460,1500,1560,1600,1610,1700,1750,1780,1800,1880,1960,2250],
    "sehhhbm50800":[469.9,520.7,533.4,558.8,571.5,584.2,609.6,622.3,647.7,685.8,711.2,762,774.7,787.4,800.1,812.8,838.2,850.9,863.6,889,914.4,939.8,952.5,990.6,1003.3,1016,1041.4,1054.1,1066.8,1092.2,1117.6,1130.3,1143,1155.7,1181.1,1219.2,1231.9,1244.6,1257.3,1295.4,1320.8,1333.5,1346.2,1371.6,1409.7,1422.4,1435.1,1447.8,1473.2,1485.9,1524,1536.7,1562.1,1600.2,1625.6,1638.3,1651,1663.7,1676.4,1701.8,1727.2,1778,1854.2,1905,1930.4,1955.8,1968.5,1981.2,2032,2057.4,2082.8,2133.6,2159,2184.4,2209.8,2222.5,2286,2413,2438.4,2501.9,2540,2590.8,2641.6,2667,2794,2844.8,2870.2,2895.6,2971.8,2997.2,3175,3352.8,3365.5,3416.3,3429,3467.1,3556,3708.4,3835.4,3937,4178.3,4267.2,4318],
    "sehhhbm76200":[469.9,520.7,533.4,558.8,571.5,584.2,609.6,622.3,647.7,685.8,711.2,762,774.7,787.4,800.1,812.8,838.2,850.9,863.6,889,914.4,939.8,952.5,990.6,1003.3,1016,1041.4,1054.1,1066.8,1092.2,1117.6,1130.3,1143,1155.7,1181.1,1219.2,1231.9,1244.6,1257.3,1295.4,1320.8,1333.5,1346.2,1371.6,1409.7,1422.4,1435.1,1447.8,1473.2,1485.9,1524,1536.7,1562.1,1600.2,1625.6,1638.3,1651,1663.7,1676.4,1701.8,1727.2,1778,1854.2,1905,1930.4,1955.8,1968.5,1981.2,2032,2057.4,2082.8,2133.6,2159,2184.4,2209.8,2222.5,2286,2413,2438.4,2501.9,2540,2590.8,2641.6,2667,2794,2844.8,2870.2,2895.6,2971.8,2997.2,3175,3352.8,3365.5,3416.3,3429,3467.1,3556,3708.4,3835.4,3937,4178.3,4267.2,4318],
    "smh08bm85000":[320,360,376,384,424,432,472,480,504,512,520,536,560,576,592,600,608,624,632,640,656,672,680,712,720,760,776,784,800,824,840,848,856,880,896,912,920,928,936,960,968,976,1000,1040,1056,1064,1080,1096,1104,1120,1128,1136,1152,1160,1176,1184,1192,1200,1216,1224,1248,1256,1264,1280,1304,1320,1328,1344,1360,1392,1400,1424,1432,1440,1480,1512,1520,1552,1600,1680,1696,1728,1760,1800,1896,1904,1936,2000,2056,2080,2104,2160,2200,2240,2248,2272,2288,2400,2504,2600,2800,3048,3200,3280,3360,3600,3824,4400,4464,4960],
};

// rules
cds.configurator.DefaultRule.add(configurator, "bm03000;sehhh");
cds.configurator.DefaultRule.add(configurator, "bm03000;selll");
cds.configurator.DefaultRule.add(configurator, "bm03000;semxl");
cds.configurator.DefaultRule.add(configurator, "bm03000;sexll");
cds.configurator.DefaultRule.add(configurator, "bm03000;sma05");
cds.configurator.DefaultRule.add(configurator, "bm03000;sma10");
cds.configurator.DefaultRule.add(configurator, "bm03000;smh03");
cds.configurator.DefaultRule.add(configurator, "bm03000;smh05");
cds.configurator.DefaultRule.add(configurator, "bm03000;smh08");
cds.configurator.DefaultRule.add(configurator, "bm03000;smt05");
cds.configurator.DefaultRule.add(configurator, "bm03000;smt10");
cds.configurator.DefaultRule.add(configurator, "bm03000;smt25");
cds.configurator.DefaultRule.add(configurator, "bm03000;tea010");
cds.configurator.DefaultRule.add(configurator, "bm03000;tea011");
cds.configurator.DefaultRule.add(configurator, "bm03000;tea023");
cds.configurator.DefaultRule.add(configurator, "bm03000;tea027");
cds.configurator.DefaultRule.add(configurator, "bm03000;tea029");
cds.configurator.DefaultRule.add(configurator, "bm03000;tea031");
cds.configurator.DefaultRule.add(configurator, "bm03000;tea033");
cds.configurator.DefaultRule.add(configurator, "bm03000;tea034");
cds.configurator.DefaultRule.add(configurator, "bm03000;tea035");
cds.configurator.DefaultRule.add(configurator, "bm03000;tea037");
cds.configurator.DefaultRule.add(configurator, "bm03000;tea038");
cds.configurator.DefaultRule.add(configurator, "bm03000;tea039");
cds.configurator.DefaultRule.add(configurator, "bm03000;tea041");
cds.configurator.DefaultRule.add(configurator, "bm03000;tea043");
cds.configurator.DefaultRule.add(configurator, "bm03000;tea046");
cds.configurator.DefaultRule.add(configurator, "bm03000;tea052");
cds.configurator.DefaultRule.add(configurator, "bm03000;tea053");
cds.configurator.DefaultRule.add(configurator, "bm03000;tea062");
cds.configurator.DefaultRule.add(configurator, "bm03000;tea063");
cds.configurator.DefaultRule.add(configurator, "bm03000;tea064");
cds.configurator.DefaultRule.add(configurator, "bm03000;tea067");
cds.configurator.DefaultRule.add(configurator, "bm03000;tea068");
cds.configurator.DefaultRule.add(configurator, "bm03000;tea070");
cds.configurator.DefaultRule.add(configurator, "bm03000;tea071");
cds.configurator.DefaultRule.add(configurator, "bm03000;tea072");
cds.configurator.DefaultRule.add(configurator, "bm03000;tea074");
cds.configurator.DefaultRule.add(configurator, "bm03000;tea075");
cds.configurator.DefaultRule.add(configurator, "bm03000;tea080");
cds.configurator.DefaultRule.add(configurator, "bm03000;tea084");
cds.configurator.DefaultRule.add(configurator, "bm03000;tea090");
cds.configurator.DefaultRule.add(configurator, "bm03000;tea096");
cds.configurator.DefaultRule.add(configurator, "bm03000;tea100");
cds.configurator.DefaultRule.add(configurator, "bm03000;tea112");
cds.configurator.DefaultRule.add(configurator, "bm03000;tea120");
cds.configurator.DefaultRule.add(configurator, "bm03000;tea126");
cds.configurator.DefaultRule.add(configurator, "bm03000;tea140");
cds.configurator.DefaultRule.add(configurator, "bm03000;tea144");
cds.configurator.DefaultRule.add(configurator, "bm03000;tea154");
cds.configurator.DefaultRule.add(configurator, "bm03000;tea168");
cds.configurator.DefaultRule.add(configurator, "bm03000;tea180");
cds.configurator.DefaultRule.add(configurator, "bm03000;tea192");
cds.configurator.DefaultRule.add(configurator, "bm03000;tea200");
cds.configurator.DefaultRule.add(configurator, "bm03000;tea216");
cds.configurator.DefaultRule.add(configurator, "bm03000;tea224");
cds.configurator.DefaultRule.add(configurator, "bm03000;teb010");
cds.configurator.DefaultRule.add(configurator, "bm03000;teb011");
cds.configurator.DefaultRule.add(configurator, "bm03000;teb023");
cds.configurator.DefaultRule.add(configurator, "bm03000;teb027");
cds.configurator.DefaultRule.add(configurator, "bm03000;teb029");
cds.configurator.DefaultRule.add(configurator, "bm03000;teb031");
cds.configurator.DefaultRule.add(configurator, "bm03000;teb033");
cds.configurator.DefaultRule.add(configurator, "bm03000;teb034");
cds.configurator.DefaultRule.add(configurator, "bm03000;teb035");
cds.configurator.DefaultRule.add(configurator, "bm03000;teb037");
cds.configurator.DefaultRule.add(configurator, "bm03000;teb038");
cds.configurator.DefaultRule.add(configurator, "bm03000;teb039");
cds.configurator.DefaultRule.add(configurator, "bm03000;teb041");
cds.configurator.DefaultRule.add(configurator, "bm03000;teb043");
cds.configurator.DefaultRule.add(configurator, "bm03000;teb046");
cds.configurator.DefaultRule.add(configurator, "bm03000;teb052");
cds.configurator.DefaultRule.add(configurator, "bm03000;teb053");
cds.configurator.DefaultRule.add(configurator, "bm03000;teb062");
cds.configurator.DefaultRule.add(configurator, "bm03000;teb063");
cds.configurator.DefaultRule.add(configurator, "bm03000;teb064");
cds.configurator.DefaultRule.add(configurator, "bm03000;teb067");
cds.configurator.DefaultRule.add(configurator, "bm03000;teb068");
cds.configurator.DefaultRule.add(configurator, "bm03000;teb070");
cds.configurator.DefaultRule.add(configurator, "bm03000;teb071");
cds.configurator.DefaultRule.add(configurator, "bm03000;teb072");
cds.configurator.DefaultRule.add(configurator, "bm03000;teb074");
cds.configurator.DefaultRule.add(configurator, "bm03000;teb075");
cds.configurator.DefaultRule.add(configurator, "bm03000;teb080");
cds.configurator.DefaultRule.add(configurator, "bm03000;teb084");
cds.configurator.DefaultRule.add(configurator, "bm03000;teb090");
cds.configurator.DefaultRule.add(configurator, "bm03000;teb096");
cds.configurator.DefaultRule.add(configurator, "bm03000;teb100");
cds.configurator.DefaultRule.add(configurator, "bm03000;teb112");
cds.configurator.DefaultRule.add(configurator, "bm03000;teb120");
cds.configurator.DefaultRule.add(configurator, "bm03000;teb126");
cds.configurator.DefaultRule.add(configurator, "bm03000;teb140");
cds.configurator.DefaultRule.add(configurator, "bm03000;teb144");
cds.configurator.DefaultRule.add(configurator, "bm03000;teb154");
cds.configurator.DefaultRule.add(configurator, "bm03000;teb168");
cds.configurator.DefaultRule.add(configurator, "bm03000;teb180");
cds.configurator.DefaultRule.add(configurator, "bm03000;teb192");
cds.configurator.DefaultRule.add(configurator, "bm03000;teb200");
cds.configurator.DefaultRule.add(configurator, "bm03000;teb216");
cds.configurator.DefaultRule.add(configurator, "bm03000;teb224");
cds.configurator.DefaultRule.add(configurator, "bm03175;sehhh");
cds.configurator.DefaultRule.add(configurator, "bm03175;selll");
cds.configurator.DefaultRule.add(configurator, "bm03175;sexll");
cds.configurator.DefaultRule.add(configurator, "bm03175;sma05");
cds.configurator.DefaultRule.add(configurator, "bm03175;sma10");
cds.configurator.DefaultRule.add(configurator, "bm03175;smh03");
cds.configurator.DefaultRule.add(configurator, "bm03175;smh05");
cds.configurator.DefaultRule.add(configurator, "bm03175;smh08");
cds.configurator.DefaultRule.add(configurator, "bm03175;smt05");
cds.configurator.DefaultRule.add(configurator, "bm03175;smt10");
cds.configurator.DefaultRule.add(configurator, "bm03175;smt25");
cds.configurator.DefaultRule.add(configurator, "bm03175;tea013");
cds.configurator.DefaultRule.add(configurator, "bm03175;tea017");
cds.configurator.DefaultRule.add(configurator, "bm03175;tea019");
cds.configurator.DefaultRule.add(configurator, "bm03175;tea023");
cds.configurator.DefaultRule.add(configurator, "bm03175;tea025");
cds.configurator.DefaultRule.add(configurator, "bm03175;tea026");
cds.configurator.DefaultRule.add(configurator, "bm03175;tea027");
cds.configurator.DefaultRule.add(configurator, "bm03175;tea029");
cds.configurator.DefaultRule.add(configurator, "bm03175;tea031");
cds.configurator.DefaultRule.add(configurator, "bm03175;tea033");
cds.configurator.DefaultRule.add(configurator, "bm03175;tea034");
cds.configurator.DefaultRule.add(configurator, "bm03175;tea035");
cds.configurator.DefaultRule.add(configurator, "bm03175;tea037");
cds.configurator.DefaultRule.add(configurator, "bm03175;tea038");
cds.configurator.DefaultRule.add(configurator, "bm03175;tea039");
cds.configurator.DefaultRule.add(configurator, "bm03175;tea041");
cds.configurator.DefaultRule.add(configurator, "bm03175;tea043");
cds.configurator.DefaultRule.add(configurator, "bm03175;tea045");
cds.configurator.DefaultRule.add(configurator, "bm03175;tea046");
cds.configurator.DefaultRule.add(configurator, "bm03175;tea050");
cds.configurator.DefaultRule.add(configurator, "bm03175;tea052");
cds.configurator.DefaultRule.add(configurator, "bm03175;tea053");
cds.configurator.DefaultRule.add(configurator, "bm03175;tea056");
cds.configurator.DefaultRule.add(configurator, "bm03175;tea062");
cds.configurator.DefaultRule.add(configurator, "bm03175;tea063");
cds.configurator.DefaultRule.add(configurator, "bm03175;tea064");
cds.configurator.DefaultRule.add(configurator, "bm03175;tea067");
cds.configurator.DefaultRule.add(configurator, "bm03175;tea068");
cds.configurator.DefaultRule.add(configurator, "bm03175;tea070");
cds.configurator.DefaultRule.add(configurator, "bm03175;tea071");
cds.configurator.DefaultRule.add(configurator, "bm03175;tea072");
cds.configurator.DefaultRule.add(configurator, "bm03175;tea074");
cds.configurator.DefaultRule.add(configurator, "bm03175;tea075");
cds.configurator.DefaultRule.add(configurator, "bm03175;tea080");
cds.configurator.DefaultRule.add(configurator, "bm03175;tea084");
cds.configurator.DefaultRule.add(configurator, "bm03175;tea090");
cds.configurator.DefaultRule.add(configurator, "bm03175;tea096");
cds.configurator.DefaultRule.add(configurator, "bm03175;tea100");
cds.configurator.DefaultRule.add(configurator, "bm03175;tea112");
cds.configurator.DefaultRule.add(configurator, "bm03175;tea120");
cds.configurator.DefaultRule.add(configurator, "bm03175;tea126");
cds.configurator.DefaultRule.add(configurator, "bm03175;tea140");
cds.configurator.DefaultRule.add(configurator, "bm03175;tea144");
cds.configurator.DefaultRule.add(configurator, "bm03175;tea154");
cds.configurator.DefaultRule.add(configurator, "bm03175;tea168");
cds.configurator.DefaultRule.add(configurator, "bm03175;tea180");
cds.configurator.DefaultRule.add(configurator, "bm03175;tea192");
cds.configurator.DefaultRule.add(configurator, "bm03175;tea200");
cds.configurator.DefaultRule.add(configurator, "bm03175;tea216");
cds.configurator.DefaultRule.add(configurator, "bm03175;tea224");
cds.configurator.DefaultRule.add(configurator, "bm03175;teb013");
cds.configurator.DefaultRule.add(configurator, "bm03175;teb017");
cds.configurator.DefaultRule.add(configurator, "bm03175;teb019");
cds.configurator.DefaultRule.add(configurator, "bm03175;teb023");
cds.configurator.DefaultRule.add(configurator, "bm03175;teb025");
cds.configurator.DefaultRule.add(configurator, "bm03175;teb026");
cds.configurator.DefaultRule.add(configurator, "bm03175;teb027");
cds.configurator.DefaultRule.add(configurator, "bm03175;teb029");
cds.configurator.DefaultRule.add(configurator, "bm03175;teb031");
cds.configurator.DefaultRule.add(configurator, "bm03175;teb033");
cds.configurator.DefaultRule.add(configurator, "bm03175;teb034");
cds.configurator.DefaultRule.add(configurator, "bm03175;teb035");
cds.configurator.DefaultRule.add(configurator, "bm03175;teb037");
cds.configurator.DefaultRule.add(configurator, "bm03175;teb038");
cds.configurator.DefaultRule.add(configurator, "bm03175;teb039");
cds.configurator.DefaultRule.add(configurator, "bm03175;teb041");
cds.configurator.DefaultRule.add(configurator, "bm03175;teb043");
cds.configurator.DefaultRule.add(configurator, "bm03175;teb045");
cds.configurator.DefaultRule.add(configurator, "bm03175;teb046");
cds.configurator.DefaultRule.add(configurator, "bm03175;teb050");
cds.configurator.DefaultRule.add(configurator, "bm03175;teb052");
cds.configurator.DefaultRule.add(configurator, "bm03175;teb053");
cds.configurator.DefaultRule.add(configurator, "bm03175;teb056");
cds.configurator.DefaultRule.add(configurator, "bm03175;teb062");
cds.configurator.DefaultRule.add(configurator, "bm03175;teb063");
cds.configurator.DefaultRule.add(configurator, "bm03175;teb064");
cds.configurator.DefaultRule.add(configurator, "bm03175;teb067");
cds.configurator.DefaultRule.add(configurator, "bm03175;teb068");
cds.configurator.DefaultRule.add(configurator, "bm03175;teb070");
cds.configurator.DefaultRule.add(configurator, "bm03175;teb071");
cds.configurator.DefaultRule.add(configurator, "bm03175;teb072");
cds.configurator.DefaultRule.add(configurator, "bm03175;teb074");
cds.configurator.DefaultRule.add(configurator, "bm03175;teb075");
cds.configurator.DefaultRule.add(configurator, "bm03175;teb080");
cds.configurator.DefaultRule.add(configurator, "bm03175;teb084");
cds.configurator.DefaultRule.add(configurator, "bm03175;teb090");
cds.configurator.DefaultRule.add(configurator, "bm03175;teb096");
cds.configurator.DefaultRule.add(configurator, "bm03175;teb100");
cds.configurator.DefaultRule.add(configurator, "bm03175;teb112");
cds.configurator.DefaultRule.add(configurator, "bm03175;teb120");
cds.configurator.DefaultRule.add(configurator, "bm03175;teb126");
cds.configurator.DefaultRule.add(configurator, "bm03175;teb140");
cds.configurator.DefaultRule.add(configurator, "bm03175;teb144");
cds.configurator.DefaultRule.add(configurator, "bm03175;teb154");
cds.configurator.DefaultRule.add(configurator, "bm03175;teb168");
cds.configurator.DefaultRule.add(configurator, "bm03175;teb180");
cds.configurator.DefaultRule.add(configurator, "bm03175;teb192");
cds.configurator.DefaultRule.add(configurator, "bm03175;teb200");
cds.configurator.DefaultRule.add(configurator, "bm03175;teb216");
cds.configurator.DefaultRule.add(configurator, "bm03175;teb224");
cds.configurator.DefaultRule.add(configurator, "bm06000;sehhh");
cds.configurator.DefaultRule.add(configurator, "bm06000;selll");
cds.configurator.DefaultRule.add(configurator, "bm06000;semxl");
cds.configurator.DefaultRule.add(configurator, "bm06000;sexll");
cds.configurator.DefaultRule.add(configurator, "bm06000;sma05");
cds.configurator.DefaultRule.add(configurator, "bm06000;sma10");
cds.configurator.DefaultRule.add(configurator, "bm06000;smh05");
cds.configurator.DefaultRule.add(configurator, "bm06000;smh08");
cds.configurator.DefaultRule.add(configurator, "bm06000;smt05");
cds.configurator.DefaultRule.add(configurator, "bm06000;smt10");
cds.configurator.DefaultRule.add(configurator, "bm06000;tea023");
cds.configurator.DefaultRule.add(configurator, "bm06000;tea027");
cds.configurator.DefaultRule.add(configurator, "bm06000;tea029");
cds.configurator.DefaultRule.add(configurator, "bm06000;tea031");
cds.configurator.DefaultRule.add(configurator, "bm06000;tea033");
cds.configurator.DefaultRule.add(configurator, "bm06000;tea035");
cds.configurator.DefaultRule.add(configurator, "bm06000;tea037");
cds.configurator.DefaultRule.add(configurator, "bm06000;tea039");
cds.configurator.DefaultRule.add(configurator, "bm06000;tea041");
cds.configurator.DefaultRule.add(configurator, "bm06000;tea043");
cds.configurator.DefaultRule.add(configurator, "bm06000;tea046");
cds.configurator.DefaultRule.add(configurator, "bm06000;tea052");
cds.configurator.DefaultRule.add(configurator, "bm06000;tea053");
cds.configurator.DefaultRule.add(configurator, "bm06000;tea063");
cds.configurator.DefaultRule.add(configurator, "bm06000;tea064");
cds.configurator.DefaultRule.add(configurator, "bm06000;tea067");
cds.configurator.DefaultRule.add(configurator, "bm06000;tea070");
cds.configurator.DefaultRule.add(configurator, "bm06000;tea071");
cds.configurator.DefaultRule.add(configurator, "bm06000;tea075");
cds.configurator.DefaultRule.add(configurator, "bm06000;tea084");
cds.configurator.DefaultRule.add(configurator, "bm06000;tea096");
cds.configurator.DefaultRule.add(configurator, "bm06000;tea112");
cds.configurator.DefaultRule.add(configurator, "bm06000;tea126");
cds.configurator.DefaultRule.add(configurator, "bm06000;tea140");
cds.configurator.DefaultRule.add(configurator, "bm06000;tea144");
cds.configurator.DefaultRule.add(configurator, "bm06000;tea154");
cds.configurator.DefaultRule.add(configurator, "bm06000;tea168");
cds.configurator.DefaultRule.add(configurator, "bm06000;tea180");
cds.configurator.DefaultRule.add(configurator, "bm06000;tea192");
cds.configurator.DefaultRule.add(configurator, "bm06000;tea200");
cds.configurator.DefaultRule.add(configurator, "bm06000;tea216");
cds.configurator.DefaultRule.add(configurator, "bm06000;tea224");
cds.configurator.DefaultRule.add(configurator, "bm06000;teb023");
cds.configurator.DefaultRule.add(configurator, "bm06000;teb027");
cds.configurator.DefaultRule.add(configurator, "bm06000;teb029");
cds.configurator.DefaultRule.add(configurator, "bm06000;teb031");
cds.configurator.DefaultRule.add(configurator, "bm06000;teb033");
cds.configurator.DefaultRule.add(configurator, "bm06000;teb035");
cds.configurator.DefaultRule.add(configurator, "bm06000;teb037");
cds.configurator.DefaultRule.add(configurator, "bm06000;teb039");
cds.configurator.DefaultRule.add(configurator, "bm06000;teb041");
cds.configurator.DefaultRule.add(configurator, "bm06000;teb043");
cds.configurator.DefaultRule.add(configurator, "bm06000;teb046");
cds.configurator.DefaultRule.add(configurator, "bm06000;teb052");
cds.configurator.DefaultRule.add(configurator, "bm06000;teb053");
cds.configurator.DefaultRule.add(configurator, "bm06000;teb063");
cds.configurator.DefaultRule.add(configurator, "bm06000;teb064");
cds.configurator.DefaultRule.add(configurator, "bm06000;teb067");
cds.configurator.DefaultRule.add(configurator, "bm06000;teb070");
cds.configurator.DefaultRule.add(configurator, "bm06000;teb071");
cds.configurator.DefaultRule.add(configurator, "bm06000;teb075");
cds.configurator.DefaultRule.add(configurator, "bm06000;teb084");
cds.configurator.DefaultRule.add(configurator, "bm06000;teb096");
cds.configurator.DefaultRule.add(configurator, "bm06000;teb112");
cds.configurator.DefaultRule.add(configurator, "bm06000;teb126");
cds.configurator.DefaultRule.add(configurator, "bm06000;teb140");
cds.configurator.DefaultRule.add(configurator, "bm06000;teb144");
cds.configurator.DefaultRule.add(configurator, "bm06000;teb154");
cds.configurator.DefaultRule.add(configurator, "bm06000;teb168");
cds.configurator.DefaultRule.add(configurator, "bm06000;teb180");
cds.configurator.DefaultRule.add(configurator, "bm06000;teb192");
cds.configurator.DefaultRule.add(configurator, "bm06000;teb200");
cds.configurator.DefaultRule.add(configurator, "bm06000;teb216");
cds.configurator.DefaultRule.add(configurator, "bm06000;teb224");
cds.configurator.DefaultRule.add(configurator, "bm06350;sehhh");
cds.configurator.DefaultRule.add(configurator, "bm06350;selll");
cds.configurator.DefaultRule.add(configurator, "bm06350;sma05");
cds.configurator.DefaultRule.add(configurator, "bm06350;sma10");
cds.configurator.DefaultRule.add(configurator, "bm06350;smh03");
cds.configurator.DefaultRule.add(configurator, "bm06350;smh05");
cds.configurator.DefaultRule.add(configurator, "bm06350;smh08");
cds.configurator.DefaultRule.add(configurator, "bm06350;smt05");
cds.configurator.DefaultRule.add(configurator, "bm06350;smt10");
cds.configurator.DefaultRule.add(configurator, "bm06350;smt25");
cds.configurator.DefaultRule.add(configurator, "bm06350;tea017");
cds.configurator.DefaultRule.add(configurator, "bm06350;tea019");
cds.configurator.DefaultRule.add(configurator, "bm06350;tea023");
cds.configurator.DefaultRule.add(configurator, "bm06350;tea027");
cds.configurator.DefaultRule.add(configurator, "bm06350;tea029");
cds.configurator.DefaultRule.add(configurator, "bm06350;tea031");
cds.configurator.DefaultRule.add(configurator, "bm06350;tea033");
cds.configurator.DefaultRule.add(configurator, "bm06350;tea034");
cds.configurator.DefaultRule.add(configurator, "bm06350;tea035");
cds.configurator.DefaultRule.add(configurator, "bm06350;tea037");
cds.configurator.DefaultRule.add(configurator, "bm06350;tea038");
cds.configurator.DefaultRule.add(configurator, "bm06350;tea039");
cds.configurator.DefaultRule.add(configurator, "bm06350;tea041");
cds.configurator.DefaultRule.add(configurator, "bm06350;tea043");
cds.configurator.DefaultRule.add(configurator, "bm06350;tea045");
cds.configurator.DefaultRule.add(configurator, "bm06350;tea046");
cds.configurator.DefaultRule.add(configurator, "bm06350;tea052");
cds.configurator.DefaultRule.add(configurator, "bm06350;tea053");
cds.configurator.DefaultRule.add(configurator, "bm06350;tea056");
cds.configurator.DefaultRule.add(configurator, "bm06350;tea062");
cds.configurator.DefaultRule.add(configurator, "bm06350;tea063");
cds.configurator.DefaultRule.add(configurator, "bm06350;tea064");
cds.configurator.DefaultRule.add(configurator, "bm06350;tea067");
cds.configurator.DefaultRule.add(configurator, "bm06350;tea068");
cds.configurator.DefaultRule.add(configurator, "bm06350;tea070");
cds.configurator.DefaultRule.add(configurator, "bm06350;tea071");
cds.configurator.DefaultRule.add(configurator, "bm06350;tea074");
cds.configurator.DefaultRule.add(configurator, "bm06350;tea075");
cds.configurator.DefaultRule.add(configurator, "bm06350;tea084");
cds.configurator.DefaultRule.add(configurator, "bm06350;tea096");
cds.configurator.DefaultRule.add(configurator, "bm06350;tea112");
cds.configurator.DefaultRule.add(configurator, "bm06350;tea126");
cds.configurator.DefaultRule.add(configurator, "bm06350;tea140");
cds.configurator.DefaultRule.add(configurator, "bm06350;tea144");
cds.configurator.DefaultRule.add(configurator, "bm06350;tea154");
cds.configurator.DefaultRule.add(configurator, "bm06350;tea168");
cds.configurator.DefaultRule.add(configurator, "bm06350;tea180");
cds.configurator.DefaultRule.add(configurator, "bm06350;tea192");
cds.configurator.DefaultRule.add(configurator, "bm06350;tea200");
cds.configurator.DefaultRule.add(configurator, "bm06350;tea216");
cds.configurator.DefaultRule.add(configurator, "bm06350;tea224");
cds.configurator.DefaultRule.add(configurator, "bm06350;teb017");
cds.configurator.DefaultRule.add(configurator, "bm06350;teb019");
cds.configurator.DefaultRule.add(configurator, "bm06350;teb023");
cds.configurator.DefaultRule.add(configurator, "bm06350;teb027");
cds.configurator.DefaultRule.add(configurator, "bm06350;teb029");
cds.configurator.DefaultRule.add(configurator, "bm06350;teb031");
cds.configurator.DefaultRule.add(configurator, "bm06350;teb033");
cds.configurator.DefaultRule.add(configurator, "bm06350;teb034");
cds.configurator.DefaultRule.add(configurator, "bm06350;teb035");
cds.configurator.DefaultRule.add(configurator, "bm06350;teb037");
cds.configurator.DefaultRule.add(configurator, "bm06350;teb038");
cds.configurator.DefaultRule.add(configurator, "bm06350;teb039");
cds.configurator.DefaultRule.add(configurator, "bm06350;teb041");
cds.configurator.DefaultRule.add(configurator, "bm06350;teb043");
cds.configurator.DefaultRule.add(configurator, "bm06350;teb045");
cds.configurator.DefaultRule.add(configurator, "bm06350;teb046");
cds.configurator.DefaultRule.add(configurator, "bm06350;teb052");
cds.configurator.DefaultRule.add(configurator, "bm06350;teb053");
cds.configurator.DefaultRule.add(configurator, "bm06350;teb056");
cds.configurator.DefaultRule.add(configurator, "bm06350;teb062");
cds.configurator.DefaultRule.add(configurator, "bm06350;teb063");
cds.configurator.DefaultRule.add(configurator, "bm06350;teb064");
cds.configurator.DefaultRule.add(configurator, "bm06350;teb067");
cds.configurator.DefaultRule.add(configurator, "bm06350;teb068");
cds.configurator.DefaultRule.add(configurator, "bm06350;teb070");
cds.configurator.DefaultRule.add(configurator, "bm06350;teb071");
cds.configurator.DefaultRule.add(configurator, "bm06350;teb074");
cds.configurator.DefaultRule.add(configurator, "bm06350;teb075");
cds.configurator.DefaultRule.add(configurator, "bm06350;teb084");
cds.configurator.DefaultRule.add(configurator, "bm06350;teb096");
cds.configurator.DefaultRule.add(configurator, "bm06350;teb112");
cds.configurator.DefaultRule.add(configurator, "bm06350;teb126");
cds.configurator.DefaultRule.add(configurator, "bm06350;teb140");
cds.configurator.DefaultRule.add(configurator, "bm06350;teb144");
cds.configurator.DefaultRule.add(configurator, "bm06350;teb154");
cds.configurator.DefaultRule.add(configurator, "bm06350;teb168");
cds.configurator.DefaultRule.add(configurator, "bm06350;teb180");
cds.configurator.DefaultRule.add(configurator, "bm06350;teb192");
cds.configurator.DefaultRule.add(configurator, "bm06350;teb200");
cds.configurator.DefaultRule.add(configurator, "bm06350;teb216");
cds.configurator.DefaultRule.add(configurator, "bm06350;teb224");
cds.configurator.DefaultRule.add(configurator, "bm09000;sehhh");
cds.configurator.DefaultRule.add(configurator, "bm09000;selll");
cds.configurator.DefaultRule.add(configurator, "bm09000;semxl");
cds.configurator.DefaultRule.add(configurator, "bm09000;sexll");
cds.configurator.DefaultRule.add(configurator, "bm09000;sma05");
cds.configurator.DefaultRule.add(configurator, "bm09000;sma10");
cds.configurator.DefaultRule.add(configurator, "bm09000;smh08");
cds.configurator.DefaultRule.add(configurator, "bm09000;smt05");
cds.configurator.DefaultRule.add(configurator, "bm09000;smt10");
cds.configurator.DefaultRule.add(configurator, "bm09000;smt25");
cds.configurator.DefaultRule.add(configurator, "bm09000;tea023");
cds.configurator.DefaultRule.add(configurator, "bm09000;tea027");
cds.configurator.DefaultRule.add(configurator, "bm09000;tea029");
cds.configurator.DefaultRule.add(configurator, "bm09000;tea031");
cds.configurator.DefaultRule.add(configurator, "bm09000;tea033");
cds.configurator.DefaultRule.add(configurator, "bm09000;tea035");
cds.configurator.DefaultRule.add(configurator, "bm09000;tea037");
cds.configurator.DefaultRule.add(configurator, "bm09000;tea039");
cds.configurator.DefaultRule.add(configurator, "bm09000;tea041");
cds.configurator.DefaultRule.add(configurator, "bm09000;tea043");
cds.configurator.DefaultRule.add(configurator, "bm09000;tea046");
cds.configurator.DefaultRule.add(configurator, "bm09000;tea052");
cds.configurator.DefaultRule.add(configurator, "bm09000;tea053");
cds.configurator.DefaultRule.add(configurator, "bm09000;tea063");
cds.configurator.DefaultRule.add(configurator, "bm09000;tea064");
cds.configurator.DefaultRule.add(configurator, "bm09000;tea067");
cds.configurator.DefaultRule.add(configurator, "bm09000;tea071");
cds.configurator.DefaultRule.add(configurator, "bm09000;tea075");
cds.configurator.DefaultRule.add(configurator, "bm09000;tea084");
cds.configurator.DefaultRule.add(configurator, "bm09000;tea096");
cds.configurator.DefaultRule.add(configurator, "bm09000;tea112");
cds.configurator.DefaultRule.add(configurator, "bm09000;tea126");
cds.configurator.DefaultRule.add(configurator, "bm09000;tea140");
cds.configurator.DefaultRule.add(configurator, "bm09000;tea144");
cds.configurator.DefaultRule.add(configurator, "bm09000;tea154");
cds.configurator.DefaultRule.add(configurator, "bm09000;tea168");
cds.configurator.DefaultRule.add(configurator, "bm09000;tea180");
cds.configurator.DefaultRule.add(configurator, "bm09000;tea192");
cds.configurator.DefaultRule.add(configurator, "bm09000;tea200");
cds.configurator.DefaultRule.add(configurator, "bm09000;tea216");
cds.configurator.DefaultRule.add(configurator, "bm09000;tea224");
cds.configurator.DefaultRule.add(configurator, "bm09000;teb023");
cds.configurator.DefaultRule.add(configurator, "bm09000;teb027");
cds.configurator.DefaultRule.add(configurator, "bm09000;teb029");
cds.configurator.DefaultRule.add(configurator, "bm09000;teb031");
cds.configurator.DefaultRule.add(configurator, "bm09000;teb033");
cds.configurator.DefaultRule.add(configurator, "bm09000;teb035");
cds.configurator.DefaultRule.add(configurator, "bm09000;teb037");
cds.configurator.DefaultRule.add(configurator, "bm09000;teb039");
cds.configurator.DefaultRule.add(configurator, "bm09000;teb041");
cds.configurator.DefaultRule.add(configurator, "bm09000;teb043");
cds.configurator.DefaultRule.add(configurator, "bm09000;teb046");
cds.configurator.DefaultRule.add(configurator, "bm09000;teb052");
cds.configurator.DefaultRule.add(configurator, "bm09000;teb053");
cds.configurator.DefaultRule.add(configurator, "bm09000;teb063");
cds.configurator.DefaultRule.add(configurator, "bm09000;teb064");
cds.configurator.DefaultRule.add(configurator, "bm09000;teb067");
cds.configurator.DefaultRule.add(configurator, "bm09000;teb071");
cds.configurator.DefaultRule.add(configurator, "bm09000;teb075");
cds.configurator.DefaultRule.add(configurator, "bm09000;teb084");
cds.configurator.DefaultRule.add(configurator, "bm09000;teb096");
cds.configurator.DefaultRule.add(configurator, "bm09000;teb112");
cds.configurator.DefaultRule.add(configurator, "bm09000;teb126");
cds.configurator.DefaultRule.add(configurator, "bm09000;teb140");
cds.configurator.DefaultRule.add(configurator, "bm09000;teb144");
cds.configurator.DefaultRule.add(configurator, "bm09000;teb154");
cds.configurator.DefaultRule.add(configurator, "bm09000;teb168");
cds.configurator.DefaultRule.add(configurator, "bm09000;teb180");
cds.configurator.DefaultRule.add(configurator, "bm09000;teb192");
cds.configurator.DefaultRule.add(configurator, "bm09000;teb200");
cds.configurator.DefaultRule.add(configurator, "bm09000;teb216");
cds.configurator.DefaultRule.add(configurator, "bm09000;teb224");
cds.configurator.DefaultRule.add(configurator, "bm09525;sehhh");
cds.configurator.DefaultRule.add(configurator, "bm09525;selll");
cds.configurator.DefaultRule.add(configurator, "bm09525;sma05");
cds.configurator.DefaultRule.add(configurator, "bm09525;sma10");
cds.configurator.DefaultRule.add(configurator, "bm09525;smh03");
cds.configurator.DefaultRule.add(configurator, "bm09525;smh05");
cds.configurator.DefaultRule.add(configurator, "bm09525;smh08");
cds.configurator.DefaultRule.add(configurator, "bm09525;smt05");
cds.configurator.DefaultRule.add(configurator, "bm09525;smt10");
cds.configurator.DefaultRule.add(configurator, "bm09525;smt25");
cds.configurator.DefaultRule.add(configurator, "bm09525;tea027");
cds.configurator.DefaultRule.add(configurator, "bm09525;tea029");
cds.configurator.DefaultRule.add(configurator, "bm09525;tea031");
cds.configurator.DefaultRule.add(configurator, "bm09525;tea033");
cds.configurator.DefaultRule.add(configurator, "bm09525;tea034");
cds.configurator.DefaultRule.add(configurator, "bm09525;tea035");
cds.configurator.DefaultRule.add(configurator, "bm09525;tea037");
cds.configurator.DefaultRule.add(configurator, "bm09525;tea038");
cds.configurator.DefaultRule.add(configurator, "bm09525;tea039");
cds.configurator.DefaultRule.add(configurator, "bm09525;tea041");
cds.configurator.DefaultRule.add(configurator, "bm09525;tea043");
cds.configurator.DefaultRule.add(configurator, "bm09525;tea045");
cds.configurator.DefaultRule.add(configurator, "bm09525;tea046");
cds.configurator.DefaultRule.add(configurator, "bm09525;tea052");
cds.configurator.DefaultRule.add(configurator, "bm09525;tea053");
cds.configurator.DefaultRule.add(configurator, "bm09525;tea056");
cds.configurator.DefaultRule.add(configurator, "bm09525;tea062");
cds.configurator.DefaultRule.add(configurator, "bm09525;tea063");
cds.configurator.DefaultRule.add(configurator, "bm09525;tea064");
cds.configurator.DefaultRule.add(configurator, "bm09525;tea067");
cds.configurator.DefaultRule.add(configurator, "bm09525;tea068");
cds.configurator.DefaultRule.add(configurator, "bm09525;tea070");
cds.configurator.DefaultRule.add(configurator, "bm09525;tea071");
cds.configurator.DefaultRule.add(configurator, "bm09525;tea074");
cds.configurator.DefaultRule.add(configurator, "bm09525;tea075");
cds.configurator.DefaultRule.add(configurator, "bm09525;tea084");
cds.configurator.DefaultRule.add(configurator, "bm09525;tea096");
cds.configurator.DefaultRule.add(configurator, "bm09525;tea112");
cds.configurator.DefaultRule.add(configurator, "bm09525;tea126");
cds.configurator.DefaultRule.add(configurator, "bm09525;tea140");
cds.configurator.DefaultRule.add(configurator, "bm09525;tea144");
cds.configurator.DefaultRule.add(configurator, "bm09525;tea154");
cds.configurator.DefaultRule.add(configurator, "bm09525;tea168");
cds.configurator.DefaultRule.add(configurator, "bm09525;tea180");
cds.configurator.DefaultRule.add(configurator, "bm09525;tea192");
cds.configurator.DefaultRule.add(configurator, "bm09525;tea200");
cds.configurator.DefaultRule.add(configurator, "bm09525;tea216");
cds.configurator.DefaultRule.add(configurator, "bm09525;tea224");
cds.configurator.DefaultRule.add(configurator, "bm09525;teb027");
cds.configurator.DefaultRule.add(configurator, "bm09525;teb029");
cds.configurator.DefaultRule.add(configurator, "bm09525;teb031");
cds.configurator.DefaultRule.add(configurator, "bm09525;teb033");
cds.configurator.DefaultRule.add(configurator, "bm09525;teb034");
cds.configurator.DefaultRule.add(configurator, "bm09525;teb035");
cds.configurator.DefaultRule.add(configurator, "bm09525;teb037");
cds.configurator.DefaultRule.add(configurator, "bm09525;teb038");
cds.configurator.DefaultRule.add(configurator, "bm09525;teb039");
cds.configurator.DefaultRule.add(configurator, "bm09525;teb041");
cds.configurator.DefaultRule.add(configurator, "bm09525;teb043");
cds.configurator.DefaultRule.add(configurator, "bm09525;teb045");
cds.configurator.DefaultRule.add(configurator, "bm09525;teb046");
cds.configurator.DefaultRule.add(configurator, "bm09525;teb052");
cds.configurator.DefaultRule.add(configurator, "bm09525;teb053");
cds.configurator.DefaultRule.add(configurator, "bm09525;teb056");
cds.configurator.DefaultRule.add(configurator, "bm09525;teb062");
cds.configurator.DefaultRule.add(configurator, "bm09525;teb063");
cds.configurator.DefaultRule.add(configurator, "bm09525;teb064");
cds.configurator.DefaultRule.add(configurator, "bm09525;teb067");
cds.configurator.DefaultRule.add(configurator, "bm09525;teb068");
cds.configurator.DefaultRule.add(configurator, "bm09525;teb070");
cds.configurator.DefaultRule.add(configurator, "bm09525;teb071");
cds.configurator.DefaultRule.add(configurator, "bm09525;teb074");
cds.configurator.DefaultRule.add(configurator, "bm09525;teb075");
cds.configurator.DefaultRule.add(configurator, "bm09525;teb084");
cds.configurator.DefaultRule.add(configurator, "bm09525;teb096");
cds.configurator.DefaultRule.add(configurator, "bm09525;teb112");
cds.configurator.DefaultRule.add(configurator, "bm09525;teb126");
cds.configurator.DefaultRule.add(configurator, "bm09525;teb140");
cds.configurator.DefaultRule.add(configurator, "bm09525;teb144");
cds.configurator.DefaultRule.add(configurator, "bm09525;teb154");
cds.configurator.DefaultRule.add(configurator, "bm09525;teb168");
cds.configurator.DefaultRule.add(configurator, "bm09525;teb180");
cds.configurator.DefaultRule.add(configurator, "bm09525;teb192");
cds.configurator.DefaultRule.add(configurator, "bm09525;teb200");
cds.configurator.DefaultRule.add(configurator, "bm09525;teb216");
cds.configurator.DefaultRule.add(configurator, "bm09525;teb224");
cds.configurator.DefaultRule.add(configurator, "bm10000;sehhh");
cds.configurator.DefaultRule.add(configurator, "bm10000;selll");
cds.configurator.DefaultRule.add(configurator, "bm10000;semxl");
cds.configurator.DefaultRule.add(configurator, "bm10000;sexll");
cds.configurator.DefaultRule.add(configurator, "bm10000;sma10");
cds.configurator.DefaultRule.add(configurator, "bm10000;smh03");
cds.configurator.DefaultRule.add(configurator, "bm10000;smh05");
cds.configurator.DefaultRule.add(configurator, "bm10000;smh08");
cds.configurator.DefaultRule.add(configurator, "bm10000;smt10");
cds.configurator.DefaultRule.add(configurator, "bm10000;smt25");
cds.configurator.DefaultRule.add(configurator, "bm10000;tea011");
cds.configurator.DefaultRule.add(configurator, "bm10000;tea013");
cds.configurator.DefaultRule.add(configurator, "bm10000;tea017");
cds.configurator.DefaultRule.add(configurator, "bm10000;tea021");
cds.configurator.DefaultRule.add(configurator, "bm10000;tea023");
cds.configurator.DefaultRule.add(configurator, "bm10000;tea028");
cds.configurator.DefaultRule.add(configurator, "bm10000;tea029");
cds.configurator.DefaultRule.add(configurator, "bm10000;tea031");
cds.configurator.DefaultRule.add(configurator, "bm10000;tea033");
cds.configurator.DefaultRule.add(configurator, "bm10000;tea034");
cds.configurator.DefaultRule.add(configurator, "bm10000;tea035");
cds.configurator.DefaultRule.add(configurator, "bm10000;tea037");
cds.configurator.DefaultRule.add(configurator, "bm10000;tea038");
cds.configurator.DefaultRule.add(configurator, "bm10000;tea039");
cds.configurator.DefaultRule.add(configurator, "bm10000;tea041");
cds.configurator.DefaultRule.add(configurator, "bm10000;tea042");
cds.configurator.DefaultRule.add(configurator, "bm10000;tea043");
cds.configurator.DefaultRule.add(configurator, "bm10000;tea045");
cds.configurator.DefaultRule.add(configurator, "bm10000;tea046");
cds.configurator.DefaultRule.add(configurator, "bm10000;tea050");
cds.configurator.DefaultRule.add(configurator, "bm10000;tea052");
cds.configurator.DefaultRule.add(configurator, "bm10000;tea053");
cds.configurator.DefaultRule.add(configurator, "bm10000;tea056");
cds.configurator.DefaultRule.add(configurator, "bm10000;tea062");
cds.configurator.DefaultRule.add(configurator, "bm10000;tea063");
cds.configurator.DefaultRule.add(configurator, "bm10000;tea064");
cds.configurator.DefaultRule.add(configurator, "bm10000;tea067");
cds.configurator.DefaultRule.add(configurator, "bm10000;tea068");
cds.configurator.DefaultRule.add(configurator, "bm10000;tea070");
cds.configurator.DefaultRule.add(configurator, "bm10000;tea071");
cds.configurator.DefaultRule.add(configurator, "bm10000;tea072");
cds.configurator.DefaultRule.add(configurator, "bm10000;tea074");
cds.configurator.DefaultRule.add(configurator, "bm10000;tea075");
cds.configurator.DefaultRule.add(configurator, "bm10000;tea080");
cds.configurator.DefaultRule.add(configurator, "bm10000;tea084");
cds.configurator.DefaultRule.add(configurator, "bm10000;tea090");
cds.configurator.DefaultRule.add(configurator, "bm10000;tea096");
cds.configurator.DefaultRule.add(configurator, "bm10000;tea100");
cds.configurator.DefaultRule.add(configurator, "bm10000;tea112");
cds.configurator.DefaultRule.add(configurator, "bm10000;tea120");
cds.configurator.DefaultRule.add(configurator, "bm10000;tea126");
cds.configurator.DefaultRule.add(configurator, "bm10000;tea140");
cds.configurator.DefaultRule.add(configurator, "bm10000;tea144");
cds.configurator.DefaultRule.add(configurator, "bm10000;tea154");
cds.configurator.DefaultRule.add(configurator, "bm10000;tea168");
cds.configurator.DefaultRule.add(configurator, "bm10000;tea180");
cds.configurator.DefaultRule.add(configurator, "bm10000;tea192");
cds.configurator.DefaultRule.add(configurator, "bm10000;tea200");
cds.configurator.DefaultRule.add(configurator, "bm10000;tea216");
cds.configurator.DefaultRule.add(configurator, "bm10000;tea224");
cds.configurator.DefaultRule.add(configurator, "bm10000;teb011");
cds.configurator.DefaultRule.add(configurator, "bm10000;teb013");
cds.configurator.DefaultRule.add(configurator, "bm10000;teb017");
cds.configurator.DefaultRule.add(configurator, "bm10000;teb021");
cds.configurator.DefaultRule.add(configurator, "bm10000;teb023");
cds.configurator.DefaultRule.add(configurator, "bm10000;teb028");
cds.configurator.DefaultRule.add(configurator, "bm10000;teb029");
cds.configurator.DefaultRule.add(configurator, "bm10000;teb031");
cds.configurator.DefaultRule.add(configurator, "bm10000;teb033");
cds.configurator.DefaultRule.add(configurator, "bm10000;teb034");
cds.configurator.DefaultRule.add(configurator, "bm10000;teb035");
cds.configurator.DefaultRule.add(configurator, "bm10000;teb037");
cds.configurator.DefaultRule.add(configurator, "bm10000;teb038");
cds.configurator.DefaultRule.add(configurator, "bm10000;teb039");
cds.configurator.DefaultRule.add(configurator, "bm10000;teb041");
cds.configurator.DefaultRule.add(configurator, "bm10000;teb042");
cds.configurator.DefaultRule.add(configurator, "bm10000;teb043");
cds.configurator.DefaultRule.add(configurator, "bm10000;teb045");
cds.configurator.DefaultRule.add(configurator, "bm10000;teb046");
cds.configurator.DefaultRule.add(configurator, "bm10000;teb050");
cds.configurator.DefaultRule.add(configurator, "bm10000;teb052");
cds.configurator.DefaultRule.add(configurator, "bm10000;teb053");
cds.configurator.DefaultRule.add(configurator, "bm10000;teb056");
cds.configurator.DefaultRule.add(configurator, "bm10000;teb062");
cds.configurator.DefaultRule.add(configurator, "bm10000;teb063");
cds.configurator.DefaultRule.add(configurator, "bm10000;teb064");
cds.configurator.DefaultRule.add(configurator, "bm10000;teb067");
cds.configurator.DefaultRule.add(configurator, "bm10000;teb068");
cds.configurator.DefaultRule.add(configurator, "bm10000;teb070");
cds.configurator.DefaultRule.add(configurator, "bm10000;teb071");
cds.configurator.DefaultRule.add(configurator, "bm10000;teb072");
cds.configurator.DefaultRule.add(configurator, "bm10000;teb074");
cds.configurator.DefaultRule.add(configurator, "bm10000;teb075");
cds.configurator.DefaultRule.add(configurator, "bm10000;teb080");
cds.configurator.DefaultRule.add(configurator, "bm10000;teb084");
cds.configurator.DefaultRule.add(configurator, "bm10000;teb090");
cds.configurator.DefaultRule.add(configurator, "bm10000;teb096");
cds.configurator.DefaultRule.add(configurator, "bm10000;teb100");
cds.configurator.DefaultRule.add(configurator, "bm10000;teb112");
cds.configurator.DefaultRule.add(configurator, "bm10000;teb120");
cds.configurator.DefaultRule.add(configurator, "bm10000;teb126");
cds.configurator.DefaultRule.add(configurator, "bm10000;teb140");
cds.configurator.DefaultRule.add(configurator, "bm10000;teb144");
cds.configurator.DefaultRule.add(configurator, "bm10000;teb154");
cds.configurator.DefaultRule.add(configurator, "bm10000;teb168");
cds.configurator.DefaultRule.add(configurator, "bm10000;teb180");
cds.configurator.DefaultRule.add(configurator, "bm10000;teb192");
cds.configurator.DefaultRule.add(configurator, "bm10000;teb200");
cds.configurator.DefaultRule.add(configurator, "bm10000;teb216");
cds.configurator.DefaultRule.add(configurator, "bm10000;teb224");
cds.configurator.DefaultRule.add(configurator, "bm115000;sehhh");
cds.configurator.DefaultRule.add(configurator, "bm115000;selll");
cds.configurator.DefaultRule.add(configurator, "bm115000;semxl");
cds.configurator.DefaultRule.add(configurator, "bm115000;sexll");
cds.configurator.DefaultRule.add(configurator, "bm115000;sma05");
cds.configurator.DefaultRule.add(configurator, "bm115000;sma10");
cds.configurator.DefaultRule.add(configurator, "bm115000;smh03");
cds.configurator.DefaultRule.add(configurator, "bm115000;smh05");
cds.configurator.DefaultRule.add(configurator, "bm115000;smh08");
cds.configurator.DefaultRule.add(configurator, "bm115000;smt05");
cds.configurator.DefaultRule.add(configurator, "bm115000;smt10");
cds.configurator.DefaultRule.add(configurator, "bm115000;smt25");
cds.configurator.DefaultRule.add(configurator, "bm115000;tea010");
cds.configurator.DefaultRule.add(configurator, "bm115000;tea011");
cds.configurator.DefaultRule.add(configurator, "bm115000;tea012");
cds.configurator.DefaultRule.add(configurator, "bm115000;tea013");
cds.configurator.DefaultRule.add(configurator, "bm115000;tea014");
cds.configurator.DefaultRule.add(configurator, "bm115000;tea015");
cds.configurator.DefaultRule.add(configurator, "bm115000;tea016");
cds.configurator.DefaultRule.add(configurator, "bm115000;tea017");
cds.configurator.DefaultRule.add(configurator, "bm115000;tea018");
cds.configurator.DefaultRule.add(configurator, "bm115000;tea019");
cds.configurator.DefaultRule.add(configurator, "bm115000;tea020");
cds.configurator.DefaultRule.add(configurator, "bm115000;tea021");
cds.configurator.DefaultRule.add(configurator, "bm115000;tea022");
cds.configurator.DefaultRule.add(configurator, "bm115000;tea023");
cds.configurator.DefaultRule.add(configurator, "bm115000;tea024");
cds.configurator.DefaultRule.add(configurator, "bm115000;tea025");
cds.configurator.DefaultRule.add(configurator, "bm115000;tea026");
cds.configurator.DefaultRule.add(configurator, "bm115000;tea027");
cds.configurator.DefaultRule.add(configurator, "bm115000;tea031");
cds.configurator.DefaultRule.add(configurator, "bm115000;tea033");
cds.configurator.DefaultRule.add(configurator, "bm115000;tea035");
cds.configurator.DefaultRule.add(configurator, "bm115000;tea037");
cds.configurator.DefaultRule.add(configurator, "bm115000;tea039");
cds.configurator.DefaultRule.add(configurator, "bm115000;tea041");
cds.configurator.DefaultRule.add(configurator, "bm115000;tea042");
cds.configurator.DefaultRule.add(configurator, "bm115000;tea043");
cds.configurator.DefaultRule.add(configurator, "bm115000;tea045");
cds.configurator.DefaultRule.add(configurator, "bm115000;tea046");
cds.configurator.DefaultRule.add(configurator, "bm115000;tea050");
cds.configurator.DefaultRule.add(configurator, "bm115000;tea053");
cds.configurator.DefaultRule.add(configurator, "bm115000;tea062");
cds.configurator.DefaultRule.add(configurator, "bm115000;tea063");
cds.configurator.DefaultRule.add(configurator, "bm115000;tea067");
cds.configurator.DefaultRule.add(configurator, "bm115000;tea070");
cds.configurator.DefaultRule.add(configurator, "bm115000;tea071");
cds.configurator.DefaultRule.add(configurator, "bm115000;tea074");
cds.configurator.DefaultRule.add(configurator, "bm115000;tea075");
cds.configurator.DefaultRule.add(configurator, "bm115000;tea084");
cds.configurator.DefaultRule.add(configurator, "bm115000;tea096");
cds.configurator.DefaultRule.add(configurator, "bm115000;tea100");
cds.configurator.DefaultRule.add(configurator, "bm115000;tea120");
cds.configurator.DefaultRule.add(configurator, "bm115000;tea126");
cds.configurator.DefaultRule.add(configurator, "bm115000;tea140");
cds.configurator.DefaultRule.add(configurator, "bm115000;tea154");
cds.configurator.DefaultRule.add(configurator, "bm115000;tea180");
cds.configurator.DefaultRule.add(configurator, "bm115000;tea200");
cds.configurator.DefaultRule.add(configurator, "bm115000;tea224");
cds.configurator.DefaultRule.add(configurator, "bm115000;teb010");
cds.configurator.DefaultRule.add(configurator, "bm115000;teb011");
cds.configurator.DefaultRule.add(configurator, "bm115000;teb012");
cds.configurator.DefaultRule.add(configurator, "bm115000;teb013");
cds.configurator.DefaultRule.add(configurator, "bm115000;teb014");
cds.configurator.DefaultRule.add(configurator, "bm115000;teb015");
cds.configurator.DefaultRule.add(configurator, "bm115000;teb016");
cds.configurator.DefaultRule.add(configurator, "bm115000;teb017");
cds.configurator.DefaultRule.add(configurator, "bm115000;teb018");
cds.configurator.DefaultRule.add(configurator, "bm115000;teb019");
cds.configurator.DefaultRule.add(configurator, "bm115000;teb020");
cds.configurator.DefaultRule.add(configurator, "bm115000;teb021");
cds.configurator.DefaultRule.add(configurator, "bm115000;teb022");
cds.configurator.DefaultRule.add(configurator, "bm115000;teb023");
cds.configurator.DefaultRule.add(configurator, "bm115000;teb024");
cds.configurator.DefaultRule.add(configurator, "bm115000;teb025");
cds.configurator.DefaultRule.add(configurator, "bm115000;teb026");
cds.configurator.DefaultRule.add(configurator, "bm115000;teb027");
cds.configurator.DefaultRule.add(configurator, "bm115000;teb031");
cds.configurator.DefaultRule.add(configurator, "bm115000;teb033");
cds.configurator.DefaultRule.add(configurator, "bm115000;teb035");
cds.configurator.DefaultRule.add(configurator, "bm115000;teb037");
cds.configurator.DefaultRule.add(configurator, "bm115000;teb039");
cds.configurator.DefaultRule.add(configurator, "bm115000;teb041");
cds.configurator.DefaultRule.add(configurator, "bm115000;teb042");
cds.configurator.DefaultRule.add(configurator, "bm115000;teb043");
cds.configurator.DefaultRule.add(configurator, "bm115000;teb045");
cds.configurator.DefaultRule.add(configurator, "bm115000;teb046");
cds.configurator.DefaultRule.add(configurator, "bm115000;teb050");
cds.configurator.DefaultRule.add(configurator, "bm115000;teb053");
cds.configurator.DefaultRule.add(configurator, "bm115000;teb062");
cds.configurator.DefaultRule.add(configurator, "bm115000;teb063");
cds.configurator.DefaultRule.add(configurator, "bm115000;teb067");
cds.configurator.DefaultRule.add(configurator, "bm115000;teb070");
cds.configurator.DefaultRule.add(configurator, "bm115000;teb071");
cds.configurator.DefaultRule.add(configurator, "bm115000;teb074");
cds.configurator.DefaultRule.add(configurator, "bm115000;teb075");
cds.configurator.DefaultRule.add(configurator, "bm115000;teb084");
cds.configurator.DefaultRule.add(configurator, "bm115000;teb096");
cds.configurator.DefaultRule.add(configurator, "bm115000;teb100");
cds.configurator.DefaultRule.add(configurator, "bm115000;teb120");
cds.configurator.DefaultRule.add(configurator, "bm115000;teb126");
cds.configurator.DefaultRule.add(configurator, "bm115000;teb140");
cds.configurator.DefaultRule.add(configurator, "bm115000;teb154");
cds.configurator.DefaultRule.add(configurator, "bm115000;teb180");
cds.configurator.DefaultRule.add(configurator, "bm115000;teb200");
cds.configurator.DefaultRule.add(configurator, "bm115000;teb224");
cds.configurator.DefaultRule.add(configurator, "bm12000;sehhh");
cds.configurator.DefaultRule.add(configurator, "bm12000;selll");
cds.configurator.DefaultRule.add(configurator, "bm12000;semxl");
cds.configurator.DefaultRule.add(configurator, "bm12000;sexll");
cds.configurator.DefaultRule.add(configurator, "bm12000;sma05");
cds.configurator.DefaultRule.add(configurator, "bm12000;sma10");
cds.configurator.DefaultRule.add(configurator, "bm12000;smh03");
cds.configurator.DefaultRule.add(configurator, "bm12000;smh05");
cds.configurator.DefaultRule.add(configurator, "bm12000;smh08");
cds.configurator.DefaultRule.add(configurator, "bm12000;smt05");
cds.configurator.DefaultRule.add(configurator, "bm12000;smt10");
cds.configurator.DefaultRule.add(configurator, "bm12000;smt25");
cds.configurator.DefaultRule.add(configurator, "bm12000;tea010");
cds.configurator.DefaultRule.add(configurator, "bm12000;tea011");
cds.configurator.DefaultRule.add(configurator, "bm12000;tea012");
cds.configurator.DefaultRule.add(configurator, "bm12000;tea013");
cds.configurator.DefaultRule.add(configurator, "bm12000;tea014");
cds.configurator.DefaultRule.add(configurator, "bm12000;tea015");
cds.configurator.DefaultRule.add(configurator, "bm12000;tea016");
cds.configurator.DefaultRule.add(configurator, "bm12000;tea017");
cds.configurator.DefaultRule.add(configurator, "bm12000;tea018");
cds.configurator.DefaultRule.add(configurator, "bm12000;tea019");
cds.configurator.DefaultRule.add(configurator, "bm12000;tea020");
cds.configurator.DefaultRule.add(configurator, "bm12000;tea021");
cds.configurator.DefaultRule.add(configurator, "bm12000;tea023");
cds.configurator.DefaultRule.add(configurator, "bm12000;tea024");
cds.configurator.DefaultRule.add(configurator, "bm12000;tea035");
cds.configurator.DefaultRule.add(configurator, "bm12000;tea043");
cds.configurator.DefaultRule.add(configurator, "bm12000;tea044");
cds.configurator.DefaultRule.add(configurator, "bm12000;tea046");
cds.configurator.DefaultRule.add(configurator, "bm12000;tea052");
cds.configurator.DefaultRule.add(configurator, "bm12000;tea062");
cds.configurator.DefaultRule.add(configurator, "bm12000;tea064");
cds.configurator.DefaultRule.add(configurator, "bm12000;tea068");
cds.configurator.DefaultRule.add(configurator, "bm12000;tea070");
cds.configurator.DefaultRule.add(configurator, "bm12000;tea072");
cds.configurator.DefaultRule.add(configurator, "bm12000;tea074");
cds.configurator.DefaultRule.add(configurator, "bm12000;tea084");
cds.configurator.DefaultRule.add(configurator, "bm12000;tea096");
cds.configurator.DefaultRule.add(configurator, "bm12000;tea100");
cds.configurator.DefaultRule.add(configurator, "bm12000;tea120");
cds.configurator.DefaultRule.add(configurator, "bm12000;tea126");
cds.configurator.DefaultRule.add(configurator, "bm12000;tea144");
cds.configurator.DefaultRule.add(configurator, "bm12000;tea154");
cds.configurator.DefaultRule.add(configurator, "bm12000;tea168");
cds.configurator.DefaultRule.add(configurator, "bm12000;tea192");
cds.configurator.DefaultRule.add(configurator, "bm12000;tea200");
cds.configurator.DefaultRule.add(configurator, "bm12000;tea216");
cds.configurator.DefaultRule.add(configurator, "bm12000;teb010");
cds.configurator.DefaultRule.add(configurator, "bm12000;teb011");
cds.configurator.DefaultRule.add(configurator, "bm12000;teb012");
cds.configurator.DefaultRule.add(configurator, "bm12000;teb013");
cds.configurator.DefaultRule.add(configurator, "bm12000;teb014");
cds.configurator.DefaultRule.add(configurator, "bm12000;teb015");
cds.configurator.DefaultRule.add(configurator, "bm12000;teb016");
cds.configurator.DefaultRule.add(configurator, "bm12000;teb017");
cds.configurator.DefaultRule.add(configurator, "bm12000;teb018");
cds.configurator.DefaultRule.add(configurator, "bm12000;teb019");
cds.configurator.DefaultRule.add(configurator, "bm12000;teb020");
cds.configurator.DefaultRule.add(configurator, "bm12000;teb021");
cds.configurator.DefaultRule.add(configurator, "bm12000;teb023");
cds.configurator.DefaultRule.add(configurator, "bm12000;teb024");
cds.configurator.DefaultRule.add(configurator, "bm12000;teb035");
cds.configurator.DefaultRule.add(configurator, "bm12000;teb043");
cds.configurator.DefaultRule.add(configurator, "bm12000;teb044");
cds.configurator.DefaultRule.add(configurator, "bm12000;teb046");
cds.configurator.DefaultRule.add(configurator, "bm12000;teb052");
cds.configurator.DefaultRule.add(configurator, "bm12000;teb062");
cds.configurator.DefaultRule.add(configurator, "bm12000;teb064");
cds.configurator.DefaultRule.add(configurator, "bm12000;teb068");
cds.configurator.DefaultRule.add(configurator, "bm12000;teb070");
cds.configurator.DefaultRule.add(configurator, "bm12000;teb072");
cds.configurator.DefaultRule.add(configurator, "bm12000;teb074");
cds.configurator.DefaultRule.add(configurator, "bm12000;teb084");
cds.configurator.DefaultRule.add(configurator, "bm12000;teb096");
cds.configurator.DefaultRule.add(configurator, "bm12000;teb100");
cds.configurator.DefaultRule.add(configurator, "bm12000;teb120");
cds.configurator.DefaultRule.add(configurator, "bm12000;teb126");
cds.configurator.DefaultRule.add(configurator, "bm12000;teb144");
cds.configurator.DefaultRule.add(configurator, "bm12000;teb154");
cds.configurator.DefaultRule.add(configurator, "bm12000;teb168");
cds.configurator.DefaultRule.add(configurator, "bm12000;teb192");
cds.configurator.DefaultRule.add(configurator, "bm12000;teb200");
cds.configurator.DefaultRule.add(configurator, "bm12000;teb216");
cds.configurator.DefaultRule.add(configurator, "bm125000;sehhh");
cds.configurator.DefaultRule.add(configurator, "bm125000;selll");
cds.configurator.DefaultRule.add(configurator, "bm125000;semxl");
cds.configurator.DefaultRule.add(configurator, "bm125000;sexll");
cds.configurator.DefaultRule.add(configurator, "bm125000;sma05");
cds.configurator.DefaultRule.add(configurator, "bm125000;sma10");
cds.configurator.DefaultRule.add(configurator, "bm125000;smh03");
cds.configurator.DefaultRule.add(configurator, "bm125000;smh05");
cds.configurator.DefaultRule.add(configurator, "bm125000;smh08");
cds.configurator.DefaultRule.add(configurator, "bm125000;smt05");
cds.configurator.DefaultRule.add(configurator, "bm125000;smt10");
cds.configurator.DefaultRule.add(configurator, "bm125000;smt25");
cds.configurator.DefaultRule.add(configurator, "bm125000;tea010");
cds.configurator.DefaultRule.add(configurator, "bm125000;tea011");
cds.configurator.DefaultRule.add(configurator, "bm125000;tea012");
cds.configurator.DefaultRule.add(configurator, "bm125000;tea013");
cds.configurator.DefaultRule.add(configurator, "bm125000;tea014");
cds.configurator.DefaultRule.add(configurator, "bm125000;tea015");
cds.configurator.DefaultRule.add(configurator, "bm125000;tea016");
cds.configurator.DefaultRule.add(configurator, "bm125000;tea017");
cds.configurator.DefaultRule.add(configurator, "bm125000;tea018");
cds.configurator.DefaultRule.add(configurator, "bm125000;tea019");
cds.configurator.DefaultRule.add(configurator, "bm125000;tea020");
cds.configurator.DefaultRule.add(configurator, "bm125000;tea021");
cds.configurator.DefaultRule.add(configurator, "bm125000;tea022");
cds.configurator.DefaultRule.add(configurator, "bm125000;tea023");
cds.configurator.DefaultRule.add(configurator, "bm125000;tea024");
cds.configurator.DefaultRule.add(configurator, "bm125000;tea025");
cds.configurator.DefaultRule.add(configurator, "bm125000;tea026");
cds.configurator.DefaultRule.add(configurator, "bm125000;tea027");
cds.configurator.DefaultRule.add(configurator, "bm125000;tea041");
cds.configurator.DefaultRule.add(configurator, "bm125000;tea042");
cds.configurator.DefaultRule.add(configurator, "bm125000;tea044");
cds.configurator.DefaultRule.add(configurator, "bm125000;tea046");
cds.configurator.DefaultRule.add(configurator, "bm125000;tea052");
cds.configurator.DefaultRule.add(configurator, "bm125000;tea062");
cds.configurator.DefaultRule.add(configurator, "bm125000;tea064");
cds.configurator.DefaultRule.add(configurator, "bm125000;tea068");
cds.configurator.DefaultRule.add(configurator, "bm125000;tea070");
cds.configurator.DefaultRule.add(configurator, "bm125000;tea072");
cds.configurator.DefaultRule.add(configurator, "bm125000;tea074");
cds.configurator.DefaultRule.add(configurator, "bm125000;tea084");
cds.configurator.DefaultRule.add(configurator, "bm125000;tea096");
cds.configurator.DefaultRule.add(configurator, "bm125000;tea100");
cds.configurator.DefaultRule.add(configurator, "bm125000;tea120");
cds.configurator.DefaultRule.add(configurator, "bm125000;tea126");
cds.configurator.DefaultRule.add(configurator, "bm125000;tea144");
cds.configurator.DefaultRule.add(configurator, "bm125000;tea154");
cds.configurator.DefaultRule.add(configurator, "bm125000;tea192");
cds.configurator.DefaultRule.add(configurator, "bm125000;tea216");
cds.configurator.DefaultRule.add(configurator, "bm125000;teb010");
cds.configurator.DefaultRule.add(configurator, "bm125000;teb011");
cds.configurator.DefaultRule.add(configurator, "bm125000;teb012");
cds.configurator.DefaultRule.add(configurator, "bm125000;teb013");
cds.configurator.DefaultRule.add(configurator, "bm125000;teb014");
cds.configurator.DefaultRule.add(configurator, "bm125000;teb015");
cds.configurator.DefaultRule.add(configurator, "bm125000;teb016");
cds.configurator.DefaultRule.add(configurator, "bm125000;teb017");
cds.configurator.DefaultRule.add(configurator, "bm125000;teb018");
cds.configurator.DefaultRule.add(configurator, "bm125000;teb019");
cds.configurator.DefaultRule.add(configurator, "bm125000;teb020");
cds.configurator.DefaultRule.add(configurator, "bm125000;teb021");
cds.configurator.DefaultRule.add(configurator, "bm125000;teb022");
cds.configurator.DefaultRule.add(configurator, "bm125000;teb023");
cds.configurator.DefaultRule.add(configurator, "bm125000;teb024");
cds.configurator.DefaultRule.add(configurator, "bm125000;teb025");
cds.configurator.DefaultRule.add(configurator, "bm125000;teb026");
cds.configurator.DefaultRule.add(configurator, "bm125000;teb027");
cds.configurator.DefaultRule.add(configurator, "bm125000;teb041");
cds.configurator.DefaultRule.add(configurator, "bm125000;teb042");
cds.configurator.DefaultRule.add(configurator, "bm125000;teb044");
cds.configurator.DefaultRule.add(configurator, "bm125000;teb046");
cds.configurator.DefaultRule.add(configurator, "bm125000;teb052");
cds.configurator.DefaultRule.add(configurator, "bm125000;teb062");
cds.configurator.DefaultRule.add(configurator, "bm125000;teb064");
cds.configurator.DefaultRule.add(configurator, "bm125000;teb068");
cds.configurator.DefaultRule.add(configurator, "bm125000;teb070");
cds.configurator.DefaultRule.add(configurator, "bm125000;teb072");
cds.configurator.DefaultRule.add(configurator, "bm125000;teb074");
cds.configurator.DefaultRule.add(configurator, "bm125000;teb084");
cds.configurator.DefaultRule.add(configurator, "bm125000;teb096");
cds.configurator.DefaultRule.add(configurator, "bm125000;teb100");
cds.configurator.DefaultRule.add(configurator, "bm125000;teb120");
cds.configurator.DefaultRule.add(configurator, "bm125000;teb126");
cds.configurator.DefaultRule.add(configurator, "bm125000;teb144");
cds.configurator.DefaultRule.add(configurator, "bm125000;teb154");
cds.configurator.DefaultRule.add(configurator, "bm125000;teb192");
cds.configurator.DefaultRule.add(configurator, "bm125000;teb216");
cds.configurator.DefaultRule.add(configurator, "bm12700;sehhh");
cds.configurator.DefaultRule.add(configurator, "bm12700;semxl");
cds.configurator.DefaultRule.add(configurator, "bm12700;sexll");
cds.configurator.DefaultRule.add(configurator, "bm12700;sma05");
cds.configurator.DefaultRule.add(configurator, "bm12700;sma10");
cds.configurator.DefaultRule.add(configurator, "bm12700;smh03");
cds.configurator.DefaultRule.add(configurator, "bm12700;smh05");
cds.configurator.DefaultRule.add(configurator, "bm12700;smh08");
cds.configurator.DefaultRule.add(configurator, "bm12700;smt05");
cds.configurator.DefaultRule.add(configurator, "bm12700;smt10");
cds.configurator.DefaultRule.add(configurator, "bm12700;smt25");
cds.configurator.DefaultRule.add(configurator, "bm12700;tea011");
cds.configurator.DefaultRule.add(configurator, "bm12700;tea023");
cds.configurator.DefaultRule.add(configurator, "bm12700;tea025");
cds.configurator.DefaultRule.add(configurator, "bm12700;tea027");
cds.configurator.DefaultRule.add(configurator, "bm12700;tea029");
cds.configurator.DefaultRule.add(configurator, "bm12700;tea031");
cds.configurator.DefaultRule.add(configurator, "bm12700;tea033");
cds.configurator.DefaultRule.add(configurator, "bm12700;tea034");
cds.configurator.DefaultRule.add(configurator, "bm12700;tea035");
cds.configurator.DefaultRule.add(configurator, "bm12700;tea037");
cds.configurator.DefaultRule.add(configurator, "bm12700;tea038");
cds.configurator.DefaultRule.add(configurator, "bm12700;tea039");
cds.configurator.DefaultRule.add(configurator, "bm12700;tea041");
cds.configurator.DefaultRule.add(configurator, "bm12700;tea042");
cds.configurator.DefaultRule.add(configurator, "bm12700;tea043");
cds.configurator.DefaultRule.add(configurator, "bm12700;tea045");
cds.configurator.DefaultRule.add(configurator, "bm12700;tea046");
cds.configurator.DefaultRule.add(configurator, "bm12700;tea050");
cds.configurator.DefaultRule.add(configurator, "bm12700;tea052");
cds.configurator.DefaultRule.add(configurator, "bm12700;tea053");
cds.configurator.DefaultRule.add(configurator, "bm12700;tea056");
cds.configurator.DefaultRule.add(configurator, "bm12700;tea062");
cds.configurator.DefaultRule.add(configurator, "bm12700;tea063");
cds.configurator.DefaultRule.add(configurator, "bm12700;tea064");
cds.configurator.DefaultRule.add(configurator, "bm12700;tea067");
cds.configurator.DefaultRule.add(configurator, "bm12700;tea068");
cds.configurator.DefaultRule.add(configurator, "bm12700;tea070");
cds.configurator.DefaultRule.add(configurator, "bm12700;tea071");
cds.configurator.DefaultRule.add(configurator, "bm12700;tea074");
cds.configurator.DefaultRule.add(configurator, "bm12700;tea075");
cds.configurator.DefaultRule.add(configurator, "bm12700;tea080");
cds.configurator.DefaultRule.add(configurator, "bm12700;tea090");
cds.configurator.DefaultRule.add(configurator, "bm12700;tea100");
cds.configurator.DefaultRule.add(configurator, "bm12700;tea112");
cds.configurator.DefaultRule.add(configurator, "bm12700;tea126");
cds.configurator.DefaultRule.add(configurator, "bm12700;tea140");
cds.configurator.DefaultRule.add(configurator, "bm12700;tea144");
cds.configurator.DefaultRule.add(configurator, "bm12700;tea154");
cds.configurator.DefaultRule.add(configurator, "bm12700;tea168");
cds.configurator.DefaultRule.add(configurator, "bm12700;tea180");
cds.configurator.DefaultRule.add(configurator, "bm12700;tea192");
cds.configurator.DefaultRule.add(configurator, "bm12700;tea200");
cds.configurator.DefaultRule.add(configurator, "bm12700;tea216");
cds.configurator.DefaultRule.add(configurator, "bm12700;tea224");
cds.configurator.DefaultRule.add(configurator, "bm12700;teb011");
cds.configurator.DefaultRule.add(configurator, "bm12700;teb023");
cds.configurator.DefaultRule.add(configurator, "bm12700;teb025");
cds.configurator.DefaultRule.add(configurator, "bm12700;teb027");
cds.configurator.DefaultRule.add(configurator, "bm12700;teb029");
cds.configurator.DefaultRule.add(configurator, "bm12700;teb031");
cds.configurator.DefaultRule.add(configurator, "bm12700;teb033");
cds.configurator.DefaultRule.add(configurator, "bm12700;teb034");
cds.configurator.DefaultRule.add(configurator, "bm12700;teb035");
cds.configurator.DefaultRule.add(configurator, "bm12700;teb037");
cds.configurator.DefaultRule.add(configurator, "bm12700;teb038");
cds.configurator.DefaultRule.add(configurator, "bm12700;teb039");
cds.configurator.DefaultRule.add(configurator, "bm12700;teb041");
cds.configurator.DefaultRule.add(configurator, "bm12700;teb042");
cds.configurator.DefaultRule.add(configurator, "bm12700;teb043");
cds.configurator.DefaultRule.add(configurator, "bm12700;teb045");
cds.configurator.DefaultRule.add(configurator, "bm12700;teb046");
cds.configurator.DefaultRule.add(configurator, "bm12700;teb050");
cds.configurator.DefaultRule.add(configurator, "bm12700;teb052");
cds.configurator.DefaultRule.add(configurator, "bm12700;teb053");
cds.configurator.DefaultRule.add(configurator, "bm12700;teb056");
cds.configurator.DefaultRule.add(configurator, "bm12700;teb062");
cds.configurator.DefaultRule.add(configurator, "bm12700;teb063");
cds.configurator.DefaultRule.add(configurator, "bm12700;teb064");
cds.configurator.DefaultRule.add(configurator, "bm12700;teb067");
cds.configurator.DefaultRule.add(configurator, "bm12700;teb068");
cds.configurator.DefaultRule.add(configurator, "bm12700;teb070");
cds.configurator.DefaultRule.add(configurator, "bm12700;teb071");
cds.configurator.DefaultRule.add(configurator, "bm12700;teb074");
cds.configurator.DefaultRule.add(configurator, "bm12700;teb075");
cds.configurator.DefaultRule.add(configurator, "bm12700;teb080");
cds.configurator.DefaultRule.add(configurator, "bm12700;teb090");
cds.configurator.DefaultRule.add(configurator, "bm12700;teb100");
cds.configurator.DefaultRule.add(configurator, "bm12700;teb112");
cds.configurator.DefaultRule.add(configurator, "bm12700;teb126");
cds.configurator.DefaultRule.add(configurator, "bm12700;teb140");
cds.configurator.DefaultRule.add(configurator, "bm12700;teb144");
cds.configurator.DefaultRule.add(configurator, "bm12700;teb154");
cds.configurator.DefaultRule.add(configurator, "bm12700;teb168");
cds.configurator.DefaultRule.add(configurator, "bm12700;teb180");
cds.configurator.DefaultRule.add(configurator, "bm12700;teb192");
cds.configurator.DefaultRule.add(configurator, "bm12700;teb200");
cds.configurator.DefaultRule.add(configurator, "bm12700;teb216");
cds.configurator.DefaultRule.add(configurator, "bm12700;teb224");
cds.configurator.DefaultRule.add(configurator, "bm15000;sehhh");
cds.configurator.DefaultRule.add(configurator, "bm15000;selll");
cds.configurator.DefaultRule.add(configurator, "bm15000;semxl");
cds.configurator.DefaultRule.add(configurator, "bm15000;sexll");
cds.configurator.DefaultRule.add(configurator, "bm15000;sma05");
cds.configurator.DefaultRule.add(configurator, "bm15000;sma10");
cds.configurator.DefaultRule.add(configurator, "bm15000;smh03");
cds.configurator.DefaultRule.add(configurator, "bm15000;smh08");
cds.configurator.DefaultRule.add(configurator, "bm15000;smt05");
cds.configurator.DefaultRule.add(configurator, "bm15000;smt10");
cds.configurator.DefaultRule.add(configurator, "bm15000;smt25");
cds.configurator.DefaultRule.add(configurator, "bm15000;tea010");
cds.configurator.DefaultRule.add(configurator, "bm15000;tea011");
cds.configurator.DefaultRule.add(configurator, "bm15000;tea027");
cds.configurator.DefaultRule.add(configurator, "bm15000;tea029");
cds.configurator.DefaultRule.add(configurator, "bm15000;tea031");
cds.configurator.DefaultRule.add(configurator, "bm15000;tea033");
cds.configurator.DefaultRule.add(configurator, "bm15000;tea035");
cds.configurator.DefaultRule.add(configurator, "bm15000;tea037");
cds.configurator.DefaultRule.add(configurator, "bm15000;tea039");
cds.configurator.DefaultRule.add(configurator, "bm15000;tea041");
cds.configurator.DefaultRule.add(configurator, "bm15000;tea042");
cds.configurator.DefaultRule.add(configurator, "bm15000;tea043");
cds.configurator.DefaultRule.add(configurator, "bm15000;tea046");
cds.configurator.DefaultRule.add(configurator, "bm15000;tea053");
cds.configurator.DefaultRule.add(configurator, "bm15000;tea063");
cds.configurator.DefaultRule.add(configurator, "bm15000;tea067");
cds.configurator.DefaultRule.add(configurator, "bm15000;tea071");
cds.configurator.DefaultRule.add(configurator, "bm15000;tea075");
cds.configurator.DefaultRule.add(configurator, "bm15000;tea084");
cds.configurator.DefaultRule.add(configurator, "bm15000;tea096");
cds.configurator.DefaultRule.add(configurator, "bm15000;tea126");
cds.configurator.DefaultRule.add(configurator, "bm15000;tea140");
cds.configurator.DefaultRule.add(configurator, "bm15000;tea144");
cds.configurator.DefaultRule.add(configurator, "bm15000;tea154");
cds.configurator.DefaultRule.add(configurator, "bm15000;tea168");
cds.configurator.DefaultRule.add(configurator, "bm15000;tea180");
cds.configurator.DefaultRule.add(configurator, "bm15000;tea192");
cds.configurator.DefaultRule.add(configurator, "bm15000;tea200");
cds.configurator.DefaultRule.add(configurator, "bm15000;tea216");
cds.configurator.DefaultRule.add(configurator, "bm15000;tea224");
cds.configurator.DefaultRule.add(configurator, "bm15000;teb010");
cds.configurator.DefaultRule.add(configurator, "bm15000;teb011");
cds.configurator.DefaultRule.add(configurator, "bm15000;teb027");
cds.configurator.DefaultRule.add(configurator, "bm15000;teb029");
cds.configurator.DefaultRule.add(configurator, "bm15000;teb031");
cds.configurator.DefaultRule.add(configurator, "bm15000;teb033");
cds.configurator.DefaultRule.add(configurator, "bm15000;teb035");
cds.configurator.DefaultRule.add(configurator, "bm15000;teb037");
cds.configurator.DefaultRule.add(configurator, "bm15000;teb039");
cds.configurator.DefaultRule.add(configurator, "bm15000;teb041");
cds.configurator.DefaultRule.add(configurator, "bm15000;teb042");
cds.configurator.DefaultRule.add(configurator, "bm15000;teb043");
cds.configurator.DefaultRule.add(configurator, "bm15000;teb046");
cds.configurator.DefaultRule.add(configurator, "bm15000;teb053");
cds.configurator.DefaultRule.add(configurator, "bm15000;teb063");
cds.configurator.DefaultRule.add(configurator, "bm15000;teb067");
cds.configurator.DefaultRule.add(configurator, "bm15000;teb071");
cds.configurator.DefaultRule.add(configurator, "bm15000;teb075");
cds.configurator.DefaultRule.add(configurator, "bm15000;teb084");
cds.configurator.DefaultRule.add(configurator, "bm15000;teb096");
cds.configurator.DefaultRule.add(configurator, "bm15000;teb126");
cds.configurator.DefaultRule.add(configurator, "bm15000;teb140");
cds.configurator.DefaultRule.add(configurator, "bm15000;teb144");
cds.configurator.DefaultRule.add(configurator, "bm15000;teb154");
cds.configurator.DefaultRule.add(configurator, "bm15000;teb168");
cds.configurator.DefaultRule.add(configurator, "bm15000;teb180");
cds.configurator.DefaultRule.add(configurator, "bm15000;teb192");
cds.configurator.DefaultRule.add(configurator, "bm15000;teb200");
cds.configurator.DefaultRule.add(configurator, "bm15000;teb216");
cds.configurator.DefaultRule.add(configurator, "bm15000;teb224");
cds.configurator.DefaultRule.add(configurator, "bm16000;sehhh");
cds.configurator.DefaultRule.add(configurator, "bm16000;selll");
cds.configurator.DefaultRule.add(configurator, "bm16000;semxl");
cds.configurator.DefaultRule.add(configurator, "bm16000;sexll");
cds.configurator.DefaultRule.add(configurator, "bm16000;smh03");
cds.configurator.DefaultRule.add(configurator, "bm16000;smh05");
cds.configurator.DefaultRule.add(configurator, "bm16000;smh08");
cds.configurator.DefaultRule.add(configurator, "bm16000;smt25");
cds.configurator.DefaultRule.add(configurator, "bm16000;tea011");
cds.configurator.DefaultRule.add(configurator, "bm16000;tea013");
cds.configurator.DefaultRule.add(configurator, "bm16000;tea017");
cds.configurator.DefaultRule.add(configurator, "bm16000;tea021");
cds.configurator.DefaultRule.add(configurator, "bm16000;tea023");
cds.configurator.DefaultRule.add(configurator, "bm16000;tea028");
cds.configurator.DefaultRule.add(configurator, "bm16000;tea029");
cds.configurator.DefaultRule.add(configurator, "bm16000;tea031");
cds.configurator.DefaultRule.add(configurator, "bm16000;tea033");
cds.configurator.DefaultRule.add(configurator, "bm16000;tea034");
cds.configurator.DefaultRule.add(configurator, "bm16000;tea035");
cds.configurator.DefaultRule.add(configurator, "bm16000;tea037");
cds.configurator.DefaultRule.add(configurator, "bm16000;tea038");
cds.configurator.DefaultRule.add(configurator, "bm16000;tea039");
cds.configurator.DefaultRule.add(configurator, "bm16000;tea041");
cds.configurator.DefaultRule.add(configurator, "bm16000;tea042");
cds.configurator.DefaultRule.add(configurator, "bm16000;tea043");
cds.configurator.DefaultRule.add(configurator, "bm16000;tea045");
cds.configurator.DefaultRule.add(configurator, "bm16000;tea046");
cds.configurator.DefaultRule.add(configurator, "bm16000;tea050");
cds.configurator.DefaultRule.add(configurator, "bm16000;tea052");
cds.configurator.DefaultRule.add(configurator, "bm16000;tea053");
cds.configurator.DefaultRule.add(configurator, "bm16000;tea056");
cds.configurator.DefaultRule.add(configurator, "bm16000;tea062");
cds.configurator.DefaultRule.add(configurator, "bm16000;tea063");
cds.configurator.DefaultRule.add(configurator, "bm16000;tea064");
cds.configurator.DefaultRule.add(configurator, "bm16000;tea067");
cds.configurator.DefaultRule.add(configurator, "bm16000;tea068");
cds.configurator.DefaultRule.add(configurator, "bm16000;tea070");
cds.configurator.DefaultRule.add(configurator, "bm16000;tea071");
cds.configurator.DefaultRule.add(configurator, "bm16000;tea072");
cds.configurator.DefaultRule.add(configurator, "bm16000;tea074");
cds.configurator.DefaultRule.add(configurator, "bm16000;tea075");
cds.configurator.DefaultRule.add(configurator, "bm16000;tea080");
cds.configurator.DefaultRule.add(configurator, "bm16000;tea084");
cds.configurator.DefaultRule.add(configurator, "bm16000;tea090");
cds.configurator.DefaultRule.add(configurator, "bm16000;tea096");
cds.configurator.DefaultRule.add(configurator, "bm16000;tea100");
cds.configurator.DefaultRule.add(configurator, "bm16000;tea112");
cds.configurator.DefaultRule.add(configurator, "bm16000;tea120");
cds.configurator.DefaultRule.add(configurator, "bm16000;tea126");
cds.configurator.DefaultRule.add(configurator, "bm16000;tea140");
cds.configurator.DefaultRule.add(configurator, "bm16000;tea144");
cds.configurator.DefaultRule.add(configurator, "bm16000;tea154");
cds.configurator.DefaultRule.add(configurator, "bm16000;tea168");
cds.configurator.DefaultRule.add(configurator, "bm16000;tea180");
cds.configurator.DefaultRule.add(configurator, "bm16000;tea192");
cds.configurator.DefaultRule.add(configurator, "bm16000;tea200");
cds.configurator.DefaultRule.add(configurator, "bm16000;tea216");
cds.configurator.DefaultRule.add(configurator, "bm16000;tea224");
cds.configurator.DefaultRule.add(configurator, "bm16000;teb011");
cds.configurator.DefaultRule.add(configurator, "bm16000;teb013");
cds.configurator.DefaultRule.add(configurator, "bm16000;teb017");
cds.configurator.DefaultRule.add(configurator, "bm16000;teb021");
cds.configurator.DefaultRule.add(configurator, "bm16000;teb023");
cds.configurator.DefaultRule.add(configurator, "bm16000;teb028");
cds.configurator.DefaultRule.add(configurator, "bm16000;teb029");
cds.configurator.DefaultRule.add(configurator, "bm16000;teb031");
cds.configurator.DefaultRule.add(configurator, "bm16000;teb033");
cds.configurator.DefaultRule.add(configurator, "bm16000;teb034");
cds.configurator.DefaultRule.add(configurator, "bm16000;teb035");
cds.configurator.DefaultRule.add(configurator, "bm16000;teb037");
cds.configurator.DefaultRule.add(configurator, "bm16000;teb038");
cds.configurator.DefaultRule.add(configurator, "bm16000;teb039");
cds.configurator.DefaultRule.add(configurator, "bm16000;teb041");
cds.configurator.DefaultRule.add(configurator, "bm16000;teb042");
cds.configurator.DefaultRule.add(configurator, "bm16000;teb043");
cds.configurator.DefaultRule.add(configurator, "bm16000;teb045");
cds.configurator.DefaultRule.add(configurator, "bm16000;teb046");
cds.configurator.DefaultRule.add(configurator, "bm16000;teb050");
cds.configurator.DefaultRule.add(configurator, "bm16000;teb052");
cds.configurator.DefaultRule.add(configurator, "bm16000;teb053");
cds.configurator.DefaultRule.add(configurator, "bm16000;teb056");
cds.configurator.DefaultRule.add(configurator, "bm16000;teb062");
cds.configurator.DefaultRule.add(configurator, "bm16000;teb063");
cds.configurator.DefaultRule.add(configurator, "bm16000;teb064");
cds.configurator.DefaultRule.add(configurator, "bm16000;teb067");
cds.configurator.DefaultRule.add(configurator, "bm16000;teb068");
cds.configurator.DefaultRule.add(configurator, "bm16000;teb070");
cds.configurator.DefaultRule.add(configurator, "bm16000;teb071");
cds.configurator.DefaultRule.add(configurator, "bm16000;teb072");
cds.configurator.DefaultRule.add(configurator, "bm16000;teb074");
cds.configurator.DefaultRule.add(configurator, "bm16000;teb075");
cds.configurator.DefaultRule.add(configurator, "bm16000;teb080");
cds.configurator.DefaultRule.add(configurator, "bm16000;teb084");
cds.configurator.DefaultRule.add(configurator, "bm16000;teb090");
cds.configurator.DefaultRule.add(configurator, "bm16000;teb096");
cds.configurator.DefaultRule.add(configurator, "bm16000;teb100");
cds.configurator.DefaultRule.add(configurator, "bm16000;teb112");
cds.configurator.DefaultRule.add(configurator, "bm16000;teb120");
cds.configurator.DefaultRule.add(configurator, "bm16000;teb126");
cds.configurator.DefaultRule.add(configurator, "bm16000;teb140");
cds.configurator.DefaultRule.add(configurator, "bm16000;teb144");
cds.configurator.DefaultRule.add(configurator, "bm16000;teb154");
cds.configurator.DefaultRule.add(configurator, "bm16000;teb168");
cds.configurator.DefaultRule.add(configurator, "bm16000;teb180");
cds.configurator.DefaultRule.add(configurator, "bm16000;teb192");
cds.configurator.DefaultRule.add(configurator, "bm16000;teb200");
cds.configurator.DefaultRule.add(configurator, "bm16000;teb216");
cds.configurator.DefaultRule.add(configurator, "bm16000;teb224");
cds.configurator.DefaultRule.add(configurator, "bm170000;sehhh");
cds.configurator.DefaultRule.add(configurator, "bm170000;selll");
cds.configurator.DefaultRule.add(configurator, "bm170000;semxl");
cds.configurator.DefaultRule.add(configurator, "bm170000;sexll");
cds.configurator.DefaultRule.add(configurator, "bm170000;sma05");
cds.configurator.DefaultRule.add(configurator, "bm170000;sma10");
cds.configurator.DefaultRule.add(configurator, "bm170000;smh03");
cds.configurator.DefaultRule.add(configurator, "bm170000;smh05");
cds.configurator.DefaultRule.add(configurator, "bm170000;smh08");
cds.configurator.DefaultRule.add(configurator, "bm170000;smt05");
cds.configurator.DefaultRule.add(configurator, "bm170000;smt10");
cds.configurator.DefaultRule.add(configurator, "bm170000;smt25");
cds.configurator.DefaultRule.add(configurator, "bm170000;tea010");
cds.configurator.DefaultRule.add(configurator, "bm170000;tea011");
cds.configurator.DefaultRule.add(configurator, "bm170000;tea012");
cds.configurator.DefaultRule.add(configurator, "bm170000;tea013");
cds.configurator.DefaultRule.add(configurator, "bm170000;tea014");
cds.configurator.DefaultRule.add(configurator, "bm170000;tea015");
cds.configurator.DefaultRule.add(configurator, "bm170000;tea016");
cds.configurator.DefaultRule.add(configurator, "bm170000;tea017");
cds.configurator.DefaultRule.add(configurator, "bm170000;tea018");
cds.configurator.DefaultRule.add(configurator, "bm170000;tea019");
cds.configurator.DefaultRule.add(configurator, "bm170000;tea020");
cds.configurator.DefaultRule.add(configurator, "bm170000;tea021");
cds.configurator.DefaultRule.add(configurator, "bm170000;tea022");
cds.configurator.DefaultRule.add(configurator, "bm170000;tea023");
cds.configurator.DefaultRule.add(configurator, "bm170000;tea024");
cds.configurator.DefaultRule.add(configurator, "bm170000;tea025");
cds.configurator.DefaultRule.add(configurator, "bm170000;tea026");
cds.configurator.DefaultRule.add(configurator, "bm170000;tea027");
cds.configurator.DefaultRule.add(configurator, "bm170000;tea028");
cds.configurator.DefaultRule.add(configurator, "bm170000;tea029");
cds.configurator.DefaultRule.add(configurator, "bm170000;tea030");
cds.configurator.DefaultRule.add(configurator, "bm170000;tea031");
cds.configurator.DefaultRule.add(configurator, "bm170000;tea032");
cds.configurator.DefaultRule.add(configurator, "bm170000;tea033");
cds.configurator.DefaultRule.add(configurator, "bm170000;tea034");
cds.configurator.DefaultRule.add(configurator, "bm170000;tea035");
cds.configurator.DefaultRule.add(configurator, "bm170000;tea037");
cds.configurator.DefaultRule.add(configurator, "bm170000;tea039");
cds.configurator.DefaultRule.add(configurator, "bm170000;tea041");
cds.configurator.DefaultRule.add(configurator, "bm170000;tea042");
cds.configurator.DefaultRule.add(configurator, "bm170000;tea043");
cds.configurator.DefaultRule.add(configurator, "bm170000;tea045");
cds.configurator.DefaultRule.add(configurator, "bm170000;tea046");
cds.configurator.DefaultRule.add(configurator, "bm170000;tea050");
cds.configurator.DefaultRule.add(configurator, "bm170000;tea053");
cds.configurator.DefaultRule.add(configurator, "bm170000;tea062");
cds.configurator.DefaultRule.add(configurator, "bm170000;tea063");
cds.configurator.DefaultRule.add(configurator, "bm170000;tea067");
cds.configurator.DefaultRule.add(configurator, "bm170000;tea070");
cds.configurator.DefaultRule.add(configurator, "bm170000;tea071");
cds.configurator.DefaultRule.add(configurator, "bm170000;tea074");
cds.configurator.DefaultRule.add(configurator, "bm170000;tea075");
cds.configurator.DefaultRule.add(configurator, "bm170000;tea084");
cds.configurator.DefaultRule.add(configurator, "bm170000;tea096");
cds.configurator.DefaultRule.add(configurator, "bm170000;tea100");
cds.configurator.DefaultRule.add(configurator, "bm170000;tea120");
cds.configurator.DefaultRule.add(configurator, "bm170000;tea126");
cds.configurator.DefaultRule.add(configurator, "bm170000;tea140");
cds.configurator.DefaultRule.add(configurator, "bm170000;tea154");
cds.configurator.DefaultRule.add(configurator, "bm170000;tea180");
cds.configurator.DefaultRule.add(configurator, "bm170000;tea200");
cds.configurator.DefaultRule.add(configurator, "bm170000;tea224");
cds.configurator.DefaultRule.add(configurator, "bm170000;teb010");
cds.configurator.DefaultRule.add(configurator, "bm170000;teb011");
cds.configurator.DefaultRule.add(configurator, "bm170000;teb012");
cds.configurator.DefaultRule.add(configurator, "bm170000;teb013");
cds.configurator.DefaultRule.add(configurator, "bm170000;teb014");
cds.configurator.DefaultRule.add(configurator, "bm170000;teb015");
cds.configurator.DefaultRule.add(configurator, "bm170000;teb016");
cds.configurator.DefaultRule.add(configurator, "bm170000;teb017");
cds.configurator.DefaultRule.add(configurator, "bm170000;teb018");
cds.configurator.DefaultRule.add(configurator, "bm170000;teb019");
cds.configurator.DefaultRule.add(configurator, "bm170000;teb020");
cds.configurator.DefaultRule.add(configurator, "bm170000;teb021");
cds.configurator.DefaultRule.add(configurator, "bm170000;teb022");
cds.configurator.DefaultRule.add(configurator, "bm170000;teb023");
cds.configurator.DefaultRule.add(configurator, "bm170000;teb024");
cds.configurator.DefaultRule.add(configurator, "bm170000;teb025");
cds.configurator.DefaultRule.add(configurator, "bm170000;teb026");
cds.configurator.DefaultRule.add(configurator, "bm170000;teb027");
cds.configurator.DefaultRule.add(configurator, "bm170000;teb028");
cds.configurator.DefaultRule.add(configurator, "bm170000;teb029");
cds.configurator.DefaultRule.add(configurator, "bm170000;teb030");
cds.configurator.DefaultRule.add(configurator, "bm170000;teb031");
cds.configurator.DefaultRule.add(configurator, "bm170000;teb032");
cds.configurator.DefaultRule.add(configurator, "bm170000;teb033");
cds.configurator.DefaultRule.add(configurator, "bm170000;teb034");
cds.configurator.DefaultRule.add(configurator, "bm170000;teb035");
cds.configurator.DefaultRule.add(configurator, "bm170000;teb037");
cds.configurator.DefaultRule.add(configurator, "bm170000;teb039");
cds.configurator.DefaultRule.add(configurator, "bm170000;teb041");
cds.configurator.DefaultRule.add(configurator, "bm170000;teb042");
cds.configurator.DefaultRule.add(configurator, "bm170000;teb043");
cds.configurator.DefaultRule.add(configurator, "bm170000;teb045");
cds.configurator.DefaultRule.add(configurator, "bm170000;teb046");
cds.configurator.DefaultRule.add(configurator, "bm170000;teb050");
cds.configurator.DefaultRule.add(configurator, "bm170000;teb053");
cds.configurator.DefaultRule.add(configurator, "bm170000;teb062");
cds.configurator.DefaultRule.add(configurator, "bm170000;teb063");
cds.configurator.DefaultRule.add(configurator, "bm170000;teb067");
cds.configurator.DefaultRule.add(configurator, "bm170000;teb070");
cds.configurator.DefaultRule.add(configurator, "bm170000;teb071");
cds.configurator.DefaultRule.add(configurator, "bm170000;teb074");
cds.configurator.DefaultRule.add(configurator, "bm170000;teb075");
cds.configurator.DefaultRule.add(configurator, "bm170000;teb084");
cds.configurator.DefaultRule.add(configurator, "bm170000;teb096");
cds.configurator.DefaultRule.add(configurator, "bm170000;teb100");
cds.configurator.DefaultRule.add(configurator, "bm170000;teb120");
cds.configurator.DefaultRule.add(configurator, "bm170000;teb126");
cds.configurator.DefaultRule.add(configurator, "bm170000;teb140");
cds.configurator.DefaultRule.add(configurator, "bm170000;teb154");
cds.configurator.DefaultRule.add(configurator, "bm170000;teb180");
cds.configurator.DefaultRule.add(configurator, "bm170000;teb200");
cds.configurator.DefaultRule.add(configurator, "bm170000;teb224");
cds.configurator.DefaultRule.add(configurator, "bm19050;sehhh");
cds.configurator.DefaultRule.add(configurator, "bm19050;semxl");
cds.configurator.DefaultRule.add(configurator, "bm19050;sexll");
cds.configurator.DefaultRule.add(configurator, "bm19050;sma05");
cds.configurator.DefaultRule.add(configurator, "bm19050;sma10");
cds.configurator.DefaultRule.add(configurator, "bm19050;smh03");
cds.configurator.DefaultRule.add(configurator, "bm19050;smh05");
cds.configurator.DefaultRule.add(configurator, "bm19050;smh08");
cds.configurator.DefaultRule.add(configurator, "bm19050;smt05");
cds.configurator.DefaultRule.add(configurator, "bm19050;smt10");
cds.configurator.DefaultRule.add(configurator, "bm19050;smt25");
cds.configurator.DefaultRule.add(configurator, "bm19050;tea010");
cds.configurator.DefaultRule.add(configurator, "bm19050;tea011");
cds.configurator.DefaultRule.add(configurator, "bm19050;tea023");
cds.configurator.DefaultRule.add(configurator, "bm19050;tea025");
cds.configurator.DefaultRule.add(configurator, "bm19050;tea027");
cds.configurator.DefaultRule.add(configurator, "bm19050;tea029");
cds.configurator.DefaultRule.add(configurator, "bm19050;tea031");
cds.configurator.DefaultRule.add(configurator, "bm19050;tea033");
cds.configurator.DefaultRule.add(configurator, "bm19050;tea034");
cds.configurator.DefaultRule.add(configurator, "bm19050;tea035");
cds.configurator.DefaultRule.add(configurator, "bm19050;tea037");
cds.configurator.DefaultRule.add(configurator, "bm19050;tea038");
cds.configurator.DefaultRule.add(configurator, "bm19050;tea039");
cds.configurator.DefaultRule.add(configurator, "bm19050;tea041");
cds.configurator.DefaultRule.add(configurator, "bm19050;tea042");
cds.configurator.DefaultRule.add(configurator, "bm19050;tea043");
cds.configurator.DefaultRule.add(configurator, "bm19050;tea045");
cds.configurator.DefaultRule.add(configurator, "bm19050;tea046");
cds.configurator.DefaultRule.add(configurator, "bm19050;tea050");
cds.configurator.DefaultRule.add(configurator, "bm19050;tea052");
cds.configurator.DefaultRule.add(configurator, "bm19050;tea053");
cds.configurator.DefaultRule.add(configurator, "bm19050;tea056");
cds.configurator.DefaultRule.add(configurator, "bm19050;tea062");
cds.configurator.DefaultRule.add(configurator, "bm19050;tea063");
cds.configurator.DefaultRule.add(configurator, "bm19050;tea064");
cds.configurator.DefaultRule.add(configurator, "bm19050;tea067");
cds.configurator.DefaultRule.add(configurator, "bm19050;tea068");
cds.configurator.DefaultRule.add(configurator, "bm19050;tea070");
cds.configurator.DefaultRule.add(configurator, "bm19050;tea071");
cds.configurator.DefaultRule.add(configurator, "bm19050;tea074");
cds.configurator.DefaultRule.add(configurator, "bm19050;tea075");
cds.configurator.DefaultRule.add(configurator, "bm19050;tea080");
cds.configurator.DefaultRule.add(configurator, "bm19050;tea090");
cds.configurator.DefaultRule.add(configurator, "bm19050;tea100");
cds.configurator.DefaultRule.add(configurator, "bm19050;tea112");
cds.configurator.DefaultRule.add(configurator, "bm19050;tea126");
cds.configurator.DefaultRule.add(configurator, "bm19050;tea140");
cds.configurator.DefaultRule.add(configurator, "bm19050;tea144");
cds.configurator.DefaultRule.add(configurator, "bm19050;tea154");
cds.configurator.DefaultRule.add(configurator, "bm19050;tea168");
cds.configurator.DefaultRule.add(configurator, "bm19050;tea180");
cds.configurator.DefaultRule.add(configurator, "bm19050;tea192");
cds.configurator.DefaultRule.add(configurator, "bm19050;tea200");
cds.configurator.DefaultRule.add(configurator, "bm19050;tea216");
cds.configurator.DefaultRule.add(configurator, "bm19050;tea224");
cds.configurator.DefaultRule.add(configurator, "bm19050;teb010");
cds.configurator.DefaultRule.add(configurator, "bm19050;teb011");
cds.configurator.DefaultRule.add(configurator, "bm19050;teb023");
cds.configurator.DefaultRule.add(configurator, "bm19050;teb025");
cds.configurator.DefaultRule.add(configurator, "bm19050;teb027");
cds.configurator.DefaultRule.add(configurator, "bm19050;teb029");
cds.configurator.DefaultRule.add(configurator, "bm19050;teb031");
cds.configurator.DefaultRule.add(configurator, "bm19050;teb033");
cds.configurator.DefaultRule.add(configurator, "bm19050;teb034");
cds.configurator.DefaultRule.add(configurator, "bm19050;teb035");
cds.configurator.DefaultRule.add(configurator, "bm19050;teb037");
cds.configurator.DefaultRule.add(configurator, "bm19050;teb038");
cds.configurator.DefaultRule.add(configurator, "bm19050;teb039");
cds.configurator.DefaultRule.add(configurator, "bm19050;teb041");
cds.configurator.DefaultRule.add(configurator, "bm19050;teb042");
cds.configurator.DefaultRule.add(configurator, "bm19050;teb043");
cds.configurator.DefaultRule.add(configurator, "bm19050;teb045");
cds.configurator.DefaultRule.add(configurator, "bm19050;teb046");
cds.configurator.DefaultRule.add(configurator, "bm19050;teb050");
cds.configurator.DefaultRule.add(configurator, "bm19050;teb052");
cds.configurator.DefaultRule.add(configurator, "bm19050;teb053");
cds.configurator.DefaultRule.add(configurator, "bm19050;teb056");
cds.configurator.DefaultRule.add(configurator, "bm19050;teb062");
cds.configurator.DefaultRule.add(configurator, "bm19050;teb063");
cds.configurator.DefaultRule.add(configurator, "bm19050;teb064");
cds.configurator.DefaultRule.add(configurator, "bm19050;teb067");
cds.configurator.DefaultRule.add(configurator, "bm19050;teb068");
cds.configurator.DefaultRule.add(configurator, "bm19050;teb070");
cds.configurator.DefaultRule.add(configurator, "bm19050;teb071");
cds.configurator.DefaultRule.add(configurator, "bm19050;teb074");
cds.configurator.DefaultRule.add(configurator, "bm19050;teb075");
cds.configurator.DefaultRule.add(configurator, "bm19050;teb080");
cds.configurator.DefaultRule.add(configurator, "bm19050;teb090");
cds.configurator.DefaultRule.add(configurator, "bm19050;teb100");
cds.configurator.DefaultRule.add(configurator, "bm19050;teb112");
cds.configurator.DefaultRule.add(configurator, "bm19050;teb126");
cds.configurator.DefaultRule.add(configurator, "bm19050;teb140");
cds.configurator.DefaultRule.add(configurator, "bm19050;teb144");
cds.configurator.DefaultRule.add(configurator, "bm19050;teb154");
cds.configurator.DefaultRule.add(configurator, "bm19050;teb168");
cds.configurator.DefaultRule.add(configurator, "bm19050;teb180");
cds.configurator.DefaultRule.add(configurator, "bm19050;teb192");
cds.configurator.DefaultRule.add(configurator, "bm19050;teb200");
cds.configurator.DefaultRule.add(configurator, "bm19050;teb216");
cds.configurator.DefaultRule.add(configurator, "bm19050;teb224");
cds.configurator.DefaultRule.add(configurator, "bm20000;sehhh");
cds.configurator.DefaultRule.add(configurator, "bm20000;selll");
cds.configurator.DefaultRule.add(configurator, "bm20000;semxl");
cds.configurator.DefaultRule.add(configurator, "bm20000;sexll");
cds.configurator.DefaultRule.add(configurator, "bm20000;sma05");
cds.configurator.DefaultRule.add(configurator, "bm20000;sma10");
cds.configurator.DefaultRule.add(configurator, "bm20000;smh03");
cds.configurator.DefaultRule.add(configurator, "bm20000;smh05");
cds.configurator.DefaultRule.add(configurator, "bm20000;smt05");
cds.configurator.DefaultRule.add(configurator, "bm20000;smt10");
cds.configurator.DefaultRule.add(configurator, "bm20000;smt25");
cds.configurator.DefaultRule.add(configurator, "bm20000;tea010");
cds.configurator.DefaultRule.add(configurator, "bm20000;tea011");
cds.configurator.DefaultRule.add(configurator, "bm20000;tea012");
cds.configurator.DefaultRule.add(configurator, "bm20000;tea013");
cds.configurator.DefaultRule.add(configurator, "bm20000;tea014");
cds.configurator.DefaultRule.add(configurator, "bm20000;tea015");
cds.configurator.DefaultRule.add(configurator, "bm20000;tea016");
cds.configurator.DefaultRule.add(configurator, "bm20000;tea017");
cds.configurator.DefaultRule.add(configurator, "bm20000;tea018");
cds.configurator.DefaultRule.add(configurator, "bm20000;tea019");
cds.configurator.DefaultRule.add(configurator, "bm20000;tea020");
cds.configurator.DefaultRule.add(configurator, "bm20000;tea021");
cds.configurator.DefaultRule.add(configurator, "bm20000;tea023");
cds.configurator.DefaultRule.add(configurator, "bm20000;tea041");
cds.configurator.DefaultRule.add(configurator, "bm20000;tea052");
cds.configurator.DefaultRule.add(configurator, "bm20000;tea062");
cds.configurator.DefaultRule.add(configurator, "bm20000;tea068");
cds.configurator.DefaultRule.add(configurator, "bm20000;tea070");
cds.configurator.DefaultRule.add(configurator, "bm20000;tea074");
cds.configurator.DefaultRule.add(configurator, "bm20000;tea084");
cds.configurator.DefaultRule.add(configurator, "bm20000;tea096");
cds.configurator.DefaultRule.add(configurator, "bm20000;tea100");
cds.configurator.DefaultRule.add(configurator, "bm20000;tea120");
cds.configurator.DefaultRule.add(configurator, "bm20000;tea216");
cds.configurator.DefaultRule.add(configurator, "bm20000;teb010");
cds.configurator.DefaultRule.add(configurator, "bm20000;teb011");
cds.configurator.DefaultRule.add(configurator, "bm20000;teb012");
cds.configurator.DefaultRule.add(configurator, "bm20000;teb013");
cds.configurator.DefaultRule.add(configurator, "bm20000;teb014");
cds.configurator.DefaultRule.add(configurator, "bm20000;teb015");
cds.configurator.DefaultRule.add(configurator, "bm20000;teb016");
cds.configurator.DefaultRule.add(configurator, "bm20000;teb017");
cds.configurator.DefaultRule.add(configurator, "bm20000;teb018");
cds.configurator.DefaultRule.add(configurator, "bm20000;teb019");
cds.configurator.DefaultRule.add(configurator, "bm20000;teb020");
cds.configurator.DefaultRule.add(configurator, "bm20000;teb021");
cds.configurator.DefaultRule.add(configurator, "bm20000;teb023");
cds.configurator.DefaultRule.add(configurator, "bm20000;teb041");
cds.configurator.DefaultRule.add(configurator, "bm20000;teb052");
cds.configurator.DefaultRule.add(configurator, "bm20000;teb062");
cds.configurator.DefaultRule.add(configurator, "bm20000;teb068");
cds.configurator.DefaultRule.add(configurator, "bm20000;teb070");
cds.configurator.DefaultRule.add(configurator, "bm20000;teb074");
cds.configurator.DefaultRule.add(configurator, "bm20000;teb084");
cds.configurator.DefaultRule.add(configurator, "bm20000;teb096");
cds.configurator.DefaultRule.add(configurator, "bm20000;teb100");
cds.configurator.DefaultRule.add(configurator, "bm20000;teb120");
cds.configurator.DefaultRule.add(configurator, "bm20000;teb216");
cds.configurator.DefaultRule.add(configurator, "bm21000;sehhh");
cds.configurator.DefaultRule.add(configurator, "bm21000;selll");
cds.configurator.DefaultRule.add(configurator, "bm21000;semxl");
cds.configurator.DefaultRule.add(configurator, "bm21000;sexll");
cds.configurator.DefaultRule.add(configurator, "bm21000;sma05");
cds.configurator.DefaultRule.add(configurator, "bm21000;sma10");
cds.configurator.DefaultRule.add(configurator, "bm21000;smh03");
cds.configurator.DefaultRule.add(configurator, "bm21000;smh05");
cds.configurator.DefaultRule.add(configurator, "bm21000;smh08");
cds.configurator.DefaultRule.add(configurator, "bm21000;smt05");
cds.configurator.DefaultRule.add(configurator, "bm21000;smt10");
cds.configurator.DefaultRule.add(configurator, "bm21000;smt25");
cds.configurator.DefaultRule.add(configurator, "bm21000;tea010");
cds.configurator.DefaultRule.add(configurator, "bm21000;tea011");
cds.configurator.DefaultRule.add(configurator, "bm21000;tea012");
cds.configurator.DefaultRule.add(configurator, "bm21000;tea013");
cds.configurator.DefaultRule.add(configurator, "bm21000;tea014");
cds.configurator.DefaultRule.add(configurator, "bm21000;tea015");
cds.configurator.DefaultRule.add(configurator, "bm21000;tea016");
cds.configurator.DefaultRule.add(configurator, "bm21000;tea017");
cds.configurator.DefaultRule.add(configurator, "bm21000;tea018");
cds.configurator.DefaultRule.add(configurator, "bm21000;tea019");
cds.configurator.DefaultRule.add(configurator, "bm21000;tea020");
cds.configurator.DefaultRule.add(configurator, "bm21000;tea021");
cds.configurator.DefaultRule.add(configurator, "bm21000;tea023");
cds.configurator.DefaultRule.add(configurator, "bm21000;tea024");
cds.configurator.DefaultRule.add(configurator, "bm21000;tea043");
cds.configurator.DefaultRule.add(configurator, "bm21000;tea044");
cds.configurator.DefaultRule.add(configurator, "bm21000;tea046");
cds.configurator.DefaultRule.add(configurator, "bm21000;tea052");
cds.configurator.DefaultRule.add(configurator, "bm21000;tea062");
cds.configurator.DefaultRule.add(configurator, "bm21000;tea064");
cds.configurator.DefaultRule.add(configurator, "bm21000;tea068");
cds.configurator.DefaultRule.add(configurator, "bm21000;tea070");
cds.configurator.DefaultRule.add(configurator, "bm21000;tea072");
cds.configurator.DefaultRule.add(configurator, "bm21000;tea074");
cds.configurator.DefaultRule.add(configurator, "bm21000;tea084");
cds.configurator.DefaultRule.add(configurator, "bm21000;tea096");
cds.configurator.DefaultRule.add(configurator, "bm21000;tea100");
cds.configurator.DefaultRule.add(configurator, "bm21000;tea120");
cds.configurator.DefaultRule.add(configurator, "bm21000;tea126");
cds.configurator.DefaultRule.add(configurator, "bm21000;tea144");
cds.configurator.DefaultRule.add(configurator, "bm21000;tea154");
cds.configurator.DefaultRule.add(configurator, "bm21000;tea168");
cds.configurator.DefaultRule.add(configurator, "bm21000;tea192");
cds.configurator.DefaultRule.add(configurator, "bm21000;tea200");
cds.configurator.DefaultRule.add(configurator, "bm21000;tea216");
cds.configurator.DefaultRule.add(configurator, "bm21000;teb010");
cds.configurator.DefaultRule.add(configurator, "bm21000;teb011");
cds.configurator.DefaultRule.add(configurator, "bm21000;teb012");
cds.configurator.DefaultRule.add(configurator, "bm21000;teb013");
cds.configurator.DefaultRule.add(configurator, "bm21000;teb014");
cds.configurator.DefaultRule.add(configurator, "bm21000;teb015");
cds.configurator.DefaultRule.add(configurator, "bm21000;teb016");
cds.configurator.DefaultRule.add(configurator, "bm21000;teb017");
cds.configurator.DefaultRule.add(configurator, "bm21000;teb018");
cds.configurator.DefaultRule.add(configurator, "bm21000;teb019");
cds.configurator.DefaultRule.add(configurator, "bm21000;teb020");
cds.configurator.DefaultRule.add(configurator, "bm21000;teb021");
cds.configurator.DefaultRule.add(configurator, "bm21000;teb023");
cds.configurator.DefaultRule.add(configurator, "bm21000;teb024");
cds.configurator.DefaultRule.add(configurator, "bm21000;teb043");
cds.configurator.DefaultRule.add(configurator, "bm21000;teb044");
cds.configurator.DefaultRule.add(configurator, "bm21000;teb046");
cds.configurator.DefaultRule.add(configurator, "bm21000;teb052");
cds.configurator.DefaultRule.add(configurator, "bm21000;teb062");
cds.configurator.DefaultRule.add(configurator, "bm21000;teb064");
cds.configurator.DefaultRule.add(configurator, "bm21000;teb068");
cds.configurator.DefaultRule.add(configurator, "bm21000;teb070");
cds.configurator.DefaultRule.add(configurator, "bm21000;teb072");
cds.configurator.DefaultRule.add(configurator, "bm21000;teb074");
cds.configurator.DefaultRule.add(configurator, "bm21000;teb084");
cds.configurator.DefaultRule.add(configurator, "bm21000;teb096");
cds.configurator.DefaultRule.add(configurator, "bm21000;teb100");
cds.configurator.DefaultRule.add(configurator, "bm21000;teb120");
cds.configurator.DefaultRule.add(configurator, "bm21000;teb126");
cds.configurator.DefaultRule.add(configurator, "bm21000;teb144");
cds.configurator.DefaultRule.add(configurator, "bm21000;teb154");
cds.configurator.DefaultRule.add(configurator, "bm21000;teb168");
cds.configurator.DefaultRule.add(configurator, "bm21000;teb192");
cds.configurator.DefaultRule.add(configurator, "bm21000;teb200");
cds.configurator.DefaultRule.add(configurator, "bm21000;teb216");
cds.configurator.DefaultRule.add(configurator, "bm25000;sehhh");
cds.configurator.DefaultRule.add(configurator, "bm25000;selll");
cds.configurator.DefaultRule.add(configurator, "bm25000;semxl");
cds.configurator.DefaultRule.add(configurator, "bm25000;sexll");
cds.configurator.DefaultRule.add(configurator, "bm25000;smh03");
cds.configurator.DefaultRule.add(configurator, "bm25000;smh08");
cds.configurator.DefaultRule.add(configurator, "bm25000;smt25");
cds.configurator.DefaultRule.add(configurator, "bm25000;tea011");
cds.configurator.DefaultRule.add(configurator, "bm25000;tea013");
cds.configurator.DefaultRule.add(configurator, "bm25000;tea017");
cds.configurator.DefaultRule.add(configurator, "bm25000;tea029");
cds.configurator.DefaultRule.add(configurator, "bm25000;tea031");
cds.configurator.DefaultRule.add(configurator, "bm25000;tea033");
cds.configurator.DefaultRule.add(configurator, "bm25000;tea035");
cds.configurator.DefaultRule.add(configurator, "bm25000;tea037");
cds.configurator.DefaultRule.add(configurator, "bm25000;tea039");
cds.configurator.DefaultRule.add(configurator, "bm25000;tea041");
cds.configurator.DefaultRule.add(configurator, "bm25000;tea042");
cds.configurator.DefaultRule.add(configurator, "bm25000;tea043");
cds.configurator.DefaultRule.add(configurator, "bm25000;tea046");
cds.configurator.DefaultRule.add(configurator, "bm25000;tea053");
cds.configurator.DefaultRule.add(configurator, "bm25000;tea062");
cds.configurator.DefaultRule.add(configurator, "bm25000;tea063");
cds.configurator.DefaultRule.add(configurator, "bm25000;tea067");
cds.configurator.DefaultRule.add(configurator, "bm25000;tea070");
cds.configurator.DefaultRule.add(configurator, "bm25000;tea071");
cds.configurator.DefaultRule.add(configurator, "bm25000;tea074");
cds.configurator.DefaultRule.add(configurator, "bm25000;tea075");
cds.configurator.DefaultRule.add(configurator, "bm25000;tea084");
cds.configurator.DefaultRule.add(configurator, "bm25000;tea096");
cds.configurator.DefaultRule.add(configurator, "bm25000;tea100");
cds.configurator.DefaultRule.add(configurator, "bm25000;tea120");
cds.configurator.DefaultRule.add(configurator, "bm25000;tea126");
cds.configurator.DefaultRule.add(configurator, "bm25000;tea140");
cds.configurator.DefaultRule.add(configurator, "bm25000;tea144");
cds.configurator.DefaultRule.add(configurator, "bm25000;tea154");
cds.configurator.DefaultRule.add(configurator, "bm25000;tea168");
cds.configurator.DefaultRule.add(configurator, "bm25000;tea180");
cds.configurator.DefaultRule.add(configurator, "bm25000;tea192");
cds.configurator.DefaultRule.add(configurator, "bm25000;tea200");
cds.configurator.DefaultRule.add(configurator, "bm25000;tea216");
cds.configurator.DefaultRule.add(configurator, "bm25000;tea224");
cds.configurator.DefaultRule.add(configurator, "bm25000;teb011");
cds.configurator.DefaultRule.add(configurator, "bm25000;teb013");
cds.configurator.DefaultRule.add(configurator, "bm25000;teb017");
cds.configurator.DefaultRule.add(configurator, "bm25000;teb029");
cds.configurator.DefaultRule.add(configurator, "bm25000;teb031");
cds.configurator.DefaultRule.add(configurator, "bm25000;teb033");
cds.configurator.DefaultRule.add(configurator, "bm25000;teb035");
cds.configurator.DefaultRule.add(configurator, "bm25000;teb037");
cds.configurator.DefaultRule.add(configurator, "bm25000;teb039");
cds.configurator.DefaultRule.add(configurator, "bm25000;teb041");
cds.configurator.DefaultRule.add(configurator, "bm25000;teb042");
cds.configurator.DefaultRule.add(configurator, "bm25000;teb043");
cds.configurator.DefaultRule.add(configurator, "bm25000;teb046");
cds.configurator.DefaultRule.add(configurator, "bm25000;teb053");
cds.configurator.DefaultRule.add(configurator, "bm25000;teb062");
cds.configurator.DefaultRule.add(configurator, "bm25000;teb063");
cds.configurator.DefaultRule.add(configurator, "bm25000;teb067");
cds.configurator.DefaultRule.add(configurator, "bm25000;teb070");
cds.configurator.DefaultRule.add(configurator, "bm25000;teb071");
cds.configurator.DefaultRule.add(configurator, "bm25000;teb074");
cds.configurator.DefaultRule.add(configurator, "bm25000;teb075");
cds.configurator.DefaultRule.add(configurator, "bm25000;teb084");
cds.configurator.DefaultRule.add(configurator, "bm25000;teb096");
cds.configurator.DefaultRule.add(configurator, "bm25000;teb100");
cds.configurator.DefaultRule.add(configurator, "bm25000;teb120");
cds.configurator.DefaultRule.add(configurator, "bm25000;teb126");
cds.configurator.DefaultRule.add(configurator, "bm25000;teb140");
cds.configurator.DefaultRule.add(configurator, "bm25000;teb144");
cds.configurator.DefaultRule.add(configurator, "bm25000;teb154");
cds.configurator.DefaultRule.add(configurator, "bm25000;teb168");
cds.configurator.DefaultRule.add(configurator, "bm25000;teb180");
cds.configurator.DefaultRule.add(configurator, "bm25000;teb192");
cds.configurator.DefaultRule.add(configurator, "bm25000;teb200");
cds.configurator.DefaultRule.add(configurator, "bm25000;teb216");
cds.configurator.DefaultRule.add(configurator, "bm25000;teb224");
cds.configurator.DefaultRule.add(configurator, "bm25400;semxl");
cds.configurator.DefaultRule.add(configurator, "bm25400;sexll");
cds.configurator.DefaultRule.add(configurator, "bm25400;sma05");
cds.configurator.DefaultRule.add(configurator, "bm25400;sma10");
cds.configurator.DefaultRule.add(configurator, "bm25400;smh03");
cds.configurator.DefaultRule.add(configurator, "bm25400;smh05");
cds.configurator.DefaultRule.add(configurator, "bm25400;smh08");
cds.configurator.DefaultRule.add(configurator, "bm25400;smt05");
cds.configurator.DefaultRule.add(configurator, "bm25400;smt10");
cds.configurator.DefaultRule.add(configurator, "bm25400;smt25");
cds.configurator.DefaultRule.add(configurator, "bm25400;tea010");
cds.configurator.DefaultRule.add(configurator, "bm25400;tea011");
cds.configurator.DefaultRule.add(configurator, "bm25400;tea012");
cds.configurator.DefaultRule.add(configurator, "bm25400;tea023");
cds.configurator.DefaultRule.add(configurator, "bm25400;tea025");
cds.configurator.DefaultRule.add(configurator, "bm25400;tea027");
cds.configurator.DefaultRule.add(configurator, "bm25400;tea029");
cds.configurator.DefaultRule.add(configurator, "bm25400;tea031");
cds.configurator.DefaultRule.add(configurator, "bm25400;tea033");
cds.configurator.DefaultRule.add(configurator, "bm25400;tea034");
cds.configurator.DefaultRule.add(configurator, "bm25400;tea035");
cds.configurator.DefaultRule.add(configurator, "bm25400;tea037");
cds.configurator.DefaultRule.add(configurator, "bm25400;tea038");
cds.configurator.DefaultRule.add(configurator, "bm25400;tea039");
cds.configurator.DefaultRule.add(configurator, "bm25400;tea041");
cds.configurator.DefaultRule.add(configurator, "bm25400;tea042");
cds.configurator.DefaultRule.add(configurator, "bm25400;tea043");
cds.configurator.DefaultRule.add(configurator, "bm25400;tea045");
cds.configurator.DefaultRule.add(configurator, "bm25400;tea046");
cds.configurator.DefaultRule.add(configurator, "bm25400;tea050");
cds.configurator.DefaultRule.add(configurator, "bm25400;tea052");
cds.configurator.DefaultRule.add(configurator, "bm25400;tea053");
cds.configurator.DefaultRule.add(configurator, "bm25400;tea056");
cds.configurator.DefaultRule.add(configurator, "bm25400;tea062");
cds.configurator.DefaultRule.add(configurator, "bm25400;tea063");
cds.configurator.DefaultRule.add(configurator, "bm25400;tea064");
cds.configurator.DefaultRule.add(configurator, "bm25400;tea067");
cds.configurator.DefaultRule.add(configurator, "bm25400;tea068");
cds.configurator.DefaultRule.add(configurator, "bm25400;tea070");
cds.configurator.DefaultRule.add(configurator, "bm25400;tea071");
cds.configurator.DefaultRule.add(configurator, "bm25400;tea074");
cds.configurator.DefaultRule.add(configurator, "bm25400;tea075");
cds.configurator.DefaultRule.add(configurator, "bm25400;tea080");
cds.configurator.DefaultRule.add(configurator, "bm25400;tea090");
cds.configurator.DefaultRule.add(configurator, "bm25400;tea100");
cds.configurator.DefaultRule.add(configurator, "bm25400;tea112");
cds.configurator.DefaultRule.add(configurator, "bm25400;tea126");
cds.configurator.DefaultRule.add(configurator, "bm25400;tea140");
cds.configurator.DefaultRule.add(configurator, "bm25400;tea144");
cds.configurator.DefaultRule.add(configurator, "bm25400;tea154");
cds.configurator.DefaultRule.add(configurator, "bm25400;tea168");
cds.configurator.DefaultRule.add(configurator, "bm25400;tea180");
cds.configurator.DefaultRule.add(configurator, "bm25400;tea192");
cds.configurator.DefaultRule.add(configurator, "bm25400;tea200");
cds.configurator.DefaultRule.add(configurator, "bm25400;tea216");
cds.configurator.DefaultRule.add(configurator, "bm25400;tea224");
cds.configurator.DefaultRule.add(configurator, "bm25400;teb010");
cds.configurator.DefaultRule.add(configurator, "bm25400;teb011");
cds.configurator.DefaultRule.add(configurator, "bm25400;teb012");
cds.configurator.DefaultRule.add(configurator, "bm25400;teb023");
cds.configurator.DefaultRule.add(configurator, "bm25400;teb025");
cds.configurator.DefaultRule.add(configurator, "bm25400;teb027");
cds.configurator.DefaultRule.add(configurator, "bm25400;teb029");
cds.configurator.DefaultRule.add(configurator, "bm25400;teb031");
cds.configurator.DefaultRule.add(configurator, "bm25400;teb033");
cds.configurator.DefaultRule.add(configurator, "bm25400;teb034");
cds.configurator.DefaultRule.add(configurator, "bm25400;teb035");
cds.configurator.DefaultRule.add(configurator, "bm25400;teb037");
cds.configurator.DefaultRule.add(configurator, "bm25400;teb038");
cds.configurator.DefaultRule.add(configurator, "bm25400;teb039");
cds.configurator.DefaultRule.add(configurator, "bm25400;teb041");
cds.configurator.DefaultRule.add(configurator, "bm25400;teb042");
cds.configurator.DefaultRule.add(configurator, "bm25400;teb043");
cds.configurator.DefaultRule.add(configurator, "bm25400;teb045");
cds.configurator.DefaultRule.add(configurator, "bm25400;teb046");
cds.configurator.DefaultRule.add(configurator, "bm25400;teb050");
cds.configurator.DefaultRule.add(configurator, "bm25400;teb052");
cds.configurator.DefaultRule.add(configurator, "bm25400;teb053");
cds.configurator.DefaultRule.add(configurator, "bm25400;teb056");
cds.configurator.DefaultRule.add(configurator, "bm25400;teb062");
cds.configurator.DefaultRule.add(configurator, "bm25400;teb063");
cds.configurator.DefaultRule.add(configurator, "bm25400;teb064");
cds.configurator.DefaultRule.add(configurator, "bm25400;teb067");
cds.configurator.DefaultRule.add(configurator, "bm25400;teb068");
cds.configurator.DefaultRule.add(configurator, "bm25400;teb070");
cds.configurator.DefaultRule.add(configurator, "bm25400;teb071");
cds.configurator.DefaultRule.add(configurator, "bm25400;teb074");
cds.configurator.DefaultRule.add(configurator, "bm25400;teb075");
cds.configurator.DefaultRule.add(configurator, "bm25400;teb080");
cds.configurator.DefaultRule.add(configurator, "bm25400;teb090");
cds.configurator.DefaultRule.add(configurator, "bm25400;teb100");
cds.configurator.DefaultRule.add(configurator, "bm25400;teb112");
cds.configurator.DefaultRule.add(configurator, "bm25400;teb126");
cds.configurator.DefaultRule.add(configurator, "bm25400;teb140");
cds.configurator.DefaultRule.add(configurator, "bm25400;teb144");
cds.configurator.DefaultRule.add(configurator, "bm25400;teb154");
cds.configurator.DefaultRule.add(configurator, "bm25400;teb168");
cds.configurator.DefaultRule.add(configurator, "bm25400;teb180");
cds.configurator.DefaultRule.add(configurator, "bm25400;teb192");
cds.configurator.DefaultRule.add(configurator, "bm25400;teb200");
cds.configurator.DefaultRule.add(configurator, "bm25400;teb216");
cds.configurator.DefaultRule.add(configurator, "bm25400;teb224");
cds.configurator.DefaultRule.add(configurator, "bm30000;sehhh");
cds.configurator.DefaultRule.add(configurator, "bm30000;selll");
cds.configurator.DefaultRule.add(configurator, "bm30000;semxl");
cds.configurator.DefaultRule.add(configurator, "bm30000;sexll");
cds.configurator.DefaultRule.add(configurator, "bm30000;sma05");
cds.configurator.DefaultRule.add(configurator, "bm30000;sma10");
cds.configurator.DefaultRule.add(configurator, "bm30000;smh03");
cds.configurator.DefaultRule.add(configurator, "bm30000;smh05");
cds.configurator.DefaultRule.add(configurator, "bm30000;smt05");
cds.configurator.DefaultRule.add(configurator, "bm30000;smt10");
cds.configurator.DefaultRule.add(configurator, "bm30000;smt25");
cds.configurator.DefaultRule.add(configurator, "bm30000;tea010");
cds.configurator.DefaultRule.add(configurator, "bm30000;tea011");
cds.configurator.DefaultRule.add(configurator, "bm30000;tea012");
cds.configurator.DefaultRule.add(configurator, "bm30000;tea013");
cds.configurator.DefaultRule.add(configurator, "bm30000;tea014");
cds.configurator.DefaultRule.add(configurator, "bm30000;tea015");
cds.configurator.DefaultRule.add(configurator, "bm30000;tea016");
cds.configurator.DefaultRule.add(configurator, "bm30000;tea017");
cds.configurator.DefaultRule.add(configurator, "bm30000;tea018");
cds.configurator.DefaultRule.add(configurator, "bm30000;tea019");
cds.configurator.DefaultRule.add(configurator, "bm30000;tea020");
cds.configurator.DefaultRule.add(configurator, "bm30000;tea021");
cds.configurator.DefaultRule.add(configurator, "bm30000;tea023");
cds.configurator.DefaultRule.add(configurator, "bm30000;tea041");
cds.configurator.DefaultRule.add(configurator, "bm30000;tea043");
cds.configurator.DefaultRule.add(configurator, "bm30000;tea045");
cds.configurator.DefaultRule.add(configurator, "bm30000;tea052");
cds.configurator.DefaultRule.add(configurator, "bm30000;tea060");
cds.configurator.DefaultRule.add(configurator, "bm30000;tea062");
cds.configurator.DefaultRule.add(configurator, "bm30000;tea063");
cds.configurator.DefaultRule.add(configurator, "bm30000;tea067");
cds.configurator.DefaultRule.add(configurator, "bm30000;tea068");
cds.configurator.DefaultRule.add(configurator, "bm30000;tea070");
cds.configurator.DefaultRule.add(configurator, "bm30000;tea071");
cds.configurator.DefaultRule.add(configurator, "bm30000;tea074");
cds.configurator.DefaultRule.add(configurator, "bm30000;tea075");
cds.configurator.DefaultRule.add(configurator, "bm30000;tea084");
cds.configurator.DefaultRule.add(configurator, "bm30000;tea096");
cds.configurator.DefaultRule.add(configurator, "bm30000;tea100");
cds.configurator.DefaultRule.add(configurator, "bm30000;tea120");
cds.configurator.DefaultRule.add(configurator, "bm30000;tea126");
cds.configurator.DefaultRule.add(configurator, "bm30000;tea140");
cds.configurator.DefaultRule.add(configurator, "bm30000;tea154");
cds.configurator.DefaultRule.add(configurator, "bm30000;tea168");
cds.configurator.DefaultRule.add(configurator, "bm30000;tea180");
cds.configurator.DefaultRule.add(configurator, "bm30000;tea200");
cds.configurator.DefaultRule.add(configurator, "bm30000;tea216");
cds.configurator.DefaultRule.add(configurator, "bm30000;tea224");
cds.configurator.DefaultRule.add(configurator, "bm30000;teb010");
cds.configurator.DefaultRule.add(configurator, "bm30000;teb011");
cds.configurator.DefaultRule.add(configurator, "bm30000;teb012");
cds.configurator.DefaultRule.add(configurator, "bm30000;teb013");
cds.configurator.DefaultRule.add(configurator, "bm30000;teb014");
cds.configurator.DefaultRule.add(configurator, "bm30000;teb015");
cds.configurator.DefaultRule.add(configurator, "bm30000;teb016");
cds.configurator.DefaultRule.add(configurator, "bm30000;teb017");
cds.configurator.DefaultRule.add(configurator, "bm30000;teb018");
cds.configurator.DefaultRule.add(configurator, "bm30000;teb019");
cds.configurator.DefaultRule.add(configurator, "bm30000;teb020");
cds.configurator.DefaultRule.add(configurator, "bm30000;teb021");
cds.configurator.DefaultRule.add(configurator, "bm30000;teb023");
cds.configurator.DefaultRule.add(configurator, "bm30000;teb041");
cds.configurator.DefaultRule.add(configurator, "bm30000;teb043");
cds.configurator.DefaultRule.add(configurator, "bm30000;teb045");
cds.configurator.DefaultRule.add(configurator, "bm30000;teb052");
cds.configurator.DefaultRule.add(configurator, "bm30000;teb060");
cds.configurator.DefaultRule.add(configurator, "bm30000;teb062");
cds.configurator.DefaultRule.add(configurator, "bm30000;teb063");
cds.configurator.DefaultRule.add(configurator, "bm30000;teb067");
cds.configurator.DefaultRule.add(configurator, "bm30000;teb068");
cds.configurator.DefaultRule.add(configurator, "bm30000;teb070");
cds.configurator.DefaultRule.add(configurator, "bm30000;teb071");
cds.configurator.DefaultRule.add(configurator, "bm30000;teb074");
cds.configurator.DefaultRule.add(configurator, "bm30000;teb075");
cds.configurator.DefaultRule.add(configurator, "bm30000;teb084");
cds.configurator.DefaultRule.add(configurator, "bm30000;teb096");
cds.configurator.DefaultRule.add(configurator, "bm30000;teb100");
cds.configurator.DefaultRule.add(configurator, "bm30000;teb120");
cds.configurator.DefaultRule.add(configurator, "bm30000;teb126");
cds.configurator.DefaultRule.add(configurator, "bm30000;teb140");
cds.configurator.DefaultRule.add(configurator, "bm30000;teb154");
cds.configurator.DefaultRule.add(configurator, "bm30000;teb168");
cds.configurator.DefaultRule.add(configurator, "bm30000;teb180");
cds.configurator.DefaultRule.add(configurator, "bm30000;teb200");
cds.configurator.DefaultRule.add(configurator, "bm30000;teb216");
cds.configurator.DefaultRule.add(configurator, "bm30000;teb224");
cds.configurator.DefaultRule.add(configurator, "bm32000;sehhh");
cds.configurator.DefaultRule.add(configurator, "bm32000;selll");
cds.configurator.DefaultRule.add(configurator, "bm32000;semxl");
cds.configurator.DefaultRule.add(configurator, "bm32000;sexll");
cds.configurator.DefaultRule.add(configurator, "bm32000;sma05");
cds.configurator.DefaultRule.add(configurator, "bm32000;smh03");
cds.configurator.DefaultRule.add(configurator, "bm32000;smh05");
cds.configurator.DefaultRule.add(configurator, "bm32000;smh08");
cds.configurator.DefaultRule.add(configurator, "bm32000;smt05");
cds.configurator.DefaultRule.add(configurator, "bm32000;smt25");
cds.configurator.DefaultRule.add(configurator, "bm32000;tea010");
cds.configurator.DefaultRule.add(configurator, "bm32000;tea011");
cds.configurator.DefaultRule.add(configurator, "bm32000;tea012");
cds.configurator.DefaultRule.add(configurator, "bm32000;tea013");
cds.configurator.DefaultRule.add(configurator, "bm32000;tea014");
cds.configurator.DefaultRule.add(configurator, "bm32000;tea015");
cds.configurator.DefaultRule.add(configurator, "bm32000;tea016");
cds.configurator.DefaultRule.add(configurator, "bm32000;tea017");
cds.configurator.DefaultRule.add(configurator, "bm32000;tea021");
cds.configurator.DefaultRule.add(configurator, "bm32000;tea023");
cds.configurator.DefaultRule.add(configurator, "bm32000;tea026");
cds.configurator.DefaultRule.add(configurator, "bm32000;tea028");
cds.configurator.DefaultRule.add(configurator, "bm32000;tea029");
cds.configurator.DefaultRule.add(configurator, "bm32000;tea031");
cds.configurator.DefaultRule.add(configurator, "bm32000;tea033");
cds.configurator.DefaultRule.add(configurator, "bm32000;tea034");
cds.configurator.DefaultRule.add(configurator, "bm32000;tea035");
cds.configurator.DefaultRule.add(configurator, "bm32000;tea037");
cds.configurator.DefaultRule.add(configurator, "bm32000;tea038");
cds.configurator.DefaultRule.add(configurator, "bm32000;tea039");
cds.configurator.DefaultRule.add(configurator, "bm32000;tea041");
cds.configurator.DefaultRule.add(configurator, "bm32000;tea042");
cds.configurator.DefaultRule.add(configurator, "bm32000;tea043");
cds.configurator.DefaultRule.add(configurator, "bm32000;tea045");
cds.configurator.DefaultRule.add(configurator, "bm32000;tea046");
cds.configurator.DefaultRule.add(configurator, "bm32000;tea050");
cds.configurator.DefaultRule.add(configurator, "bm32000;tea052");
cds.configurator.DefaultRule.add(configurator, "bm32000;tea053");
cds.configurator.DefaultRule.add(configurator, "bm32000;tea056");
cds.configurator.DefaultRule.add(configurator, "bm32000;tea062");
cds.configurator.DefaultRule.add(configurator, "bm32000;tea063");
cds.configurator.DefaultRule.add(configurator, "bm32000;tea064");
cds.configurator.DefaultRule.add(configurator, "bm32000;tea067");
cds.configurator.DefaultRule.add(configurator, "bm32000;tea068");
cds.configurator.DefaultRule.add(configurator, "bm32000;tea070");
cds.configurator.DefaultRule.add(configurator, "bm32000;tea071");
cds.configurator.DefaultRule.add(configurator, "bm32000;tea072");
cds.configurator.DefaultRule.add(configurator, "bm32000;tea074");
cds.configurator.DefaultRule.add(configurator, "bm32000;tea075");
cds.configurator.DefaultRule.add(configurator, "bm32000;tea080");
cds.configurator.DefaultRule.add(configurator, "bm32000;tea084");
cds.configurator.DefaultRule.add(configurator, "bm32000;tea090");
cds.configurator.DefaultRule.add(configurator, "bm32000;tea096");
cds.configurator.DefaultRule.add(configurator, "bm32000;tea100");
cds.configurator.DefaultRule.add(configurator, "bm32000;tea112");
cds.configurator.DefaultRule.add(configurator, "bm32000;tea120");
cds.configurator.DefaultRule.add(configurator, "bm32000;tea126");
cds.configurator.DefaultRule.add(configurator, "bm32000;tea140");
cds.configurator.DefaultRule.add(configurator, "bm32000;tea144");
cds.configurator.DefaultRule.add(configurator, "bm32000;tea154");
cds.configurator.DefaultRule.add(configurator, "bm32000;tea168");
cds.configurator.DefaultRule.add(configurator, "bm32000;tea180");
cds.configurator.DefaultRule.add(configurator, "bm32000;tea192");
cds.configurator.DefaultRule.add(configurator, "bm32000;tea200");
cds.configurator.DefaultRule.add(configurator, "bm32000;tea216");
cds.configurator.DefaultRule.add(configurator, "bm32000;tea224");
cds.configurator.DefaultRule.add(configurator, "bm32000;teb010");
cds.configurator.DefaultRule.add(configurator, "bm32000;teb011");
cds.configurator.DefaultRule.add(configurator, "bm32000;teb012");
cds.configurator.DefaultRule.add(configurator, "bm32000;teb013");
cds.configurator.DefaultRule.add(configurator, "bm32000;teb014");
cds.configurator.DefaultRule.add(configurator, "bm32000;teb015");
cds.configurator.DefaultRule.add(configurator, "bm32000;teb016");
cds.configurator.DefaultRule.add(configurator, "bm32000;teb017");
cds.configurator.DefaultRule.add(configurator, "bm32000;teb021");
cds.configurator.DefaultRule.add(configurator, "bm32000;teb023");
cds.configurator.DefaultRule.add(configurator, "bm32000;teb026");
cds.configurator.DefaultRule.add(configurator, "bm32000;teb028");
cds.configurator.DefaultRule.add(configurator, "bm32000;teb029");
cds.configurator.DefaultRule.add(configurator, "bm32000;teb031");
cds.configurator.DefaultRule.add(configurator, "bm32000;teb033");
cds.configurator.DefaultRule.add(configurator, "bm32000;teb034");
cds.configurator.DefaultRule.add(configurator, "bm32000;teb035");
cds.configurator.DefaultRule.add(configurator, "bm32000;teb037");
cds.configurator.DefaultRule.add(configurator, "bm32000;teb038");
cds.configurator.DefaultRule.add(configurator, "bm32000;teb039");
cds.configurator.DefaultRule.add(configurator, "bm32000;teb041");
cds.configurator.DefaultRule.add(configurator, "bm32000;teb042");
cds.configurator.DefaultRule.add(configurator, "bm32000;teb043");
cds.configurator.DefaultRule.add(configurator, "bm32000;teb045");
cds.configurator.DefaultRule.add(configurator, "bm32000;teb046");
cds.configurator.DefaultRule.add(configurator, "bm32000;teb050");
cds.configurator.DefaultRule.add(configurator, "bm32000;teb052");
cds.configurator.DefaultRule.add(configurator, "bm32000;teb053");
cds.configurator.DefaultRule.add(configurator, "bm32000;teb056");
cds.configurator.DefaultRule.add(configurator, "bm32000;teb062");
cds.configurator.DefaultRule.add(configurator, "bm32000;teb063");
cds.configurator.DefaultRule.add(configurator, "bm32000;teb064");
cds.configurator.DefaultRule.add(configurator, "bm32000;teb067");
cds.configurator.DefaultRule.add(configurator, "bm32000;teb068");
cds.configurator.DefaultRule.add(configurator, "bm32000;teb070");
cds.configurator.DefaultRule.add(configurator, "bm32000;teb071");
cds.configurator.DefaultRule.add(configurator, "bm32000;teb072");
cds.configurator.DefaultRule.add(configurator, "bm32000;teb074");
cds.configurator.DefaultRule.add(configurator, "bm32000;teb075");
cds.configurator.DefaultRule.add(configurator, "bm32000;teb080");
cds.configurator.DefaultRule.add(configurator, "bm32000;teb084");
cds.configurator.DefaultRule.add(configurator, "bm32000;teb090");
cds.configurator.DefaultRule.add(configurator, "bm32000;teb096");
cds.configurator.DefaultRule.add(configurator, "bm32000;teb100");
cds.configurator.DefaultRule.add(configurator, "bm32000;teb112");
cds.configurator.DefaultRule.add(configurator, "bm32000;teb120");
cds.configurator.DefaultRule.add(configurator, "bm32000;teb126");
cds.configurator.DefaultRule.add(configurator, "bm32000;teb140");
cds.configurator.DefaultRule.add(configurator, "bm32000;teb144");
cds.configurator.DefaultRule.add(configurator, "bm32000;teb154");
cds.configurator.DefaultRule.add(configurator, "bm32000;teb168");
cds.configurator.DefaultRule.add(configurator, "bm32000;teb180");
cds.configurator.DefaultRule.add(configurator, "bm32000;teb192");
cds.configurator.DefaultRule.add(configurator, "bm32000;teb200");
cds.configurator.DefaultRule.add(configurator, "bm32000;teb216");
cds.configurator.DefaultRule.add(configurator, "bm32000;teb224");
cds.configurator.DefaultRule.add(configurator, "bm36000;sehhh");
cds.configurator.DefaultRule.add(configurator, "bm36000;selll");
cds.configurator.DefaultRule.add(configurator, "bm36000;semxl");
cds.configurator.DefaultRule.add(configurator, "bm36000;sexll");
cds.configurator.DefaultRule.add(configurator, "bm36000;sma05");
cds.configurator.DefaultRule.add(configurator, "bm36000;sma10");
cds.configurator.DefaultRule.add(configurator, "bm36000;smh03");
cds.configurator.DefaultRule.add(configurator, "bm36000;smh05");
cds.configurator.DefaultRule.add(configurator, "bm36000;smh08");
cds.configurator.DefaultRule.add(configurator, "bm36000;smt05");
cds.configurator.DefaultRule.add(configurator, "bm36000;smt10");
cds.configurator.DefaultRule.add(configurator, "bm36000;smt25");
cds.configurator.DefaultRule.add(configurator, "bm36000;tea010");
cds.configurator.DefaultRule.add(configurator, "bm36000;tea011");
cds.configurator.DefaultRule.add(configurator, "bm36000;tea012");
cds.configurator.DefaultRule.add(configurator, "bm36000;tea013");
cds.configurator.DefaultRule.add(configurator, "bm36000;tea014");
cds.configurator.DefaultRule.add(configurator, "bm36000;tea015");
cds.configurator.DefaultRule.add(configurator, "bm36000;tea016");
cds.configurator.DefaultRule.add(configurator, "bm36000;tea017");
cds.configurator.DefaultRule.add(configurator, "bm36000;tea018");
cds.configurator.DefaultRule.add(configurator, "bm36000;tea019");
cds.configurator.DefaultRule.add(configurator, "bm36000;tea020");
cds.configurator.DefaultRule.add(configurator, "bm36000;tea021");
cds.configurator.DefaultRule.add(configurator, "bm36000;tea023");
cds.configurator.DefaultRule.add(configurator, "bm36000;tea024");
cds.configurator.DefaultRule.add(configurator, "bm36000;tea026");
cds.configurator.DefaultRule.add(configurator, "bm36000;tea027");
cds.configurator.DefaultRule.add(configurator, "bm36000;tea029");
cds.configurator.DefaultRule.add(configurator, "bm36000;tea031");
cds.configurator.DefaultRule.add(configurator, "bm36000;tea043");
cds.configurator.DefaultRule.add(configurator, "bm36000;tea044");
cds.configurator.DefaultRule.add(configurator, "bm36000;tea046");
cds.configurator.DefaultRule.add(configurator, "bm36000;tea052");
cds.configurator.DefaultRule.add(configurator, "bm36000;tea062");
cds.configurator.DefaultRule.add(configurator, "bm36000;tea064");
cds.configurator.DefaultRule.add(configurator, "bm36000;tea068");
cds.configurator.DefaultRule.add(configurator, "bm36000;tea070");
cds.configurator.DefaultRule.add(configurator, "bm36000;tea072");
cds.configurator.DefaultRule.add(configurator, "bm36000;tea074");
cds.configurator.DefaultRule.add(configurator, "bm36000;tea084");
cds.configurator.DefaultRule.add(configurator, "bm36000;tea096");
cds.configurator.DefaultRule.add(configurator, "bm36000;tea100");
cds.configurator.DefaultRule.add(configurator, "bm36000;tea120");
cds.configurator.DefaultRule.add(configurator, "bm36000;tea126");
cds.configurator.DefaultRule.add(configurator, "bm36000;tea144");
cds.configurator.DefaultRule.add(configurator, "bm36000;tea154");
cds.configurator.DefaultRule.add(configurator, "bm36000;tea168");
cds.configurator.DefaultRule.add(configurator, "bm36000;tea192");
cds.configurator.DefaultRule.add(configurator, "bm36000;tea200");
cds.configurator.DefaultRule.add(configurator, "bm36000;tea216");
cds.configurator.DefaultRule.add(configurator, "bm36000;teb010");
cds.configurator.DefaultRule.add(configurator, "bm36000;teb011");
cds.configurator.DefaultRule.add(configurator, "bm36000;teb012");
cds.configurator.DefaultRule.add(configurator, "bm36000;teb013");
cds.configurator.DefaultRule.add(configurator, "bm36000;teb014");
cds.configurator.DefaultRule.add(configurator, "bm36000;teb015");
cds.configurator.DefaultRule.add(configurator, "bm36000;teb016");
cds.configurator.DefaultRule.add(configurator, "bm36000;teb017");
cds.configurator.DefaultRule.add(configurator, "bm36000;teb018");
cds.configurator.DefaultRule.add(configurator, "bm36000;teb019");
cds.configurator.DefaultRule.add(configurator, "bm36000;teb020");
cds.configurator.DefaultRule.add(configurator, "bm36000;teb021");
cds.configurator.DefaultRule.add(configurator, "bm36000;teb023");
cds.configurator.DefaultRule.add(configurator, "bm36000;teb024");
cds.configurator.DefaultRule.add(configurator, "bm36000;teb026");
cds.configurator.DefaultRule.add(configurator, "bm36000;teb027");
cds.configurator.DefaultRule.add(configurator, "bm36000;teb029");
cds.configurator.DefaultRule.add(configurator, "bm36000;teb031");
cds.configurator.DefaultRule.add(configurator, "bm36000;teb043");
cds.configurator.DefaultRule.add(configurator, "bm36000;teb044");
cds.configurator.DefaultRule.add(configurator, "bm36000;teb046");
cds.configurator.DefaultRule.add(configurator, "bm36000;teb052");
cds.configurator.DefaultRule.add(configurator, "bm36000;teb062");
cds.configurator.DefaultRule.add(configurator, "bm36000;teb064");
cds.configurator.DefaultRule.add(configurator, "bm36000;teb068");
cds.configurator.DefaultRule.add(configurator, "bm36000;teb070");
cds.configurator.DefaultRule.add(configurator, "bm36000;teb072");
cds.configurator.DefaultRule.add(configurator, "bm36000;teb074");
cds.configurator.DefaultRule.add(configurator, "bm36000;teb084");
cds.configurator.DefaultRule.add(configurator, "bm36000;teb096");
cds.configurator.DefaultRule.add(configurator, "bm36000;teb100");
cds.configurator.DefaultRule.add(configurator, "bm36000;teb120");
cds.configurator.DefaultRule.add(configurator, "bm36000;teb126");
cds.configurator.DefaultRule.add(configurator, "bm36000;teb144");
cds.configurator.DefaultRule.add(configurator, "bm36000;teb154");
cds.configurator.DefaultRule.add(configurator, "bm36000;teb168");
cds.configurator.DefaultRule.add(configurator, "bm36000;teb192");
cds.configurator.DefaultRule.add(configurator, "bm36000;teb200");
cds.configurator.DefaultRule.add(configurator, "bm36000;teb216");
cds.configurator.DefaultRule.add(configurator, "bm37000;sehhh");
cds.configurator.DefaultRule.add(configurator, "bm37000;selll");
cds.configurator.DefaultRule.add(configurator, "bm37000;semxl");
cds.configurator.DefaultRule.add(configurator, "bm37000;sexll");
cds.configurator.DefaultRule.add(configurator, "bm37000;sma05");
cds.configurator.DefaultRule.add(configurator, "bm37000;sma10");
cds.configurator.DefaultRule.add(configurator, "bm37000;smh03");
cds.configurator.DefaultRule.add(configurator, "bm37000;smh05");
cds.configurator.DefaultRule.add(configurator, "bm37000;smh08");
cds.configurator.DefaultRule.add(configurator, "bm37000;smt05");
cds.configurator.DefaultRule.add(configurator, "bm37000;smt10");
cds.configurator.DefaultRule.add(configurator, "bm37000;smt25");
cds.configurator.DefaultRule.add(configurator, "bm37000;tea010");
cds.configurator.DefaultRule.add(configurator, "bm37000;tea011");
cds.configurator.DefaultRule.add(configurator, "bm37000;tea012");
cds.configurator.DefaultRule.add(configurator, "bm37000;tea013");
cds.configurator.DefaultRule.add(configurator, "bm37000;tea014");
cds.configurator.DefaultRule.add(configurator, "bm37000;tea015");
cds.configurator.DefaultRule.add(configurator, "bm37000;tea016");
cds.configurator.DefaultRule.add(configurator, "bm37000;tea017");
cds.configurator.DefaultRule.add(configurator, "bm37000;tea018");
cds.configurator.DefaultRule.add(configurator, "bm37000;tea019");
cds.configurator.DefaultRule.add(configurator, "bm37000;tea020");
cds.configurator.DefaultRule.add(configurator, "bm37000;tea021");
cds.configurator.DefaultRule.add(configurator, "bm37000;tea022");
cds.configurator.DefaultRule.add(configurator, "bm37000;tea023");
cds.configurator.DefaultRule.add(configurator, "bm37000;tea024");
cds.configurator.DefaultRule.add(configurator, "bm37000;tea025");
cds.configurator.DefaultRule.add(configurator, "bm37000;tea026");
cds.configurator.DefaultRule.add(configurator, "bm37000;tea027");
cds.configurator.DefaultRule.add(configurator, "bm37000;tea041");
cds.configurator.DefaultRule.add(configurator, "bm37000;tea042");
cds.configurator.DefaultRule.add(configurator, "bm37000;tea044");
cds.configurator.DefaultRule.add(configurator, "bm37000;tea046");
cds.configurator.DefaultRule.add(configurator, "bm37000;tea052");
cds.configurator.DefaultRule.add(configurator, "bm37000;tea062");
cds.configurator.DefaultRule.add(configurator, "bm37000;tea064");
cds.configurator.DefaultRule.add(configurator, "bm37000;tea068");
cds.configurator.DefaultRule.add(configurator, "bm37000;tea070");
cds.configurator.DefaultRule.add(configurator, "bm37000;tea072");
cds.configurator.DefaultRule.add(configurator, "bm37000;tea074");
cds.configurator.DefaultRule.add(configurator, "bm37000;tea084");
cds.configurator.DefaultRule.add(configurator, "bm37000;tea096");
cds.configurator.DefaultRule.add(configurator, "bm37000;tea100");
cds.configurator.DefaultRule.add(configurator, "bm37000;tea120");
cds.configurator.DefaultRule.add(configurator, "bm37000;tea144");
cds.configurator.DefaultRule.add(configurator, "bm37000;tea192");
cds.configurator.DefaultRule.add(configurator, "bm37000;tea216");
cds.configurator.DefaultRule.add(configurator, "bm37000;teb010");
cds.configurator.DefaultRule.add(configurator, "bm37000;teb011");
cds.configurator.DefaultRule.add(configurator, "bm37000;teb012");
cds.configurator.DefaultRule.add(configurator, "bm37000;teb013");
cds.configurator.DefaultRule.add(configurator, "bm37000;teb014");
cds.configurator.DefaultRule.add(configurator, "bm37000;teb015");
cds.configurator.DefaultRule.add(configurator, "bm37000;teb016");
cds.configurator.DefaultRule.add(configurator, "bm37000;teb017");
cds.configurator.DefaultRule.add(configurator, "bm37000;teb018");
cds.configurator.DefaultRule.add(configurator, "bm37000;teb019");
cds.configurator.DefaultRule.add(configurator, "bm37000;teb020");
cds.configurator.DefaultRule.add(configurator, "bm37000;teb021");
cds.configurator.DefaultRule.add(configurator, "bm37000;teb022");
cds.configurator.DefaultRule.add(configurator, "bm37000;teb023");
cds.configurator.DefaultRule.add(configurator, "bm37000;teb024");
cds.configurator.DefaultRule.add(configurator, "bm37000;teb025");
cds.configurator.DefaultRule.add(configurator, "bm37000;teb026");
cds.configurator.DefaultRule.add(configurator, "bm37000;teb027");
cds.configurator.DefaultRule.add(configurator, "bm37000;teb041");
cds.configurator.DefaultRule.add(configurator, "bm37000;teb042");
cds.configurator.DefaultRule.add(configurator, "bm37000;teb044");
cds.configurator.DefaultRule.add(configurator, "bm37000;teb046");
cds.configurator.DefaultRule.add(configurator, "bm37000;teb052");
cds.configurator.DefaultRule.add(configurator, "bm37000;teb062");
cds.configurator.DefaultRule.add(configurator, "bm37000;teb064");
cds.configurator.DefaultRule.add(configurator, "bm37000;teb068");
cds.configurator.DefaultRule.add(configurator, "bm37000;teb070");
cds.configurator.DefaultRule.add(configurator, "bm37000;teb072");
cds.configurator.DefaultRule.add(configurator, "bm37000;teb074");
cds.configurator.DefaultRule.add(configurator, "bm37000;teb084");
cds.configurator.DefaultRule.add(configurator, "bm37000;teb096");
cds.configurator.DefaultRule.add(configurator, "bm37000;teb100");
cds.configurator.DefaultRule.add(configurator, "bm37000;teb120");
cds.configurator.DefaultRule.add(configurator, "bm37000;teb144");
cds.configurator.DefaultRule.add(configurator, "bm37000;teb192");
cds.configurator.DefaultRule.add(configurator, "bm37000;teb216");
cds.configurator.DefaultRule.add(configurator, "bm38100;selll");
cds.configurator.DefaultRule.add(configurator, "bm38100;semxl");
cds.configurator.DefaultRule.add(configurator, "bm38100;sexll");
cds.configurator.DefaultRule.add(configurator, "bm38100;sma05");
cds.configurator.DefaultRule.add(configurator, "bm38100;sma10");
cds.configurator.DefaultRule.add(configurator, "bm38100;smh03");
cds.configurator.DefaultRule.add(configurator, "bm38100;smh05");
cds.configurator.DefaultRule.add(configurator, "bm38100;smh08");
cds.configurator.DefaultRule.add(configurator, "bm38100;smt05");
cds.configurator.DefaultRule.add(configurator, "bm38100;smt10");
cds.configurator.DefaultRule.add(configurator, "bm38100;smt25");
cds.configurator.DefaultRule.add(configurator, "bm38100;tea010");
cds.configurator.DefaultRule.add(configurator, "bm38100;tea011");
cds.configurator.DefaultRule.add(configurator, "bm38100;tea012");
cds.configurator.DefaultRule.add(configurator, "bm38100;tea013");
cds.configurator.DefaultRule.add(configurator, "bm38100;tea015");
cds.configurator.DefaultRule.add(configurator, "bm38100;tea023");
cds.configurator.DefaultRule.add(configurator, "bm38100;tea025");
cds.configurator.DefaultRule.add(configurator, "bm38100;tea027");
cds.configurator.DefaultRule.add(configurator, "bm38100;tea029");
cds.configurator.DefaultRule.add(configurator, "bm38100;tea031");
cds.configurator.DefaultRule.add(configurator, "bm38100;tea033");
cds.configurator.DefaultRule.add(configurator, "bm38100;tea034");
cds.configurator.DefaultRule.add(configurator, "bm38100;tea035");
cds.configurator.DefaultRule.add(configurator, "bm38100;tea037");
cds.configurator.DefaultRule.add(configurator, "bm38100;tea038");
cds.configurator.DefaultRule.add(configurator, "bm38100;tea039");
cds.configurator.DefaultRule.add(configurator, "bm38100;tea041");
cds.configurator.DefaultRule.add(configurator, "bm38100;tea042");
cds.configurator.DefaultRule.add(configurator, "bm38100;tea043");
cds.configurator.DefaultRule.add(configurator, "bm38100;tea045");
cds.configurator.DefaultRule.add(configurator, "bm38100;tea046");
cds.configurator.DefaultRule.add(configurator, "bm38100;tea050");
cds.configurator.DefaultRule.add(configurator, "bm38100;tea052");
cds.configurator.DefaultRule.add(configurator, "bm38100;tea053");
cds.configurator.DefaultRule.add(configurator, "bm38100;tea056");
cds.configurator.DefaultRule.add(configurator, "bm38100;tea062");
cds.configurator.DefaultRule.add(configurator, "bm38100;tea063");
cds.configurator.DefaultRule.add(configurator, "bm38100;tea064");
cds.configurator.DefaultRule.add(configurator, "bm38100;tea067");
cds.configurator.DefaultRule.add(configurator, "bm38100;tea068");
cds.configurator.DefaultRule.add(configurator, "bm38100;tea070");
cds.configurator.DefaultRule.add(configurator, "bm38100;tea071");
cds.configurator.DefaultRule.add(configurator, "bm38100;tea074");
cds.configurator.DefaultRule.add(configurator, "bm38100;tea075");
cds.configurator.DefaultRule.add(configurator, "bm38100;tea080");
cds.configurator.DefaultRule.add(configurator, "bm38100;tea090");
cds.configurator.DefaultRule.add(configurator, "bm38100;tea100");
cds.configurator.DefaultRule.add(configurator, "bm38100;tea112");
cds.configurator.DefaultRule.add(configurator, "bm38100;tea126");
cds.configurator.DefaultRule.add(configurator, "bm38100;tea140");
cds.configurator.DefaultRule.add(configurator, "bm38100;tea144");
cds.configurator.DefaultRule.add(configurator, "bm38100;tea154");
cds.configurator.DefaultRule.add(configurator, "bm38100;tea168");
cds.configurator.DefaultRule.add(configurator, "bm38100;tea180");
cds.configurator.DefaultRule.add(configurator, "bm38100;tea192");
cds.configurator.DefaultRule.add(configurator, "bm38100;tea200");
cds.configurator.DefaultRule.add(configurator, "bm38100;tea216");
cds.configurator.DefaultRule.add(configurator, "bm38100;tea224");
cds.configurator.DefaultRule.add(configurator, "bm38100;teb010");
cds.configurator.DefaultRule.add(configurator, "bm38100;teb011");
cds.configurator.DefaultRule.add(configurator, "bm38100;teb012");
cds.configurator.DefaultRule.add(configurator, "bm38100;teb013");
cds.configurator.DefaultRule.add(configurator, "bm38100;teb015");
cds.configurator.DefaultRule.add(configurator, "bm38100;teb023");
cds.configurator.DefaultRule.add(configurator, "bm38100;teb025");
cds.configurator.DefaultRule.add(configurator, "bm38100;teb027");
cds.configurator.DefaultRule.add(configurator, "bm38100;teb029");
cds.configurator.DefaultRule.add(configurator, "bm38100;teb031");
cds.configurator.DefaultRule.add(configurator, "bm38100;teb033");
cds.configurator.DefaultRule.add(configurator, "bm38100;teb034");
cds.configurator.DefaultRule.add(configurator, "bm38100;teb035");
cds.configurator.DefaultRule.add(configurator, "bm38100;teb037");
cds.configurator.DefaultRule.add(configurator, "bm38100;teb038");
cds.configurator.DefaultRule.add(configurator, "bm38100;teb039");
cds.configurator.DefaultRule.add(configurator, "bm38100;teb041");
cds.configurator.DefaultRule.add(configurator, "bm38100;teb042");
cds.configurator.DefaultRule.add(configurator, "bm38100;teb043");
cds.configurator.DefaultRule.add(configurator, "bm38100;teb045");
cds.configurator.DefaultRule.add(configurator, "bm38100;teb046");
cds.configurator.DefaultRule.add(configurator, "bm38100;teb050");
cds.configurator.DefaultRule.add(configurator, "bm38100;teb052");
cds.configurator.DefaultRule.add(configurator, "bm38100;teb053");
cds.configurator.DefaultRule.add(configurator, "bm38100;teb056");
cds.configurator.DefaultRule.add(configurator, "bm38100;teb062");
cds.configurator.DefaultRule.add(configurator, "bm38100;teb063");
cds.configurator.DefaultRule.add(configurator, "bm38100;teb064");
cds.configurator.DefaultRule.add(configurator, "bm38100;teb067");
cds.configurator.DefaultRule.add(configurator, "bm38100;teb068");
cds.configurator.DefaultRule.add(configurator, "bm38100;teb070");
cds.configurator.DefaultRule.add(configurator, "bm38100;teb071");
cds.configurator.DefaultRule.add(configurator, "bm38100;teb074");
cds.configurator.DefaultRule.add(configurator, "bm38100;teb075");
cds.configurator.DefaultRule.add(configurator, "bm38100;teb080");
cds.configurator.DefaultRule.add(configurator, "bm38100;teb090");
cds.configurator.DefaultRule.add(configurator, "bm38100;teb100");
cds.configurator.DefaultRule.add(configurator, "bm38100;teb112");
cds.configurator.DefaultRule.add(configurator, "bm38100;teb126");
cds.configurator.DefaultRule.add(configurator, "bm38100;teb140");
cds.configurator.DefaultRule.add(configurator, "bm38100;teb144");
cds.configurator.DefaultRule.add(configurator, "bm38100;teb154");
cds.configurator.DefaultRule.add(configurator, "bm38100;teb168");
cds.configurator.DefaultRule.add(configurator, "bm38100;teb180");
cds.configurator.DefaultRule.add(configurator, "bm38100;teb192");
cds.configurator.DefaultRule.add(configurator, "bm38100;teb200");
cds.configurator.DefaultRule.add(configurator, "bm38100;teb216");
cds.configurator.DefaultRule.add(configurator, "bm38100;teb224");
cds.configurator.DefaultRule.add(configurator, "bm40000;sehhh");
cds.configurator.DefaultRule.add(configurator, "bm40000;selll");
cds.configurator.DefaultRule.add(configurator, "bm40000;semxl");
cds.configurator.DefaultRule.add(configurator, "bm40000;sexll");
cds.configurator.DefaultRule.add(configurator, "bm40000;sma05");
cds.configurator.DefaultRule.add(configurator, "bm40000;sma10");
cds.configurator.DefaultRule.add(configurator, "bm40000;smh03");
cds.configurator.DefaultRule.add(configurator, "bm40000;smh05");
cds.configurator.DefaultRule.add(configurator, "bm40000;smh08");
cds.configurator.DefaultRule.add(configurator, "bm40000;smt05");
cds.configurator.DefaultRule.add(configurator, "bm40000;smt10");
cds.configurator.DefaultRule.add(configurator, "bm40000;smt25");
cds.configurator.DefaultRule.add(configurator, "bm40000;tea010");
cds.configurator.DefaultRule.add(configurator, "bm40000;tea011");
cds.configurator.DefaultRule.add(configurator, "bm40000;tea012");
cds.configurator.DefaultRule.add(configurator, "bm40000;tea013");
cds.configurator.DefaultRule.add(configurator, "bm40000;tea014");
cds.configurator.DefaultRule.add(configurator, "bm40000;tea015");
cds.configurator.DefaultRule.add(configurator, "bm40000;tea016");
cds.configurator.DefaultRule.add(configurator, "bm40000;tea017");
cds.configurator.DefaultRule.add(configurator, "bm40000;tea018");
cds.configurator.DefaultRule.add(configurator, "bm40000;tea019");
cds.configurator.DefaultRule.add(configurator, "bm40000;tea020");
cds.configurator.DefaultRule.add(configurator, "bm40000;tea021");
cds.configurator.DefaultRule.add(configurator, "bm40000;tea022");
cds.configurator.DefaultRule.add(configurator, "bm40000;tea023");
cds.configurator.DefaultRule.add(configurator, "bm40000;tea024");
cds.configurator.DefaultRule.add(configurator, "bm40000;tea025");
cds.configurator.DefaultRule.add(configurator, "bm40000;tea026");
cds.configurator.DefaultRule.add(configurator, "bm40000;tea027");
cds.configurator.DefaultRule.add(configurator, "bm40000;tea041");
cds.configurator.DefaultRule.add(configurator, "bm40000;tea043");
cds.configurator.DefaultRule.add(configurator, "bm40000;tea045");
cds.configurator.DefaultRule.add(configurator, "bm40000;tea053");
cds.configurator.DefaultRule.add(configurator, "bm40000;tea062");
cds.configurator.DefaultRule.add(configurator, "bm40000;tea063");
cds.configurator.DefaultRule.add(configurator, "bm40000;tea067");
cds.configurator.DefaultRule.add(configurator, "bm40000;tea070");
cds.configurator.DefaultRule.add(configurator, "bm40000;tea071");
cds.configurator.DefaultRule.add(configurator, "bm40000;tea074");
cds.configurator.DefaultRule.add(configurator, "bm40000;tea075");
cds.configurator.DefaultRule.add(configurator, "bm40000;tea084");
cds.configurator.DefaultRule.add(configurator, "bm40000;tea096");
cds.configurator.DefaultRule.add(configurator, "bm40000;tea100");
cds.configurator.DefaultRule.add(configurator, "bm40000;tea120");
cds.configurator.DefaultRule.add(configurator, "bm40000;tea126");
cds.configurator.DefaultRule.add(configurator, "bm40000;tea140");
cds.configurator.DefaultRule.add(configurator, "bm40000;tea154");
cds.configurator.DefaultRule.add(configurator, "bm40000;tea180");
cds.configurator.DefaultRule.add(configurator, "bm40000;tea200");
cds.configurator.DefaultRule.add(configurator, "bm40000;tea216");
cds.configurator.DefaultRule.add(configurator, "bm40000;tea224");
cds.configurator.DefaultRule.add(configurator, "bm40000;teb010");
cds.configurator.DefaultRule.add(configurator, "bm40000;teb011");
cds.configurator.DefaultRule.add(configurator, "bm40000;teb012");
cds.configurator.DefaultRule.add(configurator, "bm40000;teb013");
cds.configurator.DefaultRule.add(configurator, "bm40000;teb014");
cds.configurator.DefaultRule.add(configurator, "bm40000;teb015");
cds.configurator.DefaultRule.add(configurator, "bm40000;teb016");
cds.configurator.DefaultRule.add(configurator, "bm40000;teb017");
cds.configurator.DefaultRule.add(configurator, "bm40000;teb018");
cds.configurator.DefaultRule.add(configurator, "bm40000;teb019");
cds.configurator.DefaultRule.add(configurator, "bm40000;teb020");
cds.configurator.DefaultRule.add(configurator, "bm40000;teb021");
cds.configurator.DefaultRule.add(configurator, "bm40000;teb022");
cds.configurator.DefaultRule.add(configurator, "bm40000;teb023");
cds.configurator.DefaultRule.add(configurator, "bm40000;teb024");
cds.configurator.DefaultRule.add(configurator, "bm40000;teb025");
cds.configurator.DefaultRule.add(configurator, "bm40000;teb026");
cds.configurator.DefaultRule.add(configurator, "bm40000;teb027");
cds.configurator.DefaultRule.add(configurator, "bm40000;teb041");
cds.configurator.DefaultRule.add(configurator, "bm40000;teb043");
cds.configurator.DefaultRule.add(configurator, "bm40000;teb045");
cds.configurator.DefaultRule.add(configurator, "bm40000;teb053");
cds.configurator.DefaultRule.add(configurator, "bm40000;teb062");
cds.configurator.DefaultRule.add(configurator, "bm40000;teb063");
cds.configurator.DefaultRule.add(configurator, "bm40000;teb067");
cds.configurator.DefaultRule.add(configurator, "bm40000;teb070");
cds.configurator.DefaultRule.add(configurator, "bm40000;teb071");
cds.configurator.DefaultRule.add(configurator, "bm40000;teb074");
cds.configurator.DefaultRule.add(configurator, "bm40000;teb075");
cds.configurator.DefaultRule.add(configurator, "bm40000;teb084");
cds.configurator.DefaultRule.add(configurator, "bm40000;teb096");
cds.configurator.DefaultRule.add(configurator, "bm40000;teb100");
cds.configurator.DefaultRule.add(configurator, "bm40000;teb120");
cds.configurator.DefaultRule.add(configurator, "bm40000;teb126");
cds.configurator.DefaultRule.add(configurator, "bm40000;teb140");
cds.configurator.DefaultRule.add(configurator, "bm40000;teb154");
cds.configurator.DefaultRule.add(configurator, "bm40000;teb180");
cds.configurator.DefaultRule.add(configurator, "bm40000;teb200");
cds.configurator.DefaultRule.add(configurator, "bm40000;teb216");
cds.configurator.DefaultRule.add(configurator, "bm40000;teb224");
cds.configurator.DefaultRule.add(configurator, "bm50000;sehhh");
cds.configurator.DefaultRule.add(configurator, "bm50000;selll");
cds.configurator.DefaultRule.add(configurator, "bm50000;semxl");
cds.configurator.DefaultRule.add(configurator, "bm50000;sexll");
cds.configurator.DefaultRule.add(configurator, "bm50000;sma05");
cds.configurator.DefaultRule.add(configurator, "bm50000;smh03");
cds.configurator.DefaultRule.add(configurator, "bm50000;smh05");
cds.configurator.DefaultRule.add(configurator, "bm50000;smt05");
cds.configurator.DefaultRule.add(configurator, "bm50000;smt25");
cds.configurator.DefaultRule.add(configurator, "bm50000;tea010");
cds.configurator.DefaultRule.add(configurator, "bm50000;tea011");
cds.configurator.DefaultRule.add(configurator, "bm50000;tea012");
cds.configurator.DefaultRule.add(configurator, "bm50000;tea013");
cds.configurator.DefaultRule.add(configurator, "bm50000;tea014");
cds.configurator.DefaultRule.add(configurator, "bm50000;tea015");
cds.configurator.DefaultRule.add(configurator, "bm50000;tea016");
cds.configurator.DefaultRule.add(configurator, "bm50000;tea017");
cds.configurator.DefaultRule.add(configurator, "bm50000;tea021");
cds.configurator.DefaultRule.add(configurator, "bm50000;tea023");
cds.configurator.DefaultRule.add(configurator, "bm50000;tea026");
cds.configurator.DefaultRule.add(configurator, "bm50000;tea029");
cds.configurator.DefaultRule.add(configurator, "bm50000;tea031");
cds.configurator.DefaultRule.add(configurator, "bm50000;tea033");
cds.configurator.DefaultRule.add(configurator, "bm50000;tea035");
cds.configurator.DefaultRule.add(configurator, "bm50000;tea037");
cds.configurator.DefaultRule.add(configurator, "bm50000;tea039");
cds.configurator.DefaultRule.add(configurator, "bm50000;tea041");
cds.configurator.DefaultRule.add(configurator, "bm50000;tea042");
cds.configurator.DefaultRule.add(configurator, "bm50000;tea043");
cds.configurator.DefaultRule.add(configurator, "bm50000;tea045");
cds.configurator.DefaultRule.add(configurator, "bm50000;tea046");
cds.configurator.DefaultRule.add(configurator, "bm50000;tea050");
cds.configurator.DefaultRule.add(configurator, "bm50000;tea052");
cds.configurator.DefaultRule.add(configurator, "bm50000;tea053");
cds.configurator.DefaultRule.add(configurator, "bm50000;tea062");
cds.configurator.DefaultRule.add(configurator, "bm50000;tea063");
cds.configurator.DefaultRule.add(configurator, "bm50000;tea067");
cds.configurator.DefaultRule.add(configurator, "bm50000;tea068");
cds.configurator.DefaultRule.add(configurator, "bm50000;tea070");
cds.configurator.DefaultRule.add(configurator, "bm50000;tea071");
cds.configurator.DefaultRule.add(configurator, "bm50000;tea074");
cds.configurator.DefaultRule.add(configurator, "bm50000;tea075");
cds.configurator.DefaultRule.add(configurator, "bm50000;tea084");
cds.configurator.DefaultRule.add(configurator, "bm50000;tea096");
cds.configurator.DefaultRule.add(configurator, "bm50000;tea100");
cds.configurator.DefaultRule.add(configurator, "bm50000;tea120");
cds.configurator.DefaultRule.add(configurator, "bm50000;tea126");
cds.configurator.DefaultRule.add(configurator, "bm50000;tea140");
cds.configurator.DefaultRule.add(configurator, "bm50000;tea154");
cds.configurator.DefaultRule.add(configurator, "bm50000;tea168");
cds.configurator.DefaultRule.add(configurator, "bm50000;tea180");
cds.configurator.DefaultRule.add(configurator, "bm50000;tea200");
cds.configurator.DefaultRule.add(configurator, "bm50000;tea216");
cds.configurator.DefaultRule.add(configurator, "bm50000;tea224");
cds.configurator.DefaultRule.add(configurator, "bm50000;teb010");
cds.configurator.DefaultRule.add(configurator, "bm50000;teb011");
cds.configurator.DefaultRule.add(configurator, "bm50000;teb012");
cds.configurator.DefaultRule.add(configurator, "bm50000;teb013");
cds.configurator.DefaultRule.add(configurator, "bm50000;teb014");
cds.configurator.DefaultRule.add(configurator, "bm50000;teb015");
cds.configurator.DefaultRule.add(configurator, "bm50000;teb016");
cds.configurator.DefaultRule.add(configurator, "bm50000;teb017");
cds.configurator.DefaultRule.add(configurator, "bm50000;teb021");
cds.configurator.DefaultRule.add(configurator, "bm50000;teb023");
cds.configurator.DefaultRule.add(configurator, "bm50000;teb026");
cds.configurator.DefaultRule.add(configurator, "bm50000;teb029");
cds.configurator.DefaultRule.add(configurator, "bm50000;teb031");
cds.configurator.DefaultRule.add(configurator, "bm50000;teb033");
cds.configurator.DefaultRule.add(configurator, "bm50000;teb035");
cds.configurator.DefaultRule.add(configurator, "bm50000;teb037");
cds.configurator.DefaultRule.add(configurator, "bm50000;teb039");
cds.configurator.DefaultRule.add(configurator, "bm50000;teb041");
cds.configurator.DefaultRule.add(configurator, "bm50000;teb042");
cds.configurator.DefaultRule.add(configurator, "bm50000;teb043");
cds.configurator.DefaultRule.add(configurator, "bm50000;teb045");
cds.configurator.DefaultRule.add(configurator, "bm50000;teb046");
cds.configurator.DefaultRule.add(configurator, "bm50000;teb050");
cds.configurator.DefaultRule.add(configurator, "bm50000;teb052");
cds.configurator.DefaultRule.add(configurator, "bm50000;teb053");
cds.configurator.DefaultRule.add(configurator, "bm50000;teb062");
cds.configurator.DefaultRule.add(configurator, "bm50000;teb063");
cds.configurator.DefaultRule.add(configurator, "bm50000;teb067");
cds.configurator.DefaultRule.add(configurator, "bm50000;teb068");
cds.configurator.DefaultRule.add(configurator, "bm50000;teb070");
cds.configurator.DefaultRule.add(configurator, "bm50000;teb071");
cds.configurator.DefaultRule.add(configurator, "bm50000;teb074");
cds.configurator.DefaultRule.add(configurator, "bm50000;teb075");
cds.configurator.DefaultRule.add(configurator, "bm50000;teb084");
cds.configurator.DefaultRule.add(configurator, "bm50000;teb096");
cds.configurator.DefaultRule.add(configurator, "bm50000;teb100");
cds.configurator.DefaultRule.add(configurator, "bm50000;teb120");
cds.configurator.DefaultRule.add(configurator, "bm50000;teb126");
cds.configurator.DefaultRule.add(configurator, "bm50000;teb140");
cds.configurator.DefaultRule.add(configurator, "bm50000;teb154");
cds.configurator.DefaultRule.add(configurator, "bm50000;teb168");
cds.configurator.DefaultRule.add(configurator, "bm50000;teb180");
cds.configurator.DefaultRule.add(configurator, "bm50000;teb200");
cds.configurator.DefaultRule.add(configurator, "bm50000;teb216");
cds.configurator.DefaultRule.add(configurator, "bm50000;teb224");
cds.configurator.DefaultRule.add(configurator, "bm50800;selll");
cds.configurator.DefaultRule.add(configurator, "bm50800;semxl");
cds.configurator.DefaultRule.add(configurator, "bm50800;sexll");
cds.configurator.DefaultRule.add(configurator, "bm50800;sma05");
cds.configurator.DefaultRule.add(configurator, "bm50800;sma10");
cds.configurator.DefaultRule.add(configurator, "bm50800;smh03");
cds.configurator.DefaultRule.add(configurator, "bm50800;smh05");
cds.configurator.DefaultRule.add(configurator, "bm50800;smh08");
cds.configurator.DefaultRule.add(configurator, "bm50800;smt05");
cds.configurator.DefaultRule.add(configurator, "bm50800;smt10");
cds.configurator.DefaultRule.add(configurator, "bm50800;smt25");
cds.configurator.DefaultRule.add(configurator, "bm50800;tea010");
cds.configurator.DefaultRule.add(configurator, "bm50800;tea011");
cds.configurator.DefaultRule.add(configurator, "bm50800;tea012");
cds.configurator.DefaultRule.add(configurator, "bm50800;tea013");
cds.configurator.DefaultRule.add(configurator, "bm50800;tea015");
cds.configurator.DefaultRule.add(configurator, "bm50800;tea023");
cds.configurator.DefaultRule.add(configurator, "bm50800;tea025");
cds.configurator.DefaultRule.add(configurator, "bm50800;tea027");
cds.configurator.DefaultRule.add(configurator, "bm50800;tea029");
cds.configurator.DefaultRule.add(configurator, "bm50800;tea031");
cds.configurator.DefaultRule.add(configurator, "bm50800;tea033");
cds.configurator.DefaultRule.add(configurator, "bm50800;tea034");
cds.configurator.DefaultRule.add(configurator, "bm50800;tea035");
cds.configurator.DefaultRule.add(configurator, "bm50800;tea037");
cds.configurator.DefaultRule.add(configurator, "bm50800;tea038");
cds.configurator.DefaultRule.add(configurator, "bm50800;tea039");
cds.configurator.DefaultRule.add(configurator, "bm50800;tea041");
cds.configurator.DefaultRule.add(configurator, "bm50800;tea042");
cds.configurator.DefaultRule.add(configurator, "bm50800;tea043");
cds.configurator.DefaultRule.add(configurator, "bm50800;tea045");
cds.configurator.DefaultRule.add(configurator, "bm50800;tea046");
cds.configurator.DefaultRule.add(configurator, "bm50800;tea050");
cds.configurator.DefaultRule.add(configurator, "bm50800;tea052");
cds.configurator.DefaultRule.add(configurator, "bm50800;tea053");
cds.configurator.DefaultRule.add(configurator, "bm50800;tea056");
cds.configurator.DefaultRule.add(configurator, "bm50800;tea062");
cds.configurator.DefaultRule.add(configurator, "bm50800;tea063");
cds.configurator.DefaultRule.add(configurator, "bm50800;tea064");
cds.configurator.DefaultRule.add(configurator, "bm50800;tea067");
cds.configurator.DefaultRule.add(configurator, "bm50800;tea068");
cds.configurator.DefaultRule.add(configurator, "bm50800;tea070");
cds.configurator.DefaultRule.add(configurator, "bm50800;tea071");
cds.configurator.DefaultRule.add(configurator, "bm50800;tea074");
cds.configurator.DefaultRule.add(configurator, "bm50800;tea075");
cds.configurator.DefaultRule.add(configurator, "bm50800;tea080");
cds.configurator.DefaultRule.add(configurator, "bm50800;tea090");
cds.configurator.DefaultRule.add(configurator, "bm50800;tea100");
cds.configurator.DefaultRule.add(configurator, "bm50800;tea112");
cds.configurator.DefaultRule.add(configurator, "bm50800;tea126");
cds.configurator.DefaultRule.add(configurator, "bm50800;tea140");
cds.configurator.DefaultRule.add(configurator, "bm50800;tea144");
cds.configurator.DefaultRule.add(configurator, "bm50800;tea154");
cds.configurator.DefaultRule.add(configurator, "bm50800;tea168");
cds.configurator.DefaultRule.add(configurator, "bm50800;tea180");
cds.configurator.DefaultRule.add(configurator, "bm50800;tea192");
cds.configurator.DefaultRule.add(configurator, "bm50800;tea200");
cds.configurator.DefaultRule.add(configurator, "bm50800;tea216");
cds.configurator.DefaultRule.add(configurator, "bm50800;tea224");
cds.configurator.DefaultRule.add(configurator, "bm50800;teb010");
cds.configurator.DefaultRule.add(configurator, "bm50800;teb011");
cds.configurator.DefaultRule.add(configurator, "bm50800;teb012");
cds.configurator.DefaultRule.add(configurator, "bm50800;teb013");
cds.configurator.DefaultRule.add(configurator, "bm50800;teb015");
cds.configurator.DefaultRule.add(configurator, "bm50800;teb023");
cds.configurator.DefaultRule.add(configurator, "bm50800;teb025");
cds.configurator.DefaultRule.add(configurator, "bm50800;teb027");
cds.configurator.DefaultRule.add(configurator, "bm50800;teb029");
cds.configurator.DefaultRule.add(configurator, "bm50800;teb031");
cds.configurator.DefaultRule.add(configurator, "bm50800;teb033");
cds.configurator.DefaultRule.add(configurator, "bm50800;teb034");
cds.configurator.DefaultRule.add(configurator, "bm50800;teb035");
cds.configurator.DefaultRule.add(configurator, "bm50800;teb037");
cds.configurator.DefaultRule.add(configurator, "bm50800;teb038");
cds.configurator.DefaultRule.add(configurator, "bm50800;teb039");
cds.configurator.DefaultRule.add(configurator, "bm50800;teb041");
cds.configurator.DefaultRule.add(configurator, "bm50800;teb042");
cds.configurator.DefaultRule.add(configurator, "bm50800;teb043");
cds.configurator.DefaultRule.add(configurator, "bm50800;teb045");
cds.configurator.DefaultRule.add(configurator, "bm50800;teb046");
cds.configurator.DefaultRule.add(configurator, "bm50800;teb050");
cds.configurator.DefaultRule.add(configurator, "bm50800;teb052");
cds.configurator.DefaultRule.add(configurator, "bm50800;teb053");
cds.configurator.DefaultRule.add(configurator, "bm50800;teb056");
cds.configurator.DefaultRule.add(configurator, "bm50800;teb062");
cds.configurator.DefaultRule.add(configurator, "bm50800;teb063");
cds.configurator.DefaultRule.add(configurator, "bm50800;teb064");
cds.configurator.DefaultRule.add(configurator, "bm50800;teb067");
cds.configurator.DefaultRule.add(configurator, "bm50800;teb068");
cds.configurator.DefaultRule.add(configurator, "bm50800;teb070");
cds.configurator.DefaultRule.add(configurator, "bm50800;teb071");
cds.configurator.DefaultRule.add(configurator, "bm50800;teb074");
cds.configurator.DefaultRule.add(configurator, "bm50800;teb075");
cds.configurator.DefaultRule.add(configurator, "bm50800;teb080");
cds.configurator.DefaultRule.add(configurator, "bm50800;teb090");
cds.configurator.DefaultRule.add(configurator, "bm50800;teb100");
cds.configurator.DefaultRule.add(configurator, "bm50800;teb112");
cds.configurator.DefaultRule.add(configurator, "bm50800;teb126");
cds.configurator.DefaultRule.add(configurator, "bm50800;teb140");
cds.configurator.DefaultRule.add(configurator, "bm50800;teb144");
cds.configurator.DefaultRule.add(configurator, "bm50800;teb154");
cds.configurator.DefaultRule.add(configurator, "bm50800;teb168");
cds.configurator.DefaultRule.add(configurator, "bm50800;teb180");
cds.configurator.DefaultRule.add(configurator, "bm50800;teb192");
cds.configurator.DefaultRule.add(configurator, "bm50800;teb200");
cds.configurator.DefaultRule.add(configurator, "bm50800;teb216");
cds.configurator.DefaultRule.add(configurator, "bm50800;teb224");
cds.configurator.DefaultRule.add(configurator, "bm55000;sehhh");
cds.configurator.DefaultRule.add(configurator, "bm55000;selll");
cds.configurator.DefaultRule.add(configurator, "bm55000;semxl");
cds.configurator.DefaultRule.add(configurator, "bm55000;sexll");
cds.configurator.DefaultRule.add(configurator, "bm55000;sma05");
cds.configurator.DefaultRule.add(configurator, "bm55000;sma10");
cds.configurator.DefaultRule.add(configurator, "bm55000;smh03");
cds.configurator.DefaultRule.add(configurator, "bm55000;smh05");
cds.configurator.DefaultRule.add(configurator, "bm55000;smh08");
cds.configurator.DefaultRule.add(configurator, "bm55000;smt05");
cds.configurator.DefaultRule.add(configurator, "bm55000;smt10");
cds.configurator.DefaultRule.add(configurator, "bm55000;smt25");
cds.configurator.DefaultRule.add(configurator, "bm55000;tea010");
cds.configurator.DefaultRule.add(configurator, "bm55000;tea011");
cds.configurator.DefaultRule.add(configurator, "bm55000;tea012");
cds.configurator.DefaultRule.add(configurator, "bm55000;tea013");
cds.configurator.DefaultRule.add(configurator, "bm55000;tea014");
cds.configurator.DefaultRule.add(configurator, "bm55000;tea015");
cds.configurator.DefaultRule.add(configurator, "bm55000;tea016");
cds.configurator.DefaultRule.add(configurator, "bm55000;tea017");
cds.configurator.DefaultRule.add(configurator, "bm55000;tea018");
cds.configurator.DefaultRule.add(configurator, "bm55000;tea019");
cds.configurator.DefaultRule.add(configurator, "bm55000;tea020");
cds.configurator.DefaultRule.add(configurator, "bm55000;tea021");
cds.configurator.DefaultRule.add(configurator, "bm55000;tea022");
cds.configurator.DefaultRule.add(configurator, "bm55000;tea023");
cds.configurator.DefaultRule.add(configurator, "bm55000;tea024");
cds.configurator.DefaultRule.add(configurator, "bm55000;tea025");
cds.configurator.DefaultRule.add(configurator, "bm55000;tea026");
cds.configurator.DefaultRule.add(configurator, "bm55000;tea027");
cds.configurator.DefaultRule.add(configurator, "bm55000;tea031");
cds.configurator.DefaultRule.add(configurator, "bm55000;tea033");
cds.configurator.DefaultRule.add(configurator, "bm55000;tea035");
cds.configurator.DefaultRule.add(configurator, "bm55000;tea037");
cds.configurator.DefaultRule.add(configurator, "bm55000;tea039");
cds.configurator.DefaultRule.add(configurator, "bm55000;tea041");
cds.configurator.DefaultRule.add(configurator, "bm55000;tea042");
cds.configurator.DefaultRule.add(configurator, "bm55000;tea043");
cds.configurator.DefaultRule.add(configurator, "bm55000;tea045");
cds.configurator.DefaultRule.add(configurator, "bm55000;tea046");
cds.configurator.DefaultRule.add(configurator, "bm55000;tea050");
cds.configurator.DefaultRule.add(configurator, "bm55000;tea053");
cds.configurator.DefaultRule.add(configurator, "bm55000;tea062");
cds.configurator.DefaultRule.add(configurator, "bm55000;tea063");
cds.configurator.DefaultRule.add(configurator, "bm55000;tea067");
cds.configurator.DefaultRule.add(configurator, "bm55000;tea070");
cds.configurator.DefaultRule.add(configurator, "bm55000;tea071");
cds.configurator.DefaultRule.add(configurator, "bm55000;tea074");
cds.configurator.DefaultRule.add(configurator, "bm55000;tea075");
cds.configurator.DefaultRule.add(configurator, "bm55000;tea084");
cds.configurator.DefaultRule.add(configurator, "bm55000;tea096");
cds.configurator.DefaultRule.add(configurator, "bm55000;tea100");
cds.configurator.DefaultRule.add(configurator, "bm55000;tea120");
cds.configurator.DefaultRule.add(configurator, "bm55000;tea126");
cds.configurator.DefaultRule.add(configurator, "bm55000;tea140");
cds.configurator.DefaultRule.add(configurator, "bm55000;tea154");
cds.configurator.DefaultRule.add(configurator, "bm55000;tea180");
cds.configurator.DefaultRule.add(configurator, "bm55000;tea200");
cds.configurator.DefaultRule.add(configurator, "bm55000;tea216");
cds.configurator.DefaultRule.add(configurator, "bm55000;tea224");
cds.configurator.DefaultRule.add(configurator, "bm55000;teb010");
cds.configurator.DefaultRule.add(configurator, "bm55000;teb011");
cds.configurator.DefaultRule.add(configurator, "bm55000;teb012");
cds.configurator.DefaultRule.add(configurator, "bm55000;teb013");
cds.configurator.DefaultRule.add(configurator, "bm55000;teb014");
cds.configurator.DefaultRule.add(configurator, "bm55000;teb015");
cds.configurator.DefaultRule.add(configurator, "bm55000;teb016");
cds.configurator.DefaultRule.add(configurator, "bm55000;teb017");
cds.configurator.DefaultRule.add(configurator, "bm55000;teb018");
cds.configurator.DefaultRule.add(configurator, "bm55000;teb019");
cds.configurator.DefaultRule.add(configurator, "bm55000;teb020");
cds.configurator.DefaultRule.add(configurator, "bm55000;teb021");
cds.configurator.DefaultRule.add(configurator, "bm55000;teb022");
cds.configurator.DefaultRule.add(configurator, "bm55000;teb023");
cds.configurator.DefaultRule.add(configurator, "bm55000;teb024");
cds.configurator.DefaultRule.add(configurator, "bm55000;teb025");
cds.configurator.DefaultRule.add(configurator, "bm55000;teb026");
cds.configurator.DefaultRule.add(configurator, "bm55000;teb027");
cds.configurator.DefaultRule.add(configurator, "bm55000;teb031");
cds.configurator.DefaultRule.add(configurator, "bm55000;teb033");
cds.configurator.DefaultRule.add(configurator, "bm55000;teb035");
cds.configurator.DefaultRule.add(configurator, "bm55000;teb037");
cds.configurator.DefaultRule.add(configurator, "bm55000;teb039");
cds.configurator.DefaultRule.add(configurator, "bm55000;teb041");
cds.configurator.DefaultRule.add(configurator, "bm55000;teb042");
cds.configurator.DefaultRule.add(configurator, "bm55000;teb043");
cds.configurator.DefaultRule.add(configurator, "bm55000;teb045");
cds.configurator.DefaultRule.add(configurator, "bm55000;teb046");
cds.configurator.DefaultRule.add(configurator, "bm55000;teb050");
cds.configurator.DefaultRule.add(configurator, "bm55000;teb053");
cds.configurator.DefaultRule.add(configurator, "bm55000;teb062");
cds.configurator.DefaultRule.add(configurator, "bm55000;teb063");
cds.configurator.DefaultRule.add(configurator, "bm55000;teb067");
cds.configurator.DefaultRule.add(configurator, "bm55000;teb070");
cds.configurator.DefaultRule.add(configurator, "bm55000;teb071");
cds.configurator.DefaultRule.add(configurator, "bm55000;teb074");
cds.configurator.DefaultRule.add(configurator, "bm55000;teb075");
cds.configurator.DefaultRule.add(configurator, "bm55000;teb084");
cds.configurator.DefaultRule.add(configurator, "bm55000;teb096");
cds.configurator.DefaultRule.add(configurator, "bm55000;teb100");
cds.configurator.DefaultRule.add(configurator, "bm55000;teb120");
cds.configurator.DefaultRule.add(configurator, "bm55000;teb126");
cds.configurator.DefaultRule.add(configurator, "bm55000;teb140");
cds.configurator.DefaultRule.add(configurator, "bm55000;teb154");
cds.configurator.DefaultRule.add(configurator, "bm55000;teb180");
cds.configurator.DefaultRule.add(configurator, "bm55000;teb200");
cds.configurator.DefaultRule.add(configurator, "bm55000;teb216");
cds.configurator.DefaultRule.add(configurator, "bm55000;teb224");
cds.configurator.DefaultRule.add(configurator, "bm62000;sehhh");
cds.configurator.DefaultRule.add(configurator, "bm62000;selll");
cds.configurator.DefaultRule.add(configurator, "bm62000;semxl");
cds.configurator.DefaultRule.add(configurator, "bm62000;sexll");
cds.configurator.DefaultRule.add(configurator, "bm62000;sma05");
cds.configurator.DefaultRule.add(configurator, "bm62000;sma10");
cds.configurator.DefaultRule.add(configurator, "bm62000;smh03");
cds.configurator.DefaultRule.add(configurator, "bm62000;smh05");
cds.configurator.DefaultRule.add(configurator, "bm62000;smh08");
cds.configurator.DefaultRule.add(configurator, "bm62000;smt05");
cds.configurator.DefaultRule.add(configurator, "bm62000;smt10");
cds.configurator.DefaultRule.add(configurator, "bm62000;smt25");
cds.configurator.DefaultRule.add(configurator, "bm62000;tea010");
cds.configurator.DefaultRule.add(configurator, "bm62000;tea011");
cds.configurator.DefaultRule.add(configurator, "bm62000;tea012");
cds.configurator.DefaultRule.add(configurator, "bm62000;tea013");
cds.configurator.DefaultRule.add(configurator, "bm62000;tea014");
cds.configurator.DefaultRule.add(configurator, "bm62000;tea015");
cds.configurator.DefaultRule.add(configurator, "bm62000;tea016");
cds.configurator.DefaultRule.add(configurator, "bm62000;tea017");
cds.configurator.DefaultRule.add(configurator, "bm62000;tea018");
cds.configurator.DefaultRule.add(configurator, "bm62000;tea019");
cds.configurator.DefaultRule.add(configurator, "bm62000;tea020");
cds.configurator.DefaultRule.add(configurator, "bm62000;tea021");
cds.configurator.DefaultRule.add(configurator, "bm62000;tea023");
cds.configurator.DefaultRule.add(configurator, "bm62000;tea024");
cds.configurator.DefaultRule.add(configurator, "bm62000;tea026");
cds.configurator.DefaultRule.add(configurator, "bm62000;tea027");
cds.configurator.DefaultRule.add(configurator, "bm62000;tea029");
cds.configurator.DefaultRule.add(configurator, "bm62000;tea031");
cds.configurator.DefaultRule.add(configurator, "bm62000;tea033");
cds.configurator.DefaultRule.add(configurator, "bm62000;tea035");
cds.configurator.DefaultRule.add(configurator, "bm62000;tea037");
cds.configurator.DefaultRule.add(configurator, "bm62000;tea039");
cds.configurator.DefaultRule.add(configurator, "bm62000;tea041");
cds.configurator.DefaultRule.add(configurator, "bm62000;tea043");
cds.configurator.DefaultRule.add(configurator, "bm62000;tea044");
cds.configurator.DefaultRule.add(configurator, "bm62000;tea046");
cds.configurator.DefaultRule.add(configurator, "bm62000;tea052");
cds.configurator.DefaultRule.add(configurator, "bm62000;tea062");
cds.configurator.DefaultRule.add(configurator, "bm62000;tea064");
cds.configurator.DefaultRule.add(configurator, "bm62000;tea068");
cds.configurator.DefaultRule.add(configurator, "bm62000;tea070");
cds.configurator.DefaultRule.add(configurator, "bm62000;tea072");
cds.configurator.DefaultRule.add(configurator, "bm62000;tea074");
cds.configurator.DefaultRule.add(configurator, "bm62000;tea084");
cds.configurator.DefaultRule.add(configurator, "bm62000;tea096");
cds.configurator.DefaultRule.add(configurator, "bm62000;tea100");
cds.configurator.DefaultRule.add(configurator, "bm62000;tea120");
cds.configurator.DefaultRule.add(configurator, "bm62000;tea126");
cds.configurator.DefaultRule.add(configurator, "bm62000;tea144");
cds.configurator.DefaultRule.add(configurator, "bm62000;tea154");
cds.configurator.DefaultRule.add(configurator, "bm62000;tea168");
cds.configurator.DefaultRule.add(configurator, "bm62000;tea192");
cds.configurator.DefaultRule.add(configurator, "bm62000;tea200");
cds.configurator.DefaultRule.add(configurator, "bm62000;tea216");
cds.configurator.DefaultRule.add(configurator, "bm62000;teb010");
cds.configurator.DefaultRule.add(configurator, "bm62000;teb011");
cds.configurator.DefaultRule.add(configurator, "bm62000;teb012");
cds.configurator.DefaultRule.add(configurator, "bm62000;teb013");
cds.configurator.DefaultRule.add(configurator, "bm62000;teb014");
cds.configurator.DefaultRule.add(configurator, "bm62000;teb015");
cds.configurator.DefaultRule.add(configurator, "bm62000;teb016");
cds.configurator.DefaultRule.add(configurator, "bm62000;teb017");
cds.configurator.DefaultRule.add(configurator, "bm62000;teb018");
cds.configurator.DefaultRule.add(configurator, "bm62000;teb019");
cds.configurator.DefaultRule.add(configurator, "bm62000;teb020");
cds.configurator.DefaultRule.add(configurator, "bm62000;teb021");
cds.configurator.DefaultRule.add(configurator, "bm62000;teb023");
cds.configurator.DefaultRule.add(configurator, "bm62000;teb024");
cds.configurator.DefaultRule.add(configurator, "bm62000;teb026");
cds.configurator.DefaultRule.add(configurator, "bm62000;teb027");
cds.configurator.DefaultRule.add(configurator, "bm62000;teb029");
cds.configurator.DefaultRule.add(configurator, "bm62000;teb031");
cds.configurator.DefaultRule.add(configurator, "bm62000;teb033");
cds.configurator.DefaultRule.add(configurator, "bm62000;teb035");
cds.configurator.DefaultRule.add(configurator, "bm62000;teb037");
cds.configurator.DefaultRule.add(configurator, "bm62000;teb039");
cds.configurator.DefaultRule.add(configurator, "bm62000;teb041");
cds.configurator.DefaultRule.add(configurator, "bm62000;teb043");
cds.configurator.DefaultRule.add(configurator, "bm62000;teb044");
cds.configurator.DefaultRule.add(configurator, "bm62000;teb046");
cds.configurator.DefaultRule.add(configurator, "bm62000;teb052");
cds.configurator.DefaultRule.add(configurator, "bm62000;teb062");
cds.configurator.DefaultRule.add(configurator, "bm62000;teb064");
cds.configurator.DefaultRule.add(configurator, "bm62000;teb068");
cds.configurator.DefaultRule.add(configurator, "bm62000;teb070");
cds.configurator.DefaultRule.add(configurator, "bm62000;teb072");
cds.configurator.DefaultRule.add(configurator, "bm62000;teb074");
cds.configurator.DefaultRule.add(configurator, "bm62000;teb084");
cds.configurator.DefaultRule.add(configurator, "bm62000;teb096");
cds.configurator.DefaultRule.add(configurator, "bm62000;teb100");
cds.configurator.DefaultRule.add(configurator, "bm62000;teb120");
cds.configurator.DefaultRule.add(configurator, "bm62000;teb126");
cds.configurator.DefaultRule.add(configurator, "bm62000;teb144");
cds.configurator.DefaultRule.add(configurator, "bm62000;teb154");
cds.configurator.DefaultRule.add(configurator, "bm62000;teb168");
cds.configurator.DefaultRule.add(configurator, "bm62000;teb192");
cds.configurator.DefaultRule.add(configurator, "bm62000;teb200");
cds.configurator.DefaultRule.add(configurator, "bm62000;teb216");
cds.configurator.DefaultRule.add(configurator, "bm68000;sehhh");
cds.configurator.DefaultRule.add(configurator, "bm68000;selll");
cds.configurator.DefaultRule.add(configurator, "bm68000;semxl");
cds.configurator.DefaultRule.add(configurator, "bm68000;sexll");
cds.configurator.DefaultRule.add(configurator, "bm68000;sma05");
cds.configurator.DefaultRule.add(configurator, "bm68000;sma10");
cds.configurator.DefaultRule.add(configurator, "bm68000;smh03");
cds.configurator.DefaultRule.add(configurator, "bm68000;smh05");
cds.configurator.DefaultRule.add(configurator, "bm68000;smh08");
cds.configurator.DefaultRule.add(configurator, "bm68000;smt05");
cds.configurator.DefaultRule.add(configurator, "bm68000;smt10");
cds.configurator.DefaultRule.add(configurator, "bm68000;smt25");
cds.configurator.DefaultRule.add(configurator, "bm68000;tea010");
cds.configurator.DefaultRule.add(configurator, "bm68000;tea011");
cds.configurator.DefaultRule.add(configurator, "bm68000;tea012");
cds.configurator.DefaultRule.add(configurator, "bm68000;tea013");
cds.configurator.DefaultRule.add(configurator, "bm68000;tea014");
cds.configurator.DefaultRule.add(configurator, "bm68000;tea015");
cds.configurator.DefaultRule.add(configurator, "bm68000;tea016");
cds.configurator.DefaultRule.add(configurator, "bm68000;tea017");
cds.configurator.DefaultRule.add(configurator, "bm68000;tea018");
cds.configurator.DefaultRule.add(configurator, "bm68000;tea019");
cds.configurator.DefaultRule.add(configurator, "bm68000;tea020");
cds.configurator.DefaultRule.add(configurator, "bm68000;tea021");
cds.configurator.DefaultRule.add(configurator, "bm68000;tea022");
cds.configurator.DefaultRule.add(configurator, "bm68000;tea023");
cds.configurator.DefaultRule.add(configurator, "bm68000;tea024");
cds.configurator.DefaultRule.add(configurator, "bm68000;tea025");
cds.configurator.DefaultRule.add(configurator, "bm68000;tea026");
cds.configurator.DefaultRule.add(configurator, "bm68000;tea027");
cds.configurator.DefaultRule.add(configurator, "bm68000;tea041");
cds.configurator.DefaultRule.add(configurator, "bm68000;tea042");
cds.configurator.DefaultRule.add(configurator, "bm68000;tea044");
cds.configurator.DefaultRule.add(configurator, "bm68000;tea046");
cds.configurator.DefaultRule.add(configurator, "bm68000;tea052");
cds.configurator.DefaultRule.add(configurator, "bm68000;tea062");
cds.configurator.DefaultRule.add(configurator, "bm68000;tea064");
cds.configurator.DefaultRule.add(configurator, "bm68000;tea068");
cds.configurator.DefaultRule.add(configurator, "bm68000;tea070");
cds.configurator.DefaultRule.add(configurator, "bm68000;tea072");
cds.configurator.DefaultRule.add(configurator, "bm68000;tea074");
cds.configurator.DefaultRule.add(configurator, "bm68000;tea084");
cds.configurator.DefaultRule.add(configurator, "bm68000;tea096");
cds.configurator.DefaultRule.add(configurator, "bm68000;tea100");
cds.configurator.DefaultRule.add(configurator, "bm68000;tea120");
cds.configurator.DefaultRule.add(configurator, "bm68000;tea126");
cds.configurator.DefaultRule.add(configurator, "bm68000;tea144");
cds.configurator.DefaultRule.add(configurator, "bm68000;tea154");
cds.configurator.DefaultRule.add(configurator, "bm68000;tea192");
cds.configurator.DefaultRule.add(configurator, "bm68000;tea216");
cds.configurator.DefaultRule.add(configurator, "bm68000;teb010");
cds.configurator.DefaultRule.add(configurator, "bm68000;teb011");
cds.configurator.DefaultRule.add(configurator, "bm68000;teb012");
cds.configurator.DefaultRule.add(configurator, "bm68000;teb013");
cds.configurator.DefaultRule.add(configurator, "bm68000;teb014");
cds.configurator.DefaultRule.add(configurator, "bm68000;teb015");
cds.configurator.DefaultRule.add(configurator, "bm68000;teb016");
cds.configurator.DefaultRule.add(configurator, "bm68000;teb017");
cds.configurator.DefaultRule.add(configurator, "bm68000;teb018");
cds.configurator.DefaultRule.add(configurator, "bm68000;teb019");
cds.configurator.DefaultRule.add(configurator, "bm68000;teb020");
cds.configurator.DefaultRule.add(configurator, "bm68000;teb021");
cds.configurator.DefaultRule.add(configurator, "bm68000;teb022");
cds.configurator.DefaultRule.add(configurator, "bm68000;teb023");
cds.configurator.DefaultRule.add(configurator, "bm68000;teb024");
cds.configurator.DefaultRule.add(configurator, "bm68000;teb025");
cds.configurator.DefaultRule.add(configurator, "bm68000;teb026");
cds.configurator.DefaultRule.add(configurator, "bm68000;teb027");
cds.configurator.DefaultRule.add(configurator, "bm68000;teb041");
cds.configurator.DefaultRule.add(configurator, "bm68000;teb042");
cds.configurator.DefaultRule.add(configurator, "bm68000;teb044");
cds.configurator.DefaultRule.add(configurator, "bm68000;teb046");
cds.configurator.DefaultRule.add(configurator, "bm68000;teb052");
cds.configurator.DefaultRule.add(configurator, "bm68000;teb062");
cds.configurator.DefaultRule.add(configurator, "bm68000;teb064");
cds.configurator.DefaultRule.add(configurator, "bm68000;teb068");
cds.configurator.DefaultRule.add(configurator, "bm68000;teb070");
cds.configurator.DefaultRule.add(configurator, "bm68000;teb072");
cds.configurator.DefaultRule.add(configurator, "bm68000;teb074");
cds.configurator.DefaultRule.add(configurator, "bm68000;teb084");
cds.configurator.DefaultRule.add(configurator, "bm68000;teb096");
cds.configurator.DefaultRule.add(configurator, "bm68000;teb100");
cds.configurator.DefaultRule.add(configurator, "bm68000;teb120");
cds.configurator.DefaultRule.add(configurator, "bm68000;teb126");
cds.configurator.DefaultRule.add(configurator, "bm68000;teb144");
cds.configurator.DefaultRule.add(configurator, "bm68000;teb154");
cds.configurator.DefaultRule.add(configurator, "bm68000;teb192");
cds.configurator.DefaultRule.add(configurator, "bm68000;teb216");
cds.configurator.DefaultRule.add(configurator, "bm76200;selll");
cds.configurator.DefaultRule.add(configurator, "bm76200;semxl");
cds.configurator.DefaultRule.add(configurator, "bm76200;sexll");
cds.configurator.DefaultRule.add(configurator, "bm76200;sma05");
cds.configurator.DefaultRule.add(configurator, "bm76200;sma10");
cds.configurator.DefaultRule.add(configurator, "bm76200;smh03");
cds.configurator.DefaultRule.add(configurator, "bm76200;smh05");
cds.configurator.DefaultRule.add(configurator, "bm76200;smh08");
cds.configurator.DefaultRule.add(configurator, "bm76200;smt05");
cds.configurator.DefaultRule.add(configurator, "bm76200;smt10");
cds.configurator.DefaultRule.add(configurator, "bm76200;smt25");
cds.configurator.DefaultRule.add(configurator, "bm76200;tea010");
cds.configurator.DefaultRule.add(configurator, "bm76200;tea011");
cds.configurator.DefaultRule.add(configurator, "bm76200;tea012");
cds.configurator.DefaultRule.add(configurator, "bm76200;tea013");
cds.configurator.DefaultRule.add(configurator, "bm76200;tea014");
cds.configurator.DefaultRule.add(configurator, "bm76200;tea015");
cds.configurator.DefaultRule.add(configurator, "bm76200;tea023");
cds.configurator.DefaultRule.add(configurator, "bm76200;tea025");
cds.configurator.DefaultRule.add(configurator, "bm76200;tea027");
cds.configurator.DefaultRule.add(configurator, "bm76200;tea029");
cds.configurator.DefaultRule.add(configurator, "bm76200;tea031");
cds.configurator.DefaultRule.add(configurator, "bm76200;tea033");
cds.configurator.DefaultRule.add(configurator, "bm76200;tea034");
cds.configurator.DefaultRule.add(configurator, "bm76200;tea035");
cds.configurator.DefaultRule.add(configurator, "bm76200;tea037");
cds.configurator.DefaultRule.add(configurator, "bm76200;tea038");
cds.configurator.DefaultRule.add(configurator, "bm76200;tea039");
cds.configurator.DefaultRule.add(configurator, "bm76200;tea041");
cds.configurator.DefaultRule.add(configurator, "bm76200;tea042");
cds.configurator.DefaultRule.add(configurator, "bm76200;tea043");
cds.configurator.DefaultRule.add(configurator, "bm76200;tea045");
cds.configurator.DefaultRule.add(configurator, "bm76200;tea046");
cds.configurator.DefaultRule.add(configurator, "bm76200;tea050");
cds.configurator.DefaultRule.add(configurator, "bm76200;tea052");
cds.configurator.DefaultRule.add(configurator, "bm76200;tea053");
cds.configurator.DefaultRule.add(configurator, "bm76200;tea056");
cds.configurator.DefaultRule.add(configurator, "bm76200;tea062");
cds.configurator.DefaultRule.add(configurator, "bm76200;tea063");
cds.configurator.DefaultRule.add(configurator, "bm76200;tea064");
cds.configurator.DefaultRule.add(configurator, "bm76200;tea067");
cds.configurator.DefaultRule.add(configurator, "bm76200;tea068");
cds.configurator.DefaultRule.add(configurator, "bm76200;tea070");
cds.configurator.DefaultRule.add(configurator, "bm76200;tea071");
cds.configurator.DefaultRule.add(configurator, "bm76200;tea074");
cds.configurator.DefaultRule.add(configurator, "bm76200;tea075");
cds.configurator.DefaultRule.add(configurator, "bm76200;tea080");
cds.configurator.DefaultRule.add(configurator, "bm76200;tea090");
cds.configurator.DefaultRule.add(configurator, "bm76200;tea100");
cds.configurator.DefaultRule.add(configurator, "bm76200;tea112");
cds.configurator.DefaultRule.add(configurator, "bm76200;tea126");
cds.configurator.DefaultRule.add(configurator, "bm76200;tea140");
cds.configurator.DefaultRule.add(configurator, "bm76200;tea144");
cds.configurator.DefaultRule.add(configurator, "bm76200;tea154");
cds.configurator.DefaultRule.add(configurator, "bm76200;tea168");
cds.configurator.DefaultRule.add(configurator, "bm76200;tea180");
cds.configurator.DefaultRule.add(configurator, "bm76200;tea192");
cds.configurator.DefaultRule.add(configurator, "bm76200;tea200");
cds.configurator.DefaultRule.add(configurator, "bm76200;tea216");
cds.configurator.DefaultRule.add(configurator, "bm76200;tea224");
cds.configurator.DefaultRule.add(configurator, "bm76200;teb010");
cds.configurator.DefaultRule.add(configurator, "bm76200;teb011");
cds.configurator.DefaultRule.add(configurator, "bm76200;teb012");
cds.configurator.DefaultRule.add(configurator, "bm76200;teb013");
cds.configurator.DefaultRule.add(configurator, "bm76200;teb014");
cds.configurator.DefaultRule.add(configurator, "bm76200;teb015");
cds.configurator.DefaultRule.add(configurator, "bm76200;teb023");
cds.configurator.DefaultRule.add(configurator, "bm76200;teb025");
cds.configurator.DefaultRule.add(configurator, "bm76200;teb027");
cds.configurator.DefaultRule.add(configurator, "bm76200;teb029");
cds.configurator.DefaultRule.add(configurator, "bm76200;teb031");
cds.configurator.DefaultRule.add(configurator, "bm76200;teb033");
cds.configurator.DefaultRule.add(configurator, "bm76200;teb034");
cds.configurator.DefaultRule.add(configurator, "bm76200;teb035");
cds.configurator.DefaultRule.add(configurator, "bm76200;teb037");
cds.configurator.DefaultRule.add(configurator, "bm76200;teb038");
cds.configurator.DefaultRule.add(configurator, "bm76200;teb039");
cds.configurator.DefaultRule.add(configurator, "bm76200;teb041");
cds.configurator.DefaultRule.add(configurator, "bm76200;teb042");
cds.configurator.DefaultRule.add(configurator, "bm76200;teb043");
cds.configurator.DefaultRule.add(configurator, "bm76200;teb045");
cds.configurator.DefaultRule.add(configurator, "bm76200;teb046");
cds.configurator.DefaultRule.add(configurator, "bm76200;teb050");
cds.configurator.DefaultRule.add(configurator, "bm76200;teb052");
cds.configurator.DefaultRule.add(configurator, "bm76200;teb053");
cds.configurator.DefaultRule.add(configurator, "bm76200;teb056");
cds.configurator.DefaultRule.add(configurator, "bm76200;teb062");
cds.configurator.DefaultRule.add(configurator, "bm76200;teb063");
cds.configurator.DefaultRule.add(configurator, "bm76200;teb064");
cds.configurator.DefaultRule.add(configurator, "bm76200;teb067");
cds.configurator.DefaultRule.add(configurator, "bm76200;teb068");
cds.configurator.DefaultRule.add(configurator, "bm76200;teb070");
cds.configurator.DefaultRule.add(configurator, "bm76200;teb071");
cds.configurator.DefaultRule.add(configurator, "bm76200;teb074");
cds.configurator.DefaultRule.add(configurator, "bm76200;teb075");
cds.configurator.DefaultRule.add(configurator, "bm76200;teb080");
cds.configurator.DefaultRule.add(configurator, "bm76200;teb090");
cds.configurator.DefaultRule.add(configurator, "bm76200;teb100");
cds.configurator.DefaultRule.add(configurator, "bm76200;teb112");
cds.configurator.DefaultRule.add(configurator, "bm76200;teb126");
cds.configurator.DefaultRule.add(configurator, "bm76200;teb140");
cds.configurator.DefaultRule.add(configurator, "bm76200;teb144");
cds.configurator.DefaultRule.add(configurator, "bm76200;teb154");
cds.configurator.DefaultRule.add(configurator, "bm76200;teb168");
cds.configurator.DefaultRule.add(configurator, "bm76200;teb180");
cds.configurator.DefaultRule.add(configurator, "bm76200;teb192");
cds.configurator.DefaultRule.add(configurator, "bm76200;teb200");
cds.configurator.DefaultRule.add(configurator, "bm76200;teb216");
cds.configurator.DefaultRule.add(configurator, "bm76200;teb224");
cds.configurator.DefaultRule.add(configurator, "bm85000;sehhh");
cds.configurator.DefaultRule.add(configurator, "bm85000;selll");
cds.configurator.DefaultRule.add(configurator, "bm85000;semxl");
cds.configurator.DefaultRule.add(configurator, "bm85000;sexll");
cds.configurator.DefaultRule.add(configurator, "bm85000;sma05");
cds.configurator.DefaultRule.add(configurator, "bm85000;sma10");
cds.configurator.DefaultRule.add(configurator, "bm85000;smh03");
cds.configurator.DefaultRule.add(configurator, "bm85000;smh05");
cds.configurator.DefaultRule.add(configurator, "bm85000;smt05");
cds.configurator.DefaultRule.add(configurator, "bm85000;smt10");
cds.configurator.DefaultRule.add(configurator, "bm85000;smt25");
cds.configurator.DefaultRule.add(configurator, "bm85000;tea010");
cds.configurator.DefaultRule.add(configurator, "bm85000;tea011");
cds.configurator.DefaultRule.add(configurator, "bm85000;tea012");
cds.configurator.DefaultRule.add(configurator, "bm85000;tea013");
cds.configurator.DefaultRule.add(configurator, "bm85000;tea014");
cds.configurator.DefaultRule.add(configurator, "bm85000;tea015");
cds.configurator.DefaultRule.add(configurator, "bm85000;tea016");
cds.configurator.DefaultRule.add(configurator, "bm85000;tea017");
cds.configurator.DefaultRule.add(configurator, "bm85000;tea018");
cds.configurator.DefaultRule.add(configurator, "bm85000;tea019");
cds.configurator.DefaultRule.add(configurator, "bm85000;tea020");
cds.configurator.DefaultRule.add(configurator, "bm85000;tea021");
cds.configurator.DefaultRule.add(configurator, "bm85000;tea022");
cds.configurator.DefaultRule.add(configurator, "bm85000;tea023");
cds.configurator.DefaultRule.add(configurator, "bm85000;tea024");
cds.configurator.DefaultRule.add(configurator, "bm85000;tea025");
cds.configurator.DefaultRule.add(configurator, "bm85000;tea026");
cds.configurator.DefaultRule.add(configurator, "bm85000;tea027");
cds.configurator.DefaultRule.add(configurator, "bm85000;tea031");
cds.configurator.DefaultRule.add(configurator, "bm85000;tea033");
cds.configurator.DefaultRule.add(configurator, "bm85000;tea035");
cds.configurator.DefaultRule.add(configurator, "bm85000;tea037");
cds.configurator.DefaultRule.add(configurator, "bm85000;tea039");
cds.configurator.DefaultRule.add(configurator, "bm85000;tea041");
cds.configurator.DefaultRule.add(configurator, "bm85000;tea042");
cds.configurator.DefaultRule.add(configurator, "bm85000;tea043");
cds.configurator.DefaultRule.add(configurator, "bm85000;tea045");
cds.configurator.DefaultRule.add(configurator, "bm85000;tea046");
cds.configurator.DefaultRule.add(configurator, "bm85000;tea050");
cds.configurator.DefaultRule.add(configurator, "bm85000;tea053");
cds.configurator.DefaultRule.add(configurator, "bm85000;tea062");
cds.configurator.DefaultRule.add(configurator, "bm85000;tea063");
cds.configurator.DefaultRule.add(configurator, "bm85000;tea067");
cds.configurator.DefaultRule.add(configurator, "bm85000;tea070");
cds.configurator.DefaultRule.add(configurator, "bm85000;tea071");
cds.configurator.DefaultRule.add(configurator, "bm85000;tea074");
cds.configurator.DefaultRule.add(configurator, "bm85000;tea075");
cds.configurator.DefaultRule.add(configurator, "bm85000;tea084");
cds.configurator.DefaultRule.add(configurator, "bm85000;tea096");
cds.configurator.DefaultRule.add(configurator, "bm85000;tea100");
cds.configurator.DefaultRule.add(configurator, "bm85000;tea120");
cds.configurator.DefaultRule.add(configurator, "bm85000;tea126");
cds.configurator.DefaultRule.add(configurator, "bm85000;tea140");
cds.configurator.DefaultRule.add(configurator, "bm85000;tea154");
cds.configurator.DefaultRule.add(configurator, "bm85000;tea180");
cds.configurator.DefaultRule.add(configurator, "bm85000;tea200");
cds.configurator.DefaultRule.add(configurator, "bm85000;tea216");
cds.configurator.DefaultRule.add(configurator, "bm85000;tea224");
cds.configurator.DefaultRule.add(configurator, "bm85000;teb010");
cds.configurator.DefaultRule.add(configurator, "bm85000;teb011");
cds.configurator.DefaultRule.add(configurator, "bm85000;teb012");
cds.configurator.DefaultRule.add(configurator, "bm85000;teb013");
cds.configurator.DefaultRule.add(configurator, "bm85000;teb014");
cds.configurator.DefaultRule.add(configurator, "bm85000;teb015");
cds.configurator.DefaultRule.add(configurator, "bm85000;teb016");
cds.configurator.DefaultRule.add(configurator, "bm85000;teb017");
cds.configurator.DefaultRule.add(configurator, "bm85000;teb018");
cds.configurator.DefaultRule.add(configurator, "bm85000;teb019");
cds.configurator.DefaultRule.add(configurator, "bm85000;teb020");
cds.configurator.DefaultRule.add(configurator, "bm85000;teb021");
cds.configurator.DefaultRule.add(configurator, "bm85000;teb022");
cds.configurator.DefaultRule.add(configurator, "bm85000;teb023");
cds.configurator.DefaultRule.add(configurator, "bm85000;teb024");
cds.configurator.DefaultRule.add(configurator, "bm85000;teb025");
cds.configurator.DefaultRule.add(configurator, "bm85000;teb026");
cds.configurator.DefaultRule.add(configurator, "bm85000;teb027");
cds.configurator.DefaultRule.add(configurator, "bm85000;teb031");
cds.configurator.DefaultRule.add(configurator, "bm85000;teb033");
cds.configurator.DefaultRule.add(configurator, "bm85000;teb035");
cds.configurator.DefaultRule.add(configurator, "bm85000;teb037");
cds.configurator.DefaultRule.add(configurator, "bm85000;teb039");
cds.configurator.DefaultRule.add(configurator, "bm85000;teb041");
cds.configurator.DefaultRule.add(configurator, "bm85000;teb042");
cds.configurator.DefaultRule.add(configurator, "bm85000;teb043");
cds.configurator.DefaultRule.add(configurator, "bm85000;teb045");
cds.configurator.DefaultRule.add(configurator, "bm85000;teb046");
cds.configurator.DefaultRule.add(configurator, "bm85000;teb050");
cds.configurator.DefaultRule.add(configurator, "bm85000;teb053");
cds.configurator.DefaultRule.add(configurator, "bm85000;teb062");
cds.configurator.DefaultRule.add(configurator, "bm85000;teb063");
cds.configurator.DefaultRule.add(configurator, "bm85000;teb067");
cds.configurator.DefaultRule.add(configurator, "bm85000;teb070");
cds.configurator.DefaultRule.add(configurator, "bm85000;teb071");
cds.configurator.DefaultRule.add(configurator, "bm85000;teb074");
cds.configurator.DefaultRule.add(configurator, "bm85000;teb075");
cds.configurator.DefaultRule.add(configurator, "bm85000;teb084");
cds.configurator.DefaultRule.add(configurator, "bm85000;teb096");
cds.configurator.DefaultRule.add(configurator, "bm85000;teb100");
cds.configurator.DefaultRule.add(configurator, "bm85000;teb120");
cds.configurator.DefaultRule.add(configurator, "bm85000;teb126");
cds.configurator.DefaultRule.add(configurator, "bm85000;teb140");
cds.configurator.DefaultRule.add(configurator, "bm85000;teb154");
cds.configurator.DefaultRule.add(configurator, "bm85000;teb180");
cds.configurator.DefaultRule.add(configurator, "bm85000;teb200");
cds.configurator.DefaultRule.add(configurator, "bm85000;teb216");
cds.configurator.DefaultRule.add(configurator, "bm85000;teb224");
cds.configurator.DefaultRule.add(configurator, "bm90000;sehhh");
cds.configurator.DefaultRule.add(configurator, "bm90000;selll");
cds.configurator.DefaultRule.add(configurator, "bm90000;semxl");
cds.configurator.DefaultRule.add(configurator, "bm90000;sexll");
cds.configurator.DefaultRule.add(configurator, "bm90000;sma05");
cds.configurator.DefaultRule.add(configurator, "bm90000;sma10");
cds.configurator.DefaultRule.add(configurator, "bm90000;smh03");
cds.configurator.DefaultRule.add(configurator, "bm90000;smh05");
cds.configurator.DefaultRule.add(configurator, "bm90000;smh08");
cds.configurator.DefaultRule.add(configurator, "bm90000;smt05");
cds.configurator.DefaultRule.add(configurator, "bm90000;smt10");
cds.configurator.DefaultRule.add(configurator, "bm90000;smt25");
cds.configurator.DefaultRule.add(configurator, "bm90000;tea010");
cds.configurator.DefaultRule.add(configurator, "bm90000;tea011");
cds.configurator.DefaultRule.add(configurator, "bm90000;tea012");
cds.configurator.DefaultRule.add(configurator, "bm90000;tea013");
cds.configurator.DefaultRule.add(configurator, "bm90000;tea014");
cds.configurator.DefaultRule.add(configurator, "bm90000;tea015");
cds.configurator.DefaultRule.add(configurator, "bm90000;tea016");
cds.configurator.DefaultRule.add(configurator, "bm90000;tea017");
cds.configurator.DefaultRule.add(configurator, "bm90000;tea018");
cds.configurator.DefaultRule.add(configurator, "bm90000;tea019");
cds.configurator.DefaultRule.add(configurator, "bm90000;tea020");
cds.configurator.DefaultRule.add(configurator, "bm90000;tea021");
cds.configurator.DefaultRule.add(configurator, "bm90000;tea022");
cds.configurator.DefaultRule.add(configurator, "bm90000;tea023");
cds.configurator.DefaultRule.add(configurator, "bm90000;tea024");
cds.configurator.DefaultRule.add(configurator, "bm90000;tea025");
cds.configurator.DefaultRule.add(configurator, "bm90000;tea026");
cds.configurator.DefaultRule.add(configurator, "bm90000;tea027");
cds.configurator.DefaultRule.add(configurator, "bm90000;tea041");
cds.configurator.DefaultRule.add(configurator, "bm90000;tea042");
cds.configurator.DefaultRule.add(configurator, "bm90000;tea044");
cds.configurator.DefaultRule.add(configurator, "bm90000;tea046");
cds.configurator.DefaultRule.add(configurator, "bm90000;tea052");
cds.configurator.DefaultRule.add(configurator, "bm90000;tea062");
cds.configurator.DefaultRule.add(configurator, "bm90000;tea064");
cds.configurator.DefaultRule.add(configurator, "bm90000;tea068");
cds.configurator.DefaultRule.add(configurator, "bm90000;tea070");
cds.configurator.DefaultRule.add(configurator, "bm90000;tea072");
cds.configurator.DefaultRule.add(configurator, "bm90000;tea074");
cds.configurator.DefaultRule.add(configurator, "bm90000;tea084");
cds.configurator.DefaultRule.add(configurator, "bm90000;tea096");
cds.configurator.DefaultRule.add(configurator, "bm90000;tea100");
cds.configurator.DefaultRule.add(configurator, "bm90000;tea120");
cds.configurator.DefaultRule.add(configurator, "bm90000;tea126");
cds.configurator.DefaultRule.add(configurator, "bm90000;tea144");
cds.configurator.DefaultRule.add(configurator, "bm90000;tea154");
cds.configurator.DefaultRule.add(configurator, "bm90000;tea192");
cds.configurator.DefaultRule.add(configurator, "bm90000;tea216");
cds.configurator.DefaultRule.add(configurator, "bm90000;teb010");
cds.configurator.DefaultRule.add(configurator, "bm90000;teb011");
cds.configurator.DefaultRule.add(configurator, "bm90000;teb012");
cds.configurator.DefaultRule.add(configurator, "bm90000;teb013");
cds.configurator.DefaultRule.add(configurator, "bm90000;teb014");
cds.configurator.DefaultRule.add(configurator, "bm90000;teb015");
cds.configurator.DefaultRule.add(configurator, "bm90000;teb016");
cds.configurator.DefaultRule.add(configurator, "bm90000;teb017");
cds.configurator.DefaultRule.add(configurator, "bm90000;teb018");
cds.configurator.DefaultRule.add(configurator, "bm90000;teb019");
cds.configurator.DefaultRule.add(configurator, "bm90000;teb020");
cds.configurator.DefaultRule.add(configurator, "bm90000;teb021");
cds.configurator.DefaultRule.add(configurator, "bm90000;teb022");
cds.configurator.DefaultRule.add(configurator, "bm90000;teb023");
cds.configurator.DefaultRule.add(configurator, "bm90000;teb024");
cds.configurator.DefaultRule.add(configurator, "bm90000;teb025");
cds.configurator.DefaultRule.add(configurator, "bm90000;teb026");
cds.configurator.DefaultRule.add(configurator, "bm90000;teb027");
cds.configurator.DefaultRule.add(configurator, "bm90000;teb041");
cds.configurator.DefaultRule.add(configurator, "bm90000;teb042");
cds.configurator.DefaultRule.add(configurator, "bm90000;teb044");
cds.configurator.DefaultRule.add(configurator, "bm90000;teb046");
cds.configurator.DefaultRule.add(configurator, "bm90000;teb052");
cds.configurator.DefaultRule.add(configurator, "bm90000;teb062");
cds.configurator.DefaultRule.add(configurator, "bm90000;teb064");
cds.configurator.DefaultRule.add(configurator, "bm90000;teb068");
cds.configurator.DefaultRule.add(configurator, "bm90000;teb070");
cds.configurator.DefaultRule.add(configurator, "bm90000;teb072");
cds.configurator.DefaultRule.add(configurator, "bm90000;teb074");
cds.configurator.DefaultRule.add(configurator, "bm90000;teb084");
cds.configurator.DefaultRule.add(configurator, "bm90000;teb096");
cds.configurator.DefaultRule.add(configurator, "bm90000;teb100");
cds.configurator.DefaultRule.add(configurator, "bm90000;teb120");
cds.configurator.DefaultRule.add(configurator, "bm90000;teb126");
cds.configurator.DefaultRule.add(configurator, "bm90000;teb144");
cds.configurator.DefaultRule.add(configurator, "bm90000;teb154");
cds.configurator.DefaultRule.add(configurator, "bm90000;teb192");
cds.configurator.DefaultRule.add(configurator, "bm90000;teb216");
cds.configurator.DefaultRule.add(configurator, "sehhh;tea010");
cds.configurator.DefaultRule.add(configurator, "sehhh;tea011");
cds.configurator.DefaultRule.add(configurator, "sehhh;tea012");
cds.configurator.DefaultRule.add(configurator, "sehhh;tea013");
cds.configurator.DefaultRule.add(configurator, "sehhh;tea015");
cds.configurator.DefaultRule.add(configurator, "sehhh;tea023");
cds.configurator.DefaultRule.add(configurator, "sehhh;tea025");
cds.configurator.DefaultRule.add(configurator, "sehhh;tea027");
cds.configurator.DefaultRule.add(configurator, "sehhh;tea029");
cds.configurator.DefaultRule.add(configurator, "sehhh;tea031");
cds.configurator.DefaultRule.add(configurator, "sehhh;tea033");
cds.configurator.DefaultRule.add(configurator, "sehhh;tea034");
cds.configurator.DefaultRule.add(configurator, "sehhh;tea035");
cds.configurator.DefaultRule.add(configurator, "sehhh;tea037");
cds.configurator.DefaultRule.add(configurator, "sehhh;tea038");
cds.configurator.DefaultRule.add(configurator, "sehhh;tea039");
cds.configurator.DefaultRule.add(configurator, "sehhh;tea041");
cds.configurator.DefaultRule.add(configurator, "sehhh;tea042");
cds.configurator.DefaultRule.add(configurator, "sehhh;tea043");
cds.configurator.DefaultRule.add(configurator, "sehhh;tea045");
cds.configurator.DefaultRule.add(configurator, "sehhh;tea046");
cds.configurator.DefaultRule.add(configurator, "sehhh;tea050");
cds.configurator.DefaultRule.add(configurator, "sehhh;tea052");
cds.configurator.DefaultRule.add(configurator, "sehhh;tea053");
cds.configurator.DefaultRule.add(configurator, "sehhh;tea056");
cds.configurator.DefaultRule.add(configurator, "sehhh;tea062");
cds.configurator.DefaultRule.add(configurator, "sehhh;tea063");
cds.configurator.DefaultRule.add(configurator, "sehhh;tea064");
cds.configurator.DefaultRule.add(configurator, "sehhh;tea067");
cds.configurator.DefaultRule.add(configurator, "sehhh;tea068");
cds.configurator.DefaultRule.add(configurator, "sehhh;tea070");
cds.configurator.DefaultRule.add(configurator, "sehhh;tea071");
cds.configurator.DefaultRule.add(configurator, "sehhh;tea074");
cds.configurator.DefaultRule.add(configurator, "sehhh;tea075");
cds.configurator.DefaultRule.add(configurator, "sehhh;tea080");
cds.configurator.DefaultRule.add(configurator, "sehhh;tea090");
cds.configurator.DefaultRule.add(configurator, "sehhh;tea100");
cds.configurator.DefaultRule.add(configurator, "sehhh;tea112");
cds.configurator.DefaultRule.add(configurator, "sehhh;tea126");
cds.configurator.DefaultRule.add(configurator, "sehhh;tea140");
cds.configurator.DefaultRule.add(configurator, "sehhh;tea144");
cds.configurator.DefaultRule.add(configurator, "sehhh;tea154");
cds.configurator.DefaultRule.add(configurator, "sehhh;tea168");
cds.configurator.DefaultRule.add(configurator, "sehhh;tea180");
cds.configurator.DefaultRule.add(configurator, "sehhh;tea192");
cds.configurator.DefaultRule.add(configurator, "sehhh;tea200");
cds.configurator.DefaultRule.add(configurator, "sehhh;tea216");
cds.configurator.DefaultRule.add(configurator, "sehhh;tea224");
cds.configurator.DefaultRule.add(configurator, "sehhh;teb010");
cds.configurator.DefaultRule.add(configurator, "sehhh;teb011");
cds.configurator.DefaultRule.add(configurator, "sehhh;teb012");
cds.configurator.DefaultRule.add(configurator, "sehhh;teb013");
cds.configurator.DefaultRule.add(configurator, "sehhh;teb015");
cds.configurator.DefaultRule.add(configurator, "sehhh;teb023");
cds.configurator.DefaultRule.add(configurator, "sehhh;teb025");
cds.configurator.DefaultRule.add(configurator, "sehhh;teb027");
cds.configurator.DefaultRule.add(configurator, "sehhh;teb029");
cds.configurator.DefaultRule.add(configurator, "sehhh;teb031");
cds.configurator.DefaultRule.add(configurator, "sehhh;teb033");
cds.configurator.DefaultRule.add(configurator, "sehhh;teb034");
cds.configurator.DefaultRule.add(configurator, "sehhh;teb035");
cds.configurator.DefaultRule.add(configurator, "sehhh;teb037");
cds.configurator.DefaultRule.add(configurator, "sehhh;teb038");
cds.configurator.DefaultRule.add(configurator, "sehhh;teb039");
cds.configurator.DefaultRule.add(configurator, "sehhh;teb041");
cds.configurator.DefaultRule.add(configurator, "sehhh;teb042");
cds.configurator.DefaultRule.add(configurator, "sehhh;teb043");
cds.configurator.DefaultRule.add(configurator, "sehhh;teb045");
cds.configurator.DefaultRule.add(configurator, "sehhh;teb046");
cds.configurator.DefaultRule.add(configurator, "sehhh;teb050");
cds.configurator.DefaultRule.add(configurator, "sehhh;teb052");
cds.configurator.DefaultRule.add(configurator, "sehhh;teb053");
cds.configurator.DefaultRule.add(configurator, "sehhh;teb056");
cds.configurator.DefaultRule.add(configurator, "sehhh;teb062");
cds.configurator.DefaultRule.add(configurator, "sehhh;teb063");
cds.configurator.DefaultRule.add(configurator, "sehhh;teb064");
cds.configurator.DefaultRule.add(configurator, "sehhh;teb067");
cds.configurator.DefaultRule.add(configurator, "sehhh;teb068");
cds.configurator.DefaultRule.add(configurator, "sehhh;teb070");
cds.configurator.DefaultRule.add(configurator, "sehhh;teb071");
cds.configurator.DefaultRule.add(configurator, "sehhh;teb074");
cds.configurator.DefaultRule.add(configurator, "sehhh;teb075");
cds.configurator.DefaultRule.add(configurator, "sehhh;teb080");
cds.configurator.DefaultRule.add(configurator, "sehhh;teb090");
cds.configurator.DefaultRule.add(configurator, "sehhh;teb100");
cds.configurator.DefaultRule.add(configurator, "sehhh;teb112");
cds.configurator.DefaultRule.add(configurator, "sehhh;teb126");
cds.configurator.DefaultRule.add(configurator, "sehhh;teb140");
cds.configurator.DefaultRule.add(configurator, "sehhh;teb144");
cds.configurator.DefaultRule.add(configurator, "sehhh;teb154");
cds.configurator.DefaultRule.add(configurator, "sehhh;teb168");
cds.configurator.DefaultRule.add(configurator, "sehhh;teb180");
cds.configurator.DefaultRule.add(configurator, "sehhh;teb192");
cds.configurator.DefaultRule.add(configurator, "sehhh;teb200");
cds.configurator.DefaultRule.add(configurator, "sehhh;teb216");
cds.configurator.DefaultRule.add(configurator, "sehhh;teb224");
cds.configurator.DefaultRule.add(configurator, "selll;tea011");
cds.configurator.DefaultRule.add(configurator, "selll;tea023");
cds.configurator.DefaultRule.add(configurator, "selll;tea025");
cds.configurator.DefaultRule.add(configurator, "selll;tea027");
cds.configurator.DefaultRule.add(configurator, "selll;tea029");
cds.configurator.DefaultRule.add(configurator, "selll;tea031");
cds.configurator.DefaultRule.add(configurator, "selll;tea033");
cds.configurator.DefaultRule.add(configurator, "selll;tea034");
cds.configurator.DefaultRule.add(configurator, "selll;tea035");
cds.configurator.DefaultRule.add(configurator, "selll;tea037");
cds.configurator.DefaultRule.add(configurator, "selll;tea038");
cds.configurator.DefaultRule.add(configurator, "selll;tea039");
cds.configurator.DefaultRule.add(configurator, "selll;tea041");
cds.configurator.DefaultRule.add(configurator, "selll;tea042");
cds.configurator.DefaultRule.add(configurator, "selll;tea043");
cds.configurator.DefaultRule.add(configurator, "selll;tea045");
cds.configurator.DefaultRule.add(configurator, "selll;tea046");
cds.configurator.DefaultRule.add(configurator, "selll;tea050");
cds.configurator.DefaultRule.add(configurator, "selll;tea052");
cds.configurator.DefaultRule.add(configurator, "selll;tea053");
cds.configurator.DefaultRule.add(configurator, "selll;tea056");
cds.configurator.DefaultRule.add(configurator, "selll;tea062");
cds.configurator.DefaultRule.add(configurator, "selll;tea063");
cds.configurator.DefaultRule.add(configurator, "selll;tea064");
cds.configurator.DefaultRule.add(configurator, "selll;tea067");
cds.configurator.DefaultRule.add(configurator, "selll;tea068");
cds.configurator.DefaultRule.add(configurator, "selll;tea070");
cds.configurator.DefaultRule.add(configurator, "selll;tea071");
cds.configurator.DefaultRule.add(configurator, "selll;tea074");
cds.configurator.DefaultRule.add(configurator, "selll;tea075");
cds.configurator.DefaultRule.add(configurator, "selll;tea080");
cds.configurator.DefaultRule.add(configurator, "selll;tea090");
cds.configurator.DefaultRule.add(configurator, "selll;tea100");
cds.configurator.DefaultRule.add(configurator, "selll;tea112");
cds.configurator.DefaultRule.add(configurator, "selll;tea126");
cds.configurator.DefaultRule.add(configurator, "selll;tea140");
cds.configurator.DefaultRule.add(configurator, "selll;tea144");
cds.configurator.DefaultRule.add(configurator, "selll;tea154");
cds.configurator.DefaultRule.add(configurator, "selll;tea168");
cds.configurator.DefaultRule.add(configurator, "selll;tea180");
cds.configurator.DefaultRule.add(configurator, "selll;tea192");
cds.configurator.DefaultRule.add(configurator, "selll;tea200");
cds.configurator.DefaultRule.add(configurator, "selll;tea216");
cds.configurator.DefaultRule.add(configurator, "selll;tea224");
cds.configurator.DefaultRule.add(configurator, "selll;teb011");
cds.configurator.DefaultRule.add(configurator, "selll;teb023");
cds.configurator.DefaultRule.add(configurator, "selll;teb025");
cds.configurator.DefaultRule.add(configurator, "selll;teb027");
cds.configurator.DefaultRule.add(configurator, "selll;teb029");
cds.configurator.DefaultRule.add(configurator, "selll;teb031");
cds.configurator.DefaultRule.add(configurator, "selll;teb033");
cds.configurator.DefaultRule.add(configurator, "selll;teb034");
cds.configurator.DefaultRule.add(configurator, "selll;teb035");
cds.configurator.DefaultRule.add(configurator, "selll;teb037");
cds.configurator.DefaultRule.add(configurator, "selll;teb038");
cds.configurator.DefaultRule.add(configurator, "selll;teb039");
cds.configurator.DefaultRule.add(configurator, "selll;teb041");
cds.configurator.DefaultRule.add(configurator, "selll;teb042");
cds.configurator.DefaultRule.add(configurator, "selll;teb043");
cds.configurator.DefaultRule.add(configurator, "selll;teb045");
cds.configurator.DefaultRule.add(configurator, "selll;teb046");
cds.configurator.DefaultRule.add(configurator, "selll;teb050");
cds.configurator.DefaultRule.add(configurator, "selll;teb052");
cds.configurator.DefaultRule.add(configurator, "selll;teb053");
cds.configurator.DefaultRule.add(configurator, "selll;teb056");
cds.configurator.DefaultRule.add(configurator, "selll;teb062");
cds.configurator.DefaultRule.add(configurator, "selll;teb063");
cds.configurator.DefaultRule.add(configurator, "selll;teb064");
cds.configurator.DefaultRule.add(configurator, "selll;teb067");
cds.configurator.DefaultRule.add(configurator, "selll;teb068");
cds.configurator.DefaultRule.add(configurator, "selll;teb070");
cds.configurator.DefaultRule.add(configurator, "selll;teb071");
cds.configurator.DefaultRule.add(configurator, "selll;teb074");
cds.configurator.DefaultRule.add(configurator, "selll;teb075");
cds.configurator.DefaultRule.add(configurator, "selll;teb080");
cds.configurator.DefaultRule.add(configurator, "selll;teb090");
cds.configurator.DefaultRule.add(configurator, "selll;teb100");
cds.configurator.DefaultRule.add(configurator, "selll;teb112");
cds.configurator.DefaultRule.add(configurator, "selll;teb126");
cds.configurator.DefaultRule.add(configurator, "selll;teb140");
cds.configurator.DefaultRule.add(configurator, "selll;teb144");
cds.configurator.DefaultRule.add(configurator, "selll;teb154");
cds.configurator.DefaultRule.add(configurator, "selll;teb168");
cds.configurator.DefaultRule.add(configurator, "selll;teb180");
cds.configurator.DefaultRule.add(configurator, "selll;teb192");
cds.configurator.DefaultRule.add(configurator, "selll;teb200");
cds.configurator.DefaultRule.add(configurator, "selll;teb216");
cds.configurator.DefaultRule.add(configurator, "selll;teb224");
cds.configurator.DefaultRule.add(configurator, "semxl;tea013");
cds.configurator.DefaultRule.add(configurator, "semxl;tea017");
cds.configurator.DefaultRule.add(configurator, "semxl;tea019");
cds.configurator.DefaultRule.add(configurator, "semxl;tea023");
cds.configurator.DefaultRule.add(configurator, "semxl;tea026");
cds.configurator.DefaultRule.add(configurator, "semxl;tea027");
cds.configurator.DefaultRule.add(configurator, "semxl;tea029");
cds.configurator.DefaultRule.add(configurator, "semxl;tea031");
cds.configurator.DefaultRule.add(configurator, "semxl;tea033");
cds.configurator.DefaultRule.add(configurator, "semxl;tea034");
cds.configurator.DefaultRule.add(configurator, "semxl;tea035");
cds.configurator.DefaultRule.add(configurator, "semxl;tea037");
cds.configurator.DefaultRule.add(configurator, "semxl;tea038");
cds.configurator.DefaultRule.add(configurator, "semxl;tea039");
cds.configurator.DefaultRule.add(configurator, "semxl;tea041");
cds.configurator.DefaultRule.add(configurator, "semxl;tea043");
cds.configurator.DefaultRule.add(configurator, "semxl;tea045");
cds.configurator.DefaultRule.add(configurator, "semxl;tea046");
cds.configurator.DefaultRule.add(configurator, "semxl;tea052");
cds.configurator.DefaultRule.add(configurator, "semxl;tea053");
cds.configurator.DefaultRule.add(configurator, "semxl;tea056");
cds.configurator.DefaultRule.add(configurator, "semxl;tea062");
cds.configurator.DefaultRule.add(configurator, "semxl;tea063");
cds.configurator.DefaultRule.add(configurator, "semxl;tea064");
cds.configurator.DefaultRule.add(configurator, "semxl;tea067");
cds.configurator.DefaultRule.add(configurator, "semxl;tea068");
cds.configurator.DefaultRule.add(configurator, "semxl;tea070");
cds.configurator.DefaultRule.add(configurator, "semxl;tea071");
cds.configurator.DefaultRule.add(configurator, "semxl;tea074");
cds.configurator.DefaultRule.add(configurator, "semxl;tea075");
cds.configurator.DefaultRule.add(configurator, "semxl;tea084");
cds.configurator.DefaultRule.add(configurator, "semxl;tea096");
cds.configurator.DefaultRule.add(configurator, "semxl;tea112");
cds.configurator.DefaultRule.add(configurator, "semxl;tea126");
cds.configurator.DefaultRule.add(configurator, "semxl;tea140");
cds.configurator.DefaultRule.add(configurator, "semxl;tea144");
cds.configurator.DefaultRule.add(configurator, "semxl;tea154");
cds.configurator.DefaultRule.add(configurator, "semxl;tea168");
cds.configurator.DefaultRule.add(configurator, "semxl;tea180");
cds.configurator.DefaultRule.add(configurator, "semxl;tea192");
cds.configurator.DefaultRule.add(configurator, "semxl;tea200");
cds.configurator.DefaultRule.add(configurator, "semxl;tea216");
cds.configurator.DefaultRule.add(configurator, "semxl;tea224");
cds.configurator.DefaultRule.add(configurator, "semxl;teb013");
cds.configurator.DefaultRule.add(configurator, "semxl;teb017");
cds.configurator.DefaultRule.add(configurator, "semxl;teb019");
cds.configurator.DefaultRule.add(configurator, "semxl;teb023");
cds.configurator.DefaultRule.add(configurator, "semxl;teb026");
cds.configurator.DefaultRule.add(configurator, "semxl;teb027");
cds.configurator.DefaultRule.add(configurator, "semxl;teb029");
cds.configurator.DefaultRule.add(configurator, "semxl;teb031");
cds.configurator.DefaultRule.add(configurator, "semxl;teb033");
cds.configurator.DefaultRule.add(configurator, "semxl;teb034");
cds.configurator.DefaultRule.add(configurator, "semxl;teb035");
cds.configurator.DefaultRule.add(configurator, "semxl;teb037");
cds.configurator.DefaultRule.add(configurator, "semxl;teb038");
cds.configurator.DefaultRule.add(configurator, "semxl;teb039");
cds.configurator.DefaultRule.add(configurator, "semxl;teb041");
cds.configurator.DefaultRule.add(configurator, "semxl;teb043");
cds.configurator.DefaultRule.add(configurator, "semxl;teb045");
cds.configurator.DefaultRule.add(configurator, "semxl;teb046");
cds.configurator.DefaultRule.add(configurator, "semxl;teb052");
cds.configurator.DefaultRule.add(configurator, "semxl;teb053");
cds.configurator.DefaultRule.add(configurator, "semxl;teb056");
cds.configurator.DefaultRule.add(configurator, "semxl;teb062");
cds.configurator.DefaultRule.add(configurator, "semxl;teb063");
cds.configurator.DefaultRule.add(configurator, "semxl;teb064");
cds.configurator.DefaultRule.add(configurator, "semxl;teb067");
cds.configurator.DefaultRule.add(configurator, "semxl;teb068");
cds.configurator.DefaultRule.add(configurator, "semxl;teb070");
cds.configurator.DefaultRule.add(configurator, "semxl;teb071");
cds.configurator.DefaultRule.add(configurator, "semxl;teb074");
cds.configurator.DefaultRule.add(configurator, "semxl;teb075");
cds.configurator.DefaultRule.add(configurator, "semxl;teb084");
cds.configurator.DefaultRule.add(configurator, "semxl;teb096");
cds.configurator.DefaultRule.add(configurator, "semxl;teb112");
cds.configurator.DefaultRule.add(configurator, "semxl;teb126");
cds.configurator.DefaultRule.add(configurator, "semxl;teb140");
cds.configurator.DefaultRule.add(configurator, "semxl;teb144");
cds.configurator.DefaultRule.add(configurator, "semxl;teb154");
cds.configurator.DefaultRule.add(configurator, "semxl;teb168");
cds.configurator.DefaultRule.add(configurator, "semxl;teb180");
cds.configurator.DefaultRule.add(configurator, "semxl;teb192");
cds.configurator.DefaultRule.add(configurator, "semxl;teb200");
cds.configurator.DefaultRule.add(configurator, "semxl;teb216");
cds.configurator.DefaultRule.add(configurator, "semxl;teb224");
cds.configurator.DefaultRule.add(configurator, "sexll;tea027");
cds.configurator.DefaultRule.add(configurator, "sexll;tea029");
cds.configurator.DefaultRule.add(configurator, "sexll;tea031");
cds.configurator.DefaultRule.add(configurator, "sexll;tea033");
cds.configurator.DefaultRule.add(configurator, "sexll;tea034");
cds.configurator.DefaultRule.add(configurator, "sexll;tea035");
cds.configurator.DefaultRule.add(configurator, "sexll;tea037");
cds.configurator.DefaultRule.add(configurator, "sexll;tea038");
cds.configurator.DefaultRule.add(configurator, "sexll;tea039");
cds.configurator.DefaultRule.add(configurator, "sexll;tea041");
cds.configurator.DefaultRule.add(configurator, "sexll;tea043");
cds.configurator.DefaultRule.add(configurator, "sexll;tea045");
cds.configurator.DefaultRule.add(configurator, "sexll;tea046");
cds.configurator.DefaultRule.add(configurator, "sexll;tea052");
cds.configurator.DefaultRule.add(configurator, "sexll;tea053");
cds.configurator.DefaultRule.add(configurator, "sexll;tea056");
cds.configurator.DefaultRule.add(configurator, "sexll;tea062");
cds.configurator.DefaultRule.add(configurator, "sexll;tea063");
cds.configurator.DefaultRule.add(configurator, "sexll;tea064");
cds.configurator.DefaultRule.add(configurator, "sexll;tea067");
cds.configurator.DefaultRule.add(configurator, "sexll;tea068");
cds.configurator.DefaultRule.add(configurator, "sexll;tea070");
cds.configurator.DefaultRule.add(configurator, "sexll;tea071");
cds.configurator.DefaultRule.add(configurator, "sexll;tea074");
cds.configurator.DefaultRule.add(configurator, "sexll;tea075");
cds.configurator.DefaultRule.add(configurator, "sexll;tea080");
cds.configurator.DefaultRule.add(configurator, "sexll;tea084");
cds.configurator.DefaultRule.add(configurator, "sexll;tea090");
cds.configurator.DefaultRule.add(configurator, "sexll;tea096");
cds.configurator.DefaultRule.add(configurator, "sexll;tea100");
cds.configurator.DefaultRule.add(configurator, "sexll;tea112");
cds.configurator.DefaultRule.add(configurator, "sexll;tea120");
cds.configurator.DefaultRule.add(configurator, "sexll;tea126");
cds.configurator.DefaultRule.add(configurator, "sexll;tea140");
cds.configurator.DefaultRule.add(configurator, "sexll;tea144");
cds.configurator.DefaultRule.add(configurator, "sexll;tea154");
cds.configurator.DefaultRule.add(configurator, "sexll;tea168");
cds.configurator.DefaultRule.add(configurator, "sexll;tea180");
cds.configurator.DefaultRule.add(configurator, "sexll;tea192");
cds.configurator.DefaultRule.add(configurator, "sexll;tea200");
cds.configurator.DefaultRule.add(configurator, "sexll;tea216");
cds.configurator.DefaultRule.add(configurator, "sexll;tea224");
cds.configurator.DefaultRule.add(configurator, "sexll;teb027");
cds.configurator.DefaultRule.add(configurator, "sexll;teb029");
cds.configurator.DefaultRule.add(configurator, "sexll;teb031");
cds.configurator.DefaultRule.add(configurator, "sexll;teb033");
cds.configurator.DefaultRule.add(configurator, "sexll;teb034");
cds.configurator.DefaultRule.add(configurator, "sexll;teb035");
cds.configurator.DefaultRule.add(configurator, "sexll;teb037");
cds.configurator.DefaultRule.add(configurator, "sexll;teb038");
cds.configurator.DefaultRule.add(configurator, "sexll;teb039");
cds.configurator.DefaultRule.add(configurator, "sexll;teb041");
cds.configurator.DefaultRule.add(configurator, "sexll;teb043");
cds.configurator.DefaultRule.add(configurator, "sexll;teb045");
cds.configurator.DefaultRule.add(configurator, "sexll;teb046");
cds.configurator.DefaultRule.add(configurator, "sexll;teb052");
cds.configurator.DefaultRule.add(configurator, "sexll;teb053");
cds.configurator.DefaultRule.add(configurator, "sexll;teb056");
cds.configurator.DefaultRule.add(configurator, "sexll;teb062");
cds.configurator.DefaultRule.add(configurator, "sexll;teb063");
cds.configurator.DefaultRule.add(configurator, "sexll;teb064");
cds.configurator.DefaultRule.add(configurator, "sexll;teb067");
cds.configurator.DefaultRule.add(configurator, "sexll;teb068");
cds.configurator.DefaultRule.add(configurator, "sexll;teb070");
cds.configurator.DefaultRule.add(configurator, "sexll;teb071");
cds.configurator.DefaultRule.add(configurator, "sexll;teb074");
cds.configurator.DefaultRule.add(configurator, "sexll;teb075");
cds.configurator.DefaultRule.add(configurator, "sexll;teb080");
cds.configurator.DefaultRule.add(configurator, "sexll;teb084");
cds.configurator.DefaultRule.add(configurator, "sexll;teb090");
cds.configurator.DefaultRule.add(configurator, "sexll;teb096");
cds.configurator.DefaultRule.add(configurator, "sexll;teb100");
cds.configurator.DefaultRule.add(configurator, "sexll;teb112");
cds.configurator.DefaultRule.add(configurator, "sexll;teb120");
cds.configurator.DefaultRule.add(configurator, "sexll;teb126");
cds.configurator.DefaultRule.add(configurator, "sexll;teb140");
cds.configurator.DefaultRule.add(configurator, "sexll;teb144");
cds.configurator.DefaultRule.add(configurator, "sexll;teb154");
cds.configurator.DefaultRule.add(configurator, "sexll;teb168");
cds.configurator.DefaultRule.add(configurator, "sexll;teb180");
cds.configurator.DefaultRule.add(configurator, "sexll;teb192");
cds.configurator.DefaultRule.add(configurator, "sexll;teb200");
cds.configurator.DefaultRule.add(configurator, "sexll;teb216");
cds.configurator.DefaultRule.add(configurator, "sexll;teb224");
cds.configurator.DefaultRule.add(configurator, "sma05;tea010");
cds.configurator.DefaultRule.add(configurator, "sma05;tea011");
cds.configurator.DefaultRule.add(configurator, "sma05;tea013");
cds.configurator.DefaultRule.add(configurator, "sma05;tea017");
cds.configurator.DefaultRule.add(configurator, "sma05;tea019");
cds.configurator.DefaultRule.add(configurator, "sma05;tea021");
cds.configurator.DefaultRule.add(configurator, "sma05;tea023");
cds.configurator.DefaultRule.add(configurator, "sma05;tea028");
cds.configurator.DefaultRule.add(configurator, "sma05;tea029");
cds.configurator.DefaultRule.add(configurator, "sma05;tea031");
cds.configurator.DefaultRule.add(configurator, "sma05;tea033");
cds.configurator.DefaultRule.add(configurator, "sma05;tea034");
cds.configurator.DefaultRule.add(configurator, "sma05;tea035");
cds.configurator.DefaultRule.add(configurator, "sma05;tea037");
cds.configurator.DefaultRule.add(configurator, "sma05;tea038");
cds.configurator.DefaultRule.add(configurator, "sma05;tea039");
cds.configurator.DefaultRule.add(configurator, "sma05;tea041");
cds.configurator.DefaultRule.add(configurator, "sma05;tea042");
cds.configurator.DefaultRule.add(configurator, "sma05;tea043");
cds.configurator.DefaultRule.add(configurator, "sma05;tea045");
cds.configurator.DefaultRule.add(configurator, "sma05;tea046");
cds.configurator.DefaultRule.add(configurator, "sma05;tea050");
cds.configurator.DefaultRule.add(configurator, "sma05;tea052");
cds.configurator.DefaultRule.add(configurator, "sma05;tea053");
cds.configurator.DefaultRule.add(configurator, "sma05;tea056");
cds.configurator.DefaultRule.add(configurator, "sma05;tea062");
cds.configurator.DefaultRule.add(configurator, "sma05;tea063");
cds.configurator.DefaultRule.add(configurator, "sma05;tea064");
cds.configurator.DefaultRule.add(configurator, "sma05;tea067");
cds.configurator.DefaultRule.add(configurator, "sma05;tea068");
cds.configurator.DefaultRule.add(configurator, "sma05;tea070");
cds.configurator.DefaultRule.add(configurator, "sma05;tea071");
cds.configurator.DefaultRule.add(configurator, "sma05;tea074");
cds.configurator.DefaultRule.add(configurator, "sma05;tea075");
cds.configurator.DefaultRule.add(configurator, "sma05;tea080");
cds.configurator.DefaultRule.add(configurator, "sma05;tea084");
cds.configurator.DefaultRule.add(configurator, "sma05;tea090");
cds.configurator.DefaultRule.add(configurator, "sma05;tea096");
cds.configurator.DefaultRule.add(configurator, "sma05;tea100");
cds.configurator.DefaultRule.add(configurator, "sma05;tea112");
cds.configurator.DefaultRule.add(configurator, "sma05;tea120");
cds.configurator.DefaultRule.add(configurator, "sma05;tea126");
cds.configurator.DefaultRule.add(configurator, "sma05;tea140");
cds.configurator.DefaultRule.add(configurator, "sma05;tea144");
cds.configurator.DefaultRule.add(configurator, "sma05;tea154");
cds.configurator.DefaultRule.add(configurator, "sma05;tea168");
cds.configurator.DefaultRule.add(configurator, "sma05;tea180");
cds.configurator.DefaultRule.add(configurator, "sma05;tea192");
cds.configurator.DefaultRule.add(configurator, "sma05;tea200");
cds.configurator.DefaultRule.add(configurator, "sma05;tea216");
cds.configurator.DefaultRule.add(configurator, "sma05;tea224");
cds.configurator.DefaultRule.add(configurator, "sma05;teb010");
cds.configurator.DefaultRule.add(configurator, "sma05;teb011");
cds.configurator.DefaultRule.add(configurator, "sma05;teb013");
cds.configurator.DefaultRule.add(configurator, "sma05;teb017");
cds.configurator.DefaultRule.add(configurator, "sma05;teb019");
cds.configurator.DefaultRule.add(configurator, "sma05;teb021");
cds.configurator.DefaultRule.add(configurator, "sma05;teb023");
cds.configurator.DefaultRule.add(configurator, "sma05;teb028");
cds.configurator.DefaultRule.add(configurator, "sma05;teb029");
cds.configurator.DefaultRule.add(configurator, "sma05;teb031");
cds.configurator.DefaultRule.add(configurator, "sma05;teb033");
cds.configurator.DefaultRule.add(configurator, "sma05;teb034");
cds.configurator.DefaultRule.add(configurator, "sma05;teb035");
cds.configurator.DefaultRule.add(configurator, "sma05;teb037");
cds.configurator.DefaultRule.add(configurator, "sma05;teb038");
cds.configurator.DefaultRule.add(configurator, "sma05;teb039");
cds.configurator.DefaultRule.add(configurator, "sma05;teb041");
cds.configurator.DefaultRule.add(configurator, "sma05;teb042");
cds.configurator.DefaultRule.add(configurator, "sma05;teb043");
cds.configurator.DefaultRule.add(configurator, "sma05;teb045");
cds.configurator.DefaultRule.add(configurator, "sma05;teb046");
cds.configurator.DefaultRule.add(configurator, "sma05;teb050");
cds.configurator.DefaultRule.add(configurator, "sma05;teb052");
cds.configurator.DefaultRule.add(configurator, "sma05;teb053");
cds.configurator.DefaultRule.add(configurator, "sma05;teb056");
cds.configurator.DefaultRule.add(configurator, "sma05;teb062");
cds.configurator.DefaultRule.add(configurator, "sma05;teb063");
cds.configurator.DefaultRule.add(configurator, "sma05;teb064");
cds.configurator.DefaultRule.add(configurator, "sma05;teb067");
cds.configurator.DefaultRule.add(configurator, "sma05;teb068");
cds.configurator.DefaultRule.add(configurator, "sma05;teb070");
cds.configurator.DefaultRule.add(configurator, "sma05;teb071");
cds.configurator.DefaultRule.add(configurator, "sma05;teb074");
cds.configurator.DefaultRule.add(configurator, "sma05;teb075");
cds.configurator.DefaultRule.add(configurator, "sma05;teb080");
cds.configurator.DefaultRule.add(configurator, "sma05;teb084");
cds.configurator.DefaultRule.add(configurator, "sma05;teb090");
cds.configurator.DefaultRule.add(configurator, "sma05;teb096");
cds.configurator.DefaultRule.add(configurator, "sma05;teb100");
cds.configurator.DefaultRule.add(configurator, "sma05;teb112");
cds.configurator.DefaultRule.add(configurator, "sma05;teb120");
cds.configurator.DefaultRule.add(configurator, "sma05;teb126");
cds.configurator.DefaultRule.add(configurator, "sma05;teb140");
cds.configurator.DefaultRule.add(configurator, "sma05;teb144");
cds.configurator.DefaultRule.add(configurator, "sma05;teb154");
cds.configurator.DefaultRule.add(configurator, "sma05;teb168");
cds.configurator.DefaultRule.add(configurator, "sma05;teb180");
cds.configurator.DefaultRule.add(configurator, "sma05;teb192");
cds.configurator.DefaultRule.add(configurator, "sma05;teb200");
cds.configurator.DefaultRule.add(configurator, "sma05;teb216");
cds.configurator.DefaultRule.add(configurator, "sma05;teb224");
cds.configurator.DefaultRule.add(configurator, "sma10;tea010");
cds.configurator.DefaultRule.add(configurator, "sma10;tea011");
cds.configurator.DefaultRule.add(configurator, "sma10;tea012");
cds.configurator.DefaultRule.add(configurator, "sma10;tea013");
cds.configurator.DefaultRule.add(configurator, "sma10;tea014");
cds.configurator.DefaultRule.add(configurator, "sma10;tea015");
cds.configurator.DefaultRule.add(configurator, "sma10;tea016");
cds.configurator.DefaultRule.add(configurator, "sma10;tea017");
cds.configurator.DefaultRule.add(configurator, "sma10;tea019");
cds.configurator.DefaultRule.add(configurator, "sma10;tea021");
cds.configurator.DefaultRule.add(configurator, "sma10;tea023");
cds.configurator.DefaultRule.add(configurator, "sma10;tea026");
cds.configurator.DefaultRule.add(configurator, "sma10;tea028");
cds.configurator.DefaultRule.add(configurator, "sma10;tea029");
cds.configurator.DefaultRule.add(configurator, "sma10;tea031");
cds.configurator.DefaultRule.add(configurator, "sma10;tea033");
cds.configurator.DefaultRule.add(configurator, "sma10;tea034");
cds.configurator.DefaultRule.add(configurator, "sma10;tea035");
cds.configurator.DefaultRule.add(configurator, "sma10;tea037");
cds.configurator.DefaultRule.add(configurator, "sma10;tea038");
cds.configurator.DefaultRule.add(configurator, "sma10;tea039");
cds.configurator.DefaultRule.add(configurator, "sma10;tea041");
cds.configurator.DefaultRule.add(configurator, "sma10;tea042");
cds.configurator.DefaultRule.add(configurator, "sma10;tea043");
cds.configurator.DefaultRule.add(configurator, "sma10;tea045");
cds.configurator.DefaultRule.add(configurator, "sma10;tea046");
cds.configurator.DefaultRule.add(configurator, "sma10;tea050");
cds.configurator.DefaultRule.add(configurator, "sma10;tea052");
cds.configurator.DefaultRule.add(configurator, "sma10;tea053");
cds.configurator.DefaultRule.add(configurator, "sma10;tea056");
cds.configurator.DefaultRule.add(configurator, "sma10;tea062");
cds.configurator.DefaultRule.add(configurator, "sma10;tea063");
cds.configurator.DefaultRule.add(configurator, "sma10;tea064");
cds.configurator.DefaultRule.add(configurator, "sma10;tea067");
cds.configurator.DefaultRule.add(configurator, "sma10;tea068");
cds.configurator.DefaultRule.add(configurator, "sma10;tea070");
cds.configurator.DefaultRule.add(configurator, "sma10;tea071");
cds.configurator.DefaultRule.add(configurator, "sma10;tea072");
cds.configurator.DefaultRule.add(configurator, "sma10;tea074");
cds.configurator.DefaultRule.add(configurator, "sma10;tea075");
cds.configurator.DefaultRule.add(configurator, "sma10;tea080");
cds.configurator.DefaultRule.add(configurator, "sma10;tea084");
cds.configurator.DefaultRule.add(configurator, "sma10;tea090");
cds.configurator.DefaultRule.add(configurator, "sma10;tea096");
cds.configurator.DefaultRule.add(configurator, "sma10;tea100");
cds.configurator.DefaultRule.add(configurator, "sma10;tea112");
cds.configurator.DefaultRule.add(configurator, "sma10;tea120");
cds.configurator.DefaultRule.add(configurator, "sma10;tea126");
cds.configurator.DefaultRule.add(configurator, "sma10;tea140");
cds.configurator.DefaultRule.add(configurator, "sma10;tea144");
cds.configurator.DefaultRule.add(configurator, "sma10;tea154");
cds.configurator.DefaultRule.add(configurator, "sma10;tea168");
cds.configurator.DefaultRule.add(configurator, "sma10;tea180");
cds.configurator.DefaultRule.add(configurator, "sma10;tea192");
cds.configurator.DefaultRule.add(configurator, "sma10;tea200");
cds.configurator.DefaultRule.add(configurator, "sma10;tea216");
cds.configurator.DefaultRule.add(configurator, "sma10;tea224");
cds.configurator.DefaultRule.add(configurator, "sma10;teb010");
cds.configurator.DefaultRule.add(configurator, "sma10;teb011");
cds.configurator.DefaultRule.add(configurator, "sma10;teb012");
cds.configurator.DefaultRule.add(configurator, "sma10;teb013");
cds.configurator.DefaultRule.add(configurator, "sma10;teb014");
cds.configurator.DefaultRule.add(configurator, "sma10;teb015");
cds.configurator.DefaultRule.add(configurator, "sma10;teb016");
cds.configurator.DefaultRule.add(configurator, "sma10;teb017");
cds.configurator.DefaultRule.add(configurator, "sma10;teb019");
cds.configurator.DefaultRule.add(configurator, "sma10;teb021");
cds.configurator.DefaultRule.add(configurator, "sma10;teb023");
cds.configurator.DefaultRule.add(configurator, "sma10;teb026");
cds.configurator.DefaultRule.add(configurator, "sma10;teb028");
cds.configurator.DefaultRule.add(configurator, "sma10;teb029");
cds.configurator.DefaultRule.add(configurator, "sma10;teb031");
cds.configurator.DefaultRule.add(configurator, "sma10;teb033");
cds.configurator.DefaultRule.add(configurator, "sma10;teb034");
cds.configurator.DefaultRule.add(configurator, "sma10;teb035");
cds.configurator.DefaultRule.add(configurator, "sma10;teb037");
cds.configurator.DefaultRule.add(configurator, "sma10;teb038");
cds.configurator.DefaultRule.add(configurator, "sma10;teb039");
cds.configurator.DefaultRule.add(configurator, "sma10;teb041");
cds.configurator.DefaultRule.add(configurator, "sma10;teb042");
cds.configurator.DefaultRule.add(configurator, "sma10;teb043");
cds.configurator.DefaultRule.add(configurator, "sma10;teb045");
cds.configurator.DefaultRule.add(configurator, "sma10;teb046");
cds.configurator.DefaultRule.add(configurator, "sma10;teb050");
cds.configurator.DefaultRule.add(configurator, "sma10;teb052");
cds.configurator.DefaultRule.add(configurator, "sma10;teb053");
cds.configurator.DefaultRule.add(configurator, "sma10;teb056");
cds.configurator.DefaultRule.add(configurator, "sma10;teb062");
cds.configurator.DefaultRule.add(configurator, "sma10;teb063");
cds.configurator.DefaultRule.add(configurator, "sma10;teb064");
cds.configurator.DefaultRule.add(configurator, "sma10;teb067");
cds.configurator.DefaultRule.add(configurator, "sma10;teb068");
cds.configurator.DefaultRule.add(configurator, "sma10;teb070");
cds.configurator.DefaultRule.add(configurator, "sma10;teb071");
cds.configurator.DefaultRule.add(configurator, "sma10;teb072");
cds.configurator.DefaultRule.add(configurator, "sma10;teb074");
cds.configurator.DefaultRule.add(configurator, "sma10;teb075");
cds.configurator.DefaultRule.add(configurator, "sma10;teb080");
cds.configurator.DefaultRule.add(configurator, "sma10;teb084");
cds.configurator.DefaultRule.add(configurator, "sma10;teb090");
cds.configurator.DefaultRule.add(configurator, "sma10;teb096");
cds.configurator.DefaultRule.add(configurator, "sma10;teb100");
cds.configurator.DefaultRule.add(configurator, "sma10;teb112");
cds.configurator.DefaultRule.add(configurator, "sma10;teb120");
cds.configurator.DefaultRule.add(configurator, "sma10;teb126");
cds.configurator.DefaultRule.add(configurator, "sma10;teb140");
cds.configurator.DefaultRule.add(configurator, "sma10;teb144");
cds.configurator.DefaultRule.add(configurator, "sma10;teb154");
cds.configurator.DefaultRule.add(configurator, "sma10;teb168");
cds.configurator.DefaultRule.add(configurator, "sma10;teb180");
cds.configurator.DefaultRule.add(configurator, "sma10;teb192");
cds.configurator.DefaultRule.add(configurator, "sma10;teb200");
cds.configurator.DefaultRule.add(configurator, "sma10;teb216");
cds.configurator.DefaultRule.add(configurator, "sma10;teb224");
cds.configurator.DefaultRule.add(configurator, "smh03;tea021");
cds.configurator.DefaultRule.add(configurator, "smh03;tea023");
cds.configurator.DefaultRule.add(configurator, "smh03;tea027");
cds.configurator.DefaultRule.add(configurator, "smh03;tea029");
cds.configurator.DefaultRule.add(configurator, "smh03;tea031");
cds.configurator.DefaultRule.add(configurator, "smh03;tea033");
cds.configurator.DefaultRule.add(configurator, "smh03;tea035");
cds.configurator.DefaultRule.add(configurator, "smh03;tea037");
cds.configurator.DefaultRule.add(configurator, "smh03;tea039");
cds.configurator.DefaultRule.add(configurator, "smh03;tea041");
cds.configurator.DefaultRule.add(configurator, "smh03;tea042");
cds.configurator.DefaultRule.add(configurator, "smh03;tea043");
cds.configurator.DefaultRule.add(configurator, "smh03;tea045");
cds.configurator.DefaultRule.add(configurator, "smh03;tea046");
cds.configurator.DefaultRule.add(configurator, "smh03;tea052");
cds.configurator.DefaultRule.add(configurator, "smh03;tea053");
cds.configurator.DefaultRule.add(configurator, "smh03;tea063");
cds.configurator.DefaultRule.add(configurator, "smh03;tea064");
cds.configurator.DefaultRule.add(configurator, "smh03;tea067");
cds.configurator.DefaultRule.add(configurator, "smh03;tea068");
cds.configurator.DefaultRule.add(configurator, "smh03;tea070");
cds.configurator.DefaultRule.add(configurator, "smh03;tea071");
cds.configurator.DefaultRule.add(configurator, "smh03;tea074");
cds.configurator.DefaultRule.add(configurator, "smh03;tea075");
cds.configurator.DefaultRule.add(configurator, "smh03;tea080");
cds.configurator.DefaultRule.add(configurator, "smh03;tea084");
cds.configurator.DefaultRule.add(configurator, "smh03;tea090");
cds.configurator.DefaultRule.add(configurator, "smh03;tea096");
cds.configurator.DefaultRule.add(configurator, "smh03;tea100");
cds.configurator.DefaultRule.add(configurator, "smh03;tea112");
cds.configurator.DefaultRule.add(configurator, "smh03;tea120");
cds.configurator.DefaultRule.add(configurator, "smh03;tea126");
cds.configurator.DefaultRule.add(configurator, "smh03;tea140");
cds.configurator.DefaultRule.add(configurator, "smh03;tea144");
cds.configurator.DefaultRule.add(configurator, "smh03;tea154");
cds.configurator.DefaultRule.add(configurator, "smh03;tea168");
cds.configurator.DefaultRule.add(configurator, "smh03;tea180");
cds.configurator.DefaultRule.add(configurator, "smh03;tea192");
cds.configurator.DefaultRule.add(configurator, "smh03;tea200");
cds.configurator.DefaultRule.add(configurator, "smh03;tea216");
cds.configurator.DefaultRule.add(configurator, "smh03;tea224");
cds.configurator.DefaultRule.add(configurator, "smh03;teb021");
cds.configurator.DefaultRule.add(configurator, "smh03;teb023");
cds.configurator.DefaultRule.add(configurator, "smh03;teb027");
cds.configurator.DefaultRule.add(configurator, "smh03;teb029");
cds.configurator.DefaultRule.add(configurator, "smh03;teb031");
cds.configurator.DefaultRule.add(configurator, "smh03;teb033");
cds.configurator.DefaultRule.add(configurator, "smh03;teb035");
cds.configurator.DefaultRule.add(configurator, "smh03;teb037");
cds.configurator.DefaultRule.add(configurator, "smh03;teb039");
cds.configurator.DefaultRule.add(configurator, "smh03;teb041");
cds.configurator.DefaultRule.add(configurator, "smh03;teb042");
cds.configurator.DefaultRule.add(configurator, "smh03;teb043");
cds.configurator.DefaultRule.add(configurator, "smh03;teb045");
cds.configurator.DefaultRule.add(configurator, "smh03;teb046");
cds.configurator.DefaultRule.add(configurator, "smh03;teb052");
cds.configurator.DefaultRule.add(configurator, "smh03;teb053");
cds.configurator.DefaultRule.add(configurator, "smh03;teb063");
cds.configurator.DefaultRule.add(configurator, "smh03;teb064");
cds.configurator.DefaultRule.add(configurator, "smh03;teb067");
cds.configurator.DefaultRule.add(configurator, "smh03;teb068");
cds.configurator.DefaultRule.add(configurator, "smh03;teb070");
cds.configurator.DefaultRule.add(configurator, "smh03;teb071");
cds.configurator.DefaultRule.add(configurator, "smh03;teb074");
cds.configurator.DefaultRule.add(configurator, "smh03;teb075");
cds.configurator.DefaultRule.add(configurator, "smh03;teb080");
cds.configurator.DefaultRule.add(configurator, "smh03;teb084");
cds.configurator.DefaultRule.add(configurator, "smh03;teb090");
cds.configurator.DefaultRule.add(configurator, "smh03;teb096");
cds.configurator.DefaultRule.add(configurator, "smh03;teb100");
cds.configurator.DefaultRule.add(configurator, "smh03;teb112");
cds.configurator.DefaultRule.add(configurator, "smh03;teb120");
cds.configurator.DefaultRule.add(configurator, "smh03;teb126");
cds.configurator.DefaultRule.add(configurator, "smh03;teb140");
cds.configurator.DefaultRule.add(configurator, "smh03;teb144");
cds.configurator.DefaultRule.add(configurator, "smh03;teb154");
cds.configurator.DefaultRule.add(configurator, "smh03;teb168");
cds.configurator.DefaultRule.add(configurator, "smh03;teb180");
cds.configurator.DefaultRule.add(configurator, "smh03;teb192");
cds.configurator.DefaultRule.add(configurator, "smh03;teb200");
cds.configurator.DefaultRule.add(configurator, "smh03;teb216");
cds.configurator.DefaultRule.add(configurator, "smh03;teb224");
cds.configurator.DefaultRule.add(configurator, "smh05;tea010");
cds.configurator.DefaultRule.add(configurator, "smh05;tea011");
cds.configurator.DefaultRule.add(configurator, "smh05;tea021");
cds.configurator.DefaultRule.add(configurator, "smh05;tea023");
cds.configurator.DefaultRule.add(configurator, "smh05;tea027");
cds.configurator.DefaultRule.add(configurator, "smh05;tea029");
cds.configurator.DefaultRule.add(configurator, "smh05;tea031");
cds.configurator.DefaultRule.add(configurator, "smh05;tea033");
cds.configurator.DefaultRule.add(configurator, "smh05;tea035");
cds.configurator.DefaultRule.add(configurator, "smh05;tea037");
cds.configurator.DefaultRule.add(configurator, "smh05;tea039");
cds.configurator.DefaultRule.add(configurator, "smh05;tea041");
cds.configurator.DefaultRule.add(configurator, "smh05;tea042");
cds.configurator.DefaultRule.add(configurator, "smh05;tea043");
cds.configurator.DefaultRule.add(configurator, "smh05;tea045");
cds.configurator.DefaultRule.add(configurator, "smh05;tea046");
cds.configurator.DefaultRule.add(configurator, "smh05;tea053");
cds.configurator.DefaultRule.add(configurator, "smh05;tea063");
cds.configurator.DefaultRule.add(configurator, "smh05;tea067");
cds.configurator.DefaultRule.add(configurator, "smh05;tea071");
cds.configurator.DefaultRule.add(configurator, "smh05;tea074");
cds.configurator.DefaultRule.add(configurator, "smh05;tea075");
cds.configurator.DefaultRule.add(configurator, "smh05;tea084");
cds.configurator.DefaultRule.add(configurator, "smh05;tea096");
cds.configurator.DefaultRule.add(configurator, "smh05;tea100");
cds.configurator.DefaultRule.add(configurator, "smh05;tea120");
cds.configurator.DefaultRule.add(configurator, "smh05;tea126");
cds.configurator.DefaultRule.add(configurator, "smh05;tea140");
cds.configurator.DefaultRule.add(configurator, "smh05;tea144");
cds.configurator.DefaultRule.add(configurator, "smh05;tea154");
cds.configurator.DefaultRule.add(configurator, "smh05;tea168");
cds.configurator.DefaultRule.add(configurator, "smh05;tea180");
cds.configurator.DefaultRule.add(configurator, "smh05;tea192");
cds.configurator.DefaultRule.add(configurator, "smh05;tea200");
cds.configurator.DefaultRule.add(configurator, "smh05;tea216");
cds.configurator.DefaultRule.add(configurator, "smh05;tea224");
cds.configurator.DefaultRule.add(configurator, "smh05;teb010");
cds.configurator.DefaultRule.add(configurator, "smh05;teb011");
cds.configurator.DefaultRule.add(configurator, "smh05;teb021");
cds.configurator.DefaultRule.add(configurator, "smh05;teb023");
cds.configurator.DefaultRule.add(configurator, "smh05;teb027");
cds.configurator.DefaultRule.add(configurator, "smh05;teb029");
cds.configurator.DefaultRule.add(configurator, "smh05;teb031");
cds.configurator.DefaultRule.add(configurator, "smh05;teb033");
cds.configurator.DefaultRule.add(configurator, "smh05;teb035");
cds.configurator.DefaultRule.add(configurator, "smh05;teb037");
cds.configurator.DefaultRule.add(configurator, "smh05;teb039");
cds.configurator.DefaultRule.add(configurator, "smh05;teb041");
cds.configurator.DefaultRule.add(configurator, "smh05;teb042");
cds.configurator.DefaultRule.add(configurator, "smh05;teb043");
cds.configurator.DefaultRule.add(configurator, "smh05;teb045");
cds.configurator.DefaultRule.add(configurator, "smh05;teb046");
cds.configurator.DefaultRule.add(configurator, "smh05;teb053");
cds.configurator.DefaultRule.add(configurator, "smh05;teb063");
cds.configurator.DefaultRule.add(configurator, "smh05;teb067");
cds.configurator.DefaultRule.add(configurator, "smh05;teb071");
cds.configurator.DefaultRule.add(configurator, "smh05;teb074");
cds.configurator.DefaultRule.add(configurator, "smh05;teb075");
cds.configurator.DefaultRule.add(configurator, "smh05;teb084");
cds.configurator.DefaultRule.add(configurator, "smh05;teb096");
cds.configurator.DefaultRule.add(configurator, "smh05;teb100");
cds.configurator.DefaultRule.add(configurator, "smh05;teb120");
cds.configurator.DefaultRule.add(configurator, "smh05;teb126");
cds.configurator.DefaultRule.add(configurator, "smh05;teb140");
cds.configurator.DefaultRule.add(configurator, "smh05;teb144");
cds.configurator.DefaultRule.add(configurator, "smh05;teb154");
cds.configurator.DefaultRule.add(configurator, "smh05;teb168");
cds.configurator.DefaultRule.add(configurator, "smh05;teb180");
cds.configurator.DefaultRule.add(configurator, "smh05;teb192");
cds.configurator.DefaultRule.add(configurator, "smh05;teb200");
cds.configurator.DefaultRule.add(configurator, "smh05;teb216");
cds.configurator.DefaultRule.add(configurator, "smh05;teb224");
cds.configurator.DefaultRule.add(configurator, "smh08;tea010");
cds.configurator.DefaultRule.add(configurator, "smh08;tea011");
cds.configurator.DefaultRule.add(configurator, "smh08;tea012");
cds.configurator.DefaultRule.add(configurator, "smh08;tea013");
cds.configurator.DefaultRule.add(configurator, "smh08;tea014");
cds.configurator.DefaultRule.add(configurator, "smh08;tea015");
cds.configurator.DefaultRule.add(configurator, "smh08;tea016");
cds.configurator.DefaultRule.add(configurator, "smh08;tea017");
cds.configurator.DefaultRule.add(configurator, "smh08;tea018");
cds.configurator.DefaultRule.add(configurator, "smh08;tea019");
cds.configurator.DefaultRule.add(configurator, "smh08;tea020");
cds.configurator.DefaultRule.add(configurator, "smh08;tea021");
cds.configurator.DefaultRule.add(configurator, "smh08;tea023");
cds.configurator.DefaultRule.add(configurator, "smh08;tea025");
cds.configurator.DefaultRule.add(configurator, "smh08;tea027");
cds.configurator.DefaultRule.add(configurator, "smh08;tea029");
cds.configurator.DefaultRule.add(configurator, "smh08;tea031");
cds.configurator.DefaultRule.add(configurator, "smh08;tea033");
cds.configurator.DefaultRule.add(configurator, "smh08;tea035");
cds.configurator.DefaultRule.add(configurator, "smh08;tea037");
cds.configurator.DefaultRule.add(configurator, "smh08;tea039");
cds.configurator.DefaultRule.add(configurator, "smh08;tea041");
cds.configurator.DefaultRule.add(configurator, "smh08;tea042");
cds.configurator.DefaultRule.add(configurator, "smh08;tea043");
cds.configurator.DefaultRule.add(configurator, "smh08;tea045");
cds.configurator.DefaultRule.add(configurator, "smh08;tea046");
cds.configurator.DefaultRule.add(configurator, "smh08;tea050");
cds.configurator.DefaultRule.add(configurator, "smh08;tea052");
cds.configurator.DefaultRule.add(configurator, "smh08;tea053");
cds.configurator.DefaultRule.add(configurator, "smh08;tea060");
cds.configurator.DefaultRule.add(configurator, "smh08;tea062");
cds.configurator.DefaultRule.add(configurator, "smh08;tea063");
cds.configurator.DefaultRule.add(configurator, "smh08;tea067");
cds.configurator.DefaultRule.add(configurator, "smh08;tea068");
cds.configurator.DefaultRule.add(configurator, "smh08;tea070");
cds.configurator.DefaultRule.add(configurator, "smh08;tea071");
cds.configurator.DefaultRule.add(configurator, "smh08;tea074");
cds.configurator.DefaultRule.add(configurator, "smh08;tea075");
cds.configurator.DefaultRule.add(configurator, "smh08;tea084");
cds.configurator.DefaultRule.add(configurator, "smh08;tea096");
cds.configurator.DefaultRule.add(configurator, "smh08;tea100");
cds.configurator.DefaultRule.add(configurator, "smh08;tea120");
cds.configurator.DefaultRule.add(configurator, "smh08;tea126");
cds.configurator.DefaultRule.add(configurator, "smh08;tea140");
cds.configurator.DefaultRule.add(configurator, "smh08;tea154");
cds.configurator.DefaultRule.add(configurator, "smh08;tea168");
cds.configurator.DefaultRule.add(configurator, "smh08;tea180");
cds.configurator.DefaultRule.add(configurator, "smh08;tea200");
cds.configurator.DefaultRule.add(configurator, "smh08;tea216");
cds.configurator.DefaultRule.add(configurator, "smh08;tea224");
cds.configurator.DefaultRule.add(configurator, "smh08;teb010");
cds.configurator.DefaultRule.add(configurator, "smh08;teb011");
cds.configurator.DefaultRule.add(configurator, "smh08;teb012");
cds.configurator.DefaultRule.add(configurator, "smh08;teb013");
cds.configurator.DefaultRule.add(configurator, "smh08;teb014");
cds.configurator.DefaultRule.add(configurator, "smh08;teb015");
cds.configurator.DefaultRule.add(configurator, "smh08;teb016");
cds.configurator.DefaultRule.add(configurator, "smh08;teb017");
cds.configurator.DefaultRule.add(configurator, "smh08;teb018");
cds.configurator.DefaultRule.add(configurator, "smh08;teb019");
cds.configurator.DefaultRule.add(configurator, "smh08;teb020");
cds.configurator.DefaultRule.add(configurator, "smh08;teb021");
cds.configurator.DefaultRule.add(configurator, "smh08;teb023");
cds.configurator.DefaultRule.add(configurator, "smh08;teb025");
cds.configurator.DefaultRule.add(configurator, "smh08;teb027");
cds.configurator.DefaultRule.add(configurator, "smh08;teb029");
cds.configurator.DefaultRule.add(configurator, "smh08;teb031");
cds.configurator.DefaultRule.add(configurator, "smh08;teb033");
cds.configurator.DefaultRule.add(configurator, "smh08;teb035");
cds.configurator.DefaultRule.add(configurator, "smh08;teb037");
cds.configurator.DefaultRule.add(configurator, "smh08;teb039");
cds.configurator.DefaultRule.add(configurator, "smh08;teb041");
cds.configurator.DefaultRule.add(configurator, "smh08;teb042");
cds.configurator.DefaultRule.add(configurator, "smh08;teb043");
cds.configurator.DefaultRule.add(configurator, "smh08;teb045");
cds.configurator.DefaultRule.add(configurator, "smh08;teb046");
cds.configurator.DefaultRule.add(configurator, "smh08;teb050");
cds.configurator.DefaultRule.add(configurator, "smh08;teb052");
cds.configurator.DefaultRule.add(configurator, "smh08;teb053");
cds.configurator.DefaultRule.add(configurator, "smh08;teb060");
cds.configurator.DefaultRule.add(configurator, "smh08;teb062");
cds.configurator.DefaultRule.add(configurator, "smh08;teb063");
cds.configurator.DefaultRule.add(configurator, "smh08;teb067");
cds.configurator.DefaultRule.add(configurator, "smh08;teb068");
cds.configurator.DefaultRule.add(configurator, "smh08;teb070");
cds.configurator.DefaultRule.add(configurator, "smh08;teb071");
cds.configurator.DefaultRule.add(configurator, "smh08;teb074");
cds.configurator.DefaultRule.add(configurator, "smh08;teb075");
cds.configurator.DefaultRule.add(configurator, "smh08;teb084");
cds.configurator.DefaultRule.add(configurator, "smh08;teb096");
cds.configurator.DefaultRule.add(configurator, "smh08;teb100");
cds.configurator.DefaultRule.add(configurator, "smh08;teb120");
cds.configurator.DefaultRule.add(configurator, "smh08;teb126");
cds.configurator.DefaultRule.add(configurator, "smh08;teb140");
cds.configurator.DefaultRule.add(configurator, "smh08;teb154");
cds.configurator.DefaultRule.add(configurator, "smh08;teb168");
cds.configurator.DefaultRule.add(configurator, "smh08;teb180");
cds.configurator.DefaultRule.add(configurator, "smh08;teb200");
cds.configurator.DefaultRule.add(configurator, "smh08;teb216");
cds.configurator.DefaultRule.add(configurator, "smh08;teb224");
cds.configurator.DefaultRule.add(configurator, "smt05;tea011");
cds.configurator.DefaultRule.add(configurator, "smt05;tea013");
cds.configurator.DefaultRule.add(configurator, "smt05;tea017");
cds.configurator.DefaultRule.add(configurator, "smt05;tea021");
cds.configurator.DefaultRule.add(configurator, "smt05;tea023");
cds.configurator.DefaultRule.add(configurator, "smt05;tea028");
cds.configurator.DefaultRule.add(configurator, "smt05;tea029");
cds.configurator.DefaultRule.add(configurator, "smt05;tea031");
cds.configurator.DefaultRule.add(configurator, "smt05;tea033");
cds.configurator.DefaultRule.add(configurator, "smt05;tea034");
cds.configurator.DefaultRule.add(configurator, "smt05;tea035");
cds.configurator.DefaultRule.add(configurator, "smt05;tea037");
cds.configurator.DefaultRule.add(configurator, "smt05;tea038");
cds.configurator.DefaultRule.add(configurator, "smt05;tea039");
cds.configurator.DefaultRule.add(configurator, "smt05;tea041");
cds.configurator.DefaultRule.add(configurator, "smt05;tea042");
cds.configurator.DefaultRule.add(configurator, "smt05;tea043");
cds.configurator.DefaultRule.add(configurator, "smt05;tea044");
cds.configurator.DefaultRule.add(configurator, "smt05;tea045");
cds.configurator.DefaultRule.add(configurator, "smt05;tea046");
cds.configurator.DefaultRule.add(configurator, "smt05;tea050");
cds.configurator.DefaultRule.add(configurator, "smt05;tea052");
cds.configurator.DefaultRule.add(configurator, "smt05;tea053");
cds.configurator.DefaultRule.add(configurator, "smt05;tea056");
cds.configurator.DefaultRule.add(configurator, "smt05;tea062");
cds.configurator.DefaultRule.add(configurator, "smt05;tea063");
cds.configurator.DefaultRule.add(configurator, "smt05;tea064");
cds.configurator.DefaultRule.add(configurator, "smt05;tea067");
cds.configurator.DefaultRule.add(configurator, "smt05;tea068");
cds.configurator.DefaultRule.add(configurator, "smt05;tea070");
cds.configurator.DefaultRule.add(configurator, "smt05;tea071");
cds.configurator.DefaultRule.add(configurator, "smt05;tea072");
cds.configurator.DefaultRule.add(configurator, "smt05;tea074");
cds.configurator.DefaultRule.add(configurator, "smt05;tea075");
cds.configurator.DefaultRule.add(configurator, "smt05;tea080");
cds.configurator.DefaultRule.add(configurator, "smt05;tea084");
cds.configurator.DefaultRule.add(configurator, "smt05;tea090");
cds.configurator.DefaultRule.add(configurator, "smt05;tea096");
cds.configurator.DefaultRule.add(configurator, "smt05;tea100");
cds.configurator.DefaultRule.add(configurator, "smt05;tea112");
cds.configurator.DefaultRule.add(configurator, "smt05;tea120");
cds.configurator.DefaultRule.add(configurator, "smt05;tea126");
cds.configurator.DefaultRule.add(configurator, "smt05;tea140");
cds.configurator.DefaultRule.add(configurator, "smt05;tea144");
cds.configurator.DefaultRule.add(configurator, "smt05;tea154");
cds.configurator.DefaultRule.add(configurator, "smt05;tea168");
cds.configurator.DefaultRule.add(configurator, "smt05;tea180");
cds.configurator.DefaultRule.add(configurator, "smt05;tea192");
cds.configurator.DefaultRule.add(configurator, "smt05;tea200");
cds.configurator.DefaultRule.add(configurator, "smt05;tea216");
cds.configurator.DefaultRule.add(configurator, "smt05;tea224");
cds.configurator.DefaultRule.add(configurator, "smt05;teb011");
cds.configurator.DefaultRule.add(configurator, "smt05;teb013");
cds.configurator.DefaultRule.add(configurator, "smt05;teb017");
cds.configurator.DefaultRule.add(configurator, "smt05;teb021");
cds.configurator.DefaultRule.add(configurator, "smt05;teb023");
cds.configurator.DefaultRule.add(configurator, "smt05;teb028");
cds.configurator.DefaultRule.add(configurator, "smt05;teb029");
cds.configurator.DefaultRule.add(configurator, "smt05;teb031");
cds.configurator.DefaultRule.add(configurator, "smt05;teb033");
cds.configurator.DefaultRule.add(configurator, "smt05;teb034");
cds.configurator.DefaultRule.add(configurator, "smt05;teb035");
cds.configurator.DefaultRule.add(configurator, "smt05;teb037");
cds.configurator.DefaultRule.add(configurator, "smt05;teb038");
cds.configurator.DefaultRule.add(configurator, "smt05;teb039");
cds.configurator.DefaultRule.add(configurator, "smt05;teb041");
cds.configurator.DefaultRule.add(configurator, "smt05;teb042");
cds.configurator.DefaultRule.add(configurator, "smt05;teb043");
cds.configurator.DefaultRule.add(configurator, "smt05;teb044");
cds.configurator.DefaultRule.add(configurator, "smt05;teb045");
cds.configurator.DefaultRule.add(configurator, "smt05;teb046");
cds.configurator.DefaultRule.add(configurator, "smt05;teb050");
cds.configurator.DefaultRule.add(configurator, "smt05;teb052");
cds.configurator.DefaultRule.add(configurator, "smt05;teb053");
cds.configurator.DefaultRule.add(configurator, "smt05;teb056");
cds.configurator.DefaultRule.add(configurator, "smt05;teb062");
cds.configurator.DefaultRule.add(configurator, "smt05;teb063");
cds.configurator.DefaultRule.add(configurator, "smt05;teb064");
cds.configurator.DefaultRule.add(configurator, "smt05;teb067");
cds.configurator.DefaultRule.add(configurator, "smt05;teb068");
cds.configurator.DefaultRule.add(configurator, "smt05;teb070");
cds.configurator.DefaultRule.add(configurator, "smt05;teb071");
cds.configurator.DefaultRule.add(configurator, "smt05;teb072");
cds.configurator.DefaultRule.add(configurator, "smt05;teb074");
cds.configurator.DefaultRule.add(configurator, "smt05;teb075");
cds.configurator.DefaultRule.add(configurator, "smt05;teb080");
cds.configurator.DefaultRule.add(configurator, "smt05;teb084");
cds.configurator.DefaultRule.add(configurator, "smt05;teb090");
cds.configurator.DefaultRule.add(configurator, "smt05;teb096");
cds.configurator.DefaultRule.add(configurator, "smt05;teb100");
cds.configurator.DefaultRule.add(configurator, "smt05;teb112");
cds.configurator.DefaultRule.add(configurator, "smt05;teb120");
cds.configurator.DefaultRule.add(configurator, "smt05;teb126");
cds.configurator.DefaultRule.add(configurator, "smt05;teb140");
cds.configurator.DefaultRule.add(configurator, "smt05;teb144");
cds.configurator.DefaultRule.add(configurator, "smt05;teb154");
cds.configurator.DefaultRule.add(configurator, "smt05;teb168");
cds.configurator.DefaultRule.add(configurator, "smt05;teb180");
cds.configurator.DefaultRule.add(configurator, "smt05;teb192");
cds.configurator.DefaultRule.add(configurator, "smt05;teb200");
cds.configurator.DefaultRule.add(configurator, "smt05;teb216");
cds.configurator.DefaultRule.add(configurator, "smt05;teb224");
cds.configurator.DefaultRule.add(configurator, "smt10;tea010");
cds.configurator.DefaultRule.add(configurator, "smt10;tea011");
cds.configurator.DefaultRule.add(configurator, "smt10;tea012");
cds.configurator.DefaultRule.add(configurator, "smt10;tea013");
cds.configurator.DefaultRule.add(configurator, "smt10;tea017");
cds.configurator.DefaultRule.add(configurator, "smt10;tea021");
cds.configurator.DefaultRule.add(configurator, "smt10;tea022");
cds.configurator.DefaultRule.add(configurator, "smt10;tea023");
cds.configurator.DefaultRule.add(configurator, "smt10;tea026");
cds.configurator.DefaultRule.add(configurator, "smt10;tea028");
cds.configurator.DefaultRule.add(configurator, "smt10;tea029");
cds.configurator.DefaultRule.add(configurator, "smt10;tea031");
cds.configurator.DefaultRule.add(configurator, "smt10;tea033");
cds.configurator.DefaultRule.add(configurator, "smt10;tea034");
cds.configurator.DefaultRule.add(configurator, "smt10;tea035");
cds.configurator.DefaultRule.add(configurator, "smt10;tea037");
cds.configurator.DefaultRule.add(configurator, "smt10;tea038");
cds.configurator.DefaultRule.add(configurator, "smt10;tea039");
cds.configurator.DefaultRule.add(configurator, "smt10;tea041");
cds.configurator.DefaultRule.add(configurator, "smt10;tea042");
cds.configurator.DefaultRule.add(configurator, "smt10;tea043");
cds.configurator.DefaultRule.add(configurator, "smt10;tea044");
cds.configurator.DefaultRule.add(configurator, "smt10;tea045");
cds.configurator.DefaultRule.add(configurator, "smt10;tea046");
cds.configurator.DefaultRule.add(configurator, "smt10;tea050");
cds.configurator.DefaultRule.add(configurator, "smt10;tea052");
cds.configurator.DefaultRule.add(configurator, "smt10;tea053");
cds.configurator.DefaultRule.add(configurator, "smt10;tea056");
cds.configurator.DefaultRule.add(configurator, "smt10;tea062");
cds.configurator.DefaultRule.add(configurator, "smt10;tea063");
cds.configurator.DefaultRule.add(configurator, "smt10;tea064");
cds.configurator.DefaultRule.add(configurator, "smt10;tea067");
cds.configurator.DefaultRule.add(configurator, "smt10;tea068");
cds.configurator.DefaultRule.add(configurator, "smt10;tea070");
cds.configurator.DefaultRule.add(configurator, "smt10;tea071");
cds.configurator.DefaultRule.add(configurator, "smt10;tea072");
cds.configurator.DefaultRule.add(configurator, "smt10;tea074");
cds.configurator.DefaultRule.add(configurator, "smt10;tea075");
cds.configurator.DefaultRule.add(configurator, "smt10;tea080");
cds.configurator.DefaultRule.add(configurator, "smt10;tea084");
cds.configurator.DefaultRule.add(configurator, "smt10;tea090");
cds.configurator.DefaultRule.add(configurator, "smt10;tea096");
cds.configurator.DefaultRule.add(configurator, "smt10;tea100");
cds.configurator.DefaultRule.add(configurator, "smt10;tea112");
cds.configurator.DefaultRule.add(configurator, "smt10;tea120");
cds.configurator.DefaultRule.add(configurator, "smt10;tea126");
cds.configurator.DefaultRule.add(configurator, "smt10;tea140");
cds.configurator.DefaultRule.add(configurator, "smt10;tea144");
cds.configurator.DefaultRule.add(configurator, "smt10;tea154");
cds.configurator.DefaultRule.add(configurator, "smt10;tea168");
cds.configurator.DefaultRule.add(configurator, "smt10;tea180");
cds.configurator.DefaultRule.add(configurator, "smt10;tea192");
cds.configurator.DefaultRule.add(configurator, "smt10;tea200");
cds.configurator.DefaultRule.add(configurator, "smt10;tea216");
cds.configurator.DefaultRule.add(configurator, "smt10;tea224");
cds.configurator.DefaultRule.add(configurator, "smt10;teb010");
cds.configurator.DefaultRule.add(configurator, "smt10;teb011");
cds.configurator.DefaultRule.add(configurator, "smt10;teb012");
cds.configurator.DefaultRule.add(configurator, "smt10;teb013");
cds.configurator.DefaultRule.add(configurator, "smt10;teb017");
cds.configurator.DefaultRule.add(configurator, "smt10;teb021");
cds.configurator.DefaultRule.add(configurator, "smt10;teb022");
cds.configurator.DefaultRule.add(configurator, "smt10;teb023");
cds.configurator.DefaultRule.add(configurator, "smt10;teb026");
cds.configurator.DefaultRule.add(configurator, "smt10;teb028");
cds.configurator.DefaultRule.add(configurator, "smt10;teb029");
cds.configurator.DefaultRule.add(configurator, "smt10;teb031");
cds.configurator.DefaultRule.add(configurator, "smt10;teb033");
cds.configurator.DefaultRule.add(configurator, "smt10;teb034");
cds.configurator.DefaultRule.add(configurator, "smt10;teb035");
cds.configurator.DefaultRule.add(configurator, "smt10;teb037");
cds.configurator.DefaultRule.add(configurator, "smt10;teb038");
cds.configurator.DefaultRule.add(configurator, "smt10;teb039");
cds.configurator.DefaultRule.add(configurator, "smt10;teb041");
cds.configurator.DefaultRule.add(configurator, "smt10;teb042");
cds.configurator.DefaultRule.add(configurator, "smt10;teb043");
cds.configurator.DefaultRule.add(configurator, "smt10;teb044");
cds.configurator.DefaultRule.add(configurator, "smt10;teb045");
cds.configurator.DefaultRule.add(configurator, "smt10;teb046");
cds.configurator.DefaultRule.add(configurator, "smt10;teb050");
cds.configurator.DefaultRule.add(configurator, "smt10;teb052");
cds.configurator.DefaultRule.add(configurator, "smt10;teb053");
cds.configurator.DefaultRule.add(configurator, "smt10;teb056");
cds.configurator.DefaultRule.add(configurator, "smt10;teb062");
cds.configurator.DefaultRule.add(configurator, "smt10;teb063");
cds.configurator.DefaultRule.add(configurator, "smt10;teb064");
cds.configurator.DefaultRule.add(configurator, "smt10;teb067");
cds.configurator.DefaultRule.add(configurator, "smt10;teb068");
cds.configurator.DefaultRule.add(configurator, "smt10;teb070");
cds.configurator.DefaultRule.add(configurator, "smt10;teb071");
cds.configurator.DefaultRule.add(configurator, "smt10;teb072");
cds.configurator.DefaultRule.add(configurator, "smt10;teb074");
cds.configurator.DefaultRule.add(configurator, "smt10;teb075");
cds.configurator.DefaultRule.add(configurator, "smt10;teb080");
cds.configurator.DefaultRule.add(configurator, "smt10;teb084");
cds.configurator.DefaultRule.add(configurator, "smt10;teb090");
cds.configurator.DefaultRule.add(configurator, "smt10;teb096");
cds.configurator.DefaultRule.add(configurator, "smt10;teb100");
cds.configurator.DefaultRule.add(configurator, "smt10;teb112");
cds.configurator.DefaultRule.add(configurator, "smt10;teb120");
cds.configurator.DefaultRule.add(configurator, "smt10;teb126");
cds.configurator.DefaultRule.add(configurator, "smt10;teb140");
cds.configurator.DefaultRule.add(configurator, "smt10;teb144");
cds.configurator.DefaultRule.add(configurator, "smt10;teb154");
cds.configurator.DefaultRule.add(configurator, "smt10;teb168");
cds.configurator.DefaultRule.add(configurator, "smt10;teb180");
cds.configurator.DefaultRule.add(configurator, "smt10;teb192");
cds.configurator.DefaultRule.add(configurator, "smt10;teb200");
cds.configurator.DefaultRule.add(configurator, "smt10;teb216");
cds.configurator.DefaultRule.add(configurator, "smt10;teb224");
cds.configurator.DefaultRule.add(configurator, "smt25;tea010");
cds.configurator.DefaultRule.add(configurator, "smt25;tea011");
cds.configurator.DefaultRule.add(configurator, "smt25;tea013");
cds.configurator.DefaultRule.add(configurator, "smt25;tea017");
cds.configurator.DefaultRule.add(configurator, "smt25;tea021");
cds.configurator.DefaultRule.add(configurator, "smt25;tea023");
cds.configurator.DefaultRule.add(configurator, "smt25;tea027");
cds.configurator.DefaultRule.add(configurator, "smt25;tea029");
cds.configurator.DefaultRule.add(configurator, "smt25;tea031");
cds.configurator.DefaultRule.add(configurator, "smt25;tea033");
cds.configurator.DefaultRule.add(configurator, "smt25;tea034");
cds.configurator.DefaultRule.add(configurator, "smt25;tea035");
cds.configurator.DefaultRule.add(configurator, "smt25;tea037");
cds.configurator.DefaultRule.add(configurator, "smt25;tea038");
cds.configurator.DefaultRule.add(configurator, "smt25;tea039");
cds.configurator.DefaultRule.add(configurator, "smt25;tea041");
cds.configurator.DefaultRule.add(configurator, "smt25;tea042");
cds.configurator.DefaultRule.add(configurator, "smt25;tea043");
cds.configurator.DefaultRule.add(configurator, "smt25;tea045");
cds.configurator.DefaultRule.add(configurator, "smt25;tea046");
cds.configurator.DefaultRule.add(configurator, "smt25;tea050");
cds.configurator.DefaultRule.add(configurator, "smt25;tea052");
cds.configurator.DefaultRule.add(configurator, "smt25;tea053");
cds.configurator.DefaultRule.add(configurator, "smt25;tea056");
cds.configurator.DefaultRule.add(configurator, "smt25;tea062");
cds.configurator.DefaultRule.add(configurator, "smt25;tea063");
cds.configurator.DefaultRule.add(configurator, "smt25;tea064");
cds.configurator.DefaultRule.add(configurator, "smt25;tea067");
cds.configurator.DefaultRule.add(configurator, "smt25;tea068");
cds.configurator.DefaultRule.add(configurator, "smt25;tea070");
cds.configurator.DefaultRule.add(configurator, "smt25;tea071");
cds.configurator.DefaultRule.add(configurator, "smt25;tea072");
cds.configurator.DefaultRule.add(configurator, "smt25;tea074");
cds.configurator.DefaultRule.add(configurator, "smt25;tea075");
cds.configurator.DefaultRule.add(configurator, "smt25;tea080");
cds.configurator.DefaultRule.add(configurator, "smt25;tea084");
cds.configurator.DefaultRule.add(configurator, "smt25;tea090");
cds.configurator.DefaultRule.add(configurator, "smt25;tea096");
cds.configurator.DefaultRule.add(configurator, "smt25;tea100");
cds.configurator.DefaultRule.add(configurator, "smt25;tea112");
cds.configurator.DefaultRule.add(configurator, "smt25;tea120");
cds.configurator.DefaultRule.add(configurator, "smt25;tea126");
cds.configurator.DefaultRule.add(configurator, "smt25;tea140");
cds.configurator.DefaultRule.add(configurator, "smt25;tea144");
cds.configurator.DefaultRule.add(configurator, "smt25;tea154");
cds.configurator.DefaultRule.add(configurator, "smt25;tea168");
cds.configurator.DefaultRule.add(configurator, "smt25;tea180");
cds.configurator.DefaultRule.add(configurator, "smt25;tea192");
cds.configurator.DefaultRule.add(configurator, "smt25;tea200");
cds.configurator.DefaultRule.add(configurator, "smt25;tea216");
cds.configurator.DefaultRule.add(configurator, "smt25;tea224");
cds.configurator.DefaultRule.add(configurator, "smt25;teb010");
cds.configurator.DefaultRule.add(configurator, "smt25;teb011");
cds.configurator.DefaultRule.add(configurator, "smt25;teb013");
cds.configurator.DefaultRule.add(configurator, "smt25;teb017");
cds.configurator.DefaultRule.add(configurator, "smt25;teb021");
cds.configurator.DefaultRule.add(configurator, "smt25;teb023");
cds.configurator.DefaultRule.add(configurator, "smt25;teb027");
cds.configurator.DefaultRule.add(configurator, "smt25;teb029");
cds.configurator.DefaultRule.add(configurator, "smt25;teb031");
cds.configurator.DefaultRule.add(configurator, "smt25;teb033");
cds.configurator.DefaultRule.add(configurator, "smt25;teb034");
cds.configurator.DefaultRule.add(configurator, "smt25;teb035");
cds.configurator.DefaultRule.add(configurator, "smt25;teb037");
cds.configurator.DefaultRule.add(configurator, "smt25;teb038");
cds.configurator.DefaultRule.add(configurator, "smt25;teb039");
cds.configurator.DefaultRule.add(configurator, "smt25;teb041");
cds.configurator.DefaultRule.add(configurator, "smt25;teb042");
cds.configurator.DefaultRule.add(configurator, "smt25;teb043");
cds.configurator.DefaultRule.add(configurator, "smt25;teb045");
cds.configurator.DefaultRule.add(configurator, "smt25;teb046");
cds.configurator.DefaultRule.add(configurator, "smt25;teb050");
cds.configurator.DefaultRule.add(configurator, "smt25;teb052");
cds.configurator.DefaultRule.add(configurator, "smt25;teb053");
cds.configurator.DefaultRule.add(configurator, "smt25;teb056");
cds.configurator.DefaultRule.add(configurator, "smt25;teb062");
cds.configurator.DefaultRule.add(configurator, "smt25;teb063");
cds.configurator.DefaultRule.add(configurator, "smt25;teb064");
cds.configurator.DefaultRule.add(configurator, "smt25;teb067");
cds.configurator.DefaultRule.add(configurator, "smt25;teb068");
cds.configurator.DefaultRule.add(configurator, "smt25;teb070");
cds.configurator.DefaultRule.add(configurator, "smt25;teb071");
cds.configurator.DefaultRule.add(configurator, "smt25;teb072");
cds.configurator.DefaultRule.add(configurator, "smt25;teb074");
cds.configurator.DefaultRule.add(configurator, "smt25;teb075");
cds.configurator.DefaultRule.add(configurator, "smt25;teb080");
cds.configurator.DefaultRule.add(configurator, "smt25;teb084");
cds.configurator.DefaultRule.add(configurator, "smt25;teb090");
cds.configurator.DefaultRule.add(configurator, "smt25;teb096");
cds.configurator.DefaultRule.add(configurator, "smt25;teb100");
cds.configurator.DefaultRule.add(configurator, "smt25;teb112");
cds.configurator.DefaultRule.add(configurator, "smt25;teb120");
cds.configurator.DefaultRule.add(configurator, "smt25;teb126");
cds.configurator.DefaultRule.add(configurator, "smt25;teb140");
cds.configurator.DefaultRule.add(configurator, "smt25;teb144");
cds.configurator.DefaultRule.add(configurator, "smt25;teb154");
cds.configurator.DefaultRule.add(configurator, "smt25;teb168");
cds.configurator.DefaultRule.add(configurator, "smt25;teb180");
cds.configurator.DefaultRule.add(configurator, "smt25;teb192");
cds.configurator.DefaultRule.add(configurator, "smt25;teb200");
cds.configurator.DefaultRule.add(configurator, "smt25;teb216");
cds.configurator.DefaultRule.add(configurator, "smt25;teb224");
cds.configurator.DefaultRule.add(configurator, "be0118;sehhh");
cds.configurator.DefaultRule.add(configurator, "be0118;selll");
cds.configurator.DefaultRule.add(configurator, "be0118;semxl");
cds.configurator.DefaultRule.add(configurator, "be0118;sexll");
cds.configurator.DefaultRule.add(configurator, "be0118;sma05");
cds.configurator.DefaultRule.add(configurator, "be0118;sma10");
cds.configurator.DefaultRule.add(configurator, "be0118;smh03");
cds.configurator.DefaultRule.add(configurator, "be0118;smh05");
cds.configurator.DefaultRule.add(configurator, "be0118;smh08");
cds.configurator.DefaultRule.add(configurator, "be0118;smt05");
cds.configurator.DefaultRule.add(configurator, "be0118;smt10");
cds.configurator.DefaultRule.add(configurator, "be0118;smt25");
cds.configurator.DefaultRule.add(configurator, "be0118;tea010");
cds.configurator.DefaultRule.add(configurator, "be0118;tea011");
cds.configurator.DefaultRule.add(configurator, "be0118;tea023");
cds.configurator.DefaultRule.add(configurator, "be0118;tea027");
cds.configurator.DefaultRule.add(configurator, "be0118;tea029");
cds.configurator.DefaultRule.add(configurator, "be0118;tea031");
cds.configurator.DefaultRule.add(configurator, "be0118;tea033");
cds.configurator.DefaultRule.add(configurator, "be0118;tea034");
cds.configurator.DefaultRule.add(configurator, "be0118;tea035");
cds.configurator.DefaultRule.add(configurator, "be0118;tea037");
cds.configurator.DefaultRule.add(configurator, "be0118;tea038");
cds.configurator.DefaultRule.add(configurator, "be0118;tea039");
cds.configurator.DefaultRule.add(configurator, "be0118;tea041");
cds.configurator.DefaultRule.add(configurator, "be0118;tea043");
cds.configurator.DefaultRule.add(configurator, "be0118;tea046");
cds.configurator.DefaultRule.add(configurator, "be0118;tea052");
cds.configurator.DefaultRule.add(configurator, "be0118;tea053");
cds.configurator.DefaultRule.add(configurator, "be0118;tea062");
cds.configurator.DefaultRule.add(configurator, "be0118;tea063");
cds.configurator.DefaultRule.add(configurator, "be0118;tea064");
cds.configurator.DefaultRule.add(configurator, "be0118;tea067");
cds.configurator.DefaultRule.add(configurator, "be0118;tea068");
cds.configurator.DefaultRule.add(configurator, "be0118;tea070");
cds.configurator.DefaultRule.add(configurator, "be0118;tea071");
cds.configurator.DefaultRule.add(configurator, "be0118;tea072");
cds.configurator.DefaultRule.add(configurator, "be0118;tea074");
cds.configurator.DefaultRule.add(configurator, "be0118;tea075");
cds.configurator.DefaultRule.add(configurator, "be0118;tea080");
cds.configurator.DefaultRule.add(configurator, "be0118;tea084");
cds.configurator.DefaultRule.add(configurator, "be0118;tea090");
cds.configurator.DefaultRule.add(configurator, "be0118;tea096");
cds.configurator.DefaultRule.add(configurator, "be0118;tea100");
cds.configurator.DefaultRule.add(configurator, "be0118;tea112");
cds.configurator.DefaultRule.add(configurator, "be0118;tea120");
cds.configurator.DefaultRule.add(configurator, "be0118;tea126");
cds.configurator.DefaultRule.add(configurator, "be0118;tea140");
cds.configurator.DefaultRule.add(configurator, "be0118;tea144");
cds.configurator.DefaultRule.add(configurator, "be0118;tea154");
cds.configurator.DefaultRule.add(configurator, "be0118;tea168");
cds.configurator.DefaultRule.add(configurator, "be0118;tea180");
cds.configurator.DefaultRule.add(configurator, "be0118;tea192");
cds.configurator.DefaultRule.add(configurator, "be0118;tea200");
cds.configurator.DefaultRule.add(configurator, "be0118;tea216");
cds.configurator.DefaultRule.add(configurator, "be0118;tea224");
cds.configurator.DefaultRule.add(configurator, "be0118;teb010");
cds.configurator.DefaultRule.add(configurator, "be0118;teb011");
cds.configurator.DefaultRule.add(configurator, "be0118;teb023");
cds.configurator.DefaultRule.add(configurator, "be0118;teb027");
cds.configurator.DefaultRule.add(configurator, "be0118;teb029");
cds.configurator.DefaultRule.add(configurator, "be0118;teb031");
cds.configurator.DefaultRule.add(configurator, "be0118;teb033");
cds.configurator.DefaultRule.add(configurator, "be0118;teb034");
cds.configurator.DefaultRule.add(configurator, "be0118;teb035");
cds.configurator.DefaultRule.add(configurator, "be0118;teb037");
cds.configurator.DefaultRule.add(configurator, "be0118;teb038");
cds.configurator.DefaultRule.add(configurator, "be0118;teb039");
cds.configurator.DefaultRule.add(configurator, "be0118;teb041");
cds.configurator.DefaultRule.add(configurator, "be0118;teb043");
cds.configurator.DefaultRule.add(configurator, "be0118;teb046");
cds.configurator.DefaultRule.add(configurator, "be0118;teb052");
cds.configurator.DefaultRule.add(configurator, "be0118;teb053");
cds.configurator.DefaultRule.add(configurator, "be0118;teb062");
cds.configurator.DefaultRule.add(configurator, "be0118;teb063");
cds.configurator.DefaultRule.add(configurator, "be0118;teb064");
cds.configurator.DefaultRule.add(configurator, "be0118;teb067");
cds.configurator.DefaultRule.add(configurator, "be0118;teb068");
cds.configurator.DefaultRule.add(configurator, "be0118;teb070");
cds.configurator.DefaultRule.add(configurator, "be0118;teb071");
cds.configurator.DefaultRule.add(configurator, "be0118;teb072");
cds.configurator.DefaultRule.add(configurator, "be0118;teb074");
cds.configurator.DefaultRule.add(configurator, "be0118;teb075");
cds.configurator.DefaultRule.add(configurator, "be0118;teb080");
cds.configurator.DefaultRule.add(configurator, "be0118;teb084");
cds.configurator.DefaultRule.add(configurator, "be0118;teb090");
cds.configurator.DefaultRule.add(configurator, "be0118;teb096");
cds.configurator.DefaultRule.add(configurator, "be0118;teb100");
cds.configurator.DefaultRule.add(configurator, "be0118;teb112");
cds.configurator.DefaultRule.add(configurator, "be0118;teb120");
cds.configurator.DefaultRule.add(configurator, "be0118;teb126");
cds.configurator.DefaultRule.add(configurator, "be0118;teb140");
cds.configurator.DefaultRule.add(configurator, "be0118;teb144");
cds.configurator.DefaultRule.add(configurator, "be0118;teb154");
cds.configurator.DefaultRule.add(configurator, "be0118;teb168");
cds.configurator.DefaultRule.add(configurator, "be0118;teb180");
cds.configurator.DefaultRule.add(configurator, "be0118;teb192");
cds.configurator.DefaultRule.add(configurator, "be0118;teb200");
cds.configurator.DefaultRule.add(configurator, "be0118;teb216");
cds.configurator.DefaultRule.add(configurator, "be0118;teb224");
cds.configurator.DefaultRule.add(configurator, "be0125;sehhh");
cds.configurator.DefaultRule.add(configurator, "be0125;selll");
cds.configurator.DefaultRule.add(configurator, "be0125;sexll");
cds.configurator.DefaultRule.add(configurator, "be0125;sma05");
cds.configurator.DefaultRule.add(configurator, "be0125;sma10");
cds.configurator.DefaultRule.add(configurator, "be0125;smh03");
cds.configurator.DefaultRule.add(configurator, "be0125;smh05");
cds.configurator.DefaultRule.add(configurator, "be0125;smh08");
cds.configurator.DefaultRule.add(configurator, "be0125;smt05");
cds.configurator.DefaultRule.add(configurator, "be0125;smt10");
cds.configurator.DefaultRule.add(configurator, "be0125;smt25");
cds.configurator.DefaultRule.add(configurator, "be0125;tea013");
cds.configurator.DefaultRule.add(configurator, "be0125;tea017");
cds.configurator.DefaultRule.add(configurator, "be0125;tea019");
cds.configurator.DefaultRule.add(configurator, "be0125;tea023");
cds.configurator.DefaultRule.add(configurator, "be0125;tea025");
cds.configurator.DefaultRule.add(configurator, "be0125;tea026");
cds.configurator.DefaultRule.add(configurator, "be0125;tea027");
cds.configurator.DefaultRule.add(configurator, "be0125;tea029");
cds.configurator.DefaultRule.add(configurator, "be0125;tea031");
cds.configurator.DefaultRule.add(configurator, "be0125;tea033");
cds.configurator.DefaultRule.add(configurator, "be0125;tea034");
cds.configurator.DefaultRule.add(configurator, "be0125;tea035");
cds.configurator.DefaultRule.add(configurator, "be0125;tea037");
cds.configurator.DefaultRule.add(configurator, "be0125;tea038");
cds.configurator.DefaultRule.add(configurator, "be0125;tea039");
cds.configurator.DefaultRule.add(configurator, "be0125;tea041");
cds.configurator.DefaultRule.add(configurator, "be0125;tea043");
cds.configurator.DefaultRule.add(configurator, "be0125;tea045");
cds.configurator.DefaultRule.add(configurator, "be0125;tea046");
cds.configurator.DefaultRule.add(configurator, "be0125;tea050");
cds.configurator.DefaultRule.add(configurator, "be0125;tea052");
cds.configurator.DefaultRule.add(configurator, "be0125;tea053");
cds.configurator.DefaultRule.add(configurator, "be0125;tea056");
cds.configurator.DefaultRule.add(configurator, "be0125;tea062");
cds.configurator.DefaultRule.add(configurator, "be0125;tea063");
cds.configurator.DefaultRule.add(configurator, "be0125;tea064");
cds.configurator.DefaultRule.add(configurator, "be0125;tea067");
cds.configurator.DefaultRule.add(configurator, "be0125;tea068");
cds.configurator.DefaultRule.add(configurator, "be0125;tea070");
cds.configurator.DefaultRule.add(configurator, "be0125;tea071");
cds.configurator.DefaultRule.add(configurator, "be0125;tea072");
cds.configurator.DefaultRule.add(configurator, "be0125;tea074");
cds.configurator.DefaultRule.add(configurator, "be0125;tea075");
cds.configurator.DefaultRule.add(configurator, "be0125;tea080");
cds.configurator.DefaultRule.add(configurator, "be0125;tea084");
cds.configurator.DefaultRule.add(configurator, "be0125;tea090");
cds.configurator.DefaultRule.add(configurator, "be0125;tea096");
cds.configurator.DefaultRule.add(configurator, "be0125;tea100");
cds.configurator.DefaultRule.add(configurator, "be0125;tea112");
cds.configurator.DefaultRule.add(configurator, "be0125;tea120");
cds.configurator.DefaultRule.add(configurator, "be0125;tea126");
cds.configurator.DefaultRule.add(configurator, "be0125;tea140");
cds.configurator.DefaultRule.add(configurator, "be0125;tea144");
cds.configurator.DefaultRule.add(configurator, "be0125;tea154");
cds.configurator.DefaultRule.add(configurator, "be0125;tea168");
cds.configurator.DefaultRule.add(configurator, "be0125;tea180");
cds.configurator.DefaultRule.add(configurator, "be0125;tea192");
cds.configurator.DefaultRule.add(configurator, "be0125;tea200");
cds.configurator.DefaultRule.add(configurator, "be0125;tea216");
cds.configurator.DefaultRule.add(configurator, "be0125;tea224");
cds.configurator.DefaultRule.add(configurator, "be0125;teb013");
cds.configurator.DefaultRule.add(configurator, "be0125;teb017");
cds.configurator.DefaultRule.add(configurator, "be0125;teb019");
cds.configurator.DefaultRule.add(configurator, "be0125;teb023");
cds.configurator.DefaultRule.add(configurator, "be0125;teb025");
cds.configurator.DefaultRule.add(configurator, "be0125;teb026");
cds.configurator.DefaultRule.add(configurator, "be0125;teb027");
cds.configurator.DefaultRule.add(configurator, "be0125;teb029");
cds.configurator.DefaultRule.add(configurator, "be0125;teb031");
cds.configurator.DefaultRule.add(configurator, "be0125;teb033");
cds.configurator.DefaultRule.add(configurator, "be0125;teb034");
cds.configurator.DefaultRule.add(configurator, "be0125;teb035");
cds.configurator.DefaultRule.add(configurator, "be0125;teb037");
cds.configurator.DefaultRule.add(configurator, "be0125;teb038");
cds.configurator.DefaultRule.add(configurator, "be0125;teb039");
cds.configurator.DefaultRule.add(configurator, "be0125;teb041");
cds.configurator.DefaultRule.add(configurator, "be0125;teb043");
cds.configurator.DefaultRule.add(configurator, "be0125;teb045");
cds.configurator.DefaultRule.add(configurator, "be0125;teb046");
cds.configurator.DefaultRule.add(configurator, "be0125;teb050");
cds.configurator.DefaultRule.add(configurator, "be0125;teb052");
cds.configurator.DefaultRule.add(configurator, "be0125;teb053");
cds.configurator.DefaultRule.add(configurator, "be0125;teb056");
cds.configurator.DefaultRule.add(configurator, "be0125;teb062");
cds.configurator.DefaultRule.add(configurator, "be0125;teb063");
cds.configurator.DefaultRule.add(configurator, "be0125;teb064");
cds.configurator.DefaultRule.add(configurator, "be0125;teb067");
cds.configurator.DefaultRule.add(configurator, "be0125;teb068");
cds.configurator.DefaultRule.add(configurator, "be0125;teb070");
cds.configurator.DefaultRule.add(configurator, "be0125;teb071");
cds.configurator.DefaultRule.add(configurator, "be0125;teb072");
cds.configurator.DefaultRule.add(configurator, "be0125;teb074");
cds.configurator.DefaultRule.add(configurator, "be0125;teb075");
cds.configurator.DefaultRule.add(configurator, "be0125;teb080");
cds.configurator.DefaultRule.add(configurator, "be0125;teb084");
cds.configurator.DefaultRule.add(configurator, "be0125;teb090");
cds.configurator.DefaultRule.add(configurator, "be0125;teb096");
cds.configurator.DefaultRule.add(configurator, "be0125;teb100");
cds.configurator.DefaultRule.add(configurator, "be0125;teb112");
cds.configurator.DefaultRule.add(configurator, "be0125;teb120");
cds.configurator.DefaultRule.add(configurator, "be0125;teb126");
cds.configurator.DefaultRule.add(configurator, "be0125;teb140");
cds.configurator.DefaultRule.add(configurator, "be0125;teb144");
cds.configurator.DefaultRule.add(configurator, "be0125;teb154");
cds.configurator.DefaultRule.add(configurator, "be0125;teb168");
cds.configurator.DefaultRule.add(configurator, "be0125;teb180");
cds.configurator.DefaultRule.add(configurator, "be0125;teb192");
cds.configurator.DefaultRule.add(configurator, "be0125;teb200");
cds.configurator.DefaultRule.add(configurator, "be0125;teb216");
cds.configurator.DefaultRule.add(configurator, "be0125;teb224");
cds.configurator.DefaultRule.add(configurator, "be0236;sehhh");
cds.configurator.DefaultRule.add(configurator, "be0236;selll");
cds.configurator.DefaultRule.add(configurator, "be0236;semxl");
cds.configurator.DefaultRule.add(configurator, "be0236;sexll");
cds.configurator.DefaultRule.add(configurator, "be0236;sma05");
cds.configurator.DefaultRule.add(configurator, "be0236;sma10");
cds.configurator.DefaultRule.add(configurator, "be0236;smh05");
cds.configurator.DefaultRule.add(configurator, "be0236;smh08");
cds.configurator.DefaultRule.add(configurator, "be0236;smt05");
cds.configurator.DefaultRule.add(configurator, "be0236;smt10");
cds.configurator.DefaultRule.add(configurator, "be0236;tea023");
cds.configurator.DefaultRule.add(configurator, "be0236;tea027");
cds.configurator.DefaultRule.add(configurator, "be0236;tea029");
cds.configurator.DefaultRule.add(configurator, "be0236;tea031");
cds.configurator.DefaultRule.add(configurator, "be0236;tea033");
cds.configurator.DefaultRule.add(configurator, "be0236;tea035");
cds.configurator.DefaultRule.add(configurator, "be0236;tea037");
cds.configurator.DefaultRule.add(configurator, "be0236;tea039");
cds.configurator.DefaultRule.add(configurator, "be0236;tea041");
cds.configurator.DefaultRule.add(configurator, "be0236;tea043");
cds.configurator.DefaultRule.add(configurator, "be0236;tea046");
cds.configurator.DefaultRule.add(configurator, "be0236;tea052");
cds.configurator.DefaultRule.add(configurator, "be0236;tea053");
cds.configurator.DefaultRule.add(configurator, "be0236;tea063");
cds.configurator.DefaultRule.add(configurator, "be0236;tea064");
cds.configurator.DefaultRule.add(configurator, "be0236;tea067");
cds.configurator.DefaultRule.add(configurator, "be0236;tea070");
cds.configurator.DefaultRule.add(configurator, "be0236;tea071");
cds.configurator.DefaultRule.add(configurator, "be0236;tea075");
cds.configurator.DefaultRule.add(configurator, "be0236;tea084");
cds.configurator.DefaultRule.add(configurator, "be0236;tea096");
cds.configurator.DefaultRule.add(configurator, "be0236;tea112");
cds.configurator.DefaultRule.add(configurator, "be0236;tea126");
cds.configurator.DefaultRule.add(configurator, "be0236;tea140");
cds.configurator.DefaultRule.add(configurator, "be0236;tea144");
cds.configurator.DefaultRule.add(configurator, "be0236;tea154");
cds.configurator.DefaultRule.add(configurator, "be0236;tea168");
cds.configurator.DefaultRule.add(configurator, "be0236;tea180");
cds.configurator.DefaultRule.add(configurator, "be0236;tea192");
cds.configurator.DefaultRule.add(configurator, "be0236;tea200");
cds.configurator.DefaultRule.add(configurator, "be0236;tea216");
cds.configurator.DefaultRule.add(configurator, "be0236;tea224");
cds.configurator.DefaultRule.add(configurator, "be0236;teb023");
cds.configurator.DefaultRule.add(configurator, "be0236;teb027");
cds.configurator.DefaultRule.add(configurator, "be0236;teb029");
cds.configurator.DefaultRule.add(configurator, "be0236;teb031");
cds.configurator.DefaultRule.add(configurator, "be0236;teb033");
cds.configurator.DefaultRule.add(configurator, "be0236;teb035");
cds.configurator.DefaultRule.add(configurator, "be0236;teb037");
cds.configurator.DefaultRule.add(configurator, "be0236;teb039");
cds.configurator.DefaultRule.add(configurator, "be0236;teb041");
cds.configurator.DefaultRule.add(configurator, "be0236;teb043");
cds.configurator.DefaultRule.add(configurator, "be0236;teb046");
cds.configurator.DefaultRule.add(configurator, "be0236;teb052");
cds.configurator.DefaultRule.add(configurator, "be0236;teb053");
cds.configurator.DefaultRule.add(configurator, "be0236;teb063");
cds.configurator.DefaultRule.add(configurator, "be0236;teb064");
cds.configurator.DefaultRule.add(configurator, "be0236;teb067");
cds.configurator.DefaultRule.add(configurator, "be0236;teb070");
cds.configurator.DefaultRule.add(configurator, "be0236;teb071");
cds.configurator.DefaultRule.add(configurator, "be0236;teb075");
cds.configurator.DefaultRule.add(configurator, "be0236;teb084");
cds.configurator.DefaultRule.add(configurator, "be0236;teb096");
cds.configurator.DefaultRule.add(configurator, "be0236;teb112");
cds.configurator.DefaultRule.add(configurator, "be0236;teb126");
cds.configurator.DefaultRule.add(configurator, "be0236;teb140");
cds.configurator.DefaultRule.add(configurator, "be0236;teb144");
cds.configurator.DefaultRule.add(configurator, "be0236;teb154");
cds.configurator.DefaultRule.add(configurator, "be0236;teb168");
cds.configurator.DefaultRule.add(configurator, "be0236;teb180");
cds.configurator.DefaultRule.add(configurator, "be0236;teb192");
cds.configurator.DefaultRule.add(configurator, "be0236;teb200");
cds.configurator.DefaultRule.add(configurator, "be0236;teb216");
cds.configurator.DefaultRule.add(configurator, "be0236;teb224");
cds.configurator.DefaultRule.add(configurator, "be0250;sehhh");
cds.configurator.DefaultRule.add(configurator, "be0250;selll");
cds.configurator.DefaultRule.add(configurator, "be0250;sma05");
cds.configurator.DefaultRule.add(configurator, "be0250;sma10");
cds.configurator.DefaultRule.add(configurator, "be0250;smh03");
cds.configurator.DefaultRule.add(configurator, "be0250;smh05");
cds.configurator.DefaultRule.add(configurator, "be0250;smh08");
cds.configurator.DefaultRule.add(configurator, "be0250;smt05");
cds.configurator.DefaultRule.add(configurator, "be0250;smt10");
cds.configurator.DefaultRule.add(configurator, "be0250;smt25");
cds.configurator.DefaultRule.add(configurator, "be0250;tea017");
cds.configurator.DefaultRule.add(configurator, "be0250;tea019");
cds.configurator.DefaultRule.add(configurator, "be0250;tea023");
cds.configurator.DefaultRule.add(configurator, "be0250;tea027");
cds.configurator.DefaultRule.add(configurator, "be0250;tea029");
cds.configurator.DefaultRule.add(configurator, "be0250;tea031");
cds.configurator.DefaultRule.add(configurator, "be0250;tea033");
cds.configurator.DefaultRule.add(configurator, "be0250;tea034");
cds.configurator.DefaultRule.add(configurator, "be0250;tea035");
cds.configurator.DefaultRule.add(configurator, "be0250;tea037");
cds.configurator.DefaultRule.add(configurator, "be0250;tea038");
cds.configurator.DefaultRule.add(configurator, "be0250;tea039");
cds.configurator.DefaultRule.add(configurator, "be0250;tea041");
cds.configurator.DefaultRule.add(configurator, "be0250;tea043");
cds.configurator.DefaultRule.add(configurator, "be0250;tea045");
cds.configurator.DefaultRule.add(configurator, "be0250;tea046");
cds.configurator.DefaultRule.add(configurator, "be0250;tea052");
cds.configurator.DefaultRule.add(configurator, "be0250;tea053");
cds.configurator.DefaultRule.add(configurator, "be0250;tea056");
cds.configurator.DefaultRule.add(configurator, "be0250;tea062");
cds.configurator.DefaultRule.add(configurator, "be0250;tea063");
cds.configurator.DefaultRule.add(configurator, "be0250;tea064");
cds.configurator.DefaultRule.add(configurator, "be0250;tea067");
cds.configurator.DefaultRule.add(configurator, "be0250;tea068");
cds.configurator.DefaultRule.add(configurator, "be0250;tea070");
cds.configurator.DefaultRule.add(configurator, "be0250;tea071");
cds.configurator.DefaultRule.add(configurator, "be0250;tea074");
cds.configurator.DefaultRule.add(configurator, "be0250;tea075");
cds.configurator.DefaultRule.add(configurator, "be0250;tea084");
cds.configurator.DefaultRule.add(configurator, "be0250;tea096");
cds.configurator.DefaultRule.add(configurator, "be0250;tea112");
cds.configurator.DefaultRule.add(configurator, "be0250;tea126");
cds.configurator.DefaultRule.add(configurator, "be0250;tea140");
cds.configurator.DefaultRule.add(configurator, "be0250;tea144");
cds.configurator.DefaultRule.add(configurator, "be0250;tea154");
cds.configurator.DefaultRule.add(configurator, "be0250;tea168");
cds.configurator.DefaultRule.add(configurator, "be0250;tea180");
cds.configurator.DefaultRule.add(configurator, "be0250;tea192");
cds.configurator.DefaultRule.add(configurator, "be0250;tea200");
cds.configurator.DefaultRule.add(configurator, "be0250;tea216");
cds.configurator.DefaultRule.add(configurator, "be0250;tea224");
cds.configurator.DefaultRule.add(configurator, "be0250;teb017");
cds.configurator.DefaultRule.add(configurator, "be0250;teb019");
cds.configurator.DefaultRule.add(configurator, "be0250;teb023");
cds.configurator.DefaultRule.add(configurator, "be0250;teb027");
cds.configurator.DefaultRule.add(configurator, "be0250;teb029");
cds.configurator.DefaultRule.add(configurator, "be0250;teb031");
cds.configurator.DefaultRule.add(configurator, "be0250;teb033");
cds.configurator.DefaultRule.add(configurator, "be0250;teb034");
cds.configurator.DefaultRule.add(configurator, "be0250;teb035");
cds.configurator.DefaultRule.add(configurator, "be0250;teb037");
cds.configurator.DefaultRule.add(configurator, "be0250;teb038");
cds.configurator.DefaultRule.add(configurator, "be0250;teb039");
cds.configurator.DefaultRule.add(configurator, "be0250;teb041");
cds.configurator.DefaultRule.add(configurator, "be0250;teb043");
cds.configurator.DefaultRule.add(configurator, "be0250;teb045");
cds.configurator.DefaultRule.add(configurator, "be0250;teb046");
cds.configurator.DefaultRule.add(configurator, "be0250;teb052");
cds.configurator.DefaultRule.add(configurator, "be0250;teb053");
cds.configurator.DefaultRule.add(configurator, "be0250;teb056");
cds.configurator.DefaultRule.add(configurator, "be0250;teb062");
cds.configurator.DefaultRule.add(configurator, "be0250;teb063");
cds.configurator.DefaultRule.add(configurator, "be0250;teb064");
cds.configurator.DefaultRule.add(configurator, "be0250;teb067");
cds.configurator.DefaultRule.add(configurator, "be0250;teb068");
cds.configurator.DefaultRule.add(configurator, "be0250;teb070");
cds.configurator.DefaultRule.add(configurator, "be0250;teb071");
cds.configurator.DefaultRule.add(configurator, "be0250;teb074");
cds.configurator.DefaultRule.add(configurator, "be0250;teb075");
cds.configurator.DefaultRule.add(configurator, "be0250;teb084");
cds.configurator.DefaultRule.add(configurator, "be0250;teb096");
cds.configurator.DefaultRule.add(configurator, "be0250;teb112");
cds.configurator.DefaultRule.add(configurator, "be0250;teb126");
cds.configurator.DefaultRule.add(configurator, "be0250;teb140");
cds.configurator.DefaultRule.add(configurator, "be0250;teb144");
cds.configurator.DefaultRule.add(configurator, "be0250;teb154");
cds.configurator.DefaultRule.add(configurator, "be0250;teb168");
cds.configurator.DefaultRule.add(configurator, "be0250;teb180");
cds.configurator.DefaultRule.add(configurator, "be0250;teb192");
cds.configurator.DefaultRule.add(configurator, "be0250;teb200");
cds.configurator.DefaultRule.add(configurator, "be0250;teb216");
cds.configurator.DefaultRule.add(configurator, "be0250;teb224");
cds.configurator.DefaultRule.add(configurator, "be0354;sehhh");
cds.configurator.DefaultRule.add(configurator, "be0354;selll");
cds.configurator.DefaultRule.add(configurator, "be0354;semxl");
cds.configurator.DefaultRule.add(configurator, "be0354;sexll");
cds.configurator.DefaultRule.add(configurator, "be0354;sma05");
cds.configurator.DefaultRule.add(configurator, "be0354;sma10");
cds.configurator.DefaultRule.add(configurator, "be0354;smh08");
cds.configurator.DefaultRule.add(configurator, "be0354;smt05");
cds.configurator.DefaultRule.add(configurator, "be0354;smt10");
cds.configurator.DefaultRule.add(configurator, "be0354;smt25");
cds.configurator.DefaultRule.add(configurator, "be0354;tea023");
cds.configurator.DefaultRule.add(configurator, "be0354;tea027");
cds.configurator.DefaultRule.add(configurator, "be0354;tea029");
cds.configurator.DefaultRule.add(configurator, "be0354;tea031");
cds.configurator.DefaultRule.add(configurator, "be0354;tea033");
cds.configurator.DefaultRule.add(configurator, "be0354;tea035");
cds.configurator.DefaultRule.add(configurator, "be0354;tea037");
cds.configurator.DefaultRule.add(configurator, "be0354;tea039");
cds.configurator.DefaultRule.add(configurator, "be0354;tea041");
cds.configurator.DefaultRule.add(configurator, "be0354;tea043");
cds.configurator.DefaultRule.add(configurator, "be0354;tea046");
cds.configurator.DefaultRule.add(configurator, "be0354;tea052");
cds.configurator.DefaultRule.add(configurator, "be0354;tea053");
cds.configurator.DefaultRule.add(configurator, "be0354;tea063");
cds.configurator.DefaultRule.add(configurator, "be0354;tea064");
cds.configurator.DefaultRule.add(configurator, "be0354;tea067");
cds.configurator.DefaultRule.add(configurator, "be0354;tea071");
cds.configurator.DefaultRule.add(configurator, "be0354;tea075");
cds.configurator.DefaultRule.add(configurator, "be0354;tea084");
cds.configurator.DefaultRule.add(configurator, "be0354;tea096");
cds.configurator.DefaultRule.add(configurator, "be0354;tea112");
cds.configurator.DefaultRule.add(configurator, "be0354;tea126");
cds.configurator.DefaultRule.add(configurator, "be0354;tea140");
cds.configurator.DefaultRule.add(configurator, "be0354;tea144");
cds.configurator.DefaultRule.add(configurator, "be0354;tea154");
cds.configurator.DefaultRule.add(configurator, "be0354;tea168");
cds.configurator.DefaultRule.add(configurator, "be0354;tea180");
cds.configurator.DefaultRule.add(configurator, "be0354;tea192");
cds.configurator.DefaultRule.add(configurator, "be0354;tea200");
cds.configurator.DefaultRule.add(configurator, "be0354;tea216");
cds.configurator.DefaultRule.add(configurator, "be0354;tea224");
cds.configurator.DefaultRule.add(configurator, "be0354;teb023");
cds.configurator.DefaultRule.add(configurator, "be0354;teb027");
cds.configurator.DefaultRule.add(configurator, "be0354;teb029");
cds.configurator.DefaultRule.add(configurator, "be0354;teb031");
cds.configurator.DefaultRule.add(configurator, "be0354;teb033");
cds.configurator.DefaultRule.add(configurator, "be0354;teb035");
cds.configurator.DefaultRule.add(configurator, "be0354;teb037");
cds.configurator.DefaultRule.add(configurator, "be0354;teb039");
cds.configurator.DefaultRule.add(configurator, "be0354;teb041");
cds.configurator.DefaultRule.add(configurator, "be0354;teb043");
cds.configurator.DefaultRule.add(configurator, "be0354;teb046");
cds.configurator.DefaultRule.add(configurator, "be0354;teb052");
cds.configurator.DefaultRule.add(configurator, "be0354;teb053");
cds.configurator.DefaultRule.add(configurator, "be0354;teb063");
cds.configurator.DefaultRule.add(configurator, "be0354;teb064");
cds.configurator.DefaultRule.add(configurator, "be0354;teb067");
cds.configurator.DefaultRule.add(configurator, "be0354;teb071");
cds.configurator.DefaultRule.add(configurator, "be0354;teb075");
cds.configurator.DefaultRule.add(configurator, "be0354;teb084");
cds.configurator.DefaultRule.add(configurator, "be0354;teb096");
cds.configurator.DefaultRule.add(configurator, "be0354;teb112");
cds.configurator.DefaultRule.add(configurator, "be0354;teb126");
cds.configurator.DefaultRule.add(configurator, "be0354;teb140");
cds.configurator.DefaultRule.add(configurator, "be0354;teb144");
cds.configurator.DefaultRule.add(configurator, "be0354;teb154");
cds.configurator.DefaultRule.add(configurator, "be0354;teb168");
cds.configurator.DefaultRule.add(configurator, "be0354;teb180");
cds.configurator.DefaultRule.add(configurator, "be0354;teb192");
cds.configurator.DefaultRule.add(configurator, "be0354;teb200");
cds.configurator.DefaultRule.add(configurator, "be0354;teb216");
cds.configurator.DefaultRule.add(configurator, "be0354;teb224");
cds.configurator.DefaultRule.add(configurator, "be0375;sehhh");
cds.configurator.DefaultRule.add(configurator, "be0375;selll");
cds.configurator.DefaultRule.add(configurator, "be0375;sma05");
cds.configurator.DefaultRule.add(configurator, "be0375;sma10");
cds.configurator.DefaultRule.add(configurator, "be0375;smh03");
cds.configurator.DefaultRule.add(configurator, "be0375;smh05");
cds.configurator.DefaultRule.add(configurator, "be0375;smh08");
cds.configurator.DefaultRule.add(configurator, "be0375;smt05");
cds.configurator.DefaultRule.add(configurator, "be0375;smt10");
cds.configurator.DefaultRule.add(configurator, "be0375;smt25");
cds.configurator.DefaultRule.add(configurator, "be0375;tea027");
cds.configurator.DefaultRule.add(configurator, "be0375;tea029");
cds.configurator.DefaultRule.add(configurator, "be0375;tea031");
cds.configurator.DefaultRule.add(configurator, "be0375;tea033");
cds.configurator.DefaultRule.add(configurator, "be0375;tea034");
cds.configurator.DefaultRule.add(configurator, "be0375;tea035");
cds.configurator.DefaultRule.add(configurator, "be0375;tea037");
cds.configurator.DefaultRule.add(configurator, "be0375;tea038");
cds.configurator.DefaultRule.add(configurator, "be0375;tea039");
cds.configurator.DefaultRule.add(configurator, "be0375;tea041");
cds.configurator.DefaultRule.add(configurator, "be0375;tea043");
cds.configurator.DefaultRule.add(configurator, "be0375;tea045");
cds.configurator.DefaultRule.add(configurator, "be0375;tea046");
cds.configurator.DefaultRule.add(configurator, "be0375;tea052");
cds.configurator.DefaultRule.add(configurator, "be0375;tea053");
cds.configurator.DefaultRule.add(configurator, "be0375;tea056");
cds.configurator.DefaultRule.add(configurator, "be0375;tea062");
cds.configurator.DefaultRule.add(configurator, "be0375;tea063");
cds.configurator.DefaultRule.add(configurator, "be0375;tea064");
cds.configurator.DefaultRule.add(configurator, "be0375;tea067");
cds.configurator.DefaultRule.add(configurator, "be0375;tea068");
cds.configurator.DefaultRule.add(configurator, "be0375;tea070");
cds.configurator.DefaultRule.add(configurator, "be0375;tea071");
cds.configurator.DefaultRule.add(configurator, "be0375;tea074");
cds.configurator.DefaultRule.add(configurator, "be0375;tea075");
cds.configurator.DefaultRule.add(configurator, "be0375;tea084");
cds.configurator.DefaultRule.add(configurator, "be0375;tea096");
cds.configurator.DefaultRule.add(configurator, "be0375;tea112");
cds.configurator.DefaultRule.add(configurator, "be0375;tea126");
cds.configurator.DefaultRule.add(configurator, "be0375;tea140");
cds.configurator.DefaultRule.add(configurator, "be0375;tea144");
cds.configurator.DefaultRule.add(configurator, "be0375;tea154");
cds.configurator.DefaultRule.add(configurator, "be0375;tea168");
cds.configurator.DefaultRule.add(configurator, "be0375;tea180");
cds.configurator.DefaultRule.add(configurator, "be0375;tea192");
cds.configurator.DefaultRule.add(configurator, "be0375;tea200");
cds.configurator.DefaultRule.add(configurator, "be0375;tea216");
cds.configurator.DefaultRule.add(configurator, "be0375;tea224");
cds.configurator.DefaultRule.add(configurator, "be0375;teb027");
cds.configurator.DefaultRule.add(configurator, "be0375;teb029");
cds.configurator.DefaultRule.add(configurator, "be0375;teb031");
cds.configurator.DefaultRule.add(configurator, "be0375;teb033");
cds.configurator.DefaultRule.add(configurator, "be0375;teb034");
cds.configurator.DefaultRule.add(configurator, "be0375;teb035");
cds.configurator.DefaultRule.add(configurator, "be0375;teb037");
cds.configurator.DefaultRule.add(configurator, "be0375;teb038");
cds.configurator.DefaultRule.add(configurator, "be0375;teb039");
cds.configurator.DefaultRule.add(configurator, "be0375;teb041");
cds.configurator.DefaultRule.add(configurator, "be0375;teb043");
cds.configurator.DefaultRule.add(configurator, "be0375;teb045");
cds.configurator.DefaultRule.add(configurator, "be0375;teb046");
cds.configurator.DefaultRule.add(configurator, "be0375;teb052");
cds.configurator.DefaultRule.add(configurator, "be0375;teb053");
cds.configurator.DefaultRule.add(configurator, "be0375;teb056");
cds.configurator.DefaultRule.add(configurator, "be0375;teb062");
cds.configurator.DefaultRule.add(configurator, "be0375;teb063");
cds.configurator.DefaultRule.add(configurator, "be0375;teb064");
cds.configurator.DefaultRule.add(configurator, "be0375;teb067");
cds.configurator.DefaultRule.add(configurator, "be0375;teb068");
cds.configurator.DefaultRule.add(configurator, "be0375;teb070");
cds.configurator.DefaultRule.add(configurator, "be0375;teb071");
cds.configurator.DefaultRule.add(configurator, "be0375;teb074");
cds.configurator.DefaultRule.add(configurator, "be0375;teb075");
cds.configurator.DefaultRule.add(configurator, "be0375;teb084");
cds.configurator.DefaultRule.add(configurator, "be0375;teb096");
cds.configurator.DefaultRule.add(configurator, "be0375;teb112");
cds.configurator.DefaultRule.add(configurator, "be0375;teb126");
cds.configurator.DefaultRule.add(configurator, "be0375;teb140");
cds.configurator.DefaultRule.add(configurator, "be0375;teb144");
cds.configurator.DefaultRule.add(configurator, "be0375;teb154");
cds.configurator.DefaultRule.add(configurator, "be0375;teb168");
cds.configurator.DefaultRule.add(configurator, "be0375;teb180");
cds.configurator.DefaultRule.add(configurator, "be0375;teb192");
cds.configurator.DefaultRule.add(configurator, "be0375;teb200");
cds.configurator.DefaultRule.add(configurator, "be0375;teb216");
cds.configurator.DefaultRule.add(configurator, "be0375;teb224");
cds.configurator.DefaultRule.add(configurator, "be0394;sehhh");
cds.configurator.DefaultRule.add(configurator, "be0394;selll");
cds.configurator.DefaultRule.add(configurator, "be0394;semxl");
cds.configurator.DefaultRule.add(configurator, "be0394;sexll");
cds.configurator.DefaultRule.add(configurator, "be0394;sma10");
cds.configurator.DefaultRule.add(configurator, "be0394;smh03");
cds.configurator.DefaultRule.add(configurator, "be0394;smh05");
cds.configurator.DefaultRule.add(configurator, "be0394;smh08");
cds.configurator.DefaultRule.add(configurator, "be0394;smt10");
cds.configurator.DefaultRule.add(configurator, "be0394;smt25");
cds.configurator.DefaultRule.add(configurator, "be0394;tea011");
cds.configurator.DefaultRule.add(configurator, "be0394;tea013");
cds.configurator.DefaultRule.add(configurator, "be0394;tea017");
cds.configurator.DefaultRule.add(configurator, "be0394;tea021");
cds.configurator.DefaultRule.add(configurator, "be0394;tea023");
cds.configurator.DefaultRule.add(configurator, "be0394;tea028");
cds.configurator.DefaultRule.add(configurator, "be0394;tea029");
cds.configurator.DefaultRule.add(configurator, "be0394;tea031");
cds.configurator.DefaultRule.add(configurator, "be0394;tea033");
cds.configurator.DefaultRule.add(configurator, "be0394;tea034");
cds.configurator.DefaultRule.add(configurator, "be0394;tea035");
cds.configurator.DefaultRule.add(configurator, "be0394;tea037");
cds.configurator.DefaultRule.add(configurator, "be0394;tea038");
cds.configurator.DefaultRule.add(configurator, "be0394;tea039");
cds.configurator.DefaultRule.add(configurator, "be0394;tea041");
cds.configurator.DefaultRule.add(configurator, "be0394;tea042");
cds.configurator.DefaultRule.add(configurator, "be0394;tea043");
cds.configurator.DefaultRule.add(configurator, "be0394;tea045");
cds.configurator.DefaultRule.add(configurator, "be0394;tea046");
cds.configurator.DefaultRule.add(configurator, "be0394;tea050");
cds.configurator.DefaultRule.add(configurator, "be0394;tea052");
cds.configurator.DefaultRule.add(configurator, "be0394;tea053");
cds.configurator.DefaultRule.add(configurator, "be0394;tea056");
cds.configurator.DefaultRule.add(configurator, "be0394;tea062");
cds.configurator.DefaultRule.add(configurator, "be0394;tea063");
cds.configurator.DefaultRule.add(configurator, "be0394;tea064");
cds.configurator.DefaultRule.add(configurator, "be0394;tea067");
cds.configurator.DefaultRule.add(configurator, "be0394;tea068");
cds.configurator.DefaultRule.add(configurator, "be0394;tea070");
cds.configurator.DefaultRule.add(configurator, "be0394;tea071");
cds.configurator.DefaultRule.add(configurator, "be0394;tea072");
cds.configurator.DefaultRule.add(configurator, "be0394;tea074");
cds.configurator.DefaultRule.add(configurator, "be0394;tea075");
cds.configurator.DefaultRule.add(configurator, "be0394;tea080");
cds.configurator.DefaultRule.add(configurator, "be0394;tea084");
cds.configurator.DefaultRule.add(configurator, "be0394;tea090");
cds.configurator.DefaultRule.add(configurator, "be0394;tea096");
cds.configurator.DefaultRule.add(configurator, "be0394;tea100");
cds.configurator.DefaultRule.add(configurator, "be0394;tea112");
cds.configurator.DefaultRule.add(configurator, "be0394;tea120");
cds.configurator.DefaultRule.add(configurator, "be0394;tea126");
cds.configurator.DefaultRule.add(configurator, "be0394;tea140");
cds.configurator.DefaultRule.add(configurator, "be0394;tea144");
cds.configurator.DefaultRule.add(configurator, "be0394;tea154");
cds.configurator.DefaultRule.add(configurator, "be0394;tea168");
cds.configurator.DefaultRule.add(configurator, "be0394;tea180");
cds.configurator.DefaultRule.add(configurator, "be0394;tea192");
cds.configurator.DefaultRule.add(configurator, "be0394;tea200");
cds.configurator.DefaultRule.add(configurator, "be0394;tea216");
cds.configurator.DefaultRule.add(configurator, "be0394;tea224");
cds.configurator.DefaultRule.add(configurator, "be0394;teb011");
cds.configurator.DefaultRule.add(configurator, "be0394;teb013");
cds.configurator.DefaultRule.add(configurator, "be0394;teb017");
cds.configurator.DefaultRule.add(configurator, "be0394;teb021");
cds.configurator.DefaultRule.add(configurator, "be0394;teb023");
cds.configurator.DefaultRule.add(configurator, "be0394;teb028");
cds.configurator.DefaultRule.add(configurator, "be0394;teb029");
cds.configurator.DefaultRule.add(configurator, "be0394;teb031");
cds.configurator.DefaultRule.add(configurator, "be0394;teb033");
cds.configurator.DefaultRule.add(configurator, "be0394;teb034");
cds.configurator.DefaultRule.add(configurator, "be0394;teb035");
cds.configurator.DefaultRule.add(configurator, "be0394;teb037");
cds.configurator.DefaultRule.add(configurator, "be0394;teb038");
cds.configurator.DefaultRule.add(configurator, "be0394;teb039");
cds.configurator.DefaultRule.add(configurator, "be0394;teb041");
cds.configurator.DefaultRule.add(configurator, "be0394;teb042");
cds.configurator.DefaultRule.add(configurator, "be0394;teb043");
cds.configurator.DefaultRule.add(configurator, "be0394;teb045");
cds.configurator.DefaultRule.add(configurator, "be0394;teb046");
cds.configurator.DefaultRule.add(configurator, "be0394;teb050");
cds.configurator.DefaultRule.add(configurator, "be0394;teb052");
cds.configurator.DefaultRule.add(configurator, "be0394;teb053");
cds.configurator.DefaultRule.add(configurator, "be0394;teb056");
cds.configurator.DefaultRule.add(configurator, "be0394;teb062");
cds.configurator.DefaultRule.add(configurator, "be0394;teb063");
cds.configurator.DefaultRule.add(configurator, "be0394;teb064");
cds.configurator.DefaultRule.add(configurator, "be0394;teb067");
cds.configurator.DefaultRule.add(configurator, "be0394;teb068");
cds.configurator.DefaultRule.add(configurator, "be0394;teb070");
cds.configurator.DefaultRule.add(configurator, "be0394;teb071");
cds.configurator.DefaultRule.add(configurator, "be0394;teb072");
cds.configurator.DefaultRule.add(configurator, "be0394;teb074");
cds.configurator.DefaultRule.add(configurator, "be0394;teb075");
cds.configurator.DefaultRule.add(configurator, "be0394;teb080");
cds.configurator.DefaultRule.add(configurator, "be0394;teb084");
cds.configurator.DefaultRule.add(configurator, "be0394;teb090");
cds.configurator.DefaultRule.add(configurator, "be0394;teb096");
cds.configurator.DefaultRule.add(configurator, "be0394;teb100");
cds.configurator.DefaultRule.add(configurator, "be0394;teb112");
cds.configurator.DefaultRule.add(configurator, "be0394;teb120");
cds.configurator.DefaultRule.add(configurator, "be0394;teb126");
cds.configurator.DefaultRule.add(configurator, "be0394;teb140");
cds.configurator.DefaultRule.add(configurator, "be0394;teb144");
cds.configurator.DefaultRule.add(configurator, "be0394;teb154");
cds.configurator.DefaultRule.add(configurator, "be0394;teb168");
cds.configurator.DefaultRule.add(configurator, "be0394;teb180");
cds.configurator.DefaultRule.add(configurator, "be0394;teb192");
cds.configurator.DefaultRule.add(configurator, "be0394;teb200");
cds.configurator.DefaultRule.add(configurator, "be0394;teb216");
cds.configurator.DefaultRule.add(configurator, "be0394;teb224");
cds.configurator.DefaultRule.add(configurator, "be4528;sehhh");
cds.configurator.DefaultRule.add(configurator, "be4528;selll");
cds.configurator.DefaultRule.add(configurator, "be4528;semxl");
cds.configurator.DefaultRule.add(configurator, "be4528;sexll");
cds.configurator.DefaultRule.add(configurator, "be4528;sma05");
cds.configurator.DefaultRule.add(configurator, "be4528;sma10");
cds.configurator.DefaultRule.add(configurator, "be4528;smh03");
cds.configurator.DefaultRule.add(configurator, "be4528;smh05");
cds.configurator.DefaultRule.add(configurator, "be4528;smh08");
cds.configurator.DefaultRule.add(configurator, "be4528;smt05");
cds.configurator.DefaultRule.add(configurator, "be4528;smt10");
cds.configurator.DefaultRule.add(configurator, "be4528;smt25");
cds.configurator.DefaultRule.add(configurator, "be4528;tea010");
cds.configurator.DefaultRule.add(configurator, "be4528;tea011");
cds.configurator.DefaultRule.add(configurator, "be4528;tea012");
cds.configurator.DefaultRule.add(configurator, "be4528;tea013");
cds.configurator.DefaultRule.add(configurator, "be4528;tea014");
cds.configurator.DefaultRule.add(configurator, "be4528;tea015");
cds.configurator.DefaultRule.add(configurator, "be4528;tea016");
cds.configurator.DefaultRule.add(configurator, "be4528;tea017");
cds.configurator.DefaultRule.add(configurator, "be4528;tea018");
cds.configurator.DefaultRule.add(configurator, "be4528;tea019");
cds.configurator.DefaultRule.add(configurator, "be4528;tea020");
cds.configurator.DefaultRule.add(configurator, "be4528;tea021");
cds.configurator.DefaultRule.add(configurator, "be4528;tea022");
cds.configurator.DefaultRule.add(configurator, "be4528;tea023");
cds.configurator.DefaultRule.add(configurator, "be4528;tea024");
cds.configurator.DefaultRule.add(configurator, "be4528;tea025");
cds.configurator.DefaultRule.add(configurator, "be4528;tea026");
cds.configurator.DefaultRule.add(configurator, "be4528;tea027");
cds.configurator.DefaultRule.add(configurator, "be4528;tea031");
cds.configurator.DefaultRule.add(configurator, "be4528;tea033");
cds.configurator.DefaultRule.add(configurator, "be4528;tea035");
cds.configurator.DefaultRule.add(configurator, "be4528;tea037");
cds.configurator.DefaultRule.add(configurator, "be4528;tea039");
cds.configurator.DefaultRule.add(configurator, "be4528;tea041");
cds.configurator.DefaultRule.add(configurator, "be4528;tea042");
cds.configurator.DefaultRule.add(configurator, "be4528;tea043");
cds.configurator.DefaultRule.add(configurator, "be4528;tea045");
cds.configurator.DefaultRule.add(configurator, "be4528;tea046");
cds.configurator.DefaultRule.add(configurator, "be4528;tea050");
cds.configurator.DefaultRule.add(configurator, "be4528;tea053");
cds.configurator.DefaultRule.add(configurator, "be4528;tea062");
cds.configurator.DefaultRule.add(configurator, "be4528;tea063");
cds.configurator.DefaultRule.add(configurator, "be4528;tea067");
cds.configurator.DefaultRule.add(configurator, "be4528;tea070");
cds.configurator.DefaultRule.add(configurator, "be4528;tea071");
cds.configurator.DefaultRule.add(configurator, "be4528;tea074");
cds.configurator.DefaultRule.add(configurator, "be4528;tea075");
cds.configurator.DefaultRule.add(configurator, "be4528;tea084");
cds.configurator.DefaultRule.add(configurator, "be4528;tea096");
cds.configurator.DefaultRule.add(configurator, "be4528;tea100");
cds.configurator.DefaultRule.add(configurator, "be4528;tea120");
cds.configurator.DefaultRule.add(configurator, "be4528;tea126");
cds.configurator.DefaultRule.add(configurator, "be4528;tea140");
cds.configurator.DefaultRule.add(configurator, "be4528;tea154");
cds.configurator.DefaultRule.add(configurator, "be4528;tea180");
cds.configurator.DefaultRule.add(configurator, "be4528;tea200");
cds.configurator.DefaultRule.add(configurator, "be4528;tea224");
cds.configurator.DefaultRule.add(configurator, "be4528;teb010");
cds.configurator.DefaultRule.add(configurator, "be4528;teb011");
cds.configurator.DefaultRule.add(configurator, "be4528;teb012");
cds.configurator.DefaultRule.add(configurator, "be4528;teb013");
cds.configurator.DefaultRule.add(configurator, "be4528;teb014");
cds.configurator.DefaultRule.add(configurator, "be4528;teb015");
cds.configurator.DefaultRule.add(configurator, "be4528;teb016");
cds.configurator.DefaultRule.add(configurator, "be4528;teb017");
cds.configurator.DefaultRule.add(configurator, "be4528;teb018");
cds.configurator.DefaultRule.add(configurator, "be4528;teb019");
cds.configurator.DefaultRule.add(configurator, "be4528;teb020");
cds.configurator.DefaultRule.add(configurator, "be4528;teb021");
cds.configurator.DefaultRule.add(configurator, "be4528;teb022");
cds.configurator.DefaultRule.add(configurator, "be4528;teb023");
cds.configurator.DefaultRule.add(configurator, "be4528;teb024");
cds.configurator.DefaultRule.add(configurator, "be4528;teb025");
cds.configurator.DefaultRule.add(configurator, "be4528;teb026");
cds.configurator.DefaultRule.add(configurator, "be4528;teb027");
cds.configurator.DefaultRule.add(configurator, "be4528;teb031");
cds.configurator.DefaultRule.add(configurator, "be4528;teb033");
cds.configurator.DefaultRule.add(configurator, "be4528;teb035");
cds.configurator.DefaultRule.add(configurator, "be4528;teb037");
cds.configurator.DefaultRule.add(configurator, "be4528;teb039");
cds.configurator.DefaultRule.add(configurator, "be4528;teb041");
cds.configurator.DefaultRule.add(configurator, "be4528;teb042");
cds.configurator.DefaultRule.add(configurator, "be4528;teb043");
cds.configurator.DefaultRule.add(configurator, "be4528;teb045");
cds.configurator.DefaultRule.add(configurator, "be4528;teb046");
cds.configurator.DefaultRule.add(configurator, "be4528;teb050");
cds.configurator.DefaultRule.add(configurator, "be4528;teb053");
cds.configurator.DefaultRule.add(configurator, "be4528;teb062");
cds.configurator.DefaultRule.add(configurator, "be4528;teb063");
cds.configurator.DefaultRule.add(configurator, "be4528;teb067");
cds.configurator.DefaultRule.add(configurator, "be4528;teb070");
cds.configurator.DefaultRule.add(configurator, "be4528;teb071");
cds.configurator.DefaultRule.add(configurator, "be4528;teb074");
cds.configurator.DefaultRule.add(configurator, "be4528;teb075");
cds.configurator.DefaultRule.add(configurator, "be4528;teb084");
cds.configurator.DefaultRule.add(configurator, "be4528;teb096");
cds.configurator.DefaultRule.add(configurator, "be4528;teb100");
cds.configurator.DefaultRule.add(configurator, "be4528;teb120");
cds.configurator.DefaultRule.add(configurator, "be4528;teb126");
cds.configurator.DefaultRule.add(configurator, "be4528;teb140");
cds.configurator.DefaultRule.add(configurator, "be4528;teb154");
cds.configurator.DefaultRule.add(configurator, "be4528;teb180");
cds.configurator.DefaultRule.add(configurator, "be4528;teb200");
cds.configurator.DefaultRule.add(configurator, "be4528;teb224");
cds.configurator.DefaultRule.add(configurator, "be0472;sehhh");
cds.configurator.DefaultRule.add(configurator, "be0472;selll");
cds.configurator.DefaultRule.add(configurator, "be0472;semxl");
cds.configurator.DefaultRule.add(configurator, "be0472;sexll");
cds.configurator.DefaultRule.add(configurator, "be0472;sma05");
cds.configurator.DefaultRule.add(configurator, "be0472;sma10");
cds.configurator.DefaultRule.add(configurator, "be0472;smh03");
cds.configurator.DefaultRule.add(configurator, "be0472;smh05");
cds.configurator.DefaultRule.add(configurator, "be0472;smh08");
cds.configurator.DefaultRule.add(configurator, "be0472;smt05");
cds.configurator.DefaultRule.add(configurator, "be0472;smt10");
cds.configurator.DefaultRule.add(configurator, "be0472;smt25");
cds.configurator.DefaultRule.add(configurator, "be0472;tea010");
cds.configurator.DefaultRule.add(configurator, "be0472;tea011");
cds.configurator.DefaultRule.add(configurator, "be0472;tea012");
cds.configurator.DefaultRule.add(configurator, "be0472;tea013");
cds.configurator.DefaultRule.add(configurator, "be0472;tea014");
cds.configurator.DefaultRule.add(configurator, "be0472;tea015");
cds.configurator.DefaultRule.add(configurator, "be0472;tea016");
cds.configurator.DefaultRule.add(configurator, "be0472;tea017");
cds.configurator.DefaultRule.add(configurator, "be0472;tea018");
cds.configurator.DefaultRule.add(configurator, "be0472;tea019");
cds.configurator.DefaultRule.add(configurator, "be0472;tea020");
cds.configurator.DefaultRule.add(configurator, "be0472;tea021");
cds.configurator.DefaultRule.add(configurator, "be0472;tea023");
cds.configurator.DefaultRule.add(configurator, "be0472;tea024");
cds.configurator.DefaultRule.add(configurator, "be0472;tea035");
cds.configurator.DefaultRule.add(configurator, "be0472;tea043");
cds.configurator.DefaultRule.add(configurator, "be0472;tea044");
cds.configurator.DefaultRule.add(configurator, "be0472;tea046");
cds.configurator.DefaultRule.add(configurator, "be0472;tea052");
cds.configurator.DefaultRule.add(configurator, "be0472;tea062");
cds.configurator.DefaultRule.add(configurator, "be0472;tea064");
cds.configurator.DefaultRule.add(configurator, "be0472;tea068");
cds.configurator.DefaultRule.add(configurator, "be0472;tea070");
cds.configurator.DefaultRule.add(configurator, "be0472;tea072");
cds.configurator.DefaultRule.add(configurator, "be0472;tea074");
cds.configurator.DefaultRule.add(configurator, "be0472;tea084");
cds.configurator.DefaultRule.add(configurator, "be0472;tea096");
cds.configurator.DefaultRule.add(configurator, "be0472;tea100");
cds.configurator.DefaultRule.add(configurator, "be0472;tea120");
cds.configurator.DefaultRule.add(configurator, "be0472;tea126");
cds.configurator.DefaultRule.add(configurator, "be0472;tea144");
cds.configurator.DefaultRule.add(configurator, "be0472;tea154");
cds.configurator.DefaultRule.add(configurator, "be0472;tea168");
cds.configurator.DefaultRule.add(configurator, "be0472;tea192");
cds.configurator.DefaultRule.add(configurator, "be0472;tea200");
cds.configurator.DefaultRule.add(configurator, "be0472;tea216");
cds.configurator.DefaultRule.add(configurator, "be0472;teb010");
cds.configurator.DefaultRule.add(configurator, "be0472;teb011");
cds.configurator.DefaultRule.add(configurator, "be0472;teb012");
cds.configurator.DefaultRule.add(configurator, "be0472;teb013");
cds.configurator.DefaultRule.add(configurator, "be0472;teb014");
cds.configurator.DefaultRule.add(configurator, "be0472;teb015");
cds.configurator.DefaultRule.add(configurator, "be0472;teb016");
cds.configurator.DefaultRule.add(configurator, "be0472;teb017");
cds.configurator.DefaultRule.add(configurator, "be0472;teb018");
cds.configurator.DefaultRule.add(configurator, "be0472;teb019");
cds.configurator.DefaultRule.add(configurator, "be0472;teb020");
cds.configurator.DefaultRule.add(configurator, "be0472;teb021");
cds.configurator.DefaultRule.add(configurator, "be0472;teb023");
cds.configurator.DefaultRule.add(configurator, "be0472;teb024");
cds.configurator.DefaultRule.add(configurator, "be0472;teb035");
cds.configurator.DefaultRule.add(configurator, "be0472;teb043");
cds.configurator.DefaultRule.add(configurator, "be0472;teb044");
cds.configurator.DefaultRule.add(configurator, "be0472;teb046");
cds.configurator.DefaultRule.add(configurator, "be0472;teb052");
cds.configurator.DefaultRule.add(configurator, "be0472;teb062");
cds.configurator.DefaultRule.add(configurator, "be0472;teb064");
cds.configurator.DefaultRule.add(configurator, "be0472;teb068");
cds.configurator.DefaultRule.add(configurator, "be0472;teb070");
cds.configurator.DefaultRule.add(configurator, "be0472;teb072");
cds.configurator.DefaultRule.add(configurator, "be0472;teb074");
cds.configurator.DefaultRule.add(configurator, "be0472;teb084");
cds.configurator.DefaultRule.add(configurator, "be0472;teb096");
cds.configurator.DefaultRule.add(configurator, "be0472;teb100");
cds.configurator.DefaultRule.add(configurator, "be0472;teb120");
cds.configurator.DefaultRule.add(configurator, "be0472;teb126");
cds.configurator.DefaultRule.add(configurator, "be0472;teb144");
cds.configurator.DefaultRule.add(configurator, "be0472;teb154");
cds.configurator.DefaultRule.add(configurator, "be0472;teb168");
cds.configurator.DefaultRule.add(configurator, "be0472;teb192");
cds.configurator.DefaultRule.add(configurator, "be0472;teb200");
cds.configurator.DefaultRule.add(configurator, "be0472;teb216");
cds.configurator.DefaultRule.add(configurator, "be4921;sehhh");
cds.configurator.DefaultRule.add(configurator, "be4921;selll");
cds.configurator.DefaultRule.add(configurator, "be4921;semxl");
cds.configurator.DefaultRule.add(configurator, "be4921;sexll");
cds.configurator.DefaultRule.add(configurator, "be4921;sma05");
cds.configurator.DefaultRule.add(configurator, "be4921;sma10");
cds.configurator.DefaultRule.add(configurator, "be4921;smh03");
cds.configurator.DefaultRule.add(configurator, "be4921;smh05");
cds.configurator.DefaultRule.add(configurator, "be4921;smh08");
cds.configurator.DefaultRule.add(configurator, "be4921;smt05");
cds.configurator.DefaultRule.add(configurator, "be4921;smt10");
cds.configurator.DefaultRule.add(configurator, "be4921;smt25");
cds.configurator.DefaultRule.add(configurator, "be4921;tea010");
cds.configurator.DefaultRule.add(configurator, "be4921;tea011");
cds.configurator.DefaultRule.add(configurator, "be4921;tea012");
cds.configurator.DefaultRule.add(configurator, "be4921;tea013");
cds.configurator.DefaultRule.add(configurator, "be4921;tea014");
cds.configurator.DefaultRule.add(configurator, "be4921;tea015");
cds.configurator.DefaultRule.add(configurator, "be4921;tea016");
cds.configurator.DefaultRule.add(configurator, "be4921;tea017");
cds.configurator.DefaultRule.add(configurator, "be4921;tea018");
cds.configurator.DefaultRule.add(configurator, "be4921;tea019");
cds.configurator.DefaultRule.add(configurator, "be4921;tea020");
cds.configurator.DefaultRule.add(configurator, "be4921;tea021");
cds.configurator.DefaultRule.add(configurator, "be4921;tea022");
cds.configurator.DefaultRule.add(configurator, "be4921;tea023");
cds.configurator.DefaultRule.add(configurator, "be4921;tea024");
cds.configurator.DefaultRule.add(configurator, "be4921;tea025");
cds.configurator.DefaultRule.add(configurator, "be4921;tea026");
cds.configurator.DefaultRule.add(configurator, "be4921;tea027");
cds.configurator.DefaultRule.add(configurator, "be4921;tea041");
cds.configurator.DefaultRule.add(configurator, "be4921;tea042");
cds.configurator.DefaultRule.add(configurator, "be4921;tea044");
cds.configurator.DefaultRule.add(configurator, "be4921;tea046");
cds.configurator.DefaultRule.add(configurator, "be4921;tea052");
cds.configurator.DefaultRule.add(configurator, "be4921;tea062");
cds.configurator.DefaultRule.add(configurator, "be4921;tea064");
cds.configurator.DefaultRule.add(configurator, "be4921;tea068");
cds.configurator.DefaultRule.add(configurator, "be4921;tea070");
cds.configurator.DefaultRule.add(configurator, "be4921;tea072");
cds.configurator.DefaultRule.add(configurator, "be4921;tea074");
cds.configurator.DefaultRule.add(configurator, "be4921;tea084");
cds.configurator.DefaultRule.add(configurator, "be4921;tea096");
cds.configurator.DefaultRule.add(configurator, "be4921;tea100");
cds.configurator.DefaultRule.add(configurator, "be4921;tea120");
cds.configurator.DefaultRule.add(configurator, "be4921;tea126");
cds.configurator.DefaultRule.add(configurator, "be4921;tea144");
cds.configurator.DefaultRule.add(configurator, "be4921;tea154");
cds.configurator.DefaultRule.add(configurator, "be4921;tea192");
cds.configurator.DefaultRule.add(configurator, "be4921;tea216");
cds.configurator.DefaultRule.add(configurator, "be4921;teb010");
cds.configurator.DefaultRule.add(configurator, "be4921;teb011");
cds.configurator.DefaultRule.add(configurator, "be4921;teb012");
cds.configurator.DefaultRule.add(configurator, "be4921;teb013");
cds.configurator.DefaultRule.add(configurator, "be4921;teb014");
cds.configurator.DefaultRule.add(configurator, "be4921;teb015");
cds.configurator.DefaultRule.add(configurator, "be4921;teb016");
cds.configurator.DefaultRule.add(configurator, "be4921;teb017");
cds.configurator.DefaultRule.add(configurator, "be4921;teb018");
cds.configurator.DefaultRule.add(configurator, "be4921;teb019");
cds.configurator.DefaultRule.add(configurator, "be4921;teb020");
cds.configurator.DefaultRule.add(configurator, "be4921;teb021");
cds.configurator.DefaultRule.add(configurator, "be4921;teb022");
cds.configurator.DefaultRule.add(configurator, "be4921;teb023");
cds.configurator.DefaultRule.add(configurator, "be4921;teb024");
cds.configurator.DefaultRule.add(configurator, "be4921;teb025");
cds.configurator.DefaultRule.add(configurator, "be4921;teb026");
cds.configurator.DefaultRule.add(configurator, "be4921;teb027");
cds.configurator.DefaultRule.add(configurator, "be4921;teb041");
cds.configurator.DefaultRule.add(configurator, "be4921;teb042");
cds.configurator.DefaultRule.add(configurator, "be4921;teb044");
cds.configurator.DefaultRule.add(configurator, "be4921;teb046");
cds.configurator.DefaultRule.add(configurator, "be4921;teb052");
cds.configurator.DefaultRule.add(configurator, "be4921;teb062");
cds.configurator.DefaultRule.add(configurator, "be4921;teb064");
cds.configurator.DefaultRule.add(configurator, "be4921;teb068");
cds.configurator.DefaultRule.add(configurator, "be4921;teb070");
cds.configurator.DefaultRule.add(configurator, "be4921;teb072");
cds.configurator.DefaultRule.add(configurator, "be4921;teb074");
cds.configurator.DefaultRule.add(configurator, "be4921;teb084");
cds.configurator.DefaultRule.add(configurator, "be4921;teb096");
cds.configurator.DefaultRule.add(configurator, "be4921;teb100");
cds.configurator.DefaultRule.add(configurator, "be4921;teb120");
cds.configurator.DefaultRule.add(configurator, "be4921;teb126");
cds.configurator.DefaultRule.add(configurator, "be4921;teb144");
cds.configurator.DefaultRule.add(configurator, "be4921;teb154");
cds.configurator.DefaultRule.add(configurator, "be4921;teb192");
cds.configurator.DefaultRule.add(configurator, "be4921;teb216");
cds.configurator.DefaultRule.add(configurator, "be0500;sehhh");
cds.configurator.DefaultRule.add(configurator, "be0500;semxl");
cds.configurator.DefaultRule.add(configurator, "be0500;sexll");
cds.configurator.DefaultRule.add(configurator, "be0500;sma05");
cds.configurator.DefaultRule.add(configurator, "be0500;sma10");
cds.configurator.DefaultRule.add(configurator, "be0500;smh03");
cds.configurator.DefaultRule.add(configurator, "be0500;smh05");
cds.configurator.DefaultRule.add(configurator, "be0500;smh08");
cds.configurator.DefaultRule.add(configurator, "be0500;smt05");
cds.configurator.DefaultRule.add(configurator, "be0500;smt10");
cds.configurator.DefaultRule.add(configurator, "be0500;smt25");
cds.configurator.DefaultRule.add(configurator, "be0500;tea011");
cds.configurator.DefaultRule.add(configurator, "be0500;tea023");
cds.configurator.DefaultRule.add(configurator, "be0500;tea025");
cds.configurator.DefaultRule.add(configurator, "be0500;tea027");
cds.configurator.DefaultRule.add(configurator, "be0500;tea029");
cds.configurator.DefaultRule.add(configurator, "be0500;tea031");
cds.configurator.DefaultRule.add(configurator, "be0500;tea033");
cds.configurator.DefaultRule.add(configurator, "be0500;tea034");
cds.configurator.DefaultRule.add(configurator, "be0500;tea035");
cds.configurator.DefaultRule.add(configurator, "be0500;tea037");
cds.configurator.DefaultRule.add(configurator, "be0500;tea038");
cds.configurator.DefaultRule.add(configurator, "be0500;tea039");
cds.configurator.DefaultRule.add(configurator, "be0500;tea041");
cds.configurator.DefaultRule.add(configurator, "be0500;tea042");
cds.configurator.DefaultRule.add(configurator, "be0500;tea043");
cds.configurator.DefaultRule.add(configurator, "be0500;tea045");
cds.configurator.DefaultRule.add(configurator, "be0500;tea046");
cds.configurator.DefaultRule.add(configurator, "be0500;tea050");
cds.configurator.DefaultRule.add(configurator, "be0500;tea052");
cds.configurator.DefaultRule.add(configurator, "be0500;tea053");
cds.configurator.DefaultRule.add(configurator, "be0500;tea056");
cds.configurator.DefaultRule.add(configurator, "be0500;tea062");
cds.configurator.DefaultRule.add(configurator, "be0500;tea063");
cds.configurator.DefaultRule.add(configurator, "be0500;tea064");
cds.configurator.DefaultRule.add(configurator, "be0500;tea067");
cds.configurator.DefaultRule.add(configurator, "be0500;tea068");
cds.configurator.DefaultRule.add(configurator, "be0500;tea070");
cds.configurator.DefaultRule.add(configurator, "be0500;tea071");
cds.configurator.DefaultRule.add(configurator, "be0500;tea074");
cds.configurator.DefaultRule.add(configurator, "be0500;tea075");
cds.configurator.DefaultRule.add(configurator, "be0500;tea080");
cds.configurator.DefaultRule.add(configurator, "be0500;tea090");
cds.configurator.DefaultRule.add(configurator, "be0500;tea100");
cds.configurator.DefaultRule.add(configurator, "be0500;tea112");
cds.configurator.DefaultRule.add(configurator, "be0500;tea126");
cds.configurator.DefaultRule.add(configurator, "be0500;tea140");
cds.configurator.DefaultRule.add(configurator, "be0500;tea144");
cds.configurator.DefaultRule.add(configurator, "be0500;tea154");
cds.configurator.DefaultRule.add(configurator, "be0500;tea168");
cds.configurator.DefaultRule.add(configurator, "be0500;tea180");
cds.configurator.DefaultRule.add(configurator, "be0500;tea192");
cds.configurator.DefaultRule.add(configurator, "be0500;tea200");
cds.configurator.DefaultRule.add(configurator, "be0500;tea216");
cds.configurator.DefaultRule.add(configurator, "be0500;tea224");
cds.configurator.DefaultRule.add(configurator, "be0500;teb011");
cds.configurator.DefaultRule.add(configurator, "be0500;teb023");
cds.configurator.DefaultRule.add(configurator, "be0500;teb025");
cds.configurator.DefaultRule.add(configurator, "be0500;teb027");
cds.configurator.DefaultRule.add(configurator, "be0500;teb029");
cds.configurator.DefaultRule.add(configurator, "be0500;teb031");
cds.configurator.DefaultRule.add(configurator, "be0500;teb033");
cds.configurator.DefaultRule.add(configurator, "be0500;teb034");
cds.configurator.DefaultRule.add(configurator, "be0500;teb035");
cds.configurator.DefaultRule.add(configurator, "be0500;teb037");
cds.configurator.DefaultRule.add(configurator, "be0500;teb038");
cds.configurator.DefaultRule.add(configurator, "be0500;teb039");
cds.configurator.DefaultRule.add(configurator, "be0500;teb041");
cds.configurator.DefaultRule.add(configurator, "be0500;teb042");
cds.configurator.DefaultRule.add(configurator, "be0500;teb043");
cds.configurator.DefaultRule.add(configurator, "be0500;teb045");
cds.configurator.DefaultRule.add(configurator, "be0500;teb046");
cds.configurator.DefaultRule.add(configurator, "be0500;teb050");
cds.configurator.DefaultRule.add(configurator, "be0500;teb052");
cds.configurator.DefaultRule.add(configurator, "be0500;teb053");
cds.configurator.DefaultRule.add(configurator, "be0500;teb056");
cds.configurator.DefaultRule.add(configurator, "be0500;teb062");
cds.configurator.DefaultRule.add(configurator, "be0500;teb063");
cds.configurator.DefaultRule.add(configurator, "be0500;teb064");
cds.configurator.DefaultRule.add(configurator, "be0500;teb067");
cds.configurator.DefaultRule.add(configurator, "be0500;teb068");
cds.configurator.DefaultRule.add(configurator, "be0500;teb070");
cds.configurator.DefaultRule.add(configurator, "be0500;teb071");
cds.configurator.DefaultRule.add(configurator, "be0500;teb074");
cds.configurator.DefaultRule.add(configurator, "be0500;teb075");
cds.configurator.DefaultRule.add(configurator, "be0500;teb080");
cds.configurator.DefaultRule.add(configurator, "be0500;teb090");
cds.configurator.DefaultRule.add(configurator, "be0500;teb100");
cds.configurator.DefaultRule.add(configurator, "be0500;teb112");
cds.configurator.DefaultRule.add(configurator, "be0500;teb126");
cds.configurator.DefaultRule.add(configurator, "be0500;teb140");
cds.configurator.DefaultRule.add(configurator, "be0500;teb144");
cds.configurator.DefaultRule.add(configurator, "be0500;teb154");
cds.configurator.DefaultRule.add(configurator, "be0500;teb168");
cds.configurator.DefaultRule.add(configurator, "be0500;teb180");
cds.configurator.DefaultRule.add(configurator, "be0500;teb192");
cds.configurator.DefaultRule.add(configurator, "be0500;teb200");
cds.configurator.DefaultRule.add(configurator, "be0500;teb216");
cds.configurator.DefaultRule.add(configurator, "be0500;teb224");
cds.configurator.DefaultRule.add(configurator, "be0590;sehhh");
cds.configurator.DefaultRule.add(configurator, "be0590;selll");
cds.configurator.DefaultRule.add(configurator, "be0590;semxl");
cds.configurator.DefaultRule.add(configurator, "be0590;sexll");
cds.configurator.DefaultRule.add(configurator, "be0590;sma05");
cds.configurator.DefaultRule.add(configurator, "be0590;sma10");
cds.configurator.DefaultRule.add(configurator, "be0590;smh03");
cds.configurator.DefaultRule.add(configurator, "be0590;smh08");
cds.configurator.DefaultRule.add(configurator, "be0590;smt05");
cds.configurator.DefaultRule.add(configurator, "be0590;smt10");
cds.configurator.DefaultRule.add(configurator, "be0590;smt25");
cds.configurator.DefaultRule.add(configurator, "be0590;tea010");
cds.configurator.DefaultRule.add(configurator, "be0590;tea011");
cds.configurator.DefaultRule.add(configurator, "be0590;tea027");
cds.configurator.DefaultRule.add(configurator, "be0590;tea029");
cds.configurator.DefaultRule.add(configurator, "be0590;tea031");
cds.configurator.DefaultRule.add(configurator, "be0590;tea033");
cds.configurator.DefaultRule.add(configurator, "be0590;tea035");
cds.configurator.DefaultRule.add(configurator, "be0590;tea037");
cds.configurator.DefaultRule.add(configurator, "be0590;tea039");
cds.configurator.DefaultRule.add(configurator, "be0590;tea041");
cds.configurator.DefaultRule.add(configurator, "be0590;tea042");
cds.configurator.DefaultRule.add(configurator, "be0590;tea043");
cds.configurator.DefaultRule.add(configurator, "be0590;tea046");
cds.configurator.DefaultRule.add(configurator, "be0590;tea053");
cds.configurator.DefaultRule.add(configurator, "be0590;tea063");
cds.configurator.DefaultRule.add(configurator, "be0590;tea067");
cds.configurator.DefaultRule.add(configurator, "be0590;tea071");
cds.configurator.DefaultRule.add(configurator, "be0590;tea075");
cds.configurator.DefaultRule.add(configurator, "be0590;tea084");
cds.configurator.DefaultRule.add(configurator, "be0590;tea096");
cds.configurator.DefaultRule.add(configurator, "be0590;tea126");
cds.configurator.DefaultRule.add(configurator, "be0590;tea140");
cds.configurator.DefaultRule.add(configurator, "be0590;tea144");
cds.configurator.DefaultRule.add(configurator, "be0590;tea154");
cds.configurator.DefaultRule.add(configurator, "be0590;tea168");
cds.configurator.DefaultRule.add(configurator, "be0590;tea180");
cds.configurator.DefaultRule.add(configurator, "be0590;tea192");
cds.configurator.DefaultRule.add(configurator, "be0590;tea200");
cds.configurator.DefaultRule.add(configurator, "be0590;tea216");
cds.configurator.DefaultRule.add(configurator, "be0590;tea224");
cds.configurator.DefaultRule.add(configurator, "be0590;teb010");
cds.configurator.DefaultRule.add(configurator, "be0590;teb011");
cds.configurator.DefaultRule.add(configurator, "be0590;teb027");
cds.configurator.DefaultRule.add(configurator, "be0590;teb029");
cds.configurator.DefaultRule.add(configurator, "be0590;teb031");
cds.configurator.DefaultRule.add(configurator, "be0590;teb033");
cds.configurator.DefaultRule.add(configurator, "be0590;teb035");
cds.configurator.DefaultRule.add(configurator, "be0590;teb037");
cds.configurator.DefaultRule.add(configurator, "be0590;teb039");
cds.configurator.DefaultRule.add(configurator, "be0590;teb041");
cds.configurator.DefaultRule.add(configurator, "be0590;teb042");
cds.configurator.DefaultRule.add(configurator, "be0590;teb043");
cds.configurator.DefaultRule.add(configurator, "be0590;teb046");
cds.configurator.DefaultRule.add(configurator, "be0590;teb053");
cds.configurator.DefaultRule.add(configurator, "be0590;teb063");
cds.configurator.DefaultRule.add(configurator, "be0590;teb067");
cds.configurator.DefaultRule.add(configurator, "be0590;teb071");
cds.configurator.DefaultRule.add(configurator, "be0590;teb075");
cds.configurator.DefaultRule.add(configurator, "be0590;teb084");
cds.configurator.DefaultRule.add(configurator, "be0590;teb096");
cds.configurator.DefaultRule.add(configurator, "be0590;teb126");
cds.configurator.DefaultRule.add(configurator, "be0590;teb140");
cds.configurator.DefaultRule.add(configurator, "be0590;teb144");
cds.configurator.DefaultRule.add(configurator, "be0590;teb154");
cds.configurator.DefaultRule.add(configurator, "be0590;teb168");
cds.configurator.DefaultRule.add(configurator, "be0590;teb180");
cds.configurator.DefaultRule.add(configurator, "be0590;teb192");
cds.configurator.DefaultRule.add(configurator, "be0590;teb200");
cds.configurator.DefaultRule.add(configurator, "be0590;teb216");
cds.configurator.DefaultRule.add(configurator, "be0590;teb224");
cds.configurator.DefaultRule.add(configurator, "be0630;sehhh");
cds.configurator.DefaultRule.add(configurator, "be0630;selll");
cds.configurator.DefaultRule.add(configurator, "be0630;semxl");
cds.configurator.DefaultRule.add(configurator, "be0630;sexll");
cds.configurator.DefaultRule.add(configurator, "be0630;smh03");
cds.configurator.DefaultRule.add(configurator, "be0630;smh05");
cds.configurator.DefaultRule.add(configurator, "be0630;smh08");
cds.configurator.DefaultRule.add(configurator, "be0630;smt25");
cds.configurator.DefaultRule.add(configurator, "be0630;tea011");
cds.configurator.DefaultRule.add(configurator, "be0630;tea013");
cds.configurator.DefaultRule.add(configurator, "be0630;tea017");
cds.configurator.DefaultRule.add(configurator, "be0630;tea021");
cds.configurator.DefaultRule.add(configurator, "be0630;tea023");
cds.configurator.DefaultRule.add(configurator, "be0630;tea028");
cds.configurator.DefaultRule.add(configurator, "be0630;tea029");
cds.configurator.DefaultRule.add(configurator, "be0630;tea031");
cds.configurator.DefaultRule.add(configurator, "be0630;tea033");
cds.configurator.DefaultRule.add(configurator, "be0630;tea034");
cds.configurator.DefaultRule.add(configurator, "be0630;tea035");
cds.configurator.DefaultRule.add(configurator, "be0630;tea037");
cds.configurator.DefaultRule.add(configurator, "be0630;tea038");
cds.configurator.DefaultRule.add(configurator, "be0630;tea039");
cds.configurator.DefaultRule.add(configurator, "be0630;tea041");
cds.configurator.DefaultRule.add(configurator, "be0630;tea042");
cds.configurator.DefaultRule.add(configurator, "be0630;tea043");
cds.configurator.DefaultRule.add(configurator, "be0630;tea045");
cds.configurator.DefaultRule.add(configurator, "be0630;tea046");
cds.configurator.DefaultRule.add(configurator, "be0630;tea050");
cds.configurator.DefaultRule.add(configurator, "be0630;tea052");
cds.configurator.DefaultRule.add(configurator, "be0630;tea053");
cds.configurator.DefaultRule.add(configurator, "be0630;tea056");
cds.configurator.DefaultRule.add(configurator, "be0630;tea062");
cds.configurator.DefaultRule.add(configurator, "be0630;tea063");
cds.configurator.DefaultRule.add(configurator, "be0630;tea064");
cds.configurator.DefaultRule.add(configurator, "be0630;tea067");
cds.configurator.DefaultRule.add(configurator, "be0630;tea068");
cds.configurator.DefaultRule.add(configurator, "be0630;tea070");
cds.configurator.DefaultRule.add(configurator, "be0630;tea071");
cds.configurator.DefaultRule.add(configurator, "be0630;tea072");
cds.configurator.DefaultRule.add(configurator, "be0630;tea074");
cds.configurator.DefaultRule.add(configurator, "be0630;tea075");
cds.configurator.DefaultRule.add(configurator, "be0630;tea080");
cds.configurator.DefaultRule.add(configurator, "be0630;tea084");
cds.configurator.DefaultRule.add(configurator, "be0630;tea090");
cds.configurator.DefaultRule.add(configurator, "be0630;tea096");
cds.configurator.DefaultRule.add(configurator, "be0630;tea100");
cds.configurator.DefaultRule.add(configurator, "be0630;tea112");
cds.configurator.DefaultRule.add(configurator, "be0630;tea120");
cds.configurator.DefaultRule.add(configurator, "be0630;tea126");
cds.configurator.DefaultRule.add(configurator, "be0630;tea140");
cds.configurator.DefaultRule.add(configurator, "be0630;tea144");
cds.configurator.DefaultRule.add(configurator, "be0630;tea154");
cds.configurator.DefaultRule.add(configurator, "be0630;tea168");
cds.configurator.DefaultRule.add(configurator, "be0630;tea180");
cds.configurator.DefaultRule.add(configurator, "be0630;tea192");
cds.configurator.DefaultRule.add(configurator, "be0630;tea200");
cds.configurator.DefaultRule.add(configurator, "be0630;tea216");
cds.configurator.DefaultRule.add(configurator, "be0630;tea224");
cds.configurator.DefaultRule.add(configurator, "be0630;teb011");
cds.configurator.DefaultRule.add(configurator, "be0630;teb013");
cds.configurator.DefaultRule.add(configurator, "be0630;teb017");
cds.configurator.DefaultRule.add(configurator, "be0630;teb021");
cds.configurator.DefaultRule.add(configurator, "be0630;teb023");
cds.configurator.DefaultRule.add(configurator, "be0630;teb028");
cds.configurator.DefaultRule.add(configurator, "be0630;teb029");
cds.configurator.DefaultRule.add(configurator, "be0630;teb031");
cds.configurator.DefaultRule.add(configurator, "be0630;teb033");
cds.configurator.DefaultRule.add(configurator, "be0630;teb034");
cds.configurator.DefaultRule.add(configurator, "be0630;teb035");
cds.configurator.DefaultRule.add(configurator, "be0630;teb037");
cds.configurator.DefaultRule.add(configurator, "be0630;teb038");
cds.configurator.DefaultRule.add(configurator, "be0630;teb039");
cds.configurator.DefaultRule.add(configurator, "be0630;teb041");
cds.configurator.DefaultRule.add(configurator, "be0630;teb042");
cds.configurator.DefaultRule.add(configurator, "be0630;teb043");
cds.configurator.DefaultRule.add(configurator, "be0630;teb045");
cds.configurator.DefaultRule.add(configurator, "be0630;teb046");
cds.configurator.DefaultRule.add(configurator, "be0630;teb050");
cds.configurator.DefaultRule.add(configurator, "be0630;teb052");
cds.configurator.DefaultRule.add(configurator, "be0630;teb053");
cds.configurator.DefaultRule.add(configurator, "be0630;teb056");
cds.configurator.DefaultRule.add(configurator, "be0630;teb062");
cds.configurator.DefaultRule.add(configurator, "be0630;teb063");
cds.configurator.DefaultRule.add(configurator, "be0630;teb064");
cds.configurator.DefaultRule.add(configurator, "be0630;teb067");
cds.configurator.DefaultRule.add(configurator, "be0630;teb068");
cds.configurator.DefaultRule.add(configurator, "be0630;teb070");
cds.configurator.DefaultRule.add(configurator, "be0630;teb071");
cds.configurator.DefaultRule.add(configurator, "be0630;teb072");
cds.configurator.DefaultRule.add(configurator, "be0630;teb074");
cds.configurator.DefaultRule.add(configurator, "be0630;teb075");
cds.configurator.DefaultRule.add(configurator, "be0630;teb080");
cds.configurator.DefaultRule.add(configurator, "be0630;teb084");
cds.configurator.DefaultRule.add(configurator, "be0630;teb090");
cds.configurator.DefaultRule.add(configurator, "be0630;teb096");
cds.configurator.DefaultRule.add(configurator, "be0630;teb100");
cds.configurator.DefaultRule.add(configurator, "be0630;teb112");
cds.configurator.DefaultRule.add(configurator, "be0630;teb120");
cds.configurator.DefaultRule.add(configurator, "be0630;teb126");
cds.configurator.DefaultRule.add(configurator, "be0630;teb140");
cds.configurator.DefaultRule.add(configurator, "be0630;teb144");
cds.configurator.DefaultRule.add(configurator, "be0630;teb154");
cds.configurator.DefaultRule.add(configurator, "be0630;teb168");
cds.configurator.DefaultRule.add(configurator, "be0630;teb180");
cds.configurator.DefaultRule.add(configurator, "be0630;teb192");
cds.configurator.DefaultRule.add(configurator, "be0630;teb200");
cds.configurator.DefaultRule.add(configurator, "be0630;teb216");
cds.configurator.DefaultRule.add(configurator, "be0630;teb224");
cds.configurator.DefaultRule.add(configurator, "be6693;sehhh");
cds.configurator.DefaultRule.add(configurator, "be6693;selll");
cds.configurator.DefaultRule.add(configurator, "be6693;semxl");
cds.configurator.DefaultRule.add(configurator, "be6693;sexll");
cds.configurator.DefaultRule.add(configurator, "be6693;sma05");
cds.configurator.DefaultRule.add(configurator, "be6693;sma10");
cds.configurator.DefaultRule.add(configurator, "be6693;smh03");
cds.configurator.DefaultRule.add(configurator, "be6693;smh05");
cds.configurator.DefaultRule.add(configurator, "be6693;smh08");
cds.configurator.DefaultRule.add(configurator, "be6693;smt05");
cds.configurator.DefaultRule.add(configurator, "be6693;smt10");
cds.configurator.DefaultRule.add(configurator, "be6693;smt25");
cds.configurator.DefaultRule.add(configurator, "be6693;tea010");
cds.configurator.DefaultRule.add(configurator, "be6693;tea011");
cds.configurator.DefaultRule.add(configurator, "be6693;tea012");
cds.configurator.DefaultRule.add(configurator, "be6693;tea013");
cds.configurator.DefaultRule.add(configurator, "be6693;tea014");
cds.configurator.DefaultRule.add(configurator, "be6693;tea015");
cds.configurator.DefaultRule.add(configurator, "be6693;tea016");
cds.configurator.DefaultRule.add(configurator, "be6693;tea017");
cds.configurator.DefaultRule.add(configurator, "be6693;tea018");
cds.configurator.DefaultRule.add(configurator, "be6693;tea019");
cds.configurator.DefaultRule.add(configurator, "be6693;tea020");
cds.configurator.DefaultRule.add(configurator, "be6693;tea021");
cds.configurator.DefaultRule.add(configurator, "be6693;tea022");
cds.configurator.DefaultRule.add(configurator, "be6693;tea023");
cds.configurator.DefaultRule.add(configurator, "be6693;tea024");
cds.configurator.DefaultRule.add(configurator, "be6693;tea025");
cds.configurator.DefaultRule.add(configurator, "be6693;tea026");
cds.configurator.DefaultRule.add(configurator, "be6693;tea027");
cds.configurator.DefaultRule.add(configurator, "be6693;tea028");
cds.configurator.DefaultRule.add(configurator, "be6693;tea029");
cds.configurator.DefaultRule.add(configurator, "be6693;tea030");
cds.configurator.DefaultRule.add(configurator, "be6693;tea031");
cds.configurator.DefaultRule.add(configurator, "be6693;tea032");
cds.configurator.DefaultRule.add(configurator, "be6693;tea033");
cds.configurator.DefaultRule.add(configurator, "be6693;tea034");
cds.configurator.DefaultRule.add(configurator, "be6693;tea035");
cds.configurator.DefaultRule.add(configurator, "be6693;tea037");
cds.configurator.DefaultRule.add(configurator, "be6693;tea039");
cds.configurator.DefaultRule.add(configurator, "be6693;tea041");
cds.configurator.DefaultRule.add(configurator, "be6693;tea042");
cds.configurator.DefaultRule.add(configurator, "be6693;tea043");
cds.configurator.DefaultRule.add(configurator, "be6693;tea045");
cds.configurator.DefaultRule.add(configurator, "be6693;tea046");
cds.configurator.DefaultRule.add(configurator, "be6693;tea050");
cds.configurator.DefaultRule.add(configurator, "be6693;tea053");
cds.configurator.DefaultRule.add(configurator, "be6693;tea062");
cds.configurator.DefaultRule.add(configurator, "be6693;tea063");
cds.configurator.DefaultRule.add(configurator, "be6693;tea067");
cds.configurator.DefaultRule.add(configurator, "be6693;tea070");
cds.configurator.DefaultRule.add(configurator, "be6693;tea071");
cds.configurator.DefaultRule.add(configurator, "be6693;tea074");
cds.configurator.DefaultRule.add(configurator, "be6693;tea075");
cds.configurator.DefaultRule.add(configurator, "be6693;tea084");
cds.configurator.DefaultRule.add(configurator, "be6693;tea096");
cds.configurator.DefaultRule.add(configurator, "be6693;tea100");
cds.configurator.DefaultRule.add(configurator, "be6693;tea120");
cds.configurator.DefaultRule.add(configurator, "be6693;tea126");
cds.configurator.DefaultRule.add(configurator, "be6693;tea140");
cds.configurator.DefaultRule.add(configurator, "be6693;tea154");
cds.configurator.DefaultRule.add(configurator, "be6693;tea180");
cds.configurator.DefaultRule.add(configurator, "be6693;tea200");
cds.configurator.DefaultRule.add(configurator, "be6693;tea224");
cds.configurator.DefaultRule.add(configurator, "be6693;teb010");
cds.configurator.DefaultRule.add(configurator, "be6693;teb011");
cds.configurator.DefaultRule.add(configurator, "be6693;teb012");
cds.configurator.DefaultRule.add(configurator, "be6693;teb013");
cds.configurator.DefaultRule.add(configurator, "be6693;teb014");
cds.configurator.DefaultRule.add(configurator, "be6693;teb015");
cds.configurator.DefaultRule.add(configurator, "be6693;teb016");
cds.configurator.DefaultRule.add(configurator, "be6693;teb017");
cds.configurator.DefaultRule.add(configurator, "be6693;teb018");
cds.configurator.DefaultRule.add(configurator, "be6693;teb019");
cds.configurator.DefaultRule.add(configurator, "be6693;teb020");
cds.configurator.DefaultRule.add(configurator, "be6693;teb021");
cds.configurator.DefaultRule.add(configurator, "be6693;teb022");
cds.configurator.DefaultRule.add(configurator, "be6693;teb023");
cds.configurator.DefaultRule.add(configurator, "be6693;teb024");
cds.configurator.DefaultRule.add(configurator, "be6693;teb025");
cds.configurator.DefaultRule.add(configurator, "be6693;teb026");
cds.configurator.DefaultRule.add(configurator, "be6693;teb027");
cds.configurator.DefaultRule.add(configurator, "be6693;teb028");
cds.configurator.DefaultRule.add(configurator, "be6693;teb029");
cds.configurator.DefaultRule.add(configurator, "be6693;teb030");
cds.configurator.DefaultRule.add(configurator, "be6693;teb031");
cds.configurator.DefaultRule.add(configurator, "be6693;teb032");
cds.configurator.DefaultRule.add(configurator, "be6693;teb033");
cds.configurator.DefaultRule.add(configurator, "be6693;teb034");
cds.configurator.DefaultRule.add(configurator, "be6693;teb035");
cds.configurator.DefaultRule.add(configurator, "be6693;teb037");
cds.configurator.DefaultRule.add(configurator, "be6693;teb039");
cds.configurator.DefaultRule.add(configurator, "be6693;teb041");
cds.configurator.DefaultRule.add(configurator, "be6693;teb042");
cds.configurator.DefaultRule.add(configurator, "be6693;teb043");
cds.configurator.DefaultRule.add(configurator, "be6693;teb045");
cds.configurator.DefaultRule.add(configurator, "be6693;teb046");
cds.configurator.DefaultRule.add(configurator, "be6693;teb050");
cds.configurator.DefaultRule.add(configurator, "be6693;teb053");
cds.configurator.DefaultRule.add(configurator, "be6693;teb062");
cds.configurator.DefaultRule.add(configurator, "be6693;teb063");
cds.configurator.DefaultRule.add(configurator, "be6693;teb067");
cds.configurator.DefaultRule.add(configurator, "be6693;teb070");
cds.configurator.DefaultRule.add(configurator, "be6693;teb071");
cds.configurator.DefaultRule.add(configurator, "be6693;teb074");
cds.configurator.DefaultRule.add(configurator, "be6693;teb075");
cds.configurator.DefaultRule.add(configurator, "be6693;teb084");
cds.configurator.DefaultRule.add(configurator, "be6693;teb096");
cds.configurator.DefaultRule.add(configurator, "be6693;teb100");
cds.configurator.DefaultRule.add(configurator, "be6693;teb120");
cds.configurator.DefaultRule.add(configurator, "be6693;teb126");
cds.configurator.DefaultRule.add(configurator, "be6693;teb140");
cds.configurator.DefaultRule.add(configurator, "be6693;teb154");
cds.configurator.DefaultRule.add(configurator, "be6693;teb180");
cds.configurator.DefaultRule.add(configurator, "be6693;teb200");
cds.configurator.DefaultRule.add(configurator, "be6693;teb224");
cds.configurator.DefaultRule.add(configurator, "be0750;sehhh");
cds.configurator.DefaultRule.add(configurator, "be0750;semxl");
cds.configurator.DefaultRule.add(configurator, "be0750;sexll");
cds.configurator.DefaultRule.add(configurator, "be0750;sma05");
cds.configurator.DefaultRule.add(configurator, "be0750;sma10");
cds.configurator.DefaultRule.add(configurator, "be0750;smh03");
cds.configurator.DefaultRule.add(configurator, "be0750;smh05");
cds.configurator.DefaultRule.add(configurator, "be0750;smh08");
cds.configurator.DefaultRule.add(configurator, "be0750;smt05");
cds.configurator.DefaultRule.add(configurator, "be0750;smt10");
cds.configurator.DefaultRule.add(configurator, "be0750;smt25");
cds.configurator.DefaultRule.add(configurator, "be0750;tea010");
cds.configurator.DefaultRule.add(configurator, "be0750;tea011");
cds.configurator.DefaultRule.add(configurator, "be0750;tea023");
cds.configurator.DefaultRule.add(configurator, "be0750;tea025");
cds.configurator.DefaultRule.add(configurator, "be0750;tea027");
cds.configurator.DefaultRule.add(configurator, "be0750;tea029");
cds.configurator.DefaultRule.add(configurator, "be0750;tea031");
cds.configurator.DefaultRule.add(configurator, "be0750;tea033");
cds.configurator.DefaultRule.add(configurator, "be0750;tea034");
cds.configurator.DefaultRule.add(configurator, "be0750;tea035");
cds.configurator.DefaultRule.add(configurator, "be0750;tea037");
cds.configurator.DefaultRule.add(configurator, "be0750;tea038");
cds.configurator.DefaultRule.add(configurator, "be0750;tea039");
cds.configurator.DefaultRule.add(configurator, "be0750;tea041");
cds.configurator.DefaultRule.add(configurator, "be0750;tea042");
cds.configurator.DefaultRule.add(configurator, "be0750;tea043");
cds.configurator.DefaultRule.add(configurator, "be0750;tea045");
cds.configurator.DefaultRule.add(configurator, "be0750;tea046");
cds.configurator.DefaultRule.add(configurator, "be0750;tea050");
cds.configurator.DefaultRule.add(configurator, "be0750;tea052");
cds.configurator.DefaultRule.add(configurator, "be0750;tea053");
cds.configurator.DefaultRule.add(configurator, "be0750;tea056");
cds.configurator.DefaultRule.add(configurator, "be0750;tea062");
cds.configurator.DefaultRule.add(configurator, "be0750;tea063");
cds.configurator.DefaultRule.add(configurator, "be0750;tea064");
cds.configurator.DefaultRule.add(configurator, "be0750;tea067");
cds.configurator.DefaultRule.add(configurator, "be0750;tea068");
cds.configurator.DefaultRule.add(configurator, "be0750;tea070");
cds.configurator.DefaultRule.add(configurator, "be0750;tea071");
cds.configurator.DefaultRule.add(configurator, "be0750;tea074");
cds.configurator.DefaultRule.add(configurator, "be0750;tea075");
cds.configurator.DefaultRule.add(configurator, "be0750;tea080");
cds.configurator.DefaultRule.add(configurator, "be0750;tea090");
cds.configurator.DefaultRule.add(configurator, "be0750;tea100");
cds.configurator.DefaultRule.add(configurator, "be0750;tea112");
cds.configurator.DefaultRule.add(configurator, "be0750;tea126");
cds.configurator.DefaultRule.add(configurator, "be0750;tea140");
cds.configurator.DefaultRule.add(configurator, "be0750;tea144");
cds.configurator.DefaultRule.add(configurator, "be0750;tea154");
cds.configurator.DefaultRule.add(configurator, "be0750;tea168");
cds.configurator.DefaultRule.add(configurator, "be0750;tea180");
cds.configurator.DefaultRule.add(configurator, "be0750;tea192");
cds.configurator.DefaultRule.add(configurator, "be0750;tea200");
cds.configurator.DefaultRule.add(configurator, "be0750;tea216");
cds.configurator.DefaultRule.add(configurator, "be0750;tea224");
cds.configurator.DefaultRule.add(configurator, "be0750;teb010");
cds.configurator.DefaultRule.add(configurator, "be0750;teb011");
cds.configurator.DefaultRule.add(configurator, "be0750;teb023");
cds.configurator.DefaultRule.add(configurator, "be0750;teb025");
cds.configurator.DefaultRule.add(configurator, "be0750;teb027");
cds.configurator.DefaultRule.add(configurator, "be0750;teb029");
cds.configurator.DefaultRule.add(configurator, "be0750;teb031");
cds.configurator.DefaultRule.add(configurator, "be0750;teb033");
cds.configurator.DefaultRule.add(configurator, "be0750;teb034");
cds.configurator.DefaultRule.add(configurator, "be0750;teb035");
cds.configurator.DefaultRule.add(configurator, "be0750;teb037");
cds.configurator.DefaultRule.add(configurator, "be0750;teb038");
cds.configurator.DefaultRule.add(configurator, "be0750;teb039");
cds.configurator.DefaultRule.add(configurator, "be0750;teb041");
cds.configurator.DefaultRule.add(configurator, "be0750;teb042");
cds.configurator.DefaultRule.add(configurator, "be0750;teb043");
cds.configurator.DefaultRule.add(configurator, "be0750;teb045");
cds.configurator.DefaultRule.add(configurator, "be0750;teb046");
cds.configurator.DefaultRule.add(configurator, "be0750;teb050");
cds.configurator.DefaultRule.add(configurator, "be0750;teb052");
cds.configurator.DefaultRule.add(configurator, "be0750;teb053");
cds.configurator.DefaultRule.add(configurator, "be0750;teb056");
cds.configurator.DefaultRule.add(configurator, "be0750;teb062");
cds.configurator.DefaultRule.add(configurator, "be0750;teb063");
cds.configurator.DefaultRule.add(configurator, "be0750;teb064");
cds.configurator.DefaultRule.add(configurator, "be0750;teb067");
cds.configurator.DefaultRule.add(configurator, "be0750;teb068");
cds.configurator.DefaultRule.add(configurator, "be0750;teb070");
cds.configurator.DefaultRule.add(configurator, "be0750;teb071");
cds.configurator.DefaultRule.add(configurator, "be0750;teb074");
cds.configurator.DefaultRule.add(configurator, "be0750;teb075");
cds.configurator.DefaultRule.add(configurator, "be0750;teb080");
cds.configurator.DefaultRule.add(configurator, "be0750;teb090");
cds.configurator.DefaultRule.add(configurator, "be0750;teb100");
cds.configurator.DefaultRule.add(configurator, "be0750;teb112");
cds.configurator.DefaultRule.add(configurator, "be0750;teb126");
cds.configurator.DefaultRule.add(configurator, "be0750;teb140");
cds.configurator.DefaultRule.add(configurator, "be0750;teb144");
cds.configurator.DefaultRule.add(configurator, "be0750;teb154");
cds.configurator.DefaultRule.add(configurator, "be0750;teb168");
cds.configurator.DefaultRule.add(configurator, "be0750;teb180");
cds.configurator.DefaultRule.add(configurator, "be0750;teb192");
cds.configurator.DefaultRule.add(configurator, "be0750;teb200");
cds.configurator.DefaultRule.add(configurator, "be0750;teb216");
cds.configurator.DefaultRule.add(configurator, "be0750;teb224");
cds.configurator.DefaultRule.add(configurator, "be0787;sehhh");
cds.configurator.DefaultRule.add(configurator, "be0787;selll");
cds.configurator.DefaultRule.add(configurator, "be0787;semxl");
cds.configurator.DefaultRule.add(configurator, "be0787;sexll");
cds.configurator.DefaultRule.add(configurator, "be0787;sma05");
cds.configurator.DefaultRule.add(configurator, "be0787;sma10");
cds.configurator.DefaultRule.add(configurator, "be0787;smh03");
cds.configurator.DefaultRule.add(configurator, "be0787;smh05");
cds.configurator.DefaultRule.add(configurator, "be0787;smt05");
cds.configurator.DefaultRule.add(configurator, "be0787;smt10");
cds.configurator.DefaultRule.add(configurator, "be0787;smt25");
cds.configurator.DefaultRule.add(configurator, "be0787;tea010");
cds.configurator.DefaultRule.add(configurator, "be0787;tea011");
cds.configurator.DefaultRule.add(configurator, "be0787;tea012");
cds.configurator.DefaultRule.add(configurator, "be0787;tea013");
cds.configurator.DefaultRule.add(configurator, "be0787;tea014");
cds.configurator.DefaultRule.add(configurator, "be0787;tea015");
cds.configurator.DefaultRule.add(configurator, "be0787;tea016");
cds.configurator.DefaultRule.add(configurator, "be0787;tea017");
cds.configurator.DefaultRule.add(configurator, "be0787;tea018");
cds.configurator.DefaultRule.add(configurator, "be0787;tea019");
cds.configurator.DefaultRule.add(configurator, "be0787;tea020");
cds.configurator.DefaultRule.add(configurator, "be0787;tea021");
cds.configurator.DefaultRule.add(configurator, "be0787;tea023");
cds.configurator.DefaultRule.add(configurator, "be0787;tea041");
cds.configurator.DefaultRule.add(configurator, "be0787;tea052");
cds.configurator.DefaultRule.add(configurator, "be0787;tea062");
cds.configurator.DefaultRule.add(configurator, "be0787;tea068");
cds.configurator.DefaultRule.add(configurator, "be0787;tea070");
cds.configurator.DefaultRule.add(configurator, "be0787;tea074");
cds.configurator.DefaultRule.add(configurator, "be0787;tea084");
cds.configurator.DefaultRule.add(configurator, "be0787;tea096");
cds.configurator.DefaultRule.add(configurator, "be0787;tea100");
cds.configurator.DefaultRule.add(configurator, "be0787;tea120");
cds.configurator.DefaultRule.add(configurator, "be0787;tea216");
cds.configurator.DefaultRule.add(configurator, "be0787;teb010");
cds.configurator.DefaultRule.add(configurator, "be0787;teb011");
cds.configurator.DefaultRule.add(configurator, "be0787;teb012");
cds.configurator.DefaultRule.add(configurator, "be0787;teb013");
cds.configurator.DefaultRule.add(configurator, "be0787;teb014");
cds.configurator.DefaultRule.add(configurator, "be0787;teb015");
cds.configurator.DefaultRule.add(configurator, "be0787;teb016");
cds.configurator.DefaultRule.add(configurator, "be0787;teb017");
cds.configurator.DefaultRule.add(configurator, "be0787;teb018");
cds.configurator.DefaultRule.add(configurator, "be0787;teb019");
cds.configurator.DefaultRule.add(configurator, "be0787;teb020");
cds.configurator.DefaultRule.add(configurator, "be0787;teb021");
cds.configurator.DefaultRule.add(configurator, "be0787;teb023");
cds.configurator.DefaultRule.add(configurator, "be0787;teb041");
cds.configurator.DefaultRule.add(configurator, "be0787;teb052");
cds.configurator.DefaultRule.add(configurator, "be0787;teb062");
cds.configurator.DefaultRule.add(configurator, "be0787;teb068");
cds.configurator.DefaultRule.add(configurator, "be0787;teb070");
cds.configurator.DefaultRule.add(configurator, "be0787;teb074");
cds.configurator.DefaultRule.add(configurator, "be0787;teb084");
cds.configurator.DefaultRule.add(configurator, "be0787;teb096");
cds.configurator.DefaultRule.add(configurator, "be0787;teb100");
cds.configurator.DefaultRule.add(configurator, "be0787;teb120");
cds.configurator.DefaultRule.add(configurator, "be0787;teb216");
cds.configurator.DefaultRule.add(configurator, "be0827;sehhh");
cds.configurator.DefaultRule.add(configurator, "be0827;selll");
cds.configurator.DefaultRule.add(configurator, "be0827;semxl");
cds.configurator.DefaultRule.add(configurator, "be0827;sexll");
cds.configurator.DefaultRule.add(configurator, "be0827;sma05");
cds.configurator.DefaultRule.add(configurator, "be0827;sma10");
cds.configurator.DefaultRule.add(configurator, "be0827;smh03");
cds.configurator.DefaultRule.add(configurator, "be0827;smh05");
cds.configurator.DefaultRule.add(configurator, "be0827;smh08");
cds.configurator.DefaultRule.add(configurator, "be0827;smt05");
cds.configurator.DefaultRule.add(configurator, "be0827;smt10");
cds.configurator.DefaultRule.add(configurator, "be0827;smt25");
cds.configurator.DefaultRule.add(configurator, "be0827;tea010");
cds.configurator.DefaultRule.add(configurator, "be0827;tea011");
cds.configurator.DefaultRule.add(configurator, "be0827;tea012");
cds.configurator.DefaultRule.add(configurator, "be0827;tea013");
cds.configurator.DefaultRule.add(configurator, "be0827;tea014");
cds.configurator.DefaultRule.add(configurator, "be0827;tea015");
cds.configurator.DefaultRule.add(configurator, "be0827;tea016");
cds.configurator.DefaultRule.add(configurator, "be0827;tea017");
cds.configurator.DefaultRule.add(configurator, "be0827;tea018");
cds.configurator.DefaultRule.add(configurator, "be0827;tea019");
cds.configurator.DefaultRule.add(configurator, "be0827;tea020");
cds.configurator.DefaultRule.add(configurator, "be0827;tea021");
cds.configurator.DefaultRule.add(configurator, "be0827;tea023");
cds.configurator.DefaultRule.add(configurator, "be0827;tea024");
cds.configurator.DefaultRule.add(configurator, "be0827;tea043");
cds.configurator.DefaultRule.add(configurator, "be0827;tea044");
cds.configurator.DefaultRule.add(configurator, "be0827;tea046");
cds.configurator.DefaultRule.add(configurator, "be0827;tea052");
cds.configurator.DefaultRule.add(configurator, "be0827;tea062");
cds.configurator.DefaultRule.add(configurator, "be0827;tea064");
cds.configurator.DefaultRule.add(configurator, "be0827;tea068");
cds.configurator.DefaultRule.add(configurator, "be0827;tea070");
cds.configurator.DefaultRule.add(configurator, "be0827;tea072");
cds.configurator.DefaultRule.add(configurator, "be0827;tea074");
cds.configurator.DefaultRule.add(configurator, "be0827;tea084");
cds.configurator.DefaultRule.add(configurator, "be0827;tea096");
cds.configurator.DefaultRule.add(configurator, "be0827;tea100");
cds.configurator.DefaultRule.add(configurator, "be0827;tea120");
cds.configurator.DefaultRule.add(configurator, "be0827;tea126");
cds.configurator.DefaultRule.add(configurator, "be0827;tea144");
cds.configurator.DefaultRule.add(configurator, "be0827;tea154");
cds.configurator.DefaultRule.add(configurator, "be0827;tea168");
cds.configurator.DefaultRule.add(configurator, "be0827;tea192");
cds.configurator.DefaultRule.add(configurator, "be0827;tea200");
cds.configurator.DefaultRule.add(configurator, "be0827;tea216");
cds.configurator.DefaultRule.add(configurator, "be0827;teb010");
cds.configurator.DefaultRule.add(configurator, "be0827;teb011");
cds.configurator.DefaultRule.add(configurator, "be0827;teb012");
cds.configurator.DefaultRule.add(configurator, "be0827;teb013");
cds.configurator.DefaultRule.add(configurator, "be0827;teb014");
cds.configurator.DefaultRule.add(configurator, "be0827;teb015");
cds.configurator.DefaultRule.add(configurator, "be0827;teb016");
cds.configurator.DefaultRule.add(configurator, "be0827;teb017");
cds.configurator.DefaultRule.add(configurator, "be0827;teb018");
cds.configurator.DefaultRule.add(configurator, "be0827;teb019");
cds.configurator.DefaultRule.add(configurator, "be0827;teb020");
cds.configurator.DefaultRule.add(configurator, "be0827;teb021");
cds.configurator.DefaultRule.add(configurator, "be0827;teb023");
cds.configurator.DefaultRule.add(configurator, "be0827;teb024");
cds.configurator.DefaultRule.add(configurator, "be0827;teb043");
cds.configurator.DefaultRule.add(configurator, "be0827;teb044");
cds.configurator.DefaultRule.add(configurator, "be0827;teb046");
cds.configurator.DefaultRule.add(configurator, "be0827;teb052");
cds.configurator.DefaultRule.add(configurator, "be0827;teb062");
cds.configurator.DefaultRule.add(configurator, "be0827;teb064");
cds.configurator.DefaultRule.add(configurator, "be0827;teb068");
cds.configurator.DefaultRule.add(configurator, "be0827;teb070");
cds.configurator.DefaultRule.add(configurator, "be0827;teb072");
cds.configurator.DefaultRule.add(configurator, "be0827;teb074");
cds.configurator.DefaultRule.add(configurator, "be0827;teb084");
cds.configurator.DefaultRule.add(configurator, "be0827;teb096");
cds.configurator.DefaultRule.add(configurator, "be0827;teb100");
cds.configurator.DefaultRule.add(configurator, "be0827;teb120");
cds.configurator.DefaultRule.add(configurator, "be0827;teb126");
cds.configurator.DefaultRule.add(configurator, "be0827;teb144");
cds.configurator.DefaultRule.add(configurator, "be0827;teb154");
cds.configurator.DefaultRule.add(configurator, "be0827;teb168");
cds.configurator.DefaultRule.add(configurator, "be0827;teb192");
cds.configurator.DefaultRule.add(configurator, "be0827;teb200");
cds.configurator.DefaultRule.add(configurator, "be0827;teb216");
cds.configurator.DefaultRule.add(configurator, "be0984;sehhh");
cds.configurator.DefaultRule.add(configurator, "be0984;selll");
cds.configurator.DefaultRule.add(configurator, "be0984;semxl");
cds.configurator.DefaultRule.add(configurator, "be0984;sexll");
cds.configurator.DefaultRule.add(configurator, "be0984;smh03");
cds.configurator.DefaultRule.add(configurator, "be0984;smh08");
cds.configurator.DefaultRule.add(configurator, "be0984;smt25");
cds.configurator.DefaultRule.add(configurator, "be0984;tea011");
cds.configurator.DefaultRule.add(configurator, "be0984;tea013");
cds.configurator.DefaultRule.add(configurator, "be0984;tea017");
cds.configurator.DefaultRule.add(configurator, "be0984;tea029");
cds.configurator.DefaultRule.add(configurator, "be0984;tea031");
cds.configurator.DefaultRule.add(configurator, "be0984;tea033");
cds.configurator.DefaultRule.add(configurator, "be0984;tea035");
cds.configurator.DefaultRule.add(configurator, "be0984;tea037");
cds.configurator.DefaultRule.add(configurator, "be0984;tea039");
cds.configurator.DefaultRule.add(configurator, "be0984;tea041");
cds.configurator.DefaultRule.add(configurator, "be0984;tea042");
cds.configurator.DefaultRule.add(configurator, "be0984;tea043");
cds.configurator.DefaultRule.add(configurator, "be0984;tea046");
cds.configurator.DefaultRule.add(configurator, "be0984;tea053");
cds.configurator.DefaultRule.add(configurator, "be0984;tea062");
cds.configurator.DefaultRule.add(configurator, "be0984;tea063");
cds.configurator.DefaultRule.add(configurator, "be0984;tea067");
cds.configurator.DefaultRule.add(configurator, "be0984;tea070");
cds.configurator.DefaultRule.add(configurator, "be0984;tea071");
cds.configurator.DefaultRule.add(configurator, "be0984;tea074");
cds.configurator.DefaultRule.add(configurator, "be0984;tea075");
cds.configurator.DefaultRule.add(configurator, "be0984;tea084");
cds.configurator.DefaultRule.add(configurator, "be0984;tea096");
cds.configurator.DefaultRule.add(configurator, "be0984;tea100");
cds.configurator.DefaultRule.add(configurator, "be0984;tea120");
cds.configurator.DefaultRule.add(configurator, "be0984;tea126");
cds.configurator.DefaultRule.add(configurator, "be0984;tea140");
cds.configurator.DefaultRule.add(configurator, "be0984;tea144");
cds.configurator.DefaultRule.add(configurator, "be0984;tea154");
cds.configurator.DefaultRule.add(configurator, "be0984;tea168");
cds.configurator.DefaultRule.add(configurator, "be0984;tea180");
cds.configurator.DefaultRule.add(configurator, "be0984;tea192");
cds.configurator.DefaultRule.add(configurator, "be0984;tea200");
cds.configurator.DefaultRule.add(configurator, "be0984;tea216");
cds.configurator.DefaultRule.add(configurator, "be0984;tea224");
cds.configurator.DefaultRule.add(configurator, "be0984;teb011");
cds.configurator.DefaultRule.add(configurator, "be0984;teb013");
cds.configurator.DefaultRule.add(configurator, "be0984;teb017");
cds.configurator.DefaultRule.add(configurator, "be0984;teb029");
cds.configurator.DefaultRule.add(configurator, "be0984;teb031");
cds.configurator.DefaultRule.add(configurator, "be0984;teb033");
cds.configurator.DefaultRule.add(configurator, "be0984;teb035");
cds.configurator.DefaultRule.add(configurator, "be0984;teb037");
cds.configurator.DefaultRule.add(configurator, "be0984;teb039");
cds.configurator.DefaultRule.add(configurator, "be0984;teb041");
cds.configurator.DefaultRule.add(configurator, "be0984;teb042");
cds.configurator.DefaultRule.add(configurator, "be0984;teb043");
cds.configurator.DefaultRule.add(configurator, "be0984;teb046");
cds.configurator.DefaultRule.add(configurator, "be0984;teb053");
cds.configurator.DefaultRule.add(configurator, "be0984;teb062");
cds.configurator.DefaultRule.add(configurator, "be0984;teb063");
cds.configurator.DefaultRule.add(configurator, "be0984;teb067");
cds.configurator.DefaultRule.add(configurator, "be0984;teb070");
cds.configurator.DefaultRule.add(configurator, "be0984;teb071");
cds.configurator.DefaultRule.add(configurator, "be0984;teb074");
cds.configurator.DefaultRule.add(configurator, "be0984;teb075");
cds.configurator.DefaultRule.add(configurator, "be0984;teb084");
cds.configurator.DefaultRule.add(configurator, "be0984;teb096");
cds.configurator.DefaultRule.add(configurator, "be0984;teb100");
cds.configurator.DefaultRule.add(configurator, "be0984;teb120");
cds.configurator.DefaultRule.add(configurator, "be0984;teb126");
cds.configurator.DefaultRule.add(configurator, "be0984;teb140");
cds.configurator.DefaultRule.add(configurator, "be0984;teb144");
cds.configurator.DefaultRule.add(configurator, "be0984;teb154");
cds.configurator.DefaultRule.add(configurator, "be0984;teb168");
cds.configurator.DefaultRule.add(configurator, "be0984;teb180");
cds.configurator.DefaultRule.add(configurator, "be0984;teb192");
cds.configurator.DefaultRule.add(configurator, "be0984;teb200");
cds.configurator.DefaultRule.add(configurator, "be0984;teb216");
cds.configurator.DefaultRule.add(configurator, "be0984;teb224");
cds.configurator.DefaultRule.add(configurator, "be1000;semxl");
cds.configurator.DefaultRule.add(configurator, "be1000;sexll");
cds.configurator.DefaultRule.add(configurator, "be1000;sma05");
cds.configurator.DefaultRule.add(configurator, "be1000;sma10");
cds.configurator.DefaultRule.add(configurator, "be1000;smh03");
cds.configurator.DefaultRule.add(configurator, "be1000;smh05");
cds.configurator.DefaultRule.add(configurator, "be1000;smh08");
cds.configurator.DefaultRule.add(configurator, "be1000;smt05");
cds.configurator.DefaultRule.add(configurator, "be1000;smt10");
cds.configurator.DefaultRule.add(configurator, "be1000;smt25");
cds.configurator.DefaultRule.add(configurator, "be1000;tea010");
cds.configurator.DefaultRule.add(configurator, "be1000;tea011");
cds.configurator.DefaultRule.add(configurator, "be1000;tea012");
cds.configurator.DefaultRule.add(configurator, "be1000;tea023");
cds.configurator.DefaultRule.add(configurator, "be1000;tea025");
cds.configurator.DefaultRule.add(configurator, "be1000;tea027");
cds.configurator.DefaultRule.add(configurator, "be1000;tea029");
cds.configurator.DefaultRule.add(configurator, "be1000;tea031");
cds.configurator.DefaultRule.add(configurator, "be1000;tea033");
cds.configurator.DefaultRule.add(configurator, "be1000;tea034");
cds.configurator.DefaultRule.add(configurator, "be1000;tea035");
cds.configurator.DefaultRule.add(configurator, "be1000;tea037");
cds.configurator.DefaultRule.add(configurator, "be1000;tea038");
cds.configurator.DefaultRule.add(configurator, "be1000;tea039");
cds.configurator.DefaultRule.add(configurator, "be1000;tea041");
cds.configurator.DefaultRule.add(configurator, "be1000;tea042");
cds.configurator.DefaultRule.add(configurator, "be1000;tea043");
cds.configurator.DefaultRule.add(configurator, "be1000;tea045");
cds.configurator.DefaultRule.add(configurator, "be1000;tea046");
cds.configurator.DefaultRule.add(configurator, "be1000;tea050");
cds.configurator.DefaultRule.add(configurator, "be1000;tea052");
cds.configurator.DefaultRule.add(configurator, "be1000;tea053");
cds.configurator.DefaultRule.add(configurator, "be1000;tea056");
cds.configurator.DefaultRule.add(configurator, "be1000;tea062");
cds.configurator.DefaultRule.add(configurator, "be1000;tea063");
cds.configurator.DefaultRule.add(configurator, "be1000;tea064");
cds.configurator.DefaultRule.add(configurator, "be1000;tea067");
cds.configurator.DefaultRule.add(configurator, "be1000;tea068");
cds.configurator.DefaultRule.add(configurator, "be1000;tea070");
cds.configurator.DefaultRule.add(configurator, "be1000;tea071");
cds.configurator.DefaultRule.add(configurator, "be1000;tea074");
cds.configurator.DefaultRule.add(configurator, "be1000;tea075");
cds.configurator.DefaultRule.add(configurator, "be1000;tea080");
cds.configurator.DefaultRule.add(configurator, "be1000;tea090");
cds.configurator.DefaultRule.add(configurator, "be1000;tea100");
cds.configurator.DefaultRule.add(configurator, "be1000;tea112");
cds.configurator.DefaultRule.add(configurator, "be1000;tea126");
cds.configurator.DefaultRule.add(configurator, "be1000;tea140");
cds.configurator.DefaultRule.add(configurator, "be1000;tea144");
cds.configurator.DefaultRule.add(configurator, "be1000;tea154");
cds.configurator.DefaultRule.add(configurator, "be1000;tea168");
cds.configurator.DefaultRule.add(configurator, "be1000;tea180");
cds.configurator.DefaultRule.add(configurator, "be1000;tea192");
cds.configurator.DefaultRule.add(configurator, "be1000;tea200");
cds.configurator.DefaultRule.add(configurator, "be1000;tea216");
cds.configurator.DefaultRule.add(configurator, "be1000;tea224");
cds.configurator.DefaultRule.add(configurator, "be1000;teb010");
cds.configurator.DefaultRule.add(configurator, "be1000;teb011");
cds.configurator.DefaultRule.add(configurator, "be1000;teb012");
cds.configurator.DefaultRule.add(configurator, "be1000;teb023");
cds.configurator.DefaultRule.add(configurator, "be1000;teb025");
cds.configurator.DefaultRule.add(configurator, "be1000;teb027");
cds.configurator.DefaultRule.add(configurator, "be1000;teb029");
cds.configurator.DefaultRule.add(configurator, "be1000;teb031");
cds.configurator.DefaultRule.add(configurator, "be1000;teb033");
cds.configurator.DefaultRule.add(configurator, "be1000;teb034");
cds.configurator.DefaultRule.add(configurator, "be1000;teb035");
cds.configurator.DefaultRule.add(configurator, "be1000;teb037");
cds.configurator.DefaultRule.add(configurator, "be1000;teb038");
cds.configurator.DefaultRule.add(configurator, "be1000;teb039");
cds.configurator.DefaultRule.add(configurator, "be1000;teb041");
cds.configurator.DefaultRule.add(configurator, "be1000;teb042");
cds.configurator.DefaultRule.add(configurator, "be1000;teb043");
cds.configurator.DefaultRule.add(configurator, "be1000;teb045");
cds.configurator.DefaultRule.add(configurator, "be1000;teb046");
cds.configurator.DefaultRule.add(configurator, "be1000;teb050");
cds.configurator.DefaultRule.add(configurator, "be1000;teb052");
cds.configurator.DefaultRule.add(configurator, "be1000;teb053");
cds.configurator.DefaultRule.add(configurator, "be1000;teb056");
cds.configurator.DefaultRule.add(configurator, "be1000;teb062");
cds.configurator.DefaultRule.add(configurator, "be1000;teb063");
cds.configurator.DefaultRule.add(configurator, "be1000;teb064");
cds.configurator.DefaultRule.add(configurator, "be1000;teb067");
cds.configurator.DefaultRule.add(configurator, "be1000;teb068");
cds.configurator.DefaultRule.add(configurator, "be1000;teb070");
cds.configurator.DefaultRule.add(configurator, "be1000;teb071");
cds.configurator.DefaultRule.add(configurator, "be1000;teb074");
cds.configurator.DefaultRule.add(configurator, "be1000;teb075");
cds.configurator.DefaultRule.add(configurator, "be1000;teb080");
cds.configurator.DefaultRule.add(configurator, "be1000;teb090");
cds.configurator.DefaultRule.add(configurator, "be1000;teb100");
cds.configurator.DefaultRule.add(configurator, "be1000;teb112");
cds.configurator.DefaultRule.add(configurator, "be1000;teb126");
cds.configurator.DefaultRule.add(configurator, "be1000;teb140");
cds.configurator.DefaultRule.add(configurator, "be1000;teb144");
cds.configurator.DefaultRule.add(configurator, "be1000;teb154");
cds.configurator.DefaultRule.add(configurator, "be1000;teb168");
cds.configurator.DefaultRule.add(configurator, "be1000;teb180");
cds.configurator.DefaultRule.add(configurator, "be1000;teb192");
cds.configurator.DefaultRule.add(configurator, "be1000;teb200");
cds.configurator.DefaultRule.add(configurator, "be1000;teb216");
cds.configurator.DefaultRule.add(configurator, "be1000;teb224");
cds.configurator.DefaultRule.add(configurator, "be1181;sehhh");
cds.configurator.DefaultRule.add(configurator, "be1181;selll");
cds.configurator.DefaultRule.add(configurator, "be1181;semxl");
cds.configurator.DefaultRule.add(configurator, "be1181;sexll");
cds.configurator.DefaultRule.add(configurator, "be1181;sma05");
cds.configurator.DefaultRule.add(configurator, "be1181;sma10");
cds.configurator.DefaultRule.add(configurator, "be1181;smh03");
cds.configurator.DefaultRule.add(configurator, "be1181;smh05");
cds.configurator.DefaultRule.add(configurator, "be1181;smt05");
cds.configurator.DefaultRule.add(configurator, "be1181;smt10");
cds.configurator.DefaultRule.add(configurator, "be1181;smt25");
cds.configurator.DefaultRule.add(configurator, "be1181;tea010");
cds.configurator.DefaultRule.add(configurator, "be1181;tea011");
cds.configurator.DefaultRule.add(configurator, "be1181;tea012");
cds.configurator.DefaultRule.add(configurator, "be1181;tea013");
cds.configurator.DefaultRule.add(configurator, "be1181;tea014");
cds.configurator.DefaultRule.add(configurator, "be1181;tea015");
cds.configurator.DefaultRule.add(configurator, "be1181;tea016");
cds.configurator.DefaultRule.add(configurator, "be1181;tea017");
cds.configurator.DefaultRule.add(configurator, "be1181;tea018");
cds.configurator.DefaultRule.add(configurator, "be1181;tea019");
cds.configurator.DefaultRule.add(configurator, "be1181;tea020");
cds.configurator.DefaultRule.add(configurator, "be1181;tea021");
cds.configurator.DefaultRule.add(configurator, "be1181;tea023");
cds.configurator.DefaultRule.add(configurator, "be1181;tea041");
cds.configurator.DefaultRule.add(configurator, "be1181;tea043");
cds.configurator.DefaultRule.add(configurator, "be1181;tea045");
cds.configurator.DefaultRule.add(configurator, "be1181;tea052");
cds.configurator.DefaultRule.add(configurator, "be1181;tea060");
cds.configurator.DefaultRule.add(configurator, "be1181;tea062");
cds.configurator.DefaultRule.add(configurator, "be1181;tea063");
cds.configurator.DefaultRule.add(configurator, "be1181;tea067");
cds.configurator.DefaultRule.add(configurator, "be1181;tea068");
cds.configurator.DefaultRule.add(configurator, "be1181;tea070");
cds.configurator.DefaultRule.add(configurator, "be1181;tea071");
cds.configurator.DefaultRule.add(configurator, "be1181;tea074");
cds.configurator.DefaultRule.add(configurator, "be1181;tea075");
cds.configurator.DefaultRule.add(configurator, "be1181;tea084");
cds.configurator.DefaultRule.add(configurator, "be1181;tea096");
cds.configurator.DefaultRule.add(configurator, "be1181;tea100");
cds.configurator.DefaultRule.add(configurator, "be1181;tea120");
cds.configurator.DefaultRule.add(configurator, "be1181;tea126");
cds.configurator.DefaultRule.add(configurator, "be1181;tea140");
cds.configurator.DefaultRule.add(configurator, "be1181;tea154");
cds.configurator.DefaultRule.add(configurator, "be1181;tea168");
cds.configurator.DefaultRule.add(configurator, "be1181;tea180");
cds.configurator.DefaultRule.add(configurator, "be1181;tea200");
cds.configurator.DefaultRule.add(configurator, "be1181;tea216");
cds.configurator.DefaultRule.add(configurator, "be1181;tea224");
cds.configurator.DefaultRule.add(configurator, "be1181;teb010");
cds.configurator.DefaultRule.add(configurator, "be1181;teb011");
cds.configurator.DefaultRule.add(configurator, "be1181;teb012");
cds.configurator.DefaultRule.add(configurator, "be1181;teb013");
cds.configurator.DefaultRule.add(configurator, "be1181;teb014");
cds.configurator.DefaultRule.add(configurator, "be1181;teb015");
cds.configurator.DefaultRule.add(configurator, "be1181;teb016");
cds.configurator.DefaultRule.add(configurator, "be1181;teb017");
cds.configurator.DefaultRule.add(configurator, "be1181;teb018");
cds.configurator.DefaultRule.add(configurator, "be1181;teb019");
cds.configurator.DefaultRule.add(configurator, "be1181;teb020");
cds.configurator.DefaultRule.add(configurator, "be1181;teb021");
cds.configurator.DefaultRule.add(configurator, "be1181;teb023");
cds.configurator.DefaultRule.add(configurator, "be1181;teb041");
cds.configurator.DefaultRule.add(configurator, "be1181;teb043");
cds.configurator.DefaultRule.add(configurator, "be1181;teb045");
cds.configurator.DefaultRule.add(configurator, "be1181;teb052");
cds.configurator.DefaultRule.add(configurator, "be1181;teb060");
cds.configurator.DefaultRule.add(configurator, "be1181;teb062");
cds.configurator.DefaultRule.add(configurator, "be1181;teb063");
cds.configurator.DefaultRule.add(configurator, "be1181;teb067");
cds.configurator.DefaultRule.add(configurator, "be1181;teb068");
cds.configurator.DefaultRule.add(configurator, "be1181;teb070");
cds.configurator.DefaultRule.add(configurator, "be1181;teb071");
cds.configurator.DefaultRule.add(configurator, "be1181;teb074");
cds.configurator.DefaultRule.add(configurator, "be1181;teb075");
cds.configurator.DefaultRule.add(configurator, "be1181;teb084");
cds.configurator.DefaultRule.add(configurator, "be1181;teb096");
cds.configurator.DefaultRule.add(configurator, "be1181;teb100");
cds.configurator.DefaultRule.add(configurator, "be1181;teb120");
cds.configurator.DefaultRule.add(configurator, "be1181;teb126");
cds.configurator.DefaultRule.add(configurator, "be1181;teb140");
cds.configurator.DefaultRule.add(configurator, "be1181;teb154");
cds.configurator.DefaultRule.add(configurator, "be1181;teb168");
cds.configurator.DefaultRule.add(configurator, "be1181;teb180");
cds.configurator.DefaultRule.add(configurator, "be1181;teb200");
cds.configurator.DefaultRule.add(configurator, "be1181;teb216");
cds.configurator.DefaultRule.add(configurator, "be1181;teb224");
cds.configurator.DefaultRule.add(configurator, "be1260;sehhh");
cds.configurator.DefaultRule.add(configurator, "be1260;selll");
cds.configurator.DefaultRule.add(configurator, "be1260;semxl");
cds.configurator.DefaultRule.add(configurator, "be1260;sexll");
cds.configurator.DefaultRule.add(configurator, "be1260;sma05");
cds.configurator.DefaultRule.add(configurator, "be1260;smh03");
cds.configurator.DefaultRule.add(configurator, "be1260;smh05");
cds.configurator.DefaultRule.add(configurator, "be1260;smh08");
cds.configurator.DefaultRule.add(configurator, "be1260;smt05");
cds.configurator.DefaultRule.add(configurator, "be1260;smt25");
cds.configurator.DefaultRule.add(configurator, "be1260;tea010");
cds.configurator.DefaultRule.add(configurator, "be1260;tea011");
cds.configurator.DefaultRule.add(configurator, "be1260;tea012");
cds.configurator.DefaultRule.add(configurator, "be1260;tea013");
cds.configurator.DefaultRule.add(configurator, "be1260;tea014");
cds.configurator.DefaultRule.add(configurator, "be1260;tea015");
cds.configurator.DefaultRule.add(configurator, "be1260;tea016");
cds.configurator.DefaultRule.add(configurator, "be1260;tea017");
cds.configurator.DefaultRule.add(configurator, "be1260;tea021");
cds.configurator.DefaultRule.add(configurator, "be1260;tea023");
cds.configurator.DefaultRule.add(configurator, "be1260;tea026");
cds.configurator.DefaultRule.add(configurator, "be1260;tea028");
cds.configurator.DefaultRule.add(configurator, "be1260;tea029");
cds.configurator.DefaultRule.add(configurator, "be1260;tea031");
cds.configurator.DefaultRule.add(configurator, "be1260;tea033");
cds.configurator.DefaultRule.add(configurator, "be1260;tea034");
cds.configurator.DefaultRule.add(configurator, "be1260;tea035");
cds.configurator.DefaultRule.add(configurator, "be1260;tea037");
cds.configurator.DefaultRule.add(configurator, "be1260;tea038");
cds.configurator.DefaultRule.add(configurator, "be1260;tea039");
cds.configurator.DefaultRule.add(configurator, "be1260;tea041");
cds.configurator.DefaultRule.add(configurator, "be1260;tea042");
cds.configurator.DefaultRule.add(configurator, "be1260;tea043");
cds.configurator.DefaultRule.add(configurator, "be1260;tea045");
cds.configurator.DefaultRule.add(configurator, "be1260;tea046");
cds.configurator.DefaultRule.add(configurator, "be1260;tea050");
cds.configurator.DefaultRule.add(configurator, "be1260;tea052");
cds.configurator.DefaultRule.add(configurator, "be1260;tea053");
cds.configurator.DefaultRule.add(configurator, "be1260;tea056");
cds.configurator.DefaultRule.add(configurator, "be1260;tea062");
cds.configurator.DefaultRule.add(configurator, "be1260;tea063");
cds.configurator.DefaultRule.add(configurator, "be1260;tea064");
cds.configurator.DefaultRule.add(configurator, "be1260;tea067");
cds.configurator.DefaultRule.add(configurator, "be1260;tea068");
cds.configurator.DefaultRule.add(configurator, "be1260;tea070");
cds.configurator.DefaultRule.add(configurator, "be1260;tea071");
cds.configurator.DefaultRule.add(configurator, "be1260;tea072");
cds.configurator.DefaultRule.add(configurator, "be1260;tea074");
cds.configurator.DefaultRule.add(configurator, "be1260;tea075");
cds.configurator.DefaultRule.add(configurator, "be1260;tea080");
cds.configurator.DefaultRule.add(configurator, "be1260;tea084");
cds.configurator.DefaultRule.add(configurator, "be1260;tea090");
cds.configurator.DefaultRule.add(configurator, "be1260;tea096");
cds.configurator.DefaultRule.add(configurator, "be1260;tea100");
cds.configurator.DefaultRule.add(configurator, "be1260;tea112");
cds.configurator.DefaultRule.add(configurator, "be1260;tea120");
cds.configurator.DefaultRule.add(configurator, "be1260;tea126");
cds.configurator.DefaultRule.add(configurator, "be1260;tea140");
cds.configurator.DefaultRule.add(configurator, "be1260;tea144");
cds.configurator.DefaultRule.add(configurator, "be1260;tea154");
cds.configurator.DefaultRule.add(configurator, "be1260;tea168");
cds.configurator.DefaultRule.add(configurator, "be1260;tea180");
cds.configurator.DefaultRule.add(configurator, "be1260;tea192");
cds.configurator.DefaultRule.add(configurator, "be1260;tea200");
cds.configurator.DefaultRule.add(configurator, "be1260;tea216");
cds.configurator.DefaultRule.add(configurator, "be1260;tea224");
cds.configurator.DefaultRule.add(configurator, "be1260;teb010");
cds.configurator.DefaultRule.add(configurator, "be1260;teb011");
cds.configurator.DefaultRule.add(configurator, "be1260;teb012");
cds.configurator.DefaultRule.add(configurator, "be1260;teb013");
cds.configurator.DefaultRule.add(configurator, "be1260;teb014");
cds.configurator.DefaultRule.add(configurator, "be1260;teb015");
cds.configurator.DefaultRule.add(configurator, "be1260;teb016");
cds.configurator.DefaultRule.add(configurator, "be1260;teb017");
cds.configurator.DefaultRule.add(configurator, "be1260;teb021");
cds.configurator.DefaultRule.add(configurator, "be1260;teb023");
cds.configurator.DefaultRule.add(configurator, "be1260;teb026");
cds.configurator.DefaultRule.add(configurator, "be1260;teb028");
cds.configurator.DefaultRule.add(configurator, "be1260;teb029");
cds.configurator.DefaultRule.add(configurator, "be1260;teb031");
cds.configurator.DefaultRule.add(configurator, "be1260;teb033");
cds.configurator.DefaultRule.add(configurator, "be1260;teb034");
cds.configurator.DefaultRule.add(configurator, "be1260;teb035");
cds.configurator.DefaultRule.add(configurator, "be1260;teb037");
cds.configurator.DefaultRule.add(configurator, "be1260;teb038");
cds.configurator.DefaultRule.add(configurator, "be1260;teb039");
cds.configurator.DefaultRule.add(configurator, "be1260;teb041");
cds.configurator.DefaultRule.add(configurator, "be1260;teb042");
cds.configurator.DefaultRule.add(configurator, "be1260;teb043");
cds.configurator.DefaultRule.add(configurator, "be1260;teb045");
cds.configurator.DefaultRule.add(configurator, "be1260;teb046");
cds.configurator.DefaultRule.add(configurator, "be1260;teb050");
cds.configurator.DefaultRule.add(configurator, "be1260;teb052");
cds.configurator.DefaultRule.add(configurator, "be1260;teb053");
cds.configurator.DefaultRule.add(configurator, "be1260;teb056");
cds.configurator.DefaultRule.add(configurator, "be1260;teb062");
cds.configurator.DefaultRule.add(configurator, "be1260;teb063");
cds.configurator.DefaultRule.add(configurator, "be1260;teb064");
cds.configurator.DefaultRule.add(configurator, "be1260;teb067");
cds.configurator.DefaultRule.add(configurator, "be1260;teb068");
cds.configurator.DefaultRule.add(configurator, "be1260;teb070");
cds.configurator.DefaultRule.add(configurator, "be1260;teb071");
cds.configurator.DefaultRule.add(configurator, "be1260;teb072");
cds.configurator.DefaultRule.add(configurator, "be1260;teb074");
cds.configurator.DefaultRule.add(configurator, "be1260;teb075");
cds.configurator.DefaultRule.add(configurator, "be1260;teb080");
cds.configurator.DefaultRule.add(configurator, "be1260;teb084");
cds.configurator.DefaultRule.add(configurator, "be1260;teb090");
cds.configurator.DefaultRule.add(configurator, "be1260;teb096");
cds.configurator.DefaultRule.add(configurator, "be1260;teb100");
cds.configurator.DefaultRule.add(configurator, "be1260;teb112");
cds.configurator.DefaultRule.add(configurator, "be1260;teb120");
cds.configurator.DefaultRule.add(configurator, "be1260;teb126");
cds.configurator.DefaultRule.add(configurator, "be1260;teb140");
cds.configurator.DefaultRule.add(configurator, "be1260;teb144");
cds.configurator.DefaultRule.add(configurator, "be1260;teb154");
cds.configurator.DefaultRule.add(configurator, "be1260;teb168");
cds.configurator.DefaultRule.add(configurator, "be1260;teb180");
cds.configurator.DefaultRule.add(configurator, "be1260;teb192");
cds.configurator.DefaultRule.add(configurator, "be1260;teb200");
cds.configurator.DefaultRule.add(configurator, "be1260;teb216");
cds.configurator.DefaultRule.add(configurator, "be1260;teb224");
cds.configurator.DefaultRule.add(configurator, "be1417;sehhh");
cds.configurator.DefaultRule.add(configurator, "be1417;selll");
cds.configurator.DefaultRule.add(configurator, "be1417;semxl");
cds.configurator.DefaultRule.add(configurator, "be1417;sexll");
cds.configurator.DefaultRule.add(configurator, "be1417;sma05");
cds.configurator.DefaultRule.add(configurator, "be1417;sma10");
cds.configurator.DefaultRule.add(configurator, "be1417;smh03");
cds.configurator.DefaultRule.add(configurator, "be1417;smh05");
cds.configurator.DefaultRule.add(configurator, "be1417;smh08");
cds.configurator.DefaultRule.add(configurator, "be1417;smt05");
cds.configurator.DefaultRule.add(configurator, "be1417;smt10");
cds.configurator.DefaultRule.add(configurator, "be1417;smt25");
cds.configurator.DefaultRule.add(configurator, "be1417;tea010");
cds.configurator.DefaultRule.add(configurator, "be1417;tea011");
cds.configurator.DefaultRule.add(configurator, "be1417;tea012");
cds.configurator.DefaultRule.add(configurator, "be1417;tea013");
cds.configurator.DefaultRule.add(configurator, "be1417;tea014");
cds.configurator.DefaultRule.add(configurator, "be1417;tea015");
cds.configurator.DefaultRule.add(configurator, "be1417;tea016");
cds.configurator.DefaultRule.add(configurator, "be1417;tea017");
cds.configurator.DefaultRule.add(configurator, "be1417;tea018");
cds.configurator.DefaultRule.add(configurator, "be1417;tea019");
cds.configurator.DefaultRule.add(configurator, "be1417;tea020");
cds.configurator.DefaultRule.add(configurator, "be1417;tea021");
cds.configurator.DefaultRule.add(configurator, "be1417;tea023");
cds.configurator.DefaultRule.add(configurator, "be1417;tea024");
cds.configurator.DefaultRule.add(configurator, "be1417;tea026");
cds.configurator.DefaultRule.add(configurator, "be1417;tea027");
cds.configurator.DefaultRule.add(configurator, "be1417;tea029");
cds.configurator.DefaultRule.add(configurator, "be1417;tea031");
cds.configurator.DefaultRule.add(configurator, "be1417;tea043");
cds.configurator.DefaultRule.add(configurator, "be1417;tea044");
cds.configurator.DefaultRule.add(configurator, "be1417;tea046");
cds.configurator.DefaultRule.add(configurator, "be1417;tea052");
cds.configurator.DefaultRule.add(configurator, "be1417;tea062");
cds.configurator.DefaultRule.add(configurator, "be1417;tea064");
cds.configurator.DefaultRule.add(configurator, "be1417;tea068");
cds.configurator.DefaultRule.add(configurator, "be1417;tea070");
cds.configurator.DefaultRule.add(configurator, "be1417;tea072");
cds.configurator.DefaultRule.add(configurator, "be1417;tea074");
cds.configurator.DefaultRule.add(configurator, "be1417;tea084");
cds.configurator.DefaultRule.add(configurator, "be1417;tea096");
cds.configurator.DefaultRule.add(configurator, "be1417;tea100");
cds.configurator.DefaultRule.add(configurator, "be1417;tea120");
cds.configurator.DefaultRule.add(configurator, "be1417;tea126");
cds.configurator.DefaultRule.add(configurator, "be1417;tea144");
cds.configurator.DefaultRule.add(configurator, "be1417;tea154");
cds.configurator.DefaultRule.add(configurator, "be1417;tea168");
cds.configurator.DefaultRule.add(configurator, "be1417;tea192");
cds.configurator.DefaultRule.add(configurator, "be1417;tea200");
cds.configurator.DefaultRule.add(configurator, "be1417;tea216");
cds.configurator.DefaultRule.add(configurator, "be1417;teb010");
cds.configurator.DefaultRule.add(configurator, "be1417;teb011");
cds.configurator.DefaultRule.add(configurator, "be1417;teb012");
cds.configurator.DefaultRule.add(configurator, "be1417;teb013");
cds.configurator.DefaultRule.add(configurator, "be1417;teb014");
cds.configurator.DefaultRule.add(configurator, "be1417;teb015");
cds.configurator.DefaultRule.add(configurator, "be1417;teb016");
cds.configurator.DefaultRule.add(configurator, "be1417;teb017");
cds.configurator.DefaultRule.add(configurator, "be1417;teb018");
cds.configurator.DefaultRule.add(configurator, "be1417;teb019");
cds.configurator.DefaultRule.add(configurator, "be1417;teb020");
cds.configurator.DefaultRule.add(configurator, "be1417;teb021");
cds.configurator.DefaultRule.add(configurator, "be1417;teb023");
cds.configurator.DefaultRule.add(configurator, "be1417;teb024");
cds.configurator.DefaultRule.add(configurator, "be1417;teb026");
cds.configurator.DefaultRule.add(configurator, "be1417;teb027");
cds.configurator.DefaultRule.add(configurator, "be1417;teb029");
cds.configurator.DefaultRule.add(configurator, "be1417;teb031");
cds.configurator.DefaultRule.add(configurator, "be1417;teb043");
cds.configurator.DefaultRule.add(configurator, "be1417;teb044");
cds.configurator.DefaultRule.add(configurator, "be1417;teb046");
cds.configurator.DefaultRule.add(configurator, "be1417;teb052");
cds.configurator.DefaultRule.add(configurator, "be1417;teb062");
cds.configurator.DefaultRule.add(configurator, "be1417;teb064");
cds.configurator.DefaultRule.add(configurator, "be1417;teb068");
cds.configurator.DefaultRule.add(configurator, "be1417;teb070");
cds.configurator.DefaultRule.add(configurator, "be1417;teb072");
cds.configurator.DefaultRule.add(configurator, "be1417;teb074");
cds.configurator.DefaultRule.add(configurator, "be1417;teb084");
cds.configurator.DefaultRule.add(configurator, "be1417;teb096");
cds.configurator.DefaultRule.add(configurator, "be1417;teb100");
cds.configurator.DefaultRule.add(configurator, "be1417;teb120");
cds.configurator.DefaultRule.add(configurator, "be1417;teb126");
cds.configurator.DefaultRule.add(configurator, "be1417;teb144");
cds.configurator.DefaultRule.add(configurator, "be1417;teb154");
cds.configurator.DefaultRule.add(configurator, "be1417;teb168");
cds.configurator.DefaultRule.add(configurator, "be1417;teb192");
cds.configurator.DefaultRule.add(configurator, "be1417;teb200");
cds.configurator.DefaultRule.add(configurator, "be1417;teb216");
cds.configurator.DefaultRule.add(configurator, "be1457;sehhh");
cds.configurator.DefaultRule.add(configurator, "be1457;selll");
cds.configurator.DefaultRule.add(configurator, "be1457;semxl");
cds.configurator.DefaultRule.add(configurator, "be1457;sexll");
cds.configurator.DefaultRule.add(configurator, "be1457;sma05");
cds.configurator.DefaultRule.add(configurator, "be1457;sma10");
cds.configurator.DefaultRule.add(configurator, "be1457;smh03");
cds.configurator.DefaultRule.add(configurator, "be1457;smh05");
cds.configurator.DefaultRule.add(configurator, "be1457;smh08");
cds.configurator.DefaultRule.add(configurator, "be1457;smt05");
cds.configurator.DefaultRule.add(configurator, "be1457;smt10");
cds.configurator.DefaultRule.add(configurator, "be1457;smt25");
cds.configurator.DefaultRule.add(configurator, "be1457;tea010");
cds.configurator.DefaultRule.add(configurator, "be1457;tea011");
cds.configurator.DefaultRule.add(configurator, "be1457;tea012");
cds.configurator.DefaultRule.add(configurator, "be1457;tea013");
cds.configurator.DefaultRule.add(configurator, "be1457;tea014");
cds.configurator.DefaultRule.add(configurator, "be1457;tea015");
cds.configurator.DefaultRule.add(configurator, "be1457;tea016");
cds.configurator.DefaultRule.add(configurator, "be1457;tea017");
cds.configurator.DefaultRule.add(configurator, "be1457;tea018");
cds.configurator.DefaultRule.add(configurator, "be1457;tea019");
cds.configurator.DefaultRule.add(configurator, "be1457;tea020");
cds.configurator.DefaultRule.add(configurator, "be1457;tea021");
cds.configurator.DefaultRule.add(configurator, "be1457;tea022");
cds.configurator.DefaultRule.add(configurator, "be1457;tea023");
cds.configurator.DefaultRule.add(configurator, "be1457;tea024");
cds.configurator.DefaultRule.add(configurator, "be1457;tea025");
cds.configurator.DefaultRule.add(configurator, "be1457;tea026");
cds.configurator.DefaultRule.add(configurator, "be1457;tea027");
cds.configurator.DefaultRule.add(configurator, "be1457;tea041");
cds.configurator.DefaultRule.add(configurator, "be1457;tea042");
cds.configurator.DefaultRule.add(configurator, "be1457;tea044");
cds.configurator.DefaultRule.add(configurator, "be1457;tea046");
cds.configurator.DefaultRule.add(configurator, "be1457;tea052");
cds.configurator.DefaultRule.add(configurator, "be1457;tea062");
cds.configurator.DefaultRule.add(configurator, "be1457;tea064");
cds.configurator.DefaultRule.add(configurator, "be1457;tea068");
cds.configurator.DefaultRule.add(configurator, "be1457;tea070");
cds.configurator.DefaultRule.add(configurator, "be1457;tea072");
cds.configurator.DefaultRule.add(configurator, "be1457;tea074");
cds.configurator.DefaultRule.add(configurator, "be1457;tea084");
cds.configurator.DefaultRule.add(configurator, "be1457;tea096");
cds.configurator.DefaultRule.add(configurator, "be1457;tea100");
cds.configurator.DefaultRule.add(configurator, "be1457;tea120");
cds.configurator.DefaultRule.add(configurator, "be1457;tea144");
cds.configurator.DefaultRule.add(configurator, "be1457;tea192");
cds.configurator.DefaultRule.add(configurator, "be1457;tea216");
cds.configurator.DefaultRule.add(configurator, "be1457;teb010");
cds.configurator.DefaultRule.add(configurator, "be1457;teb011");
cds.configurator.DefaultRule.add(configurator, "be1457;teb012");
cds.configurator.DefaultRule.add(configurator, "be1457;teb013");
cds.configurator.DefaultRule.add(configurator, "be1457;teb014");
cds.configurator.DefaultRule.add(configurator, "be1457;teb015");
cds.configurator.DefaultRule.add(configurator, "be1457;teb016");
cds.configurator.DefaultRule.add(configurator, "be1457;teb017");
cds.configurator.DefaultRule.add(configurator, "be1457;teb018");
cds.configurator.DefaultRule.add(configurator, "be1457;teb019");
cds.configurator.DefaultRule.add(configurator, "be1457;teb020");
cds.configurator.DefaultRule.add(configurator, "be1457;teb021");
cds.configurator.DefaultRule.add(configurator, "be1457;teb022");
cds.configurator.DefaultRule.add(configurator, "be1457;teb023");
cds.configurator.DefaultRule.add(configurator, "be1457;teb024");
cds.configurator.DefaultRule.add(configurator, "be1457;teb025");
cds.configurator.DefaultRule.add(configurator, "be1457;teb026");
cds.configurator.DefaultRule.add(configurator, "be1457;teb027");
cds.configurator.DefaultRule.add(configurator, "be1457;teb041");
cds.configurator.DefaultRule.add(configurator, "be1457;teb042");
cds.configurator.DefaultRule.add(configurator, "be1457;teb044");
cds.configurator.DefaultRule.add(configurator, "be1457;teb046");
cds.configurator.DefaultRule.add(configurator, "be1457;teb052");
cds.configurator.DefaultRule.add(configurator, "be1457;teb062");
cds.configurator.DefaultRule.add(configurator, "be1457;teb064");
cds.configurator.DefaultRule.add(configurator, "be1457;teb068");
cds.configurator.DefaultRule.add(configurator, "be1457;teb070");
cds.configurator.DefaultRule.add(configurator, "be1457;teb072");
cds.configurator.DefaultRule.add(configurator, "be1457;teb074");
cds.configurator.DefaultRule.add(configurator, "be1457;teb084");
cds.configurator.DefaultRule.add(configurator, "be1457;teb096");
cds.configurator.DefaultRule.add(configurator, "be1457;teb100");
cds.configurator.DefaultRule.add(configurator, "be1457;teb120");
cds.configurator.DefaultRule.add(configurator, "be1457;teb144");
cds.configurator.DefaultRule.add(configurator, "be1457;teb192");
cds.configurator.DefaultRule.add(configurator, "be1457;teb216");
cds.configurator.DefaultRule.add(configurator, "be1500;selll");
cds.configurator.DefaultRule.add(configurator, "be1500;semxl");
cds.configurator.DefaultRule.add(configurator, "be1500;sexll");
cds.configurator.DefaultRule.add(configurator, "be1500;sma05");
cds.configurator.DefaultRule.add(configurator, "be1500;sma10");
cds.configurator.DefaultRule.add(configurator, "be1500;smh03");
cds.configurator.DefaultRule.add(configurator, "be1500;smh05");
cds.configurator.DefaultRule.add(configurator, "be1500;smh08");
cds.configurator.DefaultRule.add(configurator, "be1500;smt05");
cds.configurator.DefaultRule.add(configurator, "be1500;smt10");
cds.configurator.DefaultRule.add(configurator, "be1500;smt25");
cds.configurator.DefaultRule.add(configurator, "be1500;tea010");
cds.configurator.DefaultRule.add(configurator, "be1500;tea011");
cds.configurator.DefaultRule.add(configurator, "be1500;tea012");
cds.configurator.DefaultRule.add(configurator, "be1500;tea013");
cds.configurator.DefaultRule.add(configurator, "be1500;tea015");
cds.configurator.DefaultRule.add(configurator, "be1500;tea023");
cds.configurator.DefaultRule.add(configurator, "be1500;tea025");
cds.configurator.DefaultRule.add(configurator, "be1500;tea027");
cds.configurator.DefaultRule.add(configurator, "be1500;tea029");
cds.configurator.DefaultRule.add(configurator, "be1500;tea031");
cds.configurator.DefaultRule.add(configurator, "be1500;tea033");
cds.configurator.DefaultRule.add(configurator, "be1500;tea034");
cds.configurator.DefaultRule.add(configurator, "be1500;tea035");
cds.configurator.DefaultRule.add(configurator, "be1500;tea037");
cds.configurator.DefaultRule.add(configurator, "be1500;tea038");
cds.configurator.DefaultRule.add(configurator, "be1500;tea039");
cds.configurator.DefaultRule.add(configurator, "be1500;tea041");
cds.configurator.DefaultRule.add(configurator, "be1500;tea042");
cds.configurator.DefaultRule.add(configurator, "be1500;tea043");
cds.configurator.DefaultRule.add(configurator, "be1500;tea045");
cds.configurator.DefaultRule.add(configurator, "be1500;tea046");
cds.configurator.DefaultRule.add(configurator, "be1500;tea050");
cds.configurator.DefaultRule.add(configurator, "be1500;tea052");
cds.configurator.DefaultRule.add(configurator, "be1500;tea053");
cds.configurator.DefaultRule.add(configurator, "be1500;tea056");
cds.configurator.DefaultRule.add(configurator, "be1500;tea062");
cds.configurator.DefaultRule.add(configurator, "be1500;tea063");
cds.configurator.DefaultRule.add(configurator, "be1500;tea064");
cds.configurator.DefaultRule.add(configurator, "be1500;tea067");
cds.configurator.DefaultRule.add(configurator, "be1500;tea068");
cds.configurator.DefaultRule.add(configurator, "be1500;tea070");
cds.configurator.DefaultRule.add(configurator, "be1500;tea071");
cds.configurator.DefaultRule.add(configurator, "be1500;tea074");
cds.configurator.DefaultRule.add(configurator, "be1500;tea075");
cds.configurator.DefaultRule.add(configurator, "be1500;tea080");
cds.configurator.DefaultRule.add(configurator, "be1500;tea090");
cds.configurator.DefaultRule.add(configurator, "be1500;tea100");
cds.configurator.DefaultRule.add(configurator, "be1500;tea112");
cds.configurator.DefaultRule.add(configurator, "be1500;tea126");
cds.configurator.DefaultRule.add(configurator, "be1500;tea140");
cds.configurator.DefaultRule.add(configurator, "be1500;tea144");
cds.configurator.DefaultRule.add(configurator, "be1500;tea154");
cds.configurator.DefaultRule.add(configurator, "be1500;tea168");
cds.configurator.DefaultRule.add(configurator, "be1500;tea180");
cds.configurator.DefaultRule.add(configurator, "be1500;tea192");
cds.configurator.DefaultRule.add(configurator, "be1500;tea200");
cds.configurator.DefaultRule.add(configurator, "be1500;tea216");
cds.configurator.DefaultRule.add(configurator, "be1500;tea224");
cds.configurator.DefaultRule.add(configurator, "be1500;teb010");
cds.configurator.DefaultRule.add(configurator, "be1500;teb011");
cds.configurator.DefaultRule.add(configurator, "be1500;teb012");
cds.configurator.DefaultRule.add(configurator, "be1500;teb013");
cds.configurator.DefaultRule.add(configurator, "be1500;teb015");
cds.configurator.DefaultRule.add(configurator, "be1500;teb023");
cds.configurator.DefaultRule.add(configurator, "be1500;teb025");
cds.configurator.DefaultRule.add(configurator, "be1500;teb027");
cds.configurator.DefaultRule.add(configurator, "be1500;teb029");
cds.configurator.DefaultRule.add(configurator, "be1500;teb031");
cds.configurator.DefaultRule.add(configurator, "be1500;teb033");
cds.configurator.DefaultRule.add(configurator, "be1500;teb034");
cds.configurator.DefaultRule.add(configurator, "be1500;teb035");
cds.configurator.DefaultRule.add(configurator, "be1500;teb037");
cds.configurator.DefaultRule.add(configurator, "be1500;teb038");
cds.configurator.DefaultRule.add(configurator, "be1500;teb039");
cds.configurator.DefaultRule.add(configurator, "be1500;teb041");
cds.configurator.DefaultRule.add(configurator, "be1500;teb042");
cds.configurator.DefaultRule.add(configurator, "be1500;teb043");
cds.configurator.DefaultRule.add(configurator, "be1500;teb045");
cds.configurator.DefaultRule.add(configurator, "be1500;teb046");
cds.configurator.DefaultRule.add(configurator, "be1500;teb050");
cds.configurator.DefaultRule.add(configurator, "be1500;teb052");
cds.configurator.DefaultRule.add(configurator, "be1500;teb053");
cds.configurator.DefaultRule.add(configurator, "be1500;teb056");
cds.configurator.DefaultRule.add(configurator, "be1500;teb062");
cds.configurator.DefaultRule.add(configurator, "be1500;teb063");
cds.configurator.DefaultRule.add(configurator, "be1500;teb064");
cds.configurator.DefaultRule.add(configurator, "be1500;teb067");
cds.configurator.DefaultRule.add(configurator, "be1500;teb068");
cds.configurator.DefaultRule.add(configurator, "be1500;teb070");
cds.configurator.DefaultRule.add(configurator, "be1500;teb071");
cds.configurator.DefaultRule.add(configurator, "be1500;teb074");
cds.configurator.DefaultRule.add(configurator, "be1500;teb075");
cds.configurator.DefaultRule.add(configurator, "be1500;teb080");
cds.configurator.DefaultRule.add(configurator, "be1500;teb090");
cds.configurator.DefaultRule.add(configurator, "be1500;teb100");
cds.configurator.DefaultRule.add(configurator, "be1500;teb112");
cds.configurator.DefaultRule.add(configurator, "be1500;teb126");
cds.configurator.DefaultRule.add(configurator, "be1500;teb140");
cds.configurator.DefaultRule.add(configurator, "be1500;teb144");
cds.configurator.DefaultRule.add(configurator, "be1500;teb154");
cds.configurator.DefaultRule.add(configurator, "be1500;teb168");
cds.configurator.DefaultRule.add(configurator, "be1500;teb180");
cds.configurator.DefaultRule.add(configurator, "be1500;teb192");
cds.configurator.DefaultRule.add(configurator, "be1500;teb200");
cds.configurator.DefaultRule.add(configurator, "be1500;teb216");
cds.configurator.DefaultRule.add(configurator, "be1500;teb224");
cds.configurator.DefaultRule.add(configurator, "be1575;sehhh");
cds.configurator.DefaultRule.add(configurator, "be1575;selll");
cds.configurator.DefaultRule.add(configurator, "be1575;semxl");
cds.configurator.DefaultRule.add(configurator, "be1575;sexll");
cds.configurator.DefaultRule.add(configurator, "be1575;sma05");
cds.configurator.DefaultRule.add(configurator, "be1575;sma10");
cds.configurator.DefaultRule.add(configurator, "be1575;smh03");
cds.configurator.DefaultRule.add(configurator, "be1575;smh05");
cds.configurator.DefaultRule.add(configurator, "be1575;smh08");
cds.configurator.DefaultRule.add(configurator, "be1575;smt05");
cds.configurator.DefaultRule.add(configurator, "be1575;smt10");
cds.configurator.DefaultRule.add(configurator, "be1575;smt25");
cds.configurator.DefaultRule.add(configurator, "be1575;tea010");
cds.configurator.DefaultRule.add(configurator, "be1575;tea011");
cds.configurator.DefaultRule.add(configurator, "be1575;tea012");
cds.configurator.DefaultRule.add(configurator, "be1575;tea013");
cds.configurator.DefaultRule.add(configurator, "be1575;tea014");
cds.configurator.DefaultRule.add(configurator, "be1575;tea015");
cds.configurator.DefaultRule.add(configurator, "be1575;tea016");
cds.configurator.DefaultRule.add(configurator, "be1575;tea017");
cds.configurator.DefaultRule.add(configurator, "be1575;tea018");
cds.configurator.DefaultRule.add(configurator, "be1575;tea019");
cds.configurator.DefaultRule.add(configurator, "be1575;tea020");
cds.configurator.DefaultRule.add(configurator, "be1575;tea021");
cds.configurator.DefaultRule.add(configurator, "be1575;tea022");
cds.configurator.DefaultRule.add(configurator, "be1575;tea023");
cds.configurator.DefaultRule.add(configurator, "be1575;tea024");
cds.configurator.DefaultRule.add(configurator, "be1575;tea025");
cds.configurator.DefaultRule.add(configurator, "be1575;tea026");
cds.configurator.DefaultRule.add(configurator, "be1575;tea027");
cds.configurator.DefaultRule.add(configurator, "be1575;tea041");
cds.configurator.DefaultRule.add(configurator, "be1575;tea043");
cds.configurator.DefaultRule.add(configurator, "be1575;tea045");
cds.configurator.DefaultRule.add(configurator, "be1575;tea053");
cds.configurator.DefaultRule.add(configurator, "be1575;tea062");
cds.configurator.DefaultRule.add(configurator, "be1575;tea063");
cds.configurator.DefaultRule.add(configurator, "be1575;tea067");
cds.configurator.DefaultRule.add(configurator, "be1575;tea070");
cds.configurator.DefaultRule.add(configurator, "be1575;tea071");
cds.configurator.DefaultRule.add(configurator, "be1575;tea074");
cds.configurator.DefaultRule.add(configurator, "be1575;tea075");
cds.configurator.DefaultRule.add(configurator, "be1575;tea084");
cds.configurator.DefaultRule.add(configurator, "be1575;tea096");
cds.configurator.DefaultRule.add(configurator, "be1575;tea100");
cds.configurator.DefaultRule.add(configurator, "be1575;tea120");
cds.configurator.DefaultRule.add(configurator, "be1575;tea126");
cds.configurator.DefaultRule.add(configurator, "be1575;tea140");
cds.configurator.DefaultRule.add(configurator, "be1575;tea154");
cds.configurator.DefaultRule.add(configurator, "be1575;tea180");
cds.configurator.DefaultRule.add(configurator, "be1575;tea200");
cds.configurator.DefaultRule.add(configurator, "be1575;tea216");
cds.configurator.DefaultRule.add(configurator, "be1575;tea224");
cds.configurator.DefaultRule.add(configurator, "be1575;teb010");
cds.configurator.DefaultRule.add(configurator, "be1575;teb011");
cds.configurator.DefaultRule.add(configurator, "be1575;teb012");
cds.configurator.DefaultRule.add(configurator, "be1575;teb013");
cds.configurator.DefaultRule.add(configurator, "be1575;teb014");
cds.configurator.DefaultRule.add(configurator, "be1575;teb015");
cds.configurator.DefaultRule.add(configurator, "be1575;teb016");
cds.configurator.DefaultRule.add(configurator, "be1575;teb017");
cds.configurator.DefaultRule.add(configurator, "be1575;teb018");
cds.configurator.DefaultRule.add(configurator, "be1575;teb019");
cds.configurator.DefaultRule.add(configurator, "be1575;teb020");
cds.configurator.DefaultRule.add(configurator, "be1575;teb021");
cds.configurator.DefaultRule.add(configurator, "be1575;teb022");
cds.configurator.DefaultRule.add(configurator, "be1575;teb023");
cds.configurator.DefaultRule.add(configurator, "be1575;teb024");
cds.configurator.DefaultRule.add(configurator, "be1575;teb025");
cds.configurator.DefaultRule.add(configurator, "be1575;teb026");
cds.configurator.DefaultRule.add(configurator, "be1575;teb027");
cds.configurator.DefaultRule.add(configurator, "be1575;teb041");
cds.configurator.DefaultRule.add(configurator, "be1575;teb043");
cds.configurator.DefaultRule.add(configurator, "be1575;teb045");
cds.configurator.DefaultRule.add(configurator, "be1575;teb053");
cds.configurator.DefaultRule.add(configurator, "be1575;teb062");
cds.configurator.DefaultRule.add(configurator, "be1575;teb063");
cds.configurator.DefaultRule.add(configurator, "be1575;teb067");
cds.configurator.DefaultRule.add(configurator, "be1575;teb070");
cds.configurator.DefaultRule.add(configurator, "be1575;teb071");
cds.configurator.DefaultRule.add(configurator, "be1575;teb074");
cds.configurator.DefaultRule.add(configurator, "be1575;teb075");
cds.configurator.DefaultRule.add(configurator, "be1575;teb084");
cds.configurator.DefaultRule.add(configurator, "be1575;teb096");
cds.configurator.DefaultRule.add(configurator, "be1575;teb100");
cds.configurator.DefaultRule.add(configurator, "be1575;teb120");
cds.configurator.DefaultRule.add(configurator, "be1575;teb126");
cds.configurator.DefaultRule.add(configurator, "be1575;teb140");
cds.configurator.DefaultRule.add(configurator, "be1575;teb154");
cds.configurator.DefaultRule.add(configurator, "be1575;teb180");
cds.configurator.DefaultRule.add(configurator, "be1575;teb200");
cds.configurator.DefaultRule.add(configurator, "be1575;teb216");
cds.configurator.DefaultRule.add(configurator, "be1575;teb224");
cds.configurator.DefaultRule.add(configurator, "be1969;sehhh");
cds.configurator.DefaultRule.add(configurator, "be1969;selll");
cds.configurator.DefaultRule.add(configurator, "be1969;semxl");
cds.configurator.DefaultRule.add(configurator, "be1969;sexll");
cds.configurator.DefaultRule.add(configurator, "be1969;sma05");
cds.configurator.DefaultRule.add(configurator, "be1969;smh03");
cds.configurator.DefaultRule.add(configurator, "be1969;smh05");
cds.configurator.DefaultRule.add(configurator, "be1969;smt05");
cds.configurator.DefaultRule.add(configurator, "be1969;smt25");
cds.configurator.DefaultRule.add(configurator, "be1969;tea010");
cds.configurator.DefaultRule.add(configurator, "be1969;tea011");
cds.configurator.DefaultRule.add(configurator, "be1969;tea012");
cds.configurator.DefaultRule.add(configurator, "be1969;tea013");
cds.configurator.DefaultRule.add(configurator, "be1969;tea014");
cds.configurator.DefaultRule.add(configurator, "be1969;tea015");
cds.configurator.DefaultRule.add(configurator, "be1969;tea016");
cds.configurator.DefaultRule.add(configurator, "be1969;tea017");
cds.configurator.DefaultRule.add(configurator, "be1969;tea021");
cds.configurator.DefaultRule.add(configurator, "be1969;tea023");
cds.configurator.DefaultRule.add(configurator, "be1969;tea026");
cds.configurator.DefaultRule.add(configurator, "be1969;tea029");
cds.configurator.DefaultRule.add(configurator, "be1969;tea031");
cds.configurator.DefaultRule.add(configurator, "be1969;tea033");
cds.configurator.DefaultRule.add(configurator, "be1969;tea035");
cds.configurator.DefaultRule.add(configurator, "be1969;tea037");
cds.configurator.DefaultRule.add(configurator, "be1969;tea039");
cds.configurator.DefaultRule.add(configurator, "be1969;tea041");
cds.configurator.DefaultRule.add(configurator, "be1969;tea042");
cds.configurator.DefaultRule.add(configurator, "be1969;tea043");
cds.configurator.DefaultRule.add(configurator, "be1969;tea045");
cds.configurator.DefaultRule.add(configurator, "be1969;tea046");
cds.configurator.DefaultRule.add(configurator, "be1969;tea050");
cds.configurator.DefaultRule.add(configurator, "be1969;tea052");
cds.configurator.DefaultRule.add(configurator, "be1969;tea053");
cds.configurator.DefaultRule.add(configurator, "be1969;tea062");
cds.configurator.DefaultRule.add(configurator, "be1969;tea063");
cds.configurator.DefaultRule.add(configurator, "be1969;tea067");
cds.configurator.DefaultRule.add(configurator, "be1969;tea068");
cds.configurator.DefaultRule.add(configurator, "be1969;tea070");
cds.configurator.DefaultRule.add(configurator, "be1969;tea071");
cds.configurator.DefaultRule.add(configurator, "be1969;tea074");
cds.configurator.DefaultRule.add(configurator, "be1969;tea075");
cds.configurator.DefaultRule.add(configurator, "be1969;tea084");
cds.configurator.DefaultRule.add(configurator, "be1969;tea096");
cds.configurator.DefaultRule.add(configurator, "be1969;tea100");
cds.configurator.DefaultRule.add(configurator, "be1969;tea120");
cds.configurator.DefaultRule.add(configurator, "be1969;tea126");
cds.configurator.DefaultRule.add(configurator, "be1969;tea140");
cds.configurator.DefaultRule.add(configurator, "be1969;tea154");
cds.configurator.DefaultRule.add(configurator, "be1969;tea168");
cds.configurator.DefaultRule.add(configurator, "be1969;tea180");
cds.configurator.DefaultRule.add(configurator, "be1969;tea200");
cds.configurator.DefaultRule.add(configurator, "be1969;tea216");
cds.configurator.DefaultRule.add(configurator, "be1969;tea224");
cds.configurator.DefaultRule.add(configurator, "be1969;teb010");
cds.configurator.DefaultRule.add(configurator, "be1969;teb011");
cds.configurator.DefaultRule.add(configurator, "be1969;teb012");
cds.configurator.DefaultRule.add(configurator, "be1969;teb013");
cds.configurator.DefaultRule.add(configurator, "be1969;teb014");
cds.configurator.DefaultRule.add(configurator, "be1969;teb015");
cds.configurator.DefaultRule.add(configurator, "be1969;teb016");
cds.configurator.DefaultRule.add(configurator, "be1969;teb017");
cds.configurator.DefaultRule.add(configurator, "be1969;teb021");
cds.configurator.DefaultRule.add(configurator, "be1969;teb023");
cds.configurator.DefaultRule.add(configurator, "be1969;teb026");
cds.configurator.DefaultRule.add(configurator, "be1969;teb029");
cds.configurator.DefaultRule.add(configurator, "be1969;teb031");
cds.configurator.DefaultRule.add(configurator, "be1969;teb033");
cds.configurator.DefaultRule.add(configurator, "be1969;teb035");
cds.configurator.DefaultRule.add(configurator, "be1969;teb037");
cds.configurator.DefaultRule.add(configurator, "be1969;teb039");
cds.configurator.DefaultRule.add(configurator, "be1969;teb041");
cds.configurator.DefaultRule.add(configurator, "be1969;teb042");
cds.configurator.DefaultRule.add(configurator, "be1969;teb043");
cds.configurator.DefaultRule.add(configurator, "be1969;teb045");
cds.configurator.DefaultRule.add(configurator, "be1969;teb046");
cds.configurator.DefaultRule.add(configurator, "be1969;teb050");
cds.configurator.DefaultRule.add(configurator, "be1969;teb052");
cds.configurator.DefaultRule.add(configurator, "be1969;teb053");
cds.configurator.DefaultRule.add(configurator, "be1969;teb062");
cds.configurator.DefaultRule.add(configurator, "be1969;teb063");
cds.configurator.DefaultRule.add(configurator, "be1969;teb067");
cds.configurator.DefaultRule.add(configurator, "be1969;teb068");
cds.configurator.DefaultRule.add(configurator, "be1969;teb070");
cds.configurator.DefaultRule.add(configurator, "be1969;teb071");
cds.configurator.DefaultRule.add(configurator, "be1969;teb074");
cds.configurator.DefaultRule.add(configurator, "be1969;teb075");
cds.configurator.DefaultRule.add(configurator, "be1969;teb084");
cds.configurator.DefaultRule.add(configurator, "be1969;teb096");
cds.configurator.DefaultRule.add(configurator, "be1969;teb100");
cds.configurator.DefaultRule.add(configurator, "be1969;teb120");
cds.configurator.DefaultRule.add(configurator, "be1969;teb126");
cds.configurator.DefaultRule.add(configurator, "be1969;teb140");
cds.configurator.DefaultRule.add(configurator, "be1969;teb154");
cds.configurator.DefaultRule.add(configurator, "be1969;teb168");
cds.configurator.DefaultRule.add(configurator, "be1969;teb180");
cds.configurator.DefaultRule.add(configurator, "be1969;teb200");
cds.configurator.DefaultRule.add(configurator, "be1969;teb216");
cds.configurator.DefaultRule.add(configurator, "be1969;teb224");
cds.configurator.DefaultRule.add(configurator, "be2000;selll");
cds.configurator.DefaultRule.add(configurator, "be2000;semxl");
cds.configurator.DefaultRule.add(configurator, "be2000;sexll");
cds.configurator.DefaultRule.add(configurator, "be2000;sma05");
cds.configurator.DefaultRule.add(configurator, "be2000;sma10");
cds.configurator.DefaultRule.add(configurator, "be2000;smh03");
cds.configurator.DefaultRule.add(configurator, "be2000;smh05");
cds.configurator.DefaultRule.add(configurator, "be2000;smh08");
cds.configurator.DefaultRule.add(configurator, "be2000;smt05");
cds.configurator.DefaultRule.add(configurator, "be2000;smt10");
cds.configurator.DefaultRule.add(configurator, "be2000;smt25");
cds.configurator.DefaultRule.add(configurator, "be2000;tea010");
cds.configurator.DefaultRule.add(configurator, "be2000;tea011");
cds.configurator.DefaultRule.add(configurator, "be2000;tea012");
cds.configurator.DefaultRule.add(configurator, "be2000;tea013");
cds.configurator.DefaultRule.add(configurator, "be2000;tea015");
cds.configurator.DefaultRule.add(configurator, "be2000;tea023");
cds.configurator.DefaultRule.add(configurator, "be2000;tea025");
cds.configurator.DefaultRule.add(configurator, "be2000;tea027");
cds.configurator.DefaultRule.add(configurator, "be2000;tea029");
cds.configurator.DefaultRule.add(configurator, "be2000;tea031");
cds.configurator.DefaultRule.add(configurator, "be2000;tea033");
cds.configurator.DefaultRule.add(configurator, "be2000;tea034");
cds.configurator.DefaultRule.add(configurator, "be2000;tea035");
cds.configurator.DefaultRule.add(configurator, "be2000;tea037");
cds.configurator.DefaultRule.add(configurator, "be2000;tea038");
cds.configurator.DefaultRule.add(configurator, "be2000;tea039");
cds.configurator.DefaultRule.add(configurator, "be2000;tea041");
cds.configurator.DefaultRule.add(configurator, "be2000;tea042");
cds.configurator.DefaultRule.add(configurator, "be2000;tea043");
cds.configurator.DefaultRule.add(configurator, "be2000;tea045");
cds.configurator.DefaultRule.add(configurator, "be2000;tea046");
cds.configurator.DefaultRule.add(configurator, "be2000;tea050");
cds.configurator.DefaultRule.add(configurator, "be2000;tea052");
cds.configurator.DefaultRule.add(configurator, "be2000;tea053");
cds.configurator.DefaultRule.add(configurator, "be2000;tea056");
cds.configurator.DefaultRule.add(configurator, "be2000;tea062");
cds.configurator.DefaultRule.add(configurator, "be2000;tea063");
cds.configurator.DefaultRule.add(configurator, "be2000;tea064");
cds.configurator.DefaultRule.add(configurator, "be2000;tea067");
cds.configurator.DefaultRule.add(configurator, "be2000;tea068");
cds.configurator.DefaultRule.add(configurator, "be2000;tea070");
cds.configurator.DefaultRule.add(configurator, "be2000;tea071");
cds.configurator.DefaultRule.add(configurator, "be2000;tea074");
cds.configurator.DefaultRule.add(configurator, "be2000;tea075");
cds.configurator.DefaultRule.add(configurator, "be2000;tea080");
cds.configurator.DefaultRule.add(configurator, "be2000;tea090");
cds.configurator.DefaultRule.add(configurator, "be2000;tea100");
cds.configurator.DefaultRule.add(configurator, "be2000;tea112");
cds.configurator.DefaultRule.add(configurator, "be2000;tea126");
cds.configurator.DefaultRule.add(configurator, "be2000;tea140");
cds.configurator.DefaultRule.add(configurator, "be2000;tea144");
cds.configurator.DefaultRule.add(configurator, "be2000;tea154");
cds.configurator.DefaultRule.add(configurator, "be2000;tea168");
cds.configurator.DefaultRule.add(configurator, "be2000;tea180");
cds.configurator.DefaultRule.add(configurator, "be2000;tea192");
cds.configurator.DefaultRule.add(configurator, "be2000;tea200");
cds.configurator.DefaultRule.add(configurator, "be2000;tea216");
cds.configurator.DefaultRule.add(configurator, "be2000;tea224");
cds.configurator.DefaultRule.add(configurator, "be2000;teb010");
cds.configurator.DefaultRule.add(configurator, "be2000;teb011");
cds.configurator.DefaultRule.add(configurator, "be2000;teb012");
cds.configurator.DefaultRule.add(configurator, "be2000;teb013");
cds.configurator.DefaultRule.add(configurator, "be2000;teb015");
cds.configurator.DefaultRule.add(configurator, "be2000;teb023");
cds.configurator.DefaultRule.add(configurator, "be2000;teb025");
cds.configurator.DefaultRule.add(configurator, "be2000;teb027");
cds.configurator.DefaultRule.add(configurator, "be2000;teb029");
cds.configurator.DefaultRule.add(configurator, "be2000;teb031");
cds.configurator.DefaultRule.add(configurator, "be2000;teb033");
cds.configurator.DefaultRule.add(configurator, "be2000;teb034");
cds.configurator.DefaultRule.add(configurator, "be2000;teb035");
cds.configurator.DefaultRule.add(configurator, "be2000;teb037");
cds.configurator.DefaultRule.add(configurator, "be2000;teb038");
cds.configurator.DefaultRule.add(configurator, "be2000;teb039");
cds.configurator.DefaultRule.add(configurator, "be2000;teb041");
cds.configurator.DefaultRule.add(configurator, "be2000;teb042");
cds.configurator.DefaultRule.add(configurator, "be2000;teb043");
cds.configurator.DefaultRule.add(configurator, "be2000;teb045");
cds.configurator.DefaultRule.add(configurator, "be2000;teb046");
cds.configurator.DefaultRule.add(configurator, "be2000;teb050");
cds.configurator.DefaultRule.add(configurator, "be2000;teb052");
cds.configurator.DefaultRule.add(configurator, "be2000;teb053");
cds.configurator.DefaultRule.add(configurator, "be2000;teb056");
cds.configurator.DefaultRule.add(configurator, "be2000;teb062");
cds.configurator.DefaultRule.add(configurator, "be2000;teb063");
cds.configurator.DefaultRule.add(configurator, "be2000;teb064");
cds.configurator.DefaultRule.add(configurator, "be2000;teb067");
cds.configurator.DefaultRule.add(configurator, "be2000;teb068");
cds.configurator.DefaultRule.add(configurator, "be2000;teb070");
cds.configurator.DefaultRule.add(configurator, "be2000;teb071");
cds.configurator.DefaultRule.add(configurator, "be2000;teb074");
cds.configurator.DefaultRule.add(configurator, "be2000;teb075");
cds.configurator.DefaultRule.add(configurator, "be2000;teb080");
cds.configurator.DefaultRule.add(configurator, "be2000;teb090");
cds.configurator.DefaultRule.add(configurator, "be2000;teb100");
cds.configurator.DefaultRule.add(configurator, "be2000;teb112");
cds.configurator.DefaultRule.add(configurator, "be2000;teb126");
cds.configurator.DefaultRule.add(configurator, "be2000;teb140");
cds.configurator.DefaultRule.add(configurator, "be2000;teb144");
cds.configurator.DefaultRule.add(configurator, "be2000;teb154");
cds.configurator.DefaultRule.add(configurator, "be2000;teb168");
cds.configurator.DefaultRule.add(configurator, "be2000;teb180");
cds.configurator.DefaultRule.add(configurator, "be2000;teb192");
cds.configurator.DefaultRule.add(configurator, "be2000;teb200");
cds.configurator.DefaultRule.add(configurator, "be2000;teb216");
cds.configurator.DefaultRule.add(configurator, "be2000;teb224");
cds.configurator.DefaultRule.add(configurator, "be2165;sehhh");
cds.configurator.DefaultRule.add(configurator, "be2165;selll");
cds.configurator.DefaultRule.add(configurator, "be2165;semxl");
cds.configurator.DefaultRule.add(configurator, "be2165;sexll");
cds.configurator.DefaultRule.add(configurator, "be2165;sma05");
cds.configurator.DefaultRule.add(configurator, "be2165;sma10");
cds.configurator.DefaultRule.add(configurator, "be2165;smh03");
cds.configurator.DefaultRule.add(configurator, "be2165;smh05");
cds.configurator.DefaultRule.add(configurator, "be2165;smh08");
cds.configurator.DefaultRule.add(configurator, "be2165;smt05");
cds.configurator.DefaultRule.add(configurator, "be2165;smt10");
cds.configurator.DefaultRule.add(configurator, "be2165;smt25");
cds.configurator.DefaultRule.add(configurator, "be2165;tea010");
cds.configurator.DefaultRule.add(configurator, "be2165;tea011");
cds.configurator.DefaultRule.add(configurator, "be2165;tea012");
cds.configurator.DefaultRule.add(configurator, "be2165;tea013");
cds.configurator.DefaultRule.add(configurator, "be2165;tea014");
cds.configurator.DefaultRule.add(configurator, "be2165;tea015");
cds.configurator.DefaultRule.add(configurator, "be2165;tea016");
cds.configurator.DefaultRule.add(configurator, "be2165;tea017");
cds.configurator.DefaultRule.add(configurator, "be2165;tea018");
cds.configurator.DefaultRule.add(configurator, "be2165;tea019");
cds.configurator.DefaultRule.add(configurator, "be2165;tea020");
cds.configurator.DefaultRule.add(configurator, "be2165;tea021");
cds.configurator.DefaultRule.add(configurator, "be2165;tea022");
cds.configurator.DefaultRule.add(configurator, "be2165;tea023");
cds.configurator.DefaultRule.add(configurator, "be2165;tea024");
cds.configurator.DefaultRule.add(configurator, "be2165;tea025");
cds.configurator.DefaultRule.add(configurator, "be2165;tea026");
cds.configurator.DefaultRule.add(configurator, "be2165;tea027");
cds.configurator.DefaultRule.add(configurator, "be2165;tea031");
cds.configurator.DefaultRule.add(configurator, "be2165;tea033");
cds.configurator.DefaultRule.add(configurator, "be2165;tea035");
cds.configurator.DefaultRule.add(configurator, "be2165;tea037");
cds.configurator.DefaultRule.add(configurator, "be2165;tea039");
cds.configurator.DefaultRule.add(configurator, "be2165;tea041");
cds.configurator.DefaultRule.add(configurator, "be2165;tea042");
cds.configurator.DefaultRule.add(configurator, "be2165;tea043");
cds.configurator.DefaultRule.add(configurator, "be2165;tea045");
cds.configurator.DefaultRule.add(configurator, "be2165;tea046");
cds.configurator.DefaultRule.add(configurator, "be2165;tea050");
cds.configurator.DefaultRule.add(configurator, "be2165;tea053");
cds.configurator.DefaultRule.add(configurator, "be2165;tea062");
cds.configurator.DefaultRule.add(configurator, "be2165;tea063");
cds.configurator.DefaultRule.add(configurator, "be2165;tea067");
cds.configurator.DefaultRule.add(configurator, "be2165;tea070");
cds.configurator.DefaultRule.add(configurator, "be2165;tea071");
cds.configurator.DefaultRule.add(configurator, "be2165;tea074");
cds.configurator.DefaultRule.add(configurator, "be2165;tea075");
cds.configurator.DefaultRule.add(configurator, "be2165;tea084");
cds.configurator.DefaultRule.add(configurator, "be2165;tea096");
cds.configurator.DefaultRule.add(configurator, "be2165;tea100");
cds.configurator.DefaultRule.add(configurator, "be2165;tea120");
cds.configurator.DefaultRule.add(configurator, "be2165;tea126");
cds.configurator.DefaultRule.add(configurator, "be2165;tea140");
cds.configurator.DefaultRule.add(configurator, "be2165;tea154");
cds.configurator.DefaultRule.add(configurator, "be2165;tea180");
cds.configurator.DefaultRule.add(configurator, "be2165;tea200");
cds.configurator.DefaultRule.add(configurator, "be2165;tea216");
cds.configurator.DefaultRule.add(configurator, "be2165;tea224");
cds.configurator.DefaultRule.add(configurator, "be2165;teb010");
cds.configurator.DefaultRule.add(configurator, "be2165;teb011");
cds.configurator.DefaultRule.add(configurator, "be2165;teb012");
cds.configurator.DefaultRule.add(configurator, "be2165;teb013");
cds.configurator.DefaultRule.add(configurator, "be2165;teb014");
cds.configurator.DefaultRule.add(configurator, "be2165;teb015");
cds.configurator.DefaultRule.add(configurator, "be2165;teb016");
cds.configurator.DefaultRule.add(configurator, "be2165;teb017");
cds.configurator.DefaultRule.add(configurator, "be2165;teb018");
cds.configurator.DefaultRule.add(configurator, "be2165;teb019");
cds.configurator.DefaultRule.add(configurator, "be2165;teb020");
cds.configurator.DefaultRule.add(configurator, "be2165;teb021");
cds.configurator.DefaultRule.add(configurator, "be2165;teb022");
cds.configurator.DefaultRule.add(configurator, "be2165;teb023");
cds.configurator.DefaultRule.add(configurator, "be2165;teb024");
cds.configurator.DefaultRule.add(configurator, "be2165;teb025");
cds.configurator.DefaultRule.add(configurator, "be2165;teb026");
cds.configurator.DefaultRule.add(configurator, "be2165;teb027");
cds.configurator.DefaultRule.add(configurator, "be2165;teb031");
cds.configurator.DefaultRule.add(configurator, "be2165;teb033");
cds.configurator.DefaultRule.add(configurator, "be2165;teb035");
cds.configurator.DefaultRule.add(configurator, "be2165;teb037");
cds.configurator.DefaultRule.add(configurator, "be2165;teb039");
cds.configurator.DefaultRule.add(configurator, "be2165;teb041");
cds.configurator.DefaultRule.add(configurator, "be2165;teb042");
cds.configurator.DefaultRule.add(configurator, "be2165;teb043");
cds.configurator.DefaultRule.add(configurator, "be2165;teb045");
cds.configurator.DefaultRule.add(configurator, "be2165;teb046");
cds.configurator.DefaultRule.add(configurator, "be2165;teb050");
cds.configurator.DefaultRule.add(configurator, "be2165;teb053");
cds.configurator.DefaultRule.add(configurator, "be2165;teb062");
cds.configurator.DefaultRule.add(configurator, "be2165;teb063");
cds.configurator.DefaultRule.add(configurator, "be2165;teb067");
cds.configurator.DefaultRule.add(configurator, "be2165;teb070");
cds.configurator.DefaultRule.add(configurator, "be2165;teb071");
cds.configurator.DefaultRule.add(configurator, "be2165;teb074");
cds.configurator.DefaultRule.add(configurator, "be2165;teb075");
cds.configurator.DefaultRule.add(configurator, "be2165;teb084");
cds.configurator.DefaultRule.add(configurator, "be2165;teb096");
cds.configurator.DefaultRule.add(configurator, "be2165;teb100");
cds.configurator.DefaultRule.add(configurator, "be2165;teb120");
cds.configurator.DefaultRule.add(configurator, "be2165;teb126");
cds.configurator.DefaultRule.add(configurator, "be2165;teb140");
cds.configurator.DefaultRule.add(configurator, "be2165;teb154");
cds.configurator.DefaultRule.add(configurator, "be2165;teb180");
cds.configurator.DefaultRule.add(configurator, "be2165;teb200");
cds.configurator.DefaultRule.add(configurator, "be2165;teb216");
cds.configurator.DefaultRule.add(configurator, "be2165;teb224");
cds.configurator.DefaultRule.add(configurator, "be2441;sehhh");
cds.configurator.DefaultRule.add(configurator, "be2441;selll");
cds.configurator.DefaultRule.add(configurator, "be2441;semxl");
cds.configurator.DefaultRule.add(configurator, "be2441;sexll");
cds.configurator.DefaultRule.add(configurator, "be2441;sma05");
cds.configurator.DefaultRule.add(configurator, "be2441;sma10");
cds.configurator.DefaultRule.add(configurator, "be2441;smh03");
cds.configurator.DefaultRule.add(configurator, "be2441;smh05");
cds.configurator.DefaultRule.add(configurator, "be2441;smh08");
cds.configurator.DefaultRule.add(configurator, "be2441;smt05");
cds.configurator.DefaultRule.add(configurator, "be2441;smt10");
cds.configurator.DefaultRule.add(configurator, "be2441;smt25");
cds.configurator.DefaultRule.add(configurator, "be2441;tea010");
cds.configurator.DefaultRule.add(configurator, "be2441;tea011");
cds.configurator.DefaultRule.add(configurator, "be2441;tea012");
cds.configurator.DefaultRule.add(configurator, "be2441;tea013");
cds.configurator.DefaultRule.add(configurator, "be2441;tea014");
cds.configurator.DefaultRule.add(configurator, "be2441;tea015");
cds.configurator.DefaultRule.add(configurator, "be2441;tea016");
cds.configurator.DefaultRule.add(configurator, "be2441;tea017");
cds.configurator.DefaultRule.add(configurator, "be2441;tea018");
cds.configurator.DefaultRule.add(configurator, "be2441;tea019");
cds.configurator.DefaultRule.add(configurator, "be2441;tea020");
cds.configurator.DefaultRule.add(configurator, "be2441;tea021");
cds.configurator.DefaultRule.add(configurator, "be2441;tea023");
cds.configurator.DefaultRule.add(configurator, "be2441;tea024");
cds.configurator.DefaultRule.add(configurator, "be2441;tea026");
cds.configurator.DefaultRule.add(configurator, "be2441;tea027");
cds.configurator.DefaultRule.add(configurator, "be2441;tea029");
cds.configurator.DefaultRule.add(configurator, "be2441;tea031");
cds.configurator.DefaultRule.add(configurator, "be2441;tea033");
cds.configurator.DefaultRule.add(configurator, "be2441;tea035");
cds.configurator.DefaultRule.add(configurator, "be2441;tea037");
cds.configurator.DefaultRule.add(configurator, "be2441;tea039");
cds.configurator.DefaultRule.add(configurator, "be2441;tea041");
cds.configurator.DefaultRule.add(configurator, "be2441;tea043");
cds.configurator.DefaultRule.add(configurator, "be2441;tea044");
cds.configurator.DefaultRule.add(configurator, "be2441;tea046");
cds.configurator.DefaultRule.add(configurator, "be2441;tea052");
cds.configurator.DefaultRule.add(configurator, "be2441;tea062");
cds.configurator.DefaultRule.add(configurator, "be2441;tea064");
cds.configurator.DefaultRule.add(configurator, "be2441;tea068");
cds.configurator.DefaultRule.add(configurator, "be2441;tea070");
cds.configurator.DefaultRule.add(configurator, "be2441;tea072");
cds.configurator.DefaultRule.add(configurator, "be2441;tea074");
cds.configurator.DefaultRule.add(configurator, "be2441;tea084");
cds.configurator.DefaultRule.add(configurator, "be2441;tea096");
cds.configurator.DefaultRule.add(configurator, "be2441;tea100");
cds.configurator.DefaultRule.add(configurator, "be2441;tea120");
cds.configurator.DefaultRule.add(configurator, "be2441;tea126");
cds.configurator.DefaultRule.add(configurator, "be2441;tea144");
cds.configurator.DefaultRule.add(configurator, "be2441;tea154");
cds.configurator.DefaultRule.add(configurator, "be2441;tea168");
cds.configurator.DefaultRule.add(configurator, "be2441;tea192");
cds.configurator.DefaultRule.add(configurator, "be2441;tea200");
cds.configurator.DefaultRule.add(configurator, "be2441;tea216");
cds.configurator.DefaultRule.add(configurator, "be2441;teb010");
cds.configurator.DefaultRule.add(configurator, "be2441;teb011");
cds.configurator.DefaultRule.add(configurator, "be2441;teb012");
cds.configurator.DefaultRule.add(configurator, "be2441;teb013");
cds.configurator.DefaultRule.add(configurator, "be2441;teb014");
cds.configurator.DefaultRule.add(configurator, "be2441;teb015");
cds.configurator.DefaultRule.add(configurator, "be2441;teb016");
cds.configurator.DefaultRule.add(configurator, "be2441;teb017");
cds.configurator.DefaultRule.add(configurator, "be2441;teb018");
cds.configurator.DefaultRule.add(configurator, "be2441;teb019");
cds.configurator.DefaultRule.add(configurator, "be2441;teb020");
cds.configurator.DefaultRule.add(configurator, "be2441;teb021");
cds.configurator.DefaultRule.add(configurator, "be2441;teb023");
cds.configurator.DefaultRule.add(configurator, "be2441;teb024");
cds.configurator.DefaultRule.add(configurator, "be2441;teb026");
cds.configurator.DefaultRule.add(configurator, "be2441;teb027");
cds.configurator.DefaultRule.add(configurator, "be2441;teb029");
cds.configurator.DefaultRule.add(configurator, "be2441;teb031");
cds.configurator.DefaultRule.add(configurator, "be2441;teb033");
cds.configurator.DefaultRule.add(configurator, "be2441;teb035");
cds.configurator.DefaultRule.add(configurator, "be2441;teb037");
cds.configurator.DefaultRule.add(configurator, "be2441;teb039");
cds.configurator.DefaultRule.add(configurator, "be2441;teb041");
cds.configurator.DefaultRule.add(configurator, "be2441;teb043");
cds.configurator.DefaultRule.add(configurator, "be2441;teb044");
cds.configurator.DefaultRule.add(configurator, "be2441;teb046");
cds.configurator.DefaultRule.add(configurator, "be2441;teb052");
cds.configurator.DefaultRule.add(configurator, "be2441;teb062");
cds.configurator.DefaultRule.add(configurator, "be2441;teb064");
cds.configurator.DefaultRule.add(configurator, "be2441;teb068");
cds.configurator.DefaultRule.add(configurator, "be2441;teb070");
cds.configurator.DefaultRule.add(configurator, "be2441;teb072");
cds.configurator.DefaultRule.add(configurator, "be2441;teb074");
cds.configurator.DefaultRule.add(configurator, "be2441;teb084");
cds.configurator.DefaultRule.add(configurator, "be2441;teb096");
cds.configurator.DefaultRule.add(configurator, "be2441;teb100");
cds.configurator.DefaultRule.add(configurator, "be2441;teb120");
cds.configurator.DefaultRule.add(configurator, "be2441;teb126");
cds.configurator.DefaultRule.add(configurator, "be2441;teb144");
cds.configurator.DefaultRule.add(configurator, "be2441;teb154");
cds.configurator.DefaultRule.add(configurator, "be2441;teb168");
cds.configurator.DefaultRule.add(configurator, "be2441;teb192");
cds.configurator.DefaultRule.add(configurator, "be2441;teb200");
cds.configurator.DefaultRule.add(configurator, "be2441;teb216");
cds.configurator.DefaultRule.add(configurator, "be2677;sehhh");
cds.configurator.DefaultRule.add(configurator, "be2677;selll");
cds.configurator.DefaultRule.add(configurator, "be2677;semxl");
cds.configurator.DefaultRule.add(configurator, "be2677;sexll");
cds.configurator.DefaultRule.add(configurator, "be2677;sma05");
cds.configurator.DefaultRule.add(configurator, "be2677;sma10");
cds.configurator.DefaultRule.add(configurator, "be2677;smh03");
cds.configurator.DefaultRule.add(configurator, "be2677;smh05");
cds.configurator.DefaultRule.add(configurator, "be2677;smh08");
cds.configurator.DefaultRule.add(configurator, "be2677;smt05");
cds.configurator.DefaultRule.add(configurator, "be2677;smt10");
cds.configurator.DefaultRule.add(configurator, "be2677;smt25");
cds.configurator.DefaultRule.add(configurator, "be2677;tea010");
cds.configurator.DefaultRule.add(configurator, "be2677;tea011");
cds.configurator.DefaultRule.add(configurator, "be2677;tea012");
cds.configurator.DefaultRule.add(configurator, "be2677;tea013");
cds.configurator.DefaultRule.add(configurator, "be2677;tea014");
cds.configurator.DefaultRule.add(configurator, "be2677;tea015");
cds.configurator.DefaultRule.add(configurator, "be2677;tea016");
cds.configurator.DefaultRule.add(configurator, "be2677;tea017");
cds.configurator.DefaultRule.add(configurator, "be2677;tea018");
cds.configurator.DefaultRule.add(configurator, "be2677;tea019");
cds.configurator.DefaultRule.add(configurator, "be2677;tea020");
cds.configurator.DefaultRule.add(configurator, "be2677;tea021");
cds.configurator.DefaultRule.add(configurator, "be2677;tea022");
cds.configurator.DefaultRule.add(configurator, "be2677;tea023");
cds.configurator.DefaultRule.add(configurator, "be2677;tea024");
cds.configurator.DefaultRule.add(configurator, "be2677;tea025");
cds.configurator.DefaultRule.add(configurator, "be2677;tea026");
cds.configurator.DefaultRule.add(configurator, "be2677;tea027");
cds.configurator.DefaultRule.add(configurator, "be2677;tea041");
cds.configurator.DefaultRule.add(configurator, "be2677;tea042");
cds.configurator.DefaultRule.add(configurator, "be2677;tea044");
cds.configurator.DefaultRule.add(configurator, "be2677;tea046");
cds.configurator.DefaultRule.add(configurator, "be2677;tea052");
cds.configurator.DefaultRule.add(configurator, "be2677;tea062");
cds.configurator.DefaultRule.add(configurator, "be2677;tea064");
cds.configurator.DefaultRule.add(configurator, "be2677;tea068");
cds.configurator.DefaultRule.add(configurator, "be2677;tea070");
cds.configurator.DefaultRule.add(configurator, "be2677;tea072");
cds.configurator.DefaultRule.add(configurator, "be2677;tea074");
cds.configurator.DefaultRule.add(configurator, "be2677;tea084");
cds.configurator.DefaultRule.add(configurator, "be2677;tea096");
cds.configurator.DefaultRule.add(configurator, "be2677;tea100");
cds.configurator.DefaultRule.add(configurator, "be2677;tea120");
cds.configurator.DefaultRule.add(configurator, "be2677;tea126");
cds.configurator.DefaultRule.add(configurator, "be2677;tea144");
cds.configurator.DefaultRule.add(configurator, "be2677;tea154");
cds.configurator.DefaultRule.add(configurator, "be2677;tea192");
cds.configurator.DefaultRule.add(configurator, "be2677;tea216");
cds.configurator.DefaultRule.add(configurator, "be2677;teb010");
cds.configurator.DefaultRule.add(configurator, "be2677;teb011");
cds.configurator.DefaultRule.add(configurator, "be2677;teb012");
cds.configurator.DefaultRule.add(configurator, "be2677;teb013");
cds.configurator.DefaultRule.add(configurator, "be2677;teb014");
cds.configurator.DefaultRule.add(configurator, "be2677;teb015");
cds.configurator.DefaultRule.add(configurator, "be2677;teb016");
cds.configurator.DefaultRule.add(configurator, "be2677;teb017");
cds.configurator.DefaultRule.add(configurator, "be2677;teb018");
cds.configurator.DefaultRule.add(configurator, "be2677;teb019");
cds.configurator.DefaultRule.add(configurator, "be2677;teb020");
cds.configurator.DefaultRule.add(configurator, "be2677;teb021");
cds.configurator.DefaultRule.add(configurator, "be2677;teb022");
cds.configurator.DefaultRule.add(configurator, "be2677;teb023");
cds.configurator.DefaultRule.add(configurator, "be2677;teb024");
cds.configurator.DefaultRule.add(configurator, "be2677;teb025");
cds.configurator.DefaultRule.add(configurator, "be2677;teb026");
cds.configurator.DefaultRule.add(configurator, "be2677;teb027");
cds.configurator.DefaultRule.add(configurator, "be2677;teb041");
cds.configurator.DefaultRule.add(configurator, "be2677;teb042");
cds.configurator.DefaultRule.add(configurator, "be2677;teb044");
cds.configurator.DefaultRule.add(configurator, "be2677;teb046");
cds.configurator.DefaultRule.add(configurator, "be2677;teb052");
cds.configurator.DefaultRule.add(configurator, "be2677;teb062");
cds.configurator.DefaultRule.add(configurator, "be2677;teb064");
cds.configurator.DefaultRule.add(configurator, "be2677;teb068");
cds.configurator.DefaultRule.add(configurator, "be2677;teb070");
cds.configurator.DefaultRule.add(configurator, "be2677;teb072");
cds.configurator.DefaultRule.add(configurator, "be2677;teb074");
cds.configurator.DefaultRule.add(configurator, "be2677;teb084");
cds.configurator.DefaultRule.add(configurator, "be2677;teb096");
cds.configurator.DefaultRule.add(configurator, "be2677;teb100");
cds.configurator.DefaultRule.add(configurator, "be2677;teb120");
cds.configurator.DefaultRule.add(configurator, "be2677;teb126");
cds.configurator.DefaultRule.add(configurator, "be2677;teb144");
cds.configurator.DefaultRule.add(configurator, "be2677;teb154");
cds.configurator.DefaultRule.add(configurator, "be2677;teb192");
cds.configurator.DefaultRule.add(configurator, "be2677;teb216");
cds.configurator.DefaultRule.add(configurator, "be3000;selll");
cds.configurator.DefaultRule.add(configurator, "be3000;semxl");
cds.configurator.DefaultRule.add(configurator, "be3000;sexll");
cds.configurator.DefaultRule.add(configurator, "be3000;sma05");
cds.configurator.DefaultRule.add(configurator, "be3000;sma10");
cds.configurator.DefaultRule.add(configurator, "be3000;smh03");
cds.configurator.DefaultRule.add(configurator, "be3000;smh05");
cds.configurator.DefaultRule.add(configurator, "be3000;smh08");
cds.configurator.DefaultRule.add(configurator, "be3000;smt05");
cds.configurator.DefaultRule.add(configurator, "be3000;smt10");
cds.configurator.DefaultRule.add(configurator, "be3000;smt25");
cds.configurator.DefaultRule.add(configurator, "be3000;tea010");
cds.configurator.DefaultRule.add(configurator, "be3000;tea011");
cds.configurator.DefaultRule.add(configurator, "be3000;tea012");
cds.configurator.DefaultRule.add(configurator, "be3000;tea013");
cds.configurator.DefaultRule.add(configurator, "be3000;tea014");
cds.configurator.DefaultRule.add(configurator, "be3000;tea015");
cds.configurator.DefaultRule.add(configurator, "be3000;tea023");
cds.configurator.DefaultRule.add(configurator, "be3000;tea025");
cds.configurator.DefaultRule.add(configurator, "be3000;tea027");
cds.configurator.DefaultRule.add(configurator, "be3000;tea029");
cds.configurator.DefaultRule.add(configurator, "be3000;tea031");
cds.configurator.DefaultRule.add(configurator, "be3000;tea033");
cds.configurator.DefaultRule.add(configurator, "be3000;tea034");
cds.configurator.DefaultRule.add(configurator, "be3000;tea035");
cds.configurator.DefaultRule.add(configurator, "be3000;tea037");
cds.configurator.DefaultRule.add(configurator, "be3000;tea038");
cds.configurator.DefaultRule.add(configurator, "be3000;tea039");
cds.configurator.DefaultRule.add(configurator, "be3000;tea041");
cds.configurator.DefaultRule.add(configurator, "be3000;tea042");
cds.configurator.DefaultRule.add(configurator, "be3000;tea043");
cds.configurator.DefaultRule.add(configurator, "be3000;tea045");
cds.configurator.DefaultRule.add(configurator, "be3000;tea046");
cds.configurator.DefaultRule.add(configurator, "be3000;tea050");
cds.configurator.DefaultRule.add(configurator, "be3000;tea052");
cds.configurator.DefaultRule.add(configurator, "be3000;tea053");
cds.configurator.DefaultRule.add(configurator, "be3000;tea056");
cds.configurator.DefaultRule.add(configurator, "be3000;tea062");
cds.configurator.DefaultRule.add(configurator, "be3000;tea063");
cds.configurator.DefaultRule.add(configurator, "be3000;tea064");
cds.configurator.DefaultRule.add(configurator, "be3000;tea067");
cds.configurator.DefaultRule.add(configurator, "be3000;tea068");
cds.configurator.DefaultRule.add(configurator, "be3000;tea070");
cds.configurator.DefaultRule.add(configurator, "be3000;tea071");
cds.configurator.DefaultRule.add(configurator, "be3000;tea074");
cds.configurator.DefaultRule.add(configurator, "be3000;tea075");
cds.configurator.DefaultRule.add(configurator, "be3000;tea080");
cds.configurator.DefaultRule.add(configurator, "be3000;tea090");
cds.configurator.DefaultRule.add(configurator, "be3000;tea100");
cds.configurator.DefaultRule.add(configurator, "be3000;tea112");
cds.configurator.DefaultRule.add(configurator, "be3000;tea126");
cds.configurator.DefaultRule.add(configurator, "be3000;tea140");
cds.configurator.DefaultRule.add(configurator, "be3000;tea144");
cds.configurator.DefaultRule.add(configurator, "be3000;tea154");
cds.configurator.DefaultRule.add(configurator, "be3000;tea168");
cds.configurator.DefaultRule.add(configurator, "be3000;tea180");
cds.configurator.DefaultRule.add(configurator, "be3000;tea192");
cds.configurator.DefaultRule.add(configurator, "be3000;tea200");
cds.configurator.DefaultRule.add(configurator, "be3000;tea216");
cds.configurator.DefaultRule.add(configurator, "be3000;tea224");
cds.configurator.DefaultRule.add(configurator, "be3000;teb010");
cds.configurator.DefaultRule.add(configurator, "be3000;teb011");
cds.configurator.DefaultRule.add(configurator, "be3000;teb012");
cds.configurator.DefaultRule.add(configurator, "be3000;teb013");
cds.configurator.DefaultRule.add(configurator, "be3000;teb014");
cds.configurator.DefaultRule.add(configurator, "be3000;teb015");
cds.configurator.DefaultRule.add(configurator, "be3000;teb023");
cds.configurator.DefaultRule.add(configurator, "be3000;teb025");
cds.configurator.DefaultRule.add(configurator, "be3000;teb027");
cds.configurator.DefaultRule.add(configurator, "be3000;teb029");
cds.configurator.DefaultRule.add(configurator, "be3000;teb031");
cds.configurator.DefaultRule.add(configurator, "be3000;teb033");
cds.configurator.DefaultRule.add(configurator, "be3000;teb034");
cds.configurator.DefaultRule.add(configurator, "be3000;teb035");
cds.configurator.DefaultRule.add(configurator, "be3000;teb037");
cds.configurator.DefaultRule.add(configurator, "be3000;teb038");
cds.configurator.DefaultRule.add(configurator, "be3000;teb039");
cds.configurator.DefaultRule.add(configurator, "be3000;teb041");
cds.configurator.DefaultRule.add(configurator, "be3000;teb042");
cds.configurator.DefaultRule.add(configurator, "be3000;teb043");
cds.configurator.DefaultRule.add(configurator, "be3000;teb045");
cds.configurator.DefaultRule.add(configurator, "be3000;teb046");
cds.configurator.DefaultRule.add(configurator, "be3000;teb050");
cds.configurator.DefaultRule.add(configurator, "be3000;teb052");
cds.configurator.DefaultRule.add(configurator, "be3000;teb053");
cds.configurator.DefaultRule.add(configurator, "be3000;teb056");
cds.configurator.DefaultRule.add(configurator, "be3000;teb062");
cds.configurator.DefaultRule.add(configurator, "be3000;teb063");
cds.configurator.DefaultRule.add(configurator, "be3000;teb064");
cds.configurator.DefaultRule.add(configurator, "be3000;teb067");
cds.configurator.DefaultRule.add(configurator, "be3000;teb068");
cds.configurator.DefaultRule.add(configurator, "be3000;teb070");
cds.configurator.DefaultRule.add(configurator, "be3000;teb071");
cds.configurator.DefaultRule.add(configurator, "be3000;teb074");
cds.configurator.DefaultRule.add(configurator, "be3000;teb075");
cds.configurator.DefaultRule.add(configurator, "be3000;teb080");
cds.configurator.DefaultRule.add(configurator, "be3000;teb090");
cds.configurator.DefaultRule.add(configurator, "be3000;teb100");
cds.configurator.DefaultRule.add(configurator, "be3000;teb112");
cds.configurator.DefaultRule.add(configurator, "be3000;teb126");
cds.configurator.DefaultRule.add(configurator, "be3000;teb140");
cds.configurator.DefaultRule.add(configurator, "be3000;teb144");
cds.configurator.DefaultRule.add(configurator, "be3000;teb154");
cds.configurator.DefaultRule.add(configurator, "be3000;teb168");
cds.configurator.DefaultRule.add(configurator, "be3000;teb180");
cds.configurator.DefaultRule.add(configurator, "be3000;teb192");
cds.configurator.DefaultRule.add(configurator, "be3000;teb200");
cds.configurator.DefaultRule.add(configurator, "be3000;teb216");
cds.configurator.DefaultRule.add(configurator, "be3000;teb224");
cds.configurator.DefaultRule.add(configurator, "be3346;sehhh");
cds.configurator.DefaultRule.add(configurator, "be3346;selll");
cds.configurator.DefaultRule.add(configurator, "be3346;semxl");
cds.configurator.DefaultRule.add(configurator, "be3346;sexll");
cds.configurator.DefaultRule.add(configurator, "be3346;sma05");
cds.configurator.DefaultRule.add(configurator, "be3346;sma10");
cds.configurator.DefaultRule.add(configurator, "be3346;smh03");
cds.configurator.DefaultRule.add(configurator, "be3346;smh05");
cds.configurator.DefaultRule.add(configurator, "be3346;smt05");
cds.configurator.DefaultRule.add(configurator, "be3346;smt10");
cds.configurator.DefaultRule.add(configurator, "be3346;smt25");
cds.configurator.DefaultRule.add(configurator, "be3346;tea010");
cds.configurator.DefaultRule.add(configurator, "be3346;tea011");
cds.configurator.DefaultRule.add(configurator, "be3346;tea012");
cds.configurator.DefaultRule.add(configurator, "be3346;tea013");
cds.configurator.DefaultRule.add(configurator, "be3346;tea014");
cds.configurator.DefaultRule.add(configurator, "be3346;tea015");
cds.configurator.DefaultRule.add(configurator, "be3346;tea016");
cds.configurator.DefaultRule.add(configurator, "be3346;tea017");
cds.configurator.DefaultRule.add(configurator, "be3346;tea018");
cds.configurator.DefaultRule.add(configurator, "be3346;tea019");
cds.configurator.DefaultRule.add(configurator, "be3346;tea020");
cds.configurator.DefaultRule.add(configurator, "be3346;tea021");
cds.configurator.DefaultRule.add(configurator, "be3346;tea022");
cds.configurator.DefaultRule.add(configurator, "be3346;tea023");
cds.configurator.DefaultRule.add(configurator, "be3346;tea024");
cds.configurator.DefaultRule.add(configurator, "be3346;tea025");
cds.configurator.DefaultRule.add(configurator, "be3346;tea026");
cds.configurator.DefaultRule.add(configurator, "be3346;tea027");
cds.configurator.DefaultRule.add(configurator, "be3346;tea031");
cds.configurator.DefaultRule.add(configurator, "be3346;tea033");
cds.configurator.DefaultRule.add(configurator, "be3346;tea035");
cds.configurator.DefaultRule.add(configurator, "be3346;tea037");
cds.configurator.DefaultRule.add(configurator, "be3346;tea039");
cds.configurator.DefaultRule.add(configurator, "be3346;tea041");
cds.configurator.DefaultRule.add(configurator, "be3346;tea042");
cds.configurator.DefaultRule.add(configurator, "be3346;tea043");
cds.configurator.DefaultRule.add(configurator, "be3346;tea045");
cds.configurator.DefaultRule.add(configurator, "be3346;tea046");
cds.configurator.DefaultRule.add(configurator, "be3346;tea050");
cds.configurator.DefaultRule.add(configurator, "be3346;tea053");
cds.configurator.DefaultRule.add(configurator, "be3346;tea062");
cds.configurator.DefaultRule.add(configurator, "be3346;tea063");
cds.configurator.DefaultRule.add(configurator, "be3346;tea067");
cds.configurator.DefaultRule.add(configurator, "be3346;tea070");
cds.configurator.DefaultRule.add(configurator, "be3346;tea071");
cds.configurator.DefaultRule.add(configurator, "be3346;tea074");
cds.configurator.DefaultRule.add(configurator, "be3346;tea075");
cds.configurator.DefaultRule.add(configurator, "be3346;tea084");
cds.configurator.DefaultRule.add(configurator, "be3346;tea096");
cds.configurator.DefaultRule.add(configurator, "be3346;tea100");
cds.configurator.DefaultRule.add(configurator, "be3346;tea120");
cds.configurator.DefaultRule.add(configurator, "be3346;tea126");
cds.configurator.DefaultRule.add(configurator, "be3346;tea140");
cds.configurator.DefaultRule.add(configurator, "be3346;tea154");
cds.configurator.DefaultRule.add(configurator, "be3346;tea180");
cds.configurator.DefaultRule.add(configurator, "be3346;tea200");
cds.configurator.DefaultRule.add(configurator, "be3346;tea216");
cds.configurator.DefaultRule.add(configurator, "be3346;tea224");
cds.configurator.DefaultRule.add(configurator, "be3346;teb010");
cds.configurator.DefaultRule.add(configurator, "be3346;teb011");
cds.configurator.DefaultRule.add(configurator, "be3346;teb012");
cds.configurator.DefaultRule.add(configurator, "be3346;teb013");
cds.configurator.DefaultRule.add(configurator, "be3346;teb014");
cds.configurator.DefaultRule.add(configurator, "be3346;teb015");
cds.configurator.DefaultRule.add(configurator, "be3346;teb016");
cds.configurator.DefaultRule.add(configurator, "be3346;teb017");
cds.configurator.DefaultRule.add(configurator, "be3346;teb018");
cds.configurator.DefaultRule.add(configurator, "be3346;teb019");
cds.configurator.DefaultRule.add(configurator, "be3346;teb020");
cds.configurator.DefaultRule.add(configurator, "be3346;teb021");
cds.configurator.DefaultRule.add(configurator, "be3346;teb022");
cds.configurator.DefaultRule.add(configurator, "be3346;teb023");
cds.configurator.DefaultRule.add(configurator, "be3346;teb024");
cds.configurator.DefaultRule.add(configurator, "be3346;teb025");
cds.configurator.DefaultRule.add(configurator, "be3346;teb026");
cds.configurator.DefaultRule.add(configurator, "be3346;teb027");
cds.configurator.DefaultRule.add(configurator, "be3346;teb031");
cds.configurator.DefaultRule.add(configurator, "be3346;teb033");
cds.configurator.DefaultRule.add(configurator, "be3346;teb035");
cds.configurator.DefaultRule.add(configurator, "be3346;teb037");
cds.configurator.DefaultRule.add(configurator, "be3346;teb039");
cds.configurator.DefaultRule.add(configurator, "be3346;teb041");
cds.configurator.DefaultRule.add(configurator, "be3346;teb042");
cds.configurator.DefaultRule.add(configurator, "be3346;teb043");
cds.configurator.DefaultRule.add(configurator, "be3346;teb045");
cds.configurator.DefaultRule.add(configurator, "be3346;teb046");
cds.configurator.DefaultRule.add(configurator, "be3346;teb050");
cds.configurator.DefaultRule.add(configurator, "be3346;teb053");
cds.configurator.DefaultRule.add(configurator, "be3346;teb062");
cds.configurator.DefaultRule.add(configurator, "be3346;teb063");
cds.configurator.DefaultRule.add(configurator, "be3346;teb067");
cds.configurator.DefaultRule.add(configurator, "be3346;teb070");
cds.configurator.DefaultRule.add(configurator, "be3346;teb071");
cds.configurator.DefaultRule.add(configurator, "be3346;teb074");
cds.configurator.DefaultRule.add(configurator, "be3346;teb075");
cds.configurator.DefaultRule.add(configurator, "be3346;teb084");
cds.configurator.DefaultRule.add(configurator, "be3346;teb096");
cds.configurator.DefaultRule.add(configurator, "be3346;teb100");
cds.configurator.DefaultRule.add(configurator, "be3346;teb120");
cds.configurator.DefaultRule.add(configurator, "be3346;teb126");
cds.configurator.DefaultRule.add(configurator, "be3346;teb140");
cds.configurator.DefaultRule.add(configurator, "be3346;teb154");
cds.configurator.DefaultRule.add(configurator, "be3346;teb180");
cds.configurator.DefaultRule.add(configurator, "be3346;teb200");
cds.configurator.DefaultRule.add(configurator, "be3346;teb216");
cds.configurator.DefaultRule.add(configurator, "be3346;teb224");
cds.configurator.DefaultRule.add(configurator, "be3543;sehhh");
cds.configurator.DefaultRule.add(configurator, "be3543;selll");
cds.configurator.DefaultRule.add(configurator, "be3543;semxl");
cds.configurator.DefaultRule.add(configurator, "be3543;sexll");
cds.configurator.DefaultRule.add(configurator, "be3543;sma05");
cds.configurator.DefaultRule.add(configurator, "be3543;sma10");
cds.configurator.DefaultRule.add(configurator, "be3543;smh03");
cds.configurator.DefaultRule.add(configurator, "be3543;smh05");
cds.configurator.DefaultRule.add(configurator, "be3543;smh08");
cds.configurator.DefaultRule.add(configurator, "be3543;smt05");
cds.configurator.DefaultRule.add(configurator, "be3543;smt10");
cds.configurator.DefaultRule.add(configurator, "be3543;smt25");
cds.configurator.DefaultRule.add(configurator, "be3543;tea010");
cds.configurator.DefaultRule.add(configurator, "be3543;tea011");
cds.configurator.DefaultRule.add(configurator, "be3543;tea012");
cds.configurator.DefaultRule.add(configurator, "be3543;tea013");
cds.configurator.DefaultRule.add(configurator, "be3543;tea014");
cds.configurator.DefaultRule.add(configurator, "be3543;tea015");
cds.configurator.DefaultRule.add(configurator, "be3543;tea016");
cds.configurator.DefaultRule.add(configurator, "be3543;tea017");
cds.configurator.DefaultRule.add(configurator, "be3543;tea018");
cds.configurator.DefaultRule.add(configurator, "be3543;tea019");
cds.configurator.DefaultRule.add(configurator, "be3543;tea020");
cds.configurator.DefaultRule.add(configurator, "be3543;tea021");
cds.configurator.DefaultRule.add(configurator, "be3543;tea022");
cds.configurator.DefaultRule.add(configurator, "be3543;tea023");
cds.configurator.DefaultRule.add(configurator, "be3543;tea024");
cds.configurator.DefaultRule.add(configurator, "be3543;tea025");
cds.configurator.DefaultRule.add(configurator, "be3543;tea026");
cds.configurator.DefaultRule.add(configurator, "be3543;tea027");
cds.configurator.DefaultRule.add(configurator, "be3543;tea041");
cds.configurator.DefaultRule.add(configurator, "be3543;tea042");
cds.configurator.DefaultRule.add(configurator, "be3543;tea044");
cds.configurator.DefaultRule.add(configurator, "be3543;tea046");
cds.configurator.DefaultRule.add(configurator, "be3543;tea052");
cds.configurator.DefaultRule.add(configurator, "be3543;tea062");
cds.configurator.DefaultRule.add(configurator, "be3543;tea064");
cds.configurator.DefaultRule.add(configurator, "be3543;tea068");
cds.configurator.DefaultRule.add(configurator, "be3543;tea070");
cds.configurator.DefaultRule.add(configurator, "be3543;tea072");
cds.configurator.DefaultRule.add(configurator, "be3543;tea074");
cds.configurator.DefaultRule.add(configurator, "be3543;tea084");
cds.configurator.DefaultRule.add(configurator, "be3543;tea096");
cds.configurator.DefaultRule.add(configurator, "be3543;tea100");
cds.configurator.DefaultRule.add(configurator, "be3543;tea120");
cds.configurator.DefaultRule.add(configurator, "be3543;tea126");
cds.configurator.DefaultRule.add(configurator, "be3543;tea144");
cds.configurator.DefaultRule.add(configurator, "be3543;tea154");
cds.configurator.DefaultRule.add(configurator, "be3543;tea192");
cds.configurator.DefaultRule.add(configurator, "be3543;tea216");
cds.configurator.DefaultRule.add(configurator, "be3543;teb010");
cds.configurator.DefaultRule.add(configurator, "be3543;teb011");
cds.configurator.DefaultRule.add(configurator, "be3543;teb012");
cds.configurator.DefaultRule.add(configurator, "be3543;teb013");
cds.configurator.DefaultRule.add(configurator, "be3543;teb014");
cds.configurator.DefaultRule.add(configurator, "be3543;teb015");
cds.configurator.DefaultRule.add(configurator, "be3543;teb016");
cds.configurator.DefaultRule.add(configurator, "be3543;teb017");
cds.configurator.DefaultRule.add(configurator, "be3543;teb018");
cds.configurator.DefaultRule.add(configurator, "be3543;teb019");
cds.configurator.DefaultRule.add(configurator, "be3543;teb020");
cds.configurator.DefaultRule.add(configurator, "be3543;teb021");
cds.configurator.DefaultRule.add(configurator, "be3543;teb022");
cds.configurator.DefaultRule.add(configurator, "be3543;teb023");
cds.configurator.DefaultRule.add(configurator, "be3543;teb024");
cds.configurator.DefaultRule.add(configurator, "be3543;teb025");
cds.configurator.DefaultRule.add(configurator, "be3543;teb026");
cds.configurator.DefaultRule.add(configurator, "be3543;teb027");
cds.configurator.DefaultRule.add(configurator, "be3543;teb041");
cds.configurator.DefaultRule.add(configurator, "be3543;teb042");
cds.configurator.DefaultRule.add(configurator, "be3543;teb044");
cds.configurator.DefaultRule.add(configurator, "be3543;teb046");
cds.configurator.DefaultRule.add(configurator, "be3543;teb052");
cds.configurator.DefaultRule.add(configurator, "be3543;teb062");
cds.configurator.DefaultRule.add(configurator, "be3543;teb064");
cds.configurator.DefaultRule.add(configurator, "be3543;teb068");
cds.configurator.DefaultRule.add(configurator, "be3543;teb070");
cds.configurator.DefaultRule.add(configurator, "be3543;teb072");
cds.configurator.DefaultRule.add(configurator, "be3543;teb074");
cds.configurator.DefaultRule.add(configurator, "be3543;teb084");
cds.configurator.DefaultRule.add(configurator, "be3543;teb096");
cds.configurator.DefaultRule.add(configurator, "be3543;teb100");
cds.configurator.DefaultRule.add(configurator, "be3543;teb120");
cds.configurator.DefaultRule.add(configurator, "be3543;teb126");
cds.configurator.DefaultRule.add(configurator, "be3543;teb144");
cds.configurator.DefaultRule.add(configurator, "be3543;teb154");
cds.configurator.DefaultRule.add(configurator, "be3543;teb192");
cds.configurator.DefaultRule.add(configurator, "be3543;teb216");
cds.configurator.DefaultRule.add(configurator, "tea010;teb011");
cds.configurator.DefaultRule.add(configurator, "tea010;teb012");
cds.configurator.DefaultRule.add(configurator, "tea010;teb013");
cds.configurator.DefaultRule.add(configurator, "tea010;teb014");
cds.configurator.DefaultRule.add(configurator, "tea010;teb015");
cds.configurator.DefaultRule.add(configurator, "tea010;teb016");
cds.configurator.DefaultRule.add(configurator, "tea010;teb017");
cds.configurator.DefaultRule.add(configurator, "tea010;teb018");
cds.configurator.DefaultRule.add(configurator, "tea010;teb019");
cds.configurator.DefaultRule.add(configurator, "tea010;teb020");
cds.configurator.DefaultRule.add(configurator, "tea010;teb021");
cds.configurator.DefaultRule.add(configurator, "tea010;teb022");
cds.configurator.DefaultRule.add(configurator, "tea010;teb023");
cds.configurator.DefaultRule.add(configurator, "tea010;teb024");
cds.configurator.DefaultRule.add(configurator, "tea010;teb025");
cds.configurator.DefaultRule.add(configurator, "tea010;teb026");
cds.configurator.DefaultRule.add(configurator, "tea010;teb027");
cds.configurator.DefaultRule.add(configurator, "tea010;teb028");
cds.configurator.DefaultRule.add(configurator, "tea010;teb029");
cds.configurator.DefaultRule.add(configurator, "tea010;teb030");
cds.configurator.DefaultRule.add(configurator, "tea010;teb031");
cds.configurator.DefaultRule.add(configurator, "tea010;teb032");
cds.configurator.DefaultRule.add(configurator, "tea010;teb033");
cds.configurator.DefaultRule.add(configurator, "tea010;teb034");
cds.configurator.DefaultRule.add(configurator, "tea010;teb035");
cds.configurator.DefaultRule.add(configurator, "tea010;teb036");
cds.configurator.DefaultRule.add(configurator, "tea010;teb037");
cds.configurator.DefaultRule.add(configurator, "tea010;teb038");
cds.configurator.DefaultRule.add(configurator, "tea010;teb039");
cds.configurator.DefaultRule.add(configurator, "tea010;teb040");
cds.configurator.DefaultRule.add(configurator, "tea010;teb041");
cds.configurator.DefaultRule.add(configurator, "tea010;teb042");
cds.configurator.DefaultRule.add(configurator, "tea010;teb043");
cds.configurator.DefaultRule.add(configurator, "tea010;teb044");
cds.configurator.DefaultRule.add(configurator, "tea010;teb045");
cds.configurator.DefaultRule.add(configurator, "tea010;teb046");
cds.configurator.DefaultRule.add(configurator, "tea010;teb048");
cds.configurator.DefaultRule.add(configurator, "tea010;teb050");
cds.configurator.DefaultRule.add(configurator, "tea010;teb052");
cds.configurator.DefaultRule.add(configurator, "tea010;teb053");
cds.configurator.DefaultRule.add(configurator, "tea010;teb056");
cds.configurator.DefaultRule.add(configurator, "tea010;teb060");
cds.configurator.DefaultRule.add(configurator, "tea010;teb062");
cds.configurator.DefaultRule.add(configurator, "tea010;teb063");
cds.configurator.DefaultRule.add(configurator, "tea010;teb064");
cds.configurator.DefaultRule.add(configurator, "tea010;teb067");
cds.configurator.DefaultRule.add(configurator, "tea010;teb068");
cds.configurator.DefaultRule.add(configurator, "tea010;teb070");
cds.configurator.DefaultRule.add(configurator, "tea010;teb071");
cds.configurator.DefaultRule.add(configurator, "tea010;teb072");
cds.configurator.DefaultRule.add(configurator, "tea010;teb074");
cds.configurator.DefaultRule.add(configurator, "tea010;teb075");
cds.configurator.DefaultRule.add(configurator, "tea010;teb080");
cds.configurator.DefaultRule.add(configurator, "tea010;teb084");
cds.configurator.DefaultRule.add(configurator, "tea010;teb090");
cds.configurator.DefaultRule.add(configurator, "tea010;teb096");
cds.configurator.DefaultRule.add(configurator, "tea010;teb100");
cds.configurator.DefaultRule.add(configurator, "tea010;teb112");
cds.configurator.DefaultRule.add(configurator, "tea010;teb120");
cds.configurator.DefaultRule.add(configurator, "tea010;teb126");
cds.configurator.DefaultRule.add(configurator, "tea010;teb140");
cds.configurator.DefaultRule.add(configurator, "tea010;teb144");
cds.configurator.DefaultRule.add(configurator, "tea010;teb154");
cds.configurator.DefaultRule.add(configurator, "tea010;teb168");
cds.configurator.DefaultRule.add(configurator, "tea010;teb180");
cds.configurator.DefaultRule.add(configurator, "tea010;teb192");
cds.configurator.DefaultRule.add(configurator, "tea010;teb200");
cds.configurator.DefaultRule.add(configurator, "tea010;teb216");
cds.configurator.DefaultRule.add(configurator, "tea010;teb224");
cds.configurator.DefaultRule.add(configurator, "tea011;teb012");
cds.configurator.DefaultRule.add(configurator, "tea011;teb013");
cds.configurator.DefaultRule.add(configurator, "tea011;teb014");
cds.configurator.DefaultRule.add(configurator, "tea011;teb015");
cds.configurator.DefaultRule.add(configurator, "tea011;teb016");
cds.configurator.DefaultRule.add(configurator, "tea011;teb017");
cds.configurator.DefaultRule.add(configurator, "tea011;teb018");
cds.configurator.DefaultRule.add(configurator, "tea011;teb019");
cds.configurator.DefaultRule.add(configurator, "tea011;teb020");
cds.configurator.DefaultRule.add(configurator, "tea011;teb021");
cds.configurator.DefaultRule.add(configurator, "tea011;teb022");
cds.configurator.DefaultRule.add(configurator, "tea011;teb023");
cds.configurator.DefaultRule.add(configurator, "tea011;teb024");
cds.configurator.DefaultRule.add(configurator, "tea011;teb025");
cds.configurator.DefaultRule.add(configurator, "tea011;teb026");
cds.configurator.DefaultRule.add(configurator, "tea011;teb027");
cds.configurator.DefaultRule.add(configurator, "tea011;teb028");
cds.configurator.DefaultRule.add(configurator, "tea011;teb029");
cds.configurator.DefaultRule.add(configurator, "tea011;teb030");
cds.configurator.DefaultRule.add(configurator, "tea011;teb031");
cds.configurator.DefaultRule.add(configurator, "tea011;teb032");
cds.configurator.DefaultRule.add(configurator, "tea011;teb033");
cds.configurator.DefaultRule.add(configurator, "tea011;teb034");
cds.configurator.DefaultRule.add(configurator, "tea011;teb035");
cds.configurator.DefaultRule.add(configurator, "tea011;teb036");
cds.configurator.DefaultRule.add(configurator, "tea011;teb037");
cds.configurator.DefaultRule.add(configurator, "tea011;teb038");
cds.configurator.DefaultRule.add(configurator, "tea011;teb039");
cds.configurator.DefaultRule.add(configurator, "tea011;teb040");
cds.configurator.DefaultRule.add(configurator, "tea011;teb041");
cds.configurator.DefaultRule.add(configurator, "tea011;teb042");
cds.configurator.DefaultRule.add(configurator, "tea011;teb043");
cds.configurator.DefaultRule.add(configurator, "tea011;teb044");
cds.configurator.DefaultRule.add(configurator, "tea011;teb045");
cds.configurator.DefaultRule.add(configurator, "tea011;teb046");
cds.configurator.DefaultRule.add(configurator, "tea011;teb048");
cds.configurator.DefaultRule.add(configurator, "tea011;teb050");
cds.configurator.DefaultRule.add(configurator, "tea011;teb052");
cds.configurator.DefaultRule.add(configurator, "tea011;teb053");
cds.configurator.DefaultRule.add(configurator, "tea011;teb056");
cds.configurator.DefaultRule.add(configurator, "tea011;teb060");
cds.configurator.DefaultRule.add(configurator, "tea011;teb062");
cds.configurator.DefaultRule.add(configurator, "tea011;teb063");
cds.configurator.DefaultRule.add(configurator, "tea011;teb064");
cds.configurator.DefaultRule.add(configurator, "tea011;teb067");
cds.configurator.DefaultRule.add(configurator, "tea011;teb068");
cds.configurator.DefaultRule.add(configurator, "tea011;teb070");
cds.configurator.DefaultRule.add(configurator, "tea011;teb071");
cds.configurator.DefaultRule.add(configurator, "tea011;teb072");
cds.configurator.DefaultRule.add(configurator, "tea011;teb074");
cds.configurator.DefaultRule.add(configurator, "tea011;teb075");
cds.configurator.DefaultRule.add(configurator, "tea011;teb080");
cds.configurator.DefaultRule.add(configurator, "tea011;teb084");
cds.configurator.DefaultRule.add(configurator, "tea011;teb090");
cds.configurator.DefaultRule.add(configurator, "tea011;teb096");
cds.configurator.DefaultRule.add(configurator, "tea011;teb100");
cds.configurator.DefaultRule.add(configurator, "tea011;teb112");
cds.configurator.DefaultRule.add(configurator, "tea011;teb120");
cds.configurator.DefaultRule.add(configurator, "tea011;teb126");
cds.configurator.DefaultRule.add(configurator, "tea011;teb140");
cds.configurator.DefaultRule.add(configurator, "tea011;teb144");
cds.configurator.DefaultRule.add(configurator, "tea011;teb154");
cds.configurator.DefaultRule.add(configurator, "tea011;teb168");
cds.configurator.DefaultRule.add(configurator, "tea011;teb180");
cds.configurator.DefaultRule.add(configurator, "tea011;teb192");
cds.configurator.DefaultRule.add(configurator, "tea011;teb200");
cds.configurator.DefaultRule.add(configurator, "tea011;teb216");
cds.configurator.DefaultRule.add(configurator, "tea011;teb224");
cds.configurator.DefaultRule.add(configurator, "tea012;teb013");
cds.configurator.DefaultRule.add(configurator, "tea012;teb014");
cds.configurator.DefaultRule.add(configurator, "tea012;teb015");
cds.configurator.DefaultRule.add(configurator, "tea012;teb016");
cds.configurator.DefaultRule.add(configurator, "tea012;teb017");
cds.configurator.DefaultRule.add(configurator, "tea012;teb018");
cds.configurator.DefaultRule.add(configurator, "tea012;teb019");
cds.configurator.DefaultRule.add(configurator, "tea012;teb020");
cds.configurator.DefaultRule.add(configurator, "tea012;teb021");
cds.configurator.DefaultRule.add(configurator, "tea012;teb022");
cds.configurator.DefaultRule.add(configurator, "tea012;teb023");
cds.configurator.DefaultRule.add(configurator, "tea012;teb024");
cds.configurator.DefaultRule.add(configurator, "tea012;teb025");
cds.configurator.DefaultRule.add(configurator, "tea012;teb026");
cds.configurator.DefaultRule.add(configurator, "tea012;teb027");
cds.configurator.DefaultRule.add(configurator, "tea012;teb028");
cds.configurator.DefaultRule.add(configurator, "tea012;teb029");
cds.configurator.DefaultRule.add(configurator, "tea012;teb030");
cds.configurator.DefaultRule.add(configurator, "tea012;teb031");
cds.configurator.DefaultRule.add(configurator, "tea012;teb032");
cds.configurator.DefaultRule.add(configurator, "tea012;teb033");
cds.configurator.DefaultRule.add(configurator, "tea012;teb034");
cds.configurator.DefaultRule.add(configurator, "tea012;teb035");
cds.configurator.DefaultRule.add(configurator, "tea012;teb036");
cds.configurator.DefaultRule.add(configurator, "tea012;teb037");
cds.configurator.DefaultRule.add(configurator, "tea012;teb038");
cds.configurator.DefaultRule.add(configurator, "tea012;teb039");
cds.configurator.DefaultRule.add(configurator, "tea012;teb040");
cds.configurator.DefaultRule.add(configurator, "tea012;teb041");
cds.configurator.DefaultRule.add(configurator, "tea012;teb042");
cds.configurator.DefaultRule.add(configurator, "tea012;teb043");
cds.configurator.DefaultRule.add(configurator, "tea012;teb044");
cds.configurator.DefaultRule.add(configurator, "tea012;teb045");
cds.configurator.DefaultRule.add(configurator, "tea012;teb046");
cds.configurator.DefaultRule.add(configurator, "tea012;teb048");
cds.configurator.DefaultRule.add(configurator, "tea012;teb050");
cds.configurator.DefaultRule.add(configurator, "tea012;teb052");
cds.configurator.DefaultRule.add(configurator, "tea012;teb053");
cds.configurator.DefaultRule.add(configurator, "tea012;teb056");
cds.configurator.DefaultRule.add(configurator, "tea012;teb060");
cds.configurator.DefaultRule.add(configurator, "tea012;teb062");
cds.configurator.DefaultRule.add(configurator, "tea012;teb063");
cds.configurator.DefaultRule.add(configurator, "tea012;teb064");
cds.configurator.DefaultRule.add(configurator, "tea012;teb067");
cds.configurator.DefaultRule.add(configurator, "tea012;teb068");
cds.configurator.DefaultRule.add(configurator, "tea012;teb070");
cds.configurator.DefaultRule.add(configurator, "tea012;teb071");
cds.configurator.DefaultRule.add(configurator, "tea012;teb072");
cds.configurator.DefaultRule.add(configurator, "tea012;teb074");
cds.configurator.DefaultRule.add(configurator, "tea012;teb075");
cds.configurator.DefaultRule.add(configurator, "tea012;teb080");
cds.configurator.DefaultRule.add(configurator, "tea012;teb084");
cds.configurator.DefaultRule.add(configurator, "tea012;teb090");
cds.configurator.DefaultRule.add(configurator, "tea012;teb096");
cds.configurator.DefaultRule.add(configurator, "tea012;teb100");
cds.configurator.DefaultRule.add(configurator, "tea012;teb112");
cds.configurator.DefaultRule.add(configurator, "tea012;teb120");
cds.configurator.DefaultRule.add(configurator, "tea012;teb126");
cds.configurator.DefaultRule.add(configurator, "tea012;teb140");
cds.configurator.DefaultRule.add(configurator, "tea012;teb144");
cds.configurator.DefaultRule.add(configurator, "tea012;teb154");
cds.configurator.DefaultRule.add(configurator, "tea012;teb168");
cds.configurator.DefaultRule.add(configurator, "tea012;teb180");
cds.configurator.DefaultRule.add(configurator, "tea012;teb192");
cds.configurator.DefaultRule.add(configurator, "tea012;teb200");
cds.configurator.DefaultRule.add(configurator, "tea012;teb216");
cds.configurator.DefaultRule.add(configurator, "tea012;teb224");
cds.configurator.DefaultRule.add(configurator, "tea013;teb014");
cds.configurator.DefaultRule.add(configurator, "tea013;teb015");
cds.configurator.DefaultRule.add(configurator, "tea013;teb016");
cds.configurator.DefaultRule.add(configurator, "tea013;teb017");
cds.configurator.DefaultRule.add(configurator, "tea013;teb018");
cds.configurator.DefaultRule.add(configurator, "tea013;teb019");
cds.configurator.DefaultRule.add(configurator, "tea013;teb020");
cds.configurator.DefaultRule.add(configurator, "tea013;teb021");
cds.configurator.DefaultRule.add(configurator, "tea013;teb022");
cds.configurator.DefaultRule.add(configurator, "tea013;teb023");
cds.configurator.DefaultRule.add(configurator, "tea013;teb024");
cds.configurator.DefaultRule.add(configurator, "tea013;teb025");
cds.configurator.DefaultRule.add(configurator, "tea013;teb026");
cds.configurator.DefaultRule.add(configurator, "tea013;teb027");
cds.configurator.DefaultRule.add(configurator, "tea013;teb028");
cds.configurator.DefaultRule.add(configurator, "tea013;teb029");
cds.configurator.DefaultRule.add(configurator, "tea013;teb030");
cds.configurator.DefaultRule.add(configurator, "tea013;teb031");
cds.configurator.DefaultRule.add(configurator, "tea013;teb032");
cds.configurator.DefaultRule.add(configurator, "tea013;teb033");
cds.configurator.DefaultRule.add(configurator, "tea013;teb034");
cds.configurator.DefaultRule.add(configurator, "tea013;teb035");
cds.configurator.DefaultRule.add(configurator, "tea013;teb036");
cds.configurator.DefaultRule.add(configurator, "tea013;teb037");
cds.configurator.DefaultRule.add(configurator, "tea013;teb038");
cds.configurator.DefaultRule.add(configurator, "tea013;teb039");
cds.configurator.DefaultRule.add(configurator, "tea013;teb040");
cds.configurator.DefaultRule.add(configurator, "tea013;teb041");
cds.configurator.DefaultRule.add(configurator, "tea013;teb042");
cds.configurator.DefaultRule.add(configurator, "tea013;teb043");
cds.configurator.DefaultRule.add(configurator, "tea013;teb044");
cds.configurator.DefaultRule.add(configurator, "tea013;teb045");
cds.configurator.DefaultRule.add(configurator, "tea013;teb046");
cds.configurator.DefaultRule.add(configurator, "tea013;teb048");
cds.configurator.DefaultRule.add(configurator, "tea013;teb050");
cds.configurator.DefaultRule.add(configurator, "tea013;teb052");
cds.configurator.DefaultRule.add(configurator, "tea013;teb053");
cds.configurator.DefaultRule.add(configurator, "tea013;teb056");
cds.configurator.DefaultRule.add(configurator, "tea013;teb060");
cds.configurator.DefaultRule.add(configurator, "tea013;teb062");
cds.configurator.DefaultRule.add(configurator, "tea013;teb063");
cds.configurator.DefaultRule.add(configurator, "tea013;teb064");
cds.configurator.DefaultRule.add(configurator, "tea013;teb067");
cds.configurator.DefaultRule.add(configurator, "tea013;teb068");
cds.configurator.DefaultRule.add(configurator, "tea013;teb070");
cds.configurator.DefaultRule.add(configurator, "tea013;teb071");
cds.configurator.DefaultRule.add(configurator, "tea013;teb072");
cds.configurator.DefaultRule.add(configurator, "tea013;teb074");
cds.configurator.DefaultRule.add(configurator, "tea013;teb075");
cds.configurator.DefaultRule.add(configurator, "tea013;teb080");
cds.configurator.DefaultRule.add(configurator, "tea013;teb084");
cds.configurator.DefaultRule.add(configurator, "tea013;teb090");
cds.configurator.DefaultRule.add(configurator, "tea013;teb096");
cds.configurator.DefaultRule.add(configurator, "tea013;teb100");
cds.configurator.DefaultRule.add(configurator, "tea013;teb112");
cds.configurator.DefaultRule.add(configurator, "tea013;teb120");
cds.configurator.DefaultRule.add(configurator, "tea013;teb126");
cds.configurator.DefaultRule.add(configurator, "tea013;teb140");
cds.configurator.DefaultRule.add(configurator, "tea013;teb144");
cds.configurator.DefaultRule.add(configurator, "tea013;teb154");
cds.configurator.DefaultRule.add(configurator, "tea013;teb168");
cds.configurator.DefaultRule.add(configurator, "tea013;teb180");
cds.configurator.DefaultRule.add(configurator, "tea013;teb192");
cds.configurator.DefaultRule.add(configurator, "tea013;teb200");
cds.configurator.DefaultRule.add(configurator, "tea013;teb216");
cds.configurator.DefaultRule.add(configurator, "tea013;teb224");
cds.configurator.DefaultRule.add(configurator, "tea014;teb015");
cds.configurator.DefaultRule.add(configurator, "tea014;teb016");
cds.configurator.DefaultRule.add(configurator, "tea014;teb017");
cds.configurator.DefaultRule.add(configurator, "tea014;teb018");
cds.configurator.DefaultRule.add(configurator, "tea014;teb019");
cds.configurator.DefaultRule.add(configurator, "tea014;teb020");
cds.configurator.DefaultRule.add(configurator, "tea014;teb021");
cds.configurator.DefaultRule.add(configurator, "tea014;teb022");
cds.configurator.DefaultRule.add(configurator, "tea014;teb023");
cds.configurator.DefaultRule.add(configurator, "tea014;teb024");
cds.configurator.DefaultRule.add(configurator, "tea014;teb025");
cds.configurator.DefaultRule.add(configurator, "tea014;teb026");
cds.configurator.DefaultRule.add(configurator, "tea014;teb027");
cds.configurator.DefaultRule.add(configurator, "tea014;teb028");
cds.configurator.DefaultRule.add(configurator, "tea014;teb029");
cds.configurator.DefaultRule.add(configurator, "tea014;teb030");
cds.configurator.DefaultRule.add(configurator, "tea014;teb031");
cds.configurator.DefaultRule.add(configurator, "tea014;teb032");
cds.configurator.DefaultRule.add(configurator, "tea014;teb033");
cds.configurator.DefaultRule.add(configurator, "tea014;teb034");
cds.configurator.DefaultRule.add(configurator, "tea014;teb035");
cds.configurator.DefaultRule.add(configurator, "tea014;teb036");
cds.configurator.DefaultRule.add(configurator, "tea014;teb037");
cds.configurator.DefaultRule.add(configurator, "tea014;teb038");
cds.configurator.DefaultRule.add(configurator, "tea014;teb039");
cds.configurator.DefaultRule.add(configurator, "tea014;teb040");
cds.configurator.DefaultRule.add(configurator, "tea014;teb041");
cds.configurator.DefaultRule.add(configurator, "tea014;teb042");
cds.configurator.DefaultRule.add(configurator, "tea014;teb043");
cds.configurator.DefaultRule.add(configurator, "tea014;teb044");
cds.configurator.DefaultRule.add(configurator, "tea014;teb045");
cds.configurator.DefaultRule.add(configurator, "tea014;teb046");
cds.configurator.DefaultRule.add(configurator, "tea014;teb048");
cds.configurator.DefaultRule.add(configurator, "tea014;teb050");
cds.configurator.DefaultRule.add(configurator, "tea014;teb052");
cds.configurator.DefaultRule.add(configurator, "tea014;teb053");
cds.configurator.DefaultRule.add(configurator, "tea014;teb056");
cds.configurator.DefaultRule.add(configurator, "tea014;teb060");
cds.configurator.DefaultRule.add(configurator, "tea014;teb062");
cds.configurator.DefaultRule.add(configurator, "tea014;teb063");
cds.configurator.DefaultRule.add(configurator, "tea014;teb064");
cds.configurator.DefaultRule.add(configurator, "tea014;teb067");
cds.configurator.DefaultRule.add(configurator, "tea014;teb068");
cds.configurator.DefaultRule.add(configurator, "tea014;teb070");
cds.configurator.DefaultRule.add(configurator, "tea014;teb071");
cds.configurator.DefaultRule.add(configurator, "tea014;teb072");
cds.configurator.DefaultRule.add(configurator, "tea014;teb074");
cds.configurator.DefaultRule.add(configurator, "tea014;teb075");
cds.configurator.DefaultRule.add(configurator, "tea014;teb080");
cds.configurator.DefaultRule.add(configurator, "tea014;teb084");
cds.configurator.DefaultRule.add(configurator, "tea014;teb090");
cds.configurator.DefaultRule.add(configurator, "tea014;teb096");
cds.configurator.DefaultRule.add(configurator, "tea014;teb100");
cds.configurator.DefaultRule.add(configurator, "tea014;teb112");
cds.configurator.DefaultRule.add(configurator, "tea014;teb120");
cds.configurator.DefaultRule.add(configurator, "tea014;teb126");
cds.configurator.DefaultRule.add(configurator, "tea014;teb140");
cds.configurator.DefaultRule.add(configurator, "tea014;teb144");
cds.configurator.DefaultRule.add(configurator, "tea014;teb154");
cds.configurator.DefaultRule.add(configurator, "tea014;teb168");
cds.configurator.DefaultRule.add(configurator, "tea014;teb180");
cds.configurator.DefaultRule.add(configurator, "tea014;teb192");
cds.configurator.DefaultRule.add(configurator, "tea014;teb200");
cds.configurator.DefaultRule.add(configurator, "tea014;teb216");
cds.configurator.DefaultRule.add(configurator, "tea014;teb224");
cds.configurator.DefaultRule.add(configurator, "tea015;teb016");
cds.configurator.DefaultRule.add(configurator, "tea015;teb017");
cds.configurator.DefaultRule.add(configurator, "tea015;teb018");
cds.configurator.DefaultRule.add(configurator, "tea015;teb019");
cds.configurator.DefaultRule.add(configurator, "tea015;teb020");
cds.configurator.DefaultRule.add(configurator, "tea015;teb021");
cds.configurator.DefaultRule.add(configurator, "tea015;teb022");
cds.configurator.DefaultRule.add(configurator, "tea015;teb023");
cds.configurator.DefaultRule.add(configurator, "tea015;teb024");
cds.configurator.DefaultRule.add(configurator, "tea015;teb025");
cds.configurator.DefaultRule.add(configurator, "tea015;teb026");
cds.configurator.DefaultRule.add(configurator, "tea015;teb027");
cds.configurator.DefaultRule.add(configurator, "tea015;teb028");
cds.configurator.DefaultRule.add(configurator, "tea015;teb029");
cds.configurator.DefaultRule.add(configurator, "tea015;teb030");
cds.configurator.DefaultRule.add(configurator, "tea015;teb031");
cds.configurator.DefaultRule.add(configurator, "tea015;teb032");
cds.configurator.DefaultRule.add(configurator, "tea015;teb033");
cds.configurator.DefaultRule.add(configurator, "tea015;teb034");
cds.configurator.DefaultRule.add(configurator, "tea015;teb035");
cds.configurator.DefaultRule.add(configurator, "tea015;teb036");
cds.configurator.DefaultRule.add(configurator, "tea015;teb037");
cds.configurator.DefaultRule.add(configurator, "tea015;teb038");
cds.configurator.DefaultRule.add(configurator, "tea015;teb039");
cds.configurator.DefaultRule.add(configurator, "tea015;teb040");
cds.configurator.DefaultRule.add(configurator, "tea015;teb041");
cds.configurator.DefaultRule.add(configurator, "tea015;teb042");
cds.configurator.DefaultRule.add(configurator, "tea015;teb043");
cds.configurator.DefaultRule.add(configurator, "tea015;teb044");
cds.configurator.DefaultRule.add(configurator, "tea015;teb045");
cds.configurator.DefaultRule.add(configurator, "tea015;teb046");
cds.configurator.DefaultRule.add(configurator, "tea015;teb048");
cds.configurator.DefaultRule.add(configurator, "tea015;teb050");
cds.configurator.DefaultRule.add(configurator, "tea015;teb052");
cds.configurator.DefaultRule.add(configurator, "tea015;teb053");
cds.configurator.DefaultRule.add(configurator, "tea015;teb056");
cds.configurator.DefaultRule.add(configurator, "tea015;teb060");
cds.configurator.DefaultRule.add(configurator, "tea015;teb062");
cds.configurator.DefaultRule.add(configurator, "tea015;teb063");
cds.configurator.DefaultRule.add(configurator, "tea015;teb064");
cds.configurator.DefaultRule.add(configurator, "tea015;teb067");
cds.configurator.DefaultRule.add(configurator, "tea015;teb068");
cds.configurator.DefaultRule.add(configurator, "tea015;teb070");
cds.configurator.DefaultRule.add(configurator, "tea015;teb071");
cds.configurator.DefaultRule.add(configurator, "tea015;teb072");
cds.configurator.DefaultRule.add(configurator, "tea015;teb074");
cds.configurator.DefaultRule.add(configurator, "tea015;teb075");
cds.configurator.DefaultRule.add(configurator, "tea015;teb080");
cds.configurator.DefaultRule.add(configurator, "tea015;teb084");
cds.configurator.DefaultRule.add(configurator, "tea015;teb090");
cds.configurator.DefaultRule.add(configurator, "tea015;teb096");
cds.configurator.DefaultRule.add(configurator, "tea015;teb100");
cds.configurator.DefaultRule.add(configurator, "tea015;teb112");
cds.configurator.DefaultRule.add(configurator, "tea015;teb120");
cds.configurator.DefaultRule.add(configurator, "tea015;teb126");
cds.configurator.DefaultRule.add(configurator, "tea015;teb140");
cds.configurator.DefaultRule.add(configurator, "tea015;teb144");
cds.configurator.DefaultRule.add(configurator, "tea015;teb154");
cds.configurator.DefaultRule.add(configurator, "tea015;teb168");
cds.configurator.DefaultRule.add(configurator, "tea015;teb180");
cds.configurator.DefaultRule.add(configurator, "tea015;teb192");
cds.configurator.DefaultRule.add(configurator, "tea015;teb200");
cds.configurator.DefaultRule.add(configurator, "tea015;teb216");
cds.configurator.DefaultRule.add(configurator, "tea015;teb224");
cds.configurator.DefaultRule.add(configurator, "tea016;teb017");
cds.configurator.DefaultRule.add(configurator, "tea016;teb018");
cds.configurator.DefaultRule.add(configurator, "tea016;teb019");
cds.configurator.DefaultRule.add(configurator, "tea016;teb020");
cds.configurator.DefaultRule.add(configurator, "tea016;teb021");
cds.configurator.DefaultRule.add(configurator, "tea016;teb022");
cds.configurator.DefaultRule.add(configurator, "tea016;teb023");
cds.configurator.DefaultRule.add(configurator, "tea016;teb024");
cds.configurator.DefaultRule.add(configurator, "tea016;teb025");
cds.configurator.DefaultRule.add(configurator, "tea016;teb026");
cds.configurator.DefaultRule.add(configurator, "tea016;teb027");
cds.configurator.DefaultRule.add(configurator, "tea016;teb028");
cds.configurator.DefaultRule.add(configurator, "tea016;teb029");
cds.configurator.DefaultRule.add(configurator, "tea016;teb030");
cds.configurator.DefaultRule.add(configurator, "tea016;teb031");
cds.configurator.DefaultRule.add(configurator, "tea016;teb032");
cds.configurator.DefaultRule.add(configurator, "tea016;teb033");
cds.configurator.DefaultRule.add(configurator, "tea016;teb034");
cds.configurator.DefaultRule.add(configurator, "tea016;teb035");
cds.configurator.DefaultRule.add(configurator, "tea016;teb036");
cds.configurator.DefaultRule.add(configurator, "tea016;teb037");
cds.configurator.DefaultRule.add(configurator, "tea016;teb038");
cds.configurator.DefaultRule.add(configurator, "tea016;teb039");
cds.configurator.DefaultRule.add(configurator, "tea016;teb040");
cds.configurator.DefaultRule.add(configurator, "tea016;teb041");
cds.configurator.DefaultRule.add(configurator, "tea016;teb042");
cds.configurator.DefaultRule.add(configurator, "tea016;teb043");
cds.configurator.DefaultRule.add(configurator, "tea016;teb044");
cds.configurator.DefaultRule.add(configurator, "tea016;teb045");
cds.configurator.DefaultRule.add(configurator, "tea016;teb046");
cds.configurator.DefaultRule.add(configurator, "tea016;teb048");
cds.configurator.DefaultRule.add(configurator, "tea016;teb050");
cds.configurator.DefaultRule.add(configurator, "tea016;teb052");
cds.configurator.DefaultRule.add(configurator, "tea016;teb053");
cds.configurator.DefaultRule.add(configurator, "tea016;teb056");
cds.configurator.DefaultRule.add(configurator, "tea016;teb060");
cds.configurator.DefaultRule.add(configurator, "tea016;teb062");
cds.configurator.DefaultRule.add(configurator, "tea016;teb063");
cds.configurator.DefaultRule.add(configurator, "tea016;teb064");
cds.configurator.DefaultRule.add(configurator, "tea016;teb067");
cds.configurator.DefaultRule.add(configurator, "tea016;teb068");
cds.configurator.DefaultRule.add(configurator, "tea016;teb070");
cds.configurator.DefaultRule.add(configurator, "tea016;teb071");
cds.configurator.DefaultRule.add(configurator, "tea016;teb072");
cds.configurator.DefaultRule.add(configurator, "tea016;teb074");
cds.configurator.DefaultRule.add(configurator, "tea016;teb075");
cds.configurator.DefaultRule.add(configurator, "tea016;teb080");
cds.configurator.DefaultRule.add(configurator, "tea016;teb084");
cds.configurator.DefaultRule.add(configurator, "tea016;teb090");
cds.configurator.DefaultRule.add(configurator, "tea016;teb096");
cds.configurator.DefaultRule.add(configurator, "tea016;teb100");
cds.configurator.DefaultRule.add(configurator, "tea016;teb112");
cds.configurator.DefaultRule.add(configurator, "tea016;teb120");
cds.configurator.DefaultRule.add(configurator, "tea016;teb126");
cds.configurator.DefaultRule.add(configurator, "tea016;teb140");
cds.configurator.DefaultRule.add(configurator, "tea016;teb144");
cds.configurator.DefaultRule.add(configurator, "tea016;teb154");
cds.configurator.DefaultRule.add(configurator, "tea016;teb168");
cds.configurator.DefaultRule.add(configurator, "tea016;teb180");
cds.configurator.DefaultRule.add(configurator, "tea016;teb192");
cds.configurator.DefaultRule.add(configurator, "tea016;teb200");
cds.configurator.DefaultRule.add(configurator, "tea016;teb216");
cds.configurator.DefaultRule.add(configurator, "tea016;teb224");
cds.configurator.DefaultRule.add(configurator, "tea017;teb018");
cds.configurator.DefaultRule.add(configurator, "tea017;teb019");
cds.configurator.DefaultRule.add(configurator, "tea017;teb020");
cds.configurator.DefaultRule.add(configurator, "tea017;teb021");
cds.configurator.DefaultRule.add(configurator, "tea017;teb022");
cds.configurator.DefaultRule.add(configurator, "tea017;teb023");
cds.configurator.DefaultRule.add(configurator, "tea017;teb024");
cds.configurator.DefaultRule.add(configurator, "tea017;teb025");
cds.configurator.DefaultRule.add(configurator, "tea017;teb026");
cds.configurator.DefaultRule.add(configurator, "tea017;teb027");
cds.configurator.DefaultRule.add(configurator, "tea017;teb028");
cds.configurator.DefaultRule.add(configurator, "tea017;teb029");
cds.configurator.DefaultRule.add(configurator, "tea017;teb030");
cds.configurator.DefaultRule.add(configurator, "tea017;teb031");
cds.configurator.DefaultRule.add(configurator, "tea017;teb032");
cds.configurator.DefaultRule.add(configurator, "tea017;teb033");
cds.configurator.DefaultRule.add(configurator, "tea017;teb034");
cds.configurator.DefaultRule.add(configurator, "tea017;teb035");
cds.configurator.DefaultRule.add(configurator, "tea017;teb036");
cds.configurator.DefaultRule.add(configurator, "tea017;teb037");
cds.configurator.DefaultRule.add(configurator, "tea017;teb038");
cds.configurator.DefaultRule.add(configurator, "tea017;teb039");
cds.configurator.DefaultRule.add(configurator, "tea017;teb040");
cds.configurator.DefaultRule.add(configurator, "tea017;teb041");
cds.configurator.DefaultRule.add(configurator, "tea017;teb042");
cds.configurator.DefaultRule.add(configurator, "tea017;teb043");
cds.configurator.DefaultRule.add(configurator, "tea017;teb044");
cds.configurator.DefaultRule.add(configurator, "tea017;teb045");
cds.configurator.DefaultRule.add(configurator, "tea017;teb046");
cds.configurator.DefaultRule.add(configurator, "tea017;teb048");
cds.configurator.DefaultRule.add(configurator, "tea017;teb050");
cds.configurator.DefaultRule.add(configurator, "tea017;teb052");
cds.configurator.DefaultRule.add(configurator, "tea017;teb053");
cds.configurator.DefaultRule.add(configurator, "tea017;teb056");
cds.configurator.DefaultRule.add(configurator, "tea017;teb060");
cds.configurator.DefaultRule.add(configurator, "tea017;teb062");
cds.configurator.DefaultRule.add(configurator, "tea017;teb063");
cds.configurator.DefaultRule.add(configurator, "tea017;teb064");
cds.configurator.DefaultRule.add(configurator, "tea017;teb067");
cds.configurator.DefaultRule.add(configurator, "tea017;teb068");
cds.configurator.DefaultRule.add(configurator, "tea017;teb070");
cds.configurator.DefaultRule.add(configurator, "tea017;teb071");
cds.configurator.DefaultRule.add(configurator, "tea017;teb072");
cds.configurator.DefaultRule.add(configurator, "tea017;teb074");
cds.configurator.DefaultRule.add(configurator, "tea017;teb075");
cds.configurator.DefaultRule.add(configurator, "tea017;teb080");
cds.configurator.DefaultRule.add(configurator, "tea017;teb084");
cds.configurator.DefaultRule.add(configurator, "tea017;teb090");
cds.configurator.DefaultRule.add(configurator, "tea017;teb096");
cds.configurator.DefaultRule.add(configurator, "tea017;teb100");
cds.configurator.DefaultRule.add(configurator, "tea017;teb112");
cds.configurator.DefaultRule.add(configurator, "tea017;teb120");
cds.configurator.DefaultRule.add(configurator, "tea017;teb126");
cds.configurator.DefaultRule.add(configurator, "tea017;teb140");
cds.configurator.DefaultRule.add(configurator, "tea017;teb144");
cds.configurator.DefaultRule.add(configurator, "tea017;teb154");
cds.configurator.DefaultRule.add(configurator, "tea017;teb168");
cds.configurator.DefaultRule.add(configurator, "tea017;teb180");
cds.configurator.DefaultRule.add(configurator, "tea017;teb192");
cds.configurator.DefaultRule.add(configurator, "tea017;teb200");
cds.configurator.DefaultRule.add(configurator, "tea017;teb216");
cds.configurator.DefaultRule.add(configurator, "tea017;teb224");
cds.configurator.DefaultRule.add(configurator, "tea018;teb019");
cds.configurator.DefaultRule.add(configurator, "tea018;teb020");
cds.configurator.DefaultRule.add(configurator, "tea018;teb021");
cds.configurator.DefaultRule.add(configurator, "tea018;teb022");
cds.configurator.DefaultRule.add(configurator, "tea018;teb023");
cds.configurator.DefaultRule.add(configurator, "tea018;teb024");
cds.configurator.DefaultRule.add(configurator, "tea018;teb025");
cds.configurator.DefaultRule.add(configurator, "tea018;teb026");
cds.configurator.DefaultRule.add(configurator, "tea018;teb027");
cds.configurator.DefaultRule.add(configurator, "tea018;teb028");
cds.configurator.DefaultRule.add(configurator, "tea018;teb029");
cds.configurator.DefaultRule.add(configurator, "tea018;teb030");
cds.configurator.DefaultRule.add(configurator, "tea018;teb031");
cds.configurator.DefaultRule.add(configurator, "tea018;teb032");
cds.configurator.DefaultRule.add(configurator, "tea018;teb033");
cds.configurator.DefaultRule.add(configurator, "tea018;teb034");
cds.configurator.DefaultRule.add(configurator, "tea018;teb035");
cds.configurator.DefaultRule.add(configurator, "tea018;teb036");
cds.configurator.DefaultRule.add(configurator, "tea018;teb037");
cds.configurator.DefaultRule.add(configurator, "tea018;teb038");
cds.configurator.DefaultRule.add(configurator, "tea018;teb039");
cds.configurator.DefaultRule.add(configurator, "tea018;teb040");
cds.configurator.DefaultRule.add(configurator, "tea018;teb041");
cds.configurator.DefaultRule.add(configurator, "tea018;teb042");
cds.configurator.DefaultRule.add(configurator, "tea018;teb043");
cds.configurator.DefaultRule.add(configurator, "tea018;teb044");
cds.configurator.DefaultRule.add(configurator, "tea018;teb045");
cds.configurator.DefaultRule.add(configurator, "tea018;teb046");
cds.configurator.DefaultRule.add(configurator, "tea018;teb048");
cds.configurator.DefaultRule.add(configurator, "tea018;teb050");
cds.configurator.DefaultRule.add(configurator, "tea018;teb052");
cds.configurator.DefaultRule.add(configurator, "tea018;teb053");
cds.configurator.DefaultRule.add(configurator, "tea018;teb056");
cds.configurator.DefaultRule.add(configurator, "tea018;teb060");
cds.configurator.DefaultRule.add(configurator, "tea018;teb062");
cds.configurator.DefaultRule.add(configurator, "tea018;teb063");
cds.configurator.DefaultRule.add(configurator, "tea018;teb064");
cds.configurator.DefaultRule.add(configurator, "tea018;teb067");
cds.configurator.DefaultRule.add(configurator, "tea018;teb068");
cds.configurator.DefaultRule.add(configurator, "tea018;teb070");
cds.configurator.DefaultRule.add(configurator, "tea018;teb071");
cds.configurator.DefaultRule.add(configurator, "tea018;teb072");
cds.configurator.DefaultRule.add(configurator, "tea018;teb074");
cds.configurator.DefaultRule.add(configurator, "tea018;teb075");
cds.configurator.DefaultRule.add(configurator, "tea018;teb080");
cds.configurator.DefaultRule.add(configurator, "tea018;teb084");
cds.configurator.DefaultRule.add(configurator, "tea018;teb090");
cds.configurator.DefaultRule.add(configurator, "tea018;teb096");
cds.configurator.DefaultRule.add(configurator, "tea018;teb100");
cds.configurator.DefaultRule.add(configurator, "tea018;teb112");
cds.configurator.DefaultRule.add(configurator, "tea018;teb120");
cds.configurator.DefaultRule.add(configurator, "tea018;teb126");
cds.configurator.DefaultRule.add(configurator, "tea018;teb140");
cds.configurator.DefaultRule.add(configurator, "tea018;teb144");
cds.configurator.DefaultRule.add(configurator, "tea018;teb154");
cds.configurator.DefaultRule.add(configurator, "tea018;teb168");
cds.configurator.DefaultRule.add(configurator, "tea018;teb180");
cds.configurator.DefaultRule.add(configurator, "tea018;teb192");
cds.configurator.DefaultRule.add(configurator, "tea018;teb200");
cds.configurator.DefaultRule.add(configurator, "tea018;teb216");
cds.configurator.DefaultRule.add(configurator, "tea018;teb224");
cds.configurator.DefaultRule.add(configurator, "tea019;teb020");
cds.configurator.DefaultRule.add(configurator, "tea019;teb021");
cds.configurator.DefaultRule.add(configurator, "tea019;teb022");
cds.configurator.DefaultRule.add(configurator, "tea019;teb023");
cds.configurator.DefaultRule.add(configurator, "tea019;teb024");
cds.configurator.DefaultRule.add(configurator, "tea019;teb025");
cds.configurator.DefaultRule.add(configurator, "tea019;teb026");
cds.configurator.DefaultRule.add(configurator, "tea019;teb027");
cds.configurator.DefaultRule.add(configurator, "tea019;teb028");
cds.configurator.DefaultRule.add(configurator, "tea019;teb029");
cds.configurator.DefaultRule.add(configurator, "tea019;teb030");
cds.configurator.DefaultRule.add(configurator, "tea019;teb031");
cds.configurator.DefaultRule.add(configurator, "tea019;teb032");
cds.configurator.DefaultRule.add(configurator, "tea019;teb033");
cds.configurator.DefaultRule.add(configurator, "tea019;teb034");
cds.configurator.DefaultRule.add(configurator, "tea019;teb035");
cds.configurator.DefaultRule.add(configurator, "tea019;teb036");
cds.configurator.DefaultRule.add(configurator, "tea019;teb037");
cds.configurator.DefaultRule.add(configurator, "tea019;teb038");
cds.configurator.DefaultRule.add(configurator, "tea019;teb039");
cds.configurator.DefaultRule.add(configurator, "tea019;teb040");
cds.configurator.DefaultRule.add(configurator, "tea019;teb041");
cds.configurator.DefaultRule.add(configurator, "tea019;teb042");
cds.configurator.DefaultRule.add(configurator, "tea019;teb043");
cds.configurator.DefaultRule.add(configurator, "tea019;teb044");
cds.configurator.DefaultRule.add(configurator, "tea019;teb045");
cds.configurator.DefaultRule.add(configurator, "tea019;teb046");
cds.configurator.DefaultRule.add(configurator, "tea019;teb048");
cds.configurator.DefaultRule.add(configurator, "tea019;teb050");
cds.configurator.DefaultRule.add(configurator, "tea019;teb052");
cds.configurator.DefaultRule.add(configurator, "tea019;teb053");
cds.configurator.DefaultRule.add(configurator, "tea019;teb056");
cds.configurator.DefaultRule.add(configurator, "tea019;teb060");
cds.configurator.DefaultRule.add(configurator, "tea019;teb062");
cds.configurator.DefaultRule.add(configurator, "tea019;teb063");
cds.configurator.DefaultRule.add(configurator, "tea019;teb064");
cds.configurator.DefaultRule.add(configurator, "tea019;teb067");
cds.configurator.DefaultRule.add(configurator, "tea019;teb068");
cds.configurator.DefaultRule.add(configurator, "tea019;teb070");
cds.configurator.DefaultRule.add(configurator, "tea019;teb071");
cds.configurator.DefaultRule.add(configurator, "tea019;teb072");
cds.configurator.DefaultRule.add(configurator, "tea019;teb074");
cds.configurator.DefaultRule.add(configurator, "tea019;teb075");
cds.configurator.DefaultRule.add(configurator, "tea019;teb080");
cds.configurator.DefaultRule.add(configurator, "tea019;teb084");
cds.configurator.DefaultRule.add(configurator, "tea019;teb090");
cds.configurator.DefaultRule.add(configurator, "tea019;teb096");
cds.configurator.DefaultRule.add(configurator, "tea019;teb100");
cds.configurator.DefaultRule.add(configurator, "tea019;teb112");
cds.configurator.DefaultRule.add(configurator, "tea019;teb120");
cds.configurator.DefaultRule.add(configurator, "tea019;teb126");
cds.configurator.DefaultRule.add(configurator, "tea019;teb140");
cds.configurator.DefaultRule.add(configurator, "tea019;teb144");
cds.configurator.DefaultRule.add(configurator, "tea019;teb154");
cds.configurator.DefaultRule.add(configurator, "tea019;teb168");
cds.configurator.DefaultRule.add(configurator, "tea019;teb180");
cds.configurator.DefaultRule.add(configurator, "tea019;teb192");
cds.configurator.DefaultRule.add(configurator, "tea019;teb200");
cds.configurator.DefaultRule.add(configurator, "tea019;teb216");
cds.configurator.DefaultRule.add(configurator, "tea019;teb224");
cds.configurator.DefaultRule.add(configurator, "tea020;teb021");
cds.configurator.DefaultRule.add(configurator, "tea020;teb022");
cds.configurator.DefaultRule.add(configurator, "tea020;teb023");
cds.configurator.DefaultRule.add(configurator, "tea020;teb024");
cds.configurator.DefaultRule.add(configurator, "tea020;teb025");
cds.configurator.DefaultRule.add(configurator, "tea020;teb026");
cds.configurator.DefaultRule.add(configurator, "tea020;teb027");
cds.configurator.DefaultRule.add(configurator, "tea020;teb028");
cds.configurator.DefaultRule.add(configurator, "tea020;teb029");
cds.configurator.DefaultRule.add(configurator, "tea020;teb030");
cds.configurator.DefaultRule.add(configurator, "tea020;teb031");
cds.configurator.DefaultRule.add(configurator, "tea020;teb032");
cds.configurator.DefaultRule.add(configurator, "tea020;teb033");
cds.configurator.DefaultRule.add(configurator, "tea020;teb034");
cds.configurator.DefaultRule.add(configurator, "tea020;teb035");
cds.configurator.DefaultRule.add(configurator, "tea020;teb036");
cds.configurator.DefaultRule.add(configurator, "tea020;teb037");
cds.configurator.DefaultRule.add(configurator, "tea020;teb038");
cds.configurator.DefaultRule.add(configurator, "tea020;teb039");
cds.configurator.DefaultRule.add(configurator, "tea020;teb040");
cds.configurator.DefaultRule.add(configurator, "tea020;teb041");
cds.configurator.DefaultRule.add(configurator, "tea020;teb042");
cds.configurator.DefaultRule.add(configurator, "tea020;teb043");
cds.configurator.DefaultRule.add(configurator, "tea020;teb044");
cds.configurator.DefaultRule.add(configurator, "tea020;teb045");
cds.configurator.DefaultRule.add(configurator, "tea020;teb046");
cds.configurator.DefaultRule.add(configurator, "tea020;teb048");
cds.configurator.DefaultRule.add(configurator, "tea020;teb050");
cds.configurator.DefaultRule.add(configurator, "tea020;teb052");
cds.configurator.DefaultRule.add(configurator, "tea020;teb053");
cds.configurator.DefaultRule.add(configurator, "tea020;teb056");
cds.configurator.DefaultRule.add(configurator, "tea020;teb060");
cds.configurator.DefaultRule.add(configurator, "tea020;teb062");
cds.configurator.DefaultRule.add(configurator, "tea020;teb063");
cds.configurator.DefaultRule.add(configurator, "tea020;teb064");
cds.configurator.DefaultRule.add(configurator, "tea020;teb067");
cds.configurator.DefaultRule.add(configurator, "tea020;teb068");
cds.configurator.DefaultRule.add(configurator, "tea020;teb070");
cds.configurator.DefaultRule.add(configurator, "tea020;teb071");
cds.configurator.DefaultRule.add(configurator, "tea020;teb072");
cds.configurator.DefaultRule.add(configurator, "tea020;teb074");
cds.configurator.DefaultRule.add(configurator, "tea020;teb075");
cds.configurator.DefaultRule.add(configurator, "tea020;teb080");
cds.configurator.DefaultRule.add(configurator, "tea020;teb084");
cds.configurator.DefaultRule.add(configurator, "tea020;teb090");
cds.configurator.DefaultRule.add(configurator, "tea020;teb096");
cds.configurator.DefaultRule.add(configurator, "tea020;teb100");
cds.configurator.DefaultRule.add(configurator, "tea020;teb112");
cds.configurator.DefaultRule.add(configurator, "tea020;teb120");
cds.configurator.DefaultRule.add(configurator, "tea020;teb126");
cds.configurator.DefaultRule.add(configurator, "tea020;teb140");
cds.configurator.DefaultRule.add(configurator, "tea020;teb144");
cds.configurator.DefaultRule.add(configurator, "tea020;teb154");
cds.configurator.DefaultRule.add(configurator, "tea020;teb168");
cds.configurator.DefaultRule.add(configurator, "tea020;teb180");
cds.configurator.DefaultRule.add(configurator, "tea020;teb192");
cds.configurator.DefaultRule.add(configurator, "tea020;teb200");
cds.configurator.DefaultRule.add(configurator, "tea020;teb216");
cds.configurator.DefaultRule.add(configurator, "tea020;teb224");
cds.configurator.DefaultRule.add(configurator, "tea021;teb022");
cds.configurator.DefaultRule.add(configurator, "tea021;teb023");
cds.configurator.DefaultRule.add(configurator, "tea021;teb024");
cds.configurator.DefaultRule.add(configurator, "tea021;teb025");
cds.configurator.DefaultRule.add(configurator, "tea021;teb026");
cds.configurator.DefaultRule.add(configurator, "tea021;teb027");
cds.configurator.DefaultRule.add(configurator, "tea021;teb028");
cds.configurator.DefaultRule.add(configurator, "tea021;teb029");
cds.configurator.DefaultRule.add(configurator, "tea021;teb030");
cds.configurator.DefaultRule.add(configurator, "tea021;teb031");
cds.configurator.DefaultRule.add(configurator, "tea021;teb032");
cds.configurator.DefaultRule.add(configurator, "tea021;teb033");
cds.configurator.DefaultRule.add(configurator, "tea021;teb034");
cds.configurator.DefaultRule.add(configurator, "tea021;teb035");
cds.configurator.DefaultRule.add(configurator, "tea021;teb036");
cds.configurator.DefaultRule.add(configurator, "tea021;teb037");
cds.configurator.DefaultRule.add(configurator, "tea021;teb038");
cds.configurator.DefaultRule.add(configurator, "tea021;teb039");
cds.configurator.DefaultRule.add(configurator, "tea021;teb040");
cds.configurator.DefaultRule.add(configurator, "tea021;teb041");
cds.configurator.DefaultRule.add(configurator, "tea021;teb042");
cds.configurator.DefaultRule.add(configurator, "tea021;teb043");
cds.configurator.DefaultRule.add(configurator, "tea021;teb044");
cds.configurator.DefaultRule.add(configurator, "tea021;teb045");
cds.configurator.DefaultRule.add(configurator, "tea021;teb046");
cds.configurator.DefaultRule.add(configurator, "tea021;teb048");
cds.configurator.DefaultRule.add(configurator, "tea021;teb050");
cds.configurator.DefaultRule.add(configurator, "tea021;teb052");
cds.configurator.DefaultRule.add(configurator, "tea021;teb053");
cds.configurator.DefaultRule.add(configurator, "tea021;teb056");
cds.configurator.DefaultRule.add(configurator, "tea021;teb060");
cds.configurator.DefaultRule.add(configurator, "tea021;teb062");
cds.configurator.DefaultRule.add(configurator, "tea021;teb063");
cds.configurator.DefaultRule.add(configurator, "tea021;teb064");
cds.configurator.DefaultRule.add(configurator, "tea021;teb067");
cds.configurator.DefaultRule.add(configurator, "tea021;teb068");
cds.configurator.DefaultRule.add(configurator, "tea021;teb070");
cds.configurator.DefaultRule.add(configurator, "tea021;teb071");
cds.configurator.DefaultRule.add(configurator, "tea021;teb072");
cds.configurator.DefaultRule.add(configurator, "tea021;teb074");
cds.configurator.DefaultRule.add(configurator, "tea021;teb075");
cds.configurator.DefaultRule.add(configurator, "tea021;teb080");
cds.configurator.DefaultRule.add(configurator, "tea021;teb084");
cds.configurator.DefaultRule.add(configurator, "tea021;teb090");
cds.configurator.DefaultRule.add(configurator, "tea021;teb096");
cds.configurator.DefaultRule.add(configurator, "tea021;teb100");
cds.configurator.DefaultRule.add(configurator, "tea021;teb112");
cds.configurator.DefaultRule.add(configurator, "tea021;teb120");
cds.configurator.DefaultRule.add(configurator, "tea021;teb126");
cds.configurator.DefaultRule.add(configurator, "tea021;teb140");
cds.configurator.DefaultRule.add(configurator, "tea021;teb144");
cds.configurator.DefaultRule.add(configurator, "tea021;teb154");
cds.configurator.DefaultRule.add(configurator, "tea021;teb168");
cds.configurator.DefaultRule.add(configurator, "tea021;teb180");
cds.configurator.DefaultRule.add(configurator, "tea021;teb192");
cds.configurator.DefaultRule.add(configurator, "tea021;teb200");
cds.configurator.DefaultRule.add(configurator, "tea021;teb216");
cds.configurator.DefaultRule.add(configurator, "tea021;teb224");
cds.configurator.DefaultRule.add(configurator, "tea022;teb023");
cds.configurator.DefaultRule.add(configurator, "tea022;teb024");
cds.configurator.DefaultRule.add(configurator, "tea022;teb025");
cds.configurator.DefaultRule.add(configurator, "tea022;teb026");
cds.configurator.DefaultRule.add(configurator, "tea022;teb027");
cds.configurator.DefaultRule.add(configurator, "tea022;teb028");
cds.configurator.DefaultRule.add(configurator, "tea022;teb029");
cds.configurator.DefaultRule.add(configurator, "tea022;teb030");
cds.configurator.DefaultRule.add(configurator, "tea022;teb031");
cds.configurator.DefaultRule.add(configurator, "tea022;teb032");
cds.configurator.DefaultRule.add(configurator, "tea022;teb033");
cds.configurator.DefaultRule.add(configurator, "tea022;teb034");
cds.configurator.DefaultRule.add(configurator, "tea022;teb035");
cds.configurator.DefaultRule.add(configurator, "tea022;teb036");
cds.configurator.DefaultRule.add(configurator, "tea022;teb037");
cds.configurator.DefaultRule.add(configurator, "tea022;teb038");
cds.configurator.DefaultRule.add(configurator, "tea022;teb039");
cds.configurator.DefaultRule.add(configurator, "tea022;teb040");
cds.configurator.DefaultRule.add(configurator, "tea022;teb041");
cds.configurator.DefaultRule.add(configurator, "tea022;teb042");
cds.configurator.DefaultRule.add(configurator, "tea022;teb043");
cds.configurator.DefaultRule.add(configurator, "tea022;teb044");
cds.configurator.DefaultRule.add(configurator, "tea022;teb045");
cds.configurator.DefaultRule.add(configurator, "tea022;teb046");
cds.configurator.DefaultRule.add(configurator, "tea022;teb048");
cds.configurator.DefaultRule.add(configurator, "tea022;teb050");
cds.configurator.DefaultRule.add(configurator, "tea022;teb052");
cds.configurator.DefaultRule.add(configurator, "tea022;teb053");
cds.configurator.DefaultRule.add(configurator, "tea022;teb056");
cds.configurator.DefaultRule.add(configurator, "tea022;teb060");
cds.configurator.DefaultRule.add(configurator, "tea022;teb062");
cds.configurator.DefaultRule.add(configurator, "tea022;teb063");
cds.configurator.DefaultRule.add(configurator, "tea022;teb064");
cds.configurator.DefaultRule.add(configurator, "tea022;teb067");
cds.configurator.DefaultRule.add(configurator, "tea022;teb068");
cds.configurator.DefaultRule.add(configurator, "tea022;teb070");
cds.configurator.DefaultRule.add(configurator, "tea022;teb071");
cds.configurator.DefaultRule.add(configurator, "tea022;teb072");
cds.configurator.DefaultRule.add(configurator, "tea022;teb074");
cds.configurator.DefaultRule.add(configurator, "tea022;teb075");
cds.configurator.DefaultRule.add(configurator, "tea022;teb080");
cds.configurator.DefaultRule.add(configurator, "tea022;teb084");
cds.configurator.DefaultRule.add(configurator, "tea022;teb090");
cds.configurator.DefaultRule.add(configurator, "tea022;teb096");
cds.configurator.DefaultRule.add(configurator, "tea022;teb100");
cds.configurator.DefaultRule.add(configurator, "tea022;teb112");
cds.configurator.DefaultRule.add(configurator, "tea022;teb120");
cds.configurator.DefaultRule.add(configurator, "tea022;teb126");
cds.configurator.DefaultRule.add(configurator, "tea022;teb140");
cds.configurator.DefaultRule.add(configurator, "tea022;teb144");
cds.configurator.DefaultRule.add(configurator, "tea022;teb154");
cds.configurator.DefaultRule.add(configurator, "tea022;teb168");
cds.configurator.DefaultRule.add(configurator, "tea022;teb180");
cds.configurator.DefaultRule.add(configurator, "tea022;teb192");
cds.configurator.DefaultRule.add(configurator, "tea022;teb200");
cds.configurator.DefaultRule.add(configurator, "tea022;teb216");
cds.configurator.DefaultRule.add(configurator, "tea022;teb224");
cds.configurator.DefaultRule.add(configurator, "tea023;teb024");
cds.configurator.DefaultRule.add(configurator, "tea023;teb025");
cds.configurator.DefaultRule.add(configurator, "tea023;teb026");
cds.configurator.DefaultRule.add(configurator, "tea023;teb027");
cds.configurator.DefaultRule.add(configurator, "tea023;teb028");
cds.configurator.DefaultRule.add(configurator, "tea023;teb029");
cds.configurator.DefaultRule.add(configurator, "tea023;teb030");
cds.configurator.DefaultRule.add(configurator, "tea023;teb031");
cds.configurator.DefaultRule.add(configurator, "tea023;teb032");
cds.configurator.DefaultRule.add(configurator, "tea023;teb033");
cds.configurator.DefaultRule.add(configurator, "tea023;teb034");
cds.configurator.DefaultRule.add(configurator, "tea023;teb035");
cds.configurator.DefaultRule.add(configurator, "tea023;teb036");
cds.configurator.DefaultRule.add(configurator, "tea023;teb037");
cds.configurator.DefaultRule.add(configurator, "tea023;teb038");
cds.configurator.DefaultRule.add(configurator, "tea023;teb039");
cds.configurator.DefaultRule.add(configurator, "tea023;teb040");
cds.configurator.DefaultRule.add(configurator, "tea023;teb041");
cds.configurator.DefaultRule.add(configurator, "tea023;teb042");
cds.configurator.DefaultRule.add(configurator, "tea023;teb043");
cds.configurator.DefaultRule.add(configurator, "tea023;teb044");
cds.configurator.DefaultRule.add(configurator, "tea023;teb045");
cds.configurator.DefaultRule.add(configurator, "tea023;teb046");
cds.configurator.DefaultRule.add(configurator, "tea023;teb048");
cds.configurator.DefaultRule.add(configurator, "tea023;teb050");
cds.configurator.DefaultRule.add(configurator, "tea023;teb052");
cds.configurator.DefaultRule.add(configurator, "tea023;teb053");
cds.configurator.DefaultRule.add(configurator, "tea023;teb056");
cds.configurator.DefaultRule.add(configurator, "tea023;teb060");
cds.configurator.DefaultRule.add(configurator, "tea023;teb062");
cds.configurator.DefaultRule.add(configurator, "tea023;teb063");
cds.configurator.DefaultRule.add(configurator, "tea023;teb064");
cds.configurator.DefaultRule.add(configurator, "tea023;teb067");
cds.configurator.DefaultRule.add(configurator, "tea023;teb068");
cds.configurator.DefaultRule.add(configurator, "tea023;teb070");
cds.configurator.DefaultRule.add(configurator, "tea023;teb071");
cds.configurator.DefaultRule.add(configurator, "tea023;teb072");
cds.configurator.DefaultRule.add(configurator, "tea023;teb074");
cds.configurator.DefaultRule.add(configurator, "tea023;teb075");
cds.configurator.DefaultRule.add(configurator, "tea023;teb080");
cds.configurator.DefaultRule.add(configurator, "tea023;teb084");
cds.configurator.DefaultRule.add(configurator, "tea023;teb090");
cds.configurator.DefaultRule.add(configurator, "tea023;teb096");
cds.configurator.DefaultRule.add(configurator, "tea023;teb100");
cds.configurator.DefaultRule.add(configurator, "tea023;teb112");
cds.configurator.DefaultRule.add(configurator, "tea023;teb120");
cds.configurator.DefaultRule.add(configurator, "tea023;teb126");
cds.configurator.DefaultRule.add(configurator, "tea023;teb140");
cds.configurator.DefaultRule.add(configurator, "tea023;teb144");
cds.configurator.DefaultRule.add(configurator, "tea023;teb154");
cds.configurator.DefaultRule.add(configurator, "tea023;teb168");
cds.configurator.DefaultRule.add(configurator, "tea023;teb180");
cds.configurator.DefaultRule.add(configurator, "tea023;teb192");
cds.configurator.DefaultRule.add(configurator, "tea023;teb200");
cds.configurator.DefaultRule.add(configurator, "tea023;teb216");
cds.configurator.DefaultRule.add(configurator, "tea023;teb224");
cds.configurator.DefaultRule.add(configurator, "tea024;teb025");
cds.configurator.DefaultRule.add(configurator, "tea024;teb026");
cds.configurator.DefaultRule.add(configurator, "tea024;teb027");
cds.configurator.DefaultRule.add(configurator, "tea024;teb028");
cds.configurator.DefaultRule.add(configurator, "tea024;teb029");
cds.configurator.DefaultRule.add(configurator, "tea024;teb030");
cds.configurator.DefaultRule.add(configurator, "tea024;teb031");
cds.configurator.DefaultRule.add(configurator, "tea024;teb032");
cds.configurator.DefaultRule.add(configurator, "tea024;teb033");
cds.configurator.DefaultRule.add(configurator, "tea024;teb034");
cds.configurator.DefaultRule.add(configurator, "tea024;teb035");
cds.configurator.DefaultRule.add(configurator, "tea024;teb036");
cds.configurator.DefaultRule.add(configurator, "tea024;teb037");
cds.configurator.DefaultRule.add(configurator, "tea024;teb038");
cds.configurator.DefaultRule.add(configurator, "tea024;teb039");
cds.configurator.DefaultRule.add(configurator, "tea024;teb040");
cds.configurator.DefaultRule.add(configurator, "tea024;teb041");
cds.configurator.DefaultRule.add(configurator, "tea024;teb042");
cds.configurator.DefaultRule.add(configurator, "tea024;teb043");
cds.configurator.DefaultRule.add(configurator, "tea024;teb044");
cds.configurator.DefaultRule.add(configurator, "tea024;teb045");
cds.configurator.DefaultRule.add(configurator, "tea024;teb046");
cds.configurator.DefaultRule.add(configurator, "tea024;teb048");
cds.configurator.DefaultRule.add(configurator, "tea024;teb050");
cds.configurator.DefaultRule.add(configurator, "tea024;teb052");
cds.configurator.DefaultRule.add(configurator, "tea024;teb053");
cds.configurator.DefaultRule.add(configurator, "tea024;teb056");
cds.configurator.DefaultRule.add(configurator, "tea024;teb060");
cds.configurator.DefaultRule.add(configurator, "tea024;teb062");
cds.configurator.DefaultRule.add(configurator, "tea024;teb063");
cds.configurator.DefaultRule.add(configurator, "tea024;teb064");
cds.configurator.DefaultRule.add(configurator, "tea024;teb067");
cds.configurator.DefaultRule.add(configurator, "tea024;teb068");
cds.configurator.DefaultRule.add(configurator, "tea024;teb070");
cds.configurator.DefaultRule.add(configurator, "tea024;teb071");
cds.configurator.DefaultRule.add(configurator, "tea024;teb072");
cds.configurator.DefaultRule.add(configurator, "tea024;teb074");
cds.configurator.DefaultRule.add(configurator, "tea024;teb075");
cds.configurator.DefaultRule.add(configurator, "tea024;teb080");
cds.configurator.DefaultRule.add(configurator, "tea024;teb084");
cds.configurator.DefaultRule.add(configurator, "tea024;teb090");
cds.configurator.DefaultRule.add(configurator, "tea024;teb096");
cds.configurator.DefaultRule.add(configurator, "tea024;teb100");
cds.configurator.DefaultRule.add(configurator, "tea024;teb112");
cds.configurator.DefaultRule.add(configurator, "tea024;teb120");
cds.configurator.DefaultRule.add(configurator, "tea024;teb126");
cds.configurator.DefaultRule.add(configurator, "tea024;teb140");
cds.configurator.DefaultRule.add(configurator, "tea024;teb144");
cds.configurator.DefaultRule.add(configurator, "tea024;teb154");
cds.configurator.DefaultRule.add(configurator, "tea024;teb168");
cds.configurator.DefaultRule.add(configurator, "tea024;teb180");
cds.configurator.DefaultRule.add(configurator, "tea024;teb192");
cds.configurator.DefaultRule.add(configurator, "tea024;teb200");
cds.configurator.DefaultRule.add(configurator, "tea024;teb216");
cds.configurator.DefaultRule.add(configurator, "tea024;teb224");
cds.configurator.DefaultRule.add(configurator, "tea025;teb026");
cds.configurator.DefaultRule.add(configurator, "tea025;teb027");
cds.configurator.DefaultRule.add(configurator, "tea025;teb028");
cds.configurator.DefaultRule.add(configurator, "tea025;teb029");
cds.configurator.DefaultRule.add(configurator, "tea025;teb030");
cds.configurator.DefaultRule.add(configurator, "tea025;teb031");
cds.configurator.DefaultRule.add(configurator, "tea025;teb032");
cds.configurator.DefaultRule.add(configurator, "tea025;teb033");
cds.configurator.DefaultRule.add(configurator, "tea025;teb034");
cds.configurator.DefaultRule.add(configurator, "tea025;teb035");
cds.configurator.DefaultRule.add(configurator, "tea025;teb036");
cds.configurator.DefaultRule.add(configurator, "tea025;teb037");
cds.configurator.DefaultRule.add(configurator, "tea025;teb038");
cds.configurator.DefaultRule.add(configurator, "tea025;teb039");
cds.configurator.DefaultRule.add(configurator, "tea025;teb040");
cds.configurator.DefaultRule.add(configurator, "tea025;teb041");
cds.configurator.DefaultRule.add(configurator, "tea025;teb042");
cds.configurator.DefaultRule.add(configurator, "tea025;teb043");
cds.configurator.DefaultRule.add(configurator, "tea025;teb044");
cds.configurator.DefaultRule.add(configurator, "tea025;teb045");
cds.configurator.DefaultRule.add(configurator, "tea025;teb046");
cds.configurator.DefaultRule.add(configurator, "tea025;teb048");
cds.configurator.DefaultRule.add(configurator, "tea025;teb050");
cds.configurator.DefaultRule.add(configurator, "tea025;teb052");
cds.configurator.DefaultRule.add(configurator, "tea025;teb053");
cds.configurator.DefaultRule.add(configurator, "tea025;teb056");
cds.configurator.DefaultRule.add(configurator, "tea025;teb060");
cds.configurator.DefaultRule.add(configurator, "tea025;teb062");
cds.configurator.DefaultRule.add(configurator, "tea025;teb063");
cds.configurator.DefaultRule.add(configurator, "tea025;teb064");
cds.configurator.DefaultRule.add(configurator, "tea025;teb067");
cds.configurator.DefaultRule.add(configurator, "tea025;teb068");
cds.configurator.DefaultRule.add(configurator, "tea025;teb070");
cds.configurator.DefaultRule.add(configurator, "tea025;teb071");
cds.configurator.DefaultRule.add(configurator, "tea025;teb072");
cds.configurator.DefaultRule.add(configurator, "tea025;teb074");
cds.configurator.DefaultRule.add(configurator, "tea025;teb075");
cds.configurator.DefaultRule.add(configurator, "tea025;teb080");
cds.configurator.DefaultRule.add(configurator, "tea025;teb084");
cds.configurator.DefaultRule.add(configurator, "tea025;teb090");
cds.configurator.DefaultRule.add(configurator, "tea025;teb096");
cds.configurator.DefaultRule.add(configurator, "tea025;teb100");
cds.configurator.DefaultRule.add(configurator, "tea025;teb112");
cds.configurator.DefaultRule.add(configurator, "tea025;teb120");
cds.configurator.DefaultRule.add(configurator, "tea025;teb126");
cds.configurator.DefaultRule.add(configurator, "tea025;teb140");
cds.configurator.DefaultRule.add(configurator, "tea025;teb144");
cds.configurator.DefaultRule.add(configurator, "tea025;teb154");
cds.configurator.DefaultRule.add(configurator, "tea025;teb168");
cds.configurator.DefaultRule.add(configurator, "tea025;teb180");
cds.configurator.DefaultRule.add(configurator, "tea025;teb192");
cds.configurator.DefaultRule.add(configurator, "tea025;teb200");
cds.configurator.DefaultRule.add(configurator, "tea025;teb216");
cds.configurator.DefaultRule.add(configurator, "tea026;teb224");
cds.configurator.DefaultRule.add(configurator, "tea026;teb027");
cds.configurator.DefaultRule.add(configurator, "tea026;teb028");
cds.configurator.DefaultRule.add(configurator, "tea026;teb029");
cds.configurator.DefaultRule.add(configurator, "tea026;teb030");
cds.configurator.DefaultRule.add(configurator, "tea026;teb031");
cds.configurator.DefaultRule.add(configurator, "tea026;teb032");
cds.configurator.DefaultRule.add(configurator, "tea026;teb033");
cds.configurator.DefaultRule.add(configurator, "tea026;teb034");
cds.configurator.DefaultRule.add(configurator, "tea026;teb035");
cds.configurator.DefaultRule.add(configurator, "tea026;teb036");
cds.configurator.DefaultRule.add(configurator, "tea026;teb037");
cds.configurator.DefaultRule.add(configurator, "tea026;teb038");
cds.configurator.DefaultRule.add(configurator, "tea026;teb039");
cds.configurator.DefaultRule.add(configurator, "tea026;teb040");
cds.configurator.DefaultRule.add(configurator, "tea026;teb041");
cds.configurator.DefaultRule.add(configurator, "tea026;teb042");
cds.configurator.DefaultRule.add(configurator, "tea026;teb043");
cds.configurator.DefaultRule.add(configurator, "tea026;teb044");
cds.configurator.DefaultRule.add(configurator, "tea026;teb045");
cds.configurator.DefaultRule.add(configurator, "tea026;teb046");
cds.configurator.DefaultRule.add(configurator, "tea026;teb048");
cds.configurator.DefaultRule.add(configurator, "tea026;teb050");
cds.configurator.DefaultRule.add(configurator, "tea026;teb052");
cds.configurator.DefaultRule.add(configurator, "tea026;teb053");
cds.configurator.DefaultRule.add(configurator, "tea026;teb056");
cds.configurator.DefaultRule.add(configurator, "tea026;teb060");
cds.configurator.DefaultRule.add(configurator, "tea026;teb062");
cds.configurator.DefaultRule.add(configurator, "tea026;teb063");
cds.configurator.DefaultRule.add(configurator, "tea026;teb064");
cds.configurator.DefaultRule.add(configurator, "tea026;teb067");
cds.configurator.DefaultRule.add(configurator, "tea026;teb068");
cds.configurator.DefaultRule.add(configurator, "tea026;teb070");
cds.configurator.DefaultRule.add(configurator, "tea026;teb071");
cds.configurator.DefaultRule.add(configurator, "tea026;teb072");
cds.configurator.DefaultRule.add(configurator, "tea026;teb074");
cds.configurator.DefaultRule.add(configurator, "tea026;teb075");
cds.configurator.DefaultRule.add(configurator, "tea026;teb080");
cds.configurator.DefaultRule.add(configurator, "tea026;teb084");
cds.configurator.DefaultRule.add(configurator, "tea026;teb090");
cds.configurator.DefaultRule.add(configurator, "tea026;teb096");
cds.configurator.DefaultRule.add(configurator, "tea026;teb100");
cds.configurator.DefaultRule.add(configurator, "tea026;teb112");
cds.configurator.DefaultRule.add(configurator, "tea026;teb120");
cds.configurator.DefaultRule.add(configurator, "tea026;teb126");
cds.configurator.DefaultRule.add(configurator, "tea026;teb140");
cds.configurator.DefaultRule.add(configurator, "tea026;teb144");
cds.configurator.DefaultRule.add(configurator, "tea026;teb154");
cds.configurator.DefaultRule.add(configurator, "tea026;teb168");
cds.configurator.DefaultRule.add(configurator, "tea026;teb180");
cds.configurator.DefaultRule.add(configurator, "tea026;teb192");
cds.configurator.DefaultRule.add(configurator, "tea026;teb200");
cds.configurator.DefaultRule.add(configurator, "tea026;teb216");
cds.configurator.DefaultRule.add(configurator, "tea026;teb224");
cds.configurator.DefaultRule.add(configurator, "tea027;teb028");
cds.configurator.DefaultRule.add(configurator, "tea027;teb029");
cds.configurator.DefaultRule.add(configurator, "tea027;teb030");
cds.configurator.DefaultRule.add(configurator, "tea027;teb031");
cds.configurator.DefaultRule.add(configurator, "tea027;teb032");
cds.configurator.DefaultRule.add(configurator, "tea027;teb033");
cds.configurator.DefaultRule.add(configurator, "tea027;teb034");
cds.configurator.DefaultRule.add(configurator, "tea027;teb035");
cds.configurator.DefaultRule.add(configurator, "tea027;teb036");
cds.configurator.DefaultRule.add(configurator, "tea027;teb037");
cds.configurator.DefaultRule.add(configurator, "tea027;teb038");
cds.configurator.DefaultRule.add(configurator, "tea027;teb039");
cds.configurator.DefaultRule.add(configurator, "tea027;teb040");
cds.configurator.DefaultRule.add(configurator, "tea027;teb041");
cds.configurator.DefaultRule.add(configurator, "tea027;teb042");
cds.configurator.DefaultRule.add(configurator, "tea027;teb043");
cds.configurator.DefaultRule.add(configurator, "tea027;teb044");
cds.configurator.DefaultRule.add(configurator, "tea027;teb045");
cds.configurator.DefaultRule.add(configurator, "tea027;teb046");
cds.configurator.DefaultRule.add(configurator, "tea027;teb048");
cds.configurator.DefaultRule.add(configurator, "tea027;teb050");
cds.configurator.DefaultRule.add(configurator, "tea027;teb052");
cds.configurator.DefaultRule.add(configurator, "tea027;teb053");
cds.configurator.DefaultRule.add(configurator, "tea027;teb056");
cds.configurator.DefaultRule.add(configurator, "tea027;teb060");
cds.configurator.DefaultRule.add(configurator, "tea027;teb062");
cds.configurator.DefaultRule.add(configurator, "tea027;teb063");
cds.configurator.DefaultRule.add(configurator, "tea027;teb064");
cds.configurator.DefaultRule.add(configurator, "tea027;teb067");
cds.configurator.DefaultRule.add(configurator, "tea027;teb068");
cds.configurator.DefaultRule.add(configurator, "tea027;teb070");
cds.configurator.DefaultRule.add(configurator, "tea027;teb071");
cds.configurator.DefaultRule.add(configurator, "tea027;teb072");
cds.configurator.DefaultRule.add(configurator, "tea027;teb074");
cds.configurator.DefaultRule.add(configurator, "tea027;teb075");
cds.configurator.DefaultRule.add(configurator, "tea027;teb080");
cds.configurator.DefaultRule.add(configurator, "tea027;teb084");
cds.configurator.DefaultRule.add(configurator, "tea027;teb090");
cds.configurator.DefaultRule.add(configurator, "tea027;teb096");
cds.configurator.DefaultRule.add(configurator, "tea027;teb100");
cds.configurator.DefaultRule.add(configurator, "tea027;teb112");
cds.configurator.DefaultRule.add(configurator, "tea027;teb120");
cds.configurator.DefaultRule.add(configurator, "tea027;teb126");
cds.configurator.DefaultRule.add(configurator, "tea027;teb140");
cds.configurator.DefaultRule.add(configurator, "tea027;teb144");
cds.configurator.DefaultRule.add(configurator, "tea027;teb154");
cds.configurator.DefaultRule.add(configurator, "tea027;teb168");
cds.configurator.DefaultRule.add(configurator, "tea027;teb180");
cds.configurator.DefaultRule.add(configurator, "tea027;teb192");
cds.configurator.DefaultRule.add(configurator, "tea027;teb200");
cds.configurator.DefaultRule.add(configurator, "tea027;teb216");
cds.configurator.DefaultRule.add(configurator, "tea027;teb224");
cds.configurator.DefaultRule.add(configurator, "tea028;teb029");
cds.configurator.DefaultRule.add(configurator, "tea028;teb030");
cds.configurator.DefaultRule.add(configurator, "tea028;teb031");
cds.configurator.DefaultRule.add(configurator, "tea028;teb032");
cds.configurator.DefaultRule.add(configurator, "tea028;teb033");
cds.configurator.DefaultRule.add(configurator, "tea028;teb034");
cds.configurator.DefaultRule.add(configurator, "tea028;teb035");
cds.configurator.DefaultRule.add(configurator, "tea028;teb036");
cds.configurator.DefaultRule.add(configurator, "tea028;teb037");
cds.configurator.DefaultRule.add(configurator, "tea028;teb038");
cds.configurator.DefaultRule.add(configurator, "tea028;teb039");
cds.configurator.DefaultRule.add(configurator, "tea028;teb040");
cds.configurator.DefaultRule.add(configurator, "tea028;teb041");
cds.configurator.DefaultRule.add(configurator, "tea028;teb042");
cds.configurator.DefaultRule.add(configurator, "tea028;teb043");
cds.configurator.DefaultRule.add(configurator, "tea028;teb044");
cds.configurator.DefaultRule.add(configurator, "tea028;teb045");
cds.configurator.DefaultRule.add(configurator, "tea028;teb046");
cds.configurator.DefaultRule.add(configurator, "tea028;teb048");
cds.configurator.DefaultRule.add(configurator, "tea028;teb050");
cds.configurator.DefaultRule.add(configurator, "tea028;teb052");
cds.configurator.DefaultRule.add(configurator, "tea028;teb053");
cds.configurator.DefaultRule.add(configurator, "tea028;teb056");
cds.configurator.DefaultRule.add(configurator, "tea028;teb060");
cds.configurator.DefaultRule.add(configurator, "tea028;teb062");
cds.configurator.DefaultRule.add(configurator, "tea028;teb063");
cds.configurator.DefaultRule.add(configurator, "tea028;teb064");
cds.configurator.DefaultRule.add(configurator, "tea028;teb067");
cds.configurator.DefaultRule.add(configurator, "tea028;teb068");
cds.configurator.DefaultRule.add(configurator, "tea028;teb070");
cds.configurator.DefaultRule.add(configurator, "tea028;teb071");
cds.configurator.DefaultRule.add(configurator, "tea028;teb072");
cds.configurator.DefaultRule.add(configurator, "tea028;teb074");
cds.configurator.DefaultRule.add(configurator, "tea028;teb075");
cds.configurator.DefaultRule.add(configurator, "tea028;teb080");
cds.configurator.DefaultRule.add(configurator, "tea028;teb084");
cds.configurator.DefaultRule.add(configurator, "tea028;teb090");
cds.configurator.DefaultRule.add(configurator, "tea028;teb096");
cds.configurator.DefaultRule.add(configurator, "tea028;teb100");
cds.configurator.DefaultRule.add(configurator, "tea028;teb112");
cds.configurator.DefaultRule.add(configurator, "tea028;teb120");
cds.configurator.DefaultRule.add(configurator, "tea028;teb126");
cds.configurator.DefaultRule.add(configurator, "tea028;teb140");
cds.configurator.DefaultRule.add(configurator, "tea028;teb144");
cds.configurator.DefaultRule.add(configurator, "tea028;teb154");
cds.configurator.DefaultRule.add(configurator, "tea028;teb168");
cds.configurator.DefaultRule.add(configurator, "tea028;teb180");
cds.configurator.DefaultRule.add(configurator, "tea028;teb192");
cds.configurator.DefaultRule.add(configurator, "tea028;teb200");
cds.configurator.DefaultRule.add(configurator, "tea028;teb216");
cds.configurator.DefaultRule.add(configurator, "tea028;teb224");
cds.configurator.DefaultRule.add(configurator, "tea029;teb030");
cds.configurator.DefaultRule.add(configurator, "tea029;teb031");
cds.configurator.DefaultRule.add(configurator, "tea029;teb032");
cds.configurator.DefaultRule.add(configurator, "tea029;teb033");
cds.configurator.DefaultRule.add(configurator, "tea029;teb034");
cds.configurator.DefaultRule.add(configurator, "tea029;teb035");
cds.configurator.DefaultRule.add(configurator, "tea029;teb036");
cds.configurator.DefaultRule.add(configurator, "tea029;teb037");
cds.configurator.DefaultRule.add(configurator, "tea029;teb038");
cds.configurator.DefaultRule.add(configurator, "tea029;teb039");
cds.configurator.DefaultRule.add(configurator, "tea029;teb040");
cds.configurator.DefaultRule.add(configurator, "tea029;teb041");
cds.configurator.DefaultRule.add(configurator, "tea029;teb042");
cds.configurator.DefaultRule.add(configurator, "tea029;teb043");
cds.configurator.DefaultRule.add(configurator, "tea029;teb044");
cds.configurator.DefaultRule.add(configurator, "tea029;teb045");
cds.configurator.DefaultRule.add(configurator, "tea029;teb046");
cds.configurator.DefaultRule.add(configurator, "tea029;teb048");
cds.configurator.DefaultRule.add(configurator, "tea029;teb050");
cds.configurator.DefaultRule.add(configurator, "tea029;teb052");
cds.configurator.DefaultRule.add(configurator, "tea029;teb053");
cds.configurator.DefaultRule.add(configurator, "tea029;teb056");
cds.configurator.DefaultRule.add(configurator, "tea029;teb060");
cds.configurator.DefaultRule.add(configurator, "tea029;teb062");
cds.configurator.DefaultRule.add(configurator, "tea029;teb063");
cds.configurator.DefaultRule.add(configurator, "tea029;teb064");
cds.configurator.DefaultRule.add(configurator, "tea029;teb067");
cds.configurator.DefaultRule.add(configurator, "tea029;teb068");
cds.configurator.DefaultRule.add(configurator, "tea029;teb070");
cds.configurator.DefaultRule.add(configurator, "tea029;teb071");
cds.configurator.DefaultRule.add(configurator, "tea029;teb072");
cds.configurator.DefaultRule.add(configurator, "tea029;teb074");
cds.configurator.DefaultRule.add(configurator, "tea029;teb075");
cds.configurator.DefaultRule.add(configurator, "tea029;teb080");
cds.configurator.DefaultRule.add(configurator, "tea029;teb084");
cds.configurator.DefaultRule.add(configurator, "tea029;teb090");
cds.configurator.DefaultRule.add(configurator, "tea029;teb096");
cds.configurator.DefaultRule.add(configurator, "tea029;teb100");
cds.configurator.DefaultRule.add(configurator, "tea029;teb112");
cds.configurator.DefaultRule.add(configurator, "tea029;teb120");
cds.configurator.DefaultRule.add(configurator, "tea029;teb126");
cds.configurator.DefaultRule.add(configurator, "tea029;teb140");
cds.configurator.DefaultRule.add(configurator, "tea029;teb144");
cds.configurator.DefaultRule.add(configurator, "tea029;teb154");
cds.configurator.DefaultRule.add(configurator, "tea029;teb168");
cds.configurator.DefaultRule.add(configurator, "tea029;teb180");
cds.configurator.DefaultRule.add(configurator, "tea029;teb192");
cds.configurator.DefaultRule.add(configurator, "tea029;teb200");
cds.configurator.DefaultRule.add(configurator, "tea029;teb216");
cds.configurator.DefaultRule.add(configurator, "tea029;teb224");
cds.configurator.DefaultRule.add(configurator, "tea030;teb031");
cds.configurator.DefaultRule.add(configurator, "tea030;teb032");
cds.configurator.DefaultRule.add(configurator, "tea030;teb033");
cds.configurator.DefaultRule.add(configurator, "tea030;teb034");
cds.configurator.DefaultRule.add(configurator, "tea030;teb035");
cds.configurator.DefaultRule.add(configurator, "tea030;teb036");
cds.configurator.DefaultRule.add(configurator, "tea030;teb037");
cds.configurator.DefaultRule.add(configurator, "tea030;teb038");
cds.configurator.DefaultRule.add(configurator, "tea030;teb039");
cds.configurator.DefaultRule.add(configurator, "tea030;teb040");
cds.configurator.DefaultRule.add(configurator, "tea030;teb041");
cds.configurator.DefaultRule.add(configurator, "tea030;teb042");
cds.configurator.DefaultRule.add(configurator, "tea030;teb043");
cds.configurator.DefaultRule.add(configurator, "tea030;teb044");
cds.configurator.DefaultRule.add(configurator, "tea030;teb045");
cds.configurator.DefaultRule.add(configurator, "tea030;teb046");
cds.configurator.DefaultRule.add(configurator, "tea030;teb048");
cds.configurator.DefaultRule.add(configurator, "tea030;teb050");
cds.configurator.DefaultRule.add(configurator, "tea030;teb052");
cds.configurator.DefaultRule.add(configurator, "tea030;teb053");
cds.configurator.DefaultRule.add(configurator, "tea030;teb056");
cds.configurator.DefaultRule.add(configurator, "tea030;teb060");
cds.configurator.DefaultRule.add(configurator, "tea030;teb062");
cds.configurator.DefaultRule.add(configurator, "tea030;teb063");
cds.configurator.DefaultRule.add(configurator, "tea030;teb064");
cds.configurator.DefaultRule.add(configurator, "tea030;teb067");
cds.configurator.DefaultRule.add(configurator, "tea030;teb068");
cds.configurator.DefaultRule.add(configurator, "tea030;teb070");
cds.configurator.DefaultRule.add(configurator, "tea030;teb071");
cds.configurator.DefaultRule.add(configurator, "tea030;teb072");
cds.configurator.DefaultRule.add(configurator, "tea030;teb074");
cds.configurator.DefaultRule.add(configurator, "tea030;teb075");
cds.configurator.DefaultRule.add(configurator, "tea030;teb080");
cds.configurator.DefaultRule.add(configurator, "tea030;teb084");
cds.configurator.DefaultRule.add(configurator, "tea030;teb090");
cds.configurator.DefaultRule.add(configurator, "tea030;teb096");
cds.configurator.DefaultRule.add(configurator, "tea030;teb100");
cds.configurator.DefaultRule.add(configurator, "tea030;teb112");
cds.configurator.DefaultRule.add(configurator, "tea030;teb120");
cds.configurator.DefaultRule.add(configurator, "tea030;teb126");
cds.configurator.DefaultRule.add(configurator, "tea030;teb140");
cds.configurator.DefaultRule.add(configurator, "tea030;teb144");
cds.configurator.DefaultRule.add(configurator, "tea030;teb154");
cds.configurator.DefaultRule.add(configurator, "tea030;teb168");
cds.configurator.DefaultRule.add(configurator, "tea030;teb180");
cds.configurator.DefaultRule.add(configurator, "tea030;teb192");
cds.configurator.DefaultRule.add(configurator, "tea030;teb200");
cds.configurator.DefaultRule.add(configurator, "tea030;teb216");
cds.configurator.DefaultRule.add(configurator, "tea030;teb224");
cds.configurator.DefaultRule.add(configurator, "tea031;teb032");
cds.configurator.DefaultRule.add(configurator, "tea031;teb033");
cds.configurator.DefaultRule.add(configurator, "tea031;teb034");
cds.configurator.DefaultRule.add(configurator, "tea031;teb035");
cds.configurator.DefaultRule.add(configurator, "tea031;teb036");
cds.configurator.DefaultRule.add(configurator, "tea031;teb037");
cds.configurator.DefaultRule.add(configurator, "tea031;teb038");
cds.configurator.DefaultRule.add(configurator, "tea031;teb039");
cds.configurator.DefaultRule.add(configurator, "tea031;teb040");
cds.configurator.DefaultRule.add(configurator, "tea031;teb041");
cds.configurator.DefaultRule.add(configurator, "tea031;teb042");
cds.configurator.DefaultRule.add(configurator, "tea031;teb043");
cds.configurator.DefaultRule.add(configurator, "tea031;teb044");
cds.configurator.DefaultRule.add(configurator, "tea031;teb045");
cds.configurator.DefaultRule.add(configurator, "tea031;teb046");
cds.configurator.DefaultRule.add(configurator, "tea031;teb048");
cds.configurator.DefaultRule.add(configurator, "tea031;teb050");
cds.configurator.DefaultRule.add(configurator, "tea031;teb052");
cds.configurator.DefaultRule.add(configurator, "tea031;teb053");
cds.configurator.DefaultRule.add(configurator, "tea031;teb056");
cds.configurator.DefaultRule.add(configurator, "tea031;teb060");
cds.configurator.DefaultRule.add(configurator, "tea031;teb062");
cds.configurator.DefaultRule.add(configurator, "tea031;teb063");
cds.configurator.DefaultRule.add(configurator, "tea031;teb064");
cds.configurator.DefaultRule.add(configurator, "tea031;teb067");
cds.configurator.DefaultRule.add(configurator, "tea031;teb068");
cds.configurator.DefaultRule.add(configurator, "tea031;teb070");
cds.configurator.DefaultRule.add(configurator, "tea031;teb071");
cds.configurator.DefaultRule.add(configurator, "tea031;teb072");
cds.configurator.DefaultRule.add(configurator, "tea031;teb074");
cds.configurator.DefaultRule.add(configurator, "tea031;teb075");
cds.configurator.DefaultRule.add(configurator, "tea031;teb080");
cds.configurator.DefaultRule.add(configurator, "tea031;teb084");
cds.configurator.DefaultRule.add(configurator, "tea031;teb090");
cds.configurator.DefaultRule.add(configurator, "tea031;teb096");
cds.configurator.DefaultRule.add(configurator, "tea031;teb100");
cds.configurator.DefaultRule.add(configurator, "tea031;teb112");
cds.configurator.DefaultRule.add(configurator, "tea031;teb120");
cds.configurator.DefaultRule.add(configurator, "tea031;teb126");
cds.configurator.DefaultRule.add(configurator, "tea031;teb140");
cds.configurator.DefaultRule.add(configurator, "tea031;teb144");
cds.configurator.DefaultRule.add(configurator, "tea031;teb154");
cds.configurator.DefaultRule.add(configurator, "tea031;teb168");
cds.configurator.DefaultRule.add(configurator, "tea031;teb180");
cds.configurator.DefaultRule.add(configurator, "tea031;teb192");
cds.configurator.DefaultRule.add(configurator, "tea031;teb200");
cds.configurator.DefaultRule.add(configurator, "tea031;teb216");
cds.configurator.DefaultRule.add(configurator, "tea031;teb224");
cds.configurator.DefaultRule.add(configurator, "tea032;teb033");
cds.configurator.DefaultRule.add(configurator, "tea032;teb034");
cds.configurator.DefaultRule.add(configurator, "tea032;teb035");
cds.configurator.DefaultRule.add(configurator, "tea032;teb036");
cds.configurator.DefaultRule.add(configurator, "tea032;teb037");
cds.configurator.DefaultRule.add(configurator, "tea032;teb038");
cds.configurator.DefaultRule.add(configurator, "tea032;teb039");
cds.configurator.DefaultRule.add(configurator, "tea032;teb040");
cds.configurator.DefaultRule.add(configurator, "tea032;teb041");
cds.configurator.DefaultRule.add(configurator, "tea032;teb042");
cds.configurator.DefaultRule.add(configurator, "tea032;teb043");
cds.configurator.DefaultRule.add(configurator, "tea032;teb044");
cds.configurator.DefaultRule.add(configurator, "tea032;teb045");
cds.configurator.DefaultRule.add(configurator, "tea032;teb046");
cds.configurator.DefaultRule.add(configurator, "tea032;teb048");
cds.configurator.DefaultRule.add(configurator, "tea032;teb050");
cds.configurator.DefaultRule.add(configurator, "tea032;teb052");
cds.configurator.DefaultRule.add(configurator, "tea032;teb053");
cds.configurator.DefaultRule.add(configurator, "tea032;teb056");
cds.configurator.DefaultRule.add(configurator, "tea032;teb060");
cds.configurator.DefaultRule.add(configurator, "tea032;teb062");
cds.configurator.DefaultRule.add(configurator, "tea032;teb063");
cds.configurator.DefaultRule.add(configurator, "tea032;teb064");
cds.configurator.DefaultRule.add(configurator, "tea032;teb067");
cds.configurator.DefaultRule.add(configurator, "tea032;teb068");
cds.configurator.DefaultRule.add(configurator, "tea032;teb070");
cds.configurator.DefaultRule.add(configurator, "tea032;teb071");
cds.configurator.DefaultRule.add(configurator, "tea032;teb072");
cds.configurator.DefaultRule.add(configurator, "tea032;teb074");
cds.configurator.DefaultRule.add(configurator, "tea032;teb075");
cds.configurator.DefaultRule.add(configurator, "tea032;teb080");
cds.configurator.DefaultRule.add(configurator, "tea032;teb084");
cds.configurator.DefaultRule.add(configurator, "tea032;teb090");
cds.configurator.DefaultRule.add(configurator, "tea032;teb096");
cds.configurator.DefaultRule.add(configurator, "tea032;teb100");
cds.configurator.DefaultRule.add(configurator, "tea032;teb112");
cds.configurator.DefaultRule.add(configurator, "tea032;teb120");
cds.configurator.DefaultRule.add(configurator, "tea032;teb126");
cds.configurator.DefaultRule.add(configurator, "tea032;teb140");
cds.configurator.DefaultRule.add(configurator, "tea032;teb144");
cds.configurator.DefaultRule.add(configurator, "tea032;teb154");
cds.configurator.DefaultRule.add(configurator, "tea032;teb168");
cds.configurator.DefaultRule.add(configurator, "tea032;teb180");
cds.configurator.DefaultRule.add(configurator, "tea032;teb192");
cds.configurator.DefaultRule.add(configurator, "tea032;teb200");
cds.configurator.DefaultRule.add(configurator, "tea032;teb216");
cds.configurator.DefaultRule.add(configurator, "tea032;teb224");
cds.configurator.DefaultRule.add(configurator, "tea033;teb034");
cds.configurator.DefaultRule.add(configurator, "tea033;teb035");
cds.configurator.DefaultRule.add(configurator, "tea033;teb036");
cds.configurator.DefaultRule.add(configurator, "tea033;teb037");
cds.configurator.DefaultRule.add(configurator, "tea033;teb038");
cds.configurator.DefaultRule.add(configurator, "tea033;teb039");
cds.configurator.DefaultRule.add(configurator, "tea033;teb040");
cds.configurator.DefaultRule.add(configurator, "tea033;teb041");
cds.configurator.DefaultRule.add(configurator, "tea033;teb042");
cds.configurator.DefaultRule.add(configurator, "tea033;teb043");
cds.configurator.DefaultRule.add(configurator, "tea033;teb044");
cds.configurator.DefaultRule.add(configurator, "tea033;teb045");
cds.configurator.DefaultRule.add(configurator, "tea033;teb046");
cds.configurator.DefaultRule.add(configurator, "tea033;teb048");
cds.configurator.DefaultRule.add(configurator, "tea033;teb050");
cds.configurator.DefaultRule.add(configurator, "tea033;teb052");
cds.configurator.DefaultRule.add(configurator, "tea033;teb053");
cds.configurator.DefaultRule.add(configurator, "tea033;teb056");
cds.configurator.DefaultRule.add(configurator, "tea033;teb060");
cds.configurator.DefaultRule.add(configurator, "tea033;teb062");
cds.configurator.DefaultRule.add(configurator, "tea033;teb063");
cds.configurator.DefaultRule.add(configurator, "tea033;teb064");
cds.configurator.DefaultRule.add(configurator, "tea033;teb067");
cds.configurator.DefaultRule.add(configurator, "tea033;teb068");
cds.configurator.DefaultRule.add(configurator, "tea033;teb070");
cds.configurator.DefaultRule.add(configurator, "tea033;teb071");
cds.configurator.DefaultRule.add(configurator, "tea033;teb072");
cds.configurator.DefaultRule.add(configurator, "tea033;teb074");
cds.configurator.DefaultRule.add(configurator, "tea033;teb075");
cds.configurator.DefaultRule.add(configurator, "tea033;teb080");
cds.configurator.DefaultRule.add(configurator, "tea033;teb084");
cds.configurator.DefaultRule.add(configurator, "tea033;teb090");
cds.configurator.DefaultRule.add(configurator, "tea033;teb096");
cds.configurator.DefaultRule.add(configurator, "tea033;teb100");
cds.configurator.DefaultRule.add(configurator, "tea033;teb112");
cds.configurator.DefaultRule.add(configurator, "tea033;teb120");
cds.configurator.DefaultRule.add(configurator, "tea033;teb126");
cds.configurator.DefaultRule.add(configurator, "tea033;teb140");
cds.configurator.DefaultRule.add(configurator, "tea033;teb144");
cds.configurator.DefaultRule.add(configurator, "tea033;teb154");
cds.configurator.DefaultRule.add(configurator, "tea033;teb168");
cds.configurator.DefaultRule.add(configurator, "tea033;teb180");
cds.configurator.DefaultRule.add(configurator, "tea033;teb192");
cds.configurator.DefaultRule.add(configurator, "tea033;teb200");
cds.configurator.DefaultRule.add(configurator, "tea033;teb216");
cds.configurator.DefaultRule.add(configurator, "tea033;teb224");
cds.configurator.DefaultRule.add(configurator, "tea034;teb035");
cds.configurator.DefaultRule.add(configurator, "tea034;teb036");
cds.configurator.DefaultRule.add(configurator, "tea034;teb037");
cds.configurator.DefaultRule.add(configurator, "tea034;teb038");
cds.configurator.DefaultRule.add(configurator, "tea034;teb039");
cds.configurator.DefaultRule.add(configurator, "tea034;teb040");
cds.configurator.DefaultRule.add(configurator, "tea034;teb041");
cds.configurator.DefaultRule.add(configurator, "tea034;teb042");
cds.configurator.DefaultRule.add(configurator, "tea034;teb043");
cds.configurator.DefaultRule.add(configurator, "tea034;teb044");
cds.configurator.DefaultRule.add(configurator, "tea034;teb045");
cds.configurator.DefaultRule.add(configurator, "tea034;teb046");
cds.configurator.DefaultRule.add(configurator, "tea034;teb048");
cds.configurator.DefaultRule.add(configurator, "tea034;teb050");
cds.configurator.DefaultRule.add(configurator, "tea034;teb052");
cds.configurator.DefaultRule.add(configurator, "tea034;teb053");
cds.configurator.DefaultRule.add(configurator, "tea034;teb056");
cds.configurator.DefaultRule.add(configurator, "tea034;teb060");
cds.configurator.DefaultRule.add(configurator, "tea034;teb062");
cds.configurator.DefaultRule.add(configurator, "tea034;teb063");
cds.configurator.DefaultRule.add(configurator, "tea034;teb064");
cds.configurator.DefaultRule.add(configurator, "tea034;teb067");
cds.configurator.DefaultRule.add(configurator, "tea034;teb068");
cds.configurator.DefaultRule.add(configurator, "tea034;teb070");
cds.configurator.DefaultRule.add(configurator, "tea034;teb071");
cds.configurator.DefaultRule.add(configurator, "tea034;teb072");
cds.configurator.DefaultRule.add(configurator, "tea034;teb074");
cds.configurator.DefaultRule.add(configurator, "tea034;teb075");
cds.configurator.DefaultRule.add(configurator, "tea034;teb080");
cds.configurator.DefaultRule.add(configurator, "tea034;teb084");
cds.configurator.DefaultRule.add(configurator, "tea034;teb090");
cds.configurator.DefaultRule.add(configurator, "tea034;teb096");
cds.configurator.DefaultRule.add(configurator, "tea034;teb100");
cds.configurator.DefaultRule.add(configurator, "tea034;teb112");
cds.configurator.DefaultRule.add(configurator, "tea034;teb120");
cds.configurator.DefaultRule.add(configurator, "tea034;teb126");
cds.configurator.DefaultRule.add(configurator, "tea034;teb140");
cds.configurator.DefaultRule.add(configurator, "tea034;teb144");
cds.configurator.DefaultRule.add(configurator, "tea034;teb154");
cds.configurator.DefaultRule.add(configurator, "tea034;teb168");
cds.configurator.DefaultRule.add(configurator, "tea034;teb180");
cds.configurator.DefaultRule.add(configurator, "tea034;teb192");
cds.configurator.DefaultRule.add(configurator, "tea034;teb200");
cds.configurator.DefaultRule.add(configurator, "tea034;teb216");
cds.configurator.DefaultRule.add(configurator, "tea034;teb224");
cds.configurator.DefaultRule.add(configurator, "tea035;teb036");
cds.configurator.DefaultRule.add(configurator, "tea035;teb037");
cds.configurator.DefaultRule.add(configurator, "tea035;teb038");
cds.configurator.DefaultRule.add(configurator, "tea035;teb039");
cds.configurator.DefaultRule.add(configurator, "tea035;teb040");
cds.configurator.DefaultRule.add(configurator, "tea035;teb041");
cds.configurator.DefaultRule.add(configurator, "tea035;teb042");
cds.configurator.DefaultRule.add(configurator, "tea035;teb043");
cds.configurator.DefaultRule.add(configurator, "tea035;teb044");
cds.configurator.DefaultRule.add(configurator, "tea035;teb045");
cds.configurator.DefaultRule.add(configurator, "tea035;teb046");
cds.configurator.DefaultRule.add(configurator, "tea035;teb048");
cds.configurator.DefaultRule.add(configurator, "tea035;teb050");
cds.configurator.DefaultRule.add(configurator, "tea035;teb052");
cds.configurator.DefaultRule.add(configurator, "tea035;teb053");
cds.configurator.DefaultRule.add(configurator, "tea035;teb056");
cds.configurator.DefaultRule.add(configurator, "tea035;teb060");
cds.configurator.DefaultRule.add(configurator, "tea035;teb062");
cds.configurator.DefaultRule.add(configurator, "tea035;teb063");
cds.configurator.DefaultRule.add(configurator, "tea035;teb064");
cds.configurator.DefaultRule.add(configurator, "tea035;teb067");
cds.configurator.DefaultRule.add(configurator, "tea035;teb068");
cds.configurator.DefaultRule.add(configurator, "tea035;teb070");
cds.configurator.DefaultRule.add(configurator, "tea035;teb071");
cds.configurator.DefaultRule.add(configurator, "tea035;teb072");
cds.configurator.DefaultRule.add(configurator, "tea035;teb074");
cds.configurator.DefaultRule.add(configurator, "tea035;teb075");
cds.configurator.DefaultRule.add(configurator, "tea035;teb080");
cds.configurator.DefaultRule.add(configurator, "tea035;teb084");
cds.configurator.DefaultRule.add(configurator, "tea035;teb090");
cds.configurator.DefaultRule.add(configurator, "tea035;teb096");
cds.configurator.DefaultRule.add(configurator, "tea035;teb100");
cds.configurator.DefaultRule.add(configurator, "tea035;teb112");
cds.configurator.DefaultRule.add(configurator, "tea035;teb120");
cds.configurator.DefaultRule.add(configurator, "tea035;teb126");
cds.configurator.DefaultRule.add(configurator, "tea035;teb140");
cds.configurator.DefaultRule.add(configurator, "tea035;teb144");
cds.configurator.DefaultRule.add(configurator, "tea035;teb154");
cds.configurator.DefaultRule.add(configurator, "tea035;teb168");
cds.configurator.DefaultRule.add(configurator, "tea035;teb180");
cds.configurator.DefaultRule.add(configurator, "tea035;teb192");
cds.configurator.DefaultRule.add(configurator, "tea035;teb200");
cds.configurator.DefaultRule.add(configurator, "tea035;teb216");
cds.configurator.DefaultRule.add(configurator, "tea035;teb224");
cds.configurator.DefaultRule.add(configurator, "tea036;teb037");
cds.configurator.DefaultRule.add(configurator, "tea036;teb038");
cds.configurator.DefaultRule.add(configurator, "tea036;teb039");
cds.configurator.DefaultRule.add(configurator, "tea036;teb040");
cds.configurator.DefaultRule.add(configurator, "tea036;teb041");
cds.configurator.DefaultRule.add(configurator, "tea036;teb042");
cds.configurator.DefaultRule.add(configurator, "tea036;teb043");
cds.configurator.DefaultRule.add(configurator, "tea036;teb044");
cds.configurator.DefaultRule.add(configurator, "tea036;teb045");
cds.configurator.DefaultRule.add(configurator, "tea036;teb046");
cds.configurator.DefaultRule.add(configurator, "tea036;teb048");
cds.configurator.DefaultRule.add(configurator, "tea036;teb050");
cds.configurator.DefaultRule.add(configurator, "tea036;teb052");
cds.configurator.DefaultRule.add(configurator, "tea036;teb053");
cds.configurator.DefaultRule.add(configurator, "tea036;teb056");
cds.configurator.DefaultRule.add(configurator, "tea036;teb060");
cds.configurator.DefaultRule.add(configurator, "tea036;teb062");
cds.configurator.DefaultRule.add(configurator, "tea036;teb063");
cds.configurator.DefaultRule.add(configurator, "tea036;teb064");
cds.configurator.DefaultRule.add(configurator, "tea036;teb067");
cds.configurator.DefaultRule.add(configurator, "tea036;teb068");
cds.configurator.DefaultRule.add(configurator, "tea036;teb070");
cds.configurator.DefaultRule.add(configurator, "tea036;teb071");
cds.configurator.DefaultRule.add(configurator, "tea036;teb072");
cds.configurator.DefaultRule.add(configurator, "tea036;teb074");
cds.configurator.DefaultRule.add(configurator, "tea036;teb075");
cds.configurator.DefaultRule.add(configurator, "tea036;teb080");
cds.configurator.DefaultRule.add(configurator, "tea036;teb084");
cds.configurator.DefaultRule.add(configurator, "tea036;teb090");
cds.configurator.DefaultRule.add(configurator, "tea036;teb096");
cds.configurator.DefaultRule.add(configurator, "tea036;teb100");
cds.configurator.DefaultRule.add(configurator, "tea036;teb112");
cds.configurator.DefaultRule.add(configurator, "tea036;teb120");
cds.configurator.DefaultRule.add(configurator, "tea036;teb126");
cds.configurator.DefaultRule.add(configurator, "tea036;teb140");
cds.configurator.DefaultRule.add(configurator, "tea036;teb144");
cds.configurator.DefaultRule.add(configurator, "tea036;teb154");
cds.configurator.DefaultRule.add(configurator, "tea036;teb168");
cds.configurator.DefaultRule.add(configurator, "tea036;teb180");
cds.configurator.DefaultRule.add(configurator, "tea036;teb192");
cds.configurator.DefaultRule.add(configurator, "tea036;teb200");
cds.configurator.DefaultRule.add(configurator, "tea036;teb216");
cds.configurator.DefaultRule.add(configurator, "tea036;teb224");
cds.configurator.DefaultRule.add(configurator, "tea037;teb038");
cds.configurator.DefaultRule.add(configurator, "tea037;teb039");
cds.configurator.DefaultRule.add(configurator, "tea037;teb040");
cds.configurator.DefaultRule.add(configurator, "tea037;teb041");
cds.configurator.DefaultRule.add(configurator, "tea037;teb042");
cds.configurator.DefaultRule.add(configurator, "tea037;teb043");
cds.configurator.DefaultRule.add(configurator, "tea037;teb044");
cds.configurator.DefaultRule.add(configurator, "tea037;teb045");
cds.configurator.DefaultRule.add(configurator, "tea037;teb046");
cds.configurator.DefaultRule.add(configurator, "tea037;teb048");
cds.configurator.DefaultRule.add(configurator, "tea037;teb050");
cds.configurator.DefaultRule.add(configurator, "tea037;teb052");
cds.configurator.DefaultRule.add(configurator, "tea037;teb053");
cds.configurator.DefaultRule.add(configurator, "tea037;teb056");
cds.configurator.DefaultRule.add(configurator, "tea037;teb060");
cds.configurator.DefaultRule.add(configurator, "tea037;teb062");
cds.configurator.DefaultRule.add(configurator, "tea037;teb063");
cds.configurator.DefaultRule.add(configurator, "tea037;teb064");
cds.configurator.DefaultRule.add(configurator, "tea037;teb067");
cds.configurator.DefaultRule.add(configurator, "tea037;teb068");
cds.configurator.DefaultRule.add(configurator, "tea037;teb070");
cds.configurator.DefaultRule.add(configurator, "tea037;teb071");
cds.configurator.DefaultRule.add(configurator, "tea037;teb072");
cds.configurator.DefaultRule.add(configurator, "tea037;teb074");
cds.configurator.DefaultRule.add(configurator, "tea037;teb075");
cds.configurator.DefaultRule.add(configurator, "tea037;teb080");
cds.configurator.DefaultRule.add(configurator, "tea037;teb084");
cds.configurator.DefaultRule.add(configurator, "tea037;teb090");
cds.configurator.DefaultRule.add(configurator, "tea037;teb096");
cds.configurator.DefaultRule.add(configurator, "tea037;teb100");
cds.configurator.DefaultRule.add(configurator, "tea037;teb112");
cds.configurator.DefaultRule.add(configurator, "tea037;teb120");
cds.configurator.DefaultRule.add(configurator, "tea037;teb126");
cds.configurator.DefaultRule.add(configurator, "tea037;teb140");
cds.configurator.DefaultRule.add(configurator, "tea037;teb144");
cds.configurator.DefaultRule.add(configurator, "tea037;teb154");
cds.configurator.DefaultRule.add(configurator, "tea037;teb168");
cds.configurator.DefaultRule.add(configurator, "tea037;teb180");
cds.configurator.DefaultRule.add(configurator, "tea037;teb192");
cds.configurator.DefaultRule.add(configurator, "tea037;teb200");
cds.configurator.DefaultRule.add(configurator, "tea037;teb216");
cds.configurator.DefaultRule.add(configurator, "tea037;teb224");
cds.configurator.DefaultRule.add(configurator, "tea038;teb039");
cds.configurator.DefaultRule.add(configurator, "tea038;teb040");
cds.configurator.DefaultRule.add(configurator, "tea038;teb041");
cds.configurator.DefaultRule.add(configurator, "tea038;teb042");
cds.configurator.DefaultRule.add(configurator, "tea038;teb043");
cds.configurator.DefaultRule.add(configurator, "tea038;teb044");
cds.configurator.DefaultRule.add(configurator, "tea038;teb045");
cds.configurator.DefaultRule.add(configurator, "tea038;teb046");
cds.configurator.DefaultRule.add(configurator, "tea038;teb048");
cds.configurator.DefaultRule.add(configurator, "tea038;teb050");
cds.configurator.DefaultRule.add(configurator, "tea038;teb052");
cds.configurator.DefaultRule.add(configurator, "tea038;teb053");
cds.configurator.DefaultRule.add(configurator, "tea038;teb056");
cds.configurator.DefaultRule.add(configurator, "tea038;teb060");
cds.configurator.DefaultRule.add(configurator, "tea038;teb062");
cds.configurator.DefaultRule.add(configurator, "tea038;teb063");
cds.configurator.DefaultRule.add(configurator, "tea038;teb064");
cds.configurator.DefaultRule.add(configurator, "tea038;teb067");
cds.configurator.DefaultRule.add(configurator, "tea038;teb068");
cds.configurator.DefaultRule.add(configurator, "tea038;teb070");
cds.configurator.DefaultRule.add(configurator, "tea038;teb071");
cds.configurator.DefaultRule.add(configurator, "tea038;teb072");
cds.configurator.DefaultRule.add(configurator, "tea038;teb074");
cds.configurator.DefaultRule.add(configurator, "tea038;teb075");
cds.configurator.DefaultRule.add(configurator, "tea038;teb080");
cds.configurator.DefaultRule.add(configurator, "tea038;teb084");
cds.configurator.DefaultRule.add(configurator, "tea038;teb090");
cds.configurator.DefaultRule.add(configurator, "tea038;teb096");
cds.configurator.DefaultRule.add(configurator, "tea038;teb100");
cds.configurator.DefaultRule.add(configurator, "tea038;teb112");
cds.configurator.DefaultRule.add(configurator, "tea038;teb120");
cds.configurator.DefaultRule.add(configurator, "tea038;teb126");
cds.configurator.DefaultRule.add(configurator, "tea038;teb140");
cds.configurator.DefaultRule.add(configurator, "tea038;teb144");
cds.configurator.DefaultRule.add(configurator, "tea038;teb154");
cds.configurator.DefaultRule.add(configurator, "tea038;teb168");
cds.configurator.DefaultRule.add(configurator, "tea038;teb180");
cds.configurator.DefaultRule.add(configurator, "tea038;teb192");
cds.configurator.DefaultRule.add(configurator, "tea038;teb200");
cds.configurator.DefaultRule.add(configurator, "tea038;teb216");
cds.configurator.DefaultRule.add(configurator, "tea038;teb224");
cds.configurator.DefaultRule.add(configurator, "tea039;teb040");
cds.configurator.DefaultRule.add(configurator, "tea039;teb041");
cds.configurator.DefaultRule.add(configurator, "tea039;teb042");
cds.configurator.DefaultRule.add(configurator, "tea039;teb043");
cds.configurator.DefaultRule.add(configurator, "tea039;teb044");
cds.configurator.DefaultRule.add(configurator, "tea039;teb045");
cds.configurator.DefaultRule.add(configurator, "tea039;teb046");
cds.configurator.DefaultRule.add(configurator, "tea039;teb048");
cds.configurator.DefaultRule.add(configurator, "tea039;teb050");
cds.configurator.DefaultRule.add(configurator, "tea039;teb052");
cds.configurator.DefaultRule.add(configurator, "tea039;teb053");
cds.configurator.DefaultRule.add(configurator, "tea039;teb056");
cds.configurator.DefaultRule.add(configurator, "tea039;teb060");
cds.configurator.DefaultRule.add(configurator, "tea039;teb062");
cds.configurator.DefaultRule.add(configurator, "tea039;teb063");
cds.configurator.DefaultRule.add(configurator, "tea039;teb064");
cds.configurator.DefaultRule.add(configurator, "tea039;teb067");
cds.configurator.DefaultRule.add(configurator, "tea039;teb068");
cds.configurator.DefaultRule.add(configurator, "tea039;teb070");
cds.configurator.DefaultRule.add(configurator, "tea039;teb071");
cds.configurator.DefaultRule.add(configurator, "tea039;teb072");
cds.configurator.DefaultRule.add(configurator, "tea039;teb074");
cds.configurator.DefaultRule.add(configurator, "tea039;teb075");
cds.configurator.DefaultRule.add(configurator, "tea039;teb080");
cds.configurator.DefaultRule.add(configurator, "tea039;teb084");
cds.configurator.DefaultRule.add(configurator, "tea039;teb090");
cds.configurator.DefaultRule.add(configurator, "tea039;teb096");
cds.configurator.DefaultRule.add(configurator, "tea039;teb100");
cds.configurator.DefaultRule.add(configurator, "tea039;teb112");
cds.configurator.DefaultRule.add(configurator, "tea039;teb120");
cds.configurator.DefaultRule.add(configurator, "tea039;teb126");
cds.configurator.DefaultRule.add(configurator, "tea039;teb140");
cds.configurator.DefaultRule.add(configurator, "tea039;teb144");
cds.configurator.DefaultRule.add(configurator, "tea039;teb154");
cds.configurator.DefaultRule.add(configurator, "tea039;teb168");
cds.configurator.DefaultRule.add(configurator, "tea039;teb180");
cds.configurator.DefaultRule.add(configurator, "tea039;teb192");
cds.configurator.DefaultRule.add(configurator, "tea039;teb200");
cds.configurator.DefaultRule.add(configurator, "tea039;teb216");
cds.configurator.DefaultRule.add(configurator, "tea039;teb224");
cds.configurator.DefaultRule.add(configurator, "tea040;teb041");
cds.configurator.DefaultRule.add(configurator, "tea040;teb042");
cds.configurator.DefaultRule.add(configurator, "tea040;teb043");
cds.configurator.DefaultRule.add(configurator, "tea040;teb044");
cds.configurator.DefaultRule.add(configurator, "tea040;teb045");
cds.configurator.DefaultRule.add(configurator, "tea040;teb046");
cds.configurator.DefaultRule.add(configurator, "tea040;teb048");
cds.configurator.DefaultRule.add(configurator, "tea040;teb050");
cds.configurator.DefaultRule.add(configurator, "tea040;teb052");
cds.configurator.DefaultRule.add(configurator, "tea040;teb053");
cds.configurator.DefaultRule.add(configurator, "tea040;teb056");
cds.configurator.DefaultRule.add(configurator, "tea040;teb060");
cds.configurator.DefaultRule.add(configurator, "tea040;teb062");
cds.configurator.DefaultRule.add(configurator, "tea040;teb063");
cds.configurator.DefaultRule.add(configurator, "tea040;teb064");
cds.configurator.DefaultRule.add(configurator, "tea040;teb067");
cds.configurator.DefaultRule.add(configurator, "tea040;teb068");
cds.configurator.DefaultRule.add(configurator, "tea040;teb070");
cds.configurator.DefaultRule.add(configurator, "tea040;teb071");
cds.configurator.DefaultRule.add(configurator, "tea040;teb072");
cds.configurator.DefaultRule.add(configurator, "tea040;teb074");
cds.configurator.DefaultRule.add(configurator, "tea040;teb075");
cds.configurator.DefaultRule.add(configurator, "tea040;teb080");
cds.configurator.DefaultRule.add(configurator, "tea040;teb084");
cds.configurator.DefaultRule.add(configurator, "tea040;teb090");
cds.configurator.DefaultRule.add(configurator, "tea040;teb096");
cds.configurator.DefaultRule.add(configurator, "tea040;teb100");
cds.configurator.DefaultRule.add(configurator, "tea040;teb112");
cds.configurator.DefaultRule.add(configurator, "tea040;teb120");
cds.configurator.DefaultRule.add(configurator, "tea040;teb126");
cds.configurator.DefaultRule.add(configurator, "tea040;teb140");
cds.configurator.DefaultRule.add(configurator, "tea040;teb144");
cds.configurator.DefaultRule.add(configurator, "tea040;teb154");
cds.configurator.DefaultRule.add(configurator, "tea040;teb168");
cds.configurator.DefaultRule.add(configurator, "tea040;teb180");
cds.configurator.DefaultRule.add(configurator, "tea040;teb192");
cds.configurator.DefaultRule.add(configurator, "tea040;teb200");
cds.configurator.DefaultRule.add(configurator, "tea040;teb216");
cds.configurator.DefaultRule.add(configurator, "tea040;teb224");
cds.configurator.DefaultRule.add(configurator, "tea041;teb042");
cds.configurator.DefaultRule.add(configurator, "tea041;teb043");
cds.configurator.DefaultRule.add(configurator, "tea041;teb044");
cds.configurator.DefaultRule.add(configurator, "tea041;teb045");
cds.configurator.DefaultRule.add(configurator, "tea041;teb046");
cds.configurator.DefaultRule.add(configurator, "tea041;teb048");
cds.configurator.DefaultRule.add(configurator, "tea041;teb050");
cds.configurator.DefaultRule.add(configurator, "tea041;teb052");
cds.configurator.DefaultRule.add(configurator, "tea041;teb053");
cds.configurator.DefaultRule.add(configurator, "tea041;teb056");
cds.configurator.DefaultRule.add(configurator, "tea041;teb060");
cds.configurator.DefaultRule.add(configurator, "tea041;teb062");
cds.configurator.DefaultRule.add(configurator, "tea041;teb063");
cds.configurator.DefaultRule.add(configurator, "tea041;teb064");
cds.configurator.DefaultRule.add(configurator, "tea041;teb067");
cds.configurator.DefaultRule.add(configurator, "tea041;teb068");
cds.configurator.DefaultRule.add(configurator, "tea041;teb070");
cds.configurator.DefaultRule.add(configurator, "tea041;teb071");
cds.configurator.DefaultRule.add(configurator, "tea041;teb072");
cds.configurator.DefaultRule.add(configurator, "tea041;teb074");
cds.configurator.DefaultRule.add(configurator, "tea041;teb075");
cds.configurator.DefaultRule.add(configurator, "tea041;teb080");
cds.configurator.DefaultRule.add(configurator, "tea041;teb084");
cds.configurator.DefaultRule.add(configurator, "tea041;teb090");
cds.configurator.DefaultRule.add(configurator, "tea041;teb096");
cds.configurator.DefaultRule.add(configurator, "tea041;teb100");
cds.configurator.DefaultRule.add(configurator, "tea041;teb112");
cds.configurator.DefaultRule.add(configurator, "tea041;teb120");
cds.configurator.DefaultRule.add(configurator, "tea041;teb126");
cds.configurator.DefaultRule.add(configurator, "tea041;teb140");
cds.configurator.DefaultRule.add(configurator, "tea041;teb144");
cds.configurator.DefaultRule.add(configurator, "tea041;teb154");
cds.configurator.DefaultRule.add(configurator, "tea041;teb168");
cds.configurator.DefaultRule.add(configurator, "tea041;teb180");
cds.configurator.DefaultRule.add(configurator, "tea041;teb192");
cds.configurator.DefaultRule.add(configurator, "tea041;teb200");
cds.configurator.DefaultRule.add(configurator, "tea041;teb216");
cds.configurator.DefaultRule.add(configurator, "tea041;teb224");
cds.configurator.DefaultRule.add(configurator, "tea042;teb043");
cds.configurator.DefaultRule.add(configurator, "tea042;teb044");
cds.configurator.DefaultRule.add(configurator, "tea042;teb045");
cds.configurator.DefaultRule.add(configurator, "tea042;teb046");
cds.configurator.DefaultRule.add(configurator, "tea042;teb048");
cds.configurator.DefaultRule.add(configurator, "tea042;teb050");
cds.configurator.DefaultRule.add(configurator, "tea042;teb052");
cds.configurator.DefaultRule.add(configurator, "tea042;teb053");
cds.configurator.DefaultRule.add(configurator, "tea042;teb056");
cds.configurator.DefaultRule.add(configurator, "tea042;teb060");
cds.configurator.DefaultRule.add(configurator, "tea042;teb062");
cds.configurator.DefaultRule.add(configurator, "tea042;teb063");
cds.configurator.DefaultRule.add(configurator, "tea042;teb064");
cds.configurator.DefaultRule.add(configurator, "tea042;teb067");
cds.configurator.DefaultRule.add(configurator, "tea042;teb068");
cds.configurator.DefaultRule.add(configurator, "tea042;teb070");
cds.configurator.DefaultRule.add(configurator, "tea042;teb071");
cds.configurator.DefaultRule.add(configurator, "tea042;teb072");
cds.configurator.DefaultRule.add(configurator, "tea042;teb074");
cds.configurator.DefaultRule.add(configurator, "tea042;teb075");
cds.configurator.DefaultRule.add(configurator, "tea042;teb080");
cds.configurator.DefaultRule.add(configurator, "tea042;teb084");
cds.configurator.DefaultRule.add(configurator, "tea042;teb090");
cds.configurator.DefaultRule.add(configurator, "tea042;teb096");
cds.configurator.DefaultRule.add(configurator, "tea042;teb100");
cds.configurator.DefaultRule.add(configurator, "tea042;teb112");
cds.configurator.DefaultRule.add(configurator, "tea042;teb120");
cds.configurator.DefaultRule.add(configurator, "tea042;teb126");
cds.configurator.DefaultRule.add(configurator, "tea042;teb140");
cds.configurator.DefaultRule.add(configurator, "tea042;teb144");
cds.configurator.DefaultRule.add(configurator, "tea042;teb154");
cds.configurator.DefaultRule.add(configurator, "tea042;teb168");
cds.configurator.DefaultRule.add(configurator, "tea042;teb180");
cds.configurator.DefaultRule.add(configurator, "tea042;teb192");
cds.configurator.DefaultRule.add(configurator, "tea042;teb200");
cds.configurator.DefaultRule.add(configurator, "tea042;teb216");
cds.configurator.DefaultRule.add(configurator, "tea042;teb224");
cds.configurator.DefaultRule.add(configurator, "tea043;teb044");
cds.configurator.DefaultRule.add(configurator, "tea043;teb045");
cds.configurator.DefaultRule.add(configurator, "tea043;teb046");
cds.configurator.DefaultRule.add(configurator, "tea043;teb048");
cds.configurator.DefaultRule.add(configurator, "tea043;teb050");
cds.configurator.DefaultRule.add(configurator, "tea043;teb052");
cds.configurator.DefaultRule.add(configurator, "tea043;teb053");
cds.configurator.DefaultRule.add(configurator, "tea043;teb056");
cds.configurator.DefaultRule.add(configurator, "tea043;teb060");
cds.configurator.DefaultRule.add(configurator, "tea043;teb062");
cds.configurator.DefaultRule.add(configurator, "tea043;teb063");
cds.configurator.DefaultRule.add(configurator, "tea043;teb064");
cds.configurator.DefaultRule.add(configurator, "tea043;teb067");
cds.configurator.DefaultRule.add(configurator, "tea043;teb068");
cds.configurator.DefaultRule.add(configurator, "tea043;teb070");
cds.configurator.DefaultRule.add(configurator, "tea043;teb071");
cds.configurator.DefaultRule.add(configurator, "tea043;teb072");
cds.configurator.DefaultRule.add(configurator, "tea043;teb074");
cds.configurator.DefaultRule.add(configurator, "tea043;teb075");
cds.configurator.DefaultRule.add(configurator, "tea043;teb080");
cds.configurator.DefaultRule.add(configurator, "tea043;teb084");
cds.configurator.DefaultRule.add(configurator, "tea043;teb090");
cds.configurator.DefaultRule.add(configurator, "tea043;teb096");
cds.configurator.DefaultRule.add(configurator, "tea043;teb100");
cds.configurator.DefaultRule.add(configurator, "tea043;teb112");
cds.configurator.DefaultRule.add(configurator, "tea043;teb120");
cds.configurator.DefaultRule.add(configurator, "tea043;teb126");
cds.configurator.DefaultRule.add(configurator, "tea043;teb140");
cds.configurator.DefaultRule.add(configurator, "tea043;teb144");
cds.configurator.DefaultRule.add(configurator, "tea043;teb154");
cds.configurator.DefaultRule.add(configurator, "tea043;teb168");
cds.configurator.DefaultRule.add(configurator, "tea043;teb180");
cds.configurator.DefaultRule.add(configurator, "tea043;teb192");
cds.configurator.DefaultRule.add(configurator, "tea043;teb200");
cds.configurator.DefaultRule.add(configurator, "tea043;teb216");
cds.configurator.DefaultRule.add(configurator, "tea043;teb224");
cds.configurator.DefaultRule.add(configurator, "tea044;teb045");
cds.configurator.DefaultRule.add(configurator, "tea044;teb046");
cds.configurator.DefaultRule.add(configurator, "tea044;teb048");
cds.configurator.DefaultRule.add(configurator, "tea044;teb050");
cds.configurator.DefaultRule.add(configurator, "tea044;teb052");
cds.configurator.DefaultRule.add(configurator, "tea044;teb053");
cds.configurator.DefaultRule.add(configurator, "tea044;teb056");
cds.configurator.DefaultRule.add(configurator, "tea044;teb060");
cds.configurator.DefaultRule.add(configurator, "tea044;teb062");
cds.configurator.DefaultRule.add(configurator, "tea044;teb063");
cds.configurator.DefaultRule.add(configurator, "tea044;teb064");
cds.configurator.DefaultRule.add(configurator, "tea044;teb067");
cds.configurator.DefaultRule.add(configurator, "tea044;teb068");
cds.configurator.DefaultRule.add(configurator, "tea044;teb070");
cds.configurator.DefaultRule.add(configurator, "tea044;teb071");
cds.configurator.DefaultRule.add(configurator, "tea044;teb072");
cds.configurator.DefaultRule.add(configurator, "tea044;teb074");
cds.configurator.DefaultRule.add(configurator, "tea044;teb075");
cds.configurator.DefaultRule.add(configurator, "tea044;teb080");
cds.configurator.DefaultRule.add(configurator, "tea044;teb084");
cds.configurator.DefaultRule.add(configurator, "tea044;teb090");
cds.configurator.DefaultRule.add(configurator, "tea044;teb096");
cds.configurator.DefaultRule.add(configurator, "tea044;teb100");
cds.configurator.DefaultRule.add(configurator, "tea044;teb112");
cds.configurator.DefaultRule.add(configurator, "tea044;teb120");
cds.configurator.DefaultRule.add(configurator, "tea044;teb126");
cds.configurator.DefaultRule.add(configurator, "tea044;teb140");
cds.configurator.DefaultRule.add(configurator, "tea044;teb144");
cds.configurator.DefaultRule.add(configurator, "tea044;teb154");
cds.configurator.DefaultRule.add(configurator, "tea044;teb168");
cds.configurator.DefaultRule.add(configurator, "tea044;teb180");
cds.configurator.DefaultRule.add(configurator, "tea044;teb192");
cds.configurator.DefaultRule.add(configurator, "tea044;teb200");
cds.configurator.DefaultRule.add(configurator, "tea044;teb216");
cds.configurator.DefaultRule.add(configurator, "tea044;teb224");
cds.configurator.DefaultRule.add(configurator, "tea045;teb046");
cds.configurator.DefaultRule.add(configurator, "tea045;teb048");
cds.configurator.DefaultRule.add(configurator, "tea045;teb050");
cds.configurator.DefaultRule.add(configurator, "tea045;teb052");
cds.configurator.DefaultRule.add(configurator, "tea045;teb053");
cds.configurator.DefaultRule.add(configurator, "tea045;teb056");
cds.configurator.DefaultRule.add(configurator, "tea045;teb060");
cds.configurator.DefaultRule.add(configurator, "tea045;teb062");
cds.configurator.DefaultRule.add(configurator, "tea045;teb063");
cds.configurator.DefaultRule.add(configurator, "tea045;teb064");
cds.configurator.DefaultRule.add(configurator, "tea045;teb067");
cds.configurator.DefaultRule.add(configurator, "tea045;teb068");
cds.configurator.DefaultRule.add(configurator, "tea045;teb070");
cds.configurator.DefaultRule.add(configurator, "tea045;teb071");
cds.configurator.DefaultRule.add(configurator, "tea045;teb072");
cds.configurator.DefaultRule.add(configurator, "tea045;teb074");
cds.configurator.DefaultRule.add(configurator, "tea045;teb075");
cds.configurator.DefaultRule.add(configurator, "tea045;teb080");
cds.configurator.DefaultRule.add(configurator, "tea045;teb084");
cds.configurator.DefaultRule.add(configurator, "tea045;teb090");
cds.configurator.DefaultRule.add(configurator, "tea045;teb096");
cds.configurator.DefaultRule.add(configurator, "tea045;teb100");
cds.configurator.DefaultRule.add(configurator, "tea045;teb112");
cds.configurator.DefaultRule.add(configurator, "tea045;teb120");
cds.configurator.DefaultRule.add(configurator, "tea045;teb126");
cds.configurator.DefaultRule.add(configurator, "tea045;teb140");
cds.configurator.DefaultRule.add(configurator, "tea045;teb144");
cds.configurator.DefaultRule.add(configurator, "tea045;teb154");
cds.configurator.DefaultRule.add(configurator, "tea045;teb168");
cds.configurator.DefaultRule.add(configurator, "tea045;teb180");
cds.configurator.DefaultRule.add(configurator, "tea045;teb192");
cds.configurator.DefaultRule.add(configurator, "tea045;teb200");
cds.configurator.DefaultRule.add(configurator, "tea045;teb216");
cds.configurator.DefaultRule.add(configurator, "tea045;teb224");
cds.configurator.DefaultRule.add(configurator, "tea046;teb048");
cds.configurator.DefaultRule.add(configurator, "tea046;teb050");
cds.configurator.DefaultRule.add(configurator, "tea046;teb052");
cds.configurator.DefaultRule.add(configurator, "tea046;teb053");
cds.configurator.DefaultRule.add(configurator, "tea046;teb056");
cds.configurator.DefaultRule.add(configurator, "tea046;teb060");
cds.configurator.DefaultRule.add(configurator, "tea046;teb062");
cds.configurator.DefaultRule.add(configurator, "tea046;teb063");
cds.configurator.DefaultRule.add(configurator, "tea046;teb064");
cds.configurator.DefaultRule.add(configurator, "tea046;teb067");
cds.configurator.DefaultRule.add(configurator, "tea046;teb068");
cds.configurator.DefaultRule.add(configurator, "tea046;teb070");
cds.configurator.DefaultRule.add(configurator, "tea046;teb071");
cds.configurator.DefaultRule.add(configurator, "tea046;teb072");
cds.configurator.DefaultRule.add(configurator, "tea046;teb074");
cds.configurator.DefaultRule.add(configurator, "tea046;teb075");
cds.configurator.DefaultRule.add(configurator, "tea046;teb080");
cds.configurator.DefaultRule.add(configurator, "tea046;teb084");
cds.configurator.DefaultRule.add(configurator, "tea046;teb090");
cds.configurator.DefaultRule.add(configurator, "tea046;teb096");
cds.configurator.DefaultRule.add(configurator, "tea046;teb100");
cds.configurator.DefaultRule.add(configurator, "tea046;teb112");
cds.configurator.DefaultRule.add(configurator, "tea046;teb120");
cds.configurator.DefaultRule.add(configurator, "tea046;teb126");
cds.configurator.DefaultRule.add(configurator, "tea046;teb140");
cds.configurator.DefaultRule.add(configurator, "tea046;teb144");
cds.configurator.DefaultRule.add(configurator, "tea046;teb154");
cds.configurator.DefaultRule.add(configurator, "tea046;teb168");
cds.configurator.DefaultRule.add(configurator, "tea046;teb180");
cds.configurator.DefaultRule.add(configurator, "tea046;teb192");
cds.configurator.DefaultRule.add(configurator, "tea046;teb200");
cds.configurator.DefaultRule.add(configurator, "tea046;teb216");
cds.configurator.DefaultRule.add(configurator, "tea046;teb224");
cds.configurator.DefaultRule.add(configurator, "tea048;teb050");
cds.configurator.DefaultRule.add(configurator, "tea048;teb052");
cds.configurator.DefaultRule.add(configurator, "tea048;teb053");
cds.configurator.DefaultRule.add(configurator, "tea048;teb056");
cds.configurator.DefaultRule.add(configurator, "tea048;teb060");
cds.configurator.DefaultRule.add(configurator, "tea048;teb062");
cds.configurator.DefaultRule.add(configurator, "tea048;teb063");
cds.configurator.DefaultRule.add(configurator, "tea048;teb064");
cds.configurator.DefaultRule.add(configurator, "tea048;teb067");
cds.configurator.DefaultRule.add(configurator, "tea048;teb068");
cds.configurator.DefaultRule.add(configurator, "tea048;teb070");
cds.configurator.DefaultRule.add(configurator, "tea048;teb071");
cds.configurator.DefaultRule.add(configurator, "tea048;teb072");
cds.configurator.DefaultRule.add(configurator, "tea048;teb074");
cds.configurator.DefaultRule.add(configurator, "tea048;teb075");
cds.configurator.DefaultRule.add(configurator, "tea048;teb080");
cds.configurator.DefaultRule.add(configurator, "tea048;teb084");
cds.configurator.DefaultRule.add(configurator, "tea048;teb090");
cds.configurator.DefaultRule.add(configurator, "tea048;teb096");
cds.configurator.DefaultRule.add(configurator, "tea048;teb100");
cds.configurator.DefaultRule.add(configurator, "tea048;teb112");
cds.configurator.DefaultRule.add(configurator, "tea048;teb120");
cds.configurator.DefaultRule.add(configurator, "tea048;teb126");
cds.configurator.DefaultRule.add(configurator, "tea048;teb140");
cds.configurator.DefaultRule.add(configurator, "tea048;teb144");
cds.configurator.DefaultRule.add(configurator, "tea048;teb154");
cds.configurator.DefaultRule.add(configurator, "tea048;teb168");
cds.configurator.DefaultRule.add(configurator, "tea048;teb180");
cds.configurator.DefaultRule.add(configurator, "tea048;teb192");
cds.configurator.DefaultRule.add(configurator, "tea048;teb200");
cds.configurator.DefaultRule.add(configurator, "tea048;teb216");
cds.configurator.DefaultRule.add(configurator, "tea048;teb224");
cds.configurator.DefaultRule.add(configurator, "tea050;teb052");
cds.configurator.DefaultRule.add(configurator, "tea050;teb053");
cds.configurator.DefaultRule.add(configurator, "tea050;teb056");
cds.configurator.DefaultRule.add(configurator, "tea050;teb060");
cds.configurator.DefaultRule.add(configurator, "tea050;teb062");
cds.configurator.DefaultRule.add(configurator, "tea050;teb063");
cds.configurator.DefaultRule.add(configurator, "tea050;teb064");
cds.configurator.DefaultRule.add(configurator, "tea050;teb067");
cds.configurator.DefaultRule.add(configurator, "tea050;teb068");
cds.configurator.DefaultRule.add(configurator, "tea050;teb070");
cds.configurator.DefaultRule.add(configurator, "tea050;teb071");
cds.configurator.DefaultRule.add(configurator, "tea050;teb072");
cds.configurator.DefaultRule.add(configurator, "tea050;teb074");
cds.configurator.DefaultRule.add(configurator, "tea050;teb075");
cds.configurator.DefaultRule.add(configurator, "tea050;teb080");
cds.configurator.DefaultRule.add(configurator, "tea050;teb084");
cds.configurator.DefaultRule.add(configurator, "tea050;teb090");
cds.configurator.DefaultRule.add(configurator, "tea050;teb096");
cds.configurator.DefaultRule.add(configurator, "tea050;teb100");
cds.configurator.DefaultRule.add(configurator, "tea050;teb112");
cds.configurator.DefaultRule.add(configurator, "tea050;teb120");
cds.configurator.DefaultRule.add(configurator, "tea050;teb126");
cds.configurator.DefaultRule.add(configurator, "tea050;teb140");
cds.configurator.DefaultRule.add(configurator, "tea050;teb144");
cds.configurator.DefaultRule.add(configurator, "tea050;teb154");
cds.configurator.DefaultRule.add(configurator, "tea050;teb168");
cds.configurator.DefaultRule.add(configurator, "tea050;teb180");
cds.configurator.DefaultRule.add(configurator, "tea050;teb192");
cds.configurator.DefaultRule.add(configurator, "tea050;teb200");
cds.configurator.DefaultRule.add(configurator, "tea050;teb216");
cds.configurator.DefaultRule.add(configurator, "tea050;teb224");
cds.configurator.DefaultRule.add(configurator, "tea052;teb053");
cds.configurator.DefaultRule.add(configurator, "tea052;teb056");
cds.configurator.DefaultRule.add(configurator, "tea052;teb060");
cds.configurator.DefaultRule.add(configurator, "tea052;teb062");
cds.configurator.DefaultRule.add(configurator, "tea052;teb063");
cds.configurator.DefaultRule.add(configurator, "tea052;teb064");
cds.configurator.DefaultRule.add(configurator, "tea052;teb067");
cds.configurator.DefaultRule.add(configurator, "tea052;teb068");
cds.configurator.DefaultRule.add(configurator, "tea052;teb070");
cds.configurator.DefaultRule.add(configurator, "tea052;teb071");
cds.configurator.DefaultRule.add(configurator, "tea052;teb072");
cds.configurator.DefaultRule.add(configurator, "tea052;teb074");
cds.configurator.DefaultRule.add(configurator, "tea052;teb075");
cds.configurator.DefaultRule.add(configurator, "tea052;teb080");
cds.configurator.DefaultRule.add(configurator, "tea052;teb084");
cds.configurator.DefaultRule.add(configurator, "tea052;teb090");
cds.configurator.DefaultRule.add(configurator, "tea052;teb096");
cds.configurator.DefaultRule.add(configurator, "tea052;teb100");
cds.configurator.DefaultRule.add(configurator, "tea052;teb112");
cds.configurator.DefaultRule.add(configurator, "tea052;teb120");
cds.configurator.DefaultRule.add(configurator, "tea052;teb126");
cds.configurator.DefaultRule.add(configurator, "tea052;teb140");
cds.configurator.DefaultRule.add(configurator, "tea052;teb144");
cds.configurator.DefaultRule.add(configurator, "tea052;teb154");
cds.configurator.DefaultRule.add(configurator, "tea052;teb168");
cds.configurator.DefaultRule.add(configurator, "tea052;teb180");
cds.configurator.DefaultRule.add(configurator, "tea052;teb192");
cds.configurator.DefaultRule.add(configurator, "tea052;teb200");
cds.configurator.DefaultRule.add(configurator, "tea052;teb216");
cds.configurator.DefaultRule.add(configurator, "tea052;teb224");
cds.configurator.DefaultRule.add(configurator, "tea053;teb056");
cds.configurator.DefaultRule.add(configurator, "tea053;teb060");
cds.configurator.DefaultRule.add(configurator, "tea053;teb062");
cds.configurator.DefaultRule.add(configurator, "tea053;teb063");
cds.configurator.DefaultRule.add(configurator, "tea053;teb064");
cds.configurator.DefaultRule.add(configurator, "tea053;teb067");
cds.configurator.DefaultRule.add(configurator, "tea053;teb068");
cds.configurator.DefaultRule.add(configurator, "tea053;teb070");
cds.configurator.DefaultRule.add(configurator, "tea053;teb071");
cds.configurator.DefaultRule.add(configurator, "tea053;teb072");
cds.configurator.DefaultRule.add(configurator, "tea053;teb074");
cds.configurator.DefaultRule.add(configurator, "tea053;teb075");
cds.configurator.DefaultRule.add(configurator, "tea053;teb080");
cds.configurator.DefaultRule.add(configurator, "tea053;teb084");
cds.configurator.DefaultRule.add(configurator, "tea053;teb090");
cds.configurator.DefaultRule.add(configurator, "tea053;teb096");
cds.configurator.DefaultRule.add(configurator, "tea053;teb100");
cds.configurator.DefaultRule.add(configurator, "tea053;teb112");
cds.configurator.DefaultRule.add(configurator, "tea053;teb120");
cds.configurator.DefaultRule.add(configurator, "tea053;teb126");
cds.configurator.DefaultRule.add(configurator, "tea053;teb140");
cds.configurator.DefaultRule.add(configurator, "tea053;teb144");
cds.configurator.DefaultRule.add(configurator, "tea053;teb154");
cds.configurator.DefaultRule.add(configurator, "tea053;teb168");
cds.configurator.DefaultRule.add(configurator, "tea053;teb180");
cds.configurator.DefaultRule.add(configurator, "tea053;teb192");
cds.configurator.DefaultRule.add(configurator, "tea053;teb200");
cds.configurator.DefaultRule.add(configurator, "tea053;teb216");
cds.configurator.DefaultRule.add(configurator, "tea053;teb224");
cds.configurator.DefaultRule.add(configurator, "tea056;teb060");
cds.configurator.DefaultRule.add(configurator, "tea056;teb062");
cds.configurator.DefaultRule.add(configurator, "tea056;teb063");
cds.configurator.DefaultRule.add(configurator, "tea056;teb064");
cds.configurator.DefaultRule.add(configurator, "tea056;teb067");
cds.configurator.DefaultRule.add(configurator, "tea056;teb068");
cds.configurator.DefaultRule.add(configurator, "tea056;teb070");
cds.configurator.DefaultRule.add(configurator, "tea056;teb071");
cds.configurator.DefaultRule.add(configurator, "tea056;teb072");
cds.configurator.DefaultRule.add(configurator, "tea056;teb074");
cds.configurator.DefaultRule.add(configurator, "tea056;teb075");
cds.configurator.DefaultRule.add(configurator, "tea056;teb080");
cds.configurator.DefaultRule.add(configurator, "tea056;teb084");
cds.configurator.DefaultRule.add(configurator, "tea056;teb090");
cds.configurator.DefaultRule.add(configurator, "tea056;teb096");
cds.configurator.DefaultRule.add(configurator, "tea056;teb100");
cds.configurator.DefaultRule.add(configurator, "tea056;teb112");
cds.configurator.DefaultRule.add(configurator, "tea056;teb120");
cds.configurator.DefaultRule.add(configurator, "tea056;teb126");
cds.configurator.DefaultRule.add(configurator, "tea056;teb140");
cds.configurator.DefaultRule.add(configurator, "tea056;teb144");
cds.configurator.DefaultRule.add(configurator, "tea056;teb154");
cds.configurator.DefaultRule.add(configurator, "tea056;teb168");
cds.configurator.DefaultRule.add(configurator, "tea056;teb180");
cds.configurator.DefaultRule.add(configurator, "tea056;teb192");
cds.configurator.DefaultRule.add(configurator, "tea056;teb200");
cds.configurator.DefaultRule.add(configurator, "tea056;teb216");
cds.configurator.DefaultRule.add(configurator, "tea056;teb224");
cds.configurator.DefaultRule.add(configurator, "tea060;teb062");
cds.configurator.DefaultRule.add(configurator, "tea060;teb063");
cds.configurator.DefaultRule.add(configurator, "tea060;teb064");
cds.configurator.DefaultRule.add(configurator, "tea060;teb067");
cds.configurator.DefaultRule.add(configurator, "tea060;teb068");
cds.configurator.DefaultRule.add(configurator, "tea060;teb070");
cds.configurator.DefaultRule.add(configurator, "tea060;teb071");
cds.configurator.DefaultRule.add(configurator, "tea060;teb072");
cds.configurator.DefaultRule.add(configurator, "tea060;teb074");
cds.configurator.DefaultRule.add(configurator, "tea060;teb075");
cds.configurator.DefaultRule.add(configurator, "tea060;teb080");
cds.configurator.DefaultRule.add(configurator, "tea060;teb084");
cds.configurator.DefaultRule.add(configurator, "tea060;teb090");
cds.configurator.DefaultRule.add(configurator, "tea060;teb096");
cds.configurator.DefaultRule.add(configurator, "tea060;teb100");
cds.configurator.DefaultRule.add(configurator, "tea060;teb112");
cds.configurator.DefaultRule.add(configurator, "tea060;teb120");
cds.configurator.DefaultRule.add(configurator, "tea060;teb126");
cds.configurator.DefaultRule.add(configurator, "tea060;teb140");
cds.configurator.DefaultRule.add(configurator, "tea060;teb144");
cds.configurator.DefaultRule.add(configurator, "tea060;teb154");
cds.configurator.DefaultRule.add(configurator, "tea060;teb168");
cds.configurator.DefaultRule.add(configurator, "tea060;teb180");
cds.configurator.DefaultRule.add(configurator, "tea060;teb192");
cds.configurator.DefaultRule.add(configurator, "tea060;teb200");
cds.configurator.DefaultRule.add(configurator, "tea060;teb216");
cds.configurator.DefaultRule.add(configurator, "tea060;teb224");
cds.configurator.DefaultRule.add(configurator, "tea062;teb063");
cds.configurator.DefaultRule.add(configurator, "tea062;teb064");
cds.configurator.DefaultRule.add(configurator, "tea062;teb067");
cds.configurator.DefaultRule.add(configurator, "tea062;teb068");
cds.configurator.DefaultRule.add(configurator, "tea062;teb070");
cds.configurator.DefaultRule.add(configurator, "tea062;teb071");
cds.configurator.DefaultRule.add(configurator, "tea062;teb072");
cds.configurator.DefaultRule.add(configurator, "tea062;teb074");
cds.configurator.DefaultRule.add(configurator, "tea062;teb075");
cds.configurator.DefaultRule.add(configurator, "tea062;teb080");
cds.configurator.DefaultRule.add(configurator, "tea062;teb084");
cds.configurator.DefaultRule.add(configurator, "tea062;teb090");
cds.configurator.DefaultRule.add(configurator, "tea062;teb096");
cds.configurator.DefaultRule.add(configurator, "tea062;teb100");
cds.configurator.DefaultRule.add(configurator, "tea062;teb112");
cds.configurator.DefaultRule.add(configurator, "tea062;teb120");
cds.configurator.DefaultRule.add(configurator, "tea062;teb126");
cds.configurator.DefaultRule.add(configurator, "tea062;teb140");
cds.configurator.DefaultRule.add(configurator, "tea062;teb144");
cds.configurator.DefaultRule.add(configurator, "tea062;teb154");
cds.configurator.DefaultRule.add(configurator, "tea062;teb168");
cds.configurator.DefaultRule.add(configurator, "tea062;teb180");
cds.configurator.DefaultRule.add(configurator, "tea062;teb192");
cds.configurator.DefaultRule.add(configurator, "tea062;teb200");
cds.configurator.DefaultRule.add(configurator, "tea062;teb216");
cds.configurator.DefaultRule.add(configurator, "tea062;teb224");
cds.configurator.DefaultRule.add(configurator, "tea063;teb064");
cds.configurator.DefaultRule.add(configurator, "tea063;teb067");
cds.configurator.DefaultRule.add(configurator, "tea063;teb068");
cds.configurator.DefaultRule.add(configurator, "tea063;teb070");
cds.configurator.DefaultRule.add(configurator, "tea063;teb071");
cds.configurator.DefaultRule.add(configurator, "tea063;teb072");
cds.configurator.DefaultRule.add(configurator, "tea063;teb074");
cds.configurator.DefaultRule.add(configurator, "tea063;teb075");
cds.configurator.DefaultRule.add(configurator, "tea063;teb080");
cds.configurator.DefaultRule.add(configurator, "tea063;teb084");
cds.configurator.DefaultRule.add(configurator, "tea063;teb090");
cds.configurator.DefaultRule.add(configurator, "tea063;teb096");
cds.configurator.DefaultRule.add(configurator, "tea063;teb100");
cds.configurator.DefaultRule.add(configurator, "tea063;teb112");
cds.configurator.DefaultRule.add(configurator, "tea063;teb120");
cds.configurator.DefaultRule.add(configurator, "tea063;teb126");
cds.configurator.DefaultRule.add(configurator, "tea063;teb140");
cds.configurator.DefaultRule.add(configurator, "tea063;teb144");
cds.configurator.DefaultRule.add(configurator, "tea063;teb154");
cds.configurator.DefaultRule.add(configurator, "tea063;teb168");
cds.configurator.DefaultRule.add(configurator, "tea063;teb180");
cds.configurator.DefaultRule.add(configurator, "tea063;teb192");
cds.configurator.DefaultRule.add(configurator, "tea063;teb200");
cds.configurator.DefaultRule.add(configurator, "tea063;teb216");
cds.configurator.DefaultRule.add(configurator, "tea063;teb224");
cds.configurator.DefaultRule.add(configurator, "tea064;teb067");
cds.configurator.DefaultRule.add(configurator, "tea064;teb068");
cds.configurator.DefaultRule.add(configurator, "tea064;teb070");
cds.configurator.DefaultRule.add(configurator, "tea064;teb071");
cds.configurator.DefaultRule.add(configurator, "tea064;teb072");
cds.configurator.DefaultRule.add(configurator, "tea064;teb074");
cds.configurator.DefaultRule.add(configurator, "tea064;teb075");
cds.configurator.DefaultRule.add(configurator, "tea064;teb080");
cds.configurator.DefaultRule.add(configurator, "tea064;teb084");
cds.configurator.DefaultRule.add(configurator, "tea064;teb090");
cds.configurator.DefaultRule.add(configurator, "tea064;teb096");
cds.configurator.DefaultRule.add(configurator, "tea064;teb100");
cds.configurator.DefaultRule.add(configurator, "tea064;teb112");
cds.configurator.DefaultRule.add(configurator, "tea064;teb120");
cds.configurator.DefaultRule.add(configurator, "tea064;teb126");
cds.configurator.DefaultRule.add(configurator, "tea064;teb140");
cds.configurator.DefaultRule.add(configurator, "tea064;teb144");
cds.configurator.DefaultRule.add(configurator, "tea064;teb154");
cds.configurator.DefaultRule.add(configurator, "tea064;teb168");
cds.configurator.DefaultRule.add(configurator, "tea064;teb180");
cds.configurator.DefaultRule.add(configurator, "tea064;teb192");
cds.configurator.DefaultRule.add(configurator, "tea064;teb200");
cds.configurator.DefaultRule.add(configurator, "tea064;teb216");
cds.configurator.DefaultRule.add(configurator, "tea064;teb224");
cds.configurator.DefaultRule.add(configurator, "tea067;teb068");
cds.configurator.DefaultRule.add(configurator, "tea067;teb070");
cds.configurator.DefaultRule.add(configurator, "tea067;teb071");
cds.configurator.DefaultRule.add(configurator, "tea067;teb072");
cds.configurator.DefaultRule.add(configurator, "tea067;teb074");
cds.configurator.DefaultRule.add(configurator, "tea067;teb075");
cds.configurator.DefaultRule.add(configurator, "tea067;teb080");
cds.configurator.DefaultRule.add(configurator, "tea067;teb084");
cds.configurator.DefaultRule.add(configurator, "tea067;teb090");
cds.configurator.DefaultRule.add(configurator, "tea067;teb096");
cds.configurator.DefaultRule.add(configurator, "tea067;teb100");
cds.configurator.DefaultRule.add(configurator, "tea067;teb112");
cds.configurator.DefaultRule.add(configurator, "tea067;teb120");
cds.configurator.DefaultRule.add(configurator, "tea067;teb126");
cds.configurator.DefaultRule.add(configurator, "tea067;teb140");
cds.configurator.DefaultRule.add(configurator, "tea067;teb144");
cds.configurator.DefaultRule.add(configurator, "tea067;teb154");
cds.configurator.DefaultRule.add(configurator, "tea067;teb168");
cds.configurator.DefaultRule.add(configurator, "tea067;teb180");
cds.configurator.DefaultRule.add(configurator, "tea067;teb192");
cds.configurator.DefaultRule.add(configurator, "tea067;teb200");
cds.configurator.DefaultRule.add(configurator, "tea067;teb216");
cds.configurator.DefaultRule.add(configurator, "tea067;teb224");
cds.configurator.DefaultRule.add(configurator, "tea068;teb070");
cds.configurator.DefaultRule.add(configurator, "tea068;teb071");
cds.configurator.DefaultRule.add(configurator, "tea068;teb072");
cds.configurator.DefaultRule.add(configurator, "tea068;teb074");
cds.configurator.DefaultRule.add(configurator, "tea068;teb075");
cds.configurator.DefaultRule.add(configurator, "tea068;teb080");
cds.configurator.DefaultRule.add(configurator, "tea068;teb084");
cds.configurator.DefaultRule.add(configurator, "tea068;teb090");
cds.configurator.DefaultRule.add(configurator, "tea068;teb096");
cds.configurator.DefaultRule.add(configurator, "tea068;teb100");
cds.configurator.DefaultRule.add(configurator, "tea068;teb112");
cds.configurator.DefaultRule.add(configurator, "tea068;teb120");
cds.configurator.DefaultRule.add(configurator, "tea068;teb126");
cds.configurator.DefaultRule.add(configurator, "tea068;teb140");
cds.configurator.DefaultRule.add(configurator, "tea068;teb144");
cds.configurator.DefaultRule.add(configurator, "tea068;teb154");
cds.configurator.DefaultRule.add(configurator, "tea068;teb168");
cds.configurator.DefaultRule.add(configurator, "tea068;teb180");
cds.configurator.DefaultRule.add(configurator, "tea068;teb192");
cds.configurator.DefaultRule.add(configurator, "tea068;teb200");
cds.configurator.DefaultRule.add(configurator, "tea068;teb216");
cds.configurator.DefaultRule.add(configurator, "tea068;teb224");
cds.configurator.DefaultRule.add(configurator, "tea070;teb071");
cds.configurator.DefaultRule.add(configurator, "tea070;teb072");
cds.configurator.DefaultRule.add(configurator, "tea070;teb074");
cds.configurator.DefaultRule.add(configurator, "tea070;teb075");
cds.configurator.DefaultRule.add(configurator, "tea070;teb080");
cds.configurator.DefaultRule.add(configurator, "tea070;teb084");
cds.configurator.DefaultRule.add(configurator, "tea070;teb090");
cds.configurator.DefaultRule.add(configurator, "tea070;teb096");
cds.configurator.DefaultRule.add(configurator, "tea070;teb100");
cds.configurator.DefaultRule.add(configurator, "tea070;teb112");
cds.configurator.DefaultRule.add(configurator, "tea070;teb120");
cds.configurator.DefaultRule.add(configurator, "tea070;teb126");
cds.configurator.DefaultRule.add(configurator, "tea070;teb140");
cds.configurator.DefaultRule.add(configurator, "tea070;teb144");
cds.configurator.DefaultRule.add(configurator, "tea070;teb154");
cds.configurator.DefaultRule.add(configurator, "tea070;teb168");
cds.configurator.DefaultRule.add(configurator, "tea070;teb180");
cds.configurator.DefaultRule.add(configurator, "tea070;teb192");
cds.configurator.DefaultRule.add(configurator, "tea070;teb200");
cds.configurator.DefaultRule.add(configurator, "tea070;teb216");
cds.configurator.DefaultRule.add(configurator, "tea070;teb224");
cds.configurator.DefaultRule.add(configurator, "tea071;teb072");
cds.configurator.DefaultRule.add(configurator, "tea071;teb074");
cds.configurator.DefaultRule.add(configurator, "tea071;teb075");
cds.configurator.DefaultRule.add(configurator, "tea071;teb080");
cds.configurator.DefaultRule.add(configurator, "tea071;teb084");
cds.configurator.DefaultRule.add(configurator, "tea071;teb090");
cds.configurator.DefaultRule.add(configurator, "tea071;teb096");
cds.configurator.DefaultRule.add(configurator, "tea071;teb100");
cds.configurator.DefaultRule.add(configurator, "tea071;teb112");
cds.configurator.DefaultRule.add(configurator, "tea071;teb120");
cds.configurator.DefaultRule.add(configurator, "tea071;teb126");
cds.configurator.DefaultRule.add(configurator, "tea071;teb140");
cds.configurator.DefaultRule.add(configurator, "tea071;teb144");
cds.configurator.DefaultRule.add(configurator, "tea071;teb154");
cds.configurator.DefaultRule.add(configurator, "tea071;teb168");
cds.configurator.DefaultRule.add(configurator, "tea071;teb180");
cds.configurator.DefaultRule.add(configurator, "tea071;teb192");
cds.configurator.DefaultRule.add(configurator, "tea071;teb200");
cds.configurator.DefaultRule.add(configurator, "tea071;teb216");
cds.configurator.DefaultRule.add(configurator, "tea071;teb224");
cds.configurator.DefaultRule.add(configurator, "tea072;teb074");
cds.configurator.DefaultRule.add(configurator, "tea072;teb075");
cds.configurator.DefaultRule.add(configurator, "tea072;teb080");
cds.configurator.DefaultRule.add(configurator, "tea072;teb084");
cds.configurator.DefaultRule.add(configurator, "tea072;teb090");
cds.configurator.DefaultRule.add(configurator, "tea072;teb096");
cds.configurator.DefaultRule.add(configurator, "tea072;teb100");
cds.configurator.DefaultRule.add(configurator, "tea072;teb112");
cds.configurator.DefaultRule.add(configurator, "tea072;teb120");
cds.configurator.DefaultRule.add(configurator, "tea072;teb126");
cds.configurator.DefaultRule.add(configurator, "tea072;teb140");
cds.configurator.DefaultRule.add(configurator, "tea072;teb144");
cds.configurator.DefaultRule.add(configurator, "tea072;teb154");
cds.configurator.DefaultRule.add(configurator, "tea072;teb168");
cds.configurator.DefaultRule.add(configurator, "tea072;teb180");
cds.configurator.DefaultRule.add(configurator, "tea072;teb192");
cds.configurator.DefaultRule.add(configurator, "tea072;teb200");
cds.configurator.DefaultRule.add(configurator, "tea072;teb216");
cds.configurator.DefaultRule.add(configurator, "tea072;teb224");
cds.configurator.DefaultRule.add(configurator, "tea074;teb075");
cds.configurator.DefaultRule.add(configurator, "tea074;teb080");
cds.configurator.DefaultRule.add(configurator, "tea074;teb084");
cds.configurator.DefaultRule.add(configurator, "tea074;teb090");
cds.configurator.DefaultRule.add(configurator, "tea074;teb096");
cds.configurator.DefaultRule.add(configurator, "tea074;teb100");
cds.configurator.DefaultRule.add(configurator, "tea074;teb112");
cds.configurator.DefaultRule.add(configurator, "tea074;teb120");
cds.configurator.DefaultRule.add(configurator, "tea074;teb126");
cds.configurator.DefaultRule.add(configurator, "tea074;teb140");
cds.configurator.DefaultRule.add(configurator, "tea074;teb144");
cds.configurator.DefaultRule.add(configurator, "tea074;teb154");
cds.configurator.DefaultRule.add(configurator, "tea074;teb168");
cds.configurator.DefaultRule.add(configurator, "tea074;teb180");
cds.configurator.DefaultRule.add(configurator, "tea074;teb192");
cds.configurator.DefaultRule.add(configurator, "tea074;teb200");
cds.configurator.DefaultRule.add(configurator, "tea074;teb216");
cds.configurator.DefaultRule.add(configurator, "tea074;teb224");
cds.configurator.DefaultRule.add(configurator, "tea075;teb080");
cds.configurator.DefaultRule.add(configurator, "tea075;teb084");
cds.configurator.DefaultRule.add(configurator, "tea075;teb090");
cds.configurator.DefaultRule.add(configurator, "tea075;teb096");
cds.configurator.DefaultRule.add(configurator, "tea075;teb100");
cds.configurator.DefaultRule.add(configurator, "tea075;teb112");
cds.configurator.DefaultRule.add(configurator, "tea075;teb120");
cds.configurator.DefaultRule.add(configurator, "tea075;teb126");
cds.configurator.DefaultRule.add(configurator, "tea075;teb140");
cds.configurator.DefaultRule.add(configurator, "tea075;teb144");
cds.configurator.DefaultRule.add(configurator, "tea075;teb154");
cds.configurator.DefaultRule.add(configurator, "tea075;teb168");
cds.configurator.DefaultRule.add(configurator, "tea075;teb180");
cds.configurator.DefaultRule.add(configurator, "tea075;teb192");
cds.configurator.DefaultRule.add(configurator, "tea075;teb200");
cds.configurator.DefaultRule.add(configurator, "tea075;teb216");
cds.configurator.DefaultRule.add(configurator, "tea075;teb224");
cds.configurator.DefaultRule.add(configurator, "tea080;teb084");
cds.configurator.DefaultRule.add(configurator, "tea080;teb090");
cds.configurator.DefaultRule.add(configurator, "tea080;teb096");
cds.configurator.DefaultRule.add(configurator, "tea080;teb100");
cds.configurator.DefaultRule.add(configurator, "tea080;teb112");
cds.configurator.DefaultRule.add(configurator, "tea080;teb120");
cds.configurator.DefaultRule.add(configurator, "tea080;teb126");
cds.configurator.DefaultRule.add(configurator, "tea080;teb140");
cds.configurator.DefaultRule.add(configurator, "tea080;teb144");
cds.configurator.DefaultRule.add(configurator, "tea080;teb154");
cds.configurator.DefaultRule.add(configurator, "tea080;teb168");
cds.configurator.DefaultRule.add(configurator, "tea080;teb180");
cds.configurator.DefaultRule.add(configurator, "tea080;teb192");
cds.configurator.DefaultRule.add(configurator, "tea080;teb200");
cds.configurator.DefaultRule.add(configurator, "tea080;teb216");
cds.configurator.DefaultRule.add(configurator, "tea080;teb224");
cds.configurator.DefaultRule.add(configurator, "tea084;teb090");
cds.configurator.DefaultRule.add(configurator, "tea084;teb096");
cds.configurator.DefaultRule.add(configurator, "tea084;teb100");
cds.configurator.DefaultRule.add(configurator, "tea084;teb112");
cds.configurator.DefaultRule.add(configurator, "tea084;teb120");
cds.configurator.DefaultRule.add(configurator, "tea084;teb126");
cds.configurator.DefaultRule.add(configurator, "tea084;teb140");
cds.configurator.DefaultRule.add(configurator, "tea084;teb144");
cds.configurator.DefaultRule.add(configurator, "tea084;teb154");
cds.configurator.DefaultRule.add(configurator, "tea084;teb168");
cds.configurator.DefaultRule.add(configurator, "tea084;teb180");
cds.configurator.DefaultRule.add(configurator, "tea084;teb192");
cds.configurator.DefaultRule.add(configurator, "tea084;teb200");
cds.configurator.DefaultRule.add(configurator, "tea084;teb216");
cds.configurator.DefaultRule.add(configurator, "tea084;teb224");
cds.configurator.DefaultRule.add(configurator, "tea090;teb096");
cds.configurator.DefaultRule.add(configurator, "tea090;teb100");
cds.configurator.DefaultRule.add(configurator, "tea090;teb112");
cds.configurator.DefaultRule.add(configurator, "tea090;teb120");
cds.configurator.DefaultRule.add(configurator, "tea090;teb126");
cds.configurator.DefaultRule.add(configurator, "tea090;teb140");
cds.configurator.DefaultRule.add(configurator, "tea090;teb144");
cds.configurator.DefaultRule.add(configurator, "tea090;teb154");
cds.configurator.DefaultRule.add(configurator, "tea090;teb168");
cds.configurator.DefaultRule.add(configurator, "tea090;teb180");
cds.configurator.DefaultRule.add(configurator, "tea090;teb192");
cds.configurator.DefaultRule.add(configurator, "tea090;teb200");
cds.configurator.DefaultRule.add(configurator, "tea090;teb216");
cds.configurator.DefaultRule.add(configurator, "tea090;teb224");
cds.configurator.DefaultRule.add(configurator, "tea096;teb100");
cds.configurator.DefaultRule.add(configurator, "tea096;teb112");
cds.configurator.DefaultRule.add(configurator, "tea096;teb120");
cds.configurator.DefaultRule.add(configurator, "tea096;teb126");
cds.configurator.DefaultRule.add(configurator, "tea096;teb140");
cds.configurator.DefaultRule.add(configurator, "tea096;teb144");
cds.configurator.DefaultRule.add(configurator, "tea096;teb154");
cds.configurator.DefaultRule.add(configurator, "tea096;teb168");
cds.configurator.DefaultRule.add(configurator, "tea096;teb180");
cds.configurator.DefaultRule.add(configurator, "tea096;teb192");
cds.configurator.DefaultRule.add(configurator, "tea096;teb200");
cds.configurator.DefaultRule.add(configurator, "tea096;teb216");
cds.configurator.DefaultRule.add(configurator, "tea096;teb224");
cds.configurator.DefaultRule.add(configurator, "tea100;teb112");
cds.configurator.DefaultRule.add(configurator, "tea100;teb120");
cds.configurator.DefaultRule.add(configurator, "tea100;teb126");
cds.configurator.DefaultRule.add(configurator, "tea100;teb140");
cds.configurator.DefaultRule.add(configurator, "tea100;teb144");
cds.configurator.DefaultRule.add(configurator, "tea100;teb154");
cds.configurator.DefaultRule.add(configurator, "tea100;teb168");
cds.configurator.DefaultRule.add(configurator, "tea100;teb180");
cds.configurator.DefaultRule.add(configurator, "tea100;teb192");
cds.configurator.DefaultRule.add(configurator, "tea100;teb200");
cds.configurator.DefaultRule.add(configurator, "tea100;teb216");
cds.configurator.DefaultRule.add(configurator, "tea100;teb224");
cds.configurator.DefaultRule.add(configurator, "tea112;teb120");
cds.configurator.DefaultRule.add(configurator, "tea112;teb126");
cds.configurator.DefaultRule.add(configurator, "tea112;teb140");
cds.configurator.DefaultRule.add(configurator, "tea112;teb144");
cds.configurator.DefaultRule.add(configurator, "tea112;teb154");
cds.configurator.DefaultRule.add(configurator, "tea112;teb168");
cds.configurator.DefaultRule.add(configurator, "tea112;teb180");
cds.configurator.DefaultRule.add(configurator, "tea112;teb192");
cds.configurator.DefaultRule.add(configurator, "tea112;teb200");
cds.configurator.DefaultRule.add(configurator, "tea112;teb216");
cds.configurator.DefaultRule.add(configurator, "tea112;teb224");
cds.configurator.DefaultRule.add(configurator, "tea120;teb126");
cds.configurator.DefaultRule.add(configurator, "tea120;teb140");
cds.configurator.DefaultRule.add(configurator, "tea120;teb144");
cds.configurator.DefaultRule.add(configurator, "tea120;teb154");
cds.configurator.DefaultRule.add(configurator, "tea120;teb168");
cds.configurator.DefaultRule.add(configurator, "tea120;teb180");
cds.configurator.DefaultRule.add(configurator, "tea120;teb192");
cds.configurator.DefaultRule.add(configurator, "tea120;teb200");
cds.configurator.DefaultRule.add(configurator, "tea120;teb216");
cds.configurator.DefaultRule.add(configurator, "tea120;teb224");
cds.configurator.DefaultRule.add(configurator, "tea126;teb140");
cds.configurator.DefaultRule.add(configurator, "tea126;teb144");
cds.configurator.DefaultRule.add(configurator, "tea126;teb154");
cds.configurator.DefaultRule.add(configurator, "tea126;teb168");
cds.configurator.DefaultRule.add(configurator, "tea126;teb180");
cds.configurator.DefaultRule.add(configurator, "tea126;teb192");
cds.configurator.DefaultRule.add(configurator, "tea126;teb200");
cds.configurator.DefaultRule.add(configurator, "tea126;teb216");
cds.configurator.DefaultRule.add(configurator, "tea126;teb224");
cds.configurator.DefaultRule.add(configurator, "tea140;teb144");
cds.configurator.DefaultRule.add(configurator, "tea140;teb154");
cds.configurator.DefaultRule.add(configurator, "tea140;teb168");
cds.configurator.DefaultRule.add(configurator, "tea140;teb180");
cds.configurator.DefaultRule.add(configurator, "tea140;teb192");
cds.configurator.DefaultRule.add(configurator, "tea140;teb200");
cds.configurator.DefaultRule.add(configurator, "tea140;teb216");
cds.configurator.DefaultRule.add(configurator, "tea140;teb224");
cds.configurator.DefaultRule.add(configurator, "tea144;teb154");
cds.configurator.DefaultRule.add(configurator, "tea144;teb168");
cds.configurator.DefaultRule.add(configurator, "tea144;teb180");
cds.configurator.DefaultRule.add(configurator, "tea144;teb192");
cds.configurator.DefaultRule.add(configurator, "tea144;teb200");
cds.configurator.DefaultRule.add(configurator, "tea144;teb216");
cds.configurator.DefaultRule.add(configurator, "tea144;teb224");
cds.configurator.DefaultRule.add(configurator, "tea154;teb168");
cds.configurator.DefaultRule.add(configurator, "tea154;teb180");
cds.configurator.DefaultRule.add(configurator, "tea154;teb192");
cds.configurator.DefaultRule.add(configurator, "tea154;teb200");
cds.configurator.DefaultRule.add(configurator, "tea154;teb216");
cds.configurator.DefaultRule.add(configurator, "tea154;teb224");
cds.configurator.DefaultRule.add(configurator, "tea168;teb180");
cds.configurator.DefaultRule.add(configurator, "tea168;teb192");
cds.configurator.DefaultRule.add(configurator, "tea168;teb200");
cds.configurator.DefaultRule.add(configurator, "tea168;teb216");
cds.configurator.DefaultRule.add(configurator, "tea168;teb224");
cds.configurator.DefaultRule.add(configurator, "tea180;teb192");
cds.configurator.DefaultRule.add(configurator, "tea180;teb200");
cds.configurator.DefaultRule.add(configurator, "tea180;teb216");
cds.configurator.DefaultRule.add(configurator, "tea180;teb224");
cds.configurator.DefaultRule.add(configurator, "tea192;teb200");
cds.configurator.DefaultRule.add(configurator, "tea192;teb216");
cds.configurator.DefaultRule.add(configurator, "tea192;teb224");
cds.configurator.DefaultRule.add(configurator, "tea200;teb216");
cds.configurator.DefaultRule.add(configurator, "tea200;teb224");
cds.configurator.DefaultRule.add(configurator, "tea216;teb224");
cds.configurator.DefaultRule.add(configurator, "ue;smh03");
cds.configurator.DefaultRule.add(configurator, "ue;smh05");
cds.configurator.DefaultRule.add(configurator, "ue;smh08");
cds.configurator.DefaultRule.add(configurator, "ue;smt25");
cds.configurator.DefaultRule.add(configurator, "ue;smt05");
cds.configurator.DefaultRule.add(configurator, "ue;smt10");
cds.configurator.DefaultRule.add(configurator, "ue;sma05");
cds.configurator.DefaultRule.add(configurator, "ue;sma10");
cds.configurator.DefaultRule.add(configurator, "um;semxl");
cds.configurator.DefaultRule.add(configurator, "um;sexll");
cds.configurator.DefaultRule.add(configurator, "um;selll");
cds.configurator.DefaultRule.add(configurator, "um;sehhh");
